export default {
  'QR6K9h': '變更為企業客戶',
  'SXr/TJ': '更改客戶名稱及地址',
  'cDZ00w': '查看',
  'tVoPUq': '新建',
  'tXBsQE': '撤回變更',
  'yeM3H9': '當前有變更中的信息，且變更審核未完成，審核通過後才可使用新的信息進行操作，可點擊查看詳情。',
  '37UnDp': '是否允許銷售主賬戶庫存',
  '5yWf2/': '賬戶認證狀態',
  'E8fzoC': '賬戶可用狀態',
  'ElicqC': '客戶名稱',
  'OtNA8e': '我的資料',
  'yOMNOj': '是',
  'P/eul9': '否',
  'UBD4b9': '地址',
  'a3sL9l': '開戶類型',
  'ehoAjT': '客戶類型',
  'pV2t/S': '基本信息',
  '1vuDaF': '待激活',
  '3+1Jck': '已認證',
  '8PESa6': '禁用',
  'CLqPBU': '編輯',
  'DUQXFs': '中國大陸客戶',
  'KOVFgK': '待審核',
  'Nxf0U5': '個人客戶',
  'P13p8i': '審核不通過',
  'Wt7gRM': '海外客戶(其他)',
  'XDzVGN': '中國澳門客戶',
  'Xqm9/H': '待認證',
  'YA0JvR': '海外客戶(澳大利亞)',
  'bzvDaH': '中國香港客戶',
  'dqeSBE': '企業客戶',
  'eobwrx': '中國臺灣客戶',
  'sZSyGZ': '啟用',
  'QsOl4N': '查看變更記錄',
  '0unUTD': '緊急聯系人電話',
  '4wwVxZ': '收件人手機',
  '6YyMOz': '收件人',
  'Ojk15q': '收件人地址',
  'fJNcQC': '錢包可消費國家',
  'tuGgMn': '緊急聯系人',
  'b5l2vN': '保存',
  'dGBGbt': '全部',
  'KASLGt': '請根據當前賬戶預計充值的幣種，選擇對應的國家，避免產生不必要的匯損。',
  'MEbxQi': '手機號碼不正確',
  'Kwqd8h': '聯系人',
  'LabgPq': '添加聯系人',
  '+4lD9e': '姓名',
  '5aTPaf': '財務類',
  '5cbASK': '直郵/郵政小包/專線',
  '87+CkL': '國內倉',
  'CS1nBc': '公司物流部門負責人',
  'FlbEqp': '最後一公裏',
  'JeSd9K': '其他',
  'JsKHKZ': '全部業務',
  'KNi3io': '聯系人微信',
  'O77bxe': '業務人員',
  'Q0U6lO': '主聯系人',
  'SiW90w': '具體職務名稱',
  'UtE0dS': '操作',
  'XeiAal': '刪除',
  'XlmRrF': '頭程物流運輸',
  'ayzEHe': '關務清關',
  'bBGcVD': '海外倉庫內及出庫',
  'dedKWK': '公司總負責人',
  'e0Sn9Q': '普通員工',
  'hDx3/S': '郵箱',
  'kjXGsB': '業務類型',
  'sZ4TxG': '退貨管理',
  't9+g0f': '手機號碼',
  'vkuBHV': '聯系人職務',
  'ZhSSVD': '編輯聯系人',
  'FkpSdN': '微信號',
  'SgFQRw': '溫馨提示：主聯系人郵箱和手機號碼將作為找回密碼的途徑，請謹慎填寫',
  'Tkqx5r': '具體職務',
  'gSS3He': '聯系人姓名',
  '0iSYp3': '確定要刪除聯系人嗎？',
  '0iT2j9': '此操作如果涉及郵箱地址、手機號碼的變更以及找回密碼，會將系統默認訂閱內容和找回密碼郵件發送到新的郵箱地址或手機，是否繼續？',
  'Xhn2gT': '請選擇',
  'bKAoaM': '手機驗證碼',
  'jhfb/7': '保存成功',
  'mZGgaM': '重新發送({countdown}s)',
  'ypMY0M': '獲取驗證碼',
  '0pw2t2': '發貨人',
  '5FboZ/': '類型',
  'UWWODP': '收貨人',
  'Unr58u': '更新時間',
  'YQa0fs': '新增',
  'ekxzlF': '名稱',
  'f9OHsz': '提單收/發貨人配置',
  'h/j3a5': '聯系人電話',
  'iUMM+c': '聯系電話',
  'wCmFtE': '請輸入非中文字符',
  'zYYUzJ': '新增收/發貨人',
  'Qqmpu5': '確定刪除嗎？',
  '0P9Dam': '經營單位名稱',
  '174V9v': '只能輸入1-999的正整數',
  'BfpU2q': '德國VAT優先級配置',
  'JcnLqY': '僅支持審核通過狀態的VAT',
  'Zf1gfY': '入庫禁止自動分配',
  'gUQJOD': '出庫自動分配優先級',
  'n/weLR': '輸入1-999的正整數，不輸入按默認規則分配',
  'vrXgIZ': '英國VAT優先級配置',
  'IuggbZ': '特別提示，以下情況萬邑通不予辦理退貨：',
  'Vzw58T': '（3）其他依法不應辦理退貨的。',
  'nRN2tZ': '海外倉',
  'pjeZQ1': '（2）不接受買家自行送至倉庫上門退件。',
  'qU4NBE': '（1）不接收任何到付退件,請提前支付運費。',
  'Cmh20w': '新增地址',
  'EGCtVA': '地址編號',
  'I/ecfs': '以下地址僅用於“國際送倉FBA”訂單的客戶自定義倉庫地址',
  'Ls/792': '編號',
  'Ozm+wK': '國家/地區',
  'R2D5Dv': '創建時間',
  'Ut8+i2': '審核通過',
  'W9Nshi': '審核狀態',
  'o/NKeE': '默認地址',
  'zarB4B': '電話',
  '+mhlOQ': '僅適用於快遞退回的客戶使用。',
  '2cscD/': '地址編號為訂單批量導入或API下單時使用，由您自定義編寫（支持任意字母、數字），但提交後不可修改',
  '4P3k8y': 'ISP退件地址',
  '5iyXaV': '以下地址僅用於"國際遞送ISP"快遞退回件簽收地址',
  'HJ9/xO': '請輸入字母和數字',
  'I3KHY+': '寄件/提貨地址',
  'LZGKge': 'FBA收貨地址',
  'ZT3XmT': '省',
  'aqQg0p': '區域',
  'gvnY3J': '城市',
  'lfTX1B': '郵編',
  'xnNdNf': '退貨地址',
  '89AO9d': '如：OAK6',
  'EPwTKQ': '街道1',
  'Y0pQ9+': '街道2',
  'Zh3+AG': '地址編號為訂單批量導入或API下單時使用，自定義編寫（任意字母，數字），提交後不可修改。',
  'cAO9+Q': '可填寫倉庫名稱及其他備註信息',
  'h/rxnW': '州/省',
  'ma1bk0': '門牌號',
  'Vy+2vj': '註：請輸入手機號碼',
  'kavVIg': '您的修改已提交,客服人員將對信息進行審核,請耐心等待大約1個工作日的時間。',
  '2cJWcY': '中文聯系人',
  '6X3PH/': '英文聯系人',
  'FdxNc2': '中國地址選擇區域後，郵編將自動填寫',
  'I1csCB': '中文地址',
  'iXLW4z': '請輸入詳細地址，省市區信息無需再次輸入',
  's4Uh1V': '英文地址',
  '+a6DnG': '審核中',
  'C2bl/o': '驗貨倉',
  'FjEahZ': '審核詳情',
  'K+M18J': '該地址不支持上門攬收',
  'MTtFwJ': '審核情況',
  'W4KBof': '攬收方式',
  'Xcsk6t': '不在供應商攬收範圍內',
  'XmRKnc': '備註',
  'jnerdQ': '該城市攬收地址超限',
  'ptQCRK': '產品線',
  'sEnMXQ': '審核未通過',
  'uyiJ3u': '未審核',
  '3Y6eOz': '失效',
  'BbeuTL': '非WINIT承運進口商',
  'C/pEBf': '查看維護記錄',
  'D+H90c': '經營單位列表',
  'G93Pnn': '清關方式',
  'MFvoiw': '出口商',
  'MSzsZn': '作廢',
  'QV3pnn': '狀態',
  'SaqVpv': '自有進口商遞延清關',
  'WrhSGw': '普通清關',
  'Zq5tH7': '維護時間',
  'bqbDVw': '查詢',
  'cawvIS': '最後更新時間',
  'gnxH14': '開票進口商',
  'lH1uep': '進口商',
  'rafcJa': '維護記錄',
  'wpl80v': '貿易商',
  'zeMk2K': '草稿',
  '7fXxGd': '英制單位',
  'CaAumf': '重量計量單位 : 磅 (lb);長度計量單位 : 英寸 (inch)',
  'EFsNaj': '偏好設置',
  'H2shJb': '重量計量單位 : 公斤 (kg);長度計量單位 : 厘米 (cm)',
  'veounH': '公制單位',
  'wZ+mT6': '選擇計量單位',
  '/CDgDv': 'EIN號',
  '1AeGN2': 'LUCID號',
  '47GdDb': '關閉',
  '62OTLP': '下單渠道',
  'EJNWSf': '<strong>API：</strong>{break}使用API下單，采用智能推薦下單後，如系統推薦的發貨倉與原倉庫不一致，會以報錯的形式進行提示，客戶可根據提示信息修改後重新提交。{break}<strong>批量導入：</strong>{break}使用批量導入下單時，采用智能推薦推薦下單，如系統推薦的發貨方案（發貨倉庫和派送方式的組合）與原方案不一致，彈出提示界面，如推薦方案有庫存，可代替原方案下單；如推薦方案無庫存，則只展示，不改變原下單方案。',
  'sX4SJM': '<strong>智能推薦下單：</strong>{break}智能推薦下單是指系統根據客戶下單時買家地址、派送方式、海外倉庫存等信息，基於尾程最優成本&最優時效的原則，計算出最優發貨方案（發貨倉庫和派送方式的組合），並推薦給客戶。如需使用智能推薦，請選擇主倉下單。',
  'EJpN+O': 'ABN號',
  'M+2rs2': 'BOND號',
  'M32toW': '提交時間',
  'QCtV9X': '智能推薦下單',
  'ZUPzqr': '開啟',
  'cBSx2y': '自動發貨',
  'dWSaKv': 'EORI號',
  'RKlsu6': '出庫智能推薦配置',
  'ilxqI8': '自動發貨：自動發貨是指系統會自動根據自動推薦所計算出的最優發貨方案自動幫客戶進行發貨，無需客戶二次確認。如您有指定倉庫發貨的需求請勿開啟！',
  'nlhDkH': 'Bussiness Number(BN)',
  'th8lNA': 'VAT號',
  'ux3AEe': '說明',
  'uzP8rj': '審核通過時間',
  '0POKcW': '應用區域',
  'bfcFzv': '平臺同步',
  'l6DYl/': '批量導入',
  'Qc8f+x': '至少選擇一個下單渠道/應用區域！',
  'k8xgfx': '至少選擇一個下單渠道！',
  '0hqZKL': '語言設置',
  'zRZV02': '商品申報價值可在通過萬邑聯或 API 下單時填寫並提交。',
  'T8UlhA': '若按訂單維度填寫申報價值，系統將按您填寫的金額分攤至對應 SKU。',
  'hzYI1M': '若按SKU 維度填寫申報價值：',
  'F18MFf': '當全部 SKU 均已填寫申報價值時，以您實際填寫的金額為準；',
  's+rM90': '當部分 SKU 未傳入申報價值，或申報價值為 0時，系統將在申報價值獲取規則中直接跳過「下單時填寫」規則，從下一優先級規則依次獲取貨值，作為該 SKU 的申報貨值。',
  'Xsrcgd': '訂單總申報價值為所有 SKU 申報價值之和。',
  '6tpF/e': '下單時填寫',
  '7wofGo': '應用',
  'C8evWc': 'SKU發貨國家的出口申報價值',
  'GlTTjv': '平臺銷售價格（僅限ebay平臺）',
  'Gwj7xc': '恢復默認',
  'JUpZ++': 'SKU發貨國家的進口申報價值',
  'MDCxK0': '獲取順序',
  'RKJ5i8': '註意：{break} 1. 申報價值獲取來源選項不能全部取消，至少保留一項。{break} 2. 當未設置申報價值獲取順序時，默認獲取順序為：{break} 下單時填寫＞平臺銷售價格（僅限ebay平臺）＞SKU發貨國家的出口申報價值＞ SKU發貨國家的進口申報價值',
  'W3sY1n': '申報價值獲取來源',
  'aBSjju': '獲取來源',
  'aq5/iT': '訂單發貨倉對應國家獲取的商品進口申報價',
  'cUGZlH': '訂單發貨倉對應國家獲取的商品出口申報價',
  'kyIaVY': '若您在萬邑聯的平臺同步綁定了eBay店鋪，系統自動獲取的訂單商品總費用',
  'qJVc8e': '申報價值獲取設置',
  'BG+fLq': '幫助指南',
  'FJZaXL': '搜索到{total}條記錄 "{keyword}" 的結果',
  'zUjHmW': '<strong>抱歉，沒有找到與“{keyword}”相關的文檔</strong>{break} 建議您：{break} 看看輸入的文字是否有誤{break} 去掉可能不必要的字詞，如“的”、“什麼”等',
  'zvNTfS': '進入指南',
  'xUjLTE': '搜索',
  '3/xobX': '請授權eBay查詢協議',
  '7uKffF': '授權eBay查詢協議',
  'GKxsGv': '授權eBay查詢協議!',
  'r0/TUu': '確定',
  '/554iQ': 'eBay賬號',
  'H0w708': '關聯eBay賬號',
  'IPC1Nx': '商品編碼',
  'VpfuUi': '規格',
  'c4RKNC': '批量導出',
  'r2dEd/': '重置',
  'xJ3UzU': '國家',
  'zJ+fPt': '維護商品',
  '1WkxFB': '未提交商品，請您搜索出商品後再提交！',
  'AFr5qh': '請輸入國家',
  'OxFkJJ': '請輸入關聯eBay賬號',
  'a6Yyuu': '請輸入商品編碼！',
  'JN5iZt': '提交成功',
  'ENPgS/': '提交',
  'Idl9bN': '下載上傳模板',
  'OVecAI': '成功',
  'UxWoxB': '請上傳文件！',
  'e6Kx8h': '上傳導入文件',
  'jvT5eh': '允許上傳文件類型為：.xls .xlsx',
  '553X02': '單個變更',
  '7hIS0P': '新增綁定關系',
  'IGEePO': '批量變更',
  'i+8CAV': '提交變更',
  'uq1Q7O': '可用庫存數',
  'yy7EDI': '上傳',
  'h7PahP': '綁定時間',
  'kc0dbR': '變更',
  '7tXP5z': '請輸入商品編碼',
  '5vOrMy': '您修改的商品編碼已提交成功。',
  'OiUovQ': '註意：{break} 1、 請不要修改任何字段或文件格式；{break} 2、一次僅允許導入2000條數據，超過時請拆分為多個文件；{break} 3、導入成功的結果請您前往【<a>eBay認證倉商品查詢</a>】進行查看。{break}',
  'Q3iOKS': 'eBay認證倉商品查詢',
  'S0QUcN': '您已導入成功，請前往eBay認證倉推送商品頁查看綁定結果。{break} 提交成功 {successNum} 條，提交失敗 {failNum} 條。 {failNum, select, 0 {} other {失敗的導入數據和失敗原因 <failUrl>點擊下載文件</failUrl>} }',
  'l85pdw': '註意：{break} 1、僅在【賬號管理】為已啟用的eBay賬號，庫存信息會同步到eBay，您可前往【<a0>賬號管理</a0>】查看eBay賬號狀態；{break} 2、該頁面僅展示已綁定的商品信息，未綁定請前往【<a1>eBay認證倉商品管理</a1>】進行綁定；{break}',
  'tqdJgC': '綁定推送/解綁',
  'w5d7pQ': '您已導入成功，請前往eBay認證倉推送商品頁查看綁定結果。',
  'zQgm+f': '溫馨提示：{break} 1、已綁定推送商品不允許變更商品關聯的eBay賬號、國家；{break} 2、提交變更時請您核實提交結果，提交後將依據變更，綁定推送關聯信息或解除綁定不再推送關聯信息。{break}',
  'Tjer6Q': '出庫自動分配優先級：包括出庫、盤虧等所有減庫存的單據，只適用普通庫存；UK-Defer入庫的庫存仍將按先入先出規則優先分配。',
  'U5Vumz': '未配置的VAT按默認規則自動分配，出庫自動分配優先級低於配置規則中的VAT。',
  'sCNEKm': '出庫自動分配優先級：包括出庫、盤虧等所有減庫存的單據。',
  'x7XBYH': '入庫禁止自動分配：如果選擇Y，退貨、盤盈等加庫存場景，此VAT不參與分配。',
  'cMDiKi': '以下地址用於「海外倉的驗貨、提貨地址」「國際遞送ISP」 和「國際送倉FBA」訂單的提貨或寄件地址新增地址。',
  'oSlHJh': '國際遞送ISP/eDS 產品，同一個城市不允許超過2個攬收地址。',
  '+eZfm3': '《信息授權協議》',
  '2QzYmY': '取消',
  '2dToBQ': 'VAT信息',
  '32RoB6': '《德國海外倉倉儲協議》',
  '3YXmhj': '重新提交',
  '608d8o': '日志',
  '9WauWf': 'Bussiness Number(BN)文件',
  'C6gmWp': '出口商注冊地址',
  'DZfXfd': '請仔細查看協議並同意',
  'DnlTlc': '《英國海外倉倉儲協議》',
  'F70ljy': '選擇普通清關的需要繳納進口清關增值稅和關稅',
  'FNgKWM': '撤回',
  'FsjBUE': '稅務代理聲明函',
  'GkNbe+': '資料',
  'Hd1SOD': '選擇開票進口商不可以作爲清關進口商',
  'I+27a0': 'EBAY店鋪綁定VAT截圖',
  'JfR4m8': '不能包含中文字符',
  'KfmqkT': '保存成草稿',
  'LRaUkx': '出入庫數據授權協議',
  'ODfvW/': '出口商名稱',
  'Qv+LG3': '《關于德國包裝法義務的法律約束力申明》',
  'Rq/p8Q': '我們確認已經符合英國關于增值稅的要求並同意簽署',
  'SSUtSr': 'EORI文件/激活截圖',
  'Sxq3ys': '請輸入歐盟國家名稱',
  'VsT/ah': '營業執照',
  'WEgQND': 'PVA進口承諾函',
  'WSq7p2': 'VAT注冊證',
  'ZKKStI': 'BOND證明',
  'ZXhbHG': '貿易商注冊地址',
  'dbS2AO': '不走萬邑通頭程運輸',
  'eGYTrD': '進口商注冊地址',
  'fKSz21': '貿易商名稱',
  'fRH1j+': '請輸入經營單位名稱',
  'g+ULz4': '萬邑通將應英國海關稅務總署（HMRC）要求提供相應的信息和文件給英國海關稅務總署（HMRC）',
  'gA384i': '維護',
  'h/HUTI': '適用國家/地區',
  'hMAtte': 'RIS文件',
  'nubBQI': '我已閱讀並同意簽署',
  'prYaF1': '選擇自有進口商遞延清關需要繳納進口清關關稅，不繳納增值稅，UK的進口商申請該報關方式需要上傳“PVA申請函”，“英國稅務代理的擡頭信紙申明函”，“VAT報稅證明”（VAT注冊日期超過6個月，提供前壹季度報稅證明/VAT注冊日期6個月以內，後續提供從注冊日期起計算第5個月的申報記錄），請在上傳資料時完成提交。',
  'q3xYc9': 'ABN注冊證',
  'qSAraU': '法人/董事',
  'rgQ1Wi': '以及',
  'tsqy8I': 'LUCID注冊文件/注冊截圖',
  'usIIRS': 'PVA申請函',
  'vDCwZ9': '上傳文件',
  'vr5TVT': '請輸入',
  'xykin+': '統壹社會信用代碼',
  'yn1SL5': '進口商名稱',
  'BdHisb': '操作時間',
  'Da7ks5': '請輸入18爲字母與數字',
  'a/r3qH': '操作人',
  'atGbyi': '請輸入18位信用代碼',
  'e1tqgk': '作廢後無法再撤回，請確認是否作廢？',
  'tLzna4': '操作動作',
  'IbJWUq': '是否作廢當前維護信息？',
  'QieJUI': '變更字段',
  'gsnEOr': '變更前',
  'pS8NPW': '變更後',
  'Dj/XZS': '請勿輸入空格',
  'ej75mI': '請輸入有效的電話號碼',
  'XwwFFy': '報關方式',
  'mqQjid': '身份證/護照正反面',
  'r+pn1G': '選擇自有進口商遞延清關需要繳納進口清關關稅，不繳納增值稅，UK的進口商申請該報關方式需要上傳“PVA申請函”，“英國稅務代理的擡頭信紙申明函”，“VAT報稅證明”（VAT注冊日期超過6個月，提供前壹季度報稅證明/VAT注冊日期6個月以內，後續提供從注冊日期起計算第5個月的申報記錄），請在上傳資料時完成提交。',
  '6RphVF': '請上傳文件',
  'D+QVwb': '頭程非WINIT承運可選擇此清關方式。',
  'o1vWQc': '當前維護記錄是指已經通過審核並啓用的進口商，在變更關鍵信息時，需要再次審核的審核記錄。 {break}核通過後才可成功變更，未審核通過則變更無效。',
  'v8rn/V': '使用客戶自有進口商做進口，只繳納關稅，不繳納VAT增值稅。UK的進口商申請該清關方式需要"英國稅務代理的擡頭信紙申明函”發至指定郵箱（可咨詢銷售開通），上傳“PVA申請函”“出入庫授權協議" "PVA聲明函”。',
  'vsXTPj': '使用第三方進口商做進口，需要繳納繳納關稅和雜費（不提供稅單）。',
  '3Atmuu': '確認失效',
  'BTlPVu': '登錄校驗日志',
  'BbSb0z': '修改',
  'BtZh7z': '創建',
  'Q4mnEi': '審核通過後修改',
  'liLr1Z': '是否刪除當前信息？',
  'mUCGVr': '確認有效',
  'rthds+': '是否撤回當前信息？',
  'sdupnt': '確認異常',
  'xk9Koe': '維護日志',
  'y3ogvt': '維護審核通過',
  'yyHJG6': '是否刪除當前維護信息？',
  'N5niLf': 'Business Number(BN)',
  'T61GlG': '當前維護記錄是指已經通過審核並啓用的{name}，在變更關鍵信息時，需要再次審核的審核記錄。{break}核通過後才可成功變更，未審核通過則變更無效。',
  'WMI5sr': 'Business Number(BN)文件',
  '+hneSS': '提交維護',
  'OTPfbv': '變更時間',
  'WMGcE3': '維護審核不通過',
  'byKmgP': '{start} 至 {end}， 共 {total} 條記錄',
  'N5Lfmq': '不允許的文件格式',
  'niXKkN': '文件大小超過10M',
  '7gd0PB': '資料錯誤提示',
  '86uQ8V': '以下文件地址失效，請重新上傳：{files}',
  'GJghrF': '注意：上傳資料格式限制爲pdf、jpg、png，大小限制10M，單文件類型限制10個',
  'HlgPNt': '中國大陸',
  'Lszars': '美國',
  'PIBLYF': '中國香港',
  'trcfDz': '例圖{index}',
  '/Fo4sl': 'UK海外倉線上協議',
  '/h0Qy3': '地址名稱',
  '1m6Ukk': '地址編碼',
  'AcTHLQ': '無效',
  'Cyu6TT': '收貨地址',
  'FXq3sc': '發貨地址',
  'JJl2M9': '導出',
  'naS99r': '有效',
  'yjFeF+': '第三方倉地址',
  'qZZtQ0': '該地址下單不可用',
  'Df3vzk': '拖拽調整順序',
  'FS9wfs': '重新提交維護',
  '2lXLcA': '請選擇適用國家',
  '3GEmd9': '查看地址字符自動修正邏輯',
  'hiw+Xi': '地址自動修正配置',
  'kyspuD': '適用國家',
  'pyipaf': '啟用自動修正地址字符',
  'rVuTxV': '變更日誌',
  'gYnrwb': '所有',
  '10jb3V': '啟用自動截取門牌號',
  'Yx3wUi': '啟用自動修正城市',
  'o1Hwo3': '變更人',
  'tGCYrC': '變更內容',
  '876ii/': '2、簽署<url>《全球地址自動優化協議》</url>後，系統將自動啟用以下所有修正項，如需關閉請去掉勾選後保存。',
  'B8Is1c': '1、啟用地址自動修正，需提前簽署<url>《全球地址自動優化協議》</url>，否則以下配置不可編輯',
  'P4iDwm': '查看門牌號截取邏輯',
  'UYZ3z+': '查看自動修正城市邏輯',
  '6AxC42': '收件人邮箱',
  'CmaYfv': '收件人VAT/EORI',
  'UVmTM9': '收件人姓名',
  'abk9Do': '收件人电话',
  'k/3yRK': '常用出库地址',
  'oN/kSF': '预约信息',
  'uoZwj+': '创建人',
  '3eRWcP': '郵箱地址',
  '6kdpEu': '收貨人信息',
  '9YhIAD': '郵件預約',
  'HNavdr': '公司名稱',
  'V2u2QJ': '預約要求',
  'jetAYE': '電話預約',
  'siSti3': '地址信息',
  'ea3Q5D': '電話號碼',
  '3XMw6o': '責任人公司',
  'AG/fPb': '地址2',
  'B7TTEB': '鑒于以下提交的內容，我/我司聲明：{break} 1.對于由我/我司的歐盟責任人負責的每件商品{break} a.商品/其包裝或隨附文件中標有歐盟責任人的名稱和聯系詳情，包括郵政地址{break} b.歐盟責任人擁有符合性聲明(或性能聲明),並有權訪問相關技術文檔以證明符合要求{break} 2.如果我/我司的歐盟責任人發生任何變更,將通知貴司{break} 3.上述提交的所有信息均屬實,如有虛假信息導致的任何責任及後果將由我/我司承擔',
  'EpqiOL': '確認是否生效？',
  'IIqX9O': '電子郵件',
  'KZEXfv': '確認是否失效？',
  'etW1Tw': '負責人狀態',
  'jrh2fV': '編碼',
  'qRFx1i': '新增負責人',
  'qWBL/6': '商品負責人',
  's4hJju': '詳情',
  'uUvS4a': '地址1',
  'w1B/h4': '生效',
  '1AtZdk': '前往提交訂單頁',
  '36+mbi': '處理狀態',
  '9AIfVS': '成功數量',
  'ARrflw': '文件名稱',
  'KnTZPE': '失敗數量',
  'NLpJXo': '耗時（分鐘）',
  'NPKHC7': '下載失敗數量',
  'O2kIme': '批量上傳結果',
  'uMZCpR': '所有數量',
  '+eaHJw': '批量新增',
  'G2smdP': '中文名稱',
  'L5h07e': '批量移除',
  'Ly/R6V': '指定不良品混合存儲',
  'RlzFYp': '確定移除嗎？',
  'XF6xi6': '請選擇需要移除的商品！',
  'aHlr3k': '移除',
  'D1o32K': '異常日期',
  'IIpaxH': '異常類型',
  'UfxykZ': '原因',
  'l0qKOL': '異常庫存數量',
  'hYlWkF': '最多支持{count}個編碼，使用逗號或換行分隔',
  'veOJme': '數量超過{count}個',
  'txkkWO': '關聯單號',
  '2C37Hc': '異常單號',
  'LLD1es': '異常原因',
  'k1dsDk': '關聯業務單號',
  '0D60ha': '更多',
  '46Xee4': '目的國進出口商',
  'WVZBn4': '目的國進出口商註冊地址',
  'sWBQDd': '目的國進出口商名稱',
  '6qPVaC': '尾程指定進口商',
  '7BkuKz': '下單設置',
  'QeeTzU': '進口國',
  'ckpzhc': '出口國',
  'yvg8P4': '尾程指定出口商',
  '75uiZ7': '請輸入{fieldName}',
  '+benQU': '您好，不可以同時選擇同一個國家或者同為歐盟國家作為進出口商，請重新選擇',
  'm3uVGW': '進出口國組合配置重復，請重新選擇',
  'n/orQt': '尾程進出口商配置',
  'h+ZVJS': '【尾程指定出口商】和【尾程指定進口商】必須指定其中一個，不能同時為空',
  '+k3Q5q': '尾程進出口商可指定國家下使用的進出口商，【尾程指定出口商】和【尾程指定進口商】必須指定其中一個，不能同時為空',
  'wxbfiR': '該目的國進出口商已失效，請重新配置',
  'KR0Hgn': '原產地出口商註冊地址',
  'O8r6Nr': '原產地出口商名稱',
  'auxh85': '其他設置',
  'eu9UcL': '原產地出口商',
  '7Rb0P0': '請輸入0-30個字符',
  '9SnCRm': '錯誤提醒',
  'BugeSn': '僅支持zip格式的壓縮包{break}將每個商品的德語說明書規範檔案名稱後，壓縮為一個zip格式的檔案，方可進行上傳。 {break}壓縮包內檔名規範：商品編碼&&&規格',
  'DqPtfZ': '有',
  'EIebSr': '無',
  'HvXKb+': '導入類型',
  'MCgWp2': '導入成功',
  'NzmP6C': '紙質德語說明書',
  'O6OGAx': '商品條碼',
  'Up6Ro9': '下載導入模板',
  'X5vmSB': '德語說明書鏈接',
  'cpiawR': '支持doc格式或者pdf格式，限製10M以下',
  'hwLqlW': '導入只支持XLS、XLSX格式文件，導入文件中的鏈接最長支持30個字符',
  'iwbG4U': '中文名稱{break}英文名稱',
  'oH13Vj': '導入',
  'pVp/bh': '請選擇文件上傳',
  'rpg4rj': '德語說明書文件',
  'xraZsK': '點擊此處',
  'srQkrR': '說明：{break}a.電子檔說明書，需進行庫內增值把說明打印出來添加到商品裏{break}b.說明書鏈接，商品出庫時將在面單上打印對應的德語說明書的鏈接，但該功能受限於尾程派送供應商，建議您盡快把德語說明書紙質文件添加到商品裏{break}c.顏色標紅的商品必須帶有紙質的德語說明書',
  '+CFe0t': 'Winit標準包裝',
  '/CesoY': '體積(CBM)',
  '0B0jPm': '天',
  '1ZbDC3': '重量(kg)',
  '2+X2n8': '批量刪除',
  '23ZRo5': '出口商VAT',
  '2IBaY7': '請輸入數字且小數點後不超過四位',
  '3xzQSW': '不能選擇的原因',
  '6+iYA0': '序號',
  '63L59R': '客製包裝',
  '6EHwdX': '托盤類型',
  '7FRGXg': '批量添加商品',
  '7n6a/K': '商品資訊',
  '7riRKk': '批量添加',
  '8VzrEu': '請選幣種',
  '9bnXiC': '單一產品',
  '9k+FW2': '尾托',
  '9ll3dY': '包材型式',
  '9qzdVH': '包裹重量(kg)',
  'Ao74DA': '訂單包材商品編碼',
  'BHT1Cr': 'SKU類型',
  'CKRHYP': '折扣金額',
  'DTvHkh': '以下報價僅供參考，最終以出庫單的實際計費為準，如有疑問，請與您的客服代表或業務經理聯繫，謝謝！ ',
  'Dpm+6x': '發貨倉，收件人國家和郵編，商品資訊為必填項{break} 如果您填寫郵編不正確，將無法計算費用{break} 如果您使用【非WINIT註冊商品】 測算，填寫的重量或體積超過渠道限制，將無法計算費用{break} 如果需要計算TOLL相關的渠道費用，或收件人國家為AU，請填寫省份/州和城市資訊{break} 如果需要計算要 申報的管道，使用【非WINIT註冊商品】測算時，請填寫銷售金額及幣種資訊並且請在【萬邑聯-個人中心-申報價值獲取設定】頁面勾選【申報價值獲取來源】為「下 單時填寫”',
  'GBQ8fq': '托盤長*寬*高',
  'GMujSv': '銷售金額',
  'HRSUhm': '若SKU類型為單一產品，請填寫出庫單商品個數；若SKU類型為套裝產品或箱產品，請填寫出庫的套數或箱數',
  'HzFVgP': '請選擇商品再進行計算',
  'KgH03N': '全托',
  'MBDvr0': '請輸入寬',
  'MPleAI': '商品名稱',
  'NgGZZ2': '請輸入12位以上數字或字母',
  'O0A1Oq': '長*寬*高(cm)',
  'Og2Qdv': '不可選擇產品',
  'P410bl': '請輸入長',
  'QrBLOg': '一單多包裹',
  'THHekX': '庫存單元標準件數',
  'TTavqO': '常規出庫',
  'TdB0f7': '請輸入高',
  'UH1kCc': '添加',
  'VGcpgt': '派送時效',
  'WHdJYA': 'Winit產品',
  'Z+i6Rm': '商品規格',
  'bZaON1': '金額輸入限制0.01-999999.99，最多兩位小數',
  'bduxF6': 'Winit已註冊商品',
  'cIVTIx': '托盤個數',
  'cQZEJX': '超托',
  'cstWzE': '進口商VAT',
  'dJ89Br': '加值服務',
  'eLEnSl': '非Winit註冊商品',
  'fMEG4U': '一單多面單打包',
  'hAZ9h3': '高請輸入數字且小數點後不超過兩位',
  'hR9/2a': '包裹長(cm)x寬(cm)x高(cm)',
  'hTL5aU': '托盤數',
  'hTZnwL': '回饋金額',
  'i0bc3f': '幣種',
  'i1oH9G': '包裝方式',
  'i738m0': '出庫加包裝',
  'igMfLW': '套裝產品',
  'jOZW14': '托盤出庫',
  'k7s6O7': '出貨倉',
  'lqAG8L': '箱產品',
  'mDikX0': '出庫數量',
  'mhxee1': '費用項名稱',
  'nIWEr7': '可選擇產品',
  'ohULHS': '收件人國家',
  'w6vqtD': 'IOSS NO.',
  'wauDMi': '總費用',
  'xuLZNZ': '長請輸入數字且小數點後不超過兩位',
  'yx2O+K': '應收金額',
  'zO/rYo': '出庫方式',
  'zy6bEq': '寬請輸入數字且小數點後不超過兩位',
  '2w153i': '實收金額',
  'IFSxrU': '費用項編碼',
  'tc4Ood': '請選擇數據',
  'Bc++8m': '氣泡袋',
  'Dm23uJ': '紙箱',
  'f9THke': '快遞袋',
  'sPJoAT': '派送費用預估',
  'TdtC9s': '請選擇出貨倉',
  'XiHRkz': '共 {total} 條記錄',
  'bFMl+l': '請選擇商品並添加',
  'SfYiE5': '輸入的值必須是大於0的整數',
  '//WaV/': '單品化管理',
  '/XgsKl': '是否有只上貨機標',
  '1+Uose': '權限設置',
  '1E5dGB': '有品牌',
  '2MJUJn': '啟用出庫組套',
  '44gmfc': '商品化管理',
  '5xncPr': '是否有限製出口標',
  '7RULl5': '啟用後，可以按批次管理商品並指定批次出庫',
  'A5gRQm': '是否有鋰電池UN標',
  'B5hVJ7': '展開更多設置',
  'BTv3tF': '不加包裝',
  'EcMORf': '啟用批次管理',
  'FOxVvr': '啟用後，您可以維護包材商品。出庫時可以配置使用客製物流包裝',
  'Hs7Y9S': '商品設置',
  'I8NwoI': '選擇不加包裝，則註冊商品默認全部不加包裝。{break}需要加包裝，註冊商品才會需要填寫包裝信息，可以對商品添加包裝偏好，後續仍可對單個商品進行修改。',
  'IOnZfu': '是否有易碎品標',
  'JJR2vL': '是否有正面朝上標',
  'KWQDuK': '啟用後，可以指定商品按照出庫組套規則進行規範打包',
  'L4Rf/B': '默認設置，後續仍可對單個商品進行修改。',
  'RShmXn': '管理方式',
  'S/KCTh': '需要加包裝',
  'S30Plx': '商品出庫包裝',
  'V2w9jQ': '啟用套裝產品',
  'XL7Ecj': '是否有9類危險品標',
  'XQ0eW6': '商品入庫包裝',
  'Z2NCKN': '啟用客製包材',
  'dBkhSm': '啟用後，可針對單一產品SKU維護箱產品',
  'eq/wHb': '無品牌',
  'et9PbY': '啟用多個第三方商品條碼',
  'fZCpT7': '啟用箱產品',
  'ipcBHJ': '默認設置，後續仍可對單個商品進行修改。{break}當通過API註冊商品時，不填則默認管理方式為當前偏好。',
  'nkXqB0': '是否有品牌',
  'ooWceD': '是否有只限陸運標',
  'rvY6SV': '收起更多設置',
  'sCJ51j': '啟用後，可以對同個商品維護多個第三方商品條碼',
  'wgwaXi': '啟用後，可針對單一產品SKU維護套裝產品',
  'xE1H+X': '設置',
  '5knzXk': '商品出庫包裝偏好',
  'Ak9BaJ': '出庫包材類型',
  'CB041o': '單一訂單',
  'DxV5Uw': '出庫包裝類別',
  'EMKEjY': '默認設置，後續仍可對單個商品進行修改',
  'NV9VX7': '復合訂單',
  'V0RiZp': '操作成功',
  'nP04RA': '選擇需要加包裝會默認開啟出庫加包裝使用權限，註冊商品時需填寫包裝信息，導入模板也會隨之更改（需重新下載導入模板）。確認需要加包裝嗎？',
  '1i8ZrX': '商品包裝材質',
  '4MGor2': '入庫包裝',
  'EWhdiR': '裸貨不支持直接出庫，請維護出庫包裝偏好為需要加包裝，否則商品無法註冊提交',
  'Gz4aGL': '出庫包裝',
  'H6C/SG': '商品包裝形狀',
  'OD7P5z': '去簽署',
  'vDrXbl': '商品入庫包裝偏好',
  'NFpCub': '銷售包裝不支持直接出庫，請維護出庫包裝偏好為需要加包裝，否則商品無法註冊提交{break}{break}若您仍需使用銷售包裝出庫，請簽署<url>《銷售包裝商品海外倉免責協議》</url>',
  'DmqHzL': '客製包材使用說明如下，請先仔細閱讀後再打開。打開後若維護了客製包材將不允許關閉，請謹慎操作！<url>《查看操作指引》</url>{break}{break}確認要啟用客製包材嗎？',
  'IKjl4Y': '出庫組套使用說明如下，請先仔細閱讀後再打開。打開後若添加了組套將不允許關閉，請謹慎操作！<url>《查看操作指引》</url>{break}{break}確認要啟用出庫組套嗎？',
  'i2iyhb': '箱產品使用說明如下，請先仔細閱讀後再打開。打開後若創建了箱產品將不允許關閉，請謹慎操作！<url>《查看操作指引》</url>{break}{break}確認要啟用箱產品嗎？',
  'iZYhRR': '批次管理使用說明如下，請先仔細閱讀後再打開。打開後將不允許關閉，請謹慎操作！<url>《查看操作指引》</url>{break}{break}確認要啟用批次管理嗎？',
  'jX7MAR': '第三方商品條碼使用說明如下，請先仔細閱讀後再打開。打開後若對商品配置了多個第三方條碼將不允許關閉，請謹慎操作！<url>《查看操作指引》</url>{break}{break}確認要啟用多個第三方商品條碼嗎？',
  'mLKBZu': '套裝產品使用說明如下，請先仔細閱讀後再打開。打開後若創建了套裝產品將不允許關閉，請謹慎操作！<url>《查看操作指引》</url>{break}{break}確認要啟用套裝產品嗎？',
  '+Xgzdq': '是否帶有電池',
  'DpcGY6': '是否為食品',
  'FGVjpL': '是否帶有液體',
  'nJAKFn': '更改商品管理方式偏好，将影响注册商品时默认取值，请谨慎操作。确认是否要切换偏好？{break}特别注意：ERP对接通过API接口注册商品时，商品管理方式不传值会默认取当前偏好管理方式，更新会影响后续注册商品属性。若API注册商品已传值则不受影响。',
  'USKhsn': '搜索的 "{keyword}" 的結果',
  'J1Q+MP': '跳過',
  '66h8jy': '操作指引',
  '19Jq5n': '共選中{count}項',
  '1WXIxS': '解綁',
  'DBt/Kx': '單品條碼',
  'FEb7U2': '確認',
  'Ig8gbN': '單品狀態',
  'R5GY4d': '導入日期',
  'Wz9vSw': '格式輸入錯誤，請換行分隔',
  'XlNGpT': '導入時間',
  'ZPVUga': '失敗原因如下:',
  'CW17P+': '複製删除失敗條碼',
  'XOD0e7': '删除失敗！',
  'mUf6oZ': '共删除{totalNumber}条，成功{sucessNumber}条，失败{failNumber}条',
  'u4FyMa': '删除成功！',
  'x79O39': '是否確定删除？',
  'J9jPRL': '複製成功',
  'Zmju6f': '是否确定删除？{break}删除后此单品将无法识别。如需使用可再次导入。',
  'aINg/w': '共选中{count}项{brack}删除后此单品码将无法识别。如需使用可再次导入。',
  'nE9ED6': '商品編碼/單品條碼必填',
  'v0yFyE': '支持{count}個査詢, 多個換行分隔',
  '16GLc2': '導入標題',
  'EJ8eWW': '請重新上傳文件',
  'PqthfX': '導入只支持XLS、XLSX格式檔案',
  'QJWMv+': '下載明細',
  'Qw6uy2': 'SI碼',
  'aFoyrY': '异常資訊',
  'msjKFi': '說明：單次最多支持導入2000行數據； 導入的單品條碼會自動忽酪大小寫（例：A001=a001）',
  'yiJCTd': '導入數量',
  'zKvO0B': '導入失敗',
  'DVNJXJ': '海外倉名稱',
  'qXXyG3': '目前是否有權限',
  'trneJA': '下單時是否顯示',
  'x/c7oO': '入庫倉庫權限與偏好設定',
  'CYysYX': '入庫倉庫權限開啟後，您無法主動關閉權限，如果您暫時不使用該倉庫，可在此關閉，下單時將不再展示該倉庫。 ',
  'Dpt9uk': '1.請先詳細閱讀[說明]內的權限描述，部分倉庫的入庫權限需要聯絡銷售，溝通細節後開啟；部分倉庫您可自行開啟入庫權限;{break}2.權限 一旦開啟，無法關閉，您可選擇下單時不展示，若確實需要關閉，請離線聯絡銷售。',
  'JSgfNL': '權限一旦開啟，無法主動關閉，但您可選擇下單時不展示。 開啟前請確認該倉庫的說明內容[{content}]',
  'Yms1oN': '確認開啟',
  'dNnCF+': '權限一旦開啟，無法主動關閉，但您可選擇下單時不展示。開啟前請確認該倉庫的說明內容',
  '+QWQ7W': '遺失',
  '3oxdqD': '凍結庫存詳情',
  '4Cv856': '倉庫',
  '51UNgD': '訂單類型',
  '7NAcml': '在途預售庫存',
  '7jOH23': '禁止出庫詳情',
  '8eXVBt': '銷毀',
  '9YU+8d': '已遺失待客戶確認',
  '9y5qSL': '客戶確認時間',
  'AG7PGl': '可用數量-單一產品',
  'BEt562': '不良品',
  'BNzv8f': '待銷毀',
  'C9KK8/': '發貨倉DOI',
  'D/f5lj': '已選中{count}項,',
  'ID5w3K': '凍結庫存',
  'IXB0ef': '在庫庫存',
  'JPAdAP': '庫存狀態',
  'JQ/Ist': '國家DOI',
  'Km0LJq': '在庫庫存=可用庫存+凍結庫存',
  'L9MjKF': '30天平均庫存',
  'Lt5p5C': '標準件數',
  'OA+Xwp': '預售待出庫',
  'P7a7B/': '調整原因',
  'PnCden': '可用庫存',
  'QSV2/G': '訂單號',
  'QchsUr': '15天平均日銷量',
  'Qo/0n7': '遺失確認中',
  'RT/7og': '歷史銷量',
  'RbA7OQ': '異動庫存數量',
  'SWKjFA': '{code}異動單品條碼',
  'T7WawI': '條碼值',
  'TpgfJ8': '請先勾選項目,再進行批量操作',
  'URlHB2': '30天平均日銷量',
  'VdJkh+': '15天平均庫存',
  'W2+wGW': '商品等級',
  'WsRSAn': '凍結',
  'WwDNC5': '待出庫',
  'X762xx': '確定是否“銷毀”？',
  'XOOIse': '凍結時間',
  'XlFayN': '禁止時間',
  'YUZvPl': '分類調整',
  'YnxgOi': 'VAT失效',
  'ZVeUDz': '可用數量-套裝產品',
  'Zdo26n': 'Winit批次號',
  'btoiBR': '歷史代銷量',
  'cRTCYq': '沒有單品條碼',
  'cU49d1': '確定是否“遺失”？',
  'ccnZxp': '在途庫存',
  'cflP7Y': '批量操作',
  'cuhpZK': '歷史入庫',
  'dLxQHX': '批量盤盈',
  'dgQSya': '批量銷毀',
  'fFmyYM': '數量',
  'fWbzVI': '禁止出庫原因',
  'fnadHf': '可用數量-箱產品',
  'j6IHvr': '查看詳情',
  'jCTrLS': '原因類型',
  'k6yR1Q': '批量遺失',
  'lGKG8E': '商品編碼:',
  'lLWqdW': '禁止出庫',
  'n+BMoU': '盤盈',
  'nESkNw': '出庫',
  'oOn0Fr': '確定是否“盤盈”？',
  'pii09f': 'DOI',
  'qauzml': '商品編碼:{code}',
  'tQ0Q32': '良品',
  'w9wMqE': '90以上',
  'wKT8Cc': '異動類型',
  'xR2mTp': '7天平均庫存',
  'xRoxY9': '在庫异常',
  'yq0/8z': '7天平均日銷量',
  'zVQSYe': '複製全部單品條碼',
  'zgawnw': '30以下',
  '3etnsJ': '商品庫存詳情',
  'mlFgct': '在庫异常庫存詳情',
  't0kvjC': '查看全部',
  '2Po2YS': '自定義備註',
  'CMMjhY': '列展示',
  'dS21yU': '國內驗貨的訂單總在途庫存，含在途預售庫存',
  '1DsLji': '盤虧',
  'AZxE/7': '已盤虧待客戶確認',
  'WA8SWg': '批量盤虧',
  'zJebwh': '確定是否“盤虧”？',
  'eZAtxt': '欄位展開',
  '/54ans': '聯系我們',
  '5XTs5h': '未開通',
  'AzoW7u': '綁定平臺賬號',
  'CYaf7V': '合作平臺',
  'CqNtWB': '在線客服',
  'FO80Dr': '公告',
  'L9AWTW': '立即充值',
  'LJ4oo0': '海外倉可下單余額',
  'bpnKHs': 'ISP錢包賬戶',
  'cDLItQ': '服務熱線',
  'dQk0wJ': 'QQ群',
  'iAGw0w': 'ISP可下單余額',
  'mFqrQH': '周一至周六',
  'qCIS/C': '海外倉錢包賬戶',
  'yYPe3y': '官方微信',
  'z3zd1c': '我的錢包',
  '0NHAD7': 'Ascan平均耗時(工作日/小時)',
  '26DC55': '註冊商品',
  '3R9vaL': '手動輸入商品信息',
  '4IKihp': '提交資料',
  '5WHhDh': '創建SKU',
  '7XxAs8': '訂單配送數量',
  '7fauGF': '庫存準確率',
  '8RMTyh': 'Dscan平均耗時(工作日/天)',
  '9HIheN': '待還賬單',
  'Al4hA+': '計算費用',
  'AmrrcV': '下載詳細倉租尾程報價',
  'BJTA9X': '上架及時率',
  'Cpevaa': '重量',
  'EdQOh6': '待辦事項',
  'FBa9eA': '創建入庫單',
  'FE59Oe': '請選擇倉庫',
  'GwpK9X': '聯系客戶經理',
  'KiyShr': '存儲在萬邑通倉庫的商品數量(個)？',
  'LMdsl4': '貨物在哪個國家履約？',
  'MvStWs': '近3個月',
  'OrZu3X': '公開價',
  'PTKAsz': '開通倉庫權限',
  'Pv8aT1': '出庫及時率',
  'Rh/Y5b': '異常訂單',
  'Sa0aiY': '近一年',
  'SkRR/r': '當前客戶數據',
  'UHii1H': '默認開通部分倉庫，需開通美西或英國倉庫權限，請點擊此處',
  'V8qnx7': '近6個月',
  'W0fifu': '簽訂合同',
  'WWlgnl': '快速創建SKU',
  'Xfbnoa': '近7天',
  'Zh1x4W': '退貨待處理',
  'aedLAU': '寬',
  'baV1Ei': '長',
  'cMSkQ5': '訂單配送時效',
  'hBkLmp': '高',
  'ik+mqU': '近1個月',
  'jSyO7i': '倉配指標',
  'kTgc5v': 'Winit頭程運輸',
  'kteyYj': '下載詳細頭程報價',
  'm/LYrd': '選擇已註冊商品',
  'mvaPZW': '倉租費用',
  'o9u8xE': '尾程費用預估',
  'r8cl4c': '商品待處理',
  'rV6Ikp': '請先簽訂服務合同和協議，我們才能為您提供基礎服務',
  'uWDBT3': '萬邑通數據',
  'v+gjOA': '以下指標數據T+1，非實時數據',
  'vN3oQA': '視頻教程',
  'wpzAgZ': 'winit倉庫指標信息',
  'wwmySt': '一口價',
  'zLIDw1': '履約費用測算',
  'zdb024': '尾程履約費用',
  'uqm47n': '平均耗時',
  'B8/NTe': '我的數據',
  'UdsGuw': '去綁定',
  '4uI559': '即統計周期內，準確無誤出庫的商品占全部商品的比例',
  '5/pZpj': '即物流公司攬收第一次掃描到目的地最後一次掃描的時間點信息',
  '9Fzg5x': '即統計周期內，正常出庫的訂單占全部訂單的比例',
  'Yueu4d': '即商品從到倉到上架至貨架的時間效率',
  'bybWts': '即客戶下單後，物流公司攬收包裹後進入到尾程倉庫的第一次掃描時間點信息',
  'E7VjfS': '倉租費用預估',
  'Ge0lbr': '商品重量',
  'w+DoTf': '商品尺寸',
  'kPcnam': '【{fieldName}】請輸入大於0的數字，最多{digits}位小數',
  'h1qBUu': '測算商品選擇',
  '+c20Bq': '尾程指標',
  '2IVg9s': '退貨指標',
  '42ASVQ': '標準海外倉快遞入庫',
  '6EkZOI': '貨物物流屬性',
  '7PAub+': '到倉上架及時率',
  '9QCBnw': '出庫指標',
  '9p6smW': '貨物從國內哪個港口發出？',
  '9qb80q': '入庫方式',
  'A9Tz/W': '空運',
  'BKXdVC': 'Winit頭程運費',
  'D2G0C4': '統計單元',
  'Epktmm': '直發自驗入庫',
  'Hg/8GB': '海運',
  'ID6XQq': '卸貨上架及時率',
  'MNTXeZ': '月',
  'Np+Iw0': '周',
  'Qpi3DY': '日',
  'R/uhzG': '貨物發往哪個國家履約',
  'SVKHsT': '自定義日期',
  'WZ68qc': '包裹',
  'WbPzFJ': '橫坐標維度',
  'XYdT8p': '運輸方式',
  'ZGJHHK': '到倉卸貨及時率',
  'ZcM+gl': '直發海外驗入庫',
  'aDdguC': '標準海外倉入庫',
  'd5xPIO': '入庫指標',
  'gNbcdl': '快遞',
  'o8kLqD': '頭程運輸方式',
  'DpnauN': '時間',
  'MHQn6p': '用戶選擇周期後轉化為具體日期，周起始{周日開始到周六結束}；每年第一周和最後一周會跨年統計',
  'SGfALI': '指標類型',
  'VLj4TX': '指標值',
  'dRP+2A': '分母',
  'upV5YZ': '數據說明',
  'ySoacE': '分子',
  '+70F5G': '包裹上架及時率(不含異常)',
  '+tjEe2': '異常包裹數',
  '3wNvEr': '正常未上架',
  'JkNfUW': '及時上架包裹數',
  'S1rbJ3': '超時未上架',
  'SeNsek': '超時上架包裹數',
  'SnHWjC': '包裹上架及時率(含異常)',
  'ek1T28': '應上架包裹數',
  'iV9J/A': '指標',
  'qee9ZL': '維度',
  'uqF4+w': '未上架包裹數',
  'VglISO': '季度',
  '04xGKp': '1. 分母：目標統計周期內，實際出庫包裹數{break}分子：分母範圍內，實際產生Dscan時間<=目標產生Dscan時間的包裹數"{break}2. 分母：實際出庫日期範圍內，實際出庫包裹數{break}分子：產生Dscan總耗時"',
  '2Bdgmz': '超時Ascan包裹數',
  '2lkHR6': '未履約訂單數',
  '4D20an': '應履約訂單數',
  '4kz3bn': '標準出庫',
  '70rwvT': '分母：應暫存日期匯總的自提訂單數{break}分子：分母範圍內,在應暫存日期23:59點前暫存到自提貨架區的訂單數',
  '7XH7nH': '包裹卸貨及時率(含異常)',
  '80fD5c': '超時未上架包裹數',
  '8VFtm8': '未出庫訂單數',
  '9AWRj6': '包裹AATscan率',
  'C63z6s': '包裹Dscan及時率',
  'CAyA0a': '正常未暫存訂單數',
  'CCv+GA': '及時卸貨包裹數',
  'CDh1Z0': '包裹Ascan及時率',
  'DKuZRC': 'Ascan平均耗時',
  'DPV9rx': '自提出庫',
  'DSYISn': '及時Ascan包裹數',
  'FPMFhy': '應卸貨包裹數',
  'Fjwf8i': 'Dscan平均耗時',
  'HkwQAL': '超時暫存訂單數',
  'IFg102': '正常出庫訂單數',
  'KCCu84': '超時未出庫履約訂單數',
  'KetzY1': '超時未Dscan包裹數',
  'O3tvz6': '應處理訂單數',
  'OXckHM': '應暫存訂單數',
  'QflAU5': '暫存及時率',
  'QhGzOU': '分母：目標上架日期（包裹到倉時間 + SLA）範圍內，應上架包裹數；{break}分子：分母範圍內，包裹實際上架日期<=目標上架日期的包裹數',
  'R+bb+H': '正常未Ascan包裹數',
  'R05sfI': '超時AATscan率包裹數',
  'T8EZBS': '未Ascan包裹數',
  'UAuAfS': '超時未處理訂單數',
  'Uh+qYa': '銷毀出庫',
  'UqstXw': 'Ascan及時率&平均耗時',
  'Uu9ZOD': '應出庫訂單數',
  'VSe5Uw': '分母：實際出庫日期範圍內，實際出庫包裹數{break}分子：產生ATTscan包裹數"',
  'VVFpWJ': '訂單出庫履約及時率',
  'VsSqY5': '訂單錯發率',
  'WUr4rT': '超時未卸貨包裹數',
  'WxCghz': '分母：目標卸貨日期（包裹到倉時間 + SLA）範圍內，應卸貨掃描包裹數{break}分子：分母範圍內，包裹實際卸貨日期<=目標卸貨日期的包裹數"',
  'XSSKN4': '超時Dscan包裹數',
  'YSXXUs': '訂單',
  'YSfC7P': '正常未處理訂單',
  'Z2dCu9': '分母：目標上架日期（包裹卸貨掃描時間 + SLA）範圍內，應上架包裹數{break}分子：分母範圍內，包裹實際上架日期<=目標上架日期的包裹數',
  'ZkUwmd': '未暫存訂單數',
  'a+G37I': '正常未上架包裹數',
  'b1DsV8': '分母：目標出庫日期範圍內，非草稿 / 客戶作廢 / 萬邑通作廢 / 抓單失敗作廢的應出庫包裹數{break}分子：分母範圍內，實際出庫日期<=目標出庫日期的包裹數"',
  'bReBTV': '正常未Dscan包裹數',
  'c5ZVUt': '超時未Ascan包裹數',
  'cDzsuR': '及時出庫訂單數',
  'cGhzfI': '及時AATscan率包裹數',
  'd9LVhN': 'Dscan及時率&平均耗時',
  'e5FeD4': '超時出庫訂單數',
  'ecuDmM': '訂單出庫錯發率',
  'eelcKV': '轉倉出庫',
  'h5/Zm7': '超時未暫存訂單數',
  'hfS5uu': '包裹卸貨及時率(不含異常)',
  'iNmyS0': '1. 分母：目標統計周期內，實際出庫包裹數{break}分子：分母範圍內，實際產生Ascan時間<=目標產生Ascan時間的包裹數"{break}2. 分母：目標出庫日期範圍內，產生Ascan包裹數{break}分子：產生Ascan總耗時"',
  'inzYEx': '退貨類型',
  'iySA8M': '正常未出庫訂單數',
  'jBvMBS': '超時卸貨包裹數',
  'jQ8TO3': '訂單暫存及時率',
  'jed6Xm': '分母：目標出庫日期範圍內，非草稿 / 客戶作廢 / 萬邑通作廢 / 抓單失敗作廢的應出庫包裹數{break}分子：分母範圍內，實際出庫時間<=目標出庫時間的包裹數',
  'k75tZv': '超時未出庫訂單數',
  'kMNnhp': '應Dscan包裹數',
  'l/MdYt': '及時處理訂單數',
  'n/cvYW': 'AATscan率',
  'nCq48k': '正常未卸貨包裹數',
  'ntw3S3': '應AATscan率包裹數',
  'ofFLk1': '退貨處理及時率',
  'pJfOu6': '訂單出庫及時率',
  'qcRLQI': '出庫履約及時率',
  'rjLU6N': '超時出庫履約訂單數',
  'sN8Get': '及時出庫履約訂單數',
  'tMq0kR': '未卸貨包裹數',
  'ta6pfJ': '及時暫存訂單數',
  'tmRLpn': '超時處理訂單數',
  'tueJPY': '正常未出庫履約訂單數',
  'u/Nmqf': '及時Dscan包裹數',
  'u9OXnl': '未Dscan包裹數',
  'v++ddI': '錯發出庫訂單數',
  'v5BXop': '應Ascan包裹數',
  'w3cM8T': '訂單處理及時率',
  'xvWSVx': '分母：目標出庫日期範圍內，非草稿 / 客戶作廢 / 萬邑通作廢 / 抓單失敗作廢的應出庫訂單數{break}分子：到賬日期範圍內，錯發訂單數（海外倉標準索賠中索賠類型為「錯發貨物」、「漏發貨物」、「多發貨物」的訂單）',
  'yHvp8+': '庫存單元',
  'z1MEnJ': '未處理訂單數',
  '71WlLj': '退貨/退貨處理及時率',
  'BUgJtV': '關註指標',
  'E/j2ry': '入庫/到倉上架及時率',
  'O3Cery': '出庫/出庫履約及時率',
  'gsXmkI': '尾程/Ascan及時率',
  '/HSkL1': '貨物預計在萬邑通倉庫存放多長時間？',
  '4xrCgJ': '長*寬*高',
  '2ABlbj': '僅僅支持Ebay和Tiktok平臺，且費用中包含了入庫和出庫的處理費',
  'Q260fk': '您未開通服務權限，此功能暫不可查看',
  'TSMoUa': '創建1個SKU之後：您已創建了商品，可以創建更多商品進行使用哦',
  'gKKcGV': '去開通權限',
  'G5HeYy': '此商品體積<單品最小存儲體積{m}CBM，則此商品按{m}CBM計算庫存總體積',
  'qR+EsV': '庫存總體積<{n}CBM，按最小倉儲體積{n}CBM計算倉儲費',
  '1/vSZm': '出庫履約率',
  'Ayb5cF': '訂單出庫履約率',
  'BiLWKP': '出庫/出庫履約率',
  'sNnQU4': '透明清晰的報價方案，我們的客戶經理會在12小時與您取得聯系',
  'aerjpH': '資料已審核通過，已為您開通海外倉服務權限，可以查看菜單啦',
  'aHWOLO': '請先提交資料，等待人工審核後即可開通海外倉服務權限',
  'Nc3gof': '您已創建了商品，可以創建更多商品進行使用哦',
  'OmtISj': '請先創建商品，商品完成需要審核，通過後該商品可正式使用',
  '7rA83N': '請先創建入庫單，選擇產品服務和填寫其他信息，才能成功下單哦',
  'KdyIP8': '您已創建了入庫單，可以繼續創建更多入庫單滿足您的需求',
  'hZ7k5Z': '分區價',
  '+1q99V': '復製失敗商品編碼',
  '+3E5ja': '商品編碼/商品條碼',
  '+Kr+Se': '超時未出庫數',
  '+NQng8': '請選擇進口國',
  '+QQt1w': '上傳德語說明書',
  '+QVEe6': '最多支持500個查詢',
  '+WN6K9': '將每個商品的德語說明書規範文件名稱後，壓縮為一個zip格式的文件，方可進行上傳。',
  '+XkXdN': '註冊重量{break}核實重量',
  '+Z+s/M': '註冊中',
  '+lSrdL': '繼續註冊商品',
  '//OPe1': '化工產品',
  '/4CAvs': '僅限草稿、註冊退回、更新退回狀態才能提交',
  '/51T4K': '出口美國的商品受美國各個部門監管，對商品安全，標簽，認證等要求嚴格，為避免商品運到美國後因此類問題導致退運或銷毀，特提醒商家註意以下問題：',
  '/EyqOO': '正常未卸貨數',
  '/SaZle': '當前商品對應類別無有效WEEE信息，請添加提交審核，且審核通過後再進行關聯操作',
  '/jX11C': '是否包材商品',
  '/qfPiv': '商品包裝',
  '/y/o6o': '請選擇修改類型',
  '/yVpDb': '默認',
  '0J/EZT': 'Dscan及時率',
  '0mdRKn': '行號',
  '0oOC0x': '<strong>裸貨</strong>：沒有任何包裝的貨物。{break} winit不支持裸貨出庫，裸貨請維護出庫包裝。{break} <strong>銷售包裝</strong>：商品出廠時帶有的包裝。{break}商品為銷售包裝，且為高貨值，則不支持直接出庫，請維護出庫包裝。{break} <strong>物流包裝</strong>：商品的包裝可支持出庫。{break}商品為物流包裝，則支持直接出庫，可不維護出庫包裝。',
  '0wrGaG': '輸入內容不能小於{min}個字符',
  '15n1gp': '行數',
  '1CVLEB': '模板填寫數據太多？{a}',
  '1EETXi': '包材承重(kg)',
  '1WEaVW': '處理及時率',
  '1eOrvk': '快捷關聯WEEE',
  '1fFSJC': '卸貨及時率(不含異常)',
  '1l12Kb': 'WEEE註冊號',
  '23GoDH': '共 {total} 條數據，失效後如果退貨需要關聯原SKU，則需要重新生效，請確認是否失效該商品',
  '2AAXee': '箱產品詳情',
  '2KeuAm': '創建套裝產品',
  '2LLzO1': '在導出文件中，修改需要更新的商品信息，選擇標準模板導入並重新提交註冊 <a>去提交></a>',
  '2Nufpg': '是否屬於DG危險品',
  '2O5LA4': '批量失效',
  '2PBb7y': '無需原產地',
  '2Rvzhl': '對木製品及木製包裝物熏蒸需提供熏蒸證書，特別是木製品需註意歐盟EUTR法規的盡職信息調查。',
  '2T9AV3': '共享庫存',
  '2TXB25': '以下商品已經含有註冊進口國：',
  '2TqpMq': '及時出庫履約數',
  '2oCbSB': '帶液體',
  '2zRAX7': '商品註冊成功',
  '2zlu4l': '英國政府更新了將產品投放至英國市場的指南文件：{break} 1. 從2023年1月1日後進口到英國的UKCA標誌領域涵蓋的商品必須要有UKCA標，即替代了原有的CE標。{break} 2. 對於已經進口到英國市場的現有庫存產品，不需要進行重新測試或重新做UKCA標識。{break} 3. 2025年12月31日之前，繼續允許企業自主選擇在產品本體的銘牌上或產品隨附的文件上標識UKCA標誌。從2026年1月1日起，只能在產品本體銘牌上進行標識。{break} 4. 對於從EEA之外的地區進口到英國的產品，仍然按照原先的規定，從2023年1月1日起，其進口商信息需要標識在產品本體的標簽上。除非在產品尺寸太小或形狀特殊而不允許的情況下，才可以接受標識在隨附文件上。{break} 相關細節請查看英國官網鏈接：{url}',
  '3+8YgJ': '請輸入預警天數',
  '3CpNmb': '電池防火標',
  '3UDwTJ': '套裝/箱標準件數',
  '3emMvn': '輔助指標',
  '3m2zVX': '請根據所選擇的批次屬性提供示意圖，需要能識別到屬性信息在商品的具體位置，圖片中需如示意圖進行標識說明。後續Winit會根據提供的示意圖查驗商品信息。<red>最多上傳1張圖片，限製為5M以內的jpg,gif,bmp,png格式。</red>',
  '430sH9': 'DG危險品補充信息',
  '4Cyq/R': '預警天數',
  '4Jk7wc': '應履約數',
  '4cdhBz': '重要指標',
  '4mJLTr': '及時上架數',
  '57UMhM': '出口到英國帶插頭的商品必須是英國規格的插頭且不允許配英規轉接頭。比如美規或歐規插頭配英規轉接頭的那種商品，如被質量監管部門查到，只能退運或銷毀。',
  '5BFAgi': '監管條件',
  '5BJFy9': '批量上傳文件',
  '5M7Vly': '上傳結果',
  '5QMQYr': 'WEEE信息需補充或更新？<a>去編輯</a>',
  '5vH5Pk': '超時未暫存數',
  '5yAzV3': '品牌名稱',
  '64kzDB': '商品特性',
  '6DKIQa': '提示：若商品內無紙質說明書，則需要提供德語說明書鏈接，商品出庫時將在面單上打印對應的德語說明書的鏈接，但該功能受限於尾程派送供應商，建議您盡快把德語說明書紙質文件添加到商品裏',
  '6DlkQ0': '未出庫數',
  '6M2O6P': '關聯WEEE',
  '6ON040': '是否退貨商品',
  '6Qu7pB': '維護箱產品',
  '6Y0p2/': '下一步',
  '7/jbov': '更新中',
  '73SuB6': '請在商品列表中篩選需要更新的商品，並選擇按照標準導入模板形式導出或<a>下載導入模板</a>，填寫商品所有信息後導入',
  '7KxUw1': '應卸貨數',
  '7YEo3Z': '應暫存數',
  '7jl7uN': '更新商品批次信息',
  '7oy56p': '超時上架數',
  '7u24R2': '備註信息',
  '88Ahen': '待修改',
  '89eJ3z': '已填寫其他信息，需選擇國家',
  '8DMyyb': '如商品或包裝貼UL, ETL以及EPA等標簽，請提供相關的認證書的復印件，一旦查貨無法提供相應證書，會因侵權而遭到退運或銷毀。',
  '8FC2V+': '箱內標準件數',
  '8K9huq': '打印數量',
  '8KQe8R': '德語說明書類型',
  '8chdAt': '年',
  '90BZso': '更新商品出/入庫包裝信息',
  '9HPrzg': '最多支持500個商品編碼/商品條碼/第三方編碼',
  '9Kfyp/': '失效後如果退貨需要關聯原SKU，則需要重新生效，請確認是否失效該商品',
  '9Rk5ct': '(包括易碎品標、僅限上貨機標、限製出口、僅限陸運、正面朝上標)',
  '9VJr3i': '請輸入大於0的數，最多保留2位小數',
  '9l1yrc': '失敗原因',
  '9q5iFF': '產品分組',
  'A6gWi0': '錯發出庫數',
  'A94SDx': '旺季加收旺季附加費',
  'AIm0ow': '上傳SOP',
  'AM5ZYU': '圖片格式限製為jpg,gif,bmp,png',
  'AOBoNV': '此套裝產品內含x件單一產品',
  'AXD5yi': '待補充',
  'AcRVLv': '若需要采集包裹碼則會在出庫環節進行采集，出庫單信息支持查詢，前提是需要保證實物包裹上存在包裹條碼！',
  'AcfqYm': '電池重量(kg)',
  'Aoiung': '您暫未設置偏好，請在[個人中心-偏好設置-商品偏好]中設置相關信息。設置後，點擊隱藏偏好信息，則已設置偏好的信息將自動隱藏',
  'Aqtj8n': '打印商品條碼',
  'AroxgK': '刪除結果',
  'AsN7cg': '超時Ascan數',
  'B13gcH': '<strong>單品化管理：</strong>一物一碼。售賣的單個商品都只有全局唯一的一個單品條碼。{break}<strong>商品化管理：</strong>一類一碼。同一個SKU所有的單品都是相同的商品條碼。',
  'B7br4z': '禁售天數',
  'B8xiJD': '帶插座',
  'BC74I9': '提示信息',
  'BFz2A6': '當前進口申報價格較高，可以在投保商品管理模塊對該商品進行投保，投保的商品在庫內會提供更精細化管理',
  'BKKHqg': '註冊長*寬*高(cm)',
  'BY90Z8': '保障商品價格的真實性；對於故意誇大或者降低申報價值的，貴方應自行承擔相關商品損失（如海關扣貨等）以及給萬邑通造成的直接和間接損失（包括但不限於銷毀費、運費、律師費、政府罰款）；',
  'BfWmDr': '補充資料',
  'BgiBV1': '需註意事項：{break} 1. 用木製容器裝運的貨品必須附有熏蒸證明書，證明符合檢疫規定；{break} 2. 澳洲訂有規例，禁止生產、進口及銷售含有致癌物質、石棉材質的服裝及消費品。{break} 3. 燃油類的商品（發動機、割草機、鏈鋸等），需要有以下相關認證（EPA、CARB、97/68/EC或澳洲產品豁免號，以上的其中之一），否則有罰款召回風險。',
  'BhoBfm': '超時暫存數',
  'Bkg7uQ': '主指標',
  'Bm5GdP': '中國臺灣',
  'Bue+Ip': '查看並使用《個性模板》',
  'C4HPJc': '上傳成功',
  'C5ShJS': '保存草稿',
  'C5uin2': '更新進口國出口申報價值',
  'C7Cq4t': '美國商品公告',
  'CJA3gl': '請選擇出庫包材類型',
  'CN+A8h': '是否共享庫存',
  'CNKrTB': '請選擇商品負責人/歐代信息',
  'CbJiR0': '箱產品包裝',
  'CcGGyt': '請先選擇國家/地區',
  'CgkufA': '將按照以下商品特性生成個性模板，導入需填寫符合特性的商品，不符合會導致註冊失敗',
  'Ch3B3M': '共 {total} 條記錄，成功啟用 {successCount}',
  'ChzSZX': '修改電池資料',
  'ClROa7': '文件最多上傳{maxCount}個，大小限製50M以內，格式限製為jpg,jpeg,png,pdf',
  'Cwym4h': '批量提交',
  'D5ZkQe': '新增第三方商品條碼',
  'D6Hvvx': '電池能量WH=電池容量AH*電池電壓V',
  'DWpV38': '未處理數',
  'DiLA5q': '當前已選擇 {num} 個商品，請選擇需要新增註冊的國家',
  'E2kRYi': '批量啟用',
  'EFPHaV': '賣家直發',
  'EVTQjd': '上傳實物批次信息示意圖',
  'Ebnrof': '如您選擇添加歐代信息，則標簽將帶有已關聯的歐代信息；如不選擇則不會帶有。',
  'F3ndvv': '刪除失敗',
  'F7X0fu': '導出所有商品信息',
  'FKf3GC': '請輸入原產地',
  'FMPuj8': '商品列表',
  'FRtCeT': '退回',
  'FTG2vb': '商品負責人名稱',
  'FbM2/d': 'Excel批量導入',
  'FetaMe': '澳洲商品公告',
  'G22f+9': '《德國生產者責任延伸包裝法》已於2022年7月1日實行。法規要求將包裝好的商品銷往德國的賣家需通過德國中央管理機構"Zentrale Stelle Verpackungsregister" "進行註冊獲得LUCID號碼，申報對應商品包裝的體積和類型等信息並繳納相應的費用，同時法規也明確履約服務提供商以及電商平臺不得為沒有按法規要求註冊的賣家提供服務。',
  'GDFkBa': '英國進出口和稅收屬同一個部門監管（HMRC），以及實行的英國盡職調查法規和平臺代扣代繳，為商家長遠發展考慮，建議用自己的公司名稱和英國的增值稅號(VAT)和進口備案號（EORI）作進口。',
  'GTt01+': '商品鏈接',
  'GdNyZk': '出口申報價值(USD)',
  'H/vKxr': '確認重量(kg)',
  'H7BeZD': '出口國家/地區',
  'HIRKi3': '維護套裝產品',
  'HMxZwz': '資料類型',
  'HWUi9z': '出庫包裝信息',
  'HnsXky': '無限製',
  'HxgJs9': '根據《市場監管法規（EU）2019/1020》的要求，自2021年7月16日起，帶有 CE 標誌並且是在歐盟境外製造的商品，需確保此類商品含有真實有效的歐盟責任人信息以及對應國家語言說明書。在法規生效後，在歐盟銷售帶有 CE 標誌的商品但沒有歐盟負責人屬於違法行為。',
  'I0f7tt': '確認刪除嗎？',
  'I4GWHd': '及時Dscan數',
  'I7cmTD': '商品屬性',
  'INWrne': '商品攜帶標簽',
  'IzXisV': '套裝產品包裝材質',
  'JGDWfH': 'Ascan及時率',
  'JILwsB': '操作日誌',
  'JO4DwF': '對於物品的描述，不能是gifts這樣的模糊字眼，可能會導致清關障礙。為了確保順利清關，需提供具體詳細的沒有歧義的商品說明。',
  'Jalqk9': '若發現申報信息與實際信息不符的商品，萬邑通保留不予提供服務的權利。',
  'Jddr2L': '英國海關禁止進入的商品: 所有仿牌假牌物品、認證或標識不齊全的商品，英國海關可能追究法律責任。',
  'JvOkw0': '商品包裹類型',
  'KIwL6G': '及時出庫數',
  'KLNwDD': '文件格式限製為jpg,jpeg,png,pdf',
  'KRVF+S': '請輸入打印數量',
  'KVd/IG': '確認長*寬*高(cm)',
  'KYjz/l': '請輸入大於0且最多保留兩位小數的數值',
  'Keyqza': '請選擇原產地',
  'KrHmK0': '請選擇商品負責人/歐代信息：',
  'Ksh8H4': '正常未上架數',
  'LRuQNL': 'WEEE類別',
  'LWSLHa': '溫馨提示',
  'LxCyKX': '請上傳',
  'LzaEIM': '去查看',
  'M+7kjk': '去設置偏好',
  'M0LDIV': '批次屬性',
  'M1h6SK': '入庫商品包裝信息',
  'MJZFFa': '商品管理方式',
  'MPh7VW': '{num} 個草稿商品，已錄入完整信息待提交審核',
  'MTpHsb': '維護包材信息',
  'MUuzgH': '進口後海關會有3年追訴期，為避免海關後期發現低報而產生的補稅和罰金，建議進口申報價值如實申報。',
  'Mke7E0': '為商家長遠發展考慮，鼓勵賣家用自己的公司名稱的增值稅號(VAT)和進口備案號（EORI）進口。',
  'MllGRu': '頭程類型',
  'MmmpSu': '去查看>',
  'MqnPY2': '標準箱寬(cm)',
  'MrgM6t': '導出商品全部信息',
  'Mwk+U+': '出庫錯發率',
  'MxBCpe': '下載錯誤數據',
  'MxxEYf': '收起',
  'MzuCgp': '進口申報價',
  'N6tEuo': '選擇註冊進口國',
  'NGs9sO': '返回',
  'NIfhB7': '未選擇商品，請到商品列表重新選擇',
  'NMg99l': '是否啟用條碼值庫存',
  'NOtdIq': '上傳說明書',
  'NUN0tG': '新增成功',
  'NXKJ/G': '包材尺寸(cm)',
  'Ndc8Tz': '{successCount} 個商品已成功刪除',
  'NnaTvD': '綁定負責人',
  'NoURe9': '資料狀態',
  'Nw3DyH': '請確保商品不出現任何侵犯知識產權的圖案或說明，包括版權、外觀專利、知名商標。',
  'O1baSg': '註冊重量(kg)',
  'O5zQhu': '是否啟用批次',
  'OA/GYS': '是否采集包裹碼',
  'OnimtZ': '註冊長*寬*高{break}核實長*寬*高',
  'OoH4Vn': '已完善',
  'OzxoGd': '出庫包裝修改',
  'P3OlMG': '請先選擇進口國家/地區',
  'PAR7vC': '進口關稅和GST計算：進口關稅按貨品在裝運港的船上交貨價征收，商品服務稅（GST） 按CIF價征收，進口申報價格必須按公平交易價格申報，如申報價值過低引起澳洲海關查驗，以及引起的補繳關稅，相應的罰金以及其他損失，我司有權進行追索。',
  'PKJshZ': '請輸入大於0的數，最多保留4位小數',
  'PMnXeY': '待提交',
  'PUESE0': '{successCount} 個商品已成功刪除，失敗 {failCount} 個，失敗原因：',
  'PjkNQN': '英國商品公告',
  'Q37+lZ': '請輸入保質期',
  'Q7MQdK': '原產地',
  'QCshfb': '為避免商品運到英國口岸後因各種問題導致退運或銷毀，特提醒商家註意以下問題：',
  'QUFY6d': '進口後HMRC會有3年追訴期，為避免HMRC後期發現低報而產生的補稅和罰金，建議進口申報價值如實申報。',
  'QdYQx3': '為避免商品運到德國口岸後因各種問題導致退運或銷毀，特提醒商家註意以下問題：',
  'QpxSsT': '及時ATTscan百分比',
  'QuQaaA': 'UN編碼',
  'QxhxD9': '周一~周五{break} 00:00-12:00提交，當天18:00前審核完畢{break} 12:01-24:00提交，次日(自然日)11:00前審核完畢{break} 周六~周日{break} 周六00:00-12:00提交，當天16:00前審核完畢{break} 周六12:01-周日24:00提交，周一11:00前審核完畢{break} 法定節假日{break} 次日(自然日)24:00前審核完畢{break}',
  'QxzrbX': '商品保存草稿成功',
  'RFLMGm': '標準箱重量(kg)',
  'RSl8E8': '指定包材SKU',
  'RrD1hw': '中文名稱/英文名稱',
  'RtFK89': '目前一口價僅支持美國，平臺為Ebay和Tiktok，敬請期待其他國家（開通一口價權限請聯系客戶經理）',
  'S25bPA': '正常未出庫數',
  'S2Dp+M': '此告示上未窮盡所有可能引起海關退運或銷毀的情況，僅就經常出現的問題進行陳述，如因以上及未提及的事件且非我司的原因引起的損失，我司將有權進行追索。',
  'SBagFp': '快捷打印條碼',
  'SCsxgT': '請輸入禁售天數',
  'SFGJw1': '當前商品提交的修改信息正在審核中，請在更新中查看待審核的商品信息{a}',
  'SGXH2R': '進口國家/地區',
  'SX//Dm': '批次管理類型',
  'Seke8U': '正常未處理',
  'StEQQQ': '應Ascan數',
  'T6gsxx': '您選擇的國家目前暫不支持尾程渠道發貨，請下載具體系統報價確認支持的國家',
  'TPXs+A': '及時Ascan數',
  'TedMK6': '此SKU必須保證隨貨攜帶紙質德語說明書',
  'TroLmA': '德國海關禁止進入的商品: 所有仿牌假牌物品、認證或標識不齊全的商品，德國海關及當地執法部門嚴查該類商品，除面臨商品召回外，還可能追究法律責任。',
  'TsDnUk': '隱藏偏好設置',
  'U9ILfl': '上架及時率(不含異常)',
  'UH3LUp': '責任人公司名稱',
  'UKk9aQ': '請輸入大於0的正整數',
  'UOhShp': '電池包裝',
  'UQkIe2': '生成個性模板',
  'UaXAnK': '商品出庫/入庫受限，請及時處理',
  'Uf/d6B': '正常未Ascan數',
  'Ura5sN': '僅支持維護已發布商品',
  'VHPbrK': '核實長*寬*高{unit}',
  'VJMEti': '文件數據校驗完畢',
  'VKV22J': '啟用結果',
  'VbRKGW': '批量新增進口國',
  'VppX7w': '正常未出庫履約數',
  'W+R6B3': '補充/確認進口國信息',
  'W01wC8': '商品長(cm)x寬(cm)x高(cm)',
  'WAfyY4': '進口申報價值(USD)',
  'WGAE7N': '應處理數',
  'WQyw5k': '立體內徑尺寸(cm)',
  'WaaLFK': '德國相關網站供參考{break}德國反傾銷反補貼的查詢網址：{url1}{break}{url2}{break}德國生產者責任延伸包裝法：{url3}{break}市場監管法規（EU）2019/1020：{url4}',
  'WdQS7N': '此告示未能窮盡所有可能引起查驗、退運或銷毀以及在澳洲海關可能出現的情況，只就常見問題進行陳述，如因以上及未提及的事件且非我司的原因引起的損失，我司將有權進行追索。',
  'Wdmil2': '展開',
  'X1F+7G': '提交失敗，請修改後重新提交',
  'X5Wxae': '展示偏好設置',
  'XFd0Fa': '箱產品包裝材質',
  'XGMo7a': '超時未出庫履約數',
  'XJFtiF': '帶三合板或高密度板',
  'XnL5tl': '二手商品',
  'Xp/Q3h': '請選擇商品管理方式',
  'XqPll/': '德語說明書要求',
  'XuoVmX': '套裝產品信息',
  'XxHAs0': '商品數量',
  'Y/0R7Y': '套內標準件數',
  'YKwdXz': '退回原因',
  'ZFM0cj': '鏈接審核狀態',
  'ZVh7Di': '模板填寫數據太多？推薦使用個性模板',
  'Zfm4bD': '選擇批次屬性後，則下入庫單需要提供對應的批次信息，驗貨將會按此屬性核驗商品批次信息［入庫批次管理除外］，後續倉庫則按照批次屬性進行庫內操作及存儲。',
  'ZgRLsG': '進口申報價必填',
  'ZmT1uG': '高貨值(收費有差異)',
  'ZqCedb': '已上傳',
  'ZvZ3JO': '電子電器類商品要符合WEEE(EAR)的規定, WEEE所涵蓋的商品列表見以下網址，確認自己的商品是否需要註冊WEEE(EAR)，如不按要求註冊最高罰款20萬歐元。{url}',
  'aDf3/y': '是否有過敏原',
  'aJTjri': 'Winit頭程產品：{productName}',
  'aMjKQb': '單個新增',
  'aO1LOt': '第一步',
  'aXTw6o': '未知，請檢查模版或導入數據是否正確',
  'acIqwr': '型號',
  'afAy25': '出庫包裝類別為「Winit標準包裝」時，如果「出庫包材類型」不指定，Winit將按快遞袋-氣泡袋-紙箱優先順序自動匹配合適的包材',
  'ahaefV': '中國',
  'ahiPbf': 'SKU編碼',
  'aveTGO': '錯誤提示',
  'ax2mk0': '{text}',
  'b7E1fz': '請選擇你需要導出的商品',
  'bW7xAs': '是否入庫',
  'bi+JOO': '距離失效日期還有【x】天時禁止提交標準出庫單，避免買家收到商品時已過期。',
  'c2fUse': '修改類型',
  'cGY0iX': '請輸入註冊重量',
  'cJNSDx': '查看分區價',
  'cNVhxt': '批量更新高貨值',
  'cQYNoa': '第三方商品條碼',
  'cSHhM6': 'UN標簽-電話號碼',
  'cTA59M': '超時未卸貨數',
  'cYYpNG': '電池種類',
  'cfjOFN': '出入庫包裝信息',
  'cqZp4l': '超時未Dscan數',
  'cuPSNv': '箱產品信息',
  'cul60h': '核實長*寬*高(cm)',
  'd3ABzd': '應ATTscan百分比',
  'dOQj0E': '商品重量(kg)',
  'dadBln': '超時出庫履約數',
  'dqi2SA': '{successCount}個商品已成功提交，失敗 {failCount} 請先完善商品信息再提交審核',
  'dsW/zv': '正常未Dscan數',
  'e4q896': '批量綁定負責人',
  'eCjyf7': '正常出庫數',
  'eDxwA7': '批量更新商品鏈接',
  'eNioNS': '授權成功',
  'eRBGSf': '暫無數據，點擊下方新增',
  'eUSpdN': '查看更多',
  'eef6wN': '註冊重量{unit}',
  'f3GjX/': '請輸入2~999的正整數',
  'f9f9Kr': '尺寸重量信息',
  'fKfc8J': '待辦提醒',
  'fmBsCH': '操作內容',
  'foXtVC': '商品狀態',
  'fr8qvK': '文件上傳成功，請等待數據校驗結果',
  'fwQPTM': '失效結果',
  'g+vrQp': '入庫包裝全部無以下標簽',
  'g+xiOs': '對木製品及木製包裝物熏蒸需提供熏蒸證書。',
  'g/fKXQ': '萬邑通{break}2022年8月',
  'g8RPWw': '當前商品提交的修改信息已被退回，請及時處理{a}',
  'gGMGjZ': '註冊長*寬*高{unit}',
  'gLHALd': '食品',
  'ggvI6Z': '全選',
  'glaaIG': '錯誤原因',
  'gyQd//': '超時未上架數',
  'gzYOOP': '{icon}您註冊的商品會在{time}內盡快維護完畢，請耐心等待～',
  'h53sPj': '超時未處理數',
  'h6p1Q+': '開始日期',
  'h7w4pz': '暫無數據',
  'h8bTqV': '未上傳',
  'hElHo2': '打印歐代信息',
  'hShFQM': '批量修改',
  'hYEDUA': '商品鏈接或圖片需與實物完全一致，且該信息能展示出該商品的商標、材質、功能等信息，以便萬邑通對該商品進行歸類審價；',
  'heSp6Q': '綁定商品負責人',
  'hk5FKM': '包材商品',
  'i4tQ/S': '輸入內容不能大於{max}個字符',
  'i5Q88U': '退貨商品',
  'i5rp4m': '全部不帶電',
  'iC7OaE': '創建箱產品',
  'iCg2nh': '為了提高註冊效率，請您先在[個人中心-偏好設置-商品偏好]中配置商品偏好',
  'iUcoKw': '全部無品牌',
  'ixHwoW': '更新商品信息（通用）',
  'iyu8lU': '關聯WEEE信息',
  'j2i5Dm': '此告示書上未窮盡所有可能引起海關退運或銷毀的情況，僅就經常出現的問題進行陳述，因以上未提及的情況且非我司原因引起的退運和銷毀事件導致的損失，我司將有權進行追索。',
  'j3YsUm': '如您電商清關，請確保您提供的售賣鏈接有效期保持最少2個月以上，如因售賣鏈接失效導致的清關失敗，會影響您的清關時效。',
  'j94Rtp': '請輸入數字、+、-，不允許有字母，支持24位',
  'jCHgBE': '未暫存數',
  'jCOU5w': '進口申報信息',
  'jPqtQS': '帶電池',
  'jb+IKU': '僅支持標簽紙打印，單次打印不得超過5000個。',
  'jd+iFu': '海關建議申報價值(USD)',
  'jl8oxj': '貨型',
  'k84DAN': '僅限草稿、註冊退回、更新退回狀態才能刪除',
  'kCh5Jz': '提示',
  'kS4Jbz': 'ATTscan率',
  'kX1Ecr': '證書',
  'l5jvRO': '入庫包裝信息',
  'l6bu0+': '保質期',
  'lCxJRw': '及時處理數',
  'lHoE+P': '批量添加第三方商品條碼',
  'lIIML6': '<strong>保質期管理：</strong>按商品批次的失效時間，先失效的先出庫，支持近有效期的批次進行預警和禁售。商品有保質期。{break} <strong>生產批次管理：</strong>按商品批次的生產時間，先生產的先出庫。商品無保質期。{break} <strong>入庫批次管理：</strong>按商品批次在海外倉的入庫時間，先入庫的先出庫。商品無保質期。',
  'lSx3mU': '帶磁性',
  'laZwLw': '此箱產品內含x件單一產品',
  'loyE8B': '超時ATTscan百分比',
  'lqnHUQ': '失敗 {failCount}，失敗原因：{reason}',
  'lrwsA+': '沒有選擇要打印的條碼',
  'lzaCiy': '未上架數',
  'm8y8Ah': '資料證書',
  'mM9rak': '未卸貨數',
  'mMJovn': '新增證書',
  'mMoNpI': '核實重量(kg)',
  'mN/UxY': '<strong>電池芯：</strong>電池只有一個電池芯，或者多個電池芯但沒經過串聯或並聯封裝{break} <strong>電池組：</strong>由兩個及以上的電池芯串聯或並聯封裝組合{break} <strong>例如：</strong>多個18650電池組合的移動電源，選電池組；多個18650電池但沒有串聯/並聯，僅多塊包裝銷售，選電池芯',
  'mNrNBK': '應出庫數',
  'mRshYx': '僅支持zip格式的壓縮包',
  'mU2j8v': '批量上傳德語說明書',
  'mgCZHX': '未Ascan數',
  'mkAC6d': '超時未Ascan數',
  'mnE1nk': '距離失效日期還有【x】天時進行郵件提示，便於及時調整該SKU該批次的銷售策略。',
  'nDwIwd': '已發布',
  'nHRaHR': '打印單品條碼',
  'nIRket': '請拖拽或點擊上傳文件',
  'nJIJx6': '查不到該商品數據，請確認該商品是否存在！',
  'nL/cut': '新增進口國',
  'nUqM8t': '去提交',
  'nVqR0D': '德國商品公告',
  'naZmU6': '帶原木',
  'nn8pTx': '提交成功，請等待工作人員審核',
  'nr36zQ': '免倉租',
  'oHUyJP': '更新商品包裹類型',
  'oIsUki': '支持doc格式或者pdf格式，限製10M以下',
  'oRsWj6': '規定時間',
  'od3FGh': '涉及到CPSC（消費品安全協會）的商品，如玩具等商品，需有CPSC指定檢測機構出具的測試報告，商品還需按要要求貼有對應的標識，詳情請查看以下鏈接：{url}',
  'ohFmwm': '超時處理數',
  'oiMpRX': '依據當地服務規定，UN標簽需提供相應的聯系電話。{break}示例：+86-12311112222；',
  'ozUGJe': '套裝產品形狀',
  'p56EUO': '更新商品攜帶標簽信息',
  'p7fE35': '電池能量(WH)',
  'pIQ+WJ': '超時Dscan數',
  'pYzaIX': '禁止入庫',
  'peveA/': '下載個性模板',
  'pkIYyv': '標準箱高(cm)',
  'pzGkXS': '數據已刪除，可能會導致未完成的國際送倉單（不含全球送整櫃）無法操作，請知悉',
  'pzwZ9y': '電池芯/電池組',
  'q0mwSH': '示例圖',
  'qAVsY3': '支持針對勾選的商品批量更新商品信息',
  'qF98LW': '單次最多可導入500條數據',
  'qUKj7E': '復製',
  'qb91VW': '應Dscan數',
  'r1Qtd7': '全部不加包裝',
  'r2gvAb': '導入結果',
  'r2imrW': '海關會與質量監管部門一起查驗商品質量是否符合相關標準，請確保所有去德國海外倉的商品都必須符合德國政府部門的規定，一旦海關或當地質量監管部門查驗，必須能夠立即提供與商品一致的，真實有效的CE證書或其他政府部門要求的相關證書，否則由此導致的扣貨、罰款等責任，由客戶承擔。',
  'r3V/O0': '金融商品',
  'r6h3uT': '操作失敗',
  'rFlDQ6': '未Dscan數',
  'rG82gu': '出口申報信息',
  'rLn5dB': '查看明細',
  'rMMK/m': '導出當前商品列表信息',
  'rOhC+k': '根據澳洲政府公布的進口要求，澳洲進口的商品必須貼有對應的英文商品標簽（品名、品牌、型號、廠家信息、成分、商品描述、原產地等），如海關查驗發現商品缺少英文商品標簽，可能面臨沒收商品以及罰款。詳細通知請參考官方鏈接：{url}',
  'rXzI0V': '請選擇包裝類型',
  'rd4gqB': '第二步',
  'ri851W': '不再提醒',
  'rkOwDC': '{successCount}個商品已成功提交',
  'rnq3gI': '去授權',
  's+FI1a': '請選擇包材類型',
  's3uVOZ': '壓縮包內文件名規範：商品編碼&&&規格',
  's8V1Ln': '帶粉末',
  's9IA1X': '上架及時率(含異常)',
  'sHviTp': '上一步',
  'sNTEDM': '模板數據共 {totalCount} 條，導入成功 {successCount} 條，失敗 {errorCount} 條',
  'saZBsM': '涉及醫療器械的商品，美國強製需要FDA註冊證書。',
  'saeFbf': '文件',
  'sgy8n9': '未履約數',
  'snEEkg': '單次最多可導入500條數據。{a}',
  'sy8edt': 'Excel批量修改',
  't8Teof': '已勾選 {num} 個條碼，單次打印總條碼數不得超過5000個',
  'tJx4Tw': '標簽尺寸',
  'tgduNy': '重復選擇證書',
  'tgzh55': '全部非食品',
  'th2jmN': '批量打印條碼',
  'twj8Sm': '過敏原',
  'u1qllb': '圖片大小限製5M以內',
  'u98d/e': '按導入標準模板中所需的信息導出',
  'uDKUFd': '已發布的商品若修改需要審核信息，則需等審核通過後才會更新商品信息',
  'uFoVy0': '已失效',
  'uKB+1J': '應上架數',
  'uNCf4c': '卸貨及時率(含異常)',
  'uNolam': '進口地',
  'uabkfT': '共 {total} 條數據，成功失效 {successCount}',
  'uiTJW+': '超時卸貨數',
  'undBgZ': '英文名稱',
  'uqDSio': '各國公告',
  'uqU3/A': '套裝產品包裝',
  'v+rZz+': '請選擇說明書類型',
  'vG+1rL': '文件大小請勿超過50M，請壓縮後上傳',
  'vHFAJd': '商品形狀',
  'vOYTyV': '異常數',
  'vP5CrI': '根據當前商品列表展示信息導出',
  'vSerbC': '進出口申報信息',
  'vbDYzP': 'WEEE類型',
  'vg5G1j': '標準箱長(cm)',
  'w/VsZL': '統計單位',
  'w1cMGO': '結束日期',
  'w9U47g': '編輯套裝產品',
  'wIiCxn': '確認重新啟用該商品嗎？',
  'wJ4QYJ': '請輸入包材承重',
  'wRcMxY': '商品負責人/歐代信息需補充或更新？<a>去編輯</a>',
  'wY0zTb': '編輯箱產品',
  'wcogSJ': '點擊下載《標準模板》',
  'wd6jjx': '正常未暫存數',
  'wp3dhe': '確認重新啟用這些商品嗎？',
  'wz0mVq': '沒有錯誤數據',
  'xADAFC': '及時卸貨數',
  'xB2mDj': '所有外包裝上一定要有產地標誌，如確認是中國製造，一定要有「Made in China」標誌。',
  'xGotZu': '該鏈接審核狀態僅適用於一WINIT承運-德國&英國遞延和電商清關,其他產品不受影響。',
  'xLTrlY': '商品註冊審核結果不代表商品在通關、運輸和倉儲中無風險！{break}因商品自身或信息有誤引起的包括但不限於商品通關、貿易、侵權和質量等責任和糾紛, 需由客戶自行承擔，感謝您的理解和配合~',
  'xQYCD1': '若開啟共享庫存，出庫時無需指定SKU類型及標準庫存SI件數，Winit系統將按出庫單中單一產品需出庫總數自動分配',
  'xeApVG': '待提交商品',
  'xjFUOB': '註冊進口國',
  'y1/0I4': '18+',
  'yG4nnB': '導出失敗商品條碼',
  'yMlPtn': '套裝產品詳情',
  'ybIMxw': '商品提交成功',
  'yz3gHz': '商品保存成功',
  'z+8yDs': '及時暫存數',
  'zCjZBU': '立體外徑尺寸(cm)',
  'zFDcg6': '導出列表同標準模板，支持修改後通過excel導入更新',
  'zG8yxE': ', 失敗 {failCount}，失敗原因：',
  'zI1Wyd': '出庫加包裝信息',
  'zf0KBc': '修改完成',
  'zubwCo': '超時出庫數',
  '0bGJDI': '帶電',
  'NoTiXs': '非食品',
  'PmAk6c': '倉儲總體積=單個商品體積（單個商品體積＜ {n}m ³， 則按 {n}m ³）*  庫存數量',
  'YVWUH+': '商品個性範本',
  'cLPzLe': '有標籤',
  'ceUK9M': '無標籤',
  'ipVi6y': '加包裝',
  'mdJrUd': '倉儲總體積＜最小倉儲體積 {m}m ³， 則按 {m}m ³ 計算倉租費',
  'rghOE1': '不帶電',
  '4jxBkZ': '超時ATTscan數',
  'fVUxJR': '應ATTscan數',
  'hWDK0B': '及時ATTscan數',
  '3MEyqn': '貨物從國內哪個城市發出？',
  'E2NwYO': 'Dscan平均耗時(工作日天數)',
  'EHTOHW': 'Ascan平均耗時(工作日小時)',
  'FTAz9m': '核實重量{unit}',
  'rl4uyx': '請先創建商品，商品審核通過後才能創建入庫單',
  '0GibQM': '增加頭程運輸費用',
  '10k6dI': '配送訂單的商品數量',
  '5BwsBi': '國內倉發貨至海外倉',
  '9kZAq1': '預估',
  'EPXw7D': '特貨',
  'Krteov': '倉儲費用',
  'RisHP+': '旺季會增加旺季倉儲附加費',
  'TZpo1e': '履約費用總覽',
  'ZA2DsJ': '頭程運輸費用',
  'aFUwPf': '指定服務價格查詢',
  'h20CZ1': '一口價預估',
  'mYmfrE': '預計海外倉存放時間',
  'ng05bx': '一個買家訂單內購買的商品件數',
  'r+WXwG': '國內發貨城市',
  'xWwXLV': '普貨',
  'Dq/R41': '若單件商品體積<{m}CBM，則按{m}CBM計費',
  'BR35ri': '出庫類型',
  'Mk43Ju': '此結果是根據輸入參數測算的海運-運輸費/空運-運輸費，實際以下單為準!',
  'OWX7o9': '商品在哪個國家履約？',
  'VYvc1A': '一個買家訂單端到端的履約預估成本',
  'iDWfFc': '訂單派送時效',
  'mR4Z9G': '履約費用試算',
  'nw+1Hz': '尾程派送訂單的商品數量',
  'vGNlLD': '已授權，請在平臺查看信息',
  '1RASRC': '您輸入的尺寸信息暫未匹配到頭程產品，請您下載報價查看或聯系客戶經理解答',
  '2UAyc8': '履約時效: {start}-{end}工作日',
  'A+bKfm': '厘米/公斤',
  'C0sWNj': '是否變更成「{sizeType}」測算？',
  'PpG3NC': 'Winit頭程運輸費用',
  'U50aCL': '快速創建入庫單',
  'WpcAaR': '您輸入的尺寸信息暫未匹配到尾程產品，請您下載報價查看或聯系客戶經理解答',
  'kLR3/1': '此費用僅為試算費用，具體消費情況以實際發貨為準',
  'noAe6D': '預計海外倉存放時長',
  'rD/rqe': '費用合計',
  'sYWXZa': '如果您需要根據確定的地址計算尾程費用，請點擊「指定服務價格查詢」填寫具體地址進行計算',
  't3l5ML': '英寸/磅',
  'xpf5RE': '您輸入的尺寸信息暫未匹配到倉儲費用，請您下載報價查看或聯系客戶經理解答',
  'g8S3b2': '以上費用未包括出入庫處理費',
  'wbTQL5': '單個訂單支持最大配送商品數量在10個以內，請您輸入正確的數量',
  'aUe2XA': '高級設定',
  'bQuDUJ': '僅限草稿、注册退回狀態才能删除',
  '29YcX4': '指國內至海外倉的運輸費用，如使用Winit承運的頭程服務請勾選此項',
  '9UxuCd': '測算倉庫',
  'C9yrox': '履約國家',
  'F3YP+/': '請註意：旺季會額外產生旺季附加費。',
  'bkBXOL': '我要精確計算費用',
  'iBahRB': '以上試算費用僅供參考，實際費用以系統扣費為準。',
  'yo4o7l': '如需指定產品或收件地址計算履約費用，可點擊此鏈接跳轉查詢。',
  '0WBg0k': '入庫處理費',
  'VTxBYV': '商品超出尺寸/重量限製，請重新填寫。{lengthMin}{sizeUnit}≤長≤{lengthMax}{sizeUnit}，{widthMin}{sizeUnit}≤寬≤{widthMax}{sizeUnit}，{heightMin}{sizeUnit}≤高≤{heightMax}{sizeUnit}，{weightMin}{weightUnit}≤重量≤{weightMax}{weightUnit}，{densityMin}kg/m3≤密度≤{densityMax}kg/m3',
  'G80Yfa': '已包含出庫處理費',
  'hrDPjg': '已包含出入庫處理費',
  '/mrUV7': '自定義',
  '0CBIls': '自定義倉組名稱',
  '2kWiny': '自定義倉組編碼',
  '6CwNwM': '上傳至草稿',
  '8g7PU8': '新增產品組',
  '9pc1MK': '發貨優先級',
  'Bl3B+J': '產品優先級',
  'D/Yid+': '是否啟用',
  'HUgTwr': '必須選擇其中一項',
  'Izo8nC': '買家分區',
  'KhGQV1': '單倉發貨策略',
  'LTEd2f': '入庫',
  'N33pTc': '新增倉組',
  'Ob9vJt': '產品組列表',
  'P0bLNx': '訂單批量上傳設置',
  'PtFTAG': '允許多倉發貨',
  'QCXk/g': '是否啟動',
  'U5iN47': '發貨策略',
  'VaPlbo': '產品組名稱',
  'Vo+Xz7': '產品組編碼',
  'WcSEBf': '禁止同一個SKU拆多倉',
  'a7KRmz': '上傳至已提交',
  'g912oq': '進出口商配置',
  'hT7MT5': '多倉發貨策略',
  'izS7og': '標準',
  'jw88JB': '新增產品',
  'n0YiRc': '倉組信息',
  'ncq348': '優先級',
  'pQfHnF': '智能推薦配置',
  'xKEYMt': '編輯產品組',
  'ywJMgk': '類別',
  'zthu91': '產品',
  '/dtKXK': '輸入內容不能超過128個字符！',
  'A+/0HA': '選擇的產品存在重復',
  'EzNenN': '取消啟用此倉庫，您已選擇的產品組[產品組名稱]下產品[產品名稱]將不支持推薦，系統將自動刪除此產品，請確認是否停用？',
  'P6bkBi': '取消啟用此倉庫？',
  'QLbJkZ': '倉組編碼',
  'XuDX2o': '暫無數據,請',
  'myrfJ/': '切換到其他國家，需要重新選擇產品分組，系統將清空已選擇的產品分組，請確認是否切換？',
  'pDx3hV': '請選擇產品',
  'qZrzit': '未添加產品',
  'rn5AwM': '請先啟用倉庫',
  'w3pzFa': '此產品編碼已經被使用',
  'EMppKo': '產品組[{productGroupName}]下產品[{productNames}]',
  'LtGXYt': '您選擇的產品{productName}在產品組{productGroupName}裏面已存在，請修改後再保存{brack}',
  'o+GSTm': '您輸入的產品組編碼已存在',
  'oCeXGU': '取消啟用此倉庫，您已選擇的{content}將不支持推薦，系統將自動刪除此產品，請確認是否停用？',
  'rtNipg': '取消啟用此倉庫，您已選擇的產品組下產品將不支持推薦，系統將自動刪除此產品，請確認是否停用？',
  'XzxeM5': '搜索產品',
  'wI4k/a': '倉組列表',
  'VJr0ui': '計費重(KG/CBM)',
  'B1xc4D': '賬戶名稱',
  'HoBJEe': '賬戶ID',
  'ZQATNs': '單據類型',
  'hzo2kV': '業務單號',
  'dsROvR': '交易日期',
  'vYbdwI': '交易類型',
  'er7lkB': '金額',
  'IAXzUL': '下單/倉租日期',
  'ZmP5ua': '主單號',
  '9yrgtf': '賣家訂單號',
  '7hnqmZ': '包裹號',
  'I0+bNm': '目的倉',
  'zKjr6y': '產品名稱',
  'qJKFfY': '目的國',
  'P/iomR': '物流分區',
  'e53tsC': 'SKU及數量',
  'MwjxBM': '重量(KG)',
  'nmj+AS': '計費方式',
  // '8ScwNO': '如需查詢和導出12個月以前的歷史數據，請聯系在線客服。',
  'IqkgWZ': '關鍵字',

  'I7bO+W': '可用余額合計(USD)',
  'qGJjK8': '已擔保還款金額(USD)',
  'ac+1ZB': '可用余額(USD)',
  'WPtJUd': '匯率(轉USD)',
  'jWa321': '可用余額',
  'Gs6y7L': '凍結金額',
  'AkjhOp': '賬戶余額',
  'D/ycuA': '付款',
  '6XUyoX': '凍結明細',
  'KZsciT': '購匯/轉入',
  'VJ35lD': '最後還款日',
  'r+gAzL': '已出賬單的未還清金額按每天浮動匯率統一轉美元展示，由於每天匯率變動及還款方向所用匯率不同，此金額僅供參考。實際還款請參照還款預估的待還金額。逾期',
  '7RhTil': '賬單預估待還金額(USD)',
  'j41fsS': '去還款',
  '+CjwvP': '還款評估',
  'lR08XW': '可下單金額',
  'BV7zhA': '點擊查看',
  'ehedRS': '個賬單待還，請在最後還款日前及時還款，若未及時還款，按逾期日利率',

  'oi8wFv': '可下單金額USD',
  'rtyTG2': '賬戶內可用於下單的金額（按每日浮動匯率統一轉USD展示）',
  'oNrwxy': '可用余額USD',
  'KJ8nVz': '可用待入賬USD',
  'Ro2q9R': '所有幣種的可用待入賬合計（按每日浮動匯率統一轉USD展示）',
  'Yy819n': '授信額度（USD）',
  'jK4Nnf': '頭程臨時額度（USD））',
  'qtAVwx': '出庫單編號',
  'ENWxyt': '消費',
  '5ISj3t': 'Winit返利',
  'zpU3Yb': '禮品卡抵扣',
  '9moHyC': '優惠券抵扣',
  'HkZt6P': '出庫單',
  'Aj4jXY': '入庫單',
  'AJzkTP': '倉儲單',
  'SDT4n4': '退貨單',
  'hkowEP': '標準索賠單',
  'ZeCQE2': '海外倉賬戶',
  'YmfoQv': '收取逾期費用。',
  'IW8HMr': '已逾期',
  'ItEF5s': '商務折扣',
  '3FoZNl': '軌跡查詢',
  'CCs6QA': '目的港',
  'CwBUk9': '截止下單',
  'G47GIt': '航班航次',
  'NVsDWV': '預計發貨',
  'RstqI4': '起始倉',
  'U+63ns': '發貨方式',
  'U0oOyg': '海外倉尾程查件申請',
  'eITI+b': '預計到達',
  'moQ/pq': '始發倉',
  'nkbxtM': '請輸入跟蹤號，最多一次性支持30個跟蹤號，號碼間請用「空格、逗號以及換行」隔開。',
  'sIulVO': '截止收貨',
  'sk3D+j': '物流計劃',
  'y8Y856': '啟運港',
  'zolGw6': '已截單',
  '+pOhR+': '檔案類型',
  '/cqdKk': '下載',
  '0OWEyT': '切換為單品化管理後無法添加協力廠商商品條碼，同時將清空已維護協力廠商商品條碼。 確認要切換嗎？',
  '2cnobD': '文件上傳',
  '60lhcg': 'SKU[{code}]提交失敗，必須保證隨貨攜帶紙質說明書，若您無法提供，商品將無法出庫。 詳詢客服',
  '9BNdhd': '僅限注册待稽核、注册退回、已發佈、更新退回、更新待稽核的商品，才能批量上傳文件',
  'B35fQu': '啟用出庫加包裝服務後，注册商品時需填寫包裝資訊，導入範本也會隨之更改（需重新下載導入範本）。 {break}啟用後無法關閉，確認需要加包裝嗎?',
  'HwyF+e': '啟用出庫加包裝服務',
  'IQB8CW': '添加檔案',
  'KTL7xe': '僅限草稿、注册退回狀態的商品，才能删除',
  'Lychr5': '包裝類別為[Winit標準包裝]時，包材類型不能為[不加包裝]',
  'M0Jk1q': '僅限已發佈的商品，才能列印條碼',
  'MLkhBi': '跳過，為其餘商品新增進口國',
  'P9HL7J': '僅限已發佈的商品，才能新增進口國',
  'TLZkuQ': '從文件管理中選擇',
  'UVc9ET': '檔案不足需補充？< a>去編輯</a>',
  'UduVZX': '選擇檔案',
  'X2PFlN': '僅限補充類型全部都為商品負責人的商品，才能批量綁定',
  'XI/sng': '複製連結',
  'XUIiyo': '僅限補充類型全部都為德語說明書的商品，才能批量操作',
  'do5UYM': '是否被商品引用',
  'gL2wtJ': '提交結果',
  'gLFXUo': '稽核不通過，請重新維護',
  'hb/4W7': '本地上傳文件',
  'r+E4Jq': '僅限草稿狀態的商品，才能提交',
  'r1IImU': '知道了',
  'Jc2rPw': '請輸入0~30個字元',
  'qQPq6P': '德語說明書連結最多30個字元',
  'sRBJ5R': '支持50M以內的jpg,jpeg,png,pdf格式檔案',
  '71F+U7': '檔案最多上傳{maxCount}個',
  '7VOwCe': '重新選擇',
  'FFdW4c': '批量維護德語說明書',
  'Tlz8ww': '維護德語說明書',
  'lQZq1z': '維護說明書',
  'ikulRv': '當前無可用余額，點擊',
  'yySTyc': '此SKU必須保證隨貨攜帶紙質說明書，否則出庫會受限，請確認是否攜帶紙質說明書？',

  '+Bp/vI': '個人帳戶',
  '+EKnLz': '未證明的付款，將被原路退回。 ',
  '+GpSaa': '富友線上超過90天的退款、易聯線上超過350天的退款及線下轉賬退款，額外產生的退款手續費，按照實際發生的費用扣除，請 以實際到帳金額為準。 ',
  '+aB+94': '*匯率(USD)',
  '+aFDe8': '匯款時間',
  '+mn2aK': '付款管道',
  '/4F0HL': '授信額度(USD)',
  '/BYjbl': '確定要一鍵開通嗎？ ',
  '/S2M/C': '轉出訊息',
  '/VO4aK': '還所有幣種的欠款。 ',
  '/vwubC': '海外倉費用計算',
  '/zEZR9': '請選擇錢包類型',
  '0X1r6A': '手續費：',
  '1y/RY3': '待還金額',
  '29Bujy': '4.點選可查看收款說明',
  '2dGT9s': '還款預估',
  '2ku/TP': '內作為押金，帳戶餘額 + 押金 >0，可正常消費。 ',
  '2ygZv/': '卡片類型',
  '3BONOy': '付款記錄',
  '3YANVl': '你已成功開通ISP帳戶。 ',
  '3mOyjF': '請選擇付款管道',
  '3sq/jr': '頭程臨時額度(USD)',
  '43p9pl': '您目前尚未開通海外倉帳戶，一鍵開通後可以：',
  '6cQmi+': '如需使用富友付款，請確保賬戶主體上傳的資料文件為最新版，否則將無法完成付款到賬',
  '4WnUuL': '銀行地址：',
  '4YQfnV': '你已成功開通海外倉帳戶。 ',
  '4hvYiT': '提交付款',
  '5P5/Mh': '付款金額不能大於',
  '5QTRWB': '計費重(KG)',
  '6/ZybD': '帳單無欠款或已還清，無需進行還款預估',
  '6K/a0B': '暫停',
  '6pFnBP': '目前可用於還款金額',
  '77wjVR': '進行處理，證明付款主體與接受付款的萬邑通帳戶是同一主體。 超過',
  '7R+2Zn': '可用待入帳',
  '7TOxPh': '聯行號：',
  '7uCsR+': '匯款金額',
  '7yRO8w': '如何進行海外倉費用計算',
  '82y49D': '發起帳戶',
  '8i9KCx': '2.不同錢包之間，支援任意幣種相互轉換。 ',
  '9/IwWU': '您目前尚未開通ISP帳戶，一鍵開通後可以：',
  '9JX759': '請填入大於0的兩位小數',
  '9bsH+T': '1.線下付款單通常需要1~3個工作天才會入帳。 如急需使用付款金額，請使用線上付款。 ',
  '9nOyKf': '與萬邑通帳戶的註冊名稱不一致！ ',
  '9oZAA6': '帳號註冊與管理',
  '9ppYjb': '備註：該筆金額將在',
  'Aj8GCU': '商品註冊與管理',
  'BB3JzJ': '【提交證明】',
  'ux+6D/': '未逾期帳單b',
  'CN1Myp': 'Paypal、Airwallex、富友信用卡超過90天及線下轉帳管道依照到帳金額退款，原付款手續費不退還；其他線上管道則全額退還。 ',
  'CnJrhy': '請點選',
  'DkxKwM': '清楚查詢ISP消費紀錄與帳單;',
  'EznDMN': '待入帳退款手續費說明：paypal、Airwallex、富友信用卡超過90天及線下轉帳管道依到帳金額退款，原付款手續費不退還；富友線上超過90天的 退款、易聯線上超過350天的退款及線下轉帳退款，額外產生的退款手續費，依照實際發生的費用扣除，請以實際到帳金額為準；其他線上管道則全 額退還。 ',
  'FbGkhC': 'Payoneer帳號解除關聯成功！ ',
  'FlqSrP': '待入帳擔保凍結',
  'GJqMVO': '還款幣種',
  'H7VDO0': '如何進行商品註冊',
  'HC2zVC': '帳單已還清，無需還款',
  'HP1Bh4': '目前可轉出：',
  'HV+RrC': '選項一：還所有幣種的欠款，還款順序為1234567（不還未出賬單的其他幣種的欠款）。 ',
  'HesHBG': '請輸入賣家訂單號碼',
  'IFdU1p': '確定解綁Payoneer帳號嗎?',
  'IIW5jM': '付款失敗',
  'IRZDt1': '請選擇收款帳號',
  'Ic3VRb': '付款金額',
  'JVWd7i': '金融卡',
  'Jh+0Zh': '2.同一個帳單內，付款幣種的欠款還清後，其他幣種按欠款金額從大到小的順序購匯還款',
  'K1GUT5': '待還',
  'KCVyDg': '轉入成功',
  'KPlzwS': '付款提示',
  'KQ2i0E': '儲存並提交付款',
  'L/WfHi': '請選擇轉入幣種',
  'M7nstf': '付款單號',
  'HYJRdP': '只還付款幣種的欠款',
  'MaPa8K': '有餘額的帳戶為欠款帳戶擔保還款的金額，在擔保時按當天匯率統一轉美元進行擔保。 若欠款帳戶實際還清，則該金額會自動調整為0。 ',
  'Mq7E3I': '指最新一期帳單對應幣種的剩餘待還金額，非即時欠款。 ',
  'NwL8D2': '付款下單使用ISP產品及服務;',
  'OMT30j': '如何提交資料開通權限',
  'P4kzRS': 'Payoneer將會收取等同於您提現手續費的支付手續費。 如有異議，請聯絡您的Payoneer客戶經理。 ',
  'PfZZIE': '最小輸入金額為0.01',
  'Pz9nMI': '付款管道處理中,請隔約1~5分鐘左右在付款單查詢付款狀態',
  'Pzdaeh': '=可用餘額*匯率。 由於匯率波動，可用餘額USD也隨匯率動態變化。 ',
  'QYZ9Zx': '頭程額度詳情',
  'RJiV2P': '一鍵開通',
  'RY0kPp': '確認還款',
  'Ri66Qg': '進行還款操作，處理完畢後，帳單預估待還金額將自動更新。 不同帳戶之間不能互相還款。 ',
  'SLJmsv': '確認還款後，系統將依照',
  'SPT6N5': '支付管道回傳的付款主體使用者名稱：',
  'Sq4y+b': '=待入帳總額-待入帳擔保凍結-待入帳退款凍結',
  'StJL1v': '轉入金額',
  'TBZp+D': '若要只還付款幣種的欠款,請修改還款優先級設定。 ',
  'TqsGZy': '請選擇付款帳戶類型',
  'U1a5b6': '請輸入TrackingNo',
  'UIl1do': '如您的主帳戶主體無法付款，請直接變更主帳戶主體，無需註冊子帳戶。 ',
  'UbVGIy': '入帳金額：',
  'UdMGCn': '待入帳退款凍結',
  'UrwhFI': '還所有幣種的欠款',
  'Ut/pd3': '1.同錢包內，支援不同幣種相互轉換，不支援同幣種轉換。 ',
  'VZZTLA': '額度詳情',
  'VgiKkA': '可用待入帳(USD)',
  'VxJpE0': '3.待入帳退款手續費說明：',
  'VzyupL': '帳號：',
  'WAIPZ7': '為不影響海外倉下單，接下來請先付款。 ',
  'WKL0h2': '上傳格式僅限於jpg, gif, png, jpeg, pdf, doc, xls, csv, docx, xlsx，大小不超過2M',
  'WMHRvU': '請輸入付款金額，限制2位小數',
  'X4GxQb': '=可用待入帳*匯率（USD）',
  'XdbxuW': '手續費',
  'XfVGBl': '線上付款',
  'Xgm4f8': '主帳戶',
  'XjiQM6': '可下單金額(USD)',
  'Y1DU7Y': 'TEMU後台及萬邑通後台基礎設定',
  'Yq7bo5': '交易號碼',
  'YsDkfI': '今日匯率：',
  'Z5TkZp': '如何進行帳號註冊',
  'Z6Sgc7': '還款',
  'Z7Qmhr': '待還總計',
  'a6ZOkV': '每天下午3點取得招行匯率作為次日的匯率使用，招行匯率查看地址',
  'aB10CI': '1.依出帳單時間的先後順序還帳',
  'aDobaI': '失敗原因:',
  'adagiy': '還款優先權設定',
  'bOeriS': '=可用待入帳(USD)',
  'bhqbML': '多個業務單號以英文逗號隔開，支援查100個訂單',
  'bmpsI4': '匯率*',
  'c0L+yJ': '為不影響ISP下單，接下來請先付款。 ',
  'csDC/0': '開戶名稱：',
  'd8I+tD': '若Payoneer有待入帳單據，解綁後可能會導致退款失敗，若無請忽略。 ',
  'dMLnuv': '付款下單使用海外倉出庫、入庫、國際送倉、退貨等產品及服務;',
  'dMXzwA': '提交資料審核後自動開通權限',
  'dde1iG': '轉入皮夾',
  'dgCSCT': '收款帳號',
  'e0EBzw': '轉入帳戶',
  'eGcy2N': '入帳帳戶',
  'eLSgnP': '帳戶總覽',
  'eRQHjK': '付款金額不能小於',
  'eUvdyt': '目前被凍結的金額',
  'ecuOhs': '失敗原因的描述（後台有返回就展示，沒有就不展示）',
  'etbYTE': '檔案大小需小於2M',
  'f8hvof': '付款帳戶類型',
  'fLc+XS': '待入帳詳情',
  'gAJffR': '選項二：只還付款幣種的欠款，還款順序為147。 ',
  'gDdy3P': '2.待入帳退款手續費說明',
  'gLueKi': '自動還款優先級',
  'gMHwLF': '請選擇卡片類型',
  'gTawBp': '可用餘額明細',
  'hQllsy': '子帳號',
  'hehTR6': '綁定帳號',
  'ikHYS2': 'ISP帳號',
  'jCBjGq': '離線付款',
  'jZ73eo': '入帳金額',
  'kV7zH8': '開通海外倉帳戶',
  'kdB1AH': '無payoneer帳號？ ',
  'koaAco': '收款管道',
  'l2g8wQ': '1.付款主體名稱與我司註冊名稱不一致時，將在第12天自動發起退款；為避免影響您下單，請使用相同主體名稱進行支付。 ',
  'l7f7r8': '若要還所有幣種的欠款，請修改還款優先級設定。 ',
  'llD/i8': '請上傳附件！ ',
  'm0y10W': '信用卡',
  'm1RY2+': '轉出金額',
  'mG5cQ0': '只還付款幣種的欠款。 ',
  'mMJ1Rl': '3.幣種CNY/HKD的最小轉出金額為0.1，幣種GBP/EUR/AUD/USD/CAD的最小轉出金額為0.01。 ',
  'mhaWrg': '我要付款',
  'mvk8fk': '可避免帳單逾期：',
  'nHkdvI': '未出帳單c',
  'nKlulI': '取消付款',
  'nT7ZVh': '如何進行後台基礎設定',
  'nVdGLm': '轉入訊息',
  'ordSAe': '公司帳戶',
  'p0X04m': '皮夾類型',
  'pFzElE': '點選註冊',
  'qQO1Kx': '請選擇收款管道',
  'qn8PaB': '案例：假設用戶有逾期賬單a，未逾期賬單b，消費未出賬單c，abc按時間先後順序發生，都有USD、AUD、GBP欠款，且AUD的欠款金額數> GBP欠款金額數。 若付款足額的USD：',
  'qsDvGz': '帳戶',
  'qwYCNh': '開戶行：',
  'rCo8W8': '個',
  'rGARdg': '請選擇匯款時間',
  'sQo+08': '轉出帳戶',
  'tKr1pi': '額度分配',
  'tb1UtE': '最小輸入金額為0.1',
  'ti7lc2': 'Payoneer暫不支持註冊在下列國家的帳戶：澳洲、日本、俄羅斯。 請使用註冊在其他國家的payoneer帳戶進行授權支付。 ',
  'uMgaXV': '2.付款主體名稱與我司註冊名稱不一致時，將在第12天自動發起退款；為避免影響您下單，請使用相同主體名稱的帳號進行支付。 ',
  'v5UE43': '待入帳總額',
  'vv2W/D': '開通ISP帳戶',
  'vy/OTR': '=帳戶餘額-凍結金額',
  'w0hdTL': '3.我司堅決執行《中華人民共和國反洗錢法》的相關規定，付款後如需退款，將由付款管道原路徑退還。 對涉嫌洗錢、虛假交易等行為，我司有義務向相關部門舉報並協助公安機關提供證據。 ',
  'wBFOVC': '帳號授權',
  'wPdOYa': '清楚查詢海外倉消費紀錄及帳單;',
  'wm1m74': '請選擇轉出幣種',
  'wnNJYN': '入帳金額以實際到帳金額為準',
  'wq/8d2': '收款說明',
  'wsJMPz': '轉出皮夾',
  'wxKEvn': '請綁定帳號授權',
  'xHiFxP': '銀行代號：',
  'xOOX40': '本付款金額,將會',
  'xSePXT': '取得更多優惠及返利',
  'xch+qQ': '預估還款金額',
  'xsvWWt': '逾期帳單a',
  'y9h4Ep': '繼續付款',
  'yA6qzf': '不夠匯還其他幣種的欠款，可能導致帳單逾期',
  'yILY8H': '付款成功',
  'ydgrO7': '已認證或（已開通服務）的帳戶，才可作為付款發起帳戶。 ',
  'yfhtRM': '附件',
  'ym4AWb': '目前帳戶對應幣種的餘額，含凍結金額。 ',
  'z1tAjb': '此處的單幣種待還金額只是根據當前匯率兌換後得到的一個預估金額。 因每天匯率都會發生變化，還款時請依照當天的匯率為準。 ',
  'T7vDas': '付款還款優先權',
  'PCAxv5': '請登錄主賬戶開通',
  'QZVGH2': '主賬戶還未開通',
  '+/mKIm': '送港類型',
  '+Haf5X': '預計上架時間',
  '+KV1mF': '預設提貨類型',
  '+VZ9L9': '{warehouseName}{break}SI數量/拆分比例%',
  '+b49JP': '新增商品',
  '+ouZSO': '打託內包裹數',
  '//BDmI': '上架異常區',
  '/1VwD2': '報錯訊息',
  '/3s7PF': '倉庫聯絡人電話',
  '/AhSAS': '驗貨中',
  '/GAWbE': '國內拆原單號',
  '/HFG6y': '快遞單號只支援6到40位的英文和數字',
  '/KZ2WA': '實際採集識別碼',
  '/cQzqv': '請填入正整數！ ',
  '/crqpT': '已扣貨',
  '/kUXrS': '查看轉存',
  '/lKNmz': 'SLA{a0}',
  '/pS13+': '請新增發票資訊',
  '0+4E11': '修改成功',
  '04Gdfx': '請先新增商品',
  '05s3bE': '不可選擇的原因',
  '09Xv5V': '請選擇出口商',
  '0Cs9O2': '空包裹',
  '0LXLDR': '備註：如您選擇添加歐代信息，則標籤將帶有已關聯的歐代信息；如不選擇則不會帶有',
  '0OjWgU': '大量收起商品資訊',
  '0Q/VKe': '若不填寫，選擇訂單後會自動生成，並可修改',
  '0Yqdvb': '建立自驗單',
  '0eFd5u': '運輸中',
  '0n+GhK': '暫時無法提供快遞單號，先確認出貨，訂單到倉前可提供。 ',
  '0oRCPJ': '更多地址',
  '1+iXcF': '大量建立預約單',
  '148weM': '預付費用',
  '1AcjeR': '請選擇{field}',
  '1Cm5u2': '建立預約單',
  '1Fsq2f': '訂單內包裹序號，僅作為計數查看，無需支援掃描',
  '1SrwnE': '<span>註：以上費用為預估費用，費用凍結時間為：國內驗貨倉驗貨完成/直發海外驗為已提交。 {break}</span> <span>帳戶可用餘額小於系統預估費用則無法提交訂單，煩請在下單前確保帳戶可用餘額充足。 </span>',
  '1Un03g': '異常狀態',
  '1Wvoid': '快捷下單',
  '1b90aB': '驗貨方式',
  '1eYE4O': '上架差異數',
  '1f8TDn': '提貨地址',
  '1kQP8C': 'WINIT產品',
  '2145JR': '終止詳情',
  '29nc3A': '實際重量(kg)',
  '2K4z2R': '辨識碼資訊不能為空！ ',
  '2N21Ip': '偏好名稱',
  '2Y/zPo': '預付費用合計',
  '2f2ltn': '整單商品以不良品上架',
  '2mmTtR': '請輸入數字且小數點後不超過六位',
  '2pylzZ': '多個單號需換行，最多支援{num}個。 雙擊切換到單一查詢',
  '3FrfH2': '請選提貨時間',
  '3Jc4/0': '發票申報資料',
  '3R6r9b': '否，邊驗貨邊裝箱',
  '3Tv9vo': '包裹條碼',
  '3U8Sns': '請維護起航時間',
  '4/Afmm': '生產日期',
  '4/cfmf': '批次列印包裹條碼',
  '48ov53': '若選擇了套裝產品/箱產品，則數量表示套數/箱數',
  '4AtBWc': '提貨類型',
  '4JMVek': '切換後將清空現有的箱單訊息，您需要重新匯入箱單。 請確認是否切換？ ',
  '4Y5o/o': '編輯快遞單號',
  '4Z9Hsl': '請輸入{field}',
  '4bqHG6': '待審批',
  '4zXeKC': 'C包裹條碼數',
  '5AMYmr': '進口報關類型',
  '5Hy2HW': '異常說明',
  '5MwSDO': '確認取消 <span>{mainOrderNo}</span> 訂單合併嗎？ 取消訂單合併後，頭程費用將獨立計算。 ',
  '5WkW6a': '國內倉扣貨數量',
  '5ZVPiX': '增值預約',
  '5eNIMa': '提貨時間',
  '5m+OgD': '新增識別碼',
  '5s/d5K': '關聯調整單號',
  '64ulHJ': '費用名稱',
  '66awCH': '刷新',
  '6EnlKE': '是否免自驗',
  '72NkSW': '更新並關閉頁面',
  '7L70OD': '實際體積(CBM)',
  '7VvMbL': '送港時間',
  '7q/H5d': '單號去重',
  '7tb4y9': '請維護貨櫃號碼',
  '8/zli1': '待預約',
  '84F3+v': '不支援修改推薦偏好資訊進行下單，如不使用此偏好，請使用其他方式下單，謝謝！ ',
  '87NQWt': '全部收齊',
  '8EFvsh': '表示該商品實際上架或驗貨的數量',
  '8N2XyN': '是否主子選單',
  '8Nd7ys': '是否確認回退到草稿？ ',
  '8OKx0+': '支援維護客戶包裹的訂單清單',
  '8PwcJP': '[下單 | 驗貨 | 實際 | 上架]',
  '8RyGw7': '聯絡方式',
  '8VaERm': '匯出您匯入包裹資訊/商品資訊的檔案,方便您在原先的檔案上修改後重新匯入。 ',
  '8aVf1s': '新增識別碼',
  '8yOIaG': '印份數',
  '9F8Tn0': '查看費用明細',
  '9Jdkl/': '發票總金額(USD)：{money}',
  '9U7C/w': '申報價值',
  '9bK+VQ': '預計到倉時間(當地)',
  'ABsoZh': '批次匯入客戶包裹',
  'ACzUlr': '不提供並取消待辦',
  'ADgz1i': '請點擊此處下載<url>商品資訊範本</url>',
  'AIQmaJ': '繼續下單',
  'ARAdzq': '(截貨到上架的時間是{maxSla}個自然日)',
  'B2Qpws': '下單體積(CBM)',
  'B6fE/x': '已卸貨',
  'B8oYdO': '分割調整',
  'BQqOxZ': '貨物處理方式',
  'BQrZ98': '大量列印商品條碼',
  'BvRA7E': '總計數',
  'ByDy2W': '商品中文名稱',
  'ByyC+Y': '新增快遞單號',
  'C8gyRs': '是否確認生效？ 生效後可透過篩選條件繼續查詢。 ',
  'C90Kr8': '貨櫃號碼',
  'CBNdcR': '是，待驗貨：已確定箱單信息，下單環節錄入完整的包裹和商品的綁定關係。 {break}否，邊驗貨邊裝箱：未確定箱單信息，下單時僅填寫商品信息，驗貨時現場操作APP綁定商品與包裹的關係。 ',
  'CBhqWQ': '總商品數：',
  'CJovuJ': '請選擇出口報關類型',
  'COLDy1': '處理人',
  'CORiCX': '散貨',
  'CSKXy4': '良上架數量:{a0}{break}不良品上架數:{a1}',
  'Ci0uZW': '包裹已到倉且存在待您操作的異常，請到《異常訊息》處理，異常處理後倉庫會繼續正常上架併計入庫處理費。 ',
  'CmFNm0': '部分到倉',
  'CykO0a': '草稿單是否有效',
  'DLVpO9': '請注意，選擇免自驗後，訂單將在提交後自動完成驗貨，無法再修改箱單資訊',
  'DapT6x': '已維護起航時間，請同時維護貨櫃號碼',
  'E+NBXN': '口罩類商品請提供CE認證（歐州），醫用口罩類商品請提供FDA認證（美國），否則庫內會進行扣貨，如已提供請忽略',
  'E7XGNI': 'HSCOOD',
  'EPU9xw': '請選擇目的倉相同的訂單建立預約單',
  'EQ3QSv': '單品數量',
  'ESC6Yn': '包裹清單',
  'EX2W4q': '直接確認出貨',
  'EgNwCT': '請先選擇是否明確裝箱清單。 ',
  'F8Cxjp': '整櫃照片',
  'FBADnU': '已驗貨',
  'FDm4J5': '倉庫地址：',
  'FMXIS2': '異常名稱',
  'FUpkCM': '存在異常單',
  'FUty4V': '目標上架時間(當地)',
  'FtPVQO': '配置偏好',
  'FvcItB': '截止收貨時間',
  'G0phnd': '編輯入庫下單偏好',
  'GAdpHS': '增值',
  'GTx/vJ': '驗貨數據支援多次導入，每次導入會清空當前訂單所有歷史驗貨數據，以最後一次導入數據為準。 ',
  'Gqin8B': '已轉出',
  'Gr4OaP': '子包裹條碼',
  'H+5XWJ': '出口報關類型',
  'H/88FZ': '訂單狀態',
  'H1BfHj': '已下單',
  'H6fRPF': '第三方箱號',
  'H74WHM': '快速自驗',
  'H7aOFH': '待更新',
  'HB0v/l': '預設預計上架時間最早的物流計劃',
  'HEsWMo': '編輯商品',
  'HGZs22': '識別碼',
  'HIB2bG': '請仔細閱讀<url>《直髮頭程使用手冊》</url>,若因未按規定操作導致違規產生 額外費用、收貨上架延誤等結果，Winit不承擔任何責任！ ',
  'HQNu2M': '總包裹數：',
  'HclFq/': '請輸入數字且小數點後不超過兩位',
  'HeBDj3': '查看歷史異常',
  'Hh4Skh': '標籤檔',
  'Hi/cDm': '合併子單',
  'HjCmpq': '調撥單號',
  'Hps8qJ': '{warehouseName}{break}SI數量|包裹數',
  'HxabgS': '商品尺寸（cm）',
  'I8h0ir': '再次下單',
  'IKLUiW': '支援建立預約單的訂單清單',
  'IQcPaX': '實際採集快遞單號',
  'IX2QXb': '總單品數：',
  'Ib2hT8': '預約倉庫',
  'IeO0m8': '預計到倉時間',
  'IpFfcK': '憑證照片',
  'IqBF9S': '包裹外包裝已張貼的自訂箱嘜條碼，需支援掃描識別，WINIT系統內需唯一',
  'J/7xTf': '是否明確裝箱清單',
  'J01u91': '預設送港類型',
  'J8dULN': '箱號',
  'JISjDR': '箱嘜樣式',
  'JT2B6+': '上架有差異',
  'JhQ/Jm': '匯總數量{break}SI數量|包裹數',
  'JloVFv': '支援維護起航時間訂單清單',
  'JoFqsi': '無該權限！ ',
  'K8uL5W': '溫馨提醒：如因此問題造成海關扣貨或查驗，所產生費用、責任等風險須由客戶自行承擔。 ',
  'KB4dfq': '已收貨',
  'KBc/G+': '上架數',
  'KGzTFK': '請填入大於0的數，最多保留3位小數',
  'KQ5tz8': '費用預估',
  'KRrlyx': '無法確定快遞單號與包裹的關係，請在下表輸入並儲存此訂單的快遞單號。 （多次儲存會自動去重並做追加處理）',
  'KVkKPj': '實際上架時間',
  'Keyhlo': '費用',
  'KwEmp3': '批次上傳識別碼',
  'LIyazS': '更新人',
  'LbBp8z': '終止數',
  'LbzjeJ': '確認出貨',
  'LpjYFr': '<title>溫馨提示:</title>{break}<span>請注意正確選擇該訂單的進口商，系統會以此進口商信息記錄該在途訂單商品信息，萬邑通會根據 英國海關稅務總署（HRMC）的要求提供該進口商的在途、在庫和出庫資訊。 </span>',
  'LqWKF0': '訂單資訊更改，預估費用發生變化，如有需要請至<url>訂單詳情</url>查看最新預估費用。 點選訂單詳情超鏈至詳情頁。 ',
  'Ls1X2Z': '已處理',
  'M0EUx8': '展開更多',
  'M7XhhM': 'A+包裹條碼數',
  'MHVja0': '出運地',
  'MNhsuy': '實際生產日期',
  'Ml6cXJ': '選擇需要複製的訂單',
  'MntjRj': '該訂單的送倉方式屬於快遞且是無箱單，請提供識別碼信息，Winit會基於識別碼信息識別訂單',
  'Mp5/Kf': '訂單資訊',
  'N25MSc': '預約狀態',
  'NUm1lw': '出貨供應商',
  'Nnflg8': '因只支援整包分割,結果可能有差異,請查看最終結果',
  'NxRF/D': 'B包裹條碼數',
  'O2GkC8': '預約成功',
  'O2w7aQ': '請先選擇Wint入庫產品再建立自驗單',
  'O78/NO': '客戶',
  'ONp4Fs': '溫馨提示：重新上傳會清空原先匯入的資訊',
  'OOa7/r': '新增子單',
  'OPMsMJ': '異常創建時間',
  'OW95UK': '<span>如果您明確送倉時間，請選擇正確的送倉時間，如果您尚不明確送倉時間，可使用系統預設計算出的送倉時間，謝謝！ </span>',
  'OXu/wN': '是否主子訂單',
  'ObFFIO': '下單時間',
  'OtbHOY': '識別碼最長128個字元',
  'PcnKff': '簽收資料',
  'PiyAfP': '預約類型',
  'Q0IJ2Z': '快遞公司',
  'Q58yf2': '預設推薦',
  'QYstE7': '合併後的主單為入庫單 {orderNo}，合併後無法更換主單。 ',
  'Qjs1ZE': '簽收單照片',
  'QreDuh': '異常預約',
  'Qzs7rS': '訂單軌跡',
  'R6Haep': '發起轉存',
  'RAwLcV': '新入庫單',
  'RMaTq1': '是否鉛封異常',
  'RWKKkV': '批次維護維護包裹條碼',
  'RlYLsE': '費用說明',
  'RuIqtm': '介面未回傳數據，產生檔案失敗',
  'S/8L6Q': '整櫃',
  'SGFD07': '是否參與調撥',
  'SLK/K9': '總標籤條碼 = 包裹數量 X 列印份數 如需重複列印多張標籤，請指定列印份數，相同的標籤將排列在一起。 ',
  'SM5IQ2': '批次匯入快遞單號',
  'SSOUy/': '更新並到下一步',
  'STnfmz': '打托數',
  'SU88Fc': '包裹數',
  'SUm34B': '海外卸貨時間',
  'SYsndp': '請確保匯入資料的準確性，否則將影響您帳戶的信用等級。 ',
  'SlzHdq': '請至少選擇一筆訂單再提交',
  'Sn2I9N': '目前訂單下單總包裹數{estimatePackageQty}個，已上架{shelvePackageQty}個，已遺失{lostPackageQty}個，已終止{stopPackageQty}個，請確認是否已全部上架完成？ 操作後剩餘{remainingPackageQty}個包裹將自動終止，並且無法恢復',
  'Sne4x8': '新增入庫下單偏好',
  'SqE6Xs': '產地',
  'T4IvBW': '第三方編碼',
  'TBbEyx': '新提交',
  'TH1ziY': '已到倉',
  'TKdhhF': '增值資訊',
  'TLgurL': '<span>如提貨類型選擇"WINIT上門提貨",且提貨地址為非免費攬收區域,收費標準請參見WINIT海外倉價卡, 如價卡無報價,請先諮詢WINIT客服獲取 報價.</span>',
  'TTRtNs': '發票總金額(USD)：{invoiceMoney}',
  'TXukVl': '關聯訂單號碼表示該入庫單相關的增值單中，對應的原入庫單或新入庫單。 僅顯示已受理、倉庫處理中、倉庫已處理、已完成加值單中的關聯訂單號',
  'TbuyGo': '顧客訂單號碼',
  'Td1kBU': '關聯訂單號碼',
  'Thj8cY': '是，待驗貨',
  'TlN+E+': '若選擇了套裝產品/箱產品,則數量表示套數/箱數',
  'TlmivL': '入庫下單設定',
  'TmeS4t': 'Winit',
  'TpnoPg': '倉庫電話：',
  'TqOQZ7': '實際費用',
  'TuZEiB': '驗貨數',
  'U5YRJc': '取消驗貨',
  'URH0xP': '預約單號',
  'UTgFmZ': '包裹重量（kg）',
  'UjxKxu': '終止',
  'UzUKJU': '維護進口商',
  'V/Q/MF': '全部取消',
  'V3EgJJ': '貨櫃號碼應為 四位大寫字母+7位數字，請檢查後提交',
  'VdzlrR': '請點擊此處',
  'VgoWxA': 'Winit費用',
  'VhKC/g': '逐一加',
  'ViVCdK': '上架完成時間',
  'VvQxun': '已遺失',
  'W5OmHx': '入庫單號',
  'W60tFR': '下單日期',
  'WGM/sd': '列印包裹條碼',
  'WPq6RS': '已匯出已匯入資訊',
  'WVa6Gz': '是否A+',
  'WeJSWO': '整櫃櫃型',
  'WntfLd': '國內倉資訊',
  'Wq3cD+': '是否高貸值',
  'WqyrgN': '部分上架',
  'Wy9Mf2': '今天',
  'X1YR3n': '回到草稿',
  'XA+N8d': '編輯包裹',
  'XBalI+': '實際產品批次號碼',
  'XCMy9u': '請選擇快遞公司',
  'XFFD/P': '大量檢視商品資訊',
  'XLlfn6': '回饋增值',
  'XOzvJn': '輸入兩個字元系統自動匹配SKU',
  'XauMax': '編輯轉存',
  'XnTAmU': '實際失效日期',
  'Y0Vai9': '實際條碼值',
  'YEHu7B': '長寬高',
  'YII2+w': '失效日期',
  'YncPzL': '若選擇使用該增值服務，當入庫訂單內某SKU單一產品庫存以A包入庫，且滿足該SKU箱產品箱規，則會自動轉為箱產品庫存上架。 ',
  'YqBDBe': '<title>溫馨提示:</title>{break}<span>英國非Winit承運訂單，請於貨品到倉前提供內容完整的進口報關文件，如未提供有效的清關文件，萬 邑通有權基於英國海關稅務總署（HRMC）對倉庫的盡職要求針對該訂單禁止出庫，謝謝。 </span>',
  'YrPv/S': '儲存模式數',
  'Z3nsrC': '請選擇刪除項目!',
  'Z7aHkZ': '凍結節點',
  'ZOZfwr': '您目前的下單資訊將自動為您儲存至草稿單{orderNo}，請確認是否取消？ ',
  'ZTlBmE': '入庫單號：',
  'ZfgKqB': '請<url>點擊此處</url>下載箱單資訊範本。 ',
  'ZlNu8o': '如提貨類型選擇"WINIT上門提貨",且提貨地址為非免費攬收區域,收費標準請參見WINIT海外倉價卡,如價卡無報價,請先諮詢WINIT客服獲取報價.',
  'ZpXeP3': '預計抵達時間',
  'a03CGi': '包括鉛封照片、開箱照片、受潮進水照片',
  'a2fLkA': '請選擇識別碼類型',
  'a5E0Ng': '子包裹海外掃描時間',
  'a5l3By': '請輸入0-100,最多為兩位小數',
  'a7NkIa': '截止下單時間',
  'aB+BJ/': '使用箱單資訊產生申報',
  'aDBVmD': '快遞單號',
  'aMiNon': '送倉方式',
  'agQLWz': '關聯調整型別',
  'av2paB': '需要客戶提供資訊',
  'avQKT6': '請輸入正整數',
  'b6ccYv': '可用產品共 {a0} 條 不可用 {a1} 條 <a2>不能選擇的產品展開</a2>',
  'b9JmDO': '取消出貨',
  'bEG5tG': '下載批次上傳識別碼模板',
  'bGVE1B': '大量維護客戶包裹碼',
  'bOqVvl': '請輸入快遞單號',
  'bccJSU': '包裹重量',
  'beiLZA': '箱單資訊不能為空！ ',
  'bjzFIC': '預計出貨時間',
  'bpSdwX': '未打托包裹數',
  'btRxj0': '費用資訊',
  'btmsJu': '已終止',
  'c2hDMK': '可確定快遞單號與包裹的關係，請下載此訂單模板，匯入上傳。 （多次導入支援更新）',
  'c2y2qR': '匯入快遞單號',
  'cNQ0gh': '下載模板，導入上傳（針對已確定快遞單號與包裹的關係）',
  'cQMY2E': '確定操作刪除嗎?',
  'cS931W': '申報中文品名',
  'cY3iEX': '取消轉存',
  'coU8Jk': '單品數',
  'ct6g4c': '您發動終止的訂單，若訂單包裹到達海外倉，將被攔截無法上架，暫存至異常區並會產生額外暫存費用，確認繼續終止嗎？ ',
  'dASZuG': '提交並確認發貨',
  'dCFfNa': '該訂單的送倉方式屬於整櫃，請維護起航時間！ ',
  'dF+aMA': '是否受潮進水',
  'dGF8Sn': '編輯識別碼',
  'dOBmL8': '保存並確認出貨',
  'dQD3ZJ': '驗貨狀態',
  'dfIz/T': '上傳快遞單號',
  'dpcPCu': '預估費用',
  'dssjRY': '申報價值（USD）',
  'e1d/Ws': '以上費用為預估費用，最終以實際收費為準。 ',
  'e8cbAb': '倉庫名稱',
  'eOIKED': '核對尺寸（cm）',
  'eelCv6': '全部清除',
  'el0Kz3': '預計送倉方式',
  'enLtM3': '扣費節點',
  'ex+IzV': '核實重量（kg）',
  'f36rK/': '請選進口商',
  'f69V6p': '簽收時間',
  'f6CeZ+': '請輸入非A+包裹條碼數',
  'fC2QjX': '維護出口商',
  'fDddkK': '主單訂單號碼',
  'fEWKZV': '產品批次號碼',
  'fQXTj6': '快遞訊息',
  'fWEyf9': '已全部上架',
  'fZDGEe': '簽收人',
  'fmXbdW': 'HSCODE',
  'fuDs1B': '異常到倉',
  'g9bh34': '商品英文名稱',
  'gB3QVh': '包裹等級',
  'gSmKzH': '計費重(kg)',
  'gmG+u8': '失數',
  'gsVL49': '尊敬的客戶，您好！ {break}<desc>根據美國海關及邊境保護局最近發布的通知，禁止進口中國新疆維吾爾自治區的棉花產品（全部或部分使用該棉花生產的產品）。 因中國棉花大部分生長在該地區，從中國進口含有棉花的產品有可能被扣留或禁止入境，詳情請查看美國海關及邊境保護局的通知連結。 </desc>{break}<url>點選連結位址</url>',
  'h5VsBC': '普通預約',
  'hJbAF7': '箱單資訊',
  'hOPDPX': '是否確認出貨',
  'hPJkFk': '提櫃地址',
  'hYC7rP': '您更改的信息將涉及下單結構的調整，將默認清空箱單信息，請確認是否調整？ ',
  'hZHPZo': '請選擇Winit入庫產品!',
  'hkVN9x': '請確認訂單是否已全部驗貨，驗貨完成後將無法修改訂單資訊。 ',
  'hl1rBH': '入庫單識別碼',
  'hvGSWe': '驗貨倉/出運地',
  'hxJVQJ': '申報單價(USD)',
  'i6uYTF': '切換後將清空現有的箱單資訊，您需要重新匯入箱單，請確認是否切換？ ',
  'iEwi00': '該訂單的送倉方式屬於快遞，請維護快遞單號！ Winit會基於快遞單號取得物流軌跡。 ',
  'iJRlKo': '倉庫地址',
  'iL72fa': '雙擊切換到批次查詢',
  'iMfa45': '支援上傳快遞單號的訂單清單',
  'iT2mOO': '是否確認失效？ 失效後可透過篩選條件繼續查詢。 ',
  'iYbZ9o': '申報單價 (USD)',
  'iZK+78': '拆單原單號',
  'jDrbVr': '入庫單驗貨狀態處於驗貨/驗貨完成，不允許修改！ ',
  'jESlL9': '近{days}天',
  'jF4g5j': '請選擇非A+包裹的商品進行印刷',
  'jJzjJ7': '待驗貨',
  'jOFy6Z': '僅發生異常情況時才有相應照片，包括異常托盤圖片、異常包裹圖片等',
  'jSb67m': '出貨計劃',
  'jcMe0a': '請至少選擇一筆單',
  'ji5/jU': '該偏好刪除後不可恢復，確定要刪除嗎？ ',
  'k3gNi8': '辨識碼訊息',
  'k3gVMn': '<title>溫馨提示:</title>{break} <span>1.請指定BC類包裹目的倉</span>{break} <span>2.系統將依照分倉比例對A 類別包裹自動進行拆分，支援自行調整，確認提交後系統將自動拆分成多個訂單</span>{break} <span>3.如希望統一貼包裹條碼，請在訂單提交前打印包裹條碼 ；提交後需依分割後訂單分開列印貼標</span>',
  'kMMJmC': '裝箱資訊以您訂單匯入包裹資訊為準，如需調整，請在完成自驗前重新匯入訂單包裹資訊。 ',
  'kVZ7cV': '取消合併',
  'khjSsg': '<title>溫馨提示</title>{break}<span>下入庫單時，我們將根據你設定的入庫下單偏好自動帶出您的偏好訊息，提升你的下單 效率</span>{break}<span>偏好設定步驟：</span>{a0}',
  'klLCMR': '扣貨數量',
  'ksgpo6': '每一張快遞入庫單申報價值不能大於{max}美金，請更改申報價值 或分割出貨',
  'kuDo/J': '{field}不能為空',
  'kyVVoP': '起航時間',
  'lNQLAr': '無法提供快遞單號。 ',
  'mLsoqa': '已回饋',
  'md3nxV': '請至少選擇一個子單再提交',
  'myc/4W': '是否A+包裹',
  'nHbUPX': '單一產品轉箱產品',
  'nLwKh5': '偏好名稱不能為空',
  'nhwDW2': '請選擇項目',
  'niU4F4': '包裹序號',
  'nnZ5Oj': '若識別碼類型為快遞單號,則需要填入 寫對應的快遞公司;若識別碼類型為入庫單號,則無需填寫,系統將自動填入。 ',
  'ntW28d': '識別碼類型',
  'nyrsly': '若勾選訂單資料會依照選取的訂單填入模版，未勾選則下載空白範本',
  'o4Vv1R': '請填寫資料！ ',
  'o7iVPm': '包裹尺寸（cm）',
  'oNsmAy': '包裹資訊',
  'oOZt0C': '簽收類型',
  'oPxsc7': '列印訂單條碼',
  'oxmeg2': '商品重量（kg）',
  'p0QER/': '違規行為包括但不限於以下：{break} ①直發頭程包裹面單/運單/提單/發票等物流單據未按照萬邑通自發頭程要求填寫，包含了WINIT或其他 WINIT 員工的名字等字樣{break} ② 直髮頭程不是發貨人承擔稅金（DDP、DTP、 F/D等）的付款模式；{break} ③入庫單狀態異常：直發自驗入庫 單不為運輸中，直發海外驗入庫單不為已下單；{break} ④直髮頭程入庫單（非快遞送倉）未預約送倉/未按預約時間送倉等"',
  'p7k/3V': '已選擇 {num} 筆記錄',
  'pDE/NS': '請加商品',
  'pNlKO3': '子',
  'pPLFGM': '倉庫名稱：',
  'pPxUIG': '請勾選訂單',
  'per6Wc': '扣費時間',
  'pfdzsY': '預設選擇最早的提貨時間',
  'pmnxx5': '國內倉扣貨',
  'pwc6NQ': '新增偏好',
  'pxcOgS': '請點擊下載<url>多SKU類型入庫箱單資訊範本</url>{break}（適用於已開通套裝/箱產品白名單或條碼值管理白名單的客戶）',
  'qALFFF': '列印箱單',
  'qCkP6I': '多個單號需換行',
  'qIXpnS': '未識別',
  'qLA8ku': '請勾選目的倉相同的訂單',
  'qO/UNZ': '時效',
  'qU/PvG': '路線',
  'qlYzaa': '立即下單',
  'qsBMLq': '子包裹號碼',
  'r9PIIM': '同一包裹仅支持添加1箱箱产品',
  's3X4br': '签收单号',
  's6jr9x': 'A包裹条码数',
  's9gMG0': '请点击上传文件',
  'sC2Q9O': '启航时间',
  'sD68ps': '<title>温馨提示:</title>{break} <span>智能国内拆单PSC订单，提交后系统将按规则自动拆分成多张订单，下单后续如有变更，请在拆分后的子单中进行修改</span>',
  'sDg3+u': '下单重量(kg)',
  'sU6jlq': '库存单元数',
  'sZhuDU': '客户包裹条码',
  'snyKle': '请点击下载<url>多SKU类型入库箱单信息模板</url>{break}（适用于已开通套装/箱产品白名单或条码值管理白名单/批次管理白名单/万邑联免自验白名单的客户）',
  'sziYw4': '批量维护包裹条码',
  'tGh90c': '必须大于0，小于等于{maxMoney}，最多保留2位小数',
  'tZ+xcf': '处理时间',
  'tZE20T': '下单数量',
  'txh7Ok': '该下单方式暂不支持此类商品入库',
  'u0n0TG': '总体积(CBM)',
  'uEX5d+': 'Winit订单号',
  'uX7sD/': '入库日期',
  'uhRzgM': '包裹长*宽*高',
  'usAYZQ': '最多支持{num}个查询',
  'ux8iYZ': '异常照片',
  'v+ZpZ/': '商品数量（SKU）',
  'vNKRrK': '快捷下单导航',
  'vOJVtM': '暂确认发货',
  'vPrigA': '订单来源',
  'vY9yDh': '温馨提示：',
  'vkZ8aE': '箱单信息导入成功后即完成更新，请确认是否更新？',
  'vp+HUi': '个人下单偏好',
  'w00px3': '是否确认取消越库？',
  'whKaxL': '请输入识别码',
  'wk5u+s': '导入失败记录',
  'wyM+iH': '申报英文品名',
  'x+J841': '库存等级',
  'x3GvYe': '若使用该增值服务，则入库单入库后，将整单商品按不良品上架至不良品区。',
  'xNeD5U': '已取消',
  'xZo6jh': '验货完成',
  'xjO4wW': '调整',
  'yE+gNd': '验货类型',
  'yGaq41': '仅支持标签纸打印,单次打印不得超过{maxBatchPrint}个',
  'yM40CJ': '<span>如箱单信息变更，系统将对拆分结果进行重新计算</span>{break}<span>以下数据仅包含A与A+包裹</span>',
  'yPL67T': '预约码',
  'yQkOEi': 'Winit入库产品',
  'yufptr': '时效单位',
  'yvm8n2': '已上架',
  'yzEJ6Q': '新增包裹',
  'zE6N7L': '异常',
  'zEP9We': '如需打印条码 <a>点击此处</a> 进入订单详情。',
  'zEcTCR': '全部清空',
  'zGN0WZ': '批量导入起航时间',
  'zKkAh7': '国内仓发货数量',
  'zXfo9H': '订单的预计送仓方式是整柜/散货，请在送仓前进行预约 <url>点击前往预约送仓</url>',
  '+K2mxF': '查看綁定商品',
  '+as26z': '綁定商品',
  '/9BA4E': '若未填寫則以winit實際採集為準，請注意保質期商品的禁售天數',
  '/XXHj8': '備註：以上是透過移除單號同步的FNSKU訊息，請您先綁定Winit商品編碼。 ',
  '1a4I+M': '批次維護第三方包裹條碼',
  '216TEI': '地址：',
  '3/5ReX': '儲存並關閉',
  '5JPEEe': '取消勾選後將清空目前商品訊息，請確認是否取消勾選？ ',
  '7MMXPF': '暫時無法提供快遞單號，先確認出貨，貨物到倉前可提供。 ',
  '7zzDTz': '是否明確裝箱資訊',
  '8NvecW': '新增商品行',
  '8QanX6': '【是，待驗貨】：已確定裝箱信息，下單環節可直接錄入包裹和商品的綁定關係。 {break}【否，邊驗貨邊裝箱】：未確定裝箱信息，下單時僅填寫商品信息，驗貨時掃描並綁定商品與包裹的關係。 ',
  '9T27Yk': '預付費用總計: {allmoney} {currency}',
  '9vGfC2': '訂單資訊更改，預估費用發生變化，如有需要請至<url>訂單詳情</url>查看最新預估費用。 ',
  'CcQbSa': '未簽署{name},<url>請點選連結進行簽署</url>',
  'CqRSDm': '{warehouseName}{break}SI數量|分割比例%',
  'CwyC8y': '請先選擇{field}',
  'F3jPfS': '聯絡人：',
  'FGaAuD': '請輸入移除單號，支援多個換行輸入',
  'I0iNxa': '取得商品明細',
  'I1W1lj': '保存期限及生產批次管理的商品，若未填寫則以winit實際採集為準，請注意保質期商品的禁售天數',
  'IKtkLx': '聯絡電話：',
  'K3TeL/': '待處理',
  'N+5Ddk': '請輸入Amazon店舖帳號',
  'NHsSAb': '國：',
  'O5JvNY': '移除單號',
  'OtByF3': '開通了條碼值管理的商品，條碼值必填。 同一個包裹內，同一SKU類型同種庫存單元標準件數（若有）的商品，條碼值需相同',
  'POaD2E': '使用目前Winit產品,需要先簽訂清關協議,<url>簽訂方式請點擊連結查看</url>。 ',
  'PV1cTK': '請輸入數字且小數點後不超過三位',
  'PfOCPu': '採集快遞單號',
  'b6OX/n': '複製下單',
  'bLlEAh': '搜尋後顯示格式為：商品編碼-商品名稱-規格【SKU類型-庫存單元標準件數（若有）】',
  'bjURnX': '未啟用出庫加包裝服務',
  'dSHhYW': '報關資訊',
  'dXNw7m': 'Winit商品編碼',
  'ekm5RV': '信箱：',
  'fuj7WB': '批次匯入第三方包裹條碼',
  'g6XoUD': '針對整櫃訂單,貨物離港後請及時在萬邑聯維護訂單【起航時間】 否則將會影響訂單預約送倉!',
  'gECtkR': '操作地點',
  'hZIYSK': '費用總計:',
  'hdaFx9': '<url>如何填寫送倉方式？ </url> {break} 散貨：散裝/托盤等非整櫃的卡車派送，送倉前必須預約；{break}整櫃：國際運輸方式是整櫃才可選，送倉前必須預約； {break}快遞：無需預約',
  'iiRPff': '是否同步亞馬遜移除訂單',
  'kFZ6Sy': 'Winit承運：指國內倉截貨至海外倉上架的全程時效；{break}賣家直發：指貨物到海外倉後的上架時效',
  'l0+dWr': '第三方包裹條碼',
  'm0/5Lx': '批次上傳包裹',
  'mhM8WV': '勾選同步亞馬遜移除單將清空商品訊息，請確認是否勾選？ ',
  'rFRyfW': '支援維護第三方包裹條碼的訂單清單',
  'sFLVr4': '提交訂單後可查看',
  'ubfSYP': '批次上傳商品',
  'vWP3K2': '請點選下載<url>導入範本</url>',
  'vsSpHk': '新增下一個',
  'vtcir0': '<url>如何填寫國際運送方式？ </url>',
  'wY/k9X': '若未填寫則以winit實際採集為準',
  'xD3QFO': '費用資訊<span>（實際扣費金額與預估金額可能不一致，以實際扣費金額為準）</span>',
  'xMUB1N': 'Amazon店舖帳號',
  'y52KzK': '30天內不再提醒',
  'yvyrt3': '重新綁定商品',
  'zOwd77': '智能國內拆單PSC訂單，提交後系統將按規則自動拆分成多張訂單，下單後續如有變更，請在拆分後的子單中進行修改',
  'gjldFJ': '截取後快遞單號',
  'jgK8RF': '打印發貨憑證',
  'NpkuXN': '是否同步亞馬遜訂單',
  'TwvSPX': '來源',
  'x51qTM': '截取前快遞單號',
  'RGuxf+': '單次列印超過{maxNumber}張標籤條碼時，請前往匯出中心下載檔案',
  'mG/n2r': '使用當前Winit產品,需要先簽訂清關協議,簽訂操作文檔請<url>點擊連結</url>查看，前往提供清關代理協議請<url2>點擊連結</url2>。',
  'S14cUE': '用於包裹計數和標識，便於貼上對應包裹標籤，不支援掃描',
  'lD8xXw': '以實際到帳金額為準',
  'RJP6qH': '核實重量',
  'aRhAJi': '核實尺寸',
  'pE1TYn': '包裹尺寸',
  'xGK0dH': '海外倉收件訊息',
  'azlx3A': '海外倉收件資訊<span>請注意：請務必依照下述的【聯絡人】和【地址】資訊填寫出貨，否則將影響倉庫收貨處理。 感謝配合。 </span>',
  '6dK+q1': '列印提貨通知',
  'Gh7kDk': '國內倉收件訊息',
  '3yxbjy': '倉庫電話',
  '0nfqFU': '請輸入業務單號',
  'GwOy47': '工作日',
  'thQW+8': '自然日',
  '9n8bNu': '支付中',
  '8PS/Vj': '待入賬',
  '/jiyIp': '金額合計',
  '7NqucZ': '切換成【自定義】，系統將清空【標準】已選擇的配置，請確認是否切換？',
  '8YBttT': '{zone}已失效',
  'GXynBY': '切換成【標準】，系統將清空【自定義】已選擇的配置，請確認是否切換？',
  'MVnxEB': '查看倉組',
  'XrLeOk': '智能推薦下單是指系統根據客戶下單時買家地址、派送方式、海外倉庫存等信息,基於配置的發貨策略計算出最優發貨方案(發貨倉庫和派送方式的組合)後,自動按照最優方案發貨{break} 註： {break} - 如果訂單為組套訂單，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單來源為「平臺同步」並且電商平臺為「速賣通」或「TIkTok」，不支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果客戶下單時指定了批次商品，不支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單的收貨人類型為「FBA轉倉-VC訂單」或「FBA轉倉-非VC訂單」，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單包含不允許拆單的增值服務，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 預售訂單無在庫庫存不支持推薦倉庫和產品發貨{break}',
  't041qm': '產品不能超過 {recommendMaxProductCount} 個',
  'zn3DrJ': 'SKU不允許拆分到多個倉庫發貨',
  'znH959': '編輯倉組',
  '2Ydaow': '日期格式适用国家',
  'Amn7e1': '請輸入批次日期格式',
  'HPr7xm': '請提供商品上的日期格式，實物到倉後依據此格式進行採集核對商品日期',
  '2A0aBn': '進口申報價值',
  'Mg5eiu': '批次日期格式',
  'qB04Og': '上傳實物上的批次資訊示意圖',
  '/earsF': '費用合計_明細',
  'FVI3+2': '請選擇{fieldName}',
  'Ms1ITn': '價格',
  'VVcSSC': '分區價預估',
  'ruoc98': '分區',
  '1t+pdo': '條碼值(FNsku)',
  '9qb/fX': '勾選此服務後，將為您擷取包裹上的快遞單號，並在入庫單顯示快遞單號與包裹條碼的關聯關係。',
  'ACbtGO': '如果您選擇了提貨日期無法選擇到提貨時間段，請選擇其他日期，謝謝！',
  'BkIerX': '此入庫單提交後將無法再次編輯移除單和商品信息，請確認信息無誤後再提交，感謝配合！',
  'JWCoTB': '以下費用為預估費用，最終以實際收費為準。',
  'SYvcgF': '移除單一動作說明',
  'ZXB19i': '移除單號最多支援輸入10個',
  'o9M0aX': '如您未進行Amazon店舖帳號授權，請<url>點選連結</url>進行授權。 授權完成後需開啟自動同步移除單設置，請<url2>點選連結</url2>進行開啟。',
  'xXyarK': '快速註冊商品',
  'y7R4i8': '可用產品共 {a0} 條 不可用 {a1} 條 <a2>展開不可用的產品</a2>',
  'yVvA0A': '識別碼類型請選擇[入庫單號]即可，亞馬遜移除快遞單號後續將為您自動同步，無需再手動錄入。',
  'xHe3ea': '條碼值為透過亞馬遜移除單號同步的FNsku資訊。 請您填寫並綁定對應商品的Winit商品編碼。 如您尚未註冊商品，請先註冊商品後再進行綁定操作。',
  'Q1REvd': '<span>註：以下費用為預估費用，費用凍結時間為：國內驗貨倉驗貨完成/直發海外驗為已提交。 {break}</span> <span>帳戶可用餘額小於系統預估費用則無法提交訂單，煩請在下單前確保帳戶可用餘額充足。 </span>',
  'pKedas': '<strong>單品化管理：</strong>一物一碼。 販售的單一商品都只有全域唯一的一個單品條碼。 {break}<strong>商品化管理：</strong>一類一碼。 同一個SKU所有的單品都是相同的商品條碼。 {break}<strong>範例：</strong>{img}',
  'v1nBi8': '請輸入批次日期格式',
  'xR0TDl': '<strong>裸貨</strong>：沒有任何包裝的貨物。 {break} winit不支援裸貨出貨，裸貨請維護出庫包裝。 {break} <strong>銷售包裝</strong>：商品出廠時所附的包裝。 {break}商品為銷售包裝，且為高貨值，則不支援直接出庫，請維護出庫包裝。 {break} <strong>物流包裝</strong>：商品的包裝可支援出庫。 {break}商品為物流包裝，則支援直接出庫，可不維護出庫包裝。 {break} <strong>範例</strong>：{img}',
  '08FD55': '重開發票',
  '0mUTze': '+本期付款',
  '1Thrlh': 'Proof Of Delivery交付憑證，是指在貨物交付完成後，收貨方簽署的一份文件或記錄，用於證明貨物已經按時、完好地送達並且已經被簽收。',
  '2HVDUM': '賬單模板',
  '3I1qk6': '接收郵箱',
  '6W0m3g': '請勾選計費明細再提交',
  '73GscL': '下載賬單',
  '7gBBpn': '賬單模板設置',
  '7hsSLH': '=預估總剩余待還USD-已擔保金額USD',
  '9HN07h': '數據已為您導出,請前往【新報表管理】進行下載。如數據量較大，可能需要稍等一會。',
  '9TKbuS': '組合賬單',
  '9zz9ZO': '=上期余額+本期付款+本期收入-本期支出',
  'A6Op4y': '各幣種的剩余待還按實時匯率轉USD展示',
  'AZj+tf': '生成對賬單',
  'Agccw2': '溫馨提示{break} 1.支持自定義客戶名稱格式和自定義發票地址{break} 2.支持自定義付款賬號{break} 3.已生成的電子發票不支持再次更改客戶名稱、地址{break}',
  'BHp1I1': '=應還金額-已還金額',
  'CVEBvE': '賬單類型',
  'D61vFu': '客戶名稱格式',
  'D9OL3m': '指本期賬單的消費支出合計',
  'DNxAOh': '上期余額',
  'EuwSjA': '為保證計費明細數據完整，請您在賬單日上午9:00後再提交下載申請',
  'Fm/6zF': '下載計費明細',
  'GCMCkP': '-本期支出',
  'HgHOzH': '組合',
  'IZLNsL': '選擇計費明細',
  'JVXLNs': '正在生成{text}，請稍後再試',
  'JsuXOm': '獨立',
  'K2nEHB': '擔保還清',
  'KGWfZy': '當前賬期無{text}',
  'KZIm0Q': '下載發票',
  'LyL2IF': '下載成功後將會發送費用明細文件至您的郵箱，請準確錄入接收郵箱。',
  'MI4Snx': '賬單',
  'MLkOlx': '逾期天數',
  'MfytXC': '無欠款',
  'N2BWAQ': '是否分幣種開票',
  'NLMRo3': '請勾選文件類型之後再點擊確定',
  'O7Eu2j': 'example',
  'OQMV/1': '統計本期賬單日及之後的已還款金額，若本期賬單日及之後有付款、返利、重算退費等數據進來，該金額將持續更新，直至賬單實際還清後不再變動。',
  'PVWng2': '憑證文件',
  'Pg9Rpj': '=剩余待還',
  'Pm2h+6': '請選擇文件類型',
  'Q5w/fU': '應還金額',
  'Rxln8B': '正在生成文件，請稍後再試',
  'SNNgc9': '區間不大於31天，且不能選擇當天',
  'U2D3GT': '支持付款幣種',
  'UIxU1v': '海外倉賬單',
  'VDNJ1O': '-已還金額',
  'VqHQ0G': '預估總剩余待還金額(USD)',
  'W4h+L/': '前往下載',
  'XEpI/L': '未還清',
  'XQVNb1': '賬單區間',
  'biRBp6': '若您需定製賬單模板（收費服務），請聯系銷售或客服。',
  'cMgr3G': '開具電子發票',
  'dH6HXW': '有余額無欠款的賬戶給欠款賬戶擔保還款的金額',
  'dgSE4n': '導出賬單列表',
  'e8F20V': '選擇是，一個幣種一張發票；選擇否，所有幣種只開具一張發票',
  'fLrdaK': '獨立賬單',
  'gATNz6': '開具發票',
  'gCCsj6': '自定義賬單',
  'hT0UeC': '通用模板',
  'hzb2RD': '本期賬單應還款金額，=本期支出-本期收入+往期未還清金額',
  'iiJJ9Q': '下載憑證文件',
  'ilUGfb': '已擔保金額(USD)',
  'k6WL09': '設置接收郵箱',
  'kCUOZc': '預估最低待還(USD)',
  'kpqLgd': '請選擇計費明細(僅供參考, 實際以賬單為準)',
  'l217Ij': '請填寫正確的email',
  'l7612M': '計費明細',
  '3xw2pa': '=本期付款入賬金額（付款金額-付款手續費）+本期購匯轉入-本期購匯轉出',
  'pOpm5W': '歸檔日期獲取異常',
  'pRnE4N': '當前賬期無憑證文件',
  'qVilOl': '溫馨提示：請下載文件之後進行解壓處理才可正常打開',
  'qkVFdo': '+本期收入',
  'sJ4LRj': '定製模板',
  'sP9NPq': '=上期賬單的期末余額',
  'tbHHxh': 'ISP賬單',
  'tyeviX': '實際還清',
  'uM3JdF': '自提簽名文件',
  'v5/qhM': '賬單狀態',
  'vkMWl1': '下載對賬單',
  'vwIDLR': '發票地址',
  'wEsN/D': '，下個賬單日生效',
  'wkJVRb': '賬單日',
  'wngIz/': '請選擇海外倉賬單模板，更改後下個賬單日生效',
  'xFfCkV': '=期末余額',
  'xf4Cok': '由於計費明細數據較多，預計需要1～3小時完成下載。',
  'xjL8gr': '賬單模板已更改為',
  'xsgE1x': '指本期賬單的返利、商務折扣、重算退費等收入合計',
  'KRm37t': '擔保還清指拿無欠款的賬戶余額給欠款賬戶進行擔保還款，暫時避免賬單逾期',
  '/+6Tlk': '未退款',
  '/Ppy4h': '交易時間',
  '1976aM': '美付寶',
  '2Kxmmo': '轉入',
  '2zFaPz': '翼支付',
  '30EC+P': '申請時間',
  '3I0TSX': '提交證明',
  '4hcFAe': '已成功開出電子收據',
  '4zuYYE': '購匯匯率',
  '5+bLlU': '批量導出失敗',
  '5vhDlk': '付款主體用戶名',
  '6JSgZS': '購匯記錄',
  '6K/bMl': '易聯快捷支付-新',
  '8RMxkK': '解凍',
  '9h6CQ0': '確定進行此操作嗎?',
  'AmlBt7': '待入賬減少',
  'C0unZT': '付款方式',
  'CiDzns': '交易名稱',
  'DCknXQ': '易聯快捷支付-舊',
  'EFfAoQ': '易聯',
  'EH123B': '拉卡拉',
  'Ewl2Oe': '開具電子收據',
  'GCRkX0': '轉出賬戶名稱',
  'HRMFFC': '付款/匯款日期',
  'IYQMcP': '轉入賬戶ID',
  'IugZez': 'payoneer',
  'JZ/pPr': '失敗反饋',
  'JjMaCQ': '富友',
  'Maoscw': '線上付款單',
  'NSzPbt': '轉出',
  'OQovFR': '單據號碼',
  'Omkcu0': '已開收據',
  'OrfTjz': '付款日期',
  'P3OAHZ': '匯款日期',
  'PczLtN': 'WorldFirst',
  'UQsx/X': 'AIRWALLEX',
  'VCMN8h': '扣款',
  'VCcwE6': '轉出幣種',
  'VGUUOs': '退款狀態',
  'WjALRF': '更改付款人',
  'XWzXar': '轉出賬戶Id',
  'XkQfZs': '線下付款單',
  'bNGPYA': '是否凍結',
  'cA1Ws2': '轉入賬戶名稱',
  'cNbG7k': '下載電子收據',
  'eHCi/8': '入賬完成時間',
  'fFCfj0': '審核意見',
  'fmLMom': 'paypal',
  'gbprFA': '銀盈通',
  'gspCjo': '待入賬增加',
  'jrDkH0': '待入賬凍結',
  'n1BMn0': '購匯時間',
  'nTUBhV': '審核備註',
  'olossh': '授信額度',
  'qAYUi5': '轉入幣種',
  'sgoT1L': '系統授信',
  'tnA6LP': '全額退款',
  'v0uPwE': '還款方式',
  'vPm/tD': '待入賬解凍',
  'yEiEuN': '初始化',
  'zkp5Gj': '當前賬戶對應幣種的現金余額',
  'cOfpGZ': '金融賬戶線下付款',
  'sbK/du': '部分退款',
  'tBCWIa': '線下付款收款賬戶',
  '/LN0dz': '提交認證材料',
  '06ydEC': '工商/公安機關出具的更名材料',
  '0WyKK9': '授信額度詳情',
  '1Be2tl': '本次沒有重新分配額度！',
  '2XlYQy': '線上-payoneer',
  '2dR8L8': '固定額度長期調整',
  '3BpBXg': '添加付款人',
  '4usBT3': '幣種類型',
  '5A94rW': '頭程臨時額度詳情',
  '6YVRXw': '您提交的信息需要在銀行返回脫敏卡號的基礎上補充隱藏的部分，例如：6222****1314 ，填寫：622200001314，只需要真實的補充*號的部分即可 。',
  '6c9bAh': '支付渠道返回卡號',
  '6iq4+V': '付款人維護',
  '7J3yRf': '請將匿名信息補充完整',
  '7kLsHL': 'ISP自動購匯轉出幣種優先級',
  '82wYZO': '請輸入{min}~{max}的數。',
  '9sWKE8': '海外倉自動購匯轉出幣種優先級',
  '9xdXiy': '支持200個任意字符',
  'ARUtA1': '修改手續費',
  'B7sWL9': '授信手續費率(日)',
  'ByGlnw': '本人確認以上信息真實有效，並嚴格遵循《中華人民共和國反洗錢法》相關規定，同時同意該賬戶建立成功後，本人的歷史待入賬將轉移至此賬戶錢包，本人確認已經同意並知曉以上內容。',
  'C31gUe': '賬號組額度信息',
  'CaL1j5': '固定額度開通',
  'Dk/nSd': '客戶可用狀態',
  'DnvIjJ': '賬單還清後恢復',
  'EP3hY+': 'Winit賬戶',
  'FN2KJv': '臨時額度到期',
  'Gl93ta': '商業登記證',
  'GyK2ns': '入賬賬戶ID',
  'HTyEWD': '水單附件',
  'I5P0tH': '調整值(USD)',
  'JUra4d': '到期',
  'JnSTBq': '是否臨時額度',
  'K2AUa1': '總額度',
  'KYUIZR': '賬單還清',
  'LSMhE9': '逾期手續費率(日)',
  'LVcITT': '-已用額度',
  'MTRndr': '原訂單信息',
  'MXGoMs': '額度占比',
  'N+aVj3': '個性化設置',
  'P0+Vn4': '現有額度',
  'R/khAR': '證明材料類型',
  'SCtQJF': '延期還款',
  'SWt3dI': '臨時額度到期時間',
  'T8zx3Y': '登記付款人（英文）',
  'UH1oUV': '線下-轉賬支付',
  'UpsVgV': '額度幣種',
  'Uz5q4D': '總額度信息',
  'UzfgD8': '只顯示2018.03.22之後的額度變化信息',
  'VZcKf/': '開通',
  'WDhkia': '若當前主體未註冊子賬戶，請務必先前往註冊子賬戶，在子賬戶認證通過後，再提交關系證明！',
  'XNwxfY': '線上-paypal',
  'Xv6Zt3': '固定額度臨時調整到期',
  'XvglP0': '入賬賬戶名稱',
  'ZbuQhO': '系統自動恢復',
  'aCHUPv': '提交關系證明',
  'aKhgRz': '固定額度臨時調整',
  'ahpaj8': '賬戶組',
  'aoySH5': '賬單逾期末還暫停',
  'c+HGJC': '還款優先級',
  'c8pyCO': '額度生效時間',
  'cRkUwN': '賬單逾期未還',
  'e2EuFU': '支付渠道賬戶信息截圖',
  'exDDgb': '調整後復原',
  'f9UHPd': '完整姓名',
  'fP/5jz': '原付款記錄',
  'fhs4vd': '額度共享',
  'fxBfjX': '已簽署',
  'g0Ks/u': '重新分配後的子賬戶額度之和，已超出總額度，不允許提交！',
  'hh028b': '未簽署',
  'hjFT+i': '子賬戶簽署',
  'jryv+i': '停用',
  'ldrfDm': '固定額度到期',
  'mWrcQ+': '實際信息',
  'ms8jKv': '調整後臨時額度(USD)',
  'mx4b6E': '額度失效日期',
  'p6R2U5': '臨時額度生效時間',
  'pmdXFO': '登記付款人（中文）',
  'pxlLW/': '臨時額度開通',
  'qoUX1p': '固定額度長期調整到期',
  'sLaJS7': '支付渠道',
  'sxulyn': '重新分配額度',
  't9Zbku': '登記付款賬號',
  'vFLRB0': '子賬戶額度協議簽署狀態',
  'vePxOp': '正常',
  'vrGnEX': '匿名信息補齊驗證',
  'w6ND0+': '補充&驗證付款人信息',
  'wzdVDX': '審核時間',
  'x/gO31': '主子關系證明狀態',
  'xSPqpc': '您提交的信息需要在銀行返回脫敏名稱的基礎上補充隱藏的部分，例如：張* ，只能填寫：張字開頭，2個字的姓名，只需要真實的補充*號的部分即可 。',
  'xWutar': '是否可分配',
  'xqOuVQ': '自動購匯轉出幣種優先級',
  'yTqIuo': '額度到期時間',
  'yqSzWz': '額度生效日期',
  'zYHOkU': '完整卡號',
  'zcNWAZ': '實際付款人（中文）',
  'zmRPq1': '=剩余額度',
  '/KdHB0': '請選擇實際付款人（中文）',
  '07XnFn': '轉賬支付',
  '3YpJS6': '上傳材料',
  '4168zc': '海外倉凍結交易明細',
  '9Y//gQ': '已擔保還款金額生效時間',
  '9cS3L3': '導入只支持jpg，jpeg，png，pdf,文件大小小於5M',
  'BEAP5q': '請上傳材料！',
  'E8ZNSd': '額度自動調整',
  'F2CUgO': '線下',
  'GOarWl': '請輸入完整姓名',
  'K6sGHx': '渠道',
  'MJttIP': '主',
  'OrTfWA': '線上',
  'UKRYgR': '文件大小需小於5M',
  'VPky+K': '無額度',
  'XA24ZP': '額度人工調整',
  'ZT1qr1': '溫馨提示{break} 1. 如需查詢和導出12個月以前的歷史數據，請聯系在線客服。',
  'ZWTiom': '海外倉額度',
  'Zr9Dss': '失敗',
  'b2xoKS': '賬戶Id',
  'bE8OQ2': '重新分配後，留給主賬戶的額度不能小於主賬戶的已用額度！',
  'kqFivl': '已擔保還款金額詳情',
  'lDtEGy': 'Payoneer',
  'lcVvbr': '請輸入完整卡號',
  'nzAb/p': '基礎額度',
  'osNaFE': '富友快捷支付',
  'r/V4bn': '主體一致的證明材料最大上傳五個文件，證件照片需清晰、完整、無反光',
  'sfnAcf': '新增付款人',
  'y6RlMb': '易聯快捷支付',
  '0+2kI2': 'paypal、Airwallex、富友信用卡超過90天及線下轉賬渠道按照到賬金額退款，原付款手續費不退還；富友線上超過90天的退款、易聯線上超過350天的退款及線下轉賬退款，額外產生的退款手續費，按照實際發生的費用扣除，請以實際到賬金額為準；其他線上渠道則全額退還。',
  '32FSGv': '該筆金額將在',
  'JY6Tha': '（拖動可更改排序）',
  'g2OLbW': '待入賬退款手續費說明：',
  'tAmjwH': '備註：',
  '/pYzfM': '1. 系統會在每月的1號自動生成海外倉賬單，每周1自動生成ISP賬單。過此時間還未生成賬單，則請聯系客服。{break} 2. 如需下載2021.12.31以前的歷史賬單，請聯系在線客服。{break} 3. 只有2017.07.31以後生成的賬單系統才提供開具電子發票，並不再提供人工開發票。自定義賬單及2017.07.31以前的歷史賬單系統不支持開具電子發票，如需開發票請聯系萬邑通在線客服。{break} 4. 如需生成3個月以前的自定義賬單，請聯系在線客服。{break} 5. 2018-02-04升級後 「本期費用」 分為 「本期支出」 與 「本期收入」 。2018-02-04以前賬單的 「本期費用」 只在 「本期支出」 列顯示。{break} 6. 只有2023年6月之後生成的賬單才支持下載計費明細；只支持下載近6個月的計費明細，若需導出12個月以前的數據，請聯系在線客服。',
  'yI753E': '情況說明',
  'L3hqUI': '是否立即啟用該配置？',
  'T65PYY': '{text}已失效',
  'Yh7u3v': '智能推薦下單是指系統根據客戶下單時買家地址、派送方式、海外倉庫存等信息,基於配置的發貨策略計算出最優發貨方案(發貨倉庫和派送方式的組合)後,自動按照最優方案發貨{break} 註： {break} - 如果訂單為組套訂單，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單來源為「平臺同步」並且電商平臺為「速賣通」或「TIkTok」，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果客戶下單時指定了批次商品，不支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單的收貨人類型為「FBA轉倉-VC訂單」或「FBA轉倉-非VC訂單」，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單包含不允許拆單的增值服務，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 預售訂單無在庫庫存不支持推薦倉庫和產品發貨{break}',
  '3Y7klw': '錯誤訊息',
  'EP+LXH': '多個單號需換行或用英文逗號隔開，最多支援{num}個，雙擊切換到單一查詢',
  'aqlBZQ': '(送倉準備中：我司會依照服務時效安排送倉,請您耐心等待)',
  'z6C48a': '多個快遞單號需換行或用英文逗號或英文分號隔開',
  'vtc2Bz': '您未選擇產品組，請至少選擇一條記錄後再保存',
  'H3MIdb': '數據已為您導出,請前往【自定義賬單】進行下載。如數據量較大，可能需要稍等一會。',
  'bv8fp+': '批量導出交易明細',
  'yg+WfY': '暫無數據資料',
  'DeRAMA': '1. 只有2017.01.01以後付款成功的付款單系統才提供開具電子收據，並不再提供人工開收據。2017.01.01以前的歷史付款單系統不支持開具電子收據，如需開收據請聯系萬邑通銷售代表。{break} 2. 線下付款單通常需要1~3個工作日才會入賬。{break} 3. 由於監管要求，待入賬金額將在付款後的第12天自動發起退款並原路退回，請保證對應的賬戶有足夠的余額用於扣款，否則將影響下單！{break} 4. 待入賬退款手續費說明：paypal、Airwallex、富友信用卡超過90天及線下轉賬渠道按照到賬金額退款，原付款手續費不退還；富友線上超過90天的退款、易聯線上超過350天的退款及線下轉賬退款，額外產生的退款手續費，按照實際發生的費用扣除，請以實際到賬金額為準；其他線上渠道則全額退還。',
  'Rel6LS': '1. 如需查詢和導出12個月以前的歷史數據，請聯系在線客服。',
  'drKhD7': '1. 如需查詢和導出12個月以前的歷史數據，請聯系在線客服。{break} 2. 授信手續費、逾期手續費，幣種CNY/HKD的最小收費金額為0.1，幣種GBP/EUR/AUD/USD/CAD的最小收費金額為0.01。',
  'nVnqxu': '1. 可設置自動購匯轉出幣種的優先級，在自動購匯還款時若有多個幣種可用余額＞0，會按此順序自動購匯還其他幣種欠款。{break} 2. 轉入幣種的優先級，按欠款原幣金額從大到小順序，依次還款。{break} 3. 購匯時間，預付款賬戶，每天淩晨自動購匯；額度賬戶，賬單的最後還款日的每天淩晨自動購匯。{break} 4. 幣種CNY/HKD的最小轉出金額為0.1，幣種GBP/EUR/AUD/USD/CAD的最小轉出金額為0.01。',
  '8ScwNO': '如需查詢和導出12個月以前的歷史數據，請聯系在線客服。',
  'aRdrxL': '1. 付款時，如果支付渠道返回的付款主體用戶名與接受付款的萬邑通賬戶名稱不一致，該筆付款金額將暫緩入賬。{break} 2. 請您在12個自然日內，根據提示上傳相關材料，證明付款主體與接受付款的萬邑通賬戶是同一主體，逾期未證明的付款，將被原路退回。',
  'eocwkf': '請點擊文件上傳',
  '2BWMJO': '員工',
  '5gvduE': '企查查信息/公司年報 (掃描件/復印件/照片/截圖均可)',
  '7q44jI': '戶口本/結婚證 (掃描件/復印件/照片均可)',
  '7wqEOF': '當月',
  '8C681+': '我已閱讀完畢並同意',
  '9NStpL': '關系證明-朋友&非直系親屬 (雙方簽字證明)',
  'Dvsk2S': '關系證明-同一集團或實控人 (雙方敲公章)',
  'FTcmHB': '下月',
  'GKmXYb': '下周',
  'IDhXnO': '請勾選',
  'K6KFx2': '同意',
  'TRJ2m9': '屬於同一個集團或同一最終控製人',
  'bO/2Dn': '每周一',
  'iW2zML': '直系親屬 (配偶、父母、子女)',
  'ijzBKx': '每月1號和16號',
  'kEnOJX': '第三周',
  'ljo7wL': '每月1號',
  'lz37HI': '朋友或非直系親屬',
  'mb1NTL': '第四周',
  'qbyohT': '額度協議簽署',
  'tAGBJe': '社保證明/勞動合同 (掃描件/復印件/照片/截圖均可)',
  'vAuGZ8': '第二周',
  '/6gyil': '重置為默認值',
  '8TJtfD': '下載附件',
  'QxCYIy': '海外倉賬戶默認：USD → CNY → HKD → GBP → EUR → AUD → CAD順序購匯。 例如：USD、CNY可用余額＞0，自動購匯時會先用USD購匯還其他幣種欠款，若未還清會再用CNY購匯繼續還。',
  'WnGw42': '當前賬單無計費明細',
  'iyWSE7': '我已閱讀並同意',
  'n1Vx1f': '您提交的信息和銀行返回信息不一致，例如：張* 可以填寫：張三，不可以填寫：李四',
  'qEIdoZ': '《額度授予協議》',
  'v/il0E': '《擔保協議》',
  'KofsN/': '股東\\法人\\董事',
  'G85A7S': '1. 付款主體名稱與我司註冊名稱不一致時，將在第12天自動發起退款；為避免影響您下單，請使用相同主體名稱進行支付。{break} 2. 待入賬退款手續費說明{break} <a2>Paypal、Airwallex、富友信用卡超過90天及線下轉賬渠道按照到賬金額退款，原付款手續費不退還；其他線上渠道則全額退還。</a2> <a2>富友線上超過90天的退款、易聯線上超過350天的退款及線下轉賬退款，額外產生的退款手續費，按照實際發生的費用扣除，請以實際到賬金額為準。</a2> 3. 我司堅決執行《中華人民共和國反洗錢法》的相關規定，付款後如需退款，將由付款渠道原路徑退還。 對涉嫌洗錢、虛假交易等行為，我司有義務向相關部門舉報並協助公安機關提供證據。{break} 4. 點擊可查看收款說明 <a1>收款說明></a1>{break} 5. 如您的主賬戶主體無法付款，請直接變更主賬戶主體，無需註冊子賬戶。{break}',
  'nEoXwk': '1. 線下付款單通常需要1~3個工作日才會入賬。如急需使用付款金額，請用線上付款。{break} 2. 付款主體名稱與我司註冊名稱不一致時，將在第12天自動發起退款；為避免影響您下單，請使用相同主體名稱的賬號進行支付。{break} 3. 待入賬退款手續費說明：{break} <a2>Paypal、Airwallex、富友信用卡超過90天及線下轉賬渠道按照到賬金額退款，原付款手續費不退還；其他線上渠道則全額退還。</a2> <a2>富友線上超過90天的退款、易聯線上超過350天的退款及線下轉賬退款，額外產生的退款手續費，按照實際發生的費用扣除，請以實際到賬金額為準。</a2> 4. 點擊可查看收款說明 <a1>收款說明></a1>{break} 5. 如您的主賬戶主體無法付款，請直接變更主賬戶主體，無需註冊子賬戶。{break}',
  'v2HOxg': '1. 同錢包內，支持不同幣種相互轉換，不支持同幣種轉換。{break} 2. 不同錢包之間，支持任意幣種相互轉換。{break} 3. 幣種CNY/HKD的最小轉出金額為0.1，幣種GBP/EUR/AUD/USD/CAD的最小轉出金額為0.01。',
  'Rg50kB': 'ISP賬戶默認：CNY → HKD → USD → GBP → EUR → AUD → CAD順序購匯',
  'K/XBN5': '1.支持自定義客戶名稱格式和自定義發票地址{break} 2.支持自定義付款賬號{break} 3.已生成的電子發票不支持再次更改客戶名稱、地址{break}',
  'qZjKi5': '支持自定義客戶名稱格式、發票地址、付款賬號',
  '/HG2Ex': '添加SKU',
  '5qxgHV': '請勾選需要添加的商品',
  '8N9CHd': '策略優先順序：自定義策略>全域策略',
  '97Ezg6': '設定銷量參攷週期',
  '9jy52o': '策略類型',
  'EhpZRc': '【{name}】策略添加SKU',
  'EwSqIq': '失效後將自動清空策略內SKU，是否確認失效？',
  'G12/1D': '最多支持500個SKU編碼',
  'GsiqV5': '查看全部{num}個',
  'H2OXqK': '推薦設定：單一產品按近4周，套裝產品按近6周，箱產品按近8周。',
  'Hxs6Qn': '清單',
  'IUpc6p': '點擊前往',
  'JLuSaS': '新增自動拆零策略',
  'K5qzOu': '全域策略',
  'LS1Plr': '共亯庫存自動拆零策略',
  'LU1GKG': 'SKU的關聯策略倉庫與當前策略倉庫有重疊，不支持添加',
  'MHg1rP': '編輯成功',
  'MWfQTj': '全域策略不能失效',
  'MjhYfS': '策略已失效，不支持添加SKU',
  'Mxj3rv': '選擇近X周的周均銷量',
  'NxN2H3': '新增策略',
  'PGRHGF': '移除成功',
  'PMcYxK': '策略內SKU',
  'VJaooL': '設定共亯庫存自動拆零策略',
  'We/I3N': '未添加SKU',
  'Wf1RuS': '是否確認生效？',
  'X/lLj9': '關聯策略',
  'cjZbLG': '在推薦設定的場景下，假設單一產品近4周的周均銷量為100件/周，套裝產品的近6周的周均銷量為5套/周，箱產品的近8周的周均銷量為2箱/周； 則每週單一產品的可用庫存低於100件且套裝產品的可用庫存大於5套或者箱產品可用庫存大於2箱時，將自動觸發套裝產品或箱產品拆零，保證接下來一周單一產品的可用庫存至少有100件。',
  'cz1Je0': '請輸入中文、字母或數位',
  'd9QEcp': '適用倉庫',
  'e6JvoK': '策略名稱',
  'fMbkSR': '存在未完成入庫單或庫存，不允許切換共亯庫存！',
  'lYOl5J': '【{name}】策略內SKU',
  'lfSY4h': '失效成功',
  'nel6io': '此策略是為了避免因單一產品不足在出庫環節進行拆箱導致影響訂單的出庫時效，Winit會基於自動拆零的策略進行提前調整庫存！',
  'nxeBGd': '示例：',
  'pfdh/O': '添加成功',
  'sIBroV': '編輯自動拆零策略',
  'u9m/ZU': '說明：針對標準出庫單以及自提出庫單數據進行統計對應SKU在海外倉的銷量【排除調撥、銷毀等异常出庫數據】',
  'vzfWmX': '生效成功',
  'wx/TF7': '是否確認失效？',
  'ySdsnX': '請勾選需要移除的商品',
  'zqbS5z': '是否有效',
  '2gRKLj': '此帳號當前未配寘共亯庫存自動拆零全域策略，為了不影響後續訂單出庫時效，在注册共亯庫存的箱產品或套裝產品時，需要先配寘共亯庫存自動拆零全域策略！{a}配置',
  '4heyxi': '您未簽署{name}，驗貨類型無法選擇客戶自驗貨，請<url>點擊連結</url>進行簽署！',
  'dnCZn1': '您未簽署{name}，頭程類型無法選擇賣家直發，請<url>點擊連結</url>進行簽署！',
  'BDNpYQ': '否，邊驗貨邊裝箱（驗貨方式：新自驗）',
  'ROVd94': '是，待驗貨（驗貨方式：舊自驗）',
  'TImPz+': '【是，待驗貨（驗貨方式：舊自驗）】：已確定裝箱信息，下單環節可直接錄入包裹和商品的綁定關係。 {break}【否，邊驗貨邊裝箱（驗貨方式：新自驗）】：未確定裝箱信息，下單時僅填寫商品信息，驗貨時掃描並綁定商品與包裹的關係。',
  'MB2LgI': '請先選擇地址!',
  'VuUe2t': '請選擇ISP賬單模板，更改後下個賬單日生效',
  'fijT/3': '單一產品A+包裹或箱產品的長寬高可不填寫，系統將預設使用對應商品的核實尺寸或註冊尺寸；如果填寫了長寬高，則系統將以填寫的資訊為準。單一產品A/B/C包裹的長寬高資訊則為必填項。',
  '+ON0XV': '體積',
  '2ud0Ps': '注册體積{unit}',
  '3Sf2xZ': '删除規格後，使用該商品時直接輸入商品編碼，無需輸入規格，確認删除該商品規格？',
  '8nvAOf': '僅限已發佈有規格的商品，才能批量删除規格',
  'LI0QcI': '核實體積{unit}',
  'Mit5WO': '僅限已發佈的商品，才能失效',
  'ZjVhvB': '進口關稅率',
  'aiBGBs': '删除成功',
  'bgMh+d': '删除規格後，使用這些商品時直接輸入商品編碼，無需輸入規格，確認删除這些商品規格嗎？',
  'fyQGOQ': '批量删除規格',
  'lZO/p4': '商品【{code}】存在待稽核的資訊，暫不允許失效！',
  'qgAEcy': '商品【{code}】存在的草稿或稽核退回的資訊會同步删除，是否確認失效？',
  'y/WY+Q': '删除規格',
  '0/JiLr': '取消原因',
  '0IvHRh': '業務單據號',
  '4Mjvd8': '批次號',
  '4eHs8/': '查看批次信息',
  '4uRbsZ': '批次日期',
  '7uzUWe': '增值服務信息',
  '8L1Vo2': '長（CM）',
  '96Mzoq': '已完成',
  'AmjYIb': '部分完成/退回原因',
  'DUdram': '軌跡信息',
  'E+q8Ix': '費用金額',
  'E64+fz': '服務要求',
  'LRFh5P': '貨物信息',
  'U17oU+': '軌跡',
  'fRZHbx': '寬（CM）',
  'foMY4M': '增值單號',
  'l0mW6t': '最新更新時間',
  'myoSWy': '體積（CBM）',
  'n0ENBy': '取消成功',
  'rv/Usx': '增值服務名稱',
  'sp7nZt': '高（CM）',
  't223jZ': '完成時間',
  'tBRn1O': '增值服務編碼',
  'uV7dt+': '服務時效',
  've8HCy': '重量（KG）',
  'z0iqAA': '增值產品',

  '0G9X0v': '待提货商品数量',
  '0hxzxw': '查看异常图片',
  '1I0n5S': '新商品规格',
  '1sIR79': '提货凭证',
  '356QM5': '查看增值明细',
  '4MHR84': '新单品条码',
  '5FbBko': '异常对象',
  '67aNgO': '新包裹条码',
  '7je90N': '新商品编码',
  '85WD1d': '新商品库存单元标准件数',
  '92ekDt': '增值结果',
  'En+SYV': '异常终止',
  'Fp8Tez': '处理中',
  'GBUVRa': '新商品SKU类型',
  'GuCNNs': '实际包装材料',
  'HUsRbx': '容器信息',
  'JTcOXu': 'X/Y，X表示下发增值单数量，Y表示实际完成数量',
  'K7fvln': '新第三方商品条码',
  'KB9hTa': '新第三方包裹条码',
  'LltneG': '新第三方单品条码',
  'Pnfg9a': '更换商品包装数量',
  'QaDES9': '新入库单号',
  'QbqTeH': '上架方式',
  'QoasKf': '库存标准件数',
  'RjHfgY': '提货商品数量',
  'SS6m7z': '待自提',
  'YlP2qM': '取消时间',
  'b0ZfpV': '全部订单',
  'd/Js41': '新商品条码',
  'hdZRSS': '商品辨识数量',
  'iGo2n+': '贴标数量',
  'lGy6FF': '取消失败原因',
  'pHN8Vk': '销毁包裹数量',
  'sNXLd2': '第三方单品条码',
  'IqSvUm': '預計完成時間（當地）',
  'RsyScM': '取消中',
  '/lOLnU': '配套電池或純電池',
  '08x8yY': '品類',
  '3LDpVN': '確認放弃更新這些商品資訊嗎？',
  '6a7FnP': '放弃更新',
  '8qMa5b': '確認放弃更新這個商品資訊嗎？',
  '9N69Wd': 'UK',
  'KY1hUt': '，如對稽核結果有疑問，請備註說明後重新提交！',
  'S+maKB': 'DE',
  'TKMdbN': '商品品類所需證書資料類型參攷如下，具體以稽核結果為准：',
  'c+Tzsj': '化妝品',
  'czdURM': 'US&AU',
  'gJpxi9': 'ALL',
  'inZ2fY': 'US',
  'jSrT6A': '化工品',
  'qlcOmV': '批量放弃更新',
  'vzV/vh': '德國交流電產品',
  '3ShLsH': '1.工廠出具的MSDS+運輸鑒定報告； 或檢測公司出具的MSDS、產品標籤圖片',
  'C2Lc0y': '1.工廠出具的MSDS+運輸鑒定報告； 或檢測公司出具的MSDS； 2.CPNP注册+產品標籤圖片',
  'Hc/VCq': 'FDA注册資訊、產品標籤圖片',
  'UBGvU5': '檢測公司出具的MSDS、產品標籤圖片',
  'YYUhWG': 'EMC測試報告、LVD測試報告、ROHS測試報告、德語說明書、產品標籤圖片',
  'bIygCY': '1.工廠出具的MSDS+運輸鑒定報告； 或檢測公司出具的MSDS； 2.SCPN注册+產品標籤圖片',
  'qxXnHH': 'MSDS、UN38.3測試報告、產品標籤圖片',
  '5WtgqL': '實際散箱數',
  '77ijwJ': '實際托盤數',
  'ge0k/G': '是否全部打托',
  '8glgCt': '該winit入庫產品不需要{field}，已預設清空原報關方式。 ',
  'SnK9qH': '進口報關',
  'WEOLvF': '出口報關',
  'fKCBMw': '進口/出口報關',
  '6SHbN1': '進出口商類型',
  'QBmXie': '<bold>致使用Winit澳洲倉庫商家的重要通知</bold>{break}{break} 1.這是一則致貨至Winit澳洲的雪梨和墨爾本倉庫商家的重要通知和更新。如果您不了解或不遵守澳洲貿易和海關法律，可能會導致您的商品被澳洲邊境部隊（ABF）官員扣押，您有責任支付相關的關稅和商品服務稅（GST），並可能受到經濟處罰。點擊「確認」即表示您已經閱讀並了解此通知，並將確保遵守澳洲貿易和海關法律。 {break} {break}<bold>商家的責任</bold>{break} 2.根據Winit的供應鏈管理服務協議（服務協議）和用戶手冊的規定，在將商品進口到澳洲時，商家有責任：{break} (a) 準確填寫並提交相關的進口申報或自我評估清關申報（進口文件）；{break} (b) 在進口文件中申報商品的真實和正確價值；以及{break} (c)支付與商品相關的澳洲關稅和稅金。 {break} {break}<bold>商家低估進口文件中的商品價值</bold>{break} 3.Winit了解到，ABF正在調查並採取行動，以處理商家在報關單中低估進口到澳洲的商品價值，並因此導致適用關稅和GST被低估或逃稅的行為（逃避關稅和稅收行為）。 {break} 4.ABF已發現部分商家利用電商履行中心（例如Winit在澳洲的倉庫）進行逃避關稅和稅務行為，尤其是商家使用自我評估清關申報（Self-Assessed Clearance Declaration）來申報價值低於1000澳元的商品的情況。 ABF正在積極監控商家發送到Winit澳洲倉庫的商品，以發現逃避關稅和稅務行為。 {break} 5.逃避關稅和稅務行為是違法的，可能導致以下後果：{break} (a) 商品在澳洲邊境被ABF扣押；{break} (b) 商家未來進口的商品在澳洲邊境被ABF扣留；以及{break} (c) ABF就任何未付或少付的關稅和GST向您發出要求或採取其他措施，您可能需要承擔經濟處罰。 {break} 6.如果ABF告知Winit商家參與了逃避關稅和稅務行為，Winit可能會拒絕接收該商家的貨物，並可能關閉商家的帳戶。 {break} {break}<bold>文件保存</bold>{break} 7.根據澳洲貿易和海關法，任何向澳洲進口商品的人都必須在進口後五年內保留其所持有的與進口商品或其運往澳洲的貨物有關的所有商業文件副本。 ABF可以要求出示這些文件，如果不遵守ABF的要求，可能會被處以罰款。 {break} 8.保留的商業文件必須包括證明進口貨物價值和進口文件中申報內容的文件。 {break} 9.為了協助遵守澳洲貿易和海關法，大多數進口商使用掃描和電子儲存商業文件的系統，並為進口到澳洲的每件物品保存一個特定文件。 {break} {break}<bold>聘請持牌報關行</bold>{break} 10.根據Winit服務協議和使用手冊的規定，Winit不負責貨物在澳洲的清關。商家在將貨物進口到澳洲時，應聘請持牌報關行協助，以確保商家遵守澳洲貿易和海關法律。澳洲持牌報關行的清單可在此找到：https://www.abf.gov.au/licensing/brokers/brokerages。 {break} 11.根據Winit服務協議和使用手冊的規定，Winit不是，也不得在任何進口文件中被列為「進口商」或「收貨人」。持牌報關行可以幫助商家準確填寫進口文件。如果進口文件沒有準確和正確填寫，可能會導致上文第5段所述的後果。 ',
  'kkSJOW': '海外本地清關：出庫單加值清關用途 ;頭程清關：入庫單頭程清關用途',
  'CXgGuD': '進口國家/地區【{country}】存在待稽核的數據，不支持更新出口國！',
  'YDqiDF': '出口國家/地區為美國時，進口國家/地區僅允許選擇美國！',
  'U76H/p': '商品編輯，進口國家/地區不允許選擇美國！',
  'l98JzC': '不同意',
  'q/ghwH': '知悉並確認',
  'dbqk8C': '系統通知',
  '4vbg3w': '商品注册失敗',
  'TrLI6T': '禁止入庫原因 :',
  'c8JvVZ': '限直發原因 :',
  'cwEnUp': '退回原因 :',
  'sEWD9z': '商品提交失敗',
  'NzT9mX': '提交失敗',
  '+DQSwD': '單一訂單出庫包裝方式',
  '+Dyoci': '應暫存完成時間（當地）',
  '+Ex1Ub': '上傳訂單',
  '+MCCzw': '啟動退貨',
  '+d+5RN': '上傳商品標籤--UPC',
  '+nHJ/w': '節省費用',
  '+sAXDI': '帳戶組餘額',
  '/2tze7': '您目前填寫的資訊未儲存，切換到其他的出庫類型系統將清空您已輸入的信息，請確認是否切換？ ',
  '/Cq3eP': '平台訂單號碼',
  '/b6CMw': '點此上傳',
  '/dU+JR': '準時',
  '02l0Ae': '1.僅支援需要補充增值的標準出庫訂單;{break} 2.目前頁面批次下單的訂單不支援智慧推薦；{break} 3.上傳的訂單的倉庫必須相同，若存在不同出庫倉庫的訂單請您分成多次提交；{break} 4.請先上傳批次範本檔案（一次不允許超過200個單），再提交加值服務，全部上傳成功後再點選確認。 {break}',
  '0OkKZE': '出完全部庫存',
  '0SA8N+': '指定裝箱僅支援單一產品、套裝產品的A類包裹。即1個包裹限制只能裝1種SKU',
  '0fFyLn': 'PickUp-三方面單',
  '1+N/2B': '上傳標籤檔案對應關係',
  '1/ktAg': '上傳BOL',
  '15E/3/': '本次總共選擇{total}單，列印成功{successCount}單，列印失敗{failedCount}單。 ',
  '1ECAGD': '匯入只支援PDF格式檔案',
  '1ES4Cj': '折扣',
  '1IlqrQ': '預設打托標準',
  '1ZZ4wT': '派送失敗',
  '1dw1ka': '上傳包裹標籤',
  '1mMngo': '將在庫SKU更換為其他SKU，可透過此服務將原SKU庫存進行扣減',
  '2AuwQx': '出庫單號',
  '2EGeQe': '該訂單號碼允許重複',
  '2Lpdn9': '如果是三方單 {a}',
  '2RLkKp': '<fw500>範本更新</fw500>: 支援在所有Sheet頁面縱向填寫SKU資訊',
  '2zxhhz': '退貨手工銷毀',
  '3I/ms8': '地址正確',
  '3fzzUW': '提供自提出庫服務，自提訂單提交成功後可在指定時間預約到倉提貨。 ',
  '3zOUmJ': '子訂單資訊',
  '4/kwLe': '批量作廢',
  '40CuD+': '上傳人',
  '434sTE': '查看標準說明',
  '47Gtdd': '範例圖片',
  '4Jxo1m': '<fw600>填寫tips</fw600>: {break} 1.如果同一訂單有多個SKU，請填寫多行SKU信息，並在對應的列【客戶訂單號】中填寫相同客戶訂單號，且SKU資訊對應的訂單資訊需保持一致{break} 2.不可在#Sheet1 和#Sheet2 中同時填寫SKU信息，如果您的SKU較少，建議在#Sheet1 中填寫SKU信息{break} 3.如果您的SKU較多，建議您在#Sheet2 中填寫SKU信息，SKU信息裡面需填寫對應的訂單所在的行號{break} 4.使用《標準出庫-平台專用模板》時，若平台為“ ebay”，則商品資訊*必填Item ID和*Transaction ID、*Platform Seller ID{break} 5.請上傳XLSX格式模板, 最多可導入5W條數據，文件大小上限5M，如文件過大，請拆分成多個檔案批次上傳{break}',
  '4NtVJg': '溫馨提示，再次下單不會附帶原單的加值服務，如需加值服務請在新單重新勾選。 ',
  '4SHLfn': '批次匯入任務號碼',
  '4w2WuG': 'WINIT追蹤號碼',
  '50IN3Z': '需下載範本文件，填寫商品編碼與第三方編碼的關係。 ',
  '50OvR9': '需下載範本文件，填寫各個包裹的標籤資訊。 (生成檔如上例)',
  '5GSF64': '系統只提供時間週期為 {maxDates} 天的資料導出',
  '5S5tsO': '檔案大小限制5M以內',
  '5gxemz': '提供第三方面單出庫，自提訂單提交成功後可在指定時間預約到倉提貨。 ',
  '5t/r6A': '應出庫日期(當地)',
  '5xs1cX': '商品編碼個數超出最大限制{num}，請調整',
  '62zELz': '請選擇出庫類型',
  '65FwA5': '退貨資訊',
  '66A+Ni': '子單出庫倉庫',
  '6IbkK3': '點選下載範本',
  '6LYgjW': '請勾選左側的加值服務～',
  '6aJQnL': '操作方式',
  '6hkcCU': '商品歐代標籤存在不同',
  '6vtXkE': '商品英代標籤存在不同',
  '773k6g': '原下單方案',
  '7B6nt3': '庫內加值服務',
  '7G93qx': '請上傳已填寫商品資料的XLSX格式範本',
  '7cPWC5': '作廢原因',
  '7jzaZI': '長寬高(cm)',
  '7lKqi+': '商品英代標籤全部相同',
  '7uCeyn': '您選擇的Winit產品不屬於Winit Guaranteed Delivery可選服務或無法在Winit Guaranteed Delivery指定時間內送達，是否繼續下單？ ',
  '8J8XY/': '分銷商',
  '8PVXv+': '平台訂單ID',
  '8VqvlV': '價格(原幣)',
  '8hMZxs': '物料領用',
  '8rR3Jg': '派送商名稱',
  '8rs/NL': '訂單已產生出庫單（批次號碼為 {taskNo}），點擊確認按鈕您將前往全部訂單單頁面查看您上傳的訂單。 ',
  '8wDxhI': '包材規格',
  '97k+rx': '新增一行',
  '9DFxej': '子訂單[{orderNo}]退貨超期未處理自動產生的訂單，不支援作廢。 ',
  '9ptMBm': 'WINIT包裹條碼',
  'AD6FxO': '標籤類型數',
  'Al/UXu': '根據您上傳的面單檔案識別不出來追蹤號，請確認上傳的檔案是否正確？ ',
  'B2Cv/r': '指定商品組托標準',
  'B5ATQM': '標籤檔案存在不同',
  'B5nx/K': '貼包裹標籤',
  'B6jIUx': '新增常用位址',
  'BHFoDf': '上傳多個檔案並提供和包裹對應關係',
  'BNXm17': '打包尺寸',
  'BlWytY': '請填入大於0的數，最多保留2位小數',
  'BlIeiJ': '視頻查詢',
  'Byb5tg': '上傳多個檔案並提供和標籤對應關係',
  'C09zE5': '派送狀態',
  'CMfUc1': '退貨單號',
  'CPoCuB': '平台資訊',
  'D0wNcl': '如以校驗失敗的地址下單，會導致妥投失敗，且DHL packet service服務會收取地址校驗費，建議下單前更正地址！ ',
  'D2yFUI': '平台商品ID',
  'D3cmbL': '下單倉庫',
  'D8w/qv': '查看平台資訊',
  'DJGKP5': '導入只支援XLSX格式檔',
  'DJqEEW': '請按以下說明選擇文件類型並上傳PDF文件：{break} 1.若訂單順序與包裹標籤順序一致，請選用【一份文件上傳包裹標籤】上傳一份多頁的包裹標籤文件，上傳檔案後Winit將依照模版表格行對應訂單順序和包裹標籤進行順序比對。 {break} 2.若訂單順序與包裹標籤順序不一致，請上傳多份包裹標籤檔案並上傳訂單與包裹標籤檔案相符關係。 {break}',
  'DLzlsg': '取消目前加值服務',
  'DXzi63': '容器號碼',
  'DYSv18': '下載裝箱明細',
  'Dnvmrb': '未依您的訂單資料符合至清關運送方式，請聯絡客服報障',
  'DrOmcS': '查看單品資訊',
  'Drd4Cm': '未指定組托標準的SKU將預設此標準打托',
  'DshrUk': '上傳英代訊息',
  'EIMaiD': '後台導入',
  'EenrW5': '訂單已產生草稿單（批次編號為 {taskNo}），點擊確認按鈕您將前往出庫全部訂單頁面查看您上傳的草稿單或提交草稿單。 ',
  'EnI5P6': '確定進行此操作嗎？ ',
  'EoGXO0': '庫存類型',
  'EzuXw/': 'Item ID',
  'FTlLKH': '批次商品下單設定',
  'FVDTCu': '上傳歐代訊息',
  'FVM5pZ': '以下時間取操作地點當地時區',
  'Frjn9M': '選擇其他產品',
  'G/EhYP': '推薦下單方案',
  'GB5SuZ': '總出庫數量必須等於平台出庫數量',
  'GRMbmN': '套',
  'GaK/Vr': '出庫時間(當地)',
  'GpT0/r': '分銷平台',
  'GstMVP': '批次匯入商品範本',
  'H2Ir0k': '貼上包裹需上傳各包裹標籤，上傳包裹後請您下載範本文件，並在文件中填寫各包裹對應的面單文件名稱！ ',
  'HHNWe8': '需下載範本文件，填寫商品編碼與歐代標籤的關係。 (生成檔如上例)',
  'HODeyW': '說明：投保金額即為保額，指針對特定聲明價值貨物投保的金額，如投保金額為100人民幣，則該貨物聲明價值即為100人民幣。 ',
  'HPuNoQ': '校驗結果',
  'HWAcVU': '第三方物流公司名稱',
  'HhXur8': '收貨資訊',
  'Hxrofw': '校驗國家、州/城市、郵編失敗,您可以<url>點擊這裡</url>進行查詢。 ',
  'I2h+Kv': '修改訂單資訊',
  'I5rvby': '如果是普通自提 {a}',
  'IUBOYb': '出庫打托服務',
  'IWDyfz': '批次上傳帶加值的出庫單',
  'IkoWrk': '您未選取商品，請選擇商品',
  'IlMZBb': '上傳面單',
  'IpEZ8l': '總計',
  'IshHqQ': '貼商品標籤',
  'IwvlMe': '預售狀態',
  'J/jch8': '請依下列說明選擇檔案類型並上傳PDF檔案：{break} 1.若所有訂單對應的ASN標籤一致，請上傳一頁一張的ASN標籤檔案並填寫ASN號碼。 {break} 2.若訂單對應的ASN標籤不一致，請上傳訂單與ASN標籤檔案相符關係並上傳標籤檔案。 {break}',
  'J0D5h+': '開始時間',
  'JEUHWo': '總價',
  'JIUNqP': '註冊公司名稱',
  'JMPE8r': '托盤',
  'JRKRJu': '下載裝箱明細模板',
  'JWp1+n': '取消此加值，系統將清空加值服務對應的服務需求和加值文件，請確認是否取消？ ',
  'JiY83H': '目前訂單的收貨人類型不允許超托時,不支援選擇允許超托',
  'KAnh4T': '匯入草稿訂單號碼',
  'KJGutH': '服務編碼',
  'KUggdg': '尺寸輸入規則：長=最長邊，寬=次長邊，高=最短邊',
  'KW8qOm': '選擇模板',
  'KvSBDO': '本次總共匯出 {total} 筆訂單，成功 {successCount} 個，失敗 {failedCount} 個，抓取中 {obtainingCount} 個。 ',
  'L2yN1f': '小貼士：以上費用為系統預估費用，最終收費按實際扣費為準；所有費用由用戶直接支付，不接受第三方代為付款',
  'LFVWAz': '點此下載《標準出庫-平台專用範本》',
  'LSjXDT': '子訂單號碼',
  'LWJl4z': '目前訂單的SKU預設了組托標準，倉庫將按照預設標準打托。 ',
  'LcEeSH': '合計（原幣）',
  'Lfctnu': '需下載範本文件，填寫商品編碼與英代標籤的關係。 ',
  'Lmn5aa': '注意：{break} 1.僅支援第三方面單直接出庫業務;{break} 2.請先上傳批次範本文件，再上傳第三方面單，全部上傳成功後再點選確認； {break} 3.上傳第三方面單時，需上傳檔案名稱和賣家訂單號碼的關係。 {break} 4.第三方面單僅支援上傳PDF格式檔案{break} 5.請上傳XLSX格式訂單範本；{break} 6.最多可匯入200個訂單，檔案大小上限5M，如檔案過大，請拆分成多個文件分批次上傳；{break}',
  'MZImmT': '第一個包裹標籤號碼',
  'MuoKTV': 'ASN標籤號',
  'N2QSRJ': '選取的訂單中存在【欄位驗證】為失敗的訂單，無法提交',
  'NDBcfT': '上傳成功(條)',
  'NF8SKF': '指定批次',
  'NKvk/k': '需要訂單狀態更新至」暫存完成「後，再進行文件資料的補充',
  'NRCc5i': '自訂配置我的增值',
  'Nde41V': '德國地址校驗',
  'NlQvfL': '修正前|修正後',
  'Nqqyky': '箱',
  'NwDD+7': '平台買家ID',
  'O2zmfw': 'Winit預計{time}送達',
  'O635R5': '追蹤號碼上傳狀態',
  'OOnFav': '公司地址',
  'OVPYND': '不通過',
  'OXLLOk': '出貨VAT',
  'OgVdYL': '12位以上（只能是數字或字母）',
  'OinASF': '新增出庫單',
  'OjkedZ': '共選擇{allNum}單{break} 驗證通過: {successNum} 單{break} 驗證不通過:<span> {failNum} </span>單{break} 不支援驗證: {noNum} 單{break}',
  'OmRJNz': '標準出庫-普通範本（匯入草稿訂單號碼）',
  'OtBOYx': '托盤尺寸要求',
  'OydMwQ': '查看商品組托標準',
  'PrLo66': '是否允許超托',
  'Q/v5qb': '【上傳標籤文件】請上傳單張可直接列印的標籤文件，避免將多個條碼放在同一個文件中。上傳的文件應為適合直接貼在單一商品/包裹上的標籤。 ',
  'Q4u6Eq': '收件人城市',
  'Q6JH65': '已作廢',
  'QG3yCE': '下載失敗訂單',
  'QPWEgx': '點擊此處下載《銷毀出庫-通用模板》',
  'QfncnO': '提供Winit海外倉自提服務，提交成功後可在指定時間到達Winit海外倉完成自提。 ',
  'Qqgk1C': '預計送達時間',
  'QuMfBo': '費用更優方案推薦',
  'RMTT8J': '請輸入庫內加值服務名稱',
  'RR2OQ+': '說明：投保金額即為保額，指針對特定聲明價值貨物投保的金額，如投保金額為100USD，則該貨物聲明價值即為100USD。 ',
  'RSe9dd': '最大可下單金額 取自可消費國家為發貨地所在國或為ALL的帳戶中最多的可用餘額，如有疑問請詢問客服。 ',
  'RfJMgc': '壞帳客戶商品自動銷毀',
  'RrGMSk': '前往草稿訂單',
  'Rrp9mD': '一、若貨物不屬於轉倉場景請選擇收貨人類型為「買家訂單」；{break} 二、轉倉貨物若屬於以下場景請選擇對應收貨人類型：{break}場景1、Amazon Seller Central帳號補貨至亞馬遜倉庫，請選擇「FBA轉倉-非VC訂單」{break} 場景2、Amazon Vendor Central帳號補貨至亞馬遜倉庫，請選擇」FBA轉倉-VC訂單“ {break} 情境3、不需要更換商品標籤且收貨人非Amazon倉庫，請選擇「轉第三方倉」。 {break}',
  'RyXQqJ': '上傳時間',
  'SOKtWI': '返利',
  'Sd/K3d': '自提出庫-第三方面單服務',
  'SmNURf': '如果您不需要這些加值服務,請取消勾選,取消後,在下單時系統將不會再向您推薦',
  'TE9fLA': '切換模板類型，系統將清空您已上傳的數據，清空後需要重新上傳，請確認是否切換？ ',
  'TNZK2r': '需線下增值',
  'TZSi0K': '根據您上傳的面單檔案辨識出來的追蹤號碼[{a0}]和您填寫的追蹤號碼[{a1}]不匹配，請確認上傳的檔案是否正確？ ',
  'TfqsbO': '德國地址校驗結果',
  'ThdPvz': '上傳托盤標籤',
  'Til6hA': '提供從Winit海外倉到買家手上的點到點的物流活動',
  'TthmIg': '出貨憑證一次只支援 {max} 個訂單，建議分批列印',
  'TwZVBu': '按下單日期當日匯率轉USD加總展示,由於匯率波動,金額也隨匯率動態變化',
  'TzYmJV': '請選擇Winit產品',
  'U/VC1c': '確認提交出庫單？ ',
  'U5Oz18': '訂單{orderNo}已印製成功',
  'UIunAN': '合計',
  'USh36q': '該出庫單尚未上傳追蹤號碼',
  'UV/rmz': '需下載範本文件，填寫商品編碼與UPC編碼的關係。 ',
  'UWp5me': '地址建議',
  'UhA9nk': '包裹標籤號碼',
  'Uz8jF0': '切換檔案類型，將清空已填寫訊息，您確認進行切換嗎？ ',
  'VECjAW': '取得檔案位址失敗！ ',
  'VSoODL': 'eBay+',
  'VVoTD/': '(共導入 {totalCount} 條，成功 {successCount} 條，失敗 {errorCount} 條)',
  'VgYd5U': '追蹤號碼與訂單關係範本',
  'VjGXk1': '上傳標籤編碼',
  'VtILvi': '推薦',
  'VwfsyG': '服務名稱',
  'W4m4yi': '總條目數',
  'W9/gSX': '下單指定批次',
  'WM1Y0D': '{0}僅支援大於{1}{2}，且小於等於{3}{2}的投保金額，最多保留2位小數，請重新輸入金額。 ',
  'WffqIr': '失效VAT凍結庫存自提',
  'WpEGiG': '已指派',
  'WpcKmi': '查看生成檔',
  'XCM1oC': '全部ASN標籤相同上傳一份檔案',
  'XOto+a': '帳戶餘額不足，當前餘額：{amountTotal}USD，訂單預估金額：{amount}USD，請付款後下單',
  'XRKL56': '如果是平台訂單 {a}',
  'XZL7fJ': '1. 僅支援上傳XLS、XLSX格式範本{break} 2. 每個文件最多支援上傳5000個商品,超出5000個請拆分成多個文件分批次上傳{break} 3. 文件大小上限5M,如果文件過大,請拆分成多個文件分批次上傳{break} 4. 導入的商品如果已存在,導入後將覆蓋原有商品的數量',
  'XaUufT': '最晚出庫時間',
  'Y7VuWC': '如果是非平台訂單 {a}',
  'YAhd/V': '最新軌跡',
  'YLFxSN': '商品數(總數/已完成)',
  'YML81t': '如果您這些倉庫有庫存的話，還可以節省 {span}',
  'YO3xxT': '總共導入 {num1} 筆,校驗成功 {num2} 筆,校驗失敗 {num3} 筆',
  'YSCxEM': '單一提交',
  'YTCWoO': '聯絡信箱',
  'YW7cc3': '收貨VAT',
  'YXI1uR': '您已經匯入過此文件，請確認是否需要重新匯入？ ',
  'Yb+UzV': '預計需等待 {predictTime} 秒，訂單校驗完成後可上填寫增值信息，請您稍後！ ',
  'YhQ2ey': '所屬sheet',
  'YmKEHX': '大量列印出貨憑證',
  'YpIZck': '總出庫數',
  'Yrb5u4': '指定日期出庫',
  'Z/p3Wh': '費用項',
  'Z6QOHS': '必大於0,小於等於可用庫存',
  'ZIfuAh': '上傳標籤',
  'Zf9p2v': '批量選擇商品',
  'ZxY3ke': '所選訂單若處於出庫確認，如取消成功，可能會收取訂單作廢費用；{break}所選訂單若處於揀選中或揀選完成，如取消成功，會收取訂單作廢費用和重新上架費用，作廢後無法撤銷，您是否確認作廢該訂單？ ',
  'a5CPqJ': '點擊此處下載《自提出庫-通用模板》',
  'a88xyg': '產品/服務',
  'aHUIrW': '收貨人類型即將更新，需要將您的加值服務文件全部清空。 ',
  'aQiOXp': '出貨倉庫',
  'acNis3': '手工下單',
  'aob7LP': '預計取件時間',
  'aq6K5m': '快遞單號/BOL',
  'aqYzZC': '查看上傳檔案',
  'ardfyD': '針對第三方面單出庫訂單，需要WINIT協助交貨給指定尾程服務商，可使用此範本。 {break} - 此範本可支援的加值服務僅限於：出庫加包裝。其他加值服務需線下提供加值服務單。 ',
  'as2D1h': '需下載範本文件，填寫商品編碼與FNSKU編碼的關係。 ',
  'bW1e0R': '請選擇商品',
  'beZa6n': '上傳商品標籤，需提供商品標籤以及商品編碼與上傳檔案的匹配關係，請您先下載匹配關係範本！ ',
  'bijCNG': '作廢訂單',
  'bs99RG': '收貨詳細地址',
  'bxPEv+': '需下載範本文件，填寫商品編碼與英代標籤的關係。 (生成檔如上例)',
  'byhnay': '商品組托標準',
  'cAZy20': '範本導入',
  'cgL+Sv': '包裹狀態',
  'cgj8zj': '訂單資訊即將更新，需要將您的加值服務文件全部清空。 ',
  'coQgJF': '收件人郵編',
  'crlcm2': '面單資訊',
  'cz74rV': '商品下架',
  'd3djw9': '最早出庫時間',
  'd7oELP': '上傳第三方面單',
  'dCjlw2': '準時派送',
  'dDAdR6': '需下載範本文件，填寫商品編碼與FNSKU編碼的關係。 (生成檔如上例)',
  'df0DoP': '服務狀態：<span>{serviceStatus}</span>{break}目標妥投時間:{targetDeliveredTime}{break}實際妥投時間:{actualDeliveredTime}{break}應出庫時間: {targetOutTime }{break}實際出庫時間: {actualOutTime}',
  'dsvRaJ': '需要暫存',
  'dzTL7Z': '複合訂單出庫包裝方式',
  'e/x7rA': '商品類型',
  'e/yYiE': '批次導出（新）', 'e4+j3h': '如果需要更多加值服務 {a}',
  'eCH8u3': '請選擇有效的日期範圍！ ',
  'eDbSh9': '擔保',
  'eQQPv4': '預估耗時(分鐘)',
  'fAPVId': '上傳失敗(條)',
  'fKxbAs': '作廢結果',
  'fPKUBh': '上傳ASN標籤',
  'fexDv7': '是否預售',
  'forWFG': '取得匯出檔案位址失敗！ ',
  'fsfYE2': '1.提貨倉庫地址和提貨時間將在訂單打包完成後提供,請留意主聯絡人郵箱或在訂單詳情頁面查詢;{break} 收到通知郵件後,憑出庫單號、提貨碼資訊到倉庫自提;{break} 美國地區訂單若是卡車公司提貨,建議賣家提前與卡車公司確認並在提貨前提供BOL文件給倉庫,若提貨人因倉庫無BOL拒絕提貨而產生的相關費用由賣家承接。 {break} 2.自提單需打包完成後才支援提貨,若因提貨人提前抵達倉庫導致放空由賣家承擔相關費用。 {break}',
  'fulsyY': '您更改了訂單內的商品，需要重新選擇增值，請確認是否需要更改?',
  'g+Qwn3': '費用明細',
  'gGL07o': '請輸入商品編碼, 多個商品請換行輸入, 最多支援輸入{num}個商品',
  'gM923M': '耗材',
  'gj4PmC': '不支持作廢',
  'gtaRBw': '選擇常用位址',
  'gw9jMp': '尺寸規格',
  'h+L5Oa': '標籤檔案全部相同',
  'hIYnem': '符合關係範本檔案',
  'hJmdHo': '允許同時操作的訂單最大數量為 {max}',
  'hQUDGa': 'IOSS No.',
  'hTuIlj': '總出庫數量必須大於指定批次出庫數量',
  'hjjUgn': '每次最多支援提交{maxNumber}單，您選擇了{number}單，請減少數量。 ',
  'hnxwdw': '派送完成',
  'iEYp1K': '一單多面單的追蹤號碼若為多個時請您填寫主追蹤號，上傳面單請提供pdf檔。 ',
  'iroH6Z': '出庫完成',
  'itTkxY': '點選下載範本檔',
  'j2CnJn': '打托標準等級名稱',
  'jC5cJ9': '請在安排提貨前先留意訂單狀態是否為打包完成狀態，如果不是請聯絡線上客服',
  'jKQAn/': '進出口商資訊',
  'jMku/A': '上傳匹配關係',
  'jOOJ20': 'wGD校驗',
  'jldSIC': '包裹標籤匹配關係範本檔案',
  'jq07Ch': '全部訂單數：{totalCount}; 已校驗訂單數：{checkNum}',
  'jv0mRc': '檔名重複，請重新選擇！ ',
  'k3HTaT': '組套關係編碼',
  'k6VOTr': '買家ID',
  'kHi2k4': '請輸入尾程加值服務名稱',
  'kXUpBC': '店舖ID',
  'kjhfZH': '退貨自動銷毀',
  'klH6bS': '包材編碼',
  'ktkm2G': '點此下載《標準出庫-通用模板》',
  'kugx4v': '輸入商品編碼，或雙擊選擇編碼新增商品',
  'kvwSlC': '平台交易號碼',
  'kw/r4N': '標準出庫-普通範本（支援多種加值服務）',
  'l+Ey3+': '以上費用為系統預估費用，最終收費依實際扣費為準。 ',
  'l/eBoQ': '銷毀/商品下架',
  'l9XE8F': '透過',
  'lWoH/C': '發生時間',
  'lYy9nF': '托盤碼',
  'lcs8Cl': '結束日期必須在開始日期之後！ ',
  'lnucNJ': '跟蹤號碼',
  'lyzr6E': '雙擊批次查詢',
  'm17b5x': '設為常用位址',
  'm3thhL': '服務過程',
  'm5sTom': '優惠價',
  'mPGkgC': '自提出庫-自提服務1.0',
  'mR+AbS': '模板檔',
  'my5+MV': '郵箱地址格式不對!',
  'n1fRuF': '子訂單',
  'n4Uj59': '平台店舖ID',
  'njGJyr': '電商平台資訊',
  'nnawzy': '原幣',
  'nz5vIk': '待確認',
  'o4DYG7': '長寬高（cm）',
  'oG8Hy3': '確認新增',
  'oH6SVx': '僅支援第三方物流自提,托盤出庫方式的自提需滿足最小下單體積0.96CBM{break} 請下單後提交"出庫增加/更改產品或單品標籤"增值服務,提供第三方物流公司面單(快遞面單/BOL等)資訊{break} 自提單完成增值後請在Day2 24:00之前完成提貨(增值完成當天為Day0),將從Day 3 開始收取滯倉費,滯倉費收費標準請見《加值與異常服務報價》{break}',
  'oHHxMC': '訂單[{orderNo}]退貨超期未處理自動產生的訂單，不支援作廢。 ',
  'oK0S4l': 'Transaction ID',
  'oXly2z': '簽署相關協議',
  'ouOOBA': '派送商',
  'ozL2c6': 'ASN標籤匹配關係範本檔案',
  'p37xrN': '商品歐代標籤全部相同',
  'p9SD4i': '銷售總額',
  'pBvQw4': '上傳商業發票',
  'pR+nKi': '一份文件上傳包裹標籤',
  'pafbPl': '上傳裝箱明細',
  'pam1F6': '上傳標籤檔',
  'ptBWFQ': '自動加包裝',
  'pw6nJB': '原價',
  'pzINE7': '出庫商品組套',
  'qC5Rts': '自提出庫-自提暫存服務',
  'qK21Mm': '正常下單',
  'qKXRjL': '常用位址',
  'qVEbQk': '批次匯入商品',
  'qXqspx': '組托標準名稱',
  'qeijb+': '上傳標籤與包裹的匹配關係',
  'qm8Kc8': '倉庫處理中',
  'qnPvi9': '批次導出（舊）',
  'qznrTS': '自提地址資訊',
  'r/YGTN': '增值文件',
  'r4ktet': 'ASN編碼',
  'rDmhRB': '超時',
  'rTOYrN': '點這裡,還能再為您節省: {span} >>>',
  'sGF/mQ': '合計(原幣)',
  'sIZFs0': '平台出庫數量必須等於總出庫數量',
  'sM4Kbb': '個人資訊',
  'sWzcHw': '訂單銷售總金額',
  'sb1vdX': '進行中',
  'svNhj4': '推薦方案派送時效',
  't3/i/R': '加值服務設定',
  't4OrzR': '商品',
  'tE8T0+': '目前產品因"{error}"原因不可用，請選擇其他產品或取消加值服務[{serviceName}]',
  'tRKFpY': '原方案派送時效',
  'thGDHR': '多個單號需換行或用英文逗號隔開,最多支援{num}個,雙擊切換到單一查詢',
  'tj9cGr': '計費產品',
  'tqI0pC': '打托標準等級',
  'tzzE+T': '請輸入正確資訊',
  'u96JkE': '我們為您提供了自訂偏好的增值服務設定功能，您可以根據自己的需求選擇不同的增值服務內容進行設定。完成偏好選項的設定後，請記得點擊「儲存」按鈕，以確保您的偏好設定生效。 ',
  'uAWnfm': '電商平台',
  'uYKziw': '包裹數(總數/已完成)',
  'uaFgSD': '日期範圍不能超過一個月！ ',
  'ucXEJT': '導出清單',
  'uh/9ZL': '下單產品',
  'ukQdI7': '下載失敗原因',
  'upDufj': '產品資訊',
  'v04auv': '結束時間',
  'vHQASu': '派送時效(天)',
  'vJKdss': '收貨人類型',
  'vKCjcc': '寄件者VAT Owner',
  'vMg/7N': 'API下單',
  'vY4wOI': '庫存單元{break}標準件數',
  'vtFAqc': '修改產品[{pscName}]時，系統顯示不支援已選取的加值服務[{vasName}]。修改後將清空選擇的加值服務，需要重新選擇。請確認是否修改？ ',
  'vvIwaz': '訂單號碼 {orderNo} 校驗不通過，原因：{msg}',
  'wQZP1z': '失敗訂單',
  'wQzRtS': '未分配',
  'wYm9QK': '商品明細',
  'weVvn9': '填寫平台資訊',
  'wehBYg': '跨國/跨區出貨時填寫，填寫金額會均攤到商品並產生發票',
  'wftiJ6': '最多可匯入5W條數據，檔案大小上限5M，如檔案過大，請拆分成多個檔案分批次上傳',
  'wurdpg': '文字說明',
  'x34SYE': '上傳提交',
  'xBSsPx': '在Winit海外倉當中的滯銷品進行銷毀處理，從而減少賣家庫存及倉儲費',
  'xKfDzT': '合計節省費用: {span}',
  'xNdC7g': '平台選擇錯誤將無法享受認證倉出貨的保護政策。例如實際上是eBay訂單，但未選擇“eBay”，eBay將無法識別訂單是認證倉發貨。 ',
  'xU66C0': '尾程加值服務',
  'xi9ohN': '出貨VAT Owner',
  'xt+0Wf': '容器類型',
  'xvn3Wk': '匯入訂單資訊',
  'y3Vt3x': '自提出庫上傳範本',
  'y6KQu/': '上傳追蹤號碼',
  'yMdx29': '需下載範本文件，填寫商品編碼與歐代標籤的關係。 ',
  'yPxAoX': '銷毀單在下單成功後的2個工作天,開始停止計倉租費用。 ',
  'yTQ3Wj': '確認大量列印選取訂單嗎？ ',
  'ya6vKV': '輸入編碼搜尋...',
  'ycrCub': '請填寫作廢原因',
  'ymeo/a': '{a}',
  'yt+3Z8': '托盤名稱',
  'z4OEaB': '收件人VAT Owner',
  'zY9LUW': '此功能支援使用者批次選擇加值服務並上傳標籤文件，如貼商品標或貼歐代標等。 ',
  'zdrSdM': '件',
  'ze81cw': '貼ASN標籤，需填寫ASN編碼以及上傳標籤檔。 ',
  'ztnKvN': '貼包裹標籤，需填寫包裹標籤號碼以及上傳標籤檔案。 ',
  '85cRES': '下單商品包含DG商品，為符合供應商要求，系統將自動創建【檢查並補貼DG標簽】的增值服務，並收取相應的增值服務費用，請下單後前往訂單詳情中查看增值服務及相關費用。',
  'EJp6Wx': '<fw600>填寫tips</fw600>: {break} 1.如果同一訂單有多個SKU，請填寫多行SKU信息，並在對應的列【客戶訂單號】中填寫相同客戶訂單號，且SKU信息對應的訂單信息需保持一致{break} 2.不可在#Sheet1 和#Sheet2 中同時填寫SKU信息，如果您的SKU較少，建議在#Sheet1 中填寫SKU信息{break} 3.如果您的SKU較多，建議您在#Sheet2 中填寫SKU信息，SKU信息裏面需填寫對應的訂單所在的行號{break} 4.請上傳XLSX格式模板, 最多可導入5W條數據，文件大小上限5M，如文件過大，請拆分成多個文件分批次上傳{break}',
  'IvZQuR': '請輸入商品編碼, 多個商品請換行輸入, 最多支持輸入{num}個商品, 雙擊切換到單個查詢',
  'ad/9Ry': '最大可下單金額',
  'tmQnHt': '由於選擇了增值服務【{vasName}】，尾程產品的收費金額已發生變化，請確認是否查看變化？',
  'bIB2Zm': '實際完成數量',
  'w17jPW': '下單包裝材料',
  '3xLqg9': '寬(cm)',
  'OlONZd': '高(cm)',
  'WGqv+Q': '長(cm)',
  '+mYTzz': '您切換後的產品【{prductName}】中針對您已選擇的增值服務【{vasName}】中只允許選擇其一，切換後系統將清空已選擇的增值服務和輸入的服務要求，請確認是否切換？',
  '0GUHhL': '請至少填寫一行包裹明細！',
  '0NMf6s': '創建增值單',
  '2AochY': '商品數',
  '3LM8lU': '請至少填寫一行商品明細！',
  '5MxYVI': '賬戶組總金額',
  '6KBoID': '是否清空？',
  '8rtKdf': '選擇訂單內所有商品',
  '9U9po2': '客戶指定商品SKU及數量，倉庫將商品外包裝及銷售包裝拆開，對商品裸貨及單品拍照，提供外箱條碼1張（拆包前拍照），商品條碼照片1張，商品實物照3~4張（商品全覽圖、商品細節圖等）;{break}備註：無論該商品數量多少，針對同一個包裹下的商品只會提供一組辨別照片。',
  '9j7Ejw': '上傳附件',
  '9sdcoI': '新建入庫增值訂單',
  'DjpAUg': '添加所有頁商品',
  'FqKI0m': '搜索後顯示格式為：商品編碼-商品名稱-規格【SKU類型-庫存單元標準件數(若有)】',
  'G0LOPQ': '查看圖片',
  'H4GzP7': '增值對象',
  'Iu8t4K': '服務時效(工作日)',
  'JZ3djF': '請先選擇下單倉庫',
  'KD95AN': '1. 僅支持上傳XLS、XLSX格式模板{break} 2. 每個文件最多支持上傳5000個商品,超出5000個請拆分成多個文件分批次上傳{break} 3. 文件大小上限5M,如果文件過大,請拆分成多個文件分批次上傳{break} 4. 導入的商品如果已存在,導入後將覆蓋原有商品的數量',
  'KtSFd3': '請選擇需要增值選項信息！',
  'N47jAg': '新建庫內增值訂單',
  'O8jTMP': '請輸入商品編碼,多個商品請換行輸入,最多支持輸入{num}個商品',
  'QcZ2zI': '勾選後將清空當前商品明細，自動帶出訂單內全部商品。',
  'QvJcOP': '增值產品信息',
  'RFAVvS': '客戶無需選擇具體的包材規格，倉庫會根據實際商品的尺重選擇合適的包材規格，具體請查看增值詳情結果。',
  'RNIttq': '勾選後將清空當前包裹明細，自動帶出訂單內全部包裹。',
  'UjkhyX': '您已添加單品信息，如果需要切換到不指定單品，系統將自動清空已添加的單品信息，請確認是否需要切換到不指定單品！客戶確認後，此按鈕切換到關閉狀態，系統同步清空商品列表已添加SKU',
  'Vsr+82': '文件上傳中...',
  'WrVyB2': '按照商品級維度選擇增值指客戶僅需選擇入庫單下具體的商品，無需導入包裹，系統自動關聯對應包裹。',
  'XM3VPI': '包裹明細',
  'Xy2gME': '異常明細',
  'YhoqBY': '是否指定單品',
  'YiuYrp': '按照包裹下的商品選擇增值',
  'b4xwkc': '添加當前頁選中商品',
  'etdYDz': '查看尺重測量商品明細',
  'fSD6JL': '新建增值訂單',
  'fmfcfE': '商品總數',
  'gbv1sQ': '導入結果：總共導入{totalCount}條，校驗成功{successCount}條，校驗失敗{errorCount}條',
  'hTBwMe': '標簽類型',
  'hh1Cwv': '是否指定批次',
  'iOKwId': '新建出庫增值訂單',
  'ieevJF': '您切換的產品【{prductName}】不支持您已選擇的增值服務【{vasName}】，切換後系統將清空已輸入的服務要求，請確認是否切換？',
  'kQ18bf': '查看辨識圖片',
  'kS86D/': '產品描述',
  'lV0eI9': '勾選選擇訂單內全部包裹，將自動帶出訂單的包裹明細（不包括已終止、已丟失、草稿、已卸貨、部分上架、已上架、上架到異常區的包裹）',
  'nc5Ajp': '請勾選你需要操作刪除的商品信息',
  'oLcSdY': '1. 僅支持上傳XLS、XLSX格式模板{break} 2. 每個文件最多支持上傳5000個商品，超出5000個請拆分成多個文件分批次上傳{break} 3. 文件大小上限5M，如果文件過大，請拆分成多個文件分批次上傳{break} 4. 導入的商品如果已存在，導入後將覆蓋原有商品的數量',
  'ofdSOM': '確定添加',
  'rtucPA': '勾選選擇訂單內全部商品，將自動帶出訂單的商品明細，其中商品數量不包括扣貨數量、丟失數量、終止數量、上架數量。',
  'sOnCAV': '您已添加商品信息，如果需要切換到指定單品，系統將自動清空已添加的商品信息，請確認是否需要切換到指定單品！客戶確認後，此按鈕切換到開啟狀態，系統同步清空商品列表已添加SKU',
  'stloSU': '清空',
  't0telM': '測量數量',
  'u/Qpw8': '按照商品級維度選擇增值',
  'wV4yyB': '請選擇需要下單的產品！',
  'xKfgtc': '請選擇需要下單的Winit產品！',
  '0hMVUW': '選擇訂單內全部商品',
  'qbGfXL': '選擇訂單內全部包裹',
  'HBVOSn': '增值選項選擇更換商品包裝時，必須選擇商品級-補貼原SKU條碼或者商品級-更換新SKU條碼',
  'vCj0xW': '增值選項選擇更換商品包裝時，必須選擇商品級-補貼原SKU條碼',
  'IFrTuT': '1. 僅支持上傳XLS、XLSX格式模板{break} 2. 每個文件最多支持上傳500個商品，超出500個請拆分成多個文件分批次上傳{break} 3. 文件大小上限5M，如果文件過大，請拆分成多個文件分批次上傳{break} 4. 商品列表按最新導入的商品信息覆蓋更新',
  'Rc/YFn': '測量單品數量',
  'bowBV5': '上傳標簽對應關系',
  'yIwIol': '產品說明',
  '/lVXii': '導入的文件格式不正確，請導入文件後綴為{accept}格式的文件',
  'F0UzrE': '請點擊【批量添加】按鈕導入單品碼',
  'o3sNed': '是否指定單品碼',
  'ajg6I7': '增值貨物發生變化，系統將清空已輸入增值選項對應的服務要求和增值文件，請確認是否修改？',
  '2JJnID': '增值對象發生變化，系統將清空已輸入增值選項對應的服務要求和增值文件，請確認是否修改？',
  'Fgj4rD': '您選擇的增值服務【{vasName}】只支持針對下單商品在庫隨機抽取一件進行尺重測量，您可以在【{vasName}】服務要求列點擊【查看尺重測量商品明細】查看測量商品明細',
  'BmD3S6': '側面',
  'wbIglz': '正面',
  'xHvzLQ': '背面',
  'cFgopv': '以上為圖例',
  '1sTzME': '注意:出庫確認(截單時間內下單訂單提交後2個工作日，截止時間後下單訂單提交後3個工作日)停止計費.',
  'DQ9abk': '托盤限高(cm)',
  'DXNP2o': '托盤限重(kg)',
  'HaLIN3': '最高碼托層數',
  'K741JW': '單層包裹數',
  'MBR1/w': '批次資訊',
  'U7gMvw': '後打單的服務(倉庫打包完成後再向供應商取得面單)，顯示實體貼的包裹條碼；前打單的服務，顯示的是系統虛擬的包裹號碼。 ',
  'ZDFgJ+': '預估|實際',
  'hBWthA': '您的商品在此倉庫已無庫存，請補貨後再下單或更換其他倉庫發貨',
  'j3jXuq': '可用餘額取自可消費國家為發貨地所在國或為ALL的帳戶中最多的可用餘額，如有疑問請詢問客服。 ',
  'l/kT2w': '下載亞馬遜裝箱清單',
  'm4c9L2': '組托標準-商品分類',
  'onH0MX': '下單商品包含DG商品，為符合供應商要求，系統將自動建立【{name}】的增值服務，並收取相應的增值服務費用，請下單後前往訂單詳情中查看增值服務及相關費用。 ',
  'yLU9ZT': '最新軌跡:',
  'uk/z4W': '您目前未簽署3.5版本的供應鏈管理協議，無法下入庫單，請<url>點擊連結</url>前往簽署再進行下單！ ',
  'SELVtF': '出庫數量大於可用庫存數，請修改',
  'eEpHfM': '組套',
  'LpECFr': '<fw600>填寫tips</fw600>: {break} 1.如果同一訂單有多個SKU，請填寫多行SKU信息，並在對應的列【賣家訂單號碼】中填寫相同賣家訂單號，且SKU資訊對應的訂單資訊需保持一致{break} 2.不可在#Sheet1 和#Sheet2 中同時填寫SKU信息，如果您的SKU較少，建議在#Sheet1 中填寫SKU信息{break} 3.如果您的SKU較多，建議您在#Sheet2 中填寫SKU信息，SKU信息裡面需填寫對應的賣家訂單號{break} 4.使用《標準出庫-平台專用模板》時，若平台為“ebay” ，則商品資訊*必填Item ID和*Transaction ID、*Platform Seller ID{break} 5.請上傳XLSX格式模板, 最多可導入5W條數據，文件大小上限5M，如文件過大，請拆分成多個檔案分批次上傳{break}',
  '11sq5D': '<fw600>填寫tips</fw600>: {break} 1.如果同一訂單有多個SKU，請填寫多行SKU信息，並在對應的列【賣家訂單號】中填寫相同賣家訂單號，且SKU資訊對應的訂單資訊需保持一致{break} 2.不可在#Sheet1 和#Sheet2 中同時填寫SKU信息，如果您的SKU較少，建議在#Sheet1 中填寫SKU信息{break} 3.如果您的SKU較多，建議您在#Sheet2 中填寫SKU信息，SKU信息裡面需填寫對應的賣家訂單號{break} 4.請上傳XLSX格式模板, 最多可導入5W條數據，文件大小上限5M，如檔案過大，請拆分成多個檔案分批次上傳{break}',
  'SJr/PB': 'eBay交易號',
  'XAs3Tz': 'eBay商品ID',
  'O5Xpbm': '增值處理中庫存詳情',
  'Ot1Uz8': '增值處理中',
  'KgnTRo': '快递面单',
  '0uVfj+': '批次日期[{batchDate}]產品批次號碼[{batchNo}]',
  'B10A4u': '商品編碼[{merchandiseCode}]規格[{specification}]對應的批次日期[{batchDate}]產品批次號[{batchNo}]不存在,請您修改後再下單。 ',
  'BOUAuk': '商品編碼[{merchandiseCode}]規格[{specification}]商品等級[{merchandiseGrade}]',
  'G/6Nal': '商品編碼[{merchandiseCode}]規格[{specification}]]條碼值[{barcodeValue}]不存在,請您修改後再下單。 ',
  'OOKwuL': '出貨數量',
  'hG1yrq': '只允許填寫<=可用庫存數量的正整數',
  'iBWZUW': '可用庫存不足,請您修改後再下單。 ',
  'mYXlzB': '條碼值[{barcodeValue}]',
  'K6oqA6': '如何新增出库单',
  'JbYw2T': '庫存不足,商品編碼為：[{merchandiseCode}],規格[{specification}],商品等級[{merchandiseGrade}]',
  'RLYGF8': '僅限更新退回商品，才能批量放弃更新',
  '/U1cNQ': '登入郵箱',
  '1axc5j': '帳號登入日誌',
  '3YYAIP': '登入時間',
  'yBaWS7': '入庫標簽特征',
  'bFBzZ6': '入庫標簽特征指您實際包裹的貼標特征，請您按照實際情況進行選擇！',
  'Ya9ARR': '請註意：在【海運整櫃100%A+包裹】場景下，<red>每個整櫃只能對應一個入庫單</red>。請勿創建多個入庫單或將一個入庫單的貨物分散放置在多個櫃子中。',
  'bZZ7HX': '入庫特殊業務場景',
  'ZkEwxh': '包裹類標簽文件(批量)',
  'k5tKw4': '托盤類標簽文件(批量)',
  'svkYiG': '上傳文件標簽對應關系',
  'vJHNAb': '商品類標簽文件(批量)',
  'yyCms8': '訂單類標簽文件(批量)',
  '+oGSwv': '校驗結果:被承運商驗證為"地址錯誤"',
  '2gCQ22': '地址準確度校驗',
  'MRrqU5': '您填寫的收貨地址被承運商驗證為“地址錯誤”，建議您修正地址後下單。 使用錯誤的地址下單可能導致包裹投遞失敗，同時產生地址檢驗/修正費用。 ',
  'XpGvSQ': '地址準確度校驗結果',
  'b5PSBI': '以下是建議地址, 請與收貨人確認後再參考使用:',
  'x8DYRv': '地址校驗異常，請聯絡客服報障',
  'A/vtZJ': '校驗結果:被承運商驗證為"地址正確"',
  '7l6zxJ': '彈窗公告',
  'OTY7H9': '該入庫標簽特征僅支持滿足以下條件的SKU進行下單：{break}1、SKU的管理方式=商品化管理；{break}2、SKU的商品包裹類型=A+包裹；{break}3、SKU出庫是否采集包裹碼=否；{break}4、SKU批次管理類型≠保質期管理/生產批次管理；',
  '9JvAYe': '由於選擇了加值服務【{vasName}】，尾程產品的收費金額及打包尺寸已發生變化，請確認是否查看變化？',
  'Og4xZy': '方案校驗不通過',
  'P+RbEx': '目前統計值(不包含目前訂單):',
  'VZm9tI': '目前訂單值:',
  'e1mqpb': '預警值:',
  'C3m66g': '請再次輸入相同的密碼',
  'FKnMw9': '確認密碼',
  'Pdx/YD': '密碼',
  'ViVQNi': '角色',
  'cHq4Ya': '子帳號管理',
  'gsk33w': '重置密码',
  'hzZoDq': '角色選擇',
  'mxnPQs': '您確定要删除此子帳號嗎？',
  'EMs8M0': '匯出報錯檔案',
  'D/UEIs': '立即付款',
  'xJrIYj': '驗貨途徑',
  '10wVQz': '订单单品数的结束值不能超过9999',
  '4Ci0HB': '包装类别',
  '5F2n3z': '出库加包装规则',
  '6EIwDL': '编辑规则',
  '720Q8J': '查看规则',
  '8huAxo': '新增规则',
  'BCUZhM': '包装规则',
  'D5PNZX': '修改仓库系统将清空已选择的适用产品，需要重新选择适用的尾程产品，请确认是否切换？',
  'FLwmFx': '是否适用',
  'I7l7ML': '适用产品',
  'QuBYs8': '订单最大货型',
  'Wm6V6+': '订单单品数',
  'cfh9l+': '加包装规则',
  'fSrVg2': '修改为[{name}]时，系统将清空已添加的产品，请确认是否修改？',
  'g1o9oC': '适用尾程产品',
  'iKvNmh': '当您下单触发了WINIT复合打包限制规则时, 是否允许WINIT尝试加纸箱出库？{break} <radio></radio>{break} <span>注:WINIT复合打包限制规则参考【WINIT海外仓仓储尾程价格表尾程通用仓库操作】</span>',
  'qDfdJy': '产品已失效，请删除',
  'qwf9Nq': '产品[{winitProductName}]已存在，请勿重复添加',
  's1TEO4': '订单单品数输入的结束值要大于等于起始值',
  'tbiToK': '适用条件',
  'yJT89v': '請新增產品',
  'Caegz9': '訂單最大貨型：TM>T240>T120>T50>T25',
  'Ot+gGB': '當訂單上未指定加包裝且SKU上未指定加包裝時，可選擇在此處維護加包裝規則，維護後，系統將按照此規則加包裝',
  'TLFHiO': '訂單單品數匯總後的值{break} 註：{break} - SKU類型為“套裝產品”，單品數=庫存單元標準箱件數*套數{break} - SKU類型為“箱產品”，單品數=庫存單元標準箱件數*箱數{break} - SKU類型為“單一產品”，單品數=件數{break}',
  'lvDzTm': '請確認是否保存?',
  'eQfOBk': '您在偏好設定了出庫加包裝規則，系統已按設定的規則加了包裝，如果您不想加包裝出庫，請到偏好設定中停用規則',
  'Z4U9y+': '查看附件',
  'uY05bw': '不指定加包裝',
  'cYiz82': '二級貨型',
  's9YTfW': '件型',
  'sPfnYX': '一級貨型',
  '2+PyVI': '無進出口資格，可以在本地進行交易採購的公司',
  'UnEWFb': '用於海外進口清關和海外倉出入庫用途',
  'c5Nj/U': '用於頭程清關出口報關',
  '/XIGWB': 'UK正常清關註冊的客戶可選擇這個報關方式。DE客戶能提供VAT+EORI號可選擇為普通清關註冊。UK直發遞延進口商註冊選擇普通清關。',
  'XJzSbr': '需要使用德國電商清關的客戶沒有EORI下單選擇使用的。沒有EORI號的客戶不使用我們頭程為了註冊德國LUCID也可以選擇這個報關方式，可不填寫EORI號，但必須提供VAT號。',
  'dSTziS': '您的萬邑聯帳戶費用已經逾期超過30個自然日，我司已將本帳號標記為系統壞賬客戶，並按約定處理了您的庫存，如有疑問請諮詢銷售或客服。',
  'wRwbQA': '用客戶自有進口商做進口清關時，繳納關稅，暫不繳VAT增值稅。UK的進口商申請該清關方式需要“英國稅務代理的抬頭信紙申明函”發至指定郵箱（可諮詢銷售開通），上傳“PVA申請函”“出入庫授權協議”“PVA聲明函”。',
  'lCh5Kb': '壞賬客戶提示',
  'WgC6Gs': '正在導出中, 稍後可在 “<url>導出中心</url>” 查看',
  '42AeNT': '是否帶有粉末',
  'Fm+Ssn': 'SKU指定入庫包裹類型使用說明如下，請先仔細閱讀後再打開。 <url>《查看操作指引》</url>{break}{break}確認要啟用支持SKU指定入庫包裹類型嗎？ ',
  'GCht0S': '支持SKU指定入庫包裹類型',
  'GDVEVI': '是否帶有磁性',
  'z0PUTp': '啟用後，可針對SKU指定入庫包類型',
  '++UdMT': '预计维护完成时间',
  '+LILpx': '规定时效',
  '0QchEc': '後續每200個商品任務會加1天維護時效',
  '6ybLAG': '已選中【{x}】條維護任務，其中超時【{y}】條，未超時【{z}】條',
  '7BlR/x': '商品【{code}】存在的草稿或維護退回的資訊會同步删除，是否確認失效？',
  '8mYf5w': '是否開啟',
  '8qzVqS': '加急維護',
  '9qDeNq': '提交時間相近的Winit會基於相同連結的商品進行合併為一個維護任務！',
  'BZjeOY': '≤200個/天',
  'FP7zbE': '00:00-24:00提交的注册任務,第二天（工作日）18:00前維護完畢',
  'IeOpzM': '沒有可操作的維護任務號',
  'L6GHh6': '加急維護提交失敗',
  'Lnr2xY': '僅限注册待維護、注册退回、已發佈、更新退回、更新待維護的商品，才能批量上傳文件',
  'N7+Dp2': '任務號',
  'OMd2yU': '請選擇需加急維護的商品後提交！',
  'OeLJXG': '週六00:00-周日24:00提交，第三天（自然日）18:00前維護完畢',
  'QR4q16': '不滿足加急條件',
  'SNpV1H': '提交加急',
  'UEJHOb': '已選中【{x}】條維護任務',
  'UTPKAA': '週六至周日',
  'V4yQzj': '是否關閉',
  'VgW/4b': '提交注册日期',
  'XyFive': '僅限注册待維護的商品,才能加急維護',
  'Zbdxq5': '12:01-24:00提交,第三天（自然日）12:00前維護完畢',
  'abtEse': '此維護任務已加急！',
  'cAoMRy': '商品【{code}】存在待維護的資訊，暫不允許失效！',
  'g2t/yp': '商品注册任務量',
  'j9fgJe': '週一至週五',
  'k28aoI': '任務類商品數量',
  'kVa+IR': '列印條碼',
  'o1jOma': '批量加急維護',
  'qqc3Vv': '提示：維護“未超時”的任務單次最多支持{totalQuantity}條，僅限{singleQuantity}次/月[本月剩餘{remainingQuantity}次]',
  'qrgvkO': '法定節假日（中國）',
  'rKcJu1': '注册的商品會在{time}內維護完畢！',
  's5Fwma': '維護時效',
  'uYmUBT': '00:00-12:00提交,第二天（自然日）18:00前維護完畢',
  'v0kTyH': "2024年8月31日起,商品注册模版新增'帶粉末''帶磁性'資訊錄入,請下載新範本提交商品注册資訊！",
  'wGnRfF': '維護任務號',
  'wNzGut': '已發佈的商品若修改需要維護資訊，則需等維護通過後才會更新商品資訊',
  '0/uZ2D': '已出賬單的剩餘待還金額按還款幣種為USD換算展示，隨每天浮動匯率變化。由於每天匯率變動及不同還款幣種所用匯率不同，此金額僅供參考。實際還款請參照還款預估的待還金額。 ',
  '25Iz53': '剩餘待還金額',
  'fBDO16': '轉出賬戶ID',
  'sZYtw3': '1. 僅支援標準出庫訂單並需要補充加值服務。 {break} 2. 大量下單頁面不提供智慧推薦功能。 {break} 3. 請務必填寫客戶訂單編號，這是必填項目。 {break} 4. 所有上傳的訂單必須選擇相同的倉庫，如果訂單涉及不同出庫倉庫，請分開提交。 {break} 5. 每次最多可匯入200筆訂單，檔案大小限制為5M。如果檔案過大，請分割成多個檔案逐批上傳。 {break} 6. 操作步驟：先上傳批次範本文件，再提交加值服務，最後點選確認。 {break}',
  '6uYvTI': '關聯第三方條碼數量',
  'GoNHt2': '關聯商品規格',
  'Gr8TCE': '請先上傳標籤檔！ ',
  'Hh/ZWd': '增值訂單號',
  'NuOfGy': '關聯商品的條碼類型',
  'OnpWLD': '關聯的庫存單元標準件數',
  'PMOlhJ': '關聯第三方條碼用於當倉庫收到貨物的條碼無法識別,實際為客戶的第三方商品/單品條碼,客戶可以下發該增值進行關聯三方條碼並下發倉庫進行上架! ',
  'T89W3a': '下載檔案',
  'UfoHwU': '單號類型',
  'V9S9uv': '檔名[{name}]重複，請重新選擇！ ',
  'cO5UFq': '關聯SKU類型',
  'ggcKT8': '第三方條碼',
  'giMLRM': '{eventNo}異常單號不存在',
  'm34H3v': '唯一識別碼',
  'oijERP': '關聯異常單',
  'rl5zz3': '檔案大小不能超過{maxSize}M!',
  'vEYQZT': '單號',
  'vEuIg5': '標識碼類型',
  'wmnWea': '關聯商品編碼',
  '6EEpFW': '若需刪除標籤文件，將同時刪除原標籤文件對應關係，請確認是否已刪除？ ',
  'XaZQMp': '若需重新上傳標籤文件，將清空原標籤文件對應關係，請確認是否重新上傳？ ',
  'Ds9qr8': '異常訊息未登記第三方商品條碼，無法選擇該增值',
  'uS1tJ+': 'X/Y，X表示下單銷毀商品數量，Y表示實際銷毀商品數',
  'RC/HA7': '偵測該加值服務已輸入相關內容，下調數量將清空對應訊息，確認是否已清空？ ',
  'VX99e/': '銷毀商品數量',
  'khx6h/': '此原子僅支援異常單入口下發!',
  '7eLyWG': '請選擇要刪除的商品',
  'QUMHES': '標籤編碼',
  'cErjIB': '恢復預設商品資訊',
  'fn6TWE': '繼續創建加值單',
  'nM2tb2': '暫存待處理',
  'x8lXXz': '重置成功',
  'Dg4vC0': '下單單品數',
  'G5g/iN': 'X/Y，X表示下單銷毀單品數量，Y表示實際銷毀單品數量',
  'XbQUq7': '銷毀單品數量',
  'xBu6OX': '完成單品數量',
  'f2lZyL': 'X/Y，X表示下發的貼標數量，Y表示實際完成的貼標數量',
  '/BhYUx': '處理方式',
  '4jItZi': 'VIP客製化指標',
  'jw6ytD': '報告',
  '0iQEVl': '同步主庫存',
  '2Zx7sc': '當前數據獲取時間2024-01-01 14:00:01 數據僅供預覽',
  '3Pjapv': '請確保所有TEMU上建聯的商品已分配組織及庫存。未分配組織的商品將默認庫存為{num}，會影響平台推單等操作{break} 目前存在{count}個商品當前組織庫存數量為{count}，請盡快處理。 {link}',
  '3tpUnz': '如需調整商品庫存分配，請在[庫存管理-組織庫存]中修改',
  '4Aiv9I': '當前數據獲取時間2024-01-01 14:00:01 數據僅供預覽，僅展示已完成匹配的萬邑聯商品和相應的平台商品',
  // '4u63Ch': '推送平台商品SKU在所選組織的總庫存；多個組織將匯總庫存',
  '6wHk32': '不在提醒',
  '8GCFT0': '同步平台',
  '8GRnN/': '萬邑聯商品',
  '8PygXr': '是否同步庫存',
  '99t1qc': '支持分平台分配組織庫存：幫助您鎖平台，防超賣',
  '9n4qMZ': '同步庫存類型',
  'Ca63SP': '平台同步更新指引',
  'EiExyD': '支持更多新平台同步庫存：新增Temu,AliExpress平台庫存同步配置',
  'GP4y0X': '庫存變更後實時同步',
  'HR1sZX': '預覽同步數據',
  'IWTIB3': '如需調整商品匹配關係，請在[平台同步-商品匹配]中修改',
  'J2ZoaX': '平台店鋪',
  'JyARXC': '萬邑聯商品*數量',
  'M271K5': '同步庫存規則配置',
  'MRcDmq': '同步組織庫存',
  'MTYOZl': '去修改',
  'O6aX6h': '目前存在{X}個店鋪未分配組織，請盡快處理。 （涉及店鋪：{platformAccountList}）{break} {XXX}店鋪匹配到多個組織，暫不支持同步庫存,目前存在{num}個商品當前組織庫存數量為{count}，請盡快處理{link}',
  'OsWrOU': '請選擇指定商品',
  'Oyp6Ar': '指定店鋪&倉庫',
  'Q5Q+On': '指定國家',
  'QIhVr/': '如有疑問，請聯繫客服',
  'R2VEw4': '庫存同步頁面優化',
  'RcwF2N': '請選擇規則狀態',
  'SG7Fui': '多個商品名稱需換行或用英文逗號隔開，最多支持{num}個，雙擊切換到單個查詢',
  'WZS4/k': 'eBay平台每xx分鐘同步一次',
  'YTTk6E': '請選擇規則名稱',
  'YXJ9aP': '同步規則',
  'ZlfiBd': '指定商品',
  'b2W4L8': '更新成功',
  'cNOkF1': '已啟用',
  'czv8e1': '站點',
  'dno1/E': '請先選擇平台及庫存規則',
  'fAuz9u': '預覽庫存數據',
  'fj7l5p': '請選擇同步規則',
  'g6zRLA': '定時同步',
  'hAqYO7': '同步組織庫存暫僅支持選擇區域。若需同步某幾個倉庫庫存總和，請在組織庫存中分配',
  'iPtOqD': '自動發貨下單後同步',
  'iYsMdD': '請選擇指定國家',
  'jVHk8u': '店鋪名稱',
  'jqPOW5': '原eBay庫存配置規則：挪入此頁面管理，若您存在歷史配置的規則，數據將一併遷移',
  'k214kS': '多個商品編碼需換行或用英文逗號隔開，最多支持{num}個，雙擊切換到單個查詢',
  'nM5rsV': '預計同步庫存數量',
  'o+Tex7': '萬邑通海外倉',
  'qdXN6d': '選擇商品',
  'sH8P2N': '已停用',
  't4qfmz': '查看規則介紹',
  'tyq1B+': '請選擇指定店鋪',
  'ua9R+2': '請選擇同步庫存類型',
  'wR9gzr': '僅同步已完成商品匹配的平台商品',
  'xciusM': '指定店鋪&倉庫&商品',
  'xiHXtm': '指定店鋪',
  'yt9qAF': '請選擇同步平台',
  'ywHog2': '規則狀態',
  'wgY9RU': '切換同步庫存類型，將會丟失當前列表指定店鋪和商品數據。確定要切換嘛？ ',
  'kAV6Pj': '支持分平台分配組織庫存：幫助您鎖平台庫存，防超賣',
  'mtLIlD': '指定商品&倉庫',
  'quEI1p': '為了防止誤操作及切換需要一定時間生效，同步庫存類型{time}小時內只能切換一次，請謹慎操作',
  '8zd1Pr': '已達切換限制（{time}小時內只能切換一次），請勿頻繁操作。若緊急需切換庫存類型，請聯繫客服申請，敬請諒解',
  'QJCj/0': '當前數據獲取時間{time} 數據僅供預覽',
  'yce93p': '當前數據獲取時間{time} 數據僅供預覽，僅展示已完成匹配的萬邑聯商品和相應的平台商品',
  '6fCl6i': '匯率',
  'BB2ikr': '還款批次號',
  'C3Ij5H': '匯率日期',
  'C8HnT4': '還款賬單',
  'pKN5uW': '1. 每天下午3點獲取招行匯率作為次日的匯率使用，招行匯率查看地址{link}。匯率只展示近7天的數據。 {break} 2. 轉出幣種指有餘額的幣種，轉入幣種指有欠款幣種，如：充值USD還GBP欠款，則採用當天轉出幣種是USD，轉入幣種是GBP的匯率計算。 ',
  'WZqpxv': 'ISP已還明細',
  'a7wxBc': '還款金額',
  // 'lVoacp': '1.已還金額組成：賬單日及之後產生的商務折扣、返利、禮品卡抵扣、重算退費和付款等數據。 ',
  'rGtSfL': '還款時間',
  'th1faz': '還款明細',
  'xqS13l': '海外倉已還明細',
  '1IlxVZ': '匯率查詢',
  '1bpn0q': '擔保匯率',
  'E1eMGw': '擔保記錄',
  'I/X6Uf': '擔保金額',
  'QbDRWw': '原幣幣種',
  'feZnQf': '擔保幣種',
  'q5d3vL': '擔保時間',
  'r6xKrc': '原幣金額',
  'CzKUXO': '請選擇賬戶',
  'Ebq99k': '請選擇賬單類型',
  '1prDIo': '選擇【一份檔案上傳包裹標籤】，需要您確保檔案內包裹標籤順序與裝箱清單的包裹順序一致，Winit將按照此順序貼標。',
  'F8jfp0': '支援上傳多份多頁的文件，如單一文件內包含多頁標籤，則同時需要在對應關係中填寫PDF文件的頁碼，Winit將按照指定的文件和頁碼貼標。',
  'XZRhcb': '選擇【全部ASN標籤相同上傳一份文件】，需要您確保文件內包裹標籤順序與下單模板的包裹順序一致，Winit將按照此順序貼標。',
  'neUz85': '上傳文件並提供和包裹的對應關係',
  'pFLKkN': '選擇【一份檔案上傳包裹標籤】，需要您確保檔案內包裹標籤順序與下單模板的包裹順序一致，Winit將按照此順序貼標。',
  'ybewHv': '僅支援上傳單份單頁的文件，所有處理對象的標籤完全相同。 ',
  'zALpCW': '選擇【上傳檔案並提供和包裹對應關係】，需要您填寫各包裹和上傳檔案的對應關係。支援上傳多份文件，如單一文件內包含多頁標籤，則同時需要在對應關係中填寫PDF文件的頁碼，Winit將依照指定的文件和頁碼貼標。',
  '2DrbeP': '第三方面單服務',
  'dj20MF': '自提服務1.0',
  'lYWbGM': '您的商品在此倉庫已無庫存，請更換其他倉庫下單',
  'tDSpP/': '自提暫存服務',
  '06OsEH': '包材重量{break}(KG)',
  '47d8N1': '唯一識別碼類型',
  '7B53IP': '包材外徑尺寸{break}(CM)',
  '9BM1R0': '唯一識別碼',
  '9zDqZw': '包材標準尺寸{break}(CM)',
  'EVT5uf': '您可以<url>點擊連結</url>註冊新的商品後下發更換新SKU條碼增值重新提交。 ',
  'NGH30T': '加值服務：{serviceName} 只支援單一產品，您下單第一步選擇的商品存在非單一產品SKU，請修改',
  'Pyomlx': '包材內徑尺寸{break}(CM)',
  'Ziq7lV': '包材商品編碼',
  'j6ntB1': '客製包材商品條碼',
  '/FB7Vp': '組內商品編碼',
  '/PTxEF': '啟用倉庫組',
  '/yffaD': '關閉組織庫存',
  '00Xv+h': '已綁定的自動分配規則',
  '05DQ6l': '平臺店鋪資訊',
  '07tt8s': '查看更多記錄',
  '1+y1bf': '下單時指定分配（暫未開放敬請期待…）',
  '1TVzx6': '組織庫存{break}可用數量',
  '1ukyO/': '未添加商品',
  '2DPEbO': '導入/匯出內容',
  '2FYaur': '請選擇退貨上架組織',
  '2Hmmtv': '組織編碼/組織名稱',
  '2UCGrz': '未綁定自動分配規則',
  '2sTxi7': '倉組內倉庫',
  '3/8rtJ': '轉移庫存數量',
  '33DNab': '最多支持{num}個組內商品編碼',
  '3nUEa0': '匯出初始化範本及數據',
  '3ny3on': '待發庫存',
  '3yklXZ': '下單商品',
  '4++SnE': '請選擇公共池庫存不足處理管道',
  '5Qc7Hj': '字元長度不超過24比特',
  '6iBjmn': '組織編碼【{x}】在【{y}】已存在，若【{z}】需要使用，組織名稱需保持一致，建議選擇已有組織編碼進行新增操作！',
  '6tZ/1+': '是否關閉？',
  '74azmI': '檔案不足需補充？<a>去編輯></a>',
  '83SQTp': '注意: 創建倉庫組後，API/ERP按主倉返回倉庫組內庫存資訊； 另外，倉庫組配寘的優先順序高於原啟用倉群管理、跨倉群管理的優先順序！',
  '8IM/VX': '切換下單國家，將清空選中倉庫和下單商品列表，請確認是否切換？',
  '8PwA5e': '庫存設定',
  '8qMOuZ': '對應國家內不存在任意有效組織，<a>前往處理>></a>',
  '9Ai3+n': '注意，删除該平臺店鋪不再適用此組織庫存，可能會影響此平臺/店鋪後續下單以及庫存同步，是否確認删除？',
  '9GOQAZ': '庫存管理維度',
  '9pkAz+': '自動分配規則：',
  '9qbR0x': '切換下單國家，將清空選中倉庫，請確認是否切換？',
  'A1UnPb': '查看分配策略',
  'AqXCTK': '<url>下載批量下單範本</url>',
  'B8z1Yk': '組織（以下未指定組織庫存不足時下單失敗）',
  'BEPP+g': '待發庫存詳情',
  'BUSFFP': '所有商品',
  'CaVbi3': '繼續調整',
  'CpPFKX': '不區分店鋪管理',
  'EO9v0T': '編輯組內商品',
  'EYW63V': '分配管道',
  'F4fn5Z': '請選擇不良品是否可用',
  'FhAaey': '顯示近30天變動記錄',
  'Fsizc+': '轉出組織/名稱',
  'GEQM/h': '導入/匯出狀態',
  'GxLLvQ': '國家【{countryCode}】的組織庫存未初始化，不允許進行調整，請先操作進行庫存初始化！',
  'H4yCmH': '至少要有一條平臺店鋪資訊',
  'HBuPwU': '同國家組織編碼不允許重複',
  'I37xbU': '請填寫',
  'IP+jXQ': '店鋪',
  'IbZi+n': '不允許重複選擇相同的平臺和店鋪',
  'IrP5Xx': '請選擇組織庫存不足處理管道',
  'IxwwdH': '庫內環節',
  'J1wj7m': '國家內所有組織失效才允許關閉，且關閉後將清空所有失效的組織資訊。',
  'JESDBu': '上架後分配',
  'K5FdtU': '出庫設定',
  'KGyDeG': '組織管理模式',
  'KeIHG5': '最多支持{num}個商品編碼',
  'KsARVE': '入庫環節',
  'L+bkwA': '退貨上架組織',
  'LiMe6f': '未指定商品組',
  'Lntzil': '未設定[{countryCode}]的組織或未完成分配策略設定，請前往設定後再進行初始化！',
  'Lv0XhX': '國家{nationStr}的全域規則未完成設定，請完善後保存！',
  'MNXVRx': '啟用組織庫存',
  'MWwpe1': '請選擇需要啟用的國家',
  'MZdgiP': '凍結件數',
  'Ma8dWp': '指定部分商品',
  'MarGpd': '公共池庫存不足處理管道',
  'Mj9ynL': '總可用庫存',
  'MnS8fr': '批量下組織庫存調整單',
  'O9gLkH': '單據號',
  'OT5/ik': '倉組名稱重複',
  'Oxs/IJ': '無法溯源處理管道',
  'P+K6Pr': '分配策略設定',
  'P0CKu+': '組織詳情',
  'P6pH0T': '組織編碼',
  'PEIjVj': '新增組織',
  'PQbeYX': '商品組編碼',
  'PkS0w0': '國家-組織管理模式清單',
  'QHMibT': '待發件數',
  'QavrS/': '規則名稱',
  'R0kxbt': '組織庫存調整單',
  'R1AWra': '接收組織/名稱',
  'RDgk5M': '全域規則',
  'RbyWkB': '部分組織適用',
  'RkMw3V': '適用分配策略詳情',
  'S1VEI4': '是否啟用組織庫存？',
  'SiZzRo': '選擇商品組',
  'THHVjx': '新增自定義自動分配規則',
  'Ta3sML': '商品組名稱',
  'TqfG+H': '未啟用，不可編輯',
  'UXFmnr': '可用變動數量',
  'VCUzC7': '不允許重複選擇國家',
  'Vcz4jn': '設定成功',
  'W3MKCX': '無商品組',
  'WDuBaK': '組織編碼/名稱',
  'WVYZTQ': '添加【{name}】商品組內商品',
  'WiIsHg': '訂單類型-操作',
  'Wv1lPZ': '分配策略',
  'XhO5Xk': '新增平臺/店鋪',
  'YpfZ65': '是否關閉組織庫存？',
  'YrE9ZY': '說明: 海外每日當地時間0點執行分配！',
  'Z6z+qp': '否，從組織庫存排除',
  'ZYpfKh': '是否需自動分配',
  'ZYwocN': '分配比例',
  'ZiIw56': '編輯組織',
  'ZtafHE': '組織名稱',
  'a3i5lR': '提示: 不良品切為可用進行庫存初始化後，不支持變更！',
  'aV9FJR': '關閉成功',
  'ab9zcP': '選擇添加',
  'aoVhjJ': '前往組織管理頁',
  'bi2QaT': '請選擇庫存組織',
  'cAOQZZ': '待設定',
  'cvLQUR': '全部組織適用',
  'dKd38j': '請選擇無法溯源處理管道',
  'e5yrxb': '出庫數量大於組織庫存可用數量，請修改',
  'f3Q3B+': '支援中文、英文、數位及基本符號！%-，./',
  'fByLAS': '期末可用庫存數',
  'fKDEpS': '最多支持500個商品編碼/商品條碼',
  'fX8PsS': '期初庫存',
  'frT5lF': '是，與良品一致',
  'fxJ2A4': '編輯全域規則',
  'g5duw8': '不良品是否可用',
  'greiLB': '所有組織比例相加不允許超過100%',
  'h9Zi8A': '編輯【{name}】商品組內商品',
  'hD/l+2': '操作類型',
  'iEr7Yj': '公共庫存',
  'iPUZTb': '比例',
  'iRUm9e': '暫未設定商品組可先保存規則後再添加或立即前往添加>>',
  'iw8JBy': '多個組內商品編碼需換行或用英文逗號隔開，最多支持{num}個，按兩下切換到單個査詢',
  'jFV/PS': '未啟用自動分配，則會默認上架至公共池，啟用後會自動分配公共池的庫存到適用規則配寘組織內。',
  'k4R4oN': '多個編碼需換行或用英文逗號隔開，最多支持{num}個，按兩下切換到單個査詢',
  'kFWSjf': '變動時間（北京时間）',
  'kTal8c': '業務單據',
  'lGIYNy': '近期組織庫存流水',
  'lH5CEc': '我已知悉倉庫配寘的使用場景，確認需要使用此功能！',
  'lfUbAE': '生效中',
  'm2P0jx': '找不到店鋪？<a>去添加></a>',
  'mA6taV': '注: 庫存不足向下取值，多餘庫存分配至公共池。',
  'mNQ9rR': '期末可用庫存',
  'njWfGp': '確認移除嗎？',
  'oUf21w': '僅支持英文、數位及基本符號！%-，./',
  'ob2lzc': '手動分配',
  'pAVVEX': '批量下單',
  'pSgnf3': '平臺',
  'poqfFR': '不允許重複選擇組織',
  'qN+r40': '按兩下切換到批量査詢組內商品編碼',
  'qT4N0f': '分配節點',
  'qwiW4l': '期初可用庫存數',
  'rj1FnG': '可轉移庫存數量為: {realUsableQty}，庫存不足',
  'rkGaTC': '查看【{name}】商品組內商品',
  's1JabS': '下單國家',
  'sHewIU': '公共池',
  'sXYWIe': '分配比例設定',
  'satd2e': '查看流水',
  'sgSypa': '切換後將會清空以下清單已添加的數據，是否繼續？',
  'stFVYC': '適用分配策略',
  't8rE2T': '組織庫存的在庫庫存不含暫存RM碼庫存，若不良品配寘為不可售，則不包含不良品庫存。',
  't9BcSt': '創建組織庫存調整單',
  'tIUEDk': '倉組名稱',
  'tjYf78': '開啟成功',
  'tzxFFx': '輸入商品編碼',
  'v013Hs': '貨物在庫內遺失後找回',
  'v58RVX': '請先選擇適用國家',
  'vY86r/': '新增商品組',
  'vYSfcl': '組織庫存不足處理管道',
  'wfMiN1': '組織',
  'wl0SFW': '庫存組織',
  'wuECGB': '請輸入0~100整數',
  'xNrgSc': '可轉移庫存數量',
  'xaJbmp': '關閉後將不會進行自動分配但原分配規則會繼續保留，是否繼續？',
  'xwLj+1': '未生效',
  'xzpkgM': '退貨入庫環節',
  'y7IuXR': '編輯自動分配規則',
  'yq0Wfa': '切換下單國家，下單商品列表，請確認是否切換？',
  'yt82oq': '已綁定自動分配規則，無法删除！',
  'yuDBWt': '自動分配商品組配寘',
  'ywvM6Z': '適用商品',
  'zSagJu': '管理維度',
  'zbMJYb': 'Winit調整單號：{docNo}',
  'zhvmkQ': '請選擇分配節點',
  '7c7h29': '請選擇非出庫消耗庫存的處理管道',
  'EeSMVF': '商品組已有自定義策略，不允許添加！',
  'Feb0g4': '請選擇非入庫產品加庫存的處理管道',
  'Fufjof': '檢查策略是否設定完成，<a>前往處理>></a>',
  'WICKWi': '合併査詢倉',
  'bK//gf': '非入庫產品加庫存的處理管道',
  'cV0Yy/': '非出庫消耗庫存的處理管道',
  'ckk76H': '貨物在庫內發生遺失、破損凍結、增值出庫等非正常出庫場景',
  'ctKGBq': '開通組織庫存後，支持對Winit同一份庫存進行折開給不同組織（平臺，平臺店鋪，團隊/通路）使用，開啟後請繼續選擇需要啟用的國家以及對應的管理模式和庫存管理維度。',
  'xTLIgG': '<fw600>操作說明</fw600>：{break} 1、初始化成功後，訂單將按照初始化後的庫存進行分配凍結，若啟用組織庫存同步至平臺，則會將對應組織的庫存數量同步至平臺！ {break} 2、除指定允許使用公共池組織外，公共池庫存對其他組織訂單不可用！ {break} 3、導入時SKU必須齊全，如存在部分SKU未導入將不成功！ {break} 4、當前無庫存無需初始化，自動更新庫存為初始化完成。 {break}',
  '39J8D8': '<strong>平臺庫存管理</strong>：應用於同一份庫存折開給不同平臺或店鋪使用，對應平臺庫存同步支持按分配後的組織進行同步，出庫下單需提供平臺資訊。 {break} <strong>團隊管道管理</strong>：應用於同一份庫存折開給不同團隊、通路使用，出庫下單必須提供組織編碼，與平臺推單、ERP推單創建互斥。',
  'CL3sbp': '適用商品組',
  'RfaPml': '<strong>倉庫級</strong>：組織庫存根據實物庫存同步庫存，根據具體倉庫進行管理庫存。 {break} <strong>國家級</strong>：組織庫存根據實物庫存按國家匯總國家內所有倉庫的庫存，無需分配組織庫存至倉庫維度，按國家進行匯總管理庫存。',
  '5yWDeS': '批量下單失敗',
  'gmmv7o': '第{index}行：{msg}',
  'E2W8HL': '組織庫存可用數量包含訂單所選庫存組織的可用數量和公共池庫存可用數量。 ',
  '+0tDgG': '挪入此頁面管理，若您存在歷史配置的規則，數據將一併遷移',
  '+RzevE': '否：無組織庫存',
  '2IQ4IG': '原eBay庫存配置規則：',
  '5Jcaq4': 'NEW',
  '8fL2iW': 'eBay平台每30分鐘同步一次',
  '9nxpUA': '預計同步庫存數據',
  'HxQTfu': '庫存同步頁面更新如下：',
  'KOB/Zk': '新增Temu,AliExpress平台庫存同步配置',
  'eqriiv': '幫助您鎖平台庫存，防超賣。 平台庫存管理暫邀請制開放，請聯繫客服申請使用權限。 ',
  'i0lbH+': '支持分平台分配組織庫存：',
  's2CUA7': '支持更多新平台同步庫存：',
  't2iHNJ': '更新',
  'ud1Gl4': '如有疑問，請聯繫客服~',
  'LNkhHz': '請確保所有{platform}上建聯的商品已分配組織及庫存。未分配組織的商品將默認庫存為0，會影響平台推單等操作',
  'FiJma7': '幫助您鎖平台庫存，防超賣。 平台庫存管理暫邀請制開放，請聯繫客服申請使用權限',
  'VZ+X/o': '您暫未開啟組織庫存權限，請先在[個人中心-偏好設置-庫存設置]中開啟組織國家權限',
  '0gq9mO': '{platform}平台暫不支持停用庫存規則',
  'dWyauH': 'Aliexpress(海外託管)',
  'U2xihl': 'eBay庫存規則當前頁面已升級，歷史配置數據已搬遷，請挪步至庫存同步規則頁面查看',
  'cUg6/f': '立即跳轉',
  'jAdq2h': 'eBay平台暫不支持停用主庫存規則，如有需要請在列表刪除規則',
  '+gYY+c': '分區級別N天妥投率',
  '/LCltR': '小時',
  'E/bqbL': '分母（實際出庫包裹數）：統計時間範圍內，實際出庫的包裹數；{break}分子（Ascan包裹數）：分母範圍內，存在Dscan的包裹數。',
  'IIyGq5': 'Ascan率',
  'd1o3FQ': 'N天妥投率',
  'qYx2dy': '分母（實際出庫包裹數）：統計時間範圍內，實際出庫的包裹數；{break}分子（Ascan包裹數）：分母範圍內，存在Ascan的包裹數。',
  'reAu6u': '計算單位',
  '9wjUe/': 'Ascan及時率&平均耗時&Ascan率',
  'mrJoJE': 'Dscan及時率&平均耗時&N天妥投率',
  'utwdg2': '目的分區分組',
  'b6im02': '分母（實際出庫包裹數）：統計時間範圍內，實際出庫的包裹數；{break}分子（Dscan包裹數）：分母範圍內，存在Dscan的包裹數。',
  '1la4o2': '長*寬*高{unit}',
  '2s/F3l': '啟用條碼值庫存管理',
  '2z0biH': '#帶原木',
  '3XiN1k': '#化工產品',
  '5XYPrq': '#高貨值（收費有差异）',
  '6gT400': '#帶三合板或高密度板',
  'BKTNSa': '注册長*寬*高/核實長*寬*高',
  'BuWYZW': '#二手商品',
  'FhjmzP': '有過敏原',
  'HGjBIi': '#帶磁性',
  'Kmi2zT': '#食品',
  'My7yVH': '#18+',
  'Ob+lrT': '#帶粉末',
  'P8thZa': '確定生效？ 生效後會立即調整庫存查詢方式，倉庫組內倉庫的庫存均按主倉返回',
  'PMBp0w': '#帶液體',
  'RnLp7c': '注册體積/核實體積',
  'VsgmEm': '倉庫組內所有倉庫的庫存會合併至主倉顯示與査詢',
  'X0e6vT': '#帶電池',
  'Y2Iwjt': '{tip}',
  'e11fjP': '體積{unit}',
  'emULBJ': '#帶插座',
  'gsPTjg': '標準箱長*寬*高（cm）',
  'j2GBkQ': '確定失效？',
  'kqV2cw': '重量{unit}',
  'nrVjq9': '#包材商品',
  'rfo4U+': '注册重量/核實重量',
  'vv0hh3': '採集包裹碼',
  'wS3w6e': '#退貨商品',
  'xsTk6Z': '批次資訊實例',
  'RJC56U': '請輸入主單號',
  'Vm6LvY': '倉庫[{warehouseName}],商品編碼[{merchandiseCode}],規格[{specification}]庫存發生變化， 禁止出庫商品只允許單次自提所有庫存，目前可用庫存未全部出庫，請將所有庫存轉移到同一個組織後重新添加！ ',
  '+vP+SG': 'AliExpress（海外託管）24年11月大促',
  '/cApcc': '應鎖定量',
  '0GjTAr': '完結狀態',
  '14g/Lr': 'AliExpress（海外託管）專享庫存活動開始啦，歡迎踴躍參與！',
  '2N4FZ4': '鎖庫存剩餘數量',
  '7C32RF': '《平臺鎖庫存協議》',
  'CYi8IL': '已完結',
  'DMwUe3': '立即參與',
  'JMtGcm': '請先閱讀協定',
  'K4E4Fa': '鎖庫存結餘',
  'KrzXJz': 'AliExpress（海外託管）',
  'LMtxPc': '請輸入商品編碼，支持批量査詢',
  'P3HDvw': '鎖庫存變動',
  'QFscDZ': '我已閱讀完畢並同意{a}',
  'QxyKF1': '活動',
  'ULjwS9': '查看指引>',
  'WigRjw': '活動將於{date}日開始，請準時來參與並完成鎖定',
  'XqcI4W': '活動時間',
  'YFUi1Q': '鎖定量變動日誌',
  'gQ4+K1': '日期',
  'ggwfF0': '推送狀態',
  'm5TFEu': 'AliExpress（海外託管）鎖庫存活動導入範本',
  'stTlh/': '尊敬的商家：參與速賣通海外託管專享庫存活動配寘，速賣通會依據專享庫存件數，對於資質符合規則的商家和商品，每次給與最高可達30%貨值的提前放款福利，具體規則請在速賣通查看相關公告。 {break}{break}注意使用前提：{break} 1、需要開啟組織庫存管理，{a1}{break} 2、需要為AliExpress（海外託管）平臺創建唯一專屬的組織，並為組織分配相應的商家數量，{a2}{break} 3、授權AliExpress（海外托管），{a3}{break} 4、平臺同步庫存規則，AliExpress（海外託管）平臺規則切換成組織管理，{a4}{break}',
  'x4lQTo': '尊敬的商家：速賣通會依據專享庫存件數，對於資質符合規則的商家和商品，每次給與最高可達30%貨值的提前放款福利，具體規則請在速賣通查看相關公告',
  'xxEkqr': '活動版本',
  'zNyLRU': '未完結',
  '/MUt5x': '啟用倉庫組庫存',
  '58hly4': '說明：{break} 1、創建倉庫組後，使用Open_API（含對接的ERP系統）按合並查詢倉查詢庫存，則會合並倉庫組內的所有倉庫的庫存後返回，且不支持按倉租內倉庫進行查詢庫存；{break} 2、倉庫組配置的優先級高於原啟用倉群管理、跨倉群管理的優先級；{break} 3、本期萬邑聯庫存頁面查詢暫不調整。',
  'YF0J+L': '確定生效? 生效後會立即調整庫存查詢方式，倉庫組內所有倉庫的庫存均合並後按合並查詢倉返回！',
  'lBsCBG': '我已知悉倉庫配置的使用場景，確認需要使用此功能！（<span>特別說明：</span>創建倉庫組後，使用Open_API（含對接的ERP系統）按合並查詢倉查詢庫存，則會合並倉庫組內的所有倉庫的庫存後返回，且不支持按倉租內倉庫進行查詢庫存。）',
  '19b/CI': '我已知悉倉庫配置的使用場景，確認需要使用此功能！（<span>特別說明：</span>創建倉庫組後，使用Open_API（含對接的ERP系統）按合並查詢倉查詢庫存，則會合並倉庫組內的所有倉庫的庫存後返回，且不支持按倉組內倉庫進行查詢庫存。）',
  'hBk4PW': '說明：{break} 1、創建倉庫組後，使用Open_API（含對接的ERP系統）按合並查詢倉查詢庫存，則會合並倉庫組內的所有倉庫的庫存後返回，且不支持按倉組內倉庫進行查詢庫存；{break} 2、倉庫組配置的優先級高於原啟用倉群管理、跨倉群管理的優先級；{break} 3、本期萬邑聯庫存頁面查詢暫不調整。',
  'kjT4OO': '目前您切換驗貨類型後將清空目前的驗貨數據，該清空不可逆，請確認是否切換？',
  'IzLc7g': '回退草稿單，會同步取消您建立的預約單，草稿單如果繼續提交，請在提交後重新建立預約單！',
  'hopP4K': '檔案未上傳成功',
  'HKRVa7': '已閱讀並同意簽署',
  'O1bX+T': '已閱讀並同意更新',
  'q9tc4Z': '《萬邑通海外倉商業性條款補充協議》',
  'u9tp6T': '《供應鏈管理協議》',
  'hWtisa': '新單上架資訊',
  'R+0iVI': '下載增值結果圖片',
  'rZWk1i': '訂單批次上傳設定：{break} 預設上傳後的訂單儲存為「草稿」狀態{break} 您可以選擇【直接上傳提交】，勾選後，在批次上傳頁面，您可以選擇上傳後的訂單儲存為「出庫確認中」狀態，上傳後無需再提交訂單{break}',
  'Ozl3ur': '前往已提交訂單',
  'TDChQE': '設定我的上傳偏好',
  'WAEEkr': '自提暫存出庫（匯入草稿訂單號碼）',
  'XUIX90': '已提交',
  'a18vC6': '如果是自提暫存服務 {a}',
  'atrzHq': '自提暫存出庫（支援多種加值服務）',
  'hn8/F1': '1. 僅支援需要補充增值的出庫訂單;{break} 2. 目前頁面批次下單的訂單不支援智慧推薦;{break} 3. 上傳的訂單的倉庫必須相同,若存在不同出庫倉庫的訂單請您分成多次提交{break} 4. 請先上傳批量模板文件(一次不允許超過200個單),再提交增值服務,全部上傳成功後再點擊確認。 {break}',
  'lVaxXz': '您同時選擇了【指定商品數量裝箱】增值服務，請先上傳裝箱明細，然後再下載【其他包裹類標籤或文件】的模板。系統會自動填入包裹序號，避免重複填寫。 ',
  'm3TyPy': '如果是三方面單服務 {a}',
  'gcULbV': '此功能支援使用者批次選擇加值服務並上傳標籤文件，如貼商品標或貼歐代標等。 {break}此功能提供自提出庫服務，自提訂單提交成功後可在指定時間預約到倉提貨。',
  '0kI3dV': '待客戶確認',
  '2G6+VQ': '以實際報價為準,審核完成後請確認報價',
  '7Yargg': '單品',
  'Kh+jB9': '增值對象發生變化，已經添加的商品信息會被自動刪除，確定修改嗎？',
  'Yx+rpK': '確認報價',
  'cTokzx': '查看報價',
  '+7FoE0': '1.增值對象=商品時，需為增值指定商品信息。{break}2.增值對象=單品時，需為增值指定單品信息。{break}3.增值對象=其他時，無需為增值指定商品或單品信息，請在下一步選擇增值服務產品時提供具體增值需求。',
  '5lK4bN': '僅支持{fileType}格式',
  'rCHoyP': '補充說明',
  'uwmfN9': '1.增值對象=商品時，需為增值指定商品信息。{break}2.增值對象=包裹時，需為增值指定包裹信息。{break}3.增值對象=訂單時，無需為增值指定商品或包裹信息，請在下一步選擇增值服務產品時提供具體增值需求。',
  '+YI1XG': '單一產品銷量參考',
  '+eP0EZ': '使用第三方商品條碼',
  '/s++ei': '請仔細核對所維護的第三方商品條碼是否正確，若出現錯綁或漏綁，後續將會導致上錯庫存、入庫無法識別等異常，產生不必要的異常費用。',
  '11POth': '需出庫採集包裹碼',
  '2riisj': '風險提示',
  '3mZDwG': '單次拆零需求量',
  '6zMjBQ': '套裝產品銷量參考',
  'CprVCI': '是否需出庫採集包裹碼',
  'LHXw9T': '滿足未來',
  'PN92Iq': '確認無誤導入',
  'QdyY3D': '至少輸入2個字符，雙擊切換至批量查詢',
  'WjHtF1': '是否需入庫校驗實物條碼一致',
  'XF2kX7': '設置單次拆零需求量',
  'd9/BRG': '箱產品銷量參考',
  'gP0n6A': '開頭是',
  'hOA76J': '等於',
  'nMoMXh': '需入庫校驗實物條碼一致',
  'unwvr3': '請輸入≤52的正整數',
  'y5s4nK': '至少輸入2個字符',
  'yHzId3': '是否使用第三方商品條碼',
  'zkVUHd': '最多查詢{num}個，雙擊切換至單個查詢',
  'JuNzF9': '此偏好設置預設值會被單個註冊頁面、註冊模板引用，請根據實際業務場景選擇！',
  'XKSryg': '默認為無需校驗。若選擇“校驗第三方包裹碼與第三方商品碼一致”，則此商品在每次創建入庫單時將自動生成一個增值服務單，用以在倉庫入庫上架環節校驗第三方包裹碼與商品碼是否匹配【需收取增值處理費】，校驗不一致則將攔截上架。（此功能需聯繫客戶經理申請使用）',
  'gdOugC': '假設當前配置如下：{break} 設置周均銷量參考周期：單一產品【近4周】、箱產品【近8周】 {break} 單一產品客戶【近4周】總銷量為：100件，則周均銷量100/4=25 {break} 箱產品客戶【近8周】總銷量為：40箱，則周均銷量為40/8=5 {break} 設置未來需滿足的需求量：滿足未來【5周】需求量，即 {break} 單一產品需求量：25*5=125件 {break} 箱產品需求量：5*5=25箱 {break} {break} 當單一產品在庫可用庫存＜125件時，在保留箱產品最小需求量25箱的情況下，將自動觸發拆零，以滿足單一產品需求量125件。',
  '0jyrwS': '已履約數',
  '3ABpBR': '已出庫數',
  '4jTYjW': '已卸貨數',
  '5nUP7h': '已Dscan數',
  'JLEpKl': '已Ascan數',
  'awHDKA': '已處理數',
  'hHhj5t': '已上架數',
  'rR8IIy': '已暫存數',
  'g2+Qaz': '及時履約率',
  '0VyNFr': '超時未履約未出庫數',
  '2VBdzB': '未履約出庫數',
  '3IT9O4': '已履約出庫數',
  'fWuU1S': '時效內未履約未出庫數',
  'kFqoD8': '已出庫',
  'vYm9gA': '未出庫',
  '6sRGhD': '應出庫日期（海外倉當地時區）',
  'yCcbFa': '分母：目標出庫日期範圍內，非草稿/客戶作廢/萬邑通作廢/抓單失敗作廢的應出庫履約包裹數；{break}分子：分母範圍內，實際出庫日期<=目標出庫日期的包裹數；{break}公式：出庫履約率=已履約出數/(已履約出庫數+未履約出庫數+超時未履約未出庫數)；{break}註意：數據非累計值，需要結合日期來查看。{break}例如，20241028，應履約數為10，表示20241028當天應該要出庫的包裹數為10（不含20241028之前的應出庫數據），其它數值字段同理。',
  '0/oh6t': '所有包裹使用相同的標簽，需上傳其中一個包裹的文件，請勿上傳重復文件。',
  'LOpyZ0': '上傳一個單品的文件(請勿上傳重復文件)',
  'P1jrho': '所有單品貼相同的標簽，需上傳其中一個單品的文件，請勿上傳重復文件。',
  'SDVcmX': '支持上傳多份多頁的文件，如單個文件內包含多頁標簽，則同時需要在對應關系中填寫PDF文件的頁碼，Winit將按照指定的文件和頁碼進行貼標。',
  'h5KDJr': '上傳一個包裹的文件(請勿上傳重復文件)',
  'vYrliL': '上傳文件(請勿上傳重復文件)',
  '/8alR4': '一致',
  '6Fz+Ci': '采集的第三方商品條碼',
  'EeMYcH': '采集的條碼對應商品是否一致',
  'RENO/4': '采集條碼數量',
  'YN26Xr': '不一致',
  'a+1Vch': '采集條碼示意圖',
  'nSVlEa': '采集的第三方商品條碼對應的商品條碼',
  'u/mLpO': '不一致原因',
  'wGe4Z6': '采集的第三方包裹條碼',
  'wuRf4t': '是否已采集條碼',
  'xevV+W': '查看示例圖',
  '+3xFjg': '推薦成功',
  '+LWuuv': '單倉推薦結果',
  '+oQtIQ': '出庫數',
  '/KORqN': '建議失敗',
  '1ORJ7h': '升級至2.0版本後將無法回退至1.0版本，請您確認是否繼續升級？ ',
  '1Tn8rf': '庫存',
  '1ktbT6': '註：升級到2.0版本後，將自動選擇最佳推薦方案出貨',
  '1rSNtA': '可自訂設定倉組',
  '1v9PKl': '智能推薦1.0和2.0版本的差異說明：',
  '4kQRdF': '顧客訂單號碼/訂單號碼',
  '7KBSXt': '原下單產品',
  '7eKHJK': '費用最低>時效最短{break} 策略優先權不支援調整{break} <red>僅支援單倉推薦</red>',
  'AvnTVw': '從1.0版本切換到2.0版本後，系統將根據上述2.0的功能初始化為倉組建議策略配置。您可以根據需要隨時進行自訂修改。 ',
  'BnTyyZ': '庫存數',
  'E5PxaL': '查看日誌',
  'EaCNoe': 'SKU信息',
  'FbO006': '原下單倉庫',
  'GjDYjH': '1.0中的「GFS」等同於2.0中「平台同步」',
  'Lwij7I': '1.0的智慧推薦區域內的倉庫不支援自訂配置{break} 2.0可自訂設定倉組，倉組內配置對應的出貨倉{break} 如：US_GROUP（{break} USWC2 Warehouse {break} USWC Warehouse{break} USTX Warehouse ）',
  'MP5s1M': '是否推薦',
  'Nj/NFB': '第{num}組',
  'Pi9Eo4': '項',
  'RgJnNO': 'API下單，批次上傳，<red>GFS</red>',
  'TLmjdM': '倉庫組合',
  'WZhBnF': '設定倉組庫存管理規則',
  'XDe/3j': '出貨成本',
  'YGCSHM': '1.0不支援自訂設定推薦頻道組{break} 2.0可依不同的場景設定智慧推薦頻道組',
  'Z/43fI': '不建議的原因',
  'ZGp72g': '推薦結果',
  'aCoNjU': '推薦頻道組',
  'aY0yyd': '倉庫優先級',
  'c9diHK': '日誌訊息',
  'cIkOY/': '推薦產品',
  'e9Qio7': '多倉推薦結果',
  'egHHtR': '目前版本1.0',
  'fJSAuQ': '2.0在原來的1.0策略的基礎上增加策略：{break} <red>策略1：優先發多庫存的倉庫</red>{break} <red>策略2：倉庫自訂順序發貨</red>{break} 新增的策略主要為了解決服務成本一致且時效一致時篩選​​最優方案的場景，可依<red>優先發多庫存的倉庫或依倉庫自訂順序出貨</ red>',
  'iH0v1D': '下單時間不能超過一個月！ ',
  'j3KqJP': '差異說明',
  'k8kDSD': '查看條碼值資訊',
  'mEBtRM': '支援自訂設定',
  'mwckV9': 'API下單，批次上傳，<red>平台同步</red>',
  'n82G+/': '支援開啟與關閉',
  'nMv4yf': '美國區,德國區,澳洲區',
  'nbwDiz': '推薦倉庫',
  'pvjx2D': '如果您需要按倉組維度管理庫存，請點擊此處，可以「啟用倉庫群組庫存」管理。 ',
  'rpKkGh': '1.0 支援使用者在有推薦方案時可以選擇自動使用或不使用推薦方案{break} 2.0 預設自動選擇推薦方案',
  'rsqXJf': '推薦應用區域',
  'tV+NM4': '查看建議策略配置',
  'uVM8Tm': '智慧推薦日誌',
  'wlvXCw': '服務成本最低>時效最短><red>優先發多庫存的倉庫>倉庫自訂順序出貨</red>{break} 策略優先權支援自訂調整{break} <red>支援多倉組合推薦出貨</red>',
  'wxm+/v': '立即升級至2.0',
  'ySJxcg': '倉庫數量',
  'yqUlmI': '推薦策略',
  'zITEeG': '智能推薦下單是指系統根據客戶下單時買家地址、派送方式、海外倉庫存等資訊,基於配置的發貨策略計算出最優發貨方案(發貨倉庫和派送方式的組合)後,自動按照最優方案發貨{break} 註： {break} - 如果訂單為組套訂單，支援推薦發貨倉庫和派送方式，不支援拆到多個倉庫發貨{break} -如果訂單來源為“平台同步”且電商平台為“速賣通”或“TIkTok”，支援推薦出貨倉庫和派送方式，不支援拆到多個倉庫出貨{break} - 如果客戶下單時指定了批次商品，不支援推薦出貨倉庫和派送方式，不支援拆到多個倉庫出貨{break} - 如果訂單的收貨人類型為「FBA轉倉-VC訂單」或「FBA轉倉-非VC訂單”，支援推薦出貨倉庫和派送方式，不支援拆到多個倉庫出貨{break} - 如果訂單包含不允許拆單的增值服務，支援推薦出貨倉庫和派送方式，不支援拆到多個倉庫發貨{break} - 預售訂單無在庫庫存不支援推薦倉庫和產品發貨{break} - 由於下單時未預估地址相關附加費用，可能會導致推薦結果出現偏差。 ',
  'pi6nIY': '目前版本：2.0',
  'YpNkdi': '匯出檔案為空',
  'NsbeKg': '不推薦',
  'TWIxab': 'Shein和TEMU平臺訂單使用【萬邑聯-平臺同步】功能推單，由於平臺限製，智能推薦功能將不會生效',
  'tSF35A': '您當前未開通智能推薦產品組的使用權限，請聯系商務經理開通權限後再使用',
  'SQH+7B': '此配置信息為當前訂單下單時的配置詳情，作為分析推薦結果的依據',
  '4F7a+n': '是否属于尾程空运DG',
  'DX+dxO': '是否属于库内DG',
  'Shg80a': '特殊属性',
  'UIUy5F': '是否属于尾程陆运DG',
  'j2Iqat': '是否属于特殊化工产品',
  'MdMQ5M': '最小值必須大於{min}',
  'QpT+5u': '取消增值',
  'sowY5O': '不通過原因',
  'AzxCLr': '材質',
  'WeeDMu': '<span>*</span>',
  'h0QYf0': '請輸入英文字母、英文符號、阿拉伯數字！',
  'dWtldt': '品牌',
  'uuoDDb': '用途',
  'KXalXC': '建議申報信息控製在{maxNumber}個以內，發票總金額不能大於{maxMoney}美金{break}線上中文描述僅供參考,請用英文錄入實際的申報信息!{break}<url>點擊查看填寫示例</url>',
  '22iXWV': '重新獲取{count}',
  '5pf2is': '驗證碼',
  '91yqs1': '新手機賬號',
  'ChJyT9': '原手機賬號',
  'EKMBnU': '修改手機賬號',
  'KZfKJ8': '綁定手機號',
  'MogvGG': '微信掃一掃綁定微信',
  'N9hObN': '綁定微信號',
  'TdGnHP': '確認綁定',
  'Z88MpV': '郵箱賬號密碼',
  'gH3BP7': '賬號安全',
  'h+HlJu': '手機號格式不正確!',
  'jy7d7Z': '郵箱賬號',
  'jyEJqj': '綁定手機賬號',
  'lQSztD': '綁定成功',
  'uWwmzm': '手機賬號',
  'wPtgoF': '確認解綁嗎？',
  'xC3qW/': '解綁微信號',
  'zusrxt': '取消綁定',
  'Ji9Dwg': '請填寫0~9999.99之間的數，最多保留2位小數',
  'nuHfsV': '上傳商品申報價值',
  'NTYH7r': '批量上傳包裹，如已有包裹信息，表格將會覆蓋原數據，如實際為新增包裹，請在原上傳表格基礎上新增包裹信息再上傳或單個新增，否則包裹信息將會覆蓋，請註意！',
  'XPznM5': '前往商品維護',
  'evvpFz': '請填寫小於等於2000的正整數！',
  'qv9EKm': '已知悉, 下單後再去維護',
  'S150lQ': '不能是B/b開頭+19位數字',
  'XdZmSP': '請輸入數字、字母、減號或下劃線,並且長度小於50個字符',
  '0AGMjg': '請選擇狀態',
  '1dHd/u': '選中的商品: {break}{codes} {break}未關聯GPSR信息,不允許選擇!',
  '4q7aWj': '前往添加>>',
  '5IblI+': '製造商名稱',
  '6up8TB': '可用模板打印尺寸【',
  '76VQlq': '請輸入GPSR名稱',
  '7Qb7zk': '標籤區域',
  '7nyFdZ': '請輸入名稱',
  '8OkSrg': 'GPSR信息',
  '97FBSp': '請按需根據銷售區域提供相應語言的警示語信息{break}示例：Warnhinweis: Nicht geeignet für Kinder unter 36 Monaten.',
  'AyW7zz': '所需警示合規環保標識',
  'BSpSco': '請選擇商品負責人',
  'BU3zeG': '製造商',
  'BrBTkB': '鑒於以下提交的信息，我/我司聲明：信息均屬實，如有虛假信息導致的任何責任及後果將由我/我司承擔',
  'CT8MBi': '適用於某類商品的GPSR信息組成，用於關聯需GPSR信息的SKU以及打印相關的GPSR信息標籤。',
  'DPAxH+': '編輯製造商',
  'F/D7pU': '標籤選擇',
  'FPNaML': '負責人詳情',
  'GpDYex': '新增製造商',
  'IhWPTD': '打印通用GPSR標籤',
  'KXmxRR': '請輸入GPSR信息名稱',
  'KreuRF': '以上組合打印信息不適用於此尺寸',
  'NVPitr': '選擇內容過多，此模板尺寸【{curSize}】無法打印全，請調整模板內容或模板尺寸後繼續添加！{enSize}',
  'QP3qdO': '鑒於以下提交的內容，我/我司聲明：{break} 1.對於由我/我司的歐盟責任人負責的每件商品{break} a.商品/其包裝或隨附文件中標有歐盟責任人的名稱和聯絡詳情，包括郵政地址{break} b.歐盟責任人擁有符合性聲明(或性能聲明),並有權訪問相關技術文件以證明符合要求{break} 2.如果我/我司的歐盟責任人發生任何變更,將通知貴司{break} 3.信息均屬實，如有虛假信息導致的任何責任及後果將由我/我司承擔',
  'QTIMTf': '請選擇模板打印尺寸',
  'S55u79': '批量關聯GPSR信息',
  'SB/wkv': '查看綁定負責人信息',
  'SOyOXk': '自定義警示語',
  'ShuBcR': '請選擇製造商',
  'T6MpaR': '請選擇GPSR信息',
  'TXtNAs': '模板打印尺寸:',
  'UYhyhR': '此商品GPSR模板+商品條碼標籤組合不適用於此尺寸打印！',
  'W8/2Ef': '關聯GPSR信息',
  'WgR9Ik': '製造商詳情',
  'WkR4ou': '打印GPSR標籤',
  'X943SP': 'GPSR信息名稱',
  'X9Hi81': '編輯負責人',
  'Y0VbfF': '點擊下載',
  'YcHiPZ': '無對應供應商信息，{a}',
  'bbSyMZ': '新增GPSR信息模板',
  'diPqGv': '《批量打印條碼模板》',
  'glkuPy': '商品條碼區域',
  'hWeYWy': '批量打印文件',
  'iFeo32': '請選擇類型',
  'k3QotQ': '歐代信息',
  'kUWb/8': '商品負責人區域',
  'lJoEc8': '不能輸入中文',
  'lSOSkG': '結尾是',
  'loKQx9': '單次不得超過5000個',
  'mpknBY': '自定義警示語區域',
  'n4VyL8': '此處僅支持打印通用GPSR標籤，若需同時打印商品條碼信息請前往商品管理關聯GPSR信息在對應商品列表打印 ！',
  'nwIvZ2': 'GPSR, 即《通用產品安全法規》(General Product Safety Regulation), 是歐盟為加強產品安全而制定的法規, 旨在確保所有在歐盟市場上銷售的產品都是安全的, 以保護消費者的健康和安全。',
  'ppwk5Y': '模板打印尺寸',
  'rA3Nmf': '僅限補充類型全部都為GPSR信息的商品，才能批量關聯',
  'sIy67M': '包含',
  'vKMx9x': '編輯GPSR信息模板',
  'w8+5lq': '其他打印項',
  'xp/GZy': '查看關聯GPSR信息',
  'yFmk5P': '請先補充商品的GPSR信息',
  'ylF0LP': 'GPSR需補充或更新？<a>去編輯</a>',
  'zGpUl0': '商品負責人&製造商基礎信息',
  'zqMDyD': '製造商信息區域',
  'GNCFjw': '{dot}僅支持標籤紙打印，單次打印不得超過5000個，打印後請掃描測試。{break}{dot}如您選擇添加GPSR信息，則標籤將帶有已關聯的GPSR信息；如果商品未關聯GPSR信息，則不允許打印。{break}{dot}如您選擇添加歐代信息，則標籤將帶有已關聯的歐代信息；如不選擇則不會帶有。',
  'MjfT9F': '該製造商已失效，請重新選擇',
  'UehsMU': '該商品負責人已失效，請重新選擇',
  '3uYLxS': '支持50M以內的jpg，jpeg，png，pdf，zip格式檔案',
  'AUuPe6': '至少輸入{num}個字元，按兩下切換至批量査詢',
  'FeVrJ/': '檔案最多上傳{maxCount}個，大小限制50M以內，格式限制為jpg，jpeg，png，pdf，zip',
  'xo2gDa': '列印GPSR資訊',
  'yxW56v': '檔案格式限制為jpg，jpeg，png，pdf，zip',
  'vXqrEQ': '當前單品管理暫不支持列印GPSR資訊組合標籤！',
  '3F0pn+': '德國新倉',
  '3Kr6md': '英國一倉',
  '3Z/8DA': '澳洲悉尼倉',
  '4G7TmF': '選擇報告月份:',
  '5eIZb1': '出庫SI',
  '5knorD': '薩凡納倉',
  'Ahfns/': '各庫齡段資金明細',
  'CpC3w/': '排行',
  'Cx/ZfQ': '美西（太平洋時區）',
  'DlNvpw': '出庫單量',
  'FMFuuk': '上月在庫SI數量',
  'GP2sjg': 'SI數量',
  'HQ4HZg': '自定義時鐘',
  'I7qN1w': 'part.1 履約消費數據',
  'JkcfsV': '澳洲墨爾本倉',
  'K83Hze': '點擊跳至最左',
  'KD3+MN': '英國',
  'LfkgD6': '澳大利亞',
  'NWSZS8': '承諾頭尾程消費額(折後)',
  'PaWMTl': '履約分析報告',
  'SZC9VK': '各平台出庫單量佔比',
  'VG2CwF': '點擊跳至最右',
  'VahHdx': '新澤西倉',
  'WWLGJO': 'part.2 庫存分析',
  'YJ9vOe': '美南倉',
  'YMgB69': '本月在庫SI數量',
  'YuT9+d': '美西一倉',
  'Z44f6M': '入庫SI',
  'ZgIeSx': '環比',
  'ZwLbdd': '比利時慕斯克龍倉',
  'a6CV9N': '英國四倉',
  'cmmHPa': '美東（東部時區）',
  'dOsMrX': '上月在庫資金',
  'dn5c7I': '中歐',
  'er80XZ': '英國三倉',
  'eyNX6K': '佔比',
  'fFmC7w': '出庫SI數量',
  'gLz/8S': '美東三倉',
  'iVp3lO': '上月出庫單量',
  'l9xczl': '二級品類',
  'ngVved': '實際頭尾程消費額',
  'oAUHli': '在庫資金指商品申報價值',
  'olJJPB': '世界時間',
  'r/enn9': '各庫齡段SI明細',
  'rYrCyO': '消費金額',
  's24SFP': '總單量',
  'sS5Zjv': '達標率',
  'suyKfo': '美西二倉',
  'udjnTi': '美中（中部時區）',
  'vETCLF': '本月在庫資金',
  'vgNCKm': '德國一倉',
  'vwrLKd': '上月月在庫SI佔比',
  'w3QnSZ': '出庫排行榜',
  'xAHzLe': '本月在庫SI佔比',
  'xbdSiX': 'part.3 出庫品類詳情',
  'zWZfR1': '加拿大多倫多倉',
  '+x9sKw': '美西',
  '3u3Azm': '{num}月',
  'ATI8nz': '{warehouse}: {warehouseLabel} 城市: {city}',
  'AzRGCX': '德國',
  'jxIf3M': '美東',
  'GBO8/I': '德國倉',
  'HoMqWj': '英國倉',
  'dG1S3v': '美西倉',
  'h3EF1T': '美東倉',
  'oXc3m5': '1. 如需查詢和導出12個月以前的歷史數據，請聯繫在線客服。 {break} 2. 授信手續費、逾期手續費及延期手續費，幣種CNY/HKD的最小收費金額為0.1，幣種GBP/EUR/AUD/USD/CAD的最小收費金額為0.01。 ',
  'FY4EWV': '倉組內其他倉庫',
  '0GyUPW': '預約郵箱',
  '1XXFUz': '計費值',
  '1mj4G9': '價格變動原因',
  '5+hBLi': '訂單重量',
  '6qeH3F': '預估托盤數',
  '9f5t0B': '訂單體積',
  '9m6tTe': '尾程詢價報價 <span>(實際打托數量會影響最終尾程費用,以實際扣費金額為準)</span>',
  'BOsZa4': '目標派送方式',
  'EBLjD7': '尾程詢價報價',
  'ETE5vQ': '供應商報價存在波動，請及時確認報價。出庫增值作業耗時、實際打托數量等也會影響實際金額',
  'FmPO/g': '打托暫存後再指定具體日期',
  'Gm0Npz': '其他備註',
  'OLzg0F': '單價',
  'OPRrfY': '托盤數量',
  'QcRv4P': '車輛需要GPS',
  'RS2s4f': '跟蹤號/憑證號',
  'RrpKm0': '單價有效截至日(當地)',
  'Si3Ovb': '計費單位',
  'UgqSWZ': '計費費率',
  'VS3QW3': '預估尾程費用',
  'VSq34r': '下載提貨單',
  'ZV6B7N': '該費用依賴於其他費用金額計算得出時使用。{break}例如通常情況下，燃油附加費=最後一公裏派送費*計費費率',
  'ZVG0lB': '超過預估托盤數',
  'aWgms2': '增值待確認',
  'iKD60I': '超過預估提貨時間',
  'ihg37s': '依賴費用項',
  'j3vF3/': '投保幣種',
  'lYkQcO': '實際尾程費用',
  'lbJx3W': '需要向供應商投保',
  'mF9qHK': '訂單數量',
  'oXkCM6': '實際供應商',
  'rCk9U1': '投保金額',
  'rjZWF2': '新建增值單',
  'sgapu/': '預約電話',
  'sgmkqg': '指定車型',
  'xcPr5G': '需要協助預約送貨',
  'yvvayC': '指定供應商',
  '+Iqggx': ',請前往<a>預約單管理</a>預約送倉',
  '4F2DLS': '未預約到倉',
  'BHIZbJ': '請選擇訂單',
  'BqJJ9L': '未到預約節點',
  'C5EziP': '已預約',
  'IToNB2': '是否清空待辦項進行查詢！',
  'MpeG4C': '待提交預約送倉',
  'PLcKBI': '卸貨方式',
  'Q6plNw': '無需預約',
  'QEmJpC': '預約送倉時間(當地)',
  'Ry3L12': '新增預約單',
  'TvlAb1': '預約次數',
  'V6neT7': '待送倉',
  'ZhMON/': '選擇待預約訂單',
  'h4VFpW': '無法創建預約單，請檢查後重新創建預約單！',
  'hdgxlJ': '待預約送倉',
  'jOywIg': '導出暫無數據',
  'q/YRnn': '實際卸貨時間(當地)',
  'sLxRLg': '預約卸貨時間(當地)',
  'wQCAYD': '包裹數量',
  'x+RSYW': '創建日期',
  'xbSzZ3': '實際送倉時間(當地)',
  'f0PSge': '僅支持按訂單送倉方式進行預約派送：送倉方式為散貨的預約散貨，送倉方式為整櫃的預約整櫃，送倉方式為快遞則無法預約；若訂單送倉方式選擇錯誤請回退草稿，重新更改送倉方式和產品後再預約；',
  'XfySEr': '入庫單預約狀態',
  '+1z4qs': '溫馨提示：支持貨物入庫後，出庫時將多個SKU組合為1個單品出庫，該服務僅支持2C庫存。',
  '/YG20j': '請輸入商品組名稱',
  '16H+KU': '套裝長（cm）',
  '1yjVbf': '商品組',
  '3uBogm': '最多保留4比特小數',
  '4g0F/w': '套裝可弃重量（kg）',
  '6tylb+': 'EXcel批量新增',
  '7FKIiN': '與成品商品編碼重複',
  '7b3ENM': '組套關係',
  'AF0IfM': '組套內商品',
  'AKAQkU': '組套商品/商品組',
  'CoJ9Ff': '組套包裝',
  'CxmT/4': '套裝商品視頻',
  'DlZIxf': '溫馨提示：同一商品組套的多個商品支持維護在一個商品組，以减少維護商品組套次數，例如：同一商品多個顏色對應多個SKU，每個顏色的SKU都可以維護為一個商品組。',
  'EI0jby': '商品編碼/商品組名稱',
  'HGxg7z': '套裝高（cm）',
  'JJsTcc': '套裝商品示意圖',
  'JWHXq+': '組套資訊',
  'KX7tJL': '<red>最多上傳5張圖片,限制為5M以內的jpg，gif，bmp，png格式</red>',
  'N52RjX': '庫內組套',
  'NLUeF8': '<red>最多上傳3個視頻,限制為50M以內的avi，dat，mpg，wmv，asf，rm，rmvb，mov，flv，mp4格式</red>',
  'NcFJGy': '下單時是否填寫',
  'ONEZAE': '出庫商品組配寘',
  'OT8ish': '商品組/商品',
  'OvAUQP': '商品已存在，請勿重複添加',
  'PIOZgH': '組套業務類別',
  'PdjukP': '當組套内容為套裝包裝，可填寫可丟棄重量； {break}可丟棄重量指組套商品進行組套時，包裝內可丟棄部分的重量。',
  'Qy13lF': '關聯GPSR',
  'RLjqtw': '套裝寬（cm）',
  'RnXcAk': '組套包裝/組套內商品',
  'TZNHjJ': '新增組套內容',
  'W7HwCn': '商品組名稱/商品編碼',
  'argxjt': '成品商品編碼',
  'brD+uB': '查看組內商品',
  'eEjnyp': '出庫組套',
  'eQuhOe': '下單時是否填寫為是指下單時訂單中需要包含該商品，否則無法進行出庫組套； {break}下單時是否填寫為否指下單時訂單中不需要包含該商品就能完成組套，若包含該商品則不視作組套的部件，作為單獨商品售賣。',
  'ebDqUr': '組套對應商品編碼',
  'fJMACQ': 'GPSR資訊名稱最多128字元',
  'iCtpFf': '溫馨提示：支持貨物入庫後，在庫內將多個SKU組合為1個SKU並重新上架售賣，該服務僅支持2C庫存。',
  'jogDbB': '列印GPSR資訊組合標籤最大列印數量為{num}',
  'lpeIQF': '溫馨提示：組套包裝為組套中的包裝，該商品在每個組套中只允許存在一個。 組套商品為組套的其中一件商品，該商品可為商品組或商品組商品中的任意一件商品。',
  'm0ZYt5': '組內商品編號',
  'nRqQiw': '與組套內容的商品編碼有重複',
  'nqSBOq': '組內商品條碼',
  'qFYiaJ': '視頻格式限制為avi，dat，mpg，wmv，asf，rm，rmvb，mov，flv，mp4',
  'taxXcG': '新增出庫組套',
  'uyKP5R': '組套關係名稱',
  'vKXaA5': '視頻大小限制50M以內',
  'vP/Azq': '只能輸入【大寫字母】【中文】【小寫字母】【數位】【-】【_】【（）】【+】【/】【@】【#】【.】',
  'xrXaSi': '組套內容',
  'yMCuMW': '新增庫內組套',
  'EZYGd+': '批次下載POD檔',
  'jwJ5aJ': '下載POD檔',
  '2BYfGC': '平臺同步是否對接',
  '6+1lpt': '平臺設置',
  '7mS1Ef': '詳見操作指引',
  'Far31d': '請啟用或添加您當前已使用的電商平臺,啟用後將控製萬邑聯平臺下拉選擇以及頁面展示，',
  'L7rr8k': '平臺編碼',
  'NP8ydP': '啟用平臺',
  'fmU8aC': '確定停用嗎？',
  'gR5+1a': '確定啟用嗎？',
  'tpXKt6': '添加平臺並啟用',
  'uIa3Sy': '添加平臺',
  'zMawsp': '平臺名稱',
  'drA1F1': '找不到平臺？請聯系客服添加',
  '2xD9pN': '與{mount}月環比',
  '80c2cB': '{mount}月出庫單量',
  '7OyNT9': '透明計劃標簽',
  'EArTq/': '不允許',
  'RlFIEF': '必須',
  'RuKykW': '訂單最大貨型/件型',
  'i0tMJ3': '訂單最大貨型：TM>T240>T120>T50>T25{break}您可以選擇按貨型或者件型設置規則',
  'kdNFDD': '訂單最大',
  'lXbQ5s': '您已選擇了增值服務[貼FBA透明計劃標簽]，此增值服務不支持選擇',
  'utBCZV': '透明計劃標與FNSKU標混合標簽',
  'HPEdSt': '訂單最大「貨型」判定規則：TM>T240>T120>T50>T25{break}訂單最大「件型」判定規則：超大件>大件>中件>小件{break}您可以選擇按貨型或者件型設置規則。',
  '06l+Qj': '您好！你提交的商品尺寸最長邊< 15 cm或者次長邊< 10cm時，即使商品已經存在物流包裝，受供應商運輸要求，會進行加包裝處理（出庫加包裝費用詳情），為了避免產生額外打包費用，建議調整商品的包裝要求後再錄入正確的尺寸！如您同意出庫加包裝，可繼續進行下一步。',
  '0m04KS': '取消後本次調整的保額將不會生效，按原保額生效，是否確認？',
  '0y8Vak': '僅支持標籤紙列印，單次列印不得超過5000個，列印後請掃描測試。',
  '10skDr': '重新投保',
  '2yoQvT': '當前操作不可逆，請確認是否更新為商品化管理！',
  '3g9GU1': '添加示意圖',
  '5FCj3u': '確認重新投保？',
  '5Kcusw': '整套|整箱：',
  '5ZDwkw': '請選擇該商品的發票等相關證明圖片上傳，Winit相關工作人員會進行稽核相關資訊。{break}<red>最多上傳5張圖片，限制為5M以內的jpg，gif，bmp，png格式。</red>{a}',
  '6XWJXx': '取消投保',
  'A+35EB': '檔案格式限制為jpg，jpeg,png',
  'AE/KxE': '單件：',
  'B/XWT5': '調整保額',
  'Ctsw2n': '列印檔案生成設定',
  'H/jbhZ': '1.同一國家箱產品箱內每件或套裝產品套內每件的投保金額不能超過單一產品的投保金額。{break}2.若箱產品或套裝產品的標準件數乘以箱內或套內每件的投保金額超出整箱|整套的限制金額時，則會按對應上限投保金額計算保費！',
  'HJOdSI': '稽核資訊',
  'K45CNn': '示意圖類型',
  'KL1vOZ': '混合存儲',
  'KbCL0r': '貨主',
  'Kej6Gd': '視頻預覽',
  'LVH+YI': '投保狀態',
  'OgT+gu': '所有SKU生成一份檔案',
  'P53D0s': '調整後投保金額',
  'Q0aPTI': '請輸入採購金額/件（USD）',
  'QnShZR': '沒有幣種不支持投保',
  'SIXvYZ': '箱產品投保金額/箱內每件',
  'UFIIqK': '子帳戶名稱',
  'V5LbEg': '採購金額/件（USD）',
  'YNWh/C': '確認取消投保？',
  'YgLev7': '可用套/箱數',
  'a71RUr': '在途庫存詳情',
  'aaEmj4': '支持50M以內的jpg,jpeg，png格式檔案',
  'aaJRtO': '投保限制金額',
  'be/PB3': '此日期為SKU對應批次資訊的日期，由批次内容决定此日期的性質。如: 批次内容是生產日期+產品批次號，則此日期為生產日期；批次内容是失效日期+產品批次號，則此日期為失效日期。',
  'd1RUKj': '商品證書資料',
  'd2MeTl': '添加商品示意圖',
  'de5n5v': '存在相同國家',
  'fOXNzj': '{dot}僅支持標籤紙列印，單次列印不得超過5000個，列印後請掃描測試。{break}{dot}如您選擇添加GPSR資訊，則標籤將帶有已關聯的GPSR資訊；如果商品未關聯GPSR資訊，則不允許列印。',
  'gneoey': '單一產品投保金額/件',
  'gzDYf6': '商品在【{codes}】已有待稽核資訊,是否提交更新？',
  'lLL5ZK': '套裝產品投保金額/套內每件',
  'lUtVXk': '商品資訊示意圖',
  'luyAlN': '提交稽核時間',
  'mQq9vE': '請輸入大於0的數位，且最多保留兩位小數',
  'mRtDqK': '在途數量',
  'nLDE+V': '原生效投保金額',
  'o0wl3e': '新增投保',
  'pVTl/X': '批次内容|日期|產品批次號',
  'pa/Hpb': '在庫套/箱數',
  'qm6h2z': '投保資訊',
  'v742LV': '不同SKU生成單獨檔案',
  'wDqNy1': '示例',
  'wI3FWu': '請上傳採購發票',
  'ye/rJU': '採購發票',
  'zrIs7T': '最近更新時間',
  'X1t/M7': '應補貼包裹條碼',
  'ZAOv9w': '實際上架入庫單號',
  'b2UFEI': '應上架入庫單號',
  'dIycQ5': '實際補貼包裹條碼',
  'Numk8A': '關聯Winit訂單號',
  'cpUlyA': '關聯加值單號',
  'DxKC20': '【{serviceName}】必須同時選擇增值選項：【{serviceName2}】！',
  'Z0Afjw': '入庫-補貼包裹條碼',
  '017M9b': '查件資訊',
  '83aOrM': '索賠時間',
  'CczxbC': '派送异常類型',
  'DMYki0': '索賠狀態',
  'FCcD/q': '處理迴響',
  'KkBukn': '索賠類型',
  'NYJgJy': '索賠流水號',
  'O96nxS': '异常持續天數',
  'PIqc3E': '查件時間',
  'bwU822': '出庫倉庫',
  'c9Nk2X': '查件狀態',
  'dM3hXJ': '查件流水號',
  'goV7bs': '軌跡發生地點',
  'hCubz5': '最近軌跡',
  'no4CjP': '索賠資訊',
  'uP/M2r': '軌跡發生時間',
  'w39FKP': '軌跡狀態',
  '4xS0E4': '出庫訂單',
  'OiVSUE': '最低收費',
  'WX6HP8': '無效，請删除此檔案並重新上傳！',
  'nQPn4+': '無效，請重新上傳！',
  'aePiuD': '證書已失效',
  '/KxreR': '庫存準時率',
  '2MYr1m': '登錄',
  '3S5WCT': '手機號登錄',
  '4/Lg7X': '請輸入登錄密碼',
  '9UZxwP': '請輸入驗證碼',
  '9z252s': '掃碼註冊',
  'I1vr0V': '找回密碼',
  'KBVp8X': '請輸入手機號',
  'MmsEyp': '註冊',
  'OQBMaY': '郵箱登錄',
  'Rdb33f': '掃碼登錄',
  'SWlncS': '預約送倉',
  'VaYh5v': '記住密碼',
  'X3Qw1f': '請輸入手機驗證碼',
  'Xjfb5m': '隱私政策',
  'YpskxZ': '出庫準時率',
  'b/9R1T': '綁定',
  'd8FaCq': 'Step1 掃碼登錄',
  'fxYWiK': '請輸入郵箱',
  'gI0VX4': '準時投遞率',
  'guGupZ': '掃碼成功',
  'ngd7Ys': '請輸入圖形驗證碼',
  'oIbf2X': '上架準時率',
  'tLW3W3': '手機號',
  'uQXjs5': 'Step2 賬號綁定',
  'x3dFer': '請輸入密碼',
  'xsqOlT': '微信昵稱',
  '1ursGp': '登錄密碼',
  '3izfxn': '微信已註冊使用，請勿重新註冊',
  '6B5YBg': '登錄方式',
  '8Je/Zh': '綁定手機號成功後即註冊成功～',
  'B6Yy/p': '支持微信快速登錄',
  'BWtB9B': '輸入6-32位數字字母組合密碼',
  'DQMC7I': '兩次密碼輸入不一致',
  'DiCHhn': '如已有賬號，請點擊按鈕綁定已有賬號',
  'GqhYph': '微信登錄',
  'Hdrh6x': '請輸入聯系人姓名',
  'IBJ0+K': '檢測到您的賬號未綁定微信賬號, 為給您提供更便捷的服務, 請盡快綁定微信～ <btn>馬上去綁定</btn>',
  'KIo76D': '微信註冊',
  'L78Ltd': '修改手機號',
  'L7gdr+': '目前在用/計劃用哪個國家的海外倉(可多選)？',
  'NfKGF1': '設置郵箱',
  'O04mT0': '用於接收消息、驗證身份（如找回密碼、變更安全設置等）',
  'ORpvGU': '設置手機號',
  'QK5ud3': '賬號驗證',
  'R9+P8F': '恭喜您，郵箱註冊成功~ {break} 請前往郵箱{email}激活賬號',
  'RXIzb7': '激活郵箱',
  'T8JunI': '請選擇註冊或綁定賬號',
  'UpWtER': '恭喜您，微信掃碼註冊成功~',
  'V5pGxT': '基本設置',
  'VGdghS': '已閱讀並接受 <a1>《用戶註冊協議》</a1><a2>《隱私政策》</a2>',
  'WZ8gJI': '您目前的年均銷售額是多少萬人民幣？',
  'XOaAVQ': '登錄萬邑聯賬號時需要輸入的密碼',
  'XfP+fO': '沒有賬號，註冊新賬號',
  'Z9M13R': '輸入郵箱字符長度不能超過50',
  'ag8LxW': '未設置',
  'auukQC': '未找到當前微信號對應的萬邑聯賬號, 請選擇：',
  'b9caeM': '請再次請輸入密碼',
  'bdjhF3': '用於接收消息、驗證身份（如找回密碼、變更安全設置等），綁定後可支持手機驗證碼登錄',
  'cRkjTF': '修改郵箱',
  'dMPyxp': '關註公眾號: WINIT萬邑通',
  'eGMWPi': '({count}S) 後進入首頁, <url>點擊立即跳轉萬邑聯首頁</url>',
  'eMnHfD': '郵箱註冊',
  'f+xVln': '請輸入確認密碼',
  'fpHtD6': '賬號修改申請已提交，現需要您前往新郵箱激活賬號',
  'g4luE6': '已設置',
  'g7ZZYG': '輸入郵箱格式錯誤',
  'idr0Yi': '恭喜您，郵箱註冊成功~',
  'lJ5T1S': '重新發送({count}s)',
  'lkvxCD': '請閱讀並接受協議',
  'o9sQv+': '立即驗證',
  'p6bh5v': '賬號密碼',
  'qiM7Bf': '微信掃一掃',
  'sPM43N': '前往郵箱',
  'trTcmQ': '(註冊成功後可通過手機號登錄哦)',
  'uQ97fV': '已有賬號，去綁定賬號',
  'uWZTJg': '了解更多資訊/享受更便捷服務',
  'yzVtH/': '綁定已有賬號',
  'zDhp9Q': '郵箱已存在，請直接登錄',
  'zdjQOh': '請選擇國家/地區',
  'kYuuSo': '關註公眾號',
  'i+upx7': '賬號綁定',
  'jIh+uu': '新登錄郵箱',
  'kXaBbd': '關註成功',
  '4cBjcA': '現需要您前往新郵箱激活賬號',
  '+CITvc': '請輸入變動日期',
  '/CmSdr': '<red>請提供完整的操作視頻，最多上傳1個視頻，限制為100M以內的avi，dat，mpg，wmv，asf，rm，rmvb，mov，flv，mp4格式</red>',
  '/DtX+8': '費用類型',
  '21rG2o': '提交日期',
  '3YV16S': '視頻大小限制100M以內',
  '3pgC7n': '貨權轉出',
  '79mGuc': '退貨入庫',
  '8ME8Ww': '匯出明細',
  '8PETXp': '調撥入庫',
  'ClOQBe': '期末庫存',
  'Cs5PyX': '最多上傳1個視頻',
  'DH94cn': '期末庫存數',
  'F1kRoj': '分類庫存詳情',
  'GQcXjn': '變動數量',
  'HWx2E7': '近1個年',
  'J6Ocmq': '運單',
  'Jz34C6': '是否需出庫採集實物條碼',
  'L8O+eh': '近7天日均銷量/近7天平均庫存',
  'M3MF3I': '最多上傳5張圖片',
  'MhOy8s': '至少輸入{num}個字元',
  'NQQAuQ': '調撥出庫',
  'O6N9fg': '近15天日均銷量/近15天平均庫存',
  'OXAH2B': '變動記錄',
  'Ore518': '倉庫DOI/國家DOI',
  'PmTJ7o': '若選擇採集服務時，萬邑通將在出庫環節採集對應的包裹條碼或協力廠商包裹條碼，採集完成後客戶可在出庫單資訊內進行査詢，請確認商品實物上存在對應的可採集的包裹條碼，否則將產生庫內异常。',
  'Qxf3/K': '單品條碼導入',
  'SDYfIP': '日期範圍最大為365天',
  'SmVbZ0': '待銷毀庫存詳情',
  'WHZ769': '在庫庫存詳情',
  'WsHvnq': '總數量',
  'XllRKa': '不按商品編碼/商品條碼或單據號査詢最多支持範圍為92天',
  'ZRBxht': '倉庫DOI',
  'bQOgOx': '變動日期',
  'dnJRgq': '倉租日期',
  'eu0qY9': '海外倉儲收費單號',
  'fSrpzL': '計費維度',
  'h+EgTN': '遺失確認中庫存詳情',
  'i2eYXn': '庫存數量最大值',
  'l/rrRH': '直發入庫',
  'lXOK3F': '庫存數量最小值',
  'lZ2LVa': '近30天日均銷量/近30天平均庫存',
  'o0NSNd': '記帳日期',
  'oMimBZ': '庫存分類調整',
  'vKjKIG': '請填寫海外倉儲收費單號或倉租日期',
  'wFphH6': '溫馨提示: 尊敬的客戶,庫存流水數據僅支持査詢近一年的數據。',
  'x9DBul': '待出庫庫存詳情',
  'xgiTGk': '貨權轉入',
  'GoU/8N': '退貨暫存未處理',
  'Y6FUe2': '査詢近15天的記錄',
  'AvNm7S': '應上架時間(當地時間)',
  'vbxo3L': '實際上架時間(當地時間)',
  'vkhDdQ': 'X/Y，X表示下發增值數量，Y表示實際完成數量',
  'wwoYQh': '增值數量',
  'hqz2lG': '訂單優先權',
  '9HYp2Y': '補充證書',
  'FgvNQH': '請先勾選待補充證書檔案的商品！',
  'GM7I33': '待補充證書檔案',
  'Ne2nfi': '批量補充證書檔案',
  'OKnjZ+': '下載補充商品證書檔案範本',
  'XDYV1L': '文件大小請勿超過10M，請壓縮後上傳',
  'e5PZ02': '支持10M以內的jpg，jpeg，png格式檔案',
  'kROGK4': '批量補充證書',
  'x3pfcJ': '請删除無效證書！',
  '08hJjN': '允許裝箱',
  '150bCw': '最大值必須>最小值',
  '1jI2sy': '選擇A包，默認允許裝成A+包',
  '29czDg': '只允許輸入大於等於0且2位小數的數字，請修改',
  'EHHXgx': '最大值',
  'EsJkLt': '發貨國家',
  'F3dI0f': '最小值必須<最大值',
  'G8A2UL': '裝箱限製',
  'HHJhh7': '包裹類型',
  'OZDdKy': '尺寸輸入規則：長=最長邊, 寬=次長邊, 高=最短邊',
  'PMguPq': '{name}只允許輸入不超過9999.99的數字，請修改',
  'RDvOwC': '包',
  'WZX4M+': '選擇B/C包，默認允許裝成A和A+包',
  'YIsl98': '最小值',
  'ZEg+9J': '裝箱規則',
  'fQudGk': '打包方式',
  'g9sUca': '包裹打包',
  'kLsmQn': '出庫裝箱規則',
  'nVsYMb': '查看WINIT的默認裝箱限製',
  'w0kW9n': '功能描述：使用者能夠依據訂單轉電商平台倉或第三方倉入庫時的收件規則，在這裡制定對應的裝箱規則。例如，依照訂單類型、收貨人類型、出貨國家等業務特性，對即將出庫的貨物進行分箱和裝箱操作。同時，也可以對裝箱後的尺寸與重量加以限制。系統會依據使用者所設定的規則，自動完成訂單的分箱和裝箱工作，從而滿足電商平台倉或第三方倉的收件要求，有效提升貨物在平台倉入庫的合規程度。 {break}註：系統依照訂單類型、收貨人類型、出貨國家等業務特性未命中您配置的裝箱規則時，倉庫打包時預設依照WINIT的裝箱規則來校驗是否符合出貨標準',
  'LR8Ac+': '壞賬期預估待還倉租（USD）',
  'JK3Fr7': '*此待還金額不包括在賬單待還金額內{break}壞賬期：{startDate}',
  'hGLhSe': '子訂單狀態',
  '5VL8XQ': '變動時間',
  '/ZyLUT': '由於供應商條款限制，此處僅展示近60天下單的數據',
  '4uSKD4': '無查件資訊',
  'KraNAc': '無索賠資訊',
  'ZsFmm2': '尾程異常明細功能說明',
  '96sxGJ': '組套條件',
  'MlJAC5': '同訂單內多套是否允許組套出庫',
  'xz7u99': '多套表示為2套及2套以上；{break}若配置為【是】則下單1件商品A，命中此組套關系，進行組套出庫，下單2件商品A，命中此組套關系，按2個組套處理；{break}若配置為【否】則下單1件商品A，命中此組套關系，進行組套出庫，下單2件商品A，不允許按組套處理，常規打包處理。',
  '+6+Mt4': '重算完成日期',
  '237gsE': '純電',
  '2IVSMv': '折後金額',
  '3RFPFO': '按SKU導出國家內每個倉庫的庫存數據',
  '3U2acT': '海外倉儲收費單號最多查詢500個，逗號或換行分隔',
  '5AvkeD': '是否投保商品',
  '5EM4lg': '庫位類型',
  '5NdmWL': '倉庫編碼',
  '6q/POx': '非電池',
  '9DHCGM': '重算備註',
  'Divclz': '是否高貨值',
  'DsCXA9': '庫齡(天)',
  'EPZLEX': '計費體積(CBM)',
  'GOfCC1': '扣費狀態',
  'KcgraU': '是否最小計費',
  'Mjamj2': '運單總體積(CBM)',
  'NlO+UH': '倉儲單明細',
  'OJzUfZ': '是否退貨',
  'OLcvb/': '#卡片商品',
  'ObUQSf': '導出SKU國家級庫存',
  'Oj70/T': '是否化工產品',
  'PwmGND': '導出數據只支持一個月，請將查詢時間段調整在一個月內!',
  'QdThDC': '是否DG',
  'URG50E': '折前金額',
  'UnOS5e': '重算後折後金額',
  'ZZrYbK': '是否特殊化工產品',
  'ZZsYN+': '內置',
  'a40x/v': '是否打托',
  'dM/4Cc': '庫存數量按SKU+國家合並，不顯示倉庫',
  'dTWKpE': '本次實收金額',
  'etS3Fs': '重算前折後金額',
  'fBupdr': '導出SKU倉庫級庫存',
  'fWVI6Y': '外置',
  'g+8vyF': '是否混合存儲',
  'gbXvkj': '上架時間',
  'lRACZW': '卡片商品',
  'murDIe': '電池類型',
  'o9bDiv': '是否批次管理',
  'pO9v22': '運單號',
  'qG6wc3': '客戶未維護',
  'r9bIiC': '第三方商品條碼數量',
  'rvynV4': '是否食品',
  'tbKn4n': '方案備註',
  'uESwgc': '折後單價',
  'vYSK/8': '出庫自提倉租單明細',
  'vl8z5u': '庫齡',
  'x/6PQh': '單個商品體積',
  'xr1IiE': '暫存日期',
  'z3yq8L': '庫齡段',
  'K0MNn8': '請切換主賬戶【{account}】查詢壞賬期的倉租明細',
  'N+Y3oq': '存在規格，不支持更新',
  'zz036a': '勾選選擇訂單內全部包裹，將自動帶出訂單的包裹明細；',
  '9BSdQ4': '您未開通A+包裹免自驗權限，驗貨類型不能選擇=客戶自驗貨，如需開通請點擊開通免驗按鈕開通，謝謝！',
  'laNzSC': '開通權限',
  '6U0Oxp': '地址類型',
  'Ku6RiZ': '不校驗',
  'cMFt3E': '地址校驗結果',
  'dg3g5T': '校驗通過',
  'lO4mGQ': '校驗不通過',
  'TWmlF4': '設置我的平臺',
  'ZGO+QQ': '出庫加卡片',
  'bawz6H': '卡片名稱',
  'grKzYm': '卡片編碼',
  'i+vMLC': '當您無法在當前下拉菜單中找到想要選擇的電商平臺時，請點擊此處設置您常用的電商平臺。',
  'nU2zG1': '張數',
  'tbT5Ro': '查看卡片的數量',
  'llaKUX': '萬邑通連結通途erp使用指南',
  '8h34cM': '主賬號',
  'NS6ZAt': '子賬號',
  'PQlTrS': '客戶ID',
  'W7TAOd': '請輸入昵稱',
  'fuyuYG': '最多輸入50個字符',
  'r2nMKU': '賬號昵稱',
  'tTpIu1': '文件大小不能超過{max}MB',
  'dXaoDL': '實際完成時間(當地)',
  'oyw7Aw': '預計完成時間(當地)',
  'mDab9A': '1、僅支持標簽紙打印，單次打印不得超過5000個，打印後請掃描測試。{break} 2、「打印文件生成設置」選擇「不同SKU生成單獨文件」時，會按打印的【SKU編碼】命名文件名稱，由於文件名不支持字符【 \\ / : * ? " < > | 】，則在生成的文件名時會自動忽略，請註意核對條碼信息，防止誤貼。',
  '+vbk++': '所有單品貼相同的標簽',
  '7cXxXG': '不同的商品貼不同的標簽',
  'Jc5Kpb': '不同的包裹使用不同的標簽',
  'YJXDjo': '所有包裹使用相同的標簽',
  'nYNtaU': '僅支持【大寫字母小寫字母數位- _（）+ / @ # . *】，請規範條碼格式。',


  '+cSl6d': '荷蘭',
  '+hC0sk': '該條件只針對eBay訂單生效',
  '+tkLmV': '店鋪狀態',
  '/fO7DP': '直接提交訂單',
  '0UNp8j': 'eBay',
  '0VccOb': '平臺賬號',
  '0qLmhP': '輸入的值必須是大於0',
  '16whGa': '訂單總金額範圍',
  '18gNnd': '如果該賬號存在已同步或發貨的訂單，停用後會導致跟蹤號上傳失敗等問題，是否確定停用？',
  '1RqymR': '{platform}授權',
  '1wUKTi': '訂單貨品尺寸=訂單中所有商品尺寸的總和{break}海外倉發貨：<a>商品匹配</a>成功的WINIT商品的核實長寬高體積重量',
  '2qD539': '授權協議',
  '4LK/OL': '設置發貨規則',
  '5XgRM0': '輸入的值必須大於等於0',
  '8m5tda': '埃及',
  '9w+ho+': '賬號',
  'A4xIfz': '優先級不能為空',
  'BE87UA': '訂單包裝方式',
  'DjVTN+': '確定要刪除選擇項嗎?',
  'Dm9v6u': '最小值不能大於最大值',
  'Eul4yJ': '意大利',
  'FGIg8D': '賣家 VAT',
  'G6SgR8': '買家支付的運費範圍',
  'Gel0iY': '基礎信息',
  'HHF8c2': 'Temu(合作倉)',
  'Ha+zt2': 'Amazon',
  'IDWBGn': '確認啟用嗎?',
  'Ij1E2t': '新增授權店鋪',
  'JIWrkV': '加拿大',
  'JPVi93': '開戶站',
  'Kc/Zlj': '授權到期時間',
  'L0LvY4': '系統優先匹配編號大的發貨規則。',
  'MIDhcI': '選擇條件',
  'MyB1Vf': '沙特阿拉伯',
  'P3nNds': 'WINIT-SKU編碼',
  'QRUdeg': '墨西哥',
  'R+nmnO': '收件人信息',
  'RclhRU': '已過期',
  'S5OXfB': '確認停用嗎？',
  'SnFLvY': '授權時間',
  'Sq+iw6': '已閱讀並同意以上內容',
  'Ulf4Sq': '印度',
  'V2qOuC': '距離到期還有<span>{remainingTime}</span>天',
  'V3B10z': '訂單貨品包含',
  'VWX2nS': '該winit產品需要買家前往萬邑通倉庫自提包裹，請知悉！',
  'WeINul': '訂單貨品限製',
  'YMjT8q': '新加坡',
  'Z4sh+T': '1、{platform}店鋪綁定多個ERP可能導致訂單重復發貨，建議只授權單個ERP進行訂單發貨。{break}2、在{platform}取消訂單或者退貨退款時，請檢查萬邑聯的訂單是否支持取消，擅自取消訂單導致的損失由您自行承擔。',
  'Zyc92J': '規則優先級',
  'aNVBIV': '法國',
  'bl+MC2': '買家支付的訂單總金額',
  'cDfqJs': '刪除後此賬號無法同步訂單，是否確定刪除？',
  'd7IajO': 'Prime訂單',
  'dO1aKB': '買家支付運費',
  'dtAVnP': '海外倉發貨',
  'fp4MWN': '日本',
  'fvYPww': '收件人信息(國家/(省份)州/城市/郵編)',
  'h70zPD': '西班牙',
  'hYtLJi': '發貨類型',
  'i18r6F': '已選條件',
  'iKSa2y': '訂單處理方式',
  'iKXJaG': '需人工審核訂單',
  'lYtwbc': '授權',
  'm8gGy1': '地址限製校驗',
  'mB5/6q': '重新授權',
  'mKU5ai': '訂單貨品',
  'me24Kc': '請至少選擇一項',
  'mmpcKu': '買家支付運費在',
  'nlsRat': '請至少選擇1項',
  'oIkTDz': 'eGD訂單',
  'odP40n': '請輸入大於大於0的正整數',
  'r1bZdF': '訂單包裹貨品尺寸(長/寬/高/體積/重量)',
  'tJ/j09': '如何獲取您的Client ID和Client secret，<url>點擊查看</url>',
  'tZXPgK': '訂單貨品尺寸=訂單中所有商品尺寸的總和',
  'u+irD5': '店鋪類型',
  'uxKWjC': 'Ontrac地址校驗不通過時，訂單需人工審核',
  'vVkHR3': '買家選擇的運輸方式',
  'vcSBZu': '巴西',
  'wYVAbQ': '訂單包裹貨品尺寸',
  'wiNgJe': '店鋪URL',
  'xaWTdZ': 'Winit訂單貨品尺寸(長/寬/高/體積/重量)',
  'yCUO83': '長/寬/高/體積/重量',
  'yXiaSw': 'PlentyMarket',
  'z4ZNAd': '電商平臺買家支付的運費，非WINIT運費',
  'zDbzKc': '訂單總金額在',
  'zmKE3v': 'Winit訂單貨品尺寸',
  'zrmbIW': '收件人公司（英文）',
  '+6dbt0': '銷售日期',
  '+TDdi+': '同步Tracking No.',
  '+g75jZ': '更改內容',
  '//LABL': '未匹配',
  '/QzWr8': 'shippingServiceName',
  '/WN1qt': '請求結束時間',
  '/XA51t': '沒有有效店鋪',
  '/YGKRs': '訂單提交日期',
  '/cWiGy': '請輸入大於等於0的整數',
  '/i/2WU': '預估費用(USD)',
  '/swJ78': '是否默認勾選【E_BAY_MOTORS】站點？',
  '/uC9lN': '已成功發貨{count}個',
  '/wP4kI': '返回發貨失敗列表',
  '/wYx9N': '獲取跟踪號後立即上傳',
  '/ykFIr': '訂單總價',
  '07ZsMQ': '請選擇退貨上架處理方式',
  '0BxjIA': '請勾選需要刪除的內容',
  '0NOsL9': '手動同步',
  '0O3sQ4': '不能選擇的產品展示',
  '0XzF3X': '自動同步訂單',
  '0lgQh9': '批量取消',
  '17OOxd': 'ShippingServiceName',
  '1DZFGW': '批量解除',
  '1E3TXK': '取消拆單成功',
  '1Eo3x5': '請先授權店鋪！',
  '1O2B7E': '您填寫的收貨地址被承運商驗證為"地址錯誤"，建議您修正地址後下單。{break}使用錯誤的地址下單可能導致包裹投遞失敗，同時產生地址檢驗/修正費用',
  '1ZCq9j': '出庫包裝方式',
  '1oMwGL': '解除',
  '1pa/Sg': '校驗國家、州/城市、郵編失敗您可以{a}進行查詢。',
  '1yjaIa': '不自動上傳Tracking No',
  '229O38': '收件人姓名填充',
  '2E1kQr': '當前發貨方式渠道產品建議您勾選ontrac地址校驗，下單校驗地址是否正確，會一定程度減少因地址錯誤產生的地址校驗附加費，增加妥投成功率哦',
  '2RN82t': '返回修改',
  '2WagLU': '提交發貨時，德國地址校驗不通過時，訂單需人工審核 <Text>(自動發貨和手動發貨都會校驗此限制)</Text>',
  '2dAmhv': '預計發貨日期',
  '2wdW7g': '去註冊',
  '2zl+/I': '賣家',
  '34Wlc/': '取消發貨日期',
  '36KE9A': '至少填寫1項，如需添加多個地區，則可以逐個添加下一條下單國家、州、城市、郵編必須與配置完全一致才能匹配',
  '36s7cj': '存在編輯狀態的商品，請先保存',
  '3RV/HR': '查看發貨成功訂單',
  '3Wv3pF': 'Tracking No.',
  '3iHW4o': '點擊查看 <url>如何獲取您的token</url>',
  '3tg6DW': '平台商品SKU',
  '3v6pY0': '訂單發貨',
  '47mZrU': '商品詳情',
  '49sNcx': 'Sale Price',
  '4da9dh': '是否指定範圍',
  '4fIBvJ': '停售',
  '4kkEGQ': '查看已發貨訂單',
  '4nzYdh': '保存到待人工審核',
  '4qleTw': '立即同步',
  '4zxOXq': '亞馬遜店鋪ID',
  '5/Py96': '合併收件人信息不相同的訂單',
  '5/Rszn': '忽略',
  '5G9UiG': '更新日期',
  '5MorV+': '只允許狀態為未下單和下單失敗的訂單下退貨單，請重新選擇！',
  '5UknIB': '平台同步將不同步winit跟踪號到ebay後台',
  '5av8fQ': '請選擇日期',
  '5c9FcU': '合併發貨',
  '5jKlmp': '自動發貨規則說明',
  '5oiTur': '同步商品數',
  '5rsaEc': '溫馨提示{break}請仔細配置亞馬遜渠道，配置錯誤將可能導致無法獲取亞馬遜面單等異常情況，請仔細檢查您的亞馬遜帳號如下：{break}1.配置的尾程派送供應商帳號必須與我司的倉庫地址一致{break}2.配置的ShippingServiceId(渠道代碼)海外關聯winit渠道編碼將應用於後續的發貨{break}3.關聯的萬邑通渠道必須準確(WINIT尾程帳號和您自有的尾程帳號對應的渠道代碼不相同)',
  '5zNZSS': '平台同步操作指引',
  '61Sghw': '收件人街道2',
  '67F4wY': '當前國家/產品不支持詳細地址校驗',
  '6EcXeL': '未發貨',
  '6ct4bd': '您的Token',
  '6fpQZR': '查看可用庫存',
  '6gb4KN': '註：自動發貨和手動發貨都會校驗此限制；物流費用包含出庫處理費、尾程派送費及其他附加費',
  '6qwXpP': '批量撤回',
  '6xd6//': '請輸入1~30位任意字符',
  '73tyqj': '確認拆單',
  '79bjkh': '稱呼+姓氏',
  '7McuUb': 'Item Location',
  '7Md/OB': '匹配發貨規則失敗{count}個{break}',
  '7ZWZR1': '近3天',
  '7gbiqq': '確認取消拆單',
  '7jV4Ao': '海外倉編輯發貨',
  '7mpTuJ': 'wish暫僅支援近7天，若時間範圍較大，需支援多次調用獲取訂單。',
  '7oHrmx': '平台商品條碼',
  '7srZ22': '當前地址下單',
  '81twis': '返回待審核列表',
  '8Dhcm2': '申報價值規則說明',
  '8GyebP': '確定批量刪除選中的商品嗎？',
  '8UQNUB': '以下商品已存在，無需重複添加',
  '8Yf49r': '去匹配',
  '8jOBpY': '輸入的值必須大於等於0，最多保留4位小數',
  '94xxej': '收件人門牌號',
  '98jk2k': '您尚未綁定任何帳號,請點擊 <a>綁定帳號</a>',
  '9A5e/t': '訂單異常原因',
  '9Hmbk+': '地址校驗',
  '9Vmjl1': '是否需要系統同步Tracking NO.至平台',
  '9ht+nd': '快捷選擇',
  '9xYxPs': '*以上費用為系統預估費用，最終收費根據出庫商品實際重量或體積計費。 部分費用無法預估，如地址相關附加費：住宅附加費、地址校驗附加費等',
  'A+Qk3q': '出庫產品',
  'A0KE+Q': '原訂單',
  'A7QEW1': '通過設置自動同步訂單規則，匹配商品並自動發貨規則，自動上傳跟踪號規則，或訂單信息替換規則等，系統將按照設置規則處理平台訂單',
  'AAcLUC': '提交發貨時，申報價值自動計算規則',
  'AEEoPg': '請選擇要確認的商品',
  'AFmlFB': 'CarrierWillPickUp',
  'AGCxbg': '出庫跟踪號',
  'AapBMy': '平台SKU',
  'Ah+hNu': '國家不相同，禁止合併訂單',
  'AjQYZ+': '設置庫存同步規則',
  'Ak5IcG': '中郵攬收',
  'Akqn+S': '確認要替換地址信息嗎？{break}原地址：{oldAddress}{break}新地址：{newAddress}',
  'Apabzu': '使用ReturnLabel',
  'AqNc7V': '平台綁定',
  'AswY/M': '地址更新',
  'B0s28p': '註：僅同步在Tiktok後台維護了seller-SKU的商品',
  'BGblXM': '輸入字符系統自動匹配SKU',
  'BgZm0W': '輸入的值必須大於等於0，最多保留6位小數',
  'C+Uxzp': '最多保留小數後6位數',
  'C0XdtD': '地址校驗限制',
  'CBne5X': '同步庫存',
  'CHw3qK': '暫無設定條件',
  'CQLU7A': 'eBay派送方式',
  'CSYChb': '數量不能大於可用庫存',
  'Ci0Gz7': '同步Tracking NO.',
  'Ck0FS5': '下單',
  'Cm99+l': '同步失敗',
  'CqjwTi': '取消訂單',
  'Cr2Er3': '國家城市郵編校驗',
  'Cr5YTm': '提交成功，請到待審核頁面查看詳情',
  'D76Z0a': '(默認展示最新50條記錄)',
  'DMJmu1': '平台售價',
  'DTDZKK': '注意：退貨無法退回DEBR2，選擇原倉退貨會導致無法上傳跟踪號',
  'DXA+RX': '該步驟必須配置，否則無法成功上傳退貨跟踪號',
  'DZ3tLQ': '訂單狀態統計',
  'DgbZbl': '上傳節點',
  'DgtsPS': '商品同步時間範圍',
  'E6sBKv': '不支持',
  'EII/T2': 'WINIT標準包裝',
  'EMN/3N': '您此次合併訂單中有如下合併項信息不同，請核對合併後信息是否準確，若信息錯誤請自行修改或取消此次合併。',
  'EYeeM/': '打包尺寸:長*寬*高(cm)',
  'EjwiL7': '批量取消訂單',
  'En+MQY': '發貨失敗{count}單',
  'EnXH4I': '僅待發貨/發貨失敗/待審核訂單操作',
  'EnmuEU': '商品條碼值重複',
  'EptF2N': '賣家ID不相同，禁止合併訂單',
  'F+TH2y': '姓氏+名稱',
  'F0/hCF': '稱呼+姓氏+名稱',
  'FERBzi': '詳細地址校驗失敗，原因：{info}',
  'FJb1Tn': '僅待發貨/發貨失敗狀態訂單操作',
  'FLVSid': 'Token已停用。推單、建聯、標發等全部功能已失效',
  'GA2pu4': '是否需要系統為您更新平台的庫存',
  'GCx4WP': '請在左邊選擇條件並設定',
  'GHgc0Z': '匹配商品並自動下單',
  'GM17E7': 'shopify唯一識別該訂單下商品的ID，用於向shopify平台確認發貨。若手動添加商品則無此信息',
  'GP5t2w': '查看原訂單商品',
  'GcJVRw': '不符合自動發貨規則的訂單將停留在未發貨列表。',
  'GeOOM8': 'prime訂單禁用該操作！',
  'H635Bj': '退貨winit產品',
  'HESoIq': '訂單處理規則',
  'HYFiGn': '返回待發貨列表',
  'HZFFbs': '指定退貨PSC',
  'HeCAli': '使用者ID',
  'HizwI7': '同步記錄',
  'HkNxGk': '同步中',
  'Hm4LpH': '僅未匹配狀態操作',
  'Hn2pQb': '賣家VAT',
  'Hy6d0p': '收件人公司非中文',
  'I3d4Gk': 'variation SKU',
  'I7S1fN': '是否需要系統為您匹配商品，匹配發貨規則，並自動下單發貨',
  'IHWpGJ': '添加拆分訂單',
  'IdgYMG': '請輸入信息',
  'IexirJ': '自動同步移除單',
  'IzzAhc': 'Token已被{platform}平台使用',
  'J0Ixtg': '已成功匹配發貨規則{count}個, 其中',
  'JFnjqm': '追加發貨商品',
  'JLs16Y': '申報價值用於國際派送<Text>(跨境清關，例如：德國海外倉派送至法國)</Text>和發票打印',
  'JNgnyH': '自動發貨校驗結果',
  'JTWY/n': '電商平台不含稅商品金額',
  'JUvp6d': '下單失敗',
  'JYmlWa': '退貨倉庫',
  'Jdb9OB': '賣家訂單號，雙擊切換到多個查詢',
  'JezdzU': '請先選擇倉庫',
  'K27qop': '全部導出',
  'K7rEg4': '訂單日誌',
  'KC5nMg': '添加下一條',
  'KQr9Qy': '發貨方',
  'Kl42ZO': '請填寫大於或等於0的數，最多保留2位小數',
  'KsxYm8': '商品刊登時間',
  'L6OOWH': 'Tiktok非美區域訂單，暫不支援按SKU數量拆分',
  'Lechn7': '合併訂單',
  'LgOGwZ': '是否需要系統同步Tracking NO.和return Tracking NO.至平台<Text>(同時獲取派送跟踪號及退貨跟踪號後，才上傳)</Text>',
  'LkEeD0': '可拆分數量',
  'Lo+WTc': '賣家自送',
  'LoPdId': '請先選擇訂單',
  'LzQ0Lw': '確認刪除？',
  'M3GU+Y': 'Winit出庫單號',
  'MIpscV': '同步訂單後，當Winit預估物流費用大於設置值時，訂單需人工審核 {break} <Text>(自動發貨和手動發貨都會校驗此限制；物流費用包含出庫處理費、尾程派送費及其他附加費)</Text>',
  'MNIlmV': '時間範圍不能超過7天，請重新選擇',
  'MYg06i': '產品庫存 Token',
  'MYkSIE': '批量確認',
  'McIP0t': '商品售價',
  'McrsRy': '檢測到平台訂單地址與當前頁面提交的地址信息不一致（訂單：{orderNolistStr}），是否需要使用平台最新地址下單？{break}若您已編輯地址，使用當前地址下單即可。',
  'Mg0AQc': '取消拆單',
  'MsI/sQ': '平台售價：0<可填寫的數據（2位小數）≤100',
  'N17kGs': 'Winit預估物流費用大於(USD):',
  'N4+kjM': '你好，Winit已完成{platform}海外倉認證啦!{break}{break}第一步，請先閱讀授權協議並同意授權獲取信息{break}第二步，在{platform}平台補充Winit的帳戶信息{break}{break}操作完成後，{platform}平台將獲取你的海外倉相關信息，並推送訂單和商品信息',
  'NDWefD': '退貨目的倉',
  'NtMJWV': '同步完成',
  'O/h+jI': '是否需要系統同步Tracking NO.至平台<Text>(獲取跟踪號即上傳)</Text>',
  'O06joR': '自動發貨不通過/異常信息',
  'OXsNWP': '批量發貨',
  'OeDSof': '請先選擇同步時間，再操作導出。{break}同步時間範圍最長支持一年，如時間跨度較大請分批查詢再導出。',
  'Oo2KiB': '提交成功{successNum}，提交失敗{failNum}。',
  'Ozld0E': '平台帳號及站點',
  'P9tr6t': '履行小時數',
  'PBGuz3': '波蘭',
  'PBjcAH': '平台商品狀態',
  'PO2HVG': '退貨訂單',
  'PvtavC': '平台商品名稱',
  'Q7ENee': '關閉指引',
  'QI6Ef9': '平台商品規格',
  'QKEWl2': '導入匹配',
  'QMaIOh': '優先級(執行順序從大到小)',
  'Qbz3hj': '本本店鋪',
  'R/w0JS': '商品總價',
  'RIGInR': '發貨成功{count}單',
  'RMDKuM': '包裹出庫時上傳',
  'RWLdD9': '請選擇2到20個訂單進行合併',
  'RY1yFe': '作廢退貨單',
  'Rrqg+Z': '去授權>',
  'RsiyM6': '通過配對平台商品和WINTI商品，建立二者匹配關係，後續同步訂單發貨會根據匹配關係處理實際發貨商品及數量',
  'S39LBS': '注意{break} 1、單次導入最大支持3000條數據，請分批導入。{break} 2、暫僅支持對未匹配的平台商品批量匹配，導入後自動確認已匹配。{break} 3、若存在一個平台商品需要對應六個及以上的WINIT商品，導入暫不支持請手動完成匹配。{break} 4、Shopify、Wish平台店鋪帳號請填寫店鋪ID，詳見帳號管理。{break}',
  'SFPZaI': '訂單範圍',
  'SMwamU': '關聯winit渠道編碼',
  'SPja2U': '訂單同步規則說明',
  'SVtGPL': '訂單處理失敗的原因',
  'SdW6D2': '同步{platform}商品',
  'Sda2Eq': '請先保存正在編輯的商品',
  'Sr3ung': '前綴',
  'Srv1tz': '設置自動退貨規則',
  'T/rcpD': 'Token暫未被{platform}平台使用，請及時去平台綁定並完成授權',
  'THApeX': '手工匹配',
  'TL7VCA': '買家派送方式',
  'TVU/FV': '合併項',
  'TfyJrx': '收件人公司',
  'Tiq/oz': '未指定查詢商品',
  'TqtWP4': '是否確認撤回？',
  'U+SXZR': '僅待確認狀態操作',
  'U0/tzD': '合併前',
  'U7Ceox': '物流費用限制',
  'U8Pz8g': 'IOSS全稱是進口一站式服務，是歐盟為減輕低價值貨物清關壓力，簡化相關手續。 {break}1.英國發歐盟，IOSS NO，根據渠道要求是否必填。如DPD',
  'UAX0mp': 'WINIT揽收',
  'UWXTRM': '目前僅OTTO和PLentyMarket平台需配置退貨規則，其餘平台配置無效',
  'UjYJFb': '僅取消發貨訂單操作',
  'UnMDmI': '請輸入數字',
  'UsHCy4': '拆單發貨',
  'VVeUFY': '暫最多統計近3個月訂單狀態流轉數據，統計為拆單或合單後的訂單數',
  'VchMSg': '請先設置收件人郵箱替換規則，才可啟用',
  'VoFDc0': '自動同步',
  'VuHi5g': '請輸入12位及以上的數字或字母',
  'WElSYV': '編輯發貨',
  'WN8E36': 'Winit商品編碼*數量',
  'WNHZoW': '亞馬遜',
  'WNLBrz': '需在WINIT註冊商品，用於商品數據管理並和平台商品建立聯繫',
  'WQKhi4': '您尚未綁定任何帳號,請點擊{a}',
  'WUjg/Y': '查看發貨失敗訂單',
  'Wdn3bR': '提交成功{successNum}，提交失敗{failNum}。<br/>失敗的導入數據和失敗原因<a>點擊下載文件</a>',
  'WonkyG': '收件人電話為空替換',
  'WtVOWa': '同步訂單',
  'X+pVqZ': '整數位長度不能超過10',
  'X7hfpR': '待人工審核',
  'X84Qes': '出庫單信息',
  'XC4iyK': '請編輯商品添加條碼值',
  'XIqLuH': '訂單包材類型',
  'XKNWZ0': '暫未設定條件，將默認全部訂單。',
  'XSkCPJ': '訂單最後更新時間',
  'Y1GIwR': '可按需啟用平台，平台啟用後可授權店鋪',
  'Y6c2bc': '訂單發貨 Token',
  'YHGW8s': '至少輸入2位',
  'YOKKP9': '請選擇要解除的商品',
  'YPwzdO': '查看取消發貨訂單',
  'YUC7c3': '賣家自定義訂單號',
  'YfisbY': 'DeliveryExperience',
  'Yq2JvZ': 'eBay每個帳戶每5分鐘僅可以請求同步一次!',
  'YycnMl': '確認啟用嗎？',
  'Yz3osq': '已同步',
  'Z12huF': '收件人信息禁止超過10000條，請刪除後再提交',
  'ZDBa84': '店鋪授權',
  'ZKTxLl': '最新地址下單',
  'ZPrnCX': '請選擇條件圈定訂單範圍',
  'ZSQdnW': '您還未授權店鋪，請先選擇平台再新增授權店鋪~',
  'ZbMlwg': 'winit渠道名稱',
  'ZcEOKe': '獲取',
  'Zd3tQ1': '只允許狀態為未下單和下單失敗的訂單可以取消訂單，請重新選擇！',
  'ZmVDi/': '增值服務選項',
  'ZphZQT': '平台同步將在跟踪號生成後立即上傳到ebay後台，並在包裹出庫時再一次同步跟踪號到ebay後台',
  'Zu7b47': '您本次操作將會解綁平台商品ID：{platformItemId}匹配關係。請確認！',
  'a1lp3z': '以下是建議地址，請與收貨人確認後再參考使用',
  'a1xnWp': '去設置',
  'aQCUfC': '賣家ID',
  'b/xWVl': '拆分數量',
  'b0To7i': '出庫單的倉庫和winit產品',
  'b0fqEV': '發貨信息',
  'bAi39D': '在售',
  'bBDPB+': '執行完畢',
  'bT3oxz': '未下單',
  'brIRvh': '匹配狀態',
  'bt6uNU': '承諾最晚送達時間',
  'c8Qmll': '拆分數量必須大於0正整數，且不能大於可拆分數量',
  'cC9GYY': '同步訂單後，收件人姓名填充規則配置',
  'cLWCG2': '平台同步將在包裹出庫時同步跟踪號到ebay後台',
  'cee+ea': '請輸入小數或整數',
  'cjf5im': '訂單總金額',
  'd7t1vH': '設置自動發貨規則',
  'dL7/Cj': '確認合併',
  'dOHXx8': '確定要撤回這些訂單到待發貨？',
  'dRv2q5': '同步時間',
  'dUKR8B': '收件人郵箱替換',
  'dlf0KO': '州',
  'dn8dx4': '出庫單的倉庫',
  'dxKF+V': '同步訂單發貨',
  'e++uU2': '買家郵箱',
  'eM8arj': '添加商品',
  'eMX0XN': '平台Carrier',
  'eN8cMr': '重新下單',
  'eZqSrm': '僅待審核訂單操作',
  'ehBnJY': '優先級必須大於等於0的整數',
  'f5iZGp': '美區',
  'f7E98A': '幣制',
  'fNjlMU': '收件人州',
  'fO5GuU': '發貨失敗{count}個',
  'fSGNZz': '比利時',
  'fSMR28': '訂單量',
  'fSloUl': '通過手動同步或開啟自動同步規則，可同步平台已付款未發貨的訂單至待發貨狀態。可手動下發海外倉出庫單，也可匹配自動發貨規則後自動下出庫單',
  'fbyUZc': '正在同步中，請稍後回來查看',
  'fem61w': '退貨跟踪號',
  'fv+irj': '或',
  'fvi6kx': '當收件人填寫的電話為空時，自動替換為配置的電話號碼進行下單',
  'g98DW3': '歐區',
  'gIYz64': '是Prime',
  'gQakVR': '您在{platform}已經標記發貨，無法重複發貨，您可前往{platform}確認；點擊下方按鈕跳轉查看取消發貨訂單。',
  'gT+x6j': '是否需要同步更新訂單信息：收件人信息、備註 <Text>(僅未發貨狀態才會更新)</Text>',
  'ggZsT6': '信息授權協議',
  'gnb/Dv': '優惠金額',
  'h8NAxo': '付款時間',
  'hJNaRw': '平台倉庫和渠道',
  'hb7p0K': '是否需要系統為您匹配商品，匹配發貨規則，並自動下單發貨<Text>(僅同步在Tiktok後台維護了seller-SKU的商品)</Text>',
  'hboJsJ': '新增收件人信息',
  'heFsnp': '同步已授權店鋪',
  'hf/k0S': '計費體積:單品體積累加(CBM)',
  'i/tHnC': '原平台訂單已被拆分為以下訂單。取消拆單後，如下已拆分的訂單將一同合併（合併後可重新拆分）',
  'iAgwMn': '買家信息',
  'iC2h7q': '僅待確認狀或已匹配狀態操作',
  'iSBznD': '請先選擇Winit產品',
  'iSi/Y2': '設置退貨規則',
  'icjeQH': '單個添加',
  'ihL77X': '確定批量確認選中的商品嗎',
  'j54HZ6': '即將過期，請重新授權',
  'jCDWTA': '確定要取消發貨以下訂單？',
  'jCc8SG': '{platform}：{value}',
  'jM4EZZ': '該Token僅用在{platform}綁定認證倉使用',
  'jNSZhB': '同步方式',
  'jSChCD': '閱讀並同意<url>《授權{platform}查詢協議》</url>',
  'jdWfuo': '店鋪名稱不能超過最大{max}個字符',
  'jmJUwg': '產品渠道已更新，請更新自動發貨規則中配置的產品渠道或重新選擇產品渠道下單，謝謝配合。',
  'jumY2+': '計劃退貨數量',
  'k1SuG1': '替換為：',
  'k3KmwO': '提交海外倉出庫單成功後，同時自動創建退貨單',
  'k4V29T': '訂購數量',
  'k5K6Yt': '合併後(可修改)',
  'k6yicO': '是否擔保訂單',
  'kGU7zi': '請輸入數字,並保留兩位小數',
  'kpSBU0': '點擊這裡',
  'kw4Idh': '已提交至待人工審核{count}單',
  'l1E5Kc': '是否確認取消發貨？',
  'lXd3or': '{platform}平台暫無有效的授權帳號，請先完成店鋪授權，{a}',
  'lcVkcM': '確認作廢退貨單？',
  'ljCEOy': '自動更新訂單信息',
  'lkf5xf': '賣家VAT號，需先註冊進口商[個人中心-服務設置- 出口商/進口商管理-查看-VAT信息-VAT] {break}1.英國發歐盟，歐盟發英國的訂單，根據渠道要求是否必填 {break}2.渠道未要求必填的訂單，如為英國出庫訂單，可填寫',
  'lliahm': '更多設置',
  'm15yzY': '請輸入1~128位任意字符',
  'm7WXxa': '發貨時間',
  'mF20Qh': '已發貨',
  'mIbw6U': '收件人公司(英文)',
  'mIw63f': '您本次操作將會確認平台商品ID：{platformItemId}匹配關係。請確認！',
  'mKK9WT': '只允許作廢狀態為已下單的訂單，請重新選擇！',
  'mSoKQe': '設置訂單發貨規則',
  'mmi+vH': '發貨商品信息',
  'n0Xfv5': '後綴',
  'n0kndm': '確認取消退貨？',
  'nHit3N': '請選擇退貨winit產品',
  'nLUS2T': '多個賣家訂單號換行或英文逗號隔開，最多支持{num}個，雙擊切換到單個查詢',
  'nQ+LR9': '使用Return label',
  'ndq6Ec': '待審核{count}個',
  'ngk71+': '退貨Winit產品',
  'o4g7EG': '訂單詳情',
  'oR7wAu': '拆分訂單',
  'odb5gY': '商品更新時間',
  'oibt/1': '增值服務項',
  'oud2NS': '售出時間',
  'p6hoaM': '發貨日期',
  'p8ioIZ': '自動發貨校驗不通過原因',
  'pLhC09': '您填寫的收貨地址被承運商驗證為"地址錯誤"，建議您修正地址後下單。{break}使用錯誤的地址下單可能導致包裹投遞失敗，同時產生地址檢驗/修正費用。',
  'pQhPvh': '公司(英文)',
  'pjDaex': 'custom Label',
  'pqJzJ3': '確定批量解除選中的商品嗎？',
  'prz34V': '您是否需要自動同步更新移除單商品明細數據以及移除單跟踪號信息',
  'pyWapc': '發貨倉庫',
  'pztUhO': '批量導入匹配',
  'qWV6JF': '同步訂單後，當Winit預估物流費用大於設置值時，訂單需人工審核',
  'ql8RgO': '您需登錄OTTO後臺，配置退貨routing code / 路由ID信息',
  'qo/NLW': '已發數量',
  'rOme4B': 'ShippingServiceId',
  'rPf5tI': 'prime的訂單和非prime訂單需要分開發貨，請仔細檢查後重新發貨。',
  'rUBnXV': '確認停用嗎？停用後平台推單、建聯、標發等全部功能將失效，請先在平台取消授權後再停用',
  're1+gV': '請先選擇退貨倉庫',
  'rhr13R': '提交訂單',
  'rtGwlf': '含有增值服務',
  's+OaHz': '包材',
  's7H+Ea': '原發貨倉',
  'sH465R': '下單信息的國家州城市郵編必須全部匹配成功才能校驗通過{break}只導入(國家/州/城市/郵編)不相同的收件人信息',
  'sLcGyn': '查看配置操作說明',
  'sNnZ4Y': '發貨失敗',
  'seO722': '請先設置計算規則，才可啟用',
  'slMFds': '出庫單的winit產品',
  't5QiVF': '訂單處理',
  't9JxrU': '您尚未綁定任何帳號，請點擊<url>綁定帳號</url>',
  'tXGo6k': '請求開始時間',
  'tcek4x': '詳細地址校驗',
  'tiQ2lL': '自發快遞',
  'tiReS9': '配置退貨承運信息',
  'toZ02P': '發貨成功',
  'tr8ieB': '近1天',
  'trwfSO': '請先選擇需要拆分發貨的商品，然後添加拆分訂單',
  'tx3VX': '同步時間範圍',
  'u7KD5S': '主單中至少存在一個商品，請重新拆分',
  'u7ocgU': '同步訂單後，收件人郵箱替換規則配置',
  'uAu2Dr': '輸入的值必須大於等於0，最多保留2位小數',
  'uB9dmc': '當前帳號暫無<strong>{menuName}</strong>菜單權限，請聯繫主帳號開啟',
  'uDkDxI': '商品範圍',
  'uK/6iw': '退貨上架處理方式',
  'uLupxE': '是否需要系統自動同步訂單至訂單列表',
  'uRbIR3': '確認授權',
  'uiMchU': '買家ID不相同，禁止合併訂單',
  'v1KiUu': 'Winit商品明細',
  'v3+E+w': 'Winit退貨單號',
  'vAgZTZ': '已拆單',
  'vBf++D': '請先通過國家城市郵編校驗',
  'vDASuh': '該收件人信息已存在，請不要重複添加',
  'vH/+mg': '已選中{count}個訂單，是否對選中的訂單重新執行自動發貨規則？',
  'vOev4X': '平台訂單詳情',
  'vWi3Vl': '確認取消訂單？',
  'vcHJ25': '必填項僅支持英文和數字',
  'vfp0r9': '確定要撤回以下訂單到待發貨？',
  'vg7n2N': '商品匹配',
  'voSiwO': '收件人街道1',
  'vrfKdo': '平台父SKU',
  'vvpREo': '重新匹配規則',
  'w1k3VB': '跨境店鋪',
  'w2H7cS': '平台子SKU',
  'w9f6F7': '退貨單狀態',
  'wazdM3': '訂單更新時間',
  'wiyRvq': '請先勾選商品並確認商品數量',
  'xFL39V': '運費',
  'xJtYaX': '授權信息',
  'xK+WAG': '賣家承諾送達日期(北京時間)',
  'xMN2jr': '拆單',
  'xRG5/O': '訂單金額',
  'xRbMLs': '設置規則',
  'xcXdOz': '設置訂單匹配規則',
  'xjgdRa': '請選擇要取消的訂單',
  'xoqs73': '暫無建議地址',
  'xrEY+m': '店鋪帳號',
  'y27XLJ': '已匹配',
  'y8FQY+': '買家派送類別',
  'yCEYqm': '拆單成功，請在未發貨-拆單發貨中查看拆單信息',
  'yDkttN': '當前國家不支持城市郵編校驗',
  'yVcad6': '提交海外倉出庫單成功，同時創建退貨單',
  'yeFbaK': '去平台查看',
  'yqcSAM': '同步訂單數',
  'yz+0WG': '查看待審核訂單',
  'z4UtzG': '當前地址校驗結果為不通過，建議您與收貨人確認後選擇推薦地址下單',
  'z54KMO': '拆單後，若拆分的任一訂單已發貨則不可撤回。已拆單的訂單不支持合並發貨',
  'z6dNPk': '訂單異常情況',
  'zFjwI6': '商品編碼*數量',
  'zWGfdT': '確認撤回？',
  'zZW2wr': '完成授權店鋪後，可以在平台同步系統中操作對應平台的相關功能：同步訂單、同步商品、上傳跟踪號標記發貨等',
  'zk7SMq': '請先拆單',
  'zygLEO': '訂單創建時間',
  '+O4tBd': '取消訂單',
  '7LJCdw': '合作倉對接',
  'FQtWyC': '常規對接',
  'Tmj1qg': '優先級不能超過最大{max}個字元',
  'ks/AJB': '常規對接合作平台： {platform} 等',
  '6nPEWw': '同步庫存規則說明',
  'bMei6Y': '合作倉對接模式平臺：{platform} 等',
  'ezoUFi': '常規對接合作平臺：{platform} 等',
  'fbUD56': '部分平臺支持設置訂單處理規則，詳見平臺操作指引。需要在平臺商家後臺中完成操作',
  'rhY6/6': '完成授權店鋪後，即可獲取相應token。需要在平臺商家後臺中完成那定授權操作',
  'txPox+': '匹配平臺商品和WINIT商品，建立二者匹配關系。需要在平臺商家後臺中完成操作',
  'Fil2JU': '查看{platform}操作指引',
  'gb6L3E': '完成配置操作後，平臺會自動同步訂單,並自動下出庫單。{break}註意：此類訂單不會展示在平臺同步菜單，訂單下發成功請在出庫單模塊中查看，訂單下發異常請在平臺後臺中進行修正後重推。部分平臺操作有差異,詳見平臺操作指引',
  'SLH3v0': '費用設置為0時將不會判斷限製規則，若需人工審核請設置大於0數值',
  'LnpBHN': '時效標記',
  '+F2ixr': '時效標記是指訂單適用的時效保障服務，與訂單選擇的通路或加值服務有關，具體請參考WINIT產品定義',
  '8A3iSu': '您設定的1個電商平台ID【{winitItemSku}】發出【{winitItemQty}】個【{winitItemName}】{break}',
  'u1MvPk': '1. 系統會在每月1號自動生成海外倉賬單，每週一自動生成ISP賬單。過此時間還未生成賬單，則請聯繫客服。 {break} 2. 獨立賬單&本期支出-本期收入不為0可開具電子發票。 {break} 3. 2025年02月01日後發票合規管理後，預開票+後開票的總開票金額超過累計至當前的消費金額時不得開具發票。 {break} 4. 發票和賬單相關問題，請聯繫在線客服。 ',
  'XVpiwO': 'BC包裹條碼數',
  '+/g10t': '出庫單銷售平臺',
  '/2o3AV': 'Seller ID',
  '0dJ1P8': '實物商品編碼',
  '0djqyQ': '請務必在貨物到倉前維護退貨跟蹤號，否則貨物有風險流轉為無主貨。',
  '0rwflq': '是否Return Label',
  '11Fc73': '檢查結果為不良品',
  '1UKfTS': '退貨商品({originalMerchandiseSerno})的庫存已經不存在，無法關聯商品，如有疑問請聯系客服，確定提交後該退貨商品的狀態將更新為已完成，是否確定？',
  '1b6W7N': '出庫單子單號',
  '1qoi3T': '圖片',
  '2L6ati': '退貨',
  '2LDGUc': '超期自動銷毀時間',
  '2hr1of': '拍照模版類型',
  '2ll590': 'RMA號',
  '2smMkx': '退貨處理時間',
  '3QNffE': '處理時效',
  '3pTMyj': '發件人信息',
  '5IfCJO': '請填寫大於0的數字，最多保留4位小數',
  '5hMlW2': '註意：{break} （1）商品需完成註冊並審核通過，才能創建退貨單。{break} （2）商品化管理的商品，實物到倉前，如能提供第三方商品條碼在商品管理頁面維護，確保倉庫收到實物時能夠掃描識別；{break} （3）單品化管理的商品，若下單時無法提供，實物到倉前，如能提供第三方單品條碼，務必在庫存單品管理頁面維護，確保倉庫收到實物時能夠掃描識別；{break} （4）若實物上無有效識別的第三方條碼信息，則倉庫收貨後會根據商品無條碼的異常策略進行處理！',
  '5n9upP': '商品級客戶定製拍照模版',
  '68BAPH': '增值服務單',
  '68cqkQ': 'RM碼',
  '6pLkXQ': '州省',
  '6vnHwd': '請輸入SKU編碼, 支持模糊搜索',
  '7/Gips': '處理意見',
  '799kEA': '修改時間',
  '7P6gF1': '下單成功',
  '7UH/y2': '確定提交',
  '7hpKK4': '客戶關聯SKU後，倉庫將退貨商品RM標簽更換為關聯的SKU M碼標簽，並移庫到良品區上架。',
  '7iUz69': '良品處理方式',
  '8Dirwm': '自動銷毀時間',
  '8TwOhb': '是否空包',
  '8cDIeY': '針對目前海外倉退貨需求，萬邑通提供無RMA退貨服務，幫助您完善退貨管理，接收未進行退貨預報的貨物，以便您及時處理您的退貨庫存。',
  'A+jWI7': '創建類型',
  'A63PcF': '暫存時間',
  'AICkca': '定製拍照模版',
  'AlOOoT': '最少支持上傳1張，最多支持上傳15張模板圖片！',
  'B6Z4Gq': '快速退貨地址',
  'BDCdKO': '檢查結果為不良品處理方式',
  'BQ2Et0': '選擇關聯商品',
  'BWdJmA': '請務必將以下WINIT退貨中心地址（已包含專屬退貨ID）維護至您的銷售平臺退貨地址或提供給您的買家，帶有退貨ID的地址將利於倉庫識別出您的退貨訂單。',
  'BnGVAl': '卸貨跟蹤號',
  'BvC0EG': '客戶下單',
  'C72hoh': '請註意完整填寫退貨地址信息及標號',
  'C8dc7/': '補充退貨跟蹤號',
  'CeXPpD': '是否投保',
  'D1zVXx': '照片已維護',
  'DBKT4U': '供應商',
  'DBrCz6': '客戶退貨跟蹤號',
  'DdDnkx': '退貨中心倉庫地址',
  'Dgc9tF': '發件人名稱',
  'DlRW4A': '無RMA（無預報）退貨指引',
  'ECxCyh': '對應處理方式',
  'EqPEoU': '新復製商品編碼',
  'F+1Ly6': '原卸貨跟蹤號',
  'F97OGz': '根據出庫單號:[{orderNo}]查詢出庫單失敗',
  'FCSu4h': '退貨數量',
  'FRKa5V': '倉庫備註',
  'FTSLqN': '郵編【{postCode}】無可用提貨日期 ！',
  'G66ewv': '分類',
  'GbI2f+': '實際拍照數量',
  'GmWdlP': '退貨商品({skuCode})的庫存已經不存在，無需再銷毀，確定提交後退貨單內對應商品狀態將自動更新為已完成，是否確定？',
  'HcO8E9': '發件人姓名',
  'HuoMXG': '此處商品級策略默認取訂單基礎內填寫策略，支持修改，此處商品級的策略優先級高於訂單基礎信息內填寫策略。',
  'HyER60': '被關聯商品信息',
  'ILbEkr': '去註冊新商品',
  'IOP/vU': '出庫數量|可退貨數量',
  'IsemUS': '出錯行號',
  'Jpz9XQ': '查看退貨增值信息',
  'Kf7UU1': '不良品處理方式',
  'Kv61+4': '派送供應商',
  'KwuNUe': '批量處理',
  'LZMJSc': '實物識別條碼',
  'NTRE6D': '查看退貨增值單',
  'NcB8kv': '維護方式',
  'OAUF/v': '（4）有RMA退貨提交訂單必須在貨物到倉前提交，否則有可能被判定為無主貨。',
  'ODaCbS': '配送時效',
  'ON6UqU': '暫存商品條碼',
  'OeMOhC': 'RM碼尺重大於被關聯的商品的核實尺重,則會更新被關聯商品尺重請謹慎選擇!',
  'P0LBOd': '處理',
  'PozUc+': '已退回',
  'QBKGFh': '批次屬性-日期-產品批次號',
  'QYLVrI': '提示：批量維護後，此次您所選擇商品的相關歷史照片模板將會清除，系統將采用您此次維護的作為照片模板。',
  'Z+MCSG': '註意:{break} 若退貨面單上無退貨ID，且商品無可識別的有效條碼，貨物將會被判斷為無主貨。{break} <font>為避免無主貨的產生和享受更優的退貨處理時效，推薦您使用萬邑通的Return Label服務或有RMA退貨服務。</font>',
  'Qgy4xA': '商品退貨策略',
  'R/Mgye': '溫馨提示：重新上傳會清空原添加的商品信息',
  'R1WVaq': '使用 Winit Return Label服務',
  'RCHqIg': '包裹尺重信息[長*寬*高 重量]: {length}cm*{width}cm*{height}cm {weight}kg',
  'RHHueZ': '請輸入退貨數量',
  'RdnRuz': '包裹尺重信息',
  'RgICGS': '選擇的關聯SKU',
  'Rl/75p': 'Return Label',
  'SdbY82': '子出庫單號',
  'SopSUH': '檢查結果為良品處理方式',
  'T0dYfd': '退貨跟蹤號允許輸入數字、字母和符號，6-60個字符',
  'T29xwd': '增值服務單號',
  'T9MdWR': '僅對 UK & DE 有效；如選擇，則該訂單下所有SKU適用該VAT。',
  'USFimD': '下單數量 | 實際上架數量',
  'UTeJqS': '原跟蹤號',
  'VN6BbB': 'RM碼重量',
  'VgURQV': '退貨暫存商品處理',
  'WZUGRX': '是否測量尺重',
  'X7zovx': '退貨子出庫單號',
  'X9Kqav': '檢查結果為良品',
  'XDxd9e': '實際上架',
  'Y1zy+s': '倉庫將退貨商品銷毀。',
  'ZEB0yN': '倉庫收到的原商品是批次管理商品，被關聯的商品不是批次管理商品，是否確定關聯？',
  'ZTSz4Y': '您輸入的商品編碼不存在，請關聯已經有的商品，請修改商品編碼，或註冊新品後再關聯新品。',
  'a381GD': '待補充退貨跟蹤號',
  'a4hXYh': '收貨倉',
  'bNrg6s': '退件實物條碼',
  'bg+pto': 'RM碼尺寸',
  'c9TJu9': '請填寫大於0的數字，最多保留2位小數',
  'cEA4zF': '修改者',
  'cYlsil': '客戶自定義模板',
  'd9R845': '退貨策略',
  'dgvdrA': '實物條碼對應SKU編碼',
  'dr93it': '下載面單',
  'e0QLxL': '模版拍照數量',
  'eV1I2k': '退貨原因',
  'eZPZ8+': '銷毀出庫單號',
  'eihkgE': '暫存商品信息',
  'fRQ7Hv': 'Scan標識符',
  'fcWN+y': 'WINIT截取',
  'flwayn': '出庫子單號',
  'g2+Ax2': '發件人詳細信息',
  'gwfFoI': '客戶關聯SKU後，退貨商品保留原RM標簽，移庫到不良品區上架。',
  'hGqR3l': 'VAT Onwer',
  'hsQeVV': '總費用（USD）',
  'i3I/pa': '待維護',
  'i8C1qO': '有RMA退貨地址須包含RMA號，將在創建訂單完成後返回。',
  'iJHRJg': '（5）AU Warehouse退貨地址為郵局POBOX地址，僅支持使用AU Post服務退回該地址，若使用AU Post之外的服務退回請聯系在線客服獲取其它退貨地址。',
  'j91Q75': 'SKU編碼[{searchText}]規格[{specification}]{status}，請使用其他SKU編碼！',
  'j9u2yH': '客戶備註',
  'kICF+A': 'WINIT訂單號',
  'kMLdYw': '訂單備註',
  'kPaZ+K': '重置為出庫單收件人信息',
  'keDN3D': '退貨下單策略',
  'l62Oqo': '取件日期',
  'lCL7h7': '處理費用',
  'loevIq': 'Winit產品及費用預估',
  'mLt8j5': '退貨完成時間',
  'mlgAHz': '關聯的商品編碼',
  'mrYK6Z': '退貨商品圖片',
  'nKLIK1': '關聯商品',
  'nq2M/N': '請填寫新復製商品的SKU編碼，該SKU僅適用於退貨維護',
  'oGfEgE': '退貨數量不能大於可退貨數量',
  'p4wQ31': '無法提供並取消代辦',
  'pAhBaD': '商品名稱(中/英)',
  'pGYuf8': '規格型號',
  'pLESa/': 'WINIT退貨中心接收貨物且能識別到貨主後將自動創建退貨單',
  'pSpGmB': '倉庫增值處理中',
  'qExiwC': '郵箱格式不正確',
  'r4aetI': 'Winit截取跟蹤號',
  'rFU4fG': '預計完成日期',
  'sNUB3N': '客戶待處理',
  'sVETw+': '退貨拍照模板',
  'stoffA': 'VAT Owner',
  'sy+pv5': 'Email',
  't7FHVM': '確認作廢嗎？',
  'tGXMLl': '退貨單品數量',
  'ts37H5': 'VAT/EORI',
  'uADqqT': '退貨商品信息',
  'udsQe8': '拍照時間',
  'v/3ZQu': 'WINIT出庫',
  'vFVpcn': '未發布',
  'vH85CS': '非WINIT出庫',
  'vW2S+F': '不良品上架商品在出庫時不能與良品同出庫單出庫',
  'w1PwZD': '發件人基本信息',
  'wBTrH2': '取件偏好地址',
  'wfl9ZM': 'Winit 訂單號',
  'xCdMfz': '非必填項，僅針對 UK & DE 有效，如指定VAT，所有商品按此VAT入庫，否則按系統規則分配。',
  'y0wTBC': '買家',
  'y9b1P7': '最多支持上傳{maxCount}張模板圖片',
  'yJeaIT': 'WINIT退貨中心將按照無RMA退貨處理策略進行處理',
  'yWr1bK': 'Winit模板',
  'ywoyKz': '申報價值(USD)',
  'zDk1Nv': '將WINIT退貨中心地址維護至您的銷售平臺退貨地址或提供給您的買家',
  'zJv/fs': '創建退貨單',
  'zVNDbm': '若未維護商品級定製拍照模版,則會按客戶級拍照模版處理,若未維護客戶級拍照模版則會按Winit標準拍照模版處理。客戶級拍照模版費用與Winit標準拍照模版不一致,詳情可見產品價卡說明。',
  'zYCqK9': '尺寸(長*寬*高/cm)',
  'zh/BWz': '上門取件信息',
  'QhLnYY': '修改日誌',
  'IoOUi9': '訂單內[{confirmListCode}]屬於不良品出庫，是否確認退貨倉庫接收實物按『直接上架-良品上架』進行添加良品庫存，繼續下單則點擊『確認』',
  '8rukt0': '已收件',
  'WSk/X1': '停計自動銷毀',
  'eJlU8R': '查看模板圖片',
  'AKFq1O': '最新推送時間',
  'UdTynn': '註意：{break} 1、僅在【賬號管理】為已啟用的eBay賬號，庫存信息會同步到eBay，您可前往【<a0>賬號管理</a0>】查看eBay賬號狀態；{break} 2、該頁面僅展示已綁定的商品信息，未綁定請前往【<a1>eBay認證倉商品管理</a1>】進行綁定；{break} 3、推送認證倉商品有庫存和商品尺重限製，詳見<a2>操作說明</a2>；{break}',
  'rrWpjk': '最新不推送原因',
  '96PAzm': '提交成功{successNum}，提交失敗{failNum}。{break}失敗的導入數據和失敗原因<a>點擊下載文件</a>',
  '3w/ZXS': '無記錄（單品未入庫或對應操作信息已超2年數據自動歸檔）',
  '5CPQd8': '當前單品狀態',
  '8VJJbj': '單一產品則為單一產品核實體積，箱套產品則為箱套產品對應的核實體積',
  'OpKDTp': '確認切換到【是，與良品一致】嗎？',
  'RYj/xc': '箱產品或套裝產品的在庫箱/套數量',
  'RydShn': '單品條碼操作日誌信息',
  'WHQp3W': '箱/套數量',
  'Xm1pt6': '普通商品',
  'uZU8sk': '出庫下單自動組套的場景下（多套表示為2套及2套以上）；{break}若配置為【是】則下單1件商品A，命中此組套關係，自動進行組套出庫，下單2件商品A，命中此組套關係，自動按2個組套處理；{break}若配置為【否】則下單1件商品A，命中此組套關係，自動進行組套出庫，下單2件商品A，不允許按組套處理，常規打包處理。',
  '8sL5pg': '數據更新',
  'HhrjUl': '分母：目標出庫日期範圍內，非草稿 / 客戶作廢 / 萬邑通作廢 / 抓單失敗作廢的應出庫包裹數{break}分子：分母範圍內，實際出庫日期<=目標出庫日期的包裹數',
  'UVl8Ye': '導出超時未出庫明細（實時）',
  'nxCFhm': '由於更新時間不一致，可能導致此數據與頁面【超時出庫數】不一致',
  '+QH9aU': '預計國內倉出庫',
  '61Q2bA': '預計到海外倉',
  'Cyx0kU': '下單重量',
  'XAVPBS': '該偏好僅應用在下入庫單過程的費用預估，其他如下單限製、海外驗的預約及違規費計算，不取本偏好的應用',
  'd/umZj': '請註意,選擇免自驗後,訂單將在提交後自動完成驗貨,無法再修改箱單；{break}且免自驗後B/C包裹因未驗貨系統無子包裹信息，上架後會按未做子包裹標準計費。',
  'rSSvME': '系統將按照您輸入的長寬高按照最長邊、次長邊、最短邊進行展示及費用預估',
  'zSDFbF': '下單體積',
  '05TZVT': '出庫異常',
  '0Npq7r': '創建出庫單',
  '6g9Wst': '待處理暫存訂單',
  'AIywwl': '拍照暫存待處理',
  'IocBNZ': '庫內異常',
  'KdkO6t': '待確認缺量訂單處理方式',
  'VtgkiE': '出庫待處理',
  'XNrxUg': '入庫異常',
  'cHJ2tH': '入庫待處理',
  'IaVnOG': '費用預估偏好設置',
  'cM+3En': '倉庫已收貨',
  'f9HdOe': '登入IP',
  '+nKXJ/': '設置策略',
  '0TIzQx': '等待審核',
  '16zLrM': '註意：為確保檢查效果，請在圖片上圈出位置，標記必要的文字說明後再上傳',
  '35Ap1W': '是否確定清空商品【{codes}】設置的退貨策略，退貨時若無商品級策略會按您配置的默認退貨策略處理！',
  '4FyYBa': '默認退貨策略(客戶級)',
  '4wGMni': '派送失敗：',
  '5V9CE8': '若海外倉收到退貨時「退回商品狀態≠正常時」將按照以下優先級匹配退貨策略：',
  'Aiuda0': '商品拍照模板',
  'Bdb4rA': '高貨值',
  'CVPemq': '商品特性-優先順序',
  'DbtZiz': '1. 在「商品退貨策略」頁面配置的商品級退貨策略。',
  'EMUWj/': '標準類型',
  'ElZ9N0': '最大支持批量查詢{num}條，批量查詢時英文逗號隔開或換行！',
  'FWkmOf': '頁面模板',
  'GRPOdU': '退貨策略匹配優先級為: {break} 商品退貨策略>默認退貨策略(客戶級)>Winit退貨策略 {break} *若均未設置"商品退貨策略"&"默認退貨策略"，則按"winit退貨策略」處理。',
  'IsZPwQ': '批量編輯',
  'LJjMp2': 'Winit策略',
  'M0p1ky': '格式支持jpg，png，gif，jpeg',
  'Nu6ukW': '批量清空策略',
  'RJAU9A': '確定清空策略嗎？',
  'SEGQZS': '退回商品狀態_正常"按照以下優先級匹配退貨策略(前往配置):{a1}>{a2}>{a3}',
  'SGo++1': '3. 如果以上1和2都未配置，退貨時將采用以下默認策略: 無RMA：拍照暫存 派送失敗：直接上架。',
  'U0+OQF': '海外倉收到退貨時「退回商品狀態=正常時」將按照以下優先級匹配退貨策略：',
  'UPxP2W': '良品圖片至少上傳5張',
  'VN1ezV': '良品圖片',
  'W3/yma': '默認退貨策略',
  'XwFUS0': '無RMA退貨策略',
  'YBQNBm': '若清空商品對應的退貨拍照模板,則會按此默認模板進行拍照，若未維護默認模板，則會按WINIT標準SOP進行拍照處理！',
  'YIGFVJ': '若商品未維護對應的退貨拍照模板,則會按此默認模板進行拍照,若未維護默認模板,則會按WINIT標準SOP進行拍照處理!',
  'YzOXoA': '1. 在本頁面配置的客戶級退貨策略。',
  'ZMYzQk': '*若均未設置"商品退貨策略"&"默認退貨策略",則實物退貨到倉後會按"winit退貨策略"處理，為避免產生不符合預期的退貨處理方式，請結合實際業務情況及時配置策略！',
  'aVh0hV': '退貨策略維護',
  'ax4G39': '編輯照片',
  'axey37': '退回商品狀態',
  'bUJ3KI': '清空策略',
  'c1hxVC': 'Winit退貨策略',
  'eivou1': '維護退貨拍照模板',
  'hBzbwm': '無RMA：',
  'hXKE17': '通用標準',
  'jJiNOd': '退貨商品狀態',
  'l0h4gZ': '多個商品編碼/商品條碼換行或用英文逗號隔開，最多支持{num}個，雙擊切換到單個查詢',
  'l8NWUi': '"退回商品狀態_非正常"按照以下優先級匹配退貨策略(前往配置):{a2}>{a3}',
  'm+CSKJ': '無RMA',
  'mmuRHl': '批量清空',
  'nzf0kE': '2. 按WINIT配置的基礎規則【{a}】',
  'o7BHmU': '批量設置策略',
  'oEcYBH': '2. 在本頁面配置的客戶級退貨策略。',
  'p7uXGN': '派送失敗退貨策略',
  'ppO2BL': '照片數量',
  'rs+KKE': '標準名稱',
  's2MRUC': '優先順序',
  'uE11Jo': '不良品圖片',
  'veuVN/': '無RMA和派送失敗的退貨策略至少填寫一項',
  'w7h6tB': '編輯策略',
  'wCQB8y': '請先勾選商品',
  'zETnvF': '商品退貨策略設置',
  'zcAqKI': '默認拍照模板',
  '8TxolX': 'Winit將按照以上的規則匹配退貨處理策略，請結合實際業務情況提前配置對應的退貨策略。',
  'ZxQtHK': '您可以根據需求配置不同的退貨處理策略',
  'fhEV6C': '退貨商品狀態≠正常時，將按照以下優先級匹配退貨策略:{a2}>{a3}',
  'kPQvJQ': '退回商品狀態=正常時，將按照以下優先級匹配退貨策略:{a1}>{a2}>{a3}',
  'Gtlk4r': '商品導入成功，可在已設置頁面查看商品',
  'hvJv2u': '(派送失敗)',
  'ngTsgq': '(無RMA)',
  '2vV3rp': '該微信綁定多個萬邑聯帳號，請選擇登入：',
  '6zf5WP': '當前微信({nickname})已綁定以下帳號：',
  'A9zFcw': '最近登入',
  'HO+Y34': '抱歉，當前微信綁定的帳號已達上限(最多綁定{bindUserNumLimit}個)',
  'Jpe8pz': '前往登入',
  'RAXpq+': '立即登入',
  'REvR5Z': '掃描登入',
  'RVmna3': '抱歉，當前微信綁定的帳號已達到上限(最多綁定{bindUserNumLimit}個)',
  'UNKU4n': '如需繼續綁定當前帳號，請錄入以下資訊：',
  'V3DdUR': '該手機號綁定多個萬邑聯帳號，請選擇登入：',
  'bVfn2l': '請選擇登入帳號',
  'dbmZAL': '手機帳號不存在或未綁定，請註冊或綁定後再登入',
  'h2IpXC': '如需繼續修改手機號，請點擊確定按鈕',
  'hGVOxM': '郵箱密碼',
  'i/PpUw': '抱歉，當前微信已綁定過帳號，不可再次注册',
  'oacN/h': '當前微信({nickname})已綁定以下帳號({bindTotal}個)：',
  'wHkfnl': '當前手機號碼({phone})已綁定以下帳號：',
  'GtIdEi': '默認驗貨倉',
  '7mwRSS': '當前該手機號碼綁定的帳號已達上限(最多綁定{bindUserNumLimit}個)',
  'LtYRX8': '抱歉，修改失敗~',
  '2r3IJC': '請輸入數值',
  '58WavZ': '自定義字段中文名稱',
  'HowtAS': '文本',
  'Jueghe': '客戶自定義字段信息',
  'ONR67m': '啟用自定義字段',
  'ORgO0e': '最多24個字符',
  'P8Gwzr': '是否確認啟用此自定義字段？生效後，API註冊、頁面註冊、模板註冊均會按配置內容進行要求提供對應自定義字段信息，無法提供或會影響商品註冊。',
  'RptCJU': '是否已了解自定義字段使用場景，確認需要使用？',
  'XlfUm/': '支持最多創建3個自定義字段',
  'YtPtMs': '是否確認不再使用此字段信息？',
  'aZDBrY': '新增字段',
  'bKnbER': '字段類型',
  'dPCJQ/': 'Open API對接字段，無需對接API可忽略',
  'dvrx23': '自定義字段',
  'hMZnus': 'API字段名',
  'ksJ/3u': '擴展配置',
  'pkMcXZ': '此功能支持用戶在註冊商品信息提供額外信息，用於更好對商品信息進行管理，請根據實際需要選擇性開通',
  'pu4ANt': '最多48個字符',
  'qCk2e7': '自定義字段英文名稱',
  'rRBPTT': '數值',
  'x4370M': '請輸入中英文或數字',
  'xOBjyi': '確認關閉嗎？',
  'yYoxkN': '是否必填',
  '5dS8AK': '上傳第三方商品條碼標簽文件',
  'bs3A4X': '第三方商品條碼標簽文件',
  'iuaNK+': '標簽對應關系',
  'C1L/tA': '目前僅支持eBay、Temu、AliExpress、Shopify平台配置規則。其餘平台將陸續開放，敬請期待!',
  'Nsa7YE': '請選擇平台Location',
  'SFe2Aw': 'shopify平台每30分鐘同步一次',
  'f9xwVI': '店鋪{account}授權無庫存相關權限：read_inventory、write_inventory、read_locations。請檢查店鋪授權token環節是否有勾選相應的權限。 ',
  'TB3rBj': '請使用「自提出庫-通用模板」進行導入',
  'gYXO5b': '請使用「銷毀單通用模板」進行導入',
  'lD87Nv': '請使用「標準出庫-平臺專用/通用模板」進行導入',
  'UDlvOw': '請輸入字母、數位、底線_、橫杠-',
  'eGdiPg': '地址編號為訂單批量導入或API下單時使用，由您自定義編寫（支持任意字母、數位、底線_、橫杠-），但提交後不可修改',
  '+uX6k3': '發貨方式選擇偏好',
  'EsdtJQ': '基本信息選擇偏好',
  'KxdV6o': '是否默認選擇最早的提貨時間',
  'LwZj/E': '是否默認選擇發貨時間最早的物流計劃',
  'ReCcIp': '北京時間',
  'SQfknD': '報關方式選擇偏好',
  'sm0/fH': '當地時間',
  'JkvJX/': '物流計劃偏好設置',
  'NZ5Lvz': '報關方式偏好設置',
  'P2tp7i': '針對國內倉驗貨且提貨類型為Winit上門提貨，萬邑聯下單/API下單會根據偏好選擇最早的提貨時間進行下單；',
  'PXtCFW': '提貨時間偏好設置',
  'yoFShO': '針對Winit承運且客戶未選擇物流計劃，萬邑聯下單/API下單會根據偏好選擇發貨時間最早的物流計劃進行下單；',
  'Y4m/OW': '僅支持目的國+頭程類型+驗貨類型維護一條報關方式偏好，若匹配到對應偏好，萬邑聯下單/API下單會根據偏好內容進行下單！',
  '5HNHGL': '是否帶有刀片',
  'NyXwQq': '#帶刀片',
  'duQQ3H': '帶刀片',
  'six1wi': '商品包含能够通過切割人體皮膚對人造成傷害的刀片物品，比如存在鋸片、餐具刀、工具刀、剃須刀片等務必勾選。',
  '7bdh+E': '根據英國當地法律法規要求，所有含刀具的商品的包裹必須粘貼年齡限製標簽，系統已自動為您添加"檢查/補貼年齡限製標簽"增值並將在訂單中收取相應費用',
  'TBpJ9a': '根據英國當地法律法規要求，所有含刀具的商品的包裹簽收時必須驗證年齡，系統已自動為您添加"Last Mile VCA"增值並將在訂單中收取相應費用',
  '6KfC40': '簽署完成',
  '8FOzIZ': '海外倉《供應鏈管理協議》和《海外倉商業性條款補充協議》{break}由於{a1}和{a2}的內容具有相互關聯性，兩份協議需要同時簽署，您可以點擊協議名稱查看具體內容。',
  'R+sv2r': '《供應鏈管理服務協議》',
  'akmnDR': '未到找該協議或該協議不存在',
  'qSrqiP': '海外倉《供應鏈管理協議》和《海外倉商業性條款補充協議》{break}由於{a1}和{a2}的內容具有相互關聯性，兩份協議需要同時簽署，您已簽署最新版本，可點擊協議名稱查看具體內容。',
  'zESJVr': '《海外倉商業性條款補充協議》',
  'zWDZbi': '不上傳萬邑通跟踪號碼到EBAY（僅比利時倉供應商B2C Europe服務適用）',
  '8vrQgq': '自提出庫（導入草稿訂單號）',
  'itoONc': '自提服務',
  'lRBa4q': '如果是自提服務 {a}',
  'p4H1SB': '自提出庫（支持多種增值服務）',
  'tpI9jm': '自提出庫-自提服務',
  'g6wYzy': '支持按賣家提供的平臺面單貼至包裹，通過合作承運商派送至買家手中。',
  'nZMq9z': '單品體積累加(CBM)',
  'rwNEpG': '打包尺寸(cm)',
  'qhKv6X': '平臺暫僅支持{platform}，請先綁定平臺賬號',
  'rlIAep': 'OTTO,PLentyMarket',
  '1L4o+6': '上次登錄時間',
  'NQMeVr': '每個手機號綁定的數量最多為5個，該手機號已綁定的數量已達上限',
  'e4DUUm': '子帳號名稱',
  'gT/sAQ': '開發者許可權',
  'zlZigq': '昵稱',
  'TTS8yp': '開發者許可權和允許授權ERP的許可權，如當前帳號無開發者許可權需求，建議關閉',
  '0xa2hp': '打開此許可權後，該帳號將擁有協力廠商授權請謹慎開啟',
  '7FR7jP': '如未及時關聯快遞單號，則有可能導致處理為退貨或無主貨，因此產生的異常費用客戶需自行承擔，最終收貨以WINIT實收為準',
  'VVc+P7': '是否亞馬遜移除單',
  'C6x6Tv': '下單費用預估偏好',
  '3ma4nl': '當前產品由於"{error}"原因不可用，您可以選擇更換其他包材類型或其他派送方式;如果為復合訂單,也可拆單後下單。',
  '5ypbAw': '添加第{i}層包裝',
  '8q9EMC': '第{i}層',
  'Atjd5O': '啟用雙層包裝服務',
  'BwGeIF': '在完成客戶訂單的整體打包後，根據品牌推廣或防護需求，在原有包裹外層額外增加一層或兩層包裝。需要註意的是，當單一包裝層無法滿足訂單的打包要求時，不允許將部分商品單獨打包後與其他未完全打包的商品組合，再進行額外包裝。',
  'G37PK3': '第三層',
  'GtNbsM': '<strong>示意圖</strong>{img}',
  'IELDaK': '已了解此服務的適用場景，確認需要使用雙層包裝服務？',
  'IUEZRN': '復製商品編碼',
  'OHQMeB': '第二層',
  'TdjNLW': '默認為加單層包裝服務，若需要使用多層包裝服務，請前往偏好設置>商品設置>{a}',
  'V4pQH6': '點擊查看示意圖',
  'ZiSqLR': '第一層',
  'efGs6k': '包材用途',
  'qke9N+': '商品包裝層級',
  'xmBGan': '由於訂單中商品中包含禮盒包材，出庫加包裝增值的信息將會被清除，請重新選擇出庫加包裝服務。',
  'hZJNn1': '由於訂單中商品中不包含禮盒包材，出庫加包裝增值的信息將會被清除，請重新選擇出庫加包裝服務。',
  '/k5tdz': '1.禮盒包材：用於多層包裝的內層，客戶需另選外層包裝。倉庫打包時，先用禮盒包材包裝商品，再添加外層包裝。（未啟用多層包裝服務不支持此類包材用途）{ break}2.物流包材：可用作單層包裝或多層包裝的外層。',
  'hhIIwx': '多層包裝服務是在現有出庫加包裝服務的基礎上，額外再新增一層包裝材料，以顯著提升包裝的美觀性、保護效能及運輸安全性。',
  'PAwxvf': '請務必在貨物到倉前及時將所有相關快遞單號關聯為識別碼。若未及時關聯，貨物可能被誤處理為退貨或因無法識別貨主而被銷毀，相關風險及費用由賣家自行承擔。{break}最終收貨情況將以WINIT實際入庫記錄為準。',
  'WWz7Q4': '無法提供並取消待辦',
  '+AVH+W': '商業地址',
  '+MPom9': '"lift-gate"指的是裝在卡車尾部的升降平臺,用 於將貨物從地面升至卡車的貨箱,或者將貨物從卡車貨箱降至地面。這種設備對於處理重型或大 型貨物特別有用,尤其是在沒有裝卸設施的地 方。在提供升降平臺服務時,可能會需要額外的 費用。',
  '+big95': '待WINIT完成裝箱、打托並暫存後,補充托盤標簽等增值文件。',
  '/dySAg': '同一個倉庫，如果有更新的WINIT版本，可點擊後刷新切換到WINIT版本',
  '0y5hzY': '切換到WINIT版本',
  '0zyVbu': '供應商名稱',
  '2BqPCg': 'FBA倉地址維護操作指引',
  '5wy87y': '該地址已有WINIT更新版本, 您當前使用的是自定義版本',
  '6qy1xl': '增值選項',
  '7SZjFs': '填寫收貨地址和出庫SKU信息, 選擇【Global Quote Shipping】的尾程產品, 提交出庫單。',
  '7YtkDc': '基於出庫單信息, 創建詢價增值單, 補充尾程詢價所需信息。',
  '7l3fV0': '詳細操作指引',
  '8JScbo': '預估托盤數量大於22托，在線報價不支持FBA送倉，請選擇人工報價。',
  '8RfQE7': '尾程詢價出庫單操作指引',
  '8RlcuN': '住宅地址默認不支持垛口卸貨，零擔派送(LTL)時必須選擇Lift-Gate和APPT。FBA轉倉默認為商業地址。',
  '8U/rTl': '目前僅限美國支持在線詢價。提交詢價增值單後，系統將在約5分鐘左右完成在線報價，請耐心等待結果後在增值單查詢頁及時確認報價。',
  '9Cez6q': '已完成第一步, 請繼續創建詢價增值單',
  'AD5sEw': '報價模式',
  'AXrI4w': '投保',
  'EAOyFB': '第一步:提交出庫單',
  'ELWNit': 'FBA地址',
  'ExQ/dx': 'WINIT收集的FBA倉地址庫',
  'HG2EsH': '車型名稱',
  'HvLzJn': '系統基於訂單體積預估的托盤數量，僅供報價參考，最終計費以倉庫實際打托數量為準。',
  'JiRAVh': '待WINIT反饋報價後(通過首頁待辦或郵件通知獲知),在增值單查詢頁面操作確認報價',
  'JsLztN': 'WINIT倉庫預約供應商提貨,完成出庫發貨。',
  'K78O7t': 'WINIT版本',
  'KPTVBp': '查看FBA倉地址',
  'LRNoCX': '第五步:倉庫預約供應商提貨',
  'MAz12w': '版本類型',
  'MG/bFQ': '訂單收貨人類型',
  'Mbi+c9': '創建詢價增值單',
  'Nkqbad': '詢價要求',
  'NxHqKo': '提交詢價增值單後，WINIT將人工為你向線下供應商詢價，並在詢價完成後郵件通知您。',
  'OQ0psa': '系統獲取報價中, 請5分鐘後來查看',
  'Ope61w': '預估托盤數量大於6托，在線報價不支持不住宅地址，請選擇人工報價。',
  'OsuCLL': 'FBA倉編號',
  'PaHEXB': 'LTL(零擔運輸)、FTL(整車運輸){break} 1.FBA僅支持LTL。{break} 2.住宅地址僅支持LTL，且必須小於6托。{break} 3.商業地址並且大於22托，僅支持FTL。{break}',
  'PihFBF': 'Lift-Gate',
  'Pp1TTV': '第三步:操作確認報價',
  'QGuvON': '如果發現WINIT地址庫不足或不正確，客戶可以新增或修改為自定義版本，經WINIT核實後可變更為WINIT版本',
  'QVA75B': '聯系人信息',
  'RUSzK5': '切換到WINIT版本成功',
  'Swiv0A': 'FBA倉聯系人信息',
  'U0U2in': '收貨人地址類型',
  'YcT8hM': 'FBA倉編碼',
  'ard8gk': 'APPT',
  'bhbSjx': '期望到達時間',
  'cbqjLX': 'FBA倉地址信息',
  'dRWDB0': '新增FBA地址',
  'dY7J2f': '待報價，請下單後基於<a>操作指引</a>額外再提交詢價增值單',
  'enEHaF': '第四步:補充托盤標簽等增值',
  'f0EiQE': '客戶自定義版本',
  'fMDeau': '當前為WINIT收集的FBA倉地址信息，修改後將保存為客戶定義版本，您後續將使用自定義版本，WINIT將核實您修改的內容，如果核實無誤，則將您修改後的內容納入到WINIT地址庫。',
  'fXO+U6': '請輸入數字英文或橫線',
  'fmmUkd': '切換至新版本',
  'hY4Lvl': '保留我的版本',
  'iIP2Yn': 'FBA倉信息，將切換到WINIT版本，是否繼續？',
  'iJ+RdK': '僅支持數字、英文、橫線',
  'j4y83C': '住宅地址',
  'kfR22B': '人工報價',
  'l3JdZG': '自定義版本',
  'lEIbzS': '請輸入FBA倉編碼',
  'lsd6bP': '訂單基礎信息',
  'lyk5VK': 'FBA倉庫信息',
  'oDhajK': '在線報價',
  'seveoq': '是否支持垛口卸貨',
  'tNh07V': '"APPT"指的是需要協助預約送貨。這樣可以確保在貨物到達時準備就緒,同時也可以幫助運輸公司更有效地安排他們的運輸計劃。',
  'tXv5//': '住宅地址默認不支持垛口卸貨',
  'uWDzGt': '第二步:創建詢價增值單',
  'uktYmS': '1. WINIT版本：WINIT收集的FBA倉地址庫。{break}2. 客戶自定義版本：如果發現WINIT地址庫不足或不正確，客戶可以新增或修改為自定義版本，經WINIT核實後可變更為WINIT版本',
  'vCy5Po': '校驗國家、州/城市、郵編失敗，您可以<url>點擊這裏</url>進行查詢。',
  'vGdZ04': '僅支持數字、加號、橫線、空格、括號',
  'wq9xDI': '版本號',
  '35Hi9P': '依賴成本',
  '1OlJRk': '尾程詢價報價 <span>(實際打托數量會影響最終尾程費用，請確認報價的單價，以實際扣費金額為準)</span>',
  'b+NmJQ': 'LTL(零擔運輸)、FTL(整車運輸){break} 1.FBA僅支援LTL。 {break} 2.住宅地址不支援大於6托，僅支援LTL。 {break} 3.商業地址且大於22托時，僅支援FTL。 {break}',
  'dTGv8M': '必須大於當天',
  'uNwwIP': '當地',
  '0H7ext': '異常關閉時間',
  '1kGGA/': '已關閉',
  'g49BG6': '出庫日期（當地）',
  'oDyZLy': '未已關閉',
  '6JWI9W': '异常生成時間（当地）',
  '8d7pkA': '異常關閉時間（当地）',
  'WyERxh': '帶章賬單首頁',
  '+X8eaX': '查看異常',
  'BsmZGD': '請輸入數字、字母、減號、底線或空格,且長度小於50個字符',
  'vlsmJo': '此費用項目設有最低收費門檻，金額為 {currency}{amount}。現依據最低收費標準，目前計算結果已調整至此最低收費額度。如需詳細了解收費細則及標準變動情況，請以最新發布的價格表內容為準。',
  'Jf5+Im': '待確認缺量訂單',
  '6bE8su': '如果預設的裝箱策略無法滿足您的業務需求:{break}請點擊此處<a>自訂您的裝箱規則偏好</a>',
  'ARuxev': '限2長*2寬*2高',
  'CZLnVK': '限制長*寬*高',
  'OTiLOA': '限制體積',
  'PQyi+9': '您尚未配置裝箱策略偏好，因此WINIT將採用標準化出庫裝箱策略執行打包作業。預設策略如下:',
  'RjFpnF': '當策略中支援多種包裹類型時，倉庫會綜合考慮商品特性、體積重量以及運輸要求等實際因素，選擇合適的包裹類型進行打包。 ',
  'jeqrK/': '注意:此策略將限制打包成{miss}類別包裹。 ',
  'pidHAI': '看全部WINIT預設裝箱規則',
  'yQjltk': '支援打包的{break}包裹類型',
  'M8w2+G': '第四步:補充托盤標籤等增值(非必須)',
  'ZoVbvy': '如需補充增值，請在提交訂單時預先選擇相應增值。 {break} 待WINIT完成裝箱、打託並暫存後,補充托盤標籤等加值文件。 {break} 如未在提交訂單時預先選擇相應增值，確認報價後倉庫不會暫存，直接出庫。 ',
  'e3qaPy': '收貨人地址類型為商業地址時，必須提供公司名稱。 ',
  'xHcWNS': '{break}線上詢價時，預估托盤數量以系統預估為準。 ',
  'CDAxI1': '受標籤尺寸篇幅限制，SKU編碼的長度若超過40位，則超出部分不會打印，不影響條碼識別。',
  'WDxSgQ': '#贈品',
  'h2khcY': '如您選擇添加GPSR信息，則標籤將帶有已關聯的GPSR信息；如果商品未關聯GPSR信息，則不允許打印。',
  'ihOQRf': '“打印文件生成設置”選擇“不同SKU生成單獨文件”時，會按打印的【SKU編碼】命名文件名稱，由於文件名不支持字符【 / : * ? " < > | 】，則在生成的文件名時會自動忽略，請注意核對條碼信息，防止誤貼。',
  'jMNHyP': '包材內徑尺寸(cm)',
  'pkctCa': '打印商品件型信息',
  'vYqf9H': '商品禁止入庫，不支持打印標籤！',
  '2L50ht': '以下商品在國家是禁止入庫，即使打印條碼實物張貼也無法創建入庫單，確認需要打印？',
  'eB8frW': '自提出庫默認使用{break}WINIT出庫單號提貨',
  'hVMnqa': '您可以選擇配置通過WINIT出庫單號進行提貨。當您勾選此項時，即表示您已確認並授權供應商使用WINIT出庫單號進行提貨，並自行承擔由此產生的相關風險。請務必確保您對WINIT出庫單號進行妥善管理。此配置僅對非FBA轉倉的訂單有效。',
  'wTt7mK': '我已知悉',
  '+rb3z9': '請選擇同一個倉庫下的異常單',
  '//qX98': '移除單來源',
  '/TyAL3': '銷毀後訂單(訂單數: {totalNum})無法恢復，請再次確認是否一鍵銷毀！',
  '/bEUPt': '共計銷毀{orderNum}異常單,請再次確認是否進行銷毀!',
  '/suo4m': '異常編號',
  '035Ocl': '*請填寫針對該異常所提交的增值服務單流水號，如您還未提交增值服務請<a>點擊此處</a>跳轉至增值服務頁面提交增值服務後填寫增值服務單號。',
  '0O5T7r': '{successCount}個移除單成功創建入庫單：{inboundOrderNoList}',
  '1Iy4LH': '預計銷毀日期',
  '1NYW+/': '異常類別',
  '1WB+di': '處理異常',
  '3JRmkd': '立即查看異常訂單',
  '3jtEoL': '緊急通知<tag>即將銷毀</tag>',
  '4ZtU8H': '處置中數量',
  '53J/Nd': '執行任務狀態',
  '5gRDaT': '最新同步時間',
  '6/g2Xy': '移除單類型',
  '9ZVJ3+': '登記倉庫',
  'AvkS7o': '移除單條件',
  'B4z3E3': '我知道了',
  'BFxcTt': '待銷毀異常訂單',
  'BWTsPT': '異常發生地',
  'ByZHeO': '1、系統將按照一個異常單構建一個增值銷毀單下發雲倉;',
  'C/fSWX': '移除單更新時間',
  'CSNtjK': '提交入庫不通過原因',
  'CfPc0f': '{failedCount}個移除單創建失敗，失敗原因如下：',
  'D2X2wB': '移除單提交時間',
  'DlDTj8': '請選擇需創建增值服務單的異常單',
  'E4dkSU': '修改增值單號',
  'F+eZ2H': 'shipped-quantiy',
  'FsSkcq': '批量處理異常',
  'GLBv34': '自動入庫規則配置',
  'GlMRI+': 'tracking-number',
  'H7s5l3': '不限製包裹類型',
  'KjADFd': '執行結果',
  'LGMqRm': '移除單商品屬性',
  'LgyOft': '已處置數量',
  'M/DPSo': '移除單狀態',
  'N3qOVE': '銷毀執行數據只保留30天',
  'NBabp4': '是否移除單',
  'OXdYxg': '全部移除單提交成功，成功創建入庫單：{inboundOrderNoList}',
  'P6DzWR': '當前勾選的異常單已有保存的增值單[<a>{orderNo}</a>],請先取消草稿單再發起增值!',
  'PbNM0f': 'carrter',
  'PcKqH0': '實物第三方包裹碼',
  'QnDR2H': 'FBA移除單物流信息報告每天更新一次，最新更新時間2024-01-01 12:34',
  'Rcgps+': '已選中{idListLength}個訂單，是否對選中的移除單重新執行自動入庫規則？',
  'RdBKhC': '請選擇需反饋的異常單',
  'SDLjvC': '自動銷毀日期：{expectedDestroyDate}（剩余處理時間：{remainHandlingDays}天）',
  'T10lmn': '當前勾選的異常單已有保存的庫內訂單[<a>{houseNo}</a>],請先取消草稿單再發起增值!',
  'Vwp5Qh': '已選移除單',
  'X6oAf8': '批量提交入庫單',
  'YDnB35': '請先勾選數據',
  'ZN9vv0': '僅未提交狀態操作',
  'ZTHPCS': '以下移除單已關聯入庫單或類型為return，不支持提交入庫單請重新選擇：{break}{removeOrderNos}',
  'ZsgS/g': '如若本次只針對暫存待處理中的部分單品進行增值處理，請您根據暫存商品中的唯一標識碼區分，在商品列表刪除掉不需要進行本次增值處理的商品，再點擊【下一步】繼續選擇需要操作的增值服務',
  'cCPVaz': '以下移除單已關聯入庫單或類型為return，不支持提交入庫單請重新選擇：{break}{removeOrderNos}移除單有誤，請重新選擇',
  'cg9FE4': '立即處理',
  'ciIGU9': '入庫指定包裹類型',
  'dT/edB': 'FNSKU',
  'dkSzVa': '入庫單規則',
  'eX5wuL': 'FBA移除單報告每天更新1次，僅更新180天內報告。最新更新時間2024-01-01 12:34 <a1>查看詳細介紹</a1>',
  'epqxJG': '二次確認',
  'g1I4y4': '一鍵銷毀異常單',
  'hCtT4f': '屬性',
  'hX26oC': '批量反饋',
  'iFtdRX': '首次同步時間',
  'imSP3c': '待處理訂單數：',
  'j6L4GB': '取消數量',
  'k+gK7m': '未提交',
  'k4brJy': 'SKU',
  'mZJznr': '批量創建銷毀增值單正在執行中,請前往<a>查詢執行結果</a>進行查看',
  'mgv9pg': '已發貨數量',
  'n6WAyp': '異常環節',
  'nE3EBp': '異常批量反饋',
  'o/9IfL': '提交入庫單',
  'p6VkG4': '移除費用',
  'qf+53n': '一鍵立即銷毀',
  'r6tjAG': '重新執行規則',
  's6MvYD': '2、在倉庫正式銷毀前,如您想取消銷毀,您可自行前往<a>萬邑聯海外倉-全部增值訂單</a>頁面取消銷毀增值單!',
  'tDxB5+': '實物WINIT包裹碼',
  'uqTux2': '{orderNum}單（已滯留{stayDays}天）',
  'w7Tfhn': '是否審核通過',
  'wuoIy0': '目前僅支持Amazon平臺配置移除單入庫規則。',
  'xfLWzZ': '是否采集A+包裹碼',
  'yOZtjM': '請至少選擇一個異常單！',
  'ycib7Y': '若您在預計銷毀日期前仍未處理該異常，系統將自動根據該異常單涉及貨物生成銷毀增值單，若您的異常貨物無需進行銷毀，請在該日期前處理異常！',
  'ymrffm': '查看跟蹤號',
  'zEhHZc': '查詢銷毀任務執行結果',
  'lYT4QZ': '<bold>異常訂單即將銷毀，請立即處理</bold>{break} <span>尊敬的客戶：</span>{break} <ul> <li>您有以下訂單因異常已被標記為「待銷毀」，目前系統已進入強製處理倒計時：{break} <liText></liText> </li> <li>請立即提交增值服務進行處理，逾期系統將自動執行銷毀操作並收取銷毀費用。</li> <li>如有疑問，可聯系在線客服協助，或查閱<a>《WINIT增值與異常服務價格表 - 海外倉異常處理》</a>了解費用標準與流程說明。</li> </ul> <line></line> <space><icon></icon><text>重要聲明：若因您未及時處理異常訂單導致貨物被銷毀，相關貨物毀損、滅失風險及銷毀費用均由您自行承擔，我司對此不承擔任何責任。請務必重視此次通知！</text></space>',
  'x5AWo7': '<bold>請及時處理異常訂單，避免貨物被銷毀</bold>{break} <span>尊敬的客戶：</span>{break} <ul> <li>根據萬邑通倉庫管理規定，若您的異常訂單處於「新提交」或「暫存待客戶反饋」狀態，且超過 30 天未主動提交增值服務申請進行處理 ，系統將自動執行銷毀操作，並收取相應銷毀費用，以此保障倉庫運營效率。</li> <li>為避免貨物損失及額外成本，請盡快確認並處理異常訂單。如有疑問，可聯系在線客服協助，或查閱<a>《WINIT增值與異常服務價格表 - 海外倉異常處理》</a>了解費用標準與流程說明。</li> </ul> <line></line> <space><icon></icon><text>風險提示：若因您未及時處理異常訂單導致貨物被銷毀，相關貨物毀損、滅失風險及銷毀費用均由您自行承擔，我司對此不承擔任何責任。請您務必重視！</text></space>',
  '0nMsYn': '即將銷毀',
  '3+yUFF': '優先級長度不能超過{max}位',
  '6Qi/57': '以下移除單已關聯入庫單或類型不為Return，不支持提交入庫單請重新選擇：{break}{onReturnOrderNos}{ononWFRs}',
  'AXV/j/': 'FBA移除單報告每天更新{pullCount}次，僅更新{pullFrequency}天內報告。最新更新時間{pullDate} <a1>查看詳細介紹</a1>',
  'GXPjP8': '以下移除單已關聯入庫單或類型不為Return，不支持提交入庫單請重新選擇：{break}{onReturnOrderNos}{ononWFRs}移除單有誤，請重新選擇',
  'J1iEpx': '自動入庫不通過/提交入庫失敗原因',
  'R98SA0': '僅未提交/提交失敗狀態操作',
  'WkbNTV': '提交成功，成功創建入庫單：{inboundOrderNoList}',
  'dsinlh': '{successCount}個移除單成功創建入庫單：{inboundOrderNoList}{break}',
  'hP8D5r': '系統優先匹配編號大的入庫規則。',
  'k9JHsi': '{failedCount}個移除單創建入庫單失敗，失敗原因如下：',
  'nRzQb9': '當移除單所有商品都同一屬性才會匹配成功。{break}註：若配置此條件，可售和不可售商品請分開下移除單',
  'qFm139': '{noMatchRuleCount}個移除單匹配自動入庫規則失敗{break}',
  'rkxcrn': 'carrier',
  'sbvVn+': '執行成功',
  'tTPoBP': '復製失敗移除單號',
  'u8ASMN': 'shipped-quantity',
  'uj13LR': 'FBA移除單物流信息報告每天更新{rderPullCount}次，僅更新{rderPullFrequency}天內報告，最新更新時間{rderPullDate}',
  '/N9qIp': '外徑',
  '/P3Q7V': '關閉窗口',
  '/W9M3v': '選擇了{serviceName}增值後，所有WINIT產品不可用，您可關閉窗口後在產品列表中查看詳細原因。',
  '3vwUoT': '判定為不良品是否需拍照',
  '4od2yG': '派送失敗的WINIT拍照模版類型',
  'Du8ONy': '定制拍照模版優先順序高於WINIT標準模版，若商品已配寘定制拍照模版或客戶級拍照模版，則此配寘不適用，倉庫會按定制模版進行拍照，否則按此配寘的WINIT模版類型進行拍照。',
  'QdKb8u': '無RMA退貨的WINIT拍照模版類型',
  'Ugy0ia': 'WINIT拍照模版類型',
  'WNgpY5': '判定為良品是否需拍照',
  'XSlHT6': '已配寘客戶級定制拍照模版，此配寘暫不生效，若需要使用WINIT標準模版，可前往取消定制模版 <a>點擊此處跳轉>></a>',
  'hpp6a7': '若選擇無需拍照，即表示相信WINIT檢查結果，後續存在异常無法提供相關照片資訊',
  'rpHIiV': '已配寘商品級定制拍照模版，此配寘暫不生效，若需要使用WINIT標準模版，可前往取消定制模版 <a>點擊此處跳轉>></a>',
  '1XWEMv': '平臺退貨原因',
  '42qy1H': '通過平臺訂單ID未匹配上相應的出庫單號，請檢查/確認出庫單賣家訂單號/電商平臺訂單號是否傳值正確',
  '44+kGE': '查看下單失敗訂單',
  '7Uao9y': '平臺退貨ID',
  'AsSGAy': '自動同步退貨訂單',
  'BZAEo6': '新增退貨原因',
  'KMIhD4': '平臺退貨狀態',
  'L2LYhY': '未找到匹配的出庫單',
  'TX5626': '請求時間',
  'VnaZN/': '退貨狀態',
  'XpmFr3': '退貨金額',
  'Xwktyf': '目前僅支持{platform}平臺。其余平臺將陸續開放，敬請期待!',
  'ZUVA4E': '下單失敗 {count}單',
  'cvZE/f': '退貨訂單同步規則說明',
  'fpFH8o': '平臺退貨單未匹配上出庫單，暫不支持下單。{break}{break} 通過平臺訂單ID未匹配上相應的出庫單號，請檢查/確認出庫單賣家訂單號/電商平臺訂單號是否傳值正確。若您可以準確定位出庫單，可以手動匹配出庫單，註意一旦確認無法修改請謹慎操作。',
  'jgVhXT': '平臺退貨類型',
  'kG7ECj': '退貨倉庫地址',
  'kv0q/g': '最多輸入{max}個字符',
  'nOsaxu': '手動匹配',
  'nkIyWE': '該退貨原因已存在，請不要重復添加',
  'npWR53': '只允許狀態為取消訂單的訂單撤回，請重新選擇！',
  'pRhMg1': '退貨承運商',
  'piC/s7': '下單成功 {count}單',
  'q4hPiU': '匹配方式',
  'qpub+R': '是否需要系統自動同步退貨訂單至退貨訂單列表',
  'rHLNSh': '查看已下單訂單',
  'rtEeyT': '不符合自動退貨規則的訂單將停留在未下單列表。',
  'scMay5': '手動匹配出庫單',
  'sqvgrn': '自動匹配',
  'vRc+X0': '退貨運輸方式',
  'y0M/fZ': '目前僅{platform}平臺需配置退貨規則，其余平臺配置無效',
  'zlJeYF': '自動下單不通過原因/異常信息',
  'zreIM8': '退貨ID',
  '/UjyGI': '平臺{platform}和TikTok不能同時選擇',
  'M0h2VP': '編輯退貨原因',
  'RsmTDW': '出庫單號存在多個',
  'r6NAzV': '僅支持狀態為<strong>{status}</strong>的訂單操作',
  '9lEixA': '更多計費信息定製',
  'h/GSwA': '輸出文件方式',
  'xtelGq': '海外倉賬單計費因子明細下載項目配置',
  '5xobfv': '<strong>配置說明：</strong>{break} 1、在你需要的計費明細大類和費用項前面打鉤後點擊保存；{break} 2、保存後回到原賬單計費明細下載頁面，刷新頁面重新下拉選中你需要的計費明細進行導出下載；{break} 3、不宜過多的選擇無需的計費項目，太多的費用項目會導致下載計費明細失敗或者系統使用緩慢；{break} 4、主子賬戶的配置以主賬戶為準，子賬戶沒有配置權限；{break} 5、有任何錢包對賬問題可以直接聯系我們：<a>https://support.qq.com/products/306264</a>',
  'TJX5Wu': '删除會自動解綁商品已關聯的協力廠商商品條碼，若需使用注意重新綁定商品！',
  'hgWy9L': '確認删除嗎？删除會自動解綁此商品已關聯的協力廠商商品條碼，若需使用注意重新綁定商品！',
  'LdRw+j': '1.廠商提供的SDS+運輸鑑定報告；或檢測公司提供的SDS、產品標籤圖片',
  'NZioeb': '1.廠商提供的SDS+運輸鑑定報告；或檢測公司提供的SDS；2.CPNP註冊+產品標籤圖片',
  'Sb09Tb': '1.廠商提供的SDS+運輸鑑定報告；或檢測公司提供的SDS；2.SCPN註冊+產品標籤圖片',
  'exIT3S': 'SDS、UN38.3測試報告、產品標籤圖片',
  'l1yTJd': '檢測公司提供的SDS、產品標籤圖片',
  'I2TiMV': 'LTL(零担运输)、FTL(整车运输){break} 1.FBA仅支持LTL，且必须小于等于14托{break} 2.住宅地址不支持大于6托，仅支持LTL。 {break} 3.商业地址并且大于22托时，仅支持FTL。 {break}',
  'cSQL5W': '预估托盘数量大于14托，在线报价时FBA送仓仅支持小于等于14托，请选择人工报价。 ',
  'KF+p1c': '尾程費用待報價, 請參考<a>操作指引</a>',
  'xMhgUa': '查看包裹軌跡',
  'Y6U20U': '軌跡名稱',
  '+DyXxN': '結果反饋',
  '/RHREI': '申請賠付貨物價格總和',
  '/eSpXG': '包裝及損壞類型的破損細節',
  '0Crtv6': '大於0的數字，保留兩位小數',
  '0KX1jR': '不拆單',
  '0QE4q1': '拆單類型',
  '0oSDZg': '系統提示',
  '16pzIO': '實際賠付金額',
  '1HMYGa': '提交人',
  '2V7sQs': '單據信息',
  '4KPJBi': '文件大小請勿超過{attachmentSizeMax}M，請壓縮後上傳',
  '4jD36a': '派送方式',
  '4vcHWR': '附件格式/數量:支持格式{attachmentFileFormat},最多上傳{attachmentNumMax}個附件,每個附件不超過{attachmentSizeMax}M。(圖片上傳成功後暫不支持預覽功能)',
  '5LSBrI': '包含貨物品名、材質、數量等詳細信息',
  '5T21V/': '包裝不符',
  '5vXAK1': '倉群內',
  '5xr61k': '商品信息描述不足',
  '6UYLU2': '索賠備註',
  '6Ydk+8': '確認供應商到賬時間',
  '71P5RG': 'LMA倉庫',
  '7IWrtA': '我已經閱讀並同意協議',
  '7xGGCf': '請勾選!',
  '9k/Y15': '請輸入出庫單號或包裹號',
  '9pKQNp': 'surepost轉交郵局無索賠',
  '9vmp+C': '您好，您的訂單存在拆單的情況，請選擇包裹號或快遞單號進行索賠',
  'A64kW0': '最多上傳 {maxCount} 個文件',
  'ABs//h': '請輸入索賠備註',
  'BqZvMO': '確認取消嗎？',
  'Cvv7k2': '只能輸入字母或數字或-且不大於40位',
  'D7iu6g': '受理時間',
  'DjDXF1': '受理客服',
  'EEunZe': '導出任務已提交，請稍後到任務中心查看',
  'EurVT+': '財務到賬日期',
  'Ew2J1p': '必須輸入大於0的整數',
  'FCDKaG': '已妥投',
  'FGj5pD': '確認金額',
  'FM6KfN': '提交索賠須知:',
  'FNy4pi': '貨值證明不符合要求',
  'GrwYYL': '選擇產品不提供索賠服務',
  'H0Kuhb': '索賠結果',
  'HNFUfF': '請上傳附件!',
  'Hi/fbr': '索賠結束日期',
  'I5gP3d': '評價等級',
  'Ip2JsU': '索賠申請資料不正確',
  'JPecZE': '小於免賠額供應商拒賠',
  'MHwPat': '流水號',
  'Meo6z8': '附件要求:{message}',
  'N5ov41': '受理信息',
  'NLrJ1E': '出庫單狀態',
  'Nu9lbs': '拒賠理由',
  'Okhk3M': '新增代客索賠單',
  'PHnJZl': '索賠單號',
  'QDa1XA': '供應商不承認收到包裹',
  'QQLUuU': '請輸入英文字符!',
  'Qw55Un': '出庫時間',
  'R0SWqT': '評價成功',
  'S0J1qQ': '請填寫大於等於 {applyTotalItemPriceMin} 的數，最多保留2位小數',
  'S4FFpE': '出庫日期',
  'SrU9lU': '單據詳情',
  'SuNgBE': '請輸入索賠貨物英文描述',
  'THiiin': '受理日期',
  'TXC7kZ': '請選擇子訂單號',
  'UmXhDu': '《代客索賠服務協議》',
  'VGOA2e': '破損圖片證據不足',
  'VmkyQv': '請選擇!',
  'Vw3U6j': '買家不配合調查',
  'WeJTWt': '銷售價',
  'WfQfPL': '收件人未備案',
  'WhsF10': '通知郵箱',
  'XYe+Jv': '已受理',
  'YIWnSk': '反饋附件',
  'YXPE2M': '請選擇索賠類型',
  'ZEEWDf': '請填寫 {applyTotalItemPriceMin}-{applyTotalItemPriceMax} 的數，最多保留2位小數',
  'ZdXHn3': '請填寫小於等於 {applyTotalItemPriceMax} 的數，最多保留2位小數',
  'a1GC6B': '代客索賠服務協議',
  'aEjIKB': '申請索賠商品數量',
  'ci/d9J': '申請日期',
  'dBccG5': '供應商不回復索賠結果',
  'e3jwTU': '請輸入!',
  'eJgUUz': '申請信息',
  'eLONg8': '申請賠付幣種',
  'eaF3d8': '超索賠期供應商拒賠',
  'eqH27/': '供應商確認賠付結果時間',
  'fDm5Jz': '所有代客索賠在理賠時效內的最後一個工作日的12:00之前提交，逾時不處理，處理審核的時效為1個工作日！',
  'fDnTRk': '1，客戶不能完整無誤提供Wint所要求的證明文件或者索賠申請文件；客戶不能在有效期內提出索賠，Winit不作受理；{break}2，Winit僅代客戶向尾程供應商索賠，對於索賠時效及最終賠付金額Winit不做任何承諾且不承擔任何責任，以尾程派送供應商的時效和最終賠付金額為準；{break}3，尾程派送供應商確認的賠償結果即為索賠的最終結果，Winit不再代客戶向尾程派送供應商進行第二次索賠申訴。',
  'foeSsK': '編輯代客索賠單:{compensateApplyNo}',
  'h9CKhv': '系統錯誤！',
  'hJZyHS': '包裹退回發件人',
  'hMWBOo': '請輸入有效的郵箱地址，多個郵箱請用英文逗號分隔',
  'hugHvs': '受理範圍',
  'j+a8uD': '請輸入郵箱,支持輸入多個郵箱,多個使用英文逗號分隔',
  'j2TO8a': '索賠貨物英文描述填寫說明：',
  'kn569p': '是否為LMA訂單',
  'lqR+og': '請輸入索賠商品數量',
  'nQ5tSF': '請按 {applyTotalItemPriceType} 輸入支持2位小數,需與貨值證明金額一致,否則有拒賠風險',
  'nf87O3': '索賠貨物英文描述不允許輸入 {invalidChar} 等特殊字符',
  'nisQHN': '實際賠付幣種',
  'oy+a30': '評價',
  'q2Rokj': '倉群間',
  'qHZ4DP': '人民幣換算當地貨幣的匯率',
  'qdvxnx': '文件格式限製為{allowExtensions}',
  'rfi+L1': '評價原因',
  'trjozq': '受理時效',
  'u02CN/': '供應商確認賠付待到賬',
  'vG/J9C': '尾程運費',
  'xIvUPW': '不在供應商受理範圍內',
  'xTzl0b': '倉群間+倉群內',
  'xpYYfX': '請輸入索賠商品數量不能超過出庫商品總數:{merchandiseQTY}',
  'xplETi': '索賠詳情',
  'zRl49D': '索賠貨物英文描述',
  'zUiu6i': '(支持多選)',
  'DIEfyv': '換行',
  'qpR1hg': '索賠標準說明',
  '+YWu7f': '編輯預約單',
  '3Lerqg': '預約總單品數',
  '4Df3pr': '取消增值預約',
  '6+vQ9D': '物流單',
  '7i3N9K': '刪除部分訂單',
  '82/C1l': '操作記錄',
  'ApzxyV': '備註：{break} 1、若Winit有默認配置分倉比例，系統將自動帶出，支持您自行修改；{break} 2、同一個分倉組合的所有倉庫的拆單比例加和需等於100%；{break} 3、若Winit有配置倉庫對應的底線比例，則配置該倉庫的拆單比例應當大於等於底線比例；{break} 4、分倉規則如下說明：{break}',
  'B3tb1+': '當入庫單是否支持合並預約=是，指該賣家直發的入庫單可以與Winit承運的入庫單一起合並預約送倉，客戶無需預約，由Winit統一安排預約送倉；若客戶需要取消合並預約，可前往萬邑聯-海外倉-入庫單列表-操作列按鈕：取消合並預約，自行取消合並預約；',
  'CGZi9F': '預約單到倉',
  'CfgLmO': '時間置換',
  'DLJr86': '重新測量尺重',
  'FhkIRV': '分倉比例偏好設置',
  'FzGNHO': '以下為Winit推薦的分倉組合，您可以針對不同的分倉組合修改對應的倉庫優先級和拆單比例作為定製的偏好；',
  'Gm0B5e': '預約單品數',
  'HLw9KS': '是否采集批次信息',
  'HkOkP6': '針對單個暫存商品發起重新測量，若WINIT再次測量結果與本次測量結果未超誤差範圍則會存在最低收費，若同倉庫存在多個暫存商品需重新測量，可前往【退貨暫存處理】頁面批量發起。',
  'IlmiwX': '預約總商品數',
  'J/JI0w': '預約總包裹數',
  'JbGo8r': '驗貨包裹數',
  'K7uftF': '櫃型',
  'KYyoJH': '商品上架數量是否有差異',
  'OpxFPG': '是否支持合並預約',
  'Ox8M6v': '底線比例%',
  'QznX7j': '拆單比例%',
  'R+Rgaz': '送倉信息',
  'RcmEcd': '回執',
  'U/8+oQ': '封條號',
  'VHAAss': '入庫單狀態',
  'WFHaMM': '未到倉',
  'XoUWci': '預約重量(kg)',
  'Y/Td5e': '卸貨包裹數',
  'ZksbG3': '暫存商品',
  'a3zvco': '定製拍照模版優先級高於WINIT標準模版，若商品已配置定製拍照模版 或 客戶級拍照模版，則此配置不適用，倉庫會按定製模版進行拍照，否則按此配置的WINIT模版類型進行拍照。',
  'cpMIb6': '增值訂單',
  'd7lb9g': '增值預約審批',
  'ewTYYR': '{break}<span>分倉拆單規則：</span>{break}',
  'gVtDem': '分倉組合名稱',
  'ggWeEC': '下單包裹數',
  'hXfCth': 'Booking',
  'iM4kr0': '預約體積(CBM)',
  'iXrDXP': '智能分倉的入庫單不能在草稿狀態打印包裹條碼，請下單成功分別在不同拆單後的入庫單打印包裹條碼！',
  'ioriKB': '上架包裹數',
  'jlGfDt': '取消預約',
  'k1wCYD': '賣家網站',
  'nYLYtl': '<title>溫馨提示:</title>{break} <span>1.請指定BC類包裹目的倉</span>{break} <span>2.系統將按照分倉比例對A類包裹自動進行拆分，支持自行調整，確認提交後系統將自動拆分成多個訂單</span>',
  'nZ0IYP': '1）A+/A包裹，將包裹下的商品進行匯總，根據商品的單品數量按照分倉比例進行拆分；{break} 2）BC包裹，按照指定目的倉分配；{break} <ml8>如下舉例：</ml8>{break} <ml8>1. 下單：下單10個A+包裹，5個A包裹，包裹下的商品均為SKU01，每個A包裹有10個單品；</ml8>{break} <ml8>2. 分倉：分2個倉，倉庫A和倉庫B，分倉比例為71%和29%，倉庫A的優先級高於倉庫B；</ml8>{break} <ml8>3. 計算邏輯:</ml8>{break} <ml16>3.1. 計算A+/A包裹的單品數量：10*1+5*10=60個；</ml16>{break} <ml16>3.2. 計算按照單品數量的分倉結果：A倉庫：60*71%=42.6個單品，B倉庫60*29%=17.4個單品；</ml16>{break} <ml16>3.3. 按照優先級，倉庫A優先級高於倉庫B，即優先分配倉庫A；</ml16>{break} <ml24>3.3.1. 系統默認有A+包裹優先分配；</ml24>{break} <ml24>3.3.2. 最終結果為：倉庫A：分配10個A+包裹+4個A包裹，共計50個單品，倉庫B：分配1個A包裹，共計10個單品；</ml24>',
  'peLNcQ': '重新預約',
  'u9v0vg': '取消合並預約',
  'v5tuoD': '送倉單',
  'vsat58': '是否智能分倉',
  'x/VGSI': '管理系統',
  'yOnUB/': 'WINIT檢查是否拍照',
  'ySu2dq': '增值預約收費',
  'zQgoWI': '包裹是否上架',
  'zfRpkM': '根據勾選的暫存商品,會按倉庫的維護匯總創建一個復測增值訂單!',
  'iaJF/P': '請務必在下單前確認您在目的倉有充足的庫容額度，否則將無法提交訂單，您的各倉庫容額度可<a>點擊此鏈接</a>進行查看！',
  'X2jA1F': '1）A+/A包裹，將包裹下的商品進行匯總，根據商品的單品數量按照分倉比例進行拆分；{break} 2）BC包裹，按照指定目的倉分配；{break} <ml8>如下舉例：</ml8>{break} <ml8>1. 下單：下單10個A+包裹，5個A包裹，包裹下的商品均為SKU01，每個A包裹有10個單品；</ml8>{break} <ml8>2. 分倉：分2個倉，倉庫A和倉庫B，分倉比例為71%和29%，倉庫A的優先級高於倉庫B；</ml8>{break} <ml8>3. 計算邏輯:</ml8>{break} <ml16>3.1. 計算A+/A包裹的單品數量：10*1+5*10=60個；</ml16>{break} <ml16>3.2. 計算按照單品數量的分倉結果：A倉庫：60*71%=42.6個單品，B倉庫60*29%=17.4個單品；</ml16>{break} <ml16>3.3. 按照優先級，倉庫A優先級高於倉庫B，即優先分配倉庫A；</ml16>{break} <ml24>3.3.1. 系統優先分配單品數量多的包裹，直至達到分倉比例；</ml24>{break} <ml24>3.3.2. 最終結果為：倉庫A：分配5個A包裹，共計50個單品，倉庫B：分配10個A+包裹，共計10個單品；</ml24>',
  'mwgDgO': '{break}<span>分倉規則如下說明：</span>{break}',
  '0pGnRG': '请确认是否创建?',
  'avNw+9': '申請代客索賠',
  'zr9GzM': '取消第三方合並預約',
  'f6Msch': '公司名稱僅支持英文、空格、數字、英文格式的連字符（-）、和號（&）、圓括號（( )）、斜杠（/）、句號（.）,請修改後重新輸入。',
  'BYrriq': '實際包裹數',
  'DMWygJ': '驗貨體積(CBM)',
  'NdyxGS': '驗貨尺重',
  'fqPPUZ': '驗貨重量(kg)',
  'zalGCs': '下單尺重',
  'W+h03U': '實際尺重',
  'twcbGg': '國內倉抽驗後確認數量',
  'y3f54g': '7.如果您需要上傳多種收貨人類型的訂單時，請先拆分訂單後再上傳。',
  '2+3GNH': '圖片限制大小{size}M以內，請壓縮後上傳',
  '5J4Kg7': '請輸入{name}',
  'BuPcLP': '且最多保留{scale}位小數',
  'KJqOG1': '格式錯誤',
  'ROiSCr': 'sheet頁',
  'RYD/kA': '格式限制小於{max}的數',
  'W+zrR1': '文件格式限制為{format}',
  'aPcADB': '長度限制最少{minLength}個字符',
  'fFsRGV': '圖片限制格式為{format}',
  'fWCKfV': '格式限制[{min},{max}]區間數',
  'l36qrs': '格式限制大於{min}的數',
  'md1Oyf': '長度限制最多{maxLength}個字符',
  'x5UKly': '長度限制{minLength}-{maxLength}個字符之間',
  'eKgHZC': '多層包裝不可選擇“不指定包裝”',
  'nxlceY': '商品編輯，出口國家/地區不允許選擇美國！',
  '/th1fU': '支持預約的入庫單量為0！',
  'HxC2VI': '支持預約的入庫單量：',
  'gX/Fwn': '備註說明:若您點擊創建預約單,系統將支持預約的入庫單合並創建一個新的預約單!',
  'lILo+B': '不支持預約的入庫單量：',
  'mJ3Mvf': '確認復製嗎?',
  'mns98D': '入庫單【{orderNo}】已綁定預約單【{bookingNo}】，回退草稿後將取消預約單，屆時您將重新創建預約單，確認是否回退到草稿？',
  'qmTv4w': '不支持預約原因',
  'sXp295': '復製創建預約單',
  'wGtjeJ': '是否復製原預約單信息直接創建?',
  '02dIi2': '平臺退貨單創建時間',
  '1Z7MG0': '平臺RMA號',
  '6d79n8': '平臺{platform}和eBay/TikTok不能同時選擇',
  'CWQV3t': '確認撤回嗎？',
  'Gdzq57': '退貨發貨時間',
  'Gp5HaQ': 'TransactionID',
  'aA7INh': '至少填寫1項{break}國家、州、城市、郵編若填寫,必須同訂單完全一致才能匹配',
  'LD7GZo': 'eBay僅能選擇18個月內的日期',
  'M9LPoJ': '平臺{platform}和ebay不能同時選擇',
  'dtTOxf': '詳細地址2',
  'oAwNvZ': '詳細地址1',
  'yVadR+': '退貨倉庫地址詳情',
  '+lfBfo': '到賬日期',
  '/++xi3': '第三方倉已出庫',
  '0LtbFX': '無上網並退貨上架',
  '0z9bjM': '補收單',
  '10x/wc': '溫馨提醒：財務的審核時間為5個工作日，由於包裹仍有可能延遲更新軌跡，並未丟失，財務會以審核時的最後軌跡狀態為準。如若在審核時軌跡有更新，會拒賠此單，但如果賠付後上網也不會額外補收。索賠受理時限為出庫日期後第11個自然日至45個自然日內，出庫當天為Day 0。',
  '1qZPE9': '此附件指，收到包裹及實物照片（能清晰識別包裹外的快遞面單，SI卡頭的單品條碼/M開頭的商品條碼）',
  '29WnEW': '索賠被拒',
  '2Kp9u5': '新增標準索賠單',
  '3ESazo': '索賠單據類型',
  '3KXefx': '退貨分類',
  '3vdl5d': '超時無上網',
  '3yv61P': '賠付金額',
  '48/DRB': '海外倉庫內丟失',
  '4DetPs': '多發貨物',
  '4UW5pU': '客戶編碼',
  '5gdhY5': '商品信息（若需要提供商品信息明細，請您聯系在線客服）',
  '6YEHIA': '庫間調撥丟失',
  '6Z+XFF': '取消人',
  '6kavqv': '1.選擇帶A-scan服務的貨物交尾程派送供應商後，在出庫單狀態為「派送中」，對應的尾程派送服務渠道沒有有效的派送軌跡生成。{break}2.供應商不接受客戶索賠，而且買家證實沒有收到貨物。{break}3.受理時限為出庫日期後第11個自然日至45個自然日內，出庫當天為Day 0{break}舉例：**訂單是10月2日出庫，10月2日為DAY 0,索賠的受理時效為10月13日---11月16日',
  '6vg3QB': '註：只允許派送中的包裹申請超時無上網',
  '7qhI2u': '包裹海外倉卸貨時間',
  '8cd7j6': '此附件指，圖片可清晰看到Winit出庫單號或快遞單號。',
  '9+KfPI': '請輸入索賠說明',
  'ATT7x+': '買家收到實物照片',
  'AnNqLb': '完成客服',
  'B9FX6E': '庫間調撥破損',
  'CcSWqn': '空',
  'DQCUED': '海外倉庫內破損',
  'DglTqP': '申請標準索賠',
  'DlyXTU': '1. 選擇了沒有Tracking服務的貨物不在此賠償範圍內。{break}2. 澳洲With Registration服務無A-Scan承諾，僅有簽收證明，不在此賠償範圍內。{break}3. 申請並獲得了尾程供應商賠付（Winit代客索賠服務）的貨物不在此賠償範圍內。{break}4. 證明貨物已交尾程供應商的，不在此賠償範圍內。{break}5. 客戶不能提供Wint所要求的證明文件或者索賠申請文件；',
  'DtcSoO': '索賠金額（USD）',
  'E910VQ': '支持輸入出庫單號、快遞單號、萬邑通跟蹤號',
  'F9hOqH': '退貨運單號',
  'FTHPZP': '賠付金額（USD）',
  'GMOAU7': '面單照片',
  'Hm5SLN': '操作時間(北京時間)',
  'Icf5jG': '此附件指，收到貨物的清晰M碼或S碼照片（能清晰識別SI開頭的單品條碼/M開頭的商品條碼）',
  'Ip8eFD': '由於原索賠單已找回，原有索賠金額將補收回來',
  'JP07eh': '單品條碼、商品條碼照片',
  'K+M9tc': '消息反饋',
  'NdKn8a': '異常產生日期',
  'ODouBx': '商品下架出庫單號',
  'ONOXRP': '貨物運單號 網上軌跡截圖',
  'OqV75t': '單次導出不能超過 {maxExport} 條，請縮小篩選條件再導出',
  'PK7a1r': '頭程破損',
  'PbNtRA': '提交成功!',
  'PurMpo': 'Winit海外倉原因導致發錯貨物。產生串貨的情況，或者發錯給買家的情況。',
  'QpJsOc': '此附件指，買家向賣家投訴沒收到貨，並且要求退款或補發的溝通截圖，{break}①證明投訴為買家本人 {break}②證明投訴的訂單與出庫單屬於同一個訂單。',
  'R1gXZc': '1、客戶不能提供Wint所要求的證明文件或者索賠申請文件；{break}2、索賠受理時限為出庫日期後80個自然日內，出庫當天算Day 0 。',
  'RXddtb': '錯交供應商-無法退回',
  'Ryp1al': '第三方倉退倉重新上架',
  'SGO2k0': '第三方倉重新貼標',
  'SnQWkX': '退回貨物運單的物流供應商面單',
  'TWpf/3': '客服回復',
  'Tsnb9z': '至少需要有一件商品的索賠數量大於0',
  'U0BwdQ': '編輯標準索賠單:{serial_number}',
  'UgJWyM': '退貨入庫單',
  'VIiRrc': '庫內貼標錯誤',
  'VerSyC': '數據唯一編碼',
  'W02EEZ': '索賠成功',
  'WjqeLR': '到倉未上架丟失',
  'X5zp/w': '買家投訴郵件',
  'YjG8ws': '1. 貨物出庫10個自然日之後對應的尾程派送運快遞單號網上軌跡查詢狀態（無A-scan軌跡）；{break}2. 買家向賣家投訴沒有收到貨物的溝通截圖，或者證明賣家包裹已按照原訂單信息重發或者賣家已根據指定訂單退款的截圖。',
  'YtXXdL': '此附件指，能證明賣家已完成重發或者退款的截圖，或者平臺上訂單發起退款的截圖，{break}①重發截圖須體現重發包裹的收件人地址、收件人名，收件人電話信息及商品信息必須與原訂單一致{break}②退款截圖須包含winit訂單號或者快遞單號等能證明為該筆訂單交易的退款{break}以上信息請在圖片中重點標註，以防被錯誤退回{break}買家投訴郵件和退款或補發截圖 二選一提供其中一份符合要求即可。',
  'Z/R8Iz': '整包',
  'ZZg9Ba': '註：只允許派送中、派送成功、派送失敗的包裹申請錯發貨物',
  'ZmnSnN': '退款或補發截圖',
  'ZoAvYj': '退貨丟失索賠暫不支持線上申請，請按賠付標準提供資料聯系在線客服調查退貨丟失情況，調查結果若確認退貨到倉丟失則Winit會主動發起賠付。',
  'aZHm4k': '快遞單號【{trackingNo}】已申請代客索賠【<a1></a1>】，暫不支持重復申請索賠，如有疑問請聯系在線客服。',
  'beR0hU': '漏發貨物',
  'br1oBU': '客服工單號',
  'c48sip': '此訂單已提交過索賠，索賠流水號{serial_num}，請直接查詢。',
  'cM7IDg': '賠付幣種',
  'dG7pk9': '到賬時間',
  'eCWHEh': '1. 面單照片（可見Winit出庫單號或快遞單號）{break}2. 收到所有單品的清晰M碼或S碼照片{break}3. 包裹及實物照片。{break}註：如買家/賣家無法提供面單照片和收到貨物的清晰M碼或S碼照片：請聯系Winit客服調查，如Winit客服確認倉庫錯發，將主動發起賠付，並且於確認後的五個工作日內賠償到賬。{break} 1）原出庫單號；{break} 2）收到貨物的包裹及實物照片； {break}3）買家向賣家投訴收到錯貨的溝通截圖。',
  'eCZEW+': '頭程丟失',
  'eKQbFf': '原單',
  'gUvzzF': '錯發貨物',
  'hDbcfV': '補賠單',
  'hVYsuo': '退貨重量',
  'ieLpUT': '原索賠單信息',
  'izFnP+': '註：只允許派送中、派送成功、派送失敗的包裹申請退貨丟失',
  'j4p94F': '倉庫核實漏發的連接或郵件截圖',
  'k2mGmc': '此附件指，買家投訴發錯貨的郵件（能清晰識別到快遞單號/ winit訂單號 / 賣家訂單號 / 電商平臺交易單號比如ebay TransactionID, ItemID)',
  'm8Z4lP': '倉庫核實錯發的鏈接或郵件截圖',
  'mfVObj': '退貨丟失',
  'p91JT+': '索賠標註說明',
  'pQ14T/': '雲倉卸貨記錄截圖',
  'qG/qcD': '免賠範圍',
  'qPibZC': '錯交供應商-退回到倉',
  'qzC1QW': '是否是自驗貨',
  'rUKhaE': '索賠申請資料',
  'tV2A33': '賠付單位',
  'thG2AF': '原索賠單',
  'tjA0bt': '原索賠單流水號',
  'wflzko': '自提出庫丟失',
  'wmO+TV': '調撥單',
  'xccF66': '非整包',
  'xfWrWt': '請輸入異常類型',
  'ykapbL': '至少需要一件商品',
  's0PQJ3': '庫間調撥破損',
  'ZQsadN': '支持輸入出庫單號、快遞單號',
  '7/6GMQ': '狀態變更',
  '33niK1': '客戶主體變更稽核後恢復額度',
  'XI6ZFw': '客戶主體變更暫停額度',
  'hBJBNE': '關聯',
  'R0/9TS': '標準面單示例',
  '/4W7Tn': '前往已下單訂單',
  '03t9MR': '文件上傳成功',
  '42OgKJ': '非WINIT出庫Return Label訂單（使用WINIT退貨面單服務）',
  '49sagY': '請根據所需要的下單場景選擇正確的模版創建退貨單，目前支持以下三個場景下單：',
  '6tHpbq': '如果是WINIT出庫退貨 <a>點擊此處下載《標準退貨-WINIT出庫非Return Label服務專用模版》</a>',
  '9IJ/fA': '增值處理完成時間',
  'AWqqOx': '標準退貨',
  'AyT4mM': '填寫出庫單號則會自動將原出庫單信息【收件人信息、出庫商品信息】下載至模版內{break}若存在不支持啟動退貨的訂單，請在輸入框中刪除對應訂單後再下載模版',
  'Ef5GsY': 'WINIT出庫Return Label訂單（使用WINIT退貨面單服務）',
  'GMlLgw': '創建失敗(條)',
  'H7pUU5': '當出庫單為一單多子單服務時，需要通過子單號發起退貨',
  'JZBDVe': '請上傳XLSX格式模板, 最多可導入1W條數據，文件大小上限30M，如文件過大，請拆分成多個文件分批次上傳',
  'K9c8Oa': '標準退貨-WINIT出庫非Return Label服務專用模版',
  'NxjxR0': '下載回執',
  'Y9M573': '訂單內商品倉庫收貨後的實際處理完成時間，基於訂單內最後一個處理的單品的實際處理策略取值，策略為拍照暫存則為暫存完成時間，策略為直接上架則為上架完成時間， 策略為銷毀則為銷毀完成時間。',
  'dDZYBp': '已下單的退貨訂單不支持在此頁面更新退貨單信息，若創建錯誤需取消後重新下單',
  'fXYgEh': '非Return Label支持導入成功後在回執文件內獲取到收件人以及帶RMA號的專屬收件地址信息。',
  'gtWL6U': '創建成功(條)',
  'jG47FI': '標準退貨-WINIT出庫Return Label服務專用模版',
  'kVADjE': '如果是非WINIT出庫退貨 <a>點擊此處下載《標準退貨-非WINIT出庫專用模板》</a>',
  'mR7h1z': 'WINIT出庫非Return Label訂單',
  'sQ0mrW': '單次最大支持100個出庫單',
  'se3hAx': '如果是WINIT出庫退貨 <a>點擊此處下載《標準退貨-WINIT出庫Return Label服務專用模版》</a>',
  'w3xp/Q': '訂單內訂單內最後一個RM商品增值完成時間，訂單狀態切為已完成。',
  'zV1tv1': '下載模版',
  'zfcyli': '可輸入WINIT出庫單號，單次最大支持100個出庫單，多個可換行或英文逗號(,)隔開',
  'qB8UnK': '三方面單服務',
  '2BMovZ': '撤回成功',
  'Dpm3Fm': '是否要撤回此付款單？',
  'fi6T5Q': '請提供與商品實物、銷售商品鏈接上一致的型號，避免審核退回修改。若沒有型號請填寫“無”。',
  'iSkSqR': '三方面單訂單（通用模板）',
  'kCS8F7': '三方面單訂單（平臺專用模板）',
  '3C70KE': '請填寫數據',
  'ANYnok': '庫內',
  'KmPK3s': '當前行的左邊申報價值需大於上一行的右邊申報價值，請修改後重新提交。',
  'YvHGhi': '填寫數字需大於等於0！',
  'ceBz7p': '若您配置了以下偏好，當人工/系統創建箱/套裝庫存調整單時，將自動獲取您的配置偏好，拆箱時進行商品逐件清點；',
  'f9xtGe': '填寫數字需大於0！',
  'imKkCz': '是否需逐件清點',
  'rLSVYX': '右邊的數字需大於左邊數字',
  'sVvA5q': '商品的進口申報價值',
  'yzFo2u': '當您創建箱轉單一庫存調整單時，若商品滿足您配置的進口申報價值區間，拆箱時將進行商品逐件清點；',
  'QElQuf': '近{days}天不再顯示',
  'XZVTu9': '校驗地址',
  'xEJFBo': '智能推薦下單是指系統根據客戶下單時買家地址、派送方式、海外倉庫存等信息,基於配置的發貨策略計算出最優發貨方案(發貨倉庫和派送方式的組合)後,自動按照最優方案發貨{break} 註： {break} - 如果訂單為組套訂單，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單來源為「平臺同步」並且電商平臺為「速賣通」或「TIkTok」，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果客戶下單時指定了批次商品，不支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單的收貨人類型為「FBA轉倉-VC訂單」或「FBA轉倉-非VC訂單」，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單包含不允許拆單的增值服務，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 預售訂單無在庫庫存不支持推薦倉庫和產品發貨{break} - 當您在【倉組配置】裏面選擇了【校驗地址】，在推薦的過程中會校驗地址並且預估地址相關的附加費用；如果您未選擇【校驗地址】，推薦的過程中將不會校驗地址，也不會預估地址相關的附加費用，推薦結果的準確性可能存在偏差。',
  '0n576u': '包裹數(預估|實際)',
  'Dai8r5': '總單品數(預估|實際)',
  'NrTd+i': '出庫數量(預估|實際)',
  'Akeoip': '如何進行驗貨操作?',
  'TMYVPY': '<bold>溫馨提示：</bold>{break}如需查詢和導出已完結3年以上的歷史訂單數據，請聯系在線客服。',
  'NcucBQ': '<title>地址校驗功能使用提示</title>{break} ⚠️ <bold>使用須知</bold>：勾選 「校驗地址」 後，在系統推薦的過程中將對您填寫的地址進行驗證（德國地址校驗/住宅地址校驗），可能出現以下情況：{break} 1.<bold>下單耗時增加</bold>：校驗地址過程需與物流商地址校驗接口交互，下單時長可能延長 3~5s；{break} 2.<bold>下單失敗風險</bold>：若物流商地址校驗接口出現臨時故障、網絡異常等異常情況，可能導致下單失敗。{break} <red>註：請仔細核對以上風險提示信息後謹慎選擇，確認勾選即視為接受上述風險。</red>',
  '+dTLCm': '成功同步{successCount}個',
  '0f7VEw': '取消失敗{failedCount}個請稍後重試{break}',
  '3aeyfd': '未同步',
  '3eKKfh': '僅未同步/同步失敗狀態訂單操作',
  '8QbMUo': '履約中心ID',
  'BYYQoI': 'LPN',
  'EoEz+f': '成功撤銷{successCount}個',
  'Fu1ey6': '成功取消{successCount}個',
  'HzNUHy': '撤銷成功',
  'KBgfjH': '批量撤銷',
  'L79/L5': '撤銷失敗{failedCount}個{break}',
  'M72Spb': '查看同步失敗列表',
  'MMYQ00': 'FBA退貨單號',
  'MWWv4c': '撤銷失敗',
  'OA1lI2': '取消失敗',
  'OxY5CB': '查看取消同步列表',
  'TwN/uR': '批量同步',
  'W56e0Y': '重新同步',
  'W6bBA3': '查看未同步列表',
  'X8qCBY': '僅取消狀態訂單操作',
  'XDQ2wC': '同步成功，',
  'XjH2Wi': '同步成功',
  'ZiBmzg': 'LPN碼',
  'dPGcC7': '確認同步嗎？',
  'dRm8V9': '取消成功，',
  'dcdgId': '取消同步',
  'fsHeVZ': '確認撤銷嗎？',
  'hR4j9y': '撤銷',
  'hYuyFy': '商品同步異常原因',
  'izEwJI': '您未開啟FBA退貨單同步開關將不會同步報告 <url2>去開啟></url2> <a1>查看詳細介紹</a1>',
  'j+em3g': '查看已同步列表',
  'nfzk7/': '退貨時間',
  'qnqsfV': '同步失敗{failedCount}個{break}',
  'rkiG6m': '撤銷失敗，',
  's6vDiK': 'FBA退貨單物流信息報告每天更新{pullCount}次，僅更新{pullFrequency}天內報告。最新更新時間{pullDate} <a1>查看詳細介紹</a1>',
  'wKkI7s': '取消失敗，',
  'xBcz9a': 'FNSKU',
  'xhmgv4': '撤銷成功，',
  'zEIkLk': '同步失敗，',
  'zwuANK': '商品同步狀態',
  '0tgneD': '已關聯',
  '2uzTTX': '成功撤銷{successCount}個',
  '3nppSO': '關聯失敗',
  '6DCH+f': 'Amazon移除單操作說明',
  'AN6GH5': '成功取消{successCount}個',
  'CdINvG': '取消關聯',
  'NtY0E8': '成功同步{successCount}個',
  'ex43en': '自動同步移除單&FBA退貨單',
  'hXKgDD': '設置自動入庫規則',
  'l06LmZ': 'FBA退貨單報告每天更新{pullCount}次，僅更新{pullFrequency}天內報告。最新更新時間{pullDate} <a1>查看詳細介紹</a1>',
  'o4+t2Y': '您是否需要自動同步獲取移除單商品明細數據以及移除單跟蹤號信息，同時包括FBA退貨單信息獲取LPN碼以供倉庫識別商品',
  'tXji6c': '未關聯',
  'CtVsla': '查看未關聯列表',
  'KHYPUz': '查看取消關聯列表',
  'Mz+pKJ': '同步關聯失敗',
  'SqFYrJ': '同步關聯成功{successCount}個',
  'axjLft': '查看關聯失敗列表',
  'gLJGbs': '同步關聯成功',
  'lquvpq': '查看已關聯列表',
  'nu/e3p': '同步關聯失敗{failedCount}個{break}',
  '0XsEG/': '您未開啟移除單同步開關將不會同步報告 <url2>去開啟></url2> <a1>查看詳細介紹</a1>',
  'YGl5V/': '當前存在{removeOrderNoLength}單已下單但未上架的移除單，請勿直接關閉移除單同步。示例單號：{removeOrderNos}{break}若關閉開關將導致上述訂單無法獲取新的快遞單號/LPN碼，倉庫將無法識別到倉包裹/商品，請謹慎操作。確定仍要關閉開關嗎？',
  '5/YAvH': '可缺比例',
  '6HrVzW': '確認正常出庫',
  '6QNfn6': '不同意缺量出庫，Winit將自動作廢訂單。您如要繼續發貨需重新下單。{break}是否確認，不同意缺量出庫？',
  '6khOLR': '缺失SI數',
  '7FWwRs': '您輸入的{name}[{value}]非正整數和0，請修改',
  '8Asou7': '最大可缺比例',
  'AHslQm': '缺量訂單處理',
  'BHseVz': '向上取整',
  'CnasbR': '您輸入的{name}[{value}]非0和最多兩位小數的數字和正整數，請修改',
  'DzZZQa': '訂單SI數終點',
  'GvnhBj': '您輸入的缺量值[{value1}]大於訂單SI數[{value2} ]，缺量值只能在訂單SI數區間內，請修改',
  'HH0mb1': '您輸入的{name}[{value}]非正整數，請修改',
  'HSbl3Z': '訂單單品數範圍',
  'IZn7Zg': '確認是否修改?',
  'KNTy5n': '您輸入的{name}[{value}]超出最大限製100，請修改',
  'MnNgWI': '同意缺量出庫後，Winit將安排訂單正常交貨給供應商;如果為自提單，請盡快安排供應商提貨。{break}是否確認同意缺量出庫？',
  'PiBHfq': '您輸入的{name}[{value}]非正整數或0，請修改',
  'RAuvJQ': '異常處理狀態',
  'SSltse': '向下取整',
  'SxJ9GS': '可缺SI數',
  'THF/1n': '確認作廢訂單',
  'Uk/dcL': '實際發貨倉',
  'WrVILK': '直接出庫',
  'YfrP7D': '下單SI數',
  'ZWZbtt': '倉群內拆單',
  'aczPp4': '方案確認時間',
  'f2KXxR': '缺量值',
  'fo9KMc': '查看缺量商品',
  'gImTsw': '設置缺量出庫規則',
  'hJL5I5': '您輸入的{name}[{value}]超出最大限製100000，請修改',
  'hhuy/C': '缺量出庫規則',
  'iMwK3P': '已打包SI數',
  'iWsoz/': '方案確認人',
  'jmzqau': '最大可缺單品數',
  'lkqAQX': '確認處理方案',
  'mjQPee': '您輸入的訂單SI數[{start1}-{end1}]與[{start2}-{end2}]存在重疊區間，請修改',
  'nsr4Y8': '您輸入的訂單SI數[{value1}]小於等於[{value2}]，終點值必須大於起點值，請修改',
  'p+tMyp': '打包完成時間',
  'pP65KW': '訂單SI數起點',
  'x1egnc': '註:對於不在以下規則範圍內的訂單,如遇缺貨,WINIT默認出庫規則為"不允許出庫"。',
  'zHVyhR': '缺量維度',
  '8U2r1I': '商品分類',
  'Re5nvq': '重新註冊商品',
  'UWi7Ma': '商品回執資訊',
  'YHQukw': '回執資訊',
  'GvZcae': '上傳失敗原因',
  '+7rXZn': '上架子包裹體積',
  '/rFwLb': '您選擇的產品【{winitProductName}】無法在下單時選擇提貨時間，請您驗貨完成後前往萬邑聯-入庫單全部訂單-待處理事項，補充提貨時間，謝謝！',
  '8tfLG5': '修改識別碼',
  'Iz/PPI': '子包裹來源',
  'LTXQVa': '打印失敗',
  'MHN+5B': '待補充提貨時間',
  'TYcOfj': '倉庫是否已掃描',
  'aZfMpy': '尊敬的客戶您好！下單後您需完成驗貨，才可將貨物發往萬邑通國內倉庫，否則將產生異常並收取異常費用！若您選擇的是Winit上門提貨，請驗貨完成後，登錄萬邑聯-入庫全部訂單，補充該入庫單的提貨時間，屆時萬邑通將在該提貨時間安排上門提貨，謝謝！',
  'e4T0CT': '非客戶',
  'teniS8': '如您發現無法選擇提貨時間,請修改"物流計劃"或將提貨類型改成""自發物流"!',
  'xRN4c5': '驗貨子包裹體積',
  'yejLLK': '維護識別碼',
  'DkAqhG': '最大限體積',
  'FKbLCe': '最大限高',
  'YwI4T5': '最大限寬',
  'odbnh2': '最大限重',
  'v8espj': '最大限長',
  '4RJQ5E': '驗貨設置',
  'E3N588': '是否打開',
  'V3Vt+a': '客戶自驗貨時觸發子包裹體積限製',
  'Us+yh+': '說明：{break} 偏好設置打開後將在驗貨環節限製小件子包裹體積不能超出0.04cbm{break} 若不啟用限製，針對小件子包裹體積超出0.04cbm的SKU，WINIT將收取理貨費用，請留意相關收費項{break} *請在驗貨開始前完成偏好設置，偏好設置將不會對已開始驗貨的訂單生效{break}',
  '4NLuER': '支持SKU指定庫內擺放管道',
  'JdX94J': '啟用後，支持在商品級進行標記商品的存儲擺放管道【平放、側放、豎放等】',
  'hE6rE9': '可選履約要求',
  'tU239Q': '開通服務後，指定擺放管道商品的庫存存儲費用將會高於普通商品，請結合實際需求謹慎開啟。',
  '5X6Sjh': '直接提交：在創建訂單時，可一次性提供增值服務所需的完整文件。{break}暫存後補充：創建訂單時暫無法提供文件，需等倉庫打包暫存完成後再補充。',
  'GU+Vrq': '提交環節',
  'XQZcrd': '暫存後提交',
  'YmPeU6': '提交環節：後續補充文件時，選擇補充文件的環節(如暫存後提交)。',
  'iZ4ZzP': '暫存後補充',
  'ky6kSp': '直接提交',
  'vr/2qa': '文件提交方式',
  '22Mqpn': '無有效WEEE註冊號',
  '3Qv+VL': '說明：快捷關聯將依據”未關聯“商品所屬的“WEEE類別”，快捷關聯該”WEEE類別“且當前”有效“的WEEE註冊號，若對應商品無有效類別的“WEEE註冊號”則會忽略關聯。',
  '5tt4V2': '失效原因',
  '6X472P': '確認並同意使用快捷關聯',
  '6uUWc2': '未關聯商品的WEEE類別',
  'ICNo7r': '商品擺放管道',
  'EeBRbZ': '未關聯的商品對應類別無有效WEEE註冊號，請添加提交審核，且審核通過後再進行關聯操作！',
  'FRsmym': '已在執行關聯，請稍後刷新查看關聯情況！',
  'FvspUO': '無未關聯的商品。如需更新請使用單個關聯或模板導入',
  'G3ZzET': 'WEEE註冊文件',
  'GOmMKL': '已關聯成功【{qty}】個SKU',
  'IPThwp': '鑑於以上提交的內容，我/我司聲明：{break} 1.對於由我/我司的提供德國WEEE註冊信息關聯的商品有在德國主管部門（Stiftung Elektroaltgeräte Register – EAR）註冊備案，並按時申報對應商品投放數據及繳納回收費用，另外對應商品也印上WEEE標籤。{break} 2.如果我/我司的WEEE註冊信息發生任何變更，將通知貴司修改。{break} 3.上述提交的所有信息均屬實，如有虛假信息導致的任何責任及後果將由我/我司承擔。',
  'MZTZvc': '點擊可查看',
  'QMEQJC': '更改',
  'V2XaN0': 'WEEE信息列表',
  'XfN2Ck': '最多上傳5個文件，限制為5M以內的jpg,png,gif,bmp,pdf格式的文件',
  'YJwhYM': 'WEEE註冊號類型',
  'YtGpRh': '新增WEEE信息',
  'YzNYFm': 'WEEE審核信息',
  'cIRvm+': '編輯WEEE信息',
  'dibfnz': '當前商品對應類別無有效WEEE信息，請添加提交審核，且審核通過後再進行關聯操作！',
  'l62HOb': '關聯時間',
  'oIsHa4': '請指定該類別需關聯的"WEEE註冊號',
  'oPgCK9': 'WEEE授權代表名稱',
  'plTZLU': '快捷關聯',
  'quexjV': '以下WEEE類別存在2個及以上"有效"的WEEE註冊號，請指定',
  'sqS2Da': '關聯狀態',
  't2bBzi': '確認取消？',
  'uaCekg': '請輸入1到16位數字',
  'uueUH5': '已關聯{relQty}條，未關聯{unRelQty}條{break} 溫馨提示：{break} 1.當前頁面展示的商品WEEE類別供您參考，具體商品WEEE類別請以商品的真實信息在德國電氣與電子設備廢料管理機構Stiftung EAR 註冊的為準。{break} 2.請您在維護WEEE信息後，需操作商品關聯對應的WEEE註冊號，未關聯WEEE註冊號的商品的德國庫存將在2023年7月1日起會被限制出庫。',
  'vdYJd/': '關聯成功',
  'w3teYZ': '更改WEEE信息',
  'Rhyt5i': '海外隱私數據查看權限',
  'awKGiZ': '開啟：子賬號可查看海外隱私數據；關閉：不可查看。',
  'uAVsJm': '打開此權限後，代表海外隱私數據可查看，請謹慎開啟',
  '0Q61kB': '是否確認',
  '62t33v': '未到倉貨物確認',
  '7jTO69': '確認不發貨',
  'CQq8b/': '拆',
  'DzM13w': '確認未到倉貨物',
  'HGFjmH': '已到倉包裹數/未到倉包裹數',
  'HshCr8': '查看確認結果',
  'Ln/QPz': '拆單來源',
  'Pvjte/': '確認結果',
  'nmidO4': '<span>確認後不可修改，請謹慎操作！</span>{break}請確認勾選包裹（共計<span>{number}</span>個）分批到倉，確認後系統將自動把未到倉包裹拆分成新入庫單，拆分成功後將通過郵件進行通知，謝謝！',
  'ob/U9u': '實際已發貨需倉庫調查',
  'ppLFVk': '溫馨提示:若超過3個自然日您仍未進行確認,系統會自動將未到倉的包裹/商品確認不發貨,終止未到倉的包裹/商品,後續如您需繼續發貨請重新創建新的入庫單,謝謝!',
  'vMKAQH': '分批到倉，拆分新入庫單',
  'xy4O9y': '<span>確認後不可修改，請謹慎操作！</span>{break}請確認勾選包裹（共計<span>{number}</span>個）不再發貨，確認後包裹狀態將切換成已終止，謝謝！',
  '5cYC+0': '暫無可用產品',
  'zgxeCD': '<span>確認後不可修改，請謹慎操作！</span>{break}請確認勾選包裹（共計<span>{number}</span>個）需倉庫進行調查？屆時調查結果將通過郵件進行通知，謝謝！',
  'jLakHl': '該入庫單整單未到倉，不支持整單拆單！該入庫單若需重新預約，請聯系客服處理！',
  '/wroH0': '《新供應鏈管理協議》',
  '8BvNX5': '海外倉《新供應鏈管理協議》和《新海外倉商業性條款補充協議》和《三方轉讓協議》{break}由於{a1}和{a2}和{a3}的內容具有相互關聯性，三份協議需要同時簽署，您可以點擊協議名稱查看具體內容。',
  'HQiSCu': '《新供應鏈管理服務協議》',
  'kQA+U7': '《三方轉讓協議》',
  'mjLaZm': '《新海外倉商業性條款補充協議》',
  's9oyw7': '海外倉《新供應鏈管理協議》和《新海外倉商業性條款補充協議》和《三方轉讓協議》{break}由於{a1}和{a2}和{a3}的內容具有相互關聯性，三份協議需要同時簽署，您已簽署最新版本，可點擊協議名稱查看具體內容。',
  '3ECTBI': '未到倉數量',
  '3fCA1g': '<span>確認後不可修改，請謹慎操作！</span>{break}請確認勾選商品（共計<span>{number}</span>個）不再發貨，確認後將更新該商品的終止數量，謝謝！',
  'KMwQTR': '<span>確認後不可修改，請謹慎操作！</span>{break}請確認勾選商品（共計<span>{number}</span>個）需倉庫進行調查？屆時調查結果將通過郵件進行通知，謝謝！',
  'p7jssq': '已到倉數量',
  'u0wsEP': '<span>僅支持拆分1個新入庫單，請確認將需拆分入庫單的商品全部勾選再進行拆分，確認後不可修改，請謹慎操作！</span>{break}請確認勾選商品（共計<span>{number}</span>個）分批到倉，確認後系統將未到倉商品拆分成新入庫單，拆分成功後將通過郵件進行通知，謝謝！',
  'yEzifq': '拆單數量',
  'LAufzk': '需與我確認',
  '7ZddkT': '訂單參考號',
  'Zmhygi': '可填寫您公司訂單管理系統中生成的訂單標識號。此單號可能主要用於對賬追蹤或自主管理。',
  'pcXfwX': '可填寫您在訂單管理中所需的其他編號，例如買家下單時的采購單號或平臺訂單號，此單號可能主要用於買家服務或平臺溯源。',
  'IpNHiJ': '請先選擇子單出庫倉庫',
  'GaGT99': '可填寫訂單管理系統中的訂單編號，便於對賬追蹤或公司內部管理。',
  'y65Bht': '可填寫關聯訂單的輔助編號（如采購單號、平臺訂單號），便於訂單匹配或平臺溯源。',
  '+9aDJv': '<bold>標簽/指標定義：</bold>{break}SKU溫度:截至所選日期,計算該SKU過去30天出庫量:高溫>=600,600>中溫>=100,100>低溫>=3,滯銷<3;{break}DOI:截至所選日期,計算該SKU近30天日均庫存數/近30天日均銷售數量;{break}日均庫存:截至所選日期,該類SKU過去30天日均庫存數據;',
  '4gr3Fd': '180天以上',
  '9kZp/B': '分層占比',
  'AthNL5': '21-30天',
  'B/fJkw': '數據更新:{dateTime}',
  'BIsCsJ': '60-180天',
  'EdFJ9X': '日均庫存',
  'FNUvro': '時間日期',
  'FRe/ki': '動銷健康度分析-溫度DOI矩陣',
  'HyhSJn': '日均庫存占比',
  'K9l7PE': '7-14天',
  'KWGy2X': '14-21天',
  'PttrTD': '0-7天',
  'YDZXyV': '中溫',
  'ZM8is8': '高溫',
  'f+39n8': 'DOI分層',
  'kXNxl6': '分層總計',
  'lG0CFz': '低溫',
  'nxyIG4': '無銷量',
  'onzGxg': '30-60天',
  'tg2hRM': '商品動銷明細數據：<a1>導出</a1>',
  'wkMrVA': '滯銷',
  'NwQeEI': '較合理備貨周期：能有效避免斷貨或滯銷風險，一般情況下，該分層占比越高，整體備貨健康度越優。',
  'WZ7oqy': '較合理備貨周期',
  'aKmWey': '較差備貨周期',
  'az4jNg': '較差備貨周期：整體滯銷的情況下，備貨卻相對較多，容易造成貨物積壓，不利於資金周轉。',
  'oKpe5k': '較優備貨周期',
  'qgmxrj': '較優備貨周期：在備貨較合理情況下，銷量也屬於高/中溫，快速流轉的情況下，綜合降低了供應鏈成本。',
  '15bR6/': '<head>尊敬的客戶您好：</head><body>萬邑通供應鏈服務提供主體將在10月1日0點變更為新主體名稱，您需要與新主體簽署《新供應鏈管理協議》、《新海外倉商業性條款補充協議》和《三方轉讓協議》，原協議將在9月30日失效，新簽署的協議將於10月1日開始生效。此次更新需要您在10月1日前完成閱讀並確認新版本協議，否則將影響您的下單。</body><footer>謝謝您的理解與配合，順祝商祺～</footer>',
  'BiB45X': '請閱讀並同意協議',
  'IbreHe': '已閱讀並接受',
  'f9W2lq': '已閱讀並接受 <a1>《新供應鏈管理協議》</a1><a2>《新海外倉商業性條款補充協議》</a2><a3>《三方轉讓協議》</a3>',
  'voly0E': '協議更新通知',
  '+AV6Zf': '導入第三方包裹條碼',
  '0+nnZ/': '系統將在您下單是默認勾選對應偏好；',
  '4eMQBe': '若您導入第三方包裹條碼，則您驗貨時可通過導入的第三方條碼進行驗貨！',
  '8Wz3p+': '請先新增商品！',
  'DE6Al9': '驗貨選擇偏好',
  'EgNZ25': '客戶自驗下單驗貨選擇偏好',
  'PPu6KQ': '下單默認選擇：是否明確裝箱明細=否(原新自驗)',
  'TdHsZ4': '當您選擇是否明確裝箱明細=是，系統將在您下單是默認勾選對應偏好；',
  'W1pRlN': '第三方包裹條碼信息',
  'XIbJH2': '系統將在您API下單時根據偏好默認賦值對應「是否明確裝箱明細」字段，若您的偏好選擇是否明確裝箱明細=否(原新自驗)，系統將自動忽略您API傳參的包裹明細數據，按照未明確裝箱明細(原新自驗)創建入庫單；',
  'c1AyPu': '系統將在您API下單時根據偏好默認賦值對應「是否免驗」字段；',
  'eNhwBJ': '下單默認選擇：是否明確裝箱明細=是(原舊自驗)',
  'elKxGq': '編輯第三方包裹條碼',
  'fT/446': '上傳第三方包裹條碼',
  'hswgDD': '萬邑聯下單',
  's7F86i': '是否明確裝箱明細',
  'yGdlFl': '上傳第三方包裹條碼為增量上傳，不刪除原已導入的第三方包裹條碼；',
  '7Su32t': '是否已開收據',
  '+6z4NM': '箱體積',
  '/j1Nes': '請至少選擇一種允許的裝箱規則後再保存。',
  '/lZTGu': '箱規格',
  '/mnsQ1': '超出最大限製 {maxNum}cm，請修改。',
  '0GUSD4': '<strong>側放：</strong> 次大面朝下（<a>示意圖</a>）',
  '1Rn687': '請先選擇裝箱方案',
  '1hq6tu': '添加包材請勾選箱',
  '2jDOKC': '是否要「恢復推薦方案」，點擊「是」，將清空「裝箱結果」',
  '3mQBqU': '超托限寬',
  '4OPpGF': '打托策略',
  '4R+53J': '上傳標簽與托盤的匹配關系',
  '4T3c5t': '箱材類型',
  '4Vwdwu': '限製寬',
  '5AH58r': '件數',
  '5cHCdK': '允許使用的托盤名稱',
  '5xJdbe': '查看裝箱規則圖例',
  '6cfIFr': '恢復推薦方案',
  '77+mEH': '選擇【一份文件上傳包裹標簽】，需要您按照Winit裝箱清單的包裹順序，在亞馬遜提交發貨信息。確保文件內包裹標簽順序與裝箱清單的包裹順序一致，Winit將按照此順序貼標。',
  '7m0Fxg': '總數量(箱)',
  '7unEPz': '托盤擺放提示',
  '8KpJnl': '主箱',
  '8WiHte': '整箱出庫，不可修改額外加包裝',
  '8iPloa': '限製寬必須大於等於托盤自身寬，請重新輸入',
  '8kjA/n': '僅支持上傳單份文件，確保文件內標簽順序與裝箱清單的順序一致，Winit將按照此順序貼標',
  'AW3QJJ': '修改後將清空選擇的裝箱策略，需要重新選擇。請確認是否修改？',
  'AaEbak': '全部嚴格單SKU且單件裝箱',
  'BAxU7U': '您輸入的裝箱數量{packedCount}已超過剩余未裝箱SKU件數{qty},請修改。',
  'BB+JEa': '不滿意,重新編輯方案',
  'Bqf6pC': '擺放方式',
  'CY12bb': '只允許錄入大於0的數，整數位最多8位，小數位最多2位',
  'DTz1y6': '限長*寬*高',
  'DWBvxe': '直接輸入單個商品的裝箱信息。適合一次添加少量商品時使用，最多支持添加10個商品，且不超過5個箱子',
  'EBTivJ': '超托限長(cm)和超托限寬(cm)至少輸入其中一個',
  'EHymsE': '托盤尺寸(長*寬*高cm)',
  'F/duGx': '您更改了訂單內的商品，需要重新選擇裝箱策略及增值服務，請確認是否需要更改?',
  'FG3A/U': '是否要「重新編輯方案」，點擊「是」，將清空「打托結果」',
  'FQY5Zq': '直接填寫',
  'FSGPan': '側放',
  'GB20/S': '自身尺寸',
  'H+V3eT': '限製長',
  'HQr2z9': '裝箱明細模板',
  'HtD9n3': '箱分組數',
  'IXlNF8': '<font>包裹類型說明：</font>{break} <span>A+包：每箱一種SKU且一件單品</span>{break} <span>A包：每箱一種SKU且多件單品</span>{break} <span>B/C包：每箱多種SKU且多件單品</span>{break} {break} <font>尺寸輸入規則：</font>長=最長邊, 寬=次長邊, 高=最短邊',
  'IcGteJ': '裝箱明細',
  'IqBDoI': '尾箱件數(件)',
  'JDV8nN': '是否默認規則',
  'JGOafx': '已裝箱/預計出庫數量',
  'JHgOt4': '選用此裝箱方案後，尾程產品的收費金額及打包尺寸已發生變化，請確認是否查看變化？',
  'JvuaYt': '沒有相同的箱規格',
  'KlgHAC': '出庫裝箱/托規則',
  'KqvuBs': '查看打托規則圖例',
  'LGc441': '托盤明細模板',
  'LMIuHR': '箱分組編號',
  'MC/oat': '最多支持添加{x}箱，如需添加更多箱，請選擇「批量上傳」指定裝箱。',
  'MafQMV': '總重量',
  'My6AUf': '裝載率:{loadingRate} 標準箱件數:{qty}件/箱 箱數:{packageCount} 尾箱包材規則:{sectionPackagingSpecification} 尾箱件數:{sectionPackagingQty}',
  'NEFb2o': '限重',
  'NZY0A1': '打托尺寸限製',
  'Nw033A': '超托尺寸',
  'P7aoMp': '指定方式',
  'PObaEM': '當單個托盤上的任意一個單品的尺寸超過托盤標準尺寸限製時，按超托的限製進行打托。',
  'PoKQTB': '修改後將清空選擇的裝箱策略及增值服務，需要重新選擇。請確認是否修改？',
  'PtqCMz': '主箱規格',
  'PvQePz': '打托結果',
  'QHTjm4': '箱類型',
  'Qab4ip': '<strong>平放：</strong> 最大面朝下（<a>示意圖</a>）',
  'SAbxQP': '在此處設置的默認裝箱規則，當您下單時選擇 「智能推薦裝箱」 作為裝箱策略，系統將自動選中您預設的默認規則，無需重復手動選擇，讓裝箱設置更高效便捷～',
  'SPdvq8': '選用此裝箱方案後，當前選中的WINIT產品【{winitProductName}】不可用，不可用的原因：{errorMsg}。並且無其他可用的WINIT產品，您可以選擇「不滿意，重新編輯方案」，選擇後系統將清除裝箱結果和已選擇的增值服務。',
  'U9NZ3C': '您更改了訂單內的商品，需要重新選擇裝箱策略，請確認是否需要更改?',
  'VkIinq': '指定裝箱說明：裝箱作業遵循原箱/箱產品優先出庫原則，即有原箱默認按入庫時原箱出庫，無原箱則按平臺倉裝箱規則執行',
  'VmZF4A': '是否要「重新編輯方案」，點擊「是」，將清空「裝箱結果」',
  'W6iRgO': '批量指定箱規格',
  'Wj97H8': '箱重量',
  'WtCeVq': '選擇包材',
  'X5GPMQ': '超托限長(cm)必須大於托盤自身長',
  'YLdm+E': '<strong>豎放：</strong> 最小面朝下（<a>示意圖</a>）',
  'Ywtwbb': '托盤號',
  'Z1Q2tF': '打托分組編號',
  'a1DFj6': '超托限寬(cm)必須大於托盤自身寬',
  'aWPqMM': '總商品數(件)',
  'ahq67k': '{qty}件/箱',
  'ceEBzP': '修改出庫裝箱限製',
  'cpRIqR': '添加包材',
  'dJty45': '選用此方案',
  'dVps5P': '打托規則圖例',
  'f8UsQV': '裝箱策略',
  'fFccZQ': '添加箱',
  'fJxmVT': '修改後將清空選擇的增值服務，需要重新選擇。請確認是否修改？',
  'foCa09': '裝載率',
  'gG/y9A': '不滿意，重新編輯方案',
  'gZUjRC': '總打托數量(托)',
  'gb2p8v': '托盤重量',
  'hlxpPC': '總體積',
  'i6zAH3': '標準箱件數',
  'iB17zU': '裝箱規則圖例',
  'iWyx6Q': '豎放',
  'j77Gcv': '了解打托策略',
  'jILrrg': '裝載率:{loadingRate} 標準箱件數:{qty}件/箱 箱數:{packageCount}',
  'jcohPw': '倉庫拆箱後重新打包',
  'kTw4K8': '您更改了訂單內的商品，需要重新選擇增值服務，請確認是否需要更改?',
  'lJtJ5S': '裝箱方案',
  'lcA2Az': '重新調整下單SKU',
  'nd8exK': '請設置默認規則後再保存。',
  'ngJ7SC': '直接混箱',
  'np++Iy': '打托規則',
  'nxU6/z': '選擇其他WINIT產品',
  'o7U57u': '超托限長',
  'p15MmV': '箱數(箱)',
  'pHZsHe': '點擊下載 <a>裝箱明細模板</a>',
  'pJZPl3': '散件件數(件)',
  'pvQHbv': '以下商品的尺寸已超出標準托盤尺寸限製，請選擇合適的擺放方式以優化托盤空間利用率。',
  'qo/H5E': '總箱數(件)',
  'qyLPwx': '整箱出庫，不可修改數量',
  'rJ+S+3': '裝箱結果',
  'rJ61OE': '倉庫人員將結合商品特性、體積重量以及運輸要求等實際因素，選擇合適的包裹類型和包材進行打托，後續可查看子訂單詳情～',
  'rJbKfQ': '托盤標簽號',
  'rKbymg': '允許多SKU混裝: 按照裝載率最優原則, 可能直接打B/C包',
  's7iQpX': '平放',
  'sHIbFj': '當前打托結果為空，請先確認打托方案～',
  'smFqf1': '允許的裝箱規則',
  't5KPFV': '選用此裝箱方案後，當前選中的WINIT產品【{winitProductName}】不可用，不可用的原因：{errorMsg}。您可以選擇「不滿意，重新編輯方案」或選擇其他WINIT產品。',
  'tYs+0n': '點擊下載 <a>打托規則模板</a>',
  'uAFTOr': '使用Excel模板一次性上傳多個商品的裝箱信息。適合添加大批量商品,一次最多支持上傳X個SKU',
  'uGh3tO': '【智能混托，最優裝載功能說明】{break} 提供多規格箱體混合碼托的智能裝載方案，精準適配單托盤滿裝需求，同步滿足承重限製、堆碼規範等打托標準，實現空間利用率最大化，滿足運輸的安全性需求。',
  'uMiwst': '散件裝箱',
  'ud70DH': '您輸入的裝箱數量{packedCount}小於未裝箱SKU件數{qty},請修改。',
  'ukE51P': '尾箱規格',
  'vKlKqA': '打托限製',
  'w90uU5': '了解裝箱策略',
  'wLwT6c': '托盤標簽全部相同',
  'wUpUxY': '按散件直接裝箱',
  'wVvPMS': '批量上傳',
  'wtq3Zr': '為確保詢價和預約送倉能夠順利，請提供FBA Reference No.',
  'xZpDye': '確認此裝箱方案',
  'yKH7Zh': '托盤標簽存在不同',
  'ysCLVn': '托盤體積',
  'ywBj4W': '箱分組編號/箱號',
  'z+MzSE': '限製長必須大於等於托盤自身長，請重新輸入',
  'z/ofGG': '當前裝箱結果為空，請先確認裝箱方案～',
  'zfLCAh': '全部單SKU且單件打托',
  '+5bHd/': '一份文件上傳快遞面單和包裹標簽',
  '0eBJCK': '總箱數',
  '39gwem': '包裹體積',
  '3WcfMz': '第一個跟蹤號',
  '3WwE4J': '更換WINIT產品信息，系統將重新計算裝箱方案，請確認是否繼續更改？',
  '49fRpD': '處理環節',
  '4MSrUM': '車牌號',
  '4Po5zN': '您可自主指定需要組合打托的包裹，以實現精準的個性化需求。',
  '4g9jXw': '倉庫人員根據商品特性和運輸要求，靈活選擇包材與裝箱方式。<span>重要提示：如您選擇此策略，則視為您授權並同意以倉庫最終的實際裝箱結果為準。</span>',
  '5e8lgk': '補增值狀態',
  '6E6SYp': '規則類型',
  '8T3XtE': '包材規格相同，且箱內的SKU種類與數量完全一致的包裹，視為同一類別。',
  'AiBk8V': '此設置用於決策：當單件貨物的長寬尺寸超出標準托盤規格時，是否允許進行打托作業。',
  'C3Xyt8': '箱數',
  'DO+dHk': '自身尺重',
  'Harof5': '您可以自主選擇具體的SKU、數量並將其裝入指定的箱子中，實現精準的個性化裝箱需求。',
  'IIPa06': '待確認增值訂單',
  'Im+u+J': '您當前訂單包含的單品數量較多，導致系統裝箱計算超時。為保障訂單快速處理，建議您通過以下方式進行調整：{break} 1、拆分訂單：建議將單個訂單的單品數量控製在500個以內。拆分後，可分別提交新訂單。{break} 2、調整裝箱策略：選擇「倉庫自主裝箱」選項，由倉庫根據實際庫存和包裝規則高效完成裝箱。{break} 感謝您的理解與配合，完成調整後即可提交訂單。',
  'LWh2KY': '提貨碼',
  'MZoc4B': '預約提貨時間(當地)',
  'QsPD6Q': '包裹類別編號/箱號',
  'XTlijw': '請先選擇打托方案',
  'ZT1G1j': '提示信息：裝箱計算超限',
  'b0twXr': '包裹類別編號',
  'cWxKfh': '全部按A+包裹或箱產品裝箱出庫',
  'eOA2gX': '系統通過算法自動計算最優的托盤裝載方案，幫您節省空間、降低運輸成本。',
  'eQ4gDr': '原箱',
  'eeQgv3': '出庫裝箱打托規則',
  'eno/75': '無主箱規',
  'fSzvk1': '指定包材',
  'kCzdh3': '最大限長*寬*高',
  'kTJOj4': '更換WINIT產品信息，系統將重新計算裝箱方案和清除已選的增值服務，請確認是否繼續更改？',
  'lGBTLd': '系統通過算法自動計算並推薦最優裝載方案與最高效的裝箱規格，有效提升空間利用率。',
  'lZ/nB8': '自提類型',
  'm5n5nA': '實際提貨時間(當地)',
  'mDGWSk': '您選擇的裝箱方案已更新，相應的操作費、尾程運費及包裹計費重量均已發生變化。請確認是否立即查看詳情？',
  'oIxJPB': '選擇【一份文件上傳快遞面單和包裹標簽】，需要您按照Winit裝箱清單的包裹順序，在亞馬遜提交發貨信息。確保文件內是一頁包裹標簽一頁快遞面單交替分布，並且總體順序與裝箱清單的包裹順序一致，Winit將按照此順序貼標。',
  'rpoODb': '獲取面單後補充',
  'rsm2O2': '倉庫人員根據商品特性與運輸要求，靈活進行打托。<span>重要提示：如您選擇此策略，則視為您授權並同意以倉庫最終的實際打托結果為準。</span>',
  'tIqy1V': '自提出庫訂單',
  'uy8FVi': '待處理訂單',
  'x1OCBv': '待訂單獲取到尾程面單後，再進行文件資料的補充',
  'xuHdu0': '標準出庫訂單',
  'y7/5dq': '散件混裝模式',
  'yTOUwm': '裝箱作業遵循」箱產品/原箱「<span>優先出庫</span>原則。即貨物入庫時的原箱將作為出庫時的首選方式；若無原箱，則按散件重新裝箱出庫。',
  'yovoCg': '商品按單件混合裝箱，極致壓縮包裹體積，最大化節省運費。',
  'DzkvrI': '獲取面單後補充：因文件中需要填充快遞面單號，需等從供應商獲取到尾程面單後再補充。',
  '+UD0Nm': '關閉時，子賬號不可訪問海外數據（出庫單收件信息/退件板塊/索賠查件板塊），開啟時允許查看。',
  'hxaUQ3': '不可查看隱私數據',
  'ufuU7X': '可以查看隱私數據',
  '/g7pR0': '或者',
  '1VgmNe': '表達式錯誤',
  '22mHbq': '左括號',
  '2ipN6G': 'DG標簽',
  '3urC7v': '項目',
  '4eaeMn': '關系',
  'BJg14B': '格式異常，請輸入0或正整數',
  'ByhhM1': '條件',
  'CoKJg6': '是否啟用清除DG標簽偏好',
  'CskvE/': '電池能量（電池組或電池芯的瓦時數）（W）',
  'FkUlFv': 'SKU標識是否為尾程空運DG',
  'HE8gpc': 'Winit標簽',
  'Iuq4N7': '下單是否自動下發覆蓋標簽增值',
  'KYlUTy': '下入庫單默認下發清除DG標簽邏輯說明',
  'O+0Baa': '開啟後，入庫時將自動清除DG標簽',
  'PYQhmH': '右括號',
  'QhGPUl': 'SKU標識是否為尾程陸運DG',
  'TIycpl': '電池包裝方式',
  'U8IB+K': '增值圖片',
  'XCFG+v': '下單A類包裹是否滿足維護偏好',
  'h624iv': '入庫增值偏好設置',
  'kNbdh7': '並且',
  'rlpMbP': '非DE',
  'ygrz65': '啟用清除DG標簽偏好',
  'zbqD5q': '值',
  'WJOgVN': '海外倉測量尺重',
  'hw6hrK': '是否自動下發覆蓋標簽增值',
  'mNZYcD': 'A+/A包裹是否符合頭程DG標簽偏好',
  'J9gDP9': '批量注册',
  'y29eMI': '單個注册',
  '252JpO': '返架中',
  'M+WRRO': '商品异常冻结',
  'Pe6Wwv': '禁售',
  'jCdXSN': '丢失调查中',
  '+I/eds': '禁售原因',
  'rrtjDg': '此帳號當前未配寘共亯庫存自動拆零全域策略，為了不影響後續訂單出庫時效，可配置共亯庫存自動拆零全域策略！ {a}配寘',
  'tPBhkV': '禁售詳情',
  'Lpj+2t': '此策略是為了避免因單一產品不足在出庫環節進行拆箱導致影響訂單的出庫時效，Winit會基於自動拆零的策略進行提前調整庫存，若不配寘共亯庫存自動拆零全域策略，將不會提前進行庫內拆零，只在出庫環節觸發庫存拆零。',
  'N6olth': '不合規禁售',
  'rHWBj4': '禁售庫存僅支持自提出庫或銷毀，不支持標準出庫！',
  'uKmlLO': '標準入庫',
  'yg35yu': '返架庫存詳情',
  'W0H3/3': '目前僅支持eBay、Temu、AliExpress、Shopify、Shein平臺配置規則。其余平臺將陸續開放，敬請期待!',
  'g7NT9e': 'Token暫未被{platform}平臺使用，請及時去平臺綁定並完成授權(平臺登錄需使用當前區域賬號)',
  'LTnlBS': '在此處設置的默認托盤，當您下單時（API下單/萬邑聯下單）系統將自動選中您預設的默認托盤，無需重復手動選擇，讓下單更高效便捷~',
  'vfW36f': '請設置默認托盤後再保存。',
  'vjX//o': '默認托盤',
  '5dZCxH': '倉庫人員將根據商品特性和運輸要求，靈活選擇包材與裝箱方式，具體裝箱結果後續可查看子訂單詳情~ {break}<span>重要提示：如您選擇此策略，則視為您授權並同意以倉庫最終的實際裝箱結果為準。</span>',
  'Ma+ddR': '使用Excel模板一次性上傳多個商品的裝箱信息。適合添加大批量商品,一次最多支持上傳{qty}個SKU',
  'fcN9C6': '請註意：允許多SKU混裝，將按照裝載率最優原則裝箱。因此，每個箱子都可能裝有多個SKU。',
  'tKqXle': '倉庫人員根據商品特性與運輸要求，靈活進行打托，具體打托結果後續可查看子訂單詳情~ {break}<span>重要提示：如您選擇此策略，則視為您授權並同意以倉庫最終的實際打托結果為準。</span>',
  'vEvtsT': '測算裝箱結果',
  '1kbSYq': '提單文件',
  '6MBNUQ': '提單號',
  '7rNHUy': '提櫃申請',
  'BvS8ua': '導入只支持{accept}格式文件',
  'I2c7n+': 'DO文件',
  'YMvE9K': '實際還櫃時間(當地)',
  'YR/KBR': '查看頭程物流跟蹤',
  'ds+/g8': '修改集裝箱號',
  'gqELkK': '預計到港時間',
  'jgq+/y': '提櫃信息',
  'rQUakN': '暫未查詢到物流記錄！',
  'zbDuSi': '請填寫英文字母+數字',
  '+AkvtB': '#配件商品',
  'f4cDDj': '限時0費率實時到賬',
  'is0zpP': '無Airwallex賬號？ ',
  '+RCnrG': 'Item Title',
  '/w6yVJ': '請選擇時間範圍',
  'BKJUwf': '你好，Winit已完成加入Amazon MSF對接啦!{break}{break}第一步，請先閱讀授權協議並同意授權獲取信息{break}第二步，授權Amazon平臺店鋪賬號{break}{break}操作完成後，平臺將獲取你的海外倉相關信息，並推送訂單和商品庫存信息',
  'BObRVR': 'orderPlacedTime',
  'ImbJHn': 'lastUpdatedDateTime',
  'SWbb1G': '發貨倉庫不一致，無法使用批量發貨，請重新選擇訂單',
  'SwNQnT': '溫馨提示：{break}1、授權完成的店鋪，將自動同步Amazon-MSF訂單自動發貨，並同步商品庫存{break}2、Amazon-MSF訂單請勿通過其他方式發貨以免造成訂單重復發貨',
  'V8FkeQ': 'creationDateTime',
  'VgausN': '僅待發貨/發貨失敗訂單操作',
  'birAPV': 'buyerOrderld',
  'jqXs1M': 'channelName',
  'qDEUjP': '目前僅支持eBay、Temu、AliExpress、Shopify、AmazonMSF平臺配置規則。其余平臺將陸續開放，敬請期待!',
  'qVGRIE': 'Quantity',
  'qgWzlQ': 'locationld',
  'rQQzl2': 'shipmentLineltem Id',
  '+V514J': '是否確認取消發貨？{break}取消後訂單將無法撤回繼續發貨，請同買家確認訂單取消，否則可能引起客訴。',
  'BfSxzs': '目前僅支持eBay、Temu、AliExpress、Shopify、Shein、AmazonMSF平臺配置規則。其余平臺將陸續開放，敬請期待!',
  'BkMWxm': 'locationId',
  'oAQLO/': '裝箱清單',
  'tDw37u': 'buyerOrderId',
  '2PgHwF': '商品{platformItemSku}未添加同步規則',
  'BniMG4': '上傳包裹號對應的補貼要求',
  'ENYSkf': '不同訂單不同要求',
  'GyW4tb': '所有訂單相同要求',
  'I9WLTQ': '期望派送時間',
  'LgA4cL': '僅限貨機運輸(Cargo Aircraft Only)',
  'Ll79cT': '導入只支持XLSX文件',
  'OKmTEL': '所有包裹相同要求',
  'T3q6qf': '導入模板',
  'a0ONXZ': '鋰電池限製-禁止空運/船運',
  'bHi3Ds': '期望送達時間(當地)',
  'eecNUt': '補貼項目',
  'k6d0X+': '批量導入訂單補充信息',
  'v0nty8': '不同包裹不同要求',
  'yr4AkT': 'UN標簽',
  'j1+jO2': '上傳客戶訂單號對應的補貼要求',
  'Pb7qI/': '共享',
  'j8ekmd': '原箱包裝',
  'vt5ccv': '不共享',
  'wVMpVn': '主快遞單號',
  'H1T87h': '擴展設定',
  'aGxRt2': '内容',
  'yVms9t': '設定項',
  'HvFvBM': '是否啟用API/ERP査詢庫存排除不良品？',
  'YLWwb+': '是否關閉API/ERP査詢庫存排除不良品？',
  'bSNLne': '啟用API/ERP査詢庫存排除不良品',
  'ti8G4l': '此配寘適用於ERP對接WINIT庫存査詢需要過濾不良品庫存的場景。 注：API對接用戶支持通過API入參選擇是否排除，若API未傳參對接也可通過此功能進行排除。',
  '+YUL4t': 'API下單自動創建箱產品',
  'WnKmzk': '自動創建的箱產品是否開啟共享庫存',
  'XTFlnc': '啟用該偏好，當您通過API下單時，系統將自動把下單A包裹轉化成箱產品，並通過A+包裹進行下單；',
  'K6A7Ay': '當前增值單取消後，請選擇是要繼續提交其他增值，還是無需其他增值可以直接出庫？',
  'xbWyo8': '繼續提交其他增值',
  '+KQIYg': 'eBay賬號授權成功',
  '+g5Odt': '成功提交{successCount}個，請等待處理結果{break}',
  '+sOaux': '組合商品長*寬*高',
  '/5kMiS': '請輸入最多8位整數，最多保留2位小數',
  '/VKVEv': '是否啟用續件費',
  '/eKhN1': '長CM',
  '/ihAwV': '待加入-未提交',
  '03OdFd': '默認庫存設置',
  '0rILia': '去匹配>',
  '1NBcfx': '錯誤',
  '1SepKA': '{countryCode} 啟用國際服務,至少要配一個區域的運費和附加費',
  '1wOL8F': '異常分類',
  '21qsQv': '缺貨',
  '2B5Uox': 'eBay賬號已被{ebayID}客戶綁定，無法再次授權其他Winit客戶賬號。如需更換請線下聯系客服進行申請，預計需要三個工作日左右',
  '2M+gaC': 'ebay itemID',
  '2h4etD': '已授權',
  '4LO5kZ': '偏好2',
  '4bdMX+': 'eBay物流服務',
  '5g4L3H': '組合商品',
  '6PECwn': '組合商品重量',
  '7PexH5': '查看授權列表',
  '8FvR5Y': 'eF SKUID',
  '8KPhfG': '待加入-審核中',
  '98O571': '僅待加入-未提交狀態操作',
  '9gwy+n': '請輸入eBay Custom Label',
  '9ozbDi': '出庫單提交日期',
  'A/W0Ji': '溫馨提示：{break}1、授權將會跳轉至eBay頁面，授權完成後自動跳回萬邑聯頁面。{break}2、授權完成的店鋪，將自動同步eF訂單自動發貨，並同步eF商品庫存{break}3、eF訂單請勿通過其他方式發貨以免造成訂單重復發貨',
  'AlNl2K': '賬號授權失敗，請重新發起授權',
  'AxfkAU': 'eBay賬號授權失敗',
  'Bzgqgx': 'Winit產品不一致，無法使用批量發貨，請重新選擇訂單',
  'Do/HOL': '加入',
  'Dtffnt': 'eF異常分類',
  'Du2hdU': '添加組合商品',
  'EXXIMD': '當為手動加入/退出時：{break}需要手動調整商品加入/退出eF{break}加入，eBaylisting庫存會同步展示Winit商品庫存(站點的所有倉庫){break}退出，eBaylisting將會展示設置的默認庫存{break}當為自動加入/退出時:{break}根據默認庫存判斷，自動加入和退出{break}當商品庫存>默認庫存，自動加入eF，eBaylisting展示Winit商品庫存(站點的所有倉庫){break}當商品庫存≤默認庫存，自動退出eF，eBaylisting展示設置的默認庫存',
  'ElIu9U': '國內配送服務設置',
  'Ere3ru': '設置eBay eF服務',
  'FcLwLD': '維護eBay平臺信息',
  'GkAFNd': 'ebay Custom Label',
  'GmBFbl': '退出失敗',
  'HTbmwk': '寬CM',
  'IckH3i': '查看itemId明細',
  'J6Fbmp': 'eBay itemID',
  'JPJyCy': '新增店鋪',
  'JoL+d9': '確認重新授權嗎？',
  'JyKQRL': '註意：僅針對已設置過eF的商品批量操作加入/退出。若要對商品批量設置服務，請使用批量設置eF功能',
  'Jznt1f': '請選擇國家設置一個ef服務',
  'KJrGS5': '取消授權',
  'KObBDp': '已退出',
  'MJ6SAC': '加入失敗',
  'Mlalnn': '加入/退出 eF設置',
  'Mp4ZYz': '加入/退出eF',
  'MzxSsq': '設置自動同步商品匹配的店鋪',
  'N6j14o': '組合商品屬性',
  'Npzogu': '引用偏好數據',
  'OATknL': '修改商品屬性',
  'Oex59+': '返回列表',
  'P7HTrM': '維護審核中',
  'PvFlx2': '商品信息完整待加入服務',
  'QnQAmD': '請勾選數據',
  'Qw1FMg': '導入文件加入/退出eF',
  'R9ZH2Y': '導入只支持XLS、XLSX格式文件{break}最多支持1000行數據，如超過請分成多個文件上傳',
  'Rl8xeS': '請輸入最多8位整數，最多保留3位小數',
  'Rr0WSm': '缺少Custom Label',
  'TRVT74': '註意：US/AU運費設置分區為eBay定義分區，與Winit分區不一致。eBay分區詳情請查看<a1>《EF操作手冊》</a1>',
  'UyqNZt': '是否組合商品',
  'VQLk5p': '你好，Winit已完成加入eBay fulfilment認證服務啦！{break}{break}第一步，請先閱讀授權協議並同意授權獲取信息{break}第二步，授權eBay(eF)平臺店鋪賬號{break}{break}操作完成後，平臺將獲取你的海外倉相關信息，並推送訂單和商品庫存信息',
  'Wb/9Lq': 'eBay訂單ID',
  'XH+l/X': '站點不一致，無法使用批量發貨，請重新選擇訂單',
  'XKyH1B': '維護成功',
  'XOXZPD': '重量KG',
  'ZR0XRH': '當商品退出eF時，希望展示在eBay平臺上的默認庫存。涉及手動退出和自動退出，以及平臺因為限製規則強製退出',
  'ZdrhPk': '當前產品服務時效低於下單物流服務，可能會導致派送時效不達標導致賠付。請謹慎選擇',
  'Zryluf': 'eBay Fulfillment服務設置',
  'aRADb+': '服務分組',
  'bfeRdA': '2、通過配對平臺商品和WINTI商品，建立二者匹配關系 {a}',
  'bqG/hC': 'eBay Custom Label',
  'byhm83': '是否使用國際配送',
  'cA7vYm': '你好，Winit已完成{platformFullName}海外倉認證啦!{break}{break}第一步，請先閱讀授權協議並同意授權獲取信息{break}第二步，在{platform}平臺補充Winit的賬戶信息{break}{break}操作完成後，{platform}平臺將獲取你的海外倉相關信息，並推送訂單和商品信息',
  'cKd6w4': '維護失敗',
  'cgxdE6': '請選擇服務分組',
  'dURpJ2': '已選中{qty}個商品,請進行批量設置EF服務。{break}註意:批量設置將會覆蓋掉針對單個商品的歷史設置',
  'dgf6Kz': '提交失敗{failedCount}個，原因：{break}{reason}',
  'e+f3fS': '查看itemID狀態',
  'eBAL2u': 'excel修改加入/退出eF',
  'eHWt7e': '已加入-退出中',
  'eJt1V9': '自動',
  'eah4XJ': '手動',
  'fVg18v': '高CM',
  'hQOH1X': '同步商品匹配',
  'htixct': 'eBay CustomLabel',
  'i03cgN': '同步店鋪',
  'i4Byyo': '國際配送服務設置',
  'jjVprn': 'eBay Fulfillment同步設置',
  'jwCzpQ': '添加Winit組合商品及數量',
  'jxmDpa': '導入商品',
  'kd2rGf': '已加入',
  'khc+Ia': '導入成功{successNum}，導入失敗{failNum}。{break}失敗的導入數據和失敗原因<a>點擊下載文件</a>',
  'knDAam': '僅支持待加入-未提交、已加入、加入失敗、已加入-退出失敗、已退出狀態批量提交eF',
  'kvVJmi': 'ebay賬號',
  'l82W4w': '批量設置eF',
  'lWeKoR': '導入成功{successNum}，導入失敗{failNum}。',
  'lnrTIe': '1、完成授權店鋪後，可操作對應功能：同步商品及匹配 {a}',
  'ltCWTv': '確認取消授權嗎？',
  'lvAG2S': '請輸入最多5位整數，最多保留6位小數',
  'mEKJuC': '加入eF狀態',
  'mcYu4G': '添加店鋪後，即可同步添加已完成商品匹配的eBay商品和Winit商品至當前eF商品管理列表。註意：暫僅一次性添加已匹配數據，後續不會同步更新。若商品匹配發生變更，未加入的商品可刪除後再次執行同步；已加入eF的商品需要退出eF修改後再加入',
  'njpUP6': '已加入-退出失敗',
  'nofz0U': 'Custom Label重復/異常',
  'pg+yjf': '授權成功，請在列表查看授權賬號信息',
  'qtqMeN': '偏好1',
  'rWR+im': '組合商品編碼',
  'soCAd+': '偏好使用僅首次引用偏好數據，支持針對當前商品再次修改{break}註意：選擇偏好後，若偏好更新當前商品EF服務數據不會同步更新；若商品需更新，請重新設置EF並提交審核，請及時查看審核結果。',
  'tJw7sI': '庫存錯誤',
  'ukoMyS': '請輸入重量',
  'vE/mGO': '最大長度為10位數字，2位小數',
  'wCa4U0': '商品待加入異常',
  'xFYQzM': '待加入',
  'xPAc/v': '退出',
  'yKQdCq': '選擇配送服務',
  'ywr1LG': 'Itme ID',
  'Jlzdr6': '萬邑通全場景高效海外倉{break}賣得好、備得少、綜合成本就是少',
  'AHodEs': '外箱采集的SN碼',
  'Y2eiCW': '是否完成增值',
  'rurl0x': '外箱采集的SN碼圖片',
  '+858kB': '日均出庫量',
  '/26ehQ': '分析備貨情況，優化備貨策略',
  '/J1+nW': '120-180天',
  '/dXFkQ': '庫存數量佔比',
  '/dcLs3': '長尾缺貨',
  '0zV38F': '截止所選日期, 該類SKU過去30天日均庫存數據',
  '1Uct28': 'SKU詳細信息',
  '2IP64b': '備貨場景概覽',
  '2JNYh6': '標籤/截止所選日期, 計算該SKU過去30天出庫量，高溫≥600, 600>中溫≥100, 100>低溫≥3, 滯銷<3',
  '2j7huF': '極差',
  '34oQh+': '庫存分析報告',
  '39zJIR': '庫存數(件)',
  '3h1uIj': '長尾最優備貨',
  '46DklJ': '暢銷最優備貨',
  '4S6nZ2': '7~14天',
  '4Y1/MP': '庫存數量',
  '5WSDbu': '當前維度暫無數據',
  '5hqTM6': '可售天數超過90天，且近30天銷量大於100件',
  '5mq2mp': '{month}月已產生存儲費 {amount}USD',
  '5rQZjy': '可售天數 14~60 天，且近30天銷量小於100件',
  '6TWotd': '可售天數 14~60 天，且近30天銷量大於100件',
  '6Z2+5w': '全部倉庫',
  '7CajwD': '疑似滯銷',
  '8DZ3T0': '可售天數：90-120天',
  '8PQ6ib': '上述數據不包含新品，日均庫存數總計 {sum} 件',
  '8R0XTD': '過去30天銷量≥600的SKU的日均庫存數匯總 - 在該DOI分層的庫存數量',
  '8vXYwp': '顯示各DOI分層下不同溫度標籤SKU的實際日均庫存數量',
  '9ZdkeY': '該DOI分層所有溫度標籤的庫存數量總計',
  '9bSO34': '嚴重滯銷',
  '9bZ7dW': '顯示各DOI分層下不同溫度標籤SKU的庫存佔比情況',
  'AoPi1s': '60~90天',
  'CgmpGr': '可售天數超過90天，且近30天銷量在3~100件範圍內',
  'Evsugq': '品質標杆',
  'G4q89I': '點擊查看疑似滯銷SKU明細',
  'GbVzIC': '可售天數：7-14天 | 補貨場景：適合空運',
  'GkdN8K': '{countryCode}-{warehouseCode}-日均庫存數量分析表',
  'I/0jhD': '14~30天',
  'ICVSdt': '點擊查看嚴重滯銷SKU明細',
  'IY3rSF': '{countryCode}-{warehouseCode}-日均庫存佔比分析表',
  'JGXefD': '點擊查看長尾缺貨SKU明細',
  'JXxGYT': '該DOI分層所有溫度標籤的庫存數量佔比總計',
  'K7Y7hZ': '該DOI分層下，某溫度標籤的SKU總庫存佔客戶所有SKU總庫存的比例',
  'Kc3Byd': '該SKU的日均出庫量',
  'L4kgwc': '備貨場景',
  'LsPFcF': '過去30天銷量在100-599的SKU的日均庫存數匯總 - 在該DOI分層的庫存數量佔比',
  'MoU1SM': '點擊單元格可查看具體場景定義',
  'NCEBh6': '庫存健康度場景分析',
  'NINLUY': '可售天數 60~90 天，不限近 30 天銷量，覆蓋暢銷 / 長尾品',
  'NLDJt+': '點擊查看上月庫存分析報告',
  'Opb6fg': '特徵',
  'PZSxPC': '可售天數：180天以上 | 補貨場景：已出現滯銷，需要消化庫存',
  'Pp7hrx': '過去30天銷量在3-99的SKU的日均庫存數匯總 - 在該DOI分層的庫存數量',
  'RWHlVK': '標籤/指標定義',
  'S01oYn': '日均庫存數量佔比',
  'TgIPS8': '庫存數佔比',
  'Tkmxf1': '該DOI分層的所有SKU總庫存佔客戶所有SKU總庫存的比例（體現DOI分層的庫存權重）',
  'TyBqOs': '導出商品動銷明細數據',
  'U8oHOq': '可售天數低於14天，且近30天銷量大於100件',
  'Zo13MH': '可售時間超過90天，且顯示近30天銷量小於3件的SKU詳細信息，包括庫存和出庫情況(按照每個日均庫存數量/SKU的日均出庫量的比值降序排序)',
  'aK+HmM': '當前客戶的滯銷庫存數量佔比<5%，則文本為：“本月庫存健康度評級為極優。庫存周轉效率處於最佳狀態，倉儲資源與流動資金利用充分。建議維持現有精細化庫存管理策略，可重點投入資源優化暢銷品備貨節奏，進一步提升整體運營效率。"',
  'aXAH1x': '本品牌',
  'b0/WDq': '合理備貨',
  'bpytH2': '0~7天',
  'c+Ctye': '庫存佔比',
  'dhFvnz': '備貨較多',
  'e652NE': '可售天數：30-60天 | 補貨場景：適合普船',
  'f8aEjy': '截止所選日期, 計算該SKU近30天日均庫存數/近30天日均銷售數量',
  'fjhs9t': 'SKU名稱(商品名稱)',
  'fw5J/X': '根據DOI分層和SKU溫度，判斷該SKU所屬的備貨場景類別',
  'gScA5O': '可售天數：0-7天 | 補貨場景：難及時補貨',
  'j3IhHx': '當前客戶的滯銷庫存數量佔比在>40%，則文本為：“本月庫存健康度評級為極差。滯銷庫存已嚴重侵占核心倉儲資源、大量佔用流動資金，且可能導致暢銷品庫存空間被擠壓，直接影響整體庫存周轉率與盈利效率，建議盡快消化庫存”',
  'j7q9fm': '過去30天銷量＜3的SKU的日均庫存數匯總 - 在該DOI分層的庫存數量佔比',
  'jaUYvO': '暢銷缺貨',
  'jpnytt': '超低溫',
  'kp1/ug': '較優',
  'nHh1If': '極優',
  'nZCtyB': '當前客戶的滯銷庫存數量佔比再5~15%，則文本為：“本月庫存健康度評級為較優。現有滯銷庫存控制在合理範圍，建議繼續保持當前的庫存管理策略，重點關注暢銷品補貨節奏即可。”',
  'nwrCxp': '本月庫存健康度評級為',
  'oybLIK': '90-120天',
  'pCZBqi': '點擊查看暢銷缺貨SKU明細',
  'py2OYq': 'SKU溫度',
  'qjEp5a': '日均庫存數量',
  'qoGZJH': '過去30天銷量在100-599的SKU的日均庫存數匯總 - 在該DOI分層的庫存數量',
  'r/mys+': '可售天數：14-30天 | 補貨場景：適合快船',
  'rfWEbZ': '過去30天銷量在3-99的SKU的日均庫存數匯總 - 在該DOI分層的庫存數量佔比',
  'rv2S54': '該DOI分層下，某溫度標籤的SKU庫存總和（直接匯總同分組的庫存）',
  'sJ8cBQ': '可售天數：60-90天',
  'sS7wyq': '該類SKU近30天無銷量，無法計算DOI，單獨統計',
  'sTsns5': '當前客戶的滯銷庫存數量佔比在15%~40%，則文本為：“本月庫存健康度評級為較差。滯銷庫存已佔用部分倉儲資源，建議優先排查高庫存滯銷 SKU，可通過促銷活動、庫存調撥等方式加速消化，減少資金佔用。”',
  'sXUdP8': '較差',
  'st5qfR': 'WINIT履約報告-{month}月庫存分析報告',
  'tEXOrZ': '過去30天銷量＜3的SKU的日均庫存數匯總 - 在該DOI分層的庫存數量',
  'v2LNfY': '可售天數低於14天，且近30天銷量小於100件',
  'wUEfqW': '該SKU的日均庫存數量',
  'xGV2rF': '可售天數：120-180天',
  'xfrc9e': '可售天數超過90天，且近30天銷量小於3件',
  'xpNOm9': '溫度DOI矩陣',
  'yH0TiS': '過去30天銷量≥600的SKU的日均庫存數匯總 - 在該DOI分層的庫存數量佔比',
  'zvoAIf': '30~60天',
  'BHOXG6': '本月庫存健康度評級為極差。滯銷庫存已嚴重侵占核心倉儲資源、大量佔用流動資金，且可能導致暢銷品庫存空間被擠壓，直接影響整體庫存周轉率與盈利效率，建議盡快消化庫存',
  'CB0FTm': '本月庫存健康度評級為較差。滯銷庫存已佔用部分倉儲資源，建議優先排查高庫存滯銷 SKU，可通過促銷活動、庫存調撥等方式加速消化，減少資金佔用。 ',
  'SyF7YC': '品類標杆（綜合零售）',
  'jsPyiB': '本月庫存健康度評級為極優。庫存周轉效率處於最佳狀態，倉儲資源與流動資金利用充分。建議維持現有精細化庫存管理策略，可重點投入資源優化暢銷品備貨節奏，進一步提升整體運營效率。 ',
  't3EZ/p': '本月庫存健康度評級為較優。現有滯銷庫存控制在合理範圍，建議繼續保持當前的庫存管理策略，重點關注暢銷品補貨節奏即可。 ',
  'I2haAQ': '想精準管控庫存風險，避免滯銷積壓與資金佔用？本報告用客觀數據替代經驗判斷，幫你定位滯銷風險。通過數據，解鎖更高效的庫存管理方案！ ',
  'S5IKvF': '可售時間超過90天，且顯示近30天銷量小於3件的SKU詳細信息，包括庫存和出庫情況(按照每個日均庫存數量降序排序)',
  'YPCIjO': '可售時間超過90天，且顯示近30天銷量在3~100件範圍內的SKU詳細信息，包括庫存和出庫情況(按照每個日均庫存數量降序排序)',
  'eQigZu': '可售時間低於14天，且顯示近30天銷量小於100件的SKU詳細信息，包括庫存和出庫情況(按照每個SKU的日均出庫量/日均庫存數量的比值降序排序)',
  'pC8w8l': '可售時間低於14天，且顯示近30天銷量大於100件的SKU詳細信息，包括庫存和出庫情況(按照每個SKU的日均出庫量/日均庫存數量的比值降序排序)',
  'Dx3xZs': '可售時間超過90天，且顯示近30天銷量在3~100件範圍內的SKU詳細信息，包括庫存和出庫情況(按照每個SKU的日均庫存數量降序排序)',
  'wGenC7': '可售時間超過90天，且顯示近30天銷量小於3件的SKU詳細信息，包括庫存和出庫情況(按照每個SKU的日均庫存數量降序排序)',
  'AoYxot': '暢銷最優',
  'UgVDmg': '長尾最優',
  'aI14f6': '庫存狀態分佈',
  '2cEeD0': '悉尼倉',
  '3lXXUZ': '德國2倉',
  'Dp6hUU': '墨爾本倉',
  'ONTDVL': '美西2倉',
  'SmiBHH': '美東5倉',
  'Xc1MK9': '美東3倉',
  'cN4WwM': '英國TW倉',
  'dfM18m': '多倫多倉',
  'hyw36k': '德國1倉',
  'jq8YEp': '美西5倉',
  's3rYvE': '美西1倉',
  'wtLyGS': '英國GF倉',
  '8AFKQY': '父级容器条码',
  '8nT9ZY': '分批处理',
  '9fCuYD': '批量导入处理',
  'AdLyfK': '源子订单号',
  'Bwqwwx': '重量（kg）',
  'CRrx95': '预计将产生返架费用: <span>{amount}{currency}</span>',
  'EBMdAL': '创建成功',
  'Gu6ve5': '批量返架',
  'HhBSTd': '包装类型',
  'KDST00': '实际出库数量',
  'KffZZe': '总商品数',
  'Qml+Jw': '新订单号',
  'TzdYjm': '全部销毁',
  'UXBFYM': '返架',
  'VGTfHQ': '总共导入{count}条，校验成功{success}条，校验失败{error}条',
  'Ww4mvO': '全部转标准出库',
  'ZeTTNk': '修改处理方式，需重新上传模板文件，确定是否修改?',
  'ZqyX8H': '源单号',
  'bSaNQ3': '本次共选择{count}个容器，预计将产生返架费用：{amount} {currency}',
  'bnfcAI': '容器重量',
  'c8/6P+': '源客户订单号',
  'cS4CeZ': '确认销毁【{code}】等容器吗？',
  'dH6cPS': '全部转自提出库',
  'fMVIuu': '总包裹数',
  'h0JOsy': '容器长*宽*高',
  'lWg/Rm': '返架原因',
  'mnflXu': '确认销毁【{code}】该容器吗？',
  'rHTOUC': '最多支持{num}个订单号',
  'tATKZZ': '暂存完成时间（当地）',
  'vkVx/K': '您所下单的商品体积之和已经超出 {configVolume}cbm，建议您选择此产品。',
  'xxS2pF': '1. 仅支持上传XLS、XLSX格式模板{break} 2. 每个文件最多支持上传5000个容器，超出5000个请拆分成多个文件分批次上传{break} 3. 文件大小上限5M，如果文件过大，请拆分成多个文件分批次上传{break}',
  'zOsH5H': '整单合并处理',
  'LN1bBn': '退貨暫存後換新單',
  'LuUUcY': '出庫暫存後換新單',
  '1/GyvI': '選中創建新自提單',
  'Ial38i': '按單號合並創建新單',
  'JTfl/3': '選中返架',
  'MO51pO': '按模板導入創建新單',
  'PegTHG': '選中創建新出庫單',
  'sN4Z/2': '選中銷毀',
  '5LrpOS': '失效待處理',
  'D5Qa5n': '該VAT號經過歐盟官網英國官網鏈接如下：<a1>What is the UK VAT number you want to check? - Check a UK VAT number - GOV.UK</a1>核實已失效，現VAT名下還有在庫（在途）庫存，請於時效內處理完畢，逾期未處理，我司將凍結庫存，禁止貨物出庫，後續只能自提和銷毀，同時失效的VAT號應英國監管要求，要上報給HMRC機構，請知悉。',
  'PJk9rP': '未檢驗',
  'gtBqMe': '異常處理中',
  'kTopMl': 'VAT狀態',
  'v0fN/N': '剩余{vatRemainExpireDate}天',
  'yrpZqC': '檢驗中',
  '1z+PUC': '失效VAT號',
  '2Wr8ti': '在庫庫存=可用庫存+不可用庫存',
  '4C52jb': '不可用類型',
  'D/IEZc': '退貨暫存中',
  'IqhS6n': '不合規凍結',
  'L1oad9': '不合規凍結原因',
  'MZGnPz': '不可用庫存',
  'Nkzb4e': '進口商/貿易商',
  'NyrztL': '丟失調查中庫存詳情',
  'R1UfwV': '失效VAT禁售庫存詳情',
  'RxOEEB': '不可用原因',
  'Sn+VZl': '退貨暫存中庫存詳情',
  'Tmm/ts': '銷售預留凍結庫存詳情',
  'ZcAx93': '出庫暫存中',
  'f0R63Z': '失效VAT禁售',
  'fvgxnz': '不合規凍結庫存詳情',
  'hGGMo3': '不合規禁售詳情',
  'hJLtvk': '禁售時間',
  'j/abtG': '不合規禁售原因',
  'kqVWhs': '失效禁售時間',
  'lMeQIl': '銷售預留凍結',
  'q1B+zO': '出庫暫存中庫存詳情',
  'y2IUn0': '商品異常凍結庫存詳情',
  'ydYOXN': '庫存詳情',
  'RJpcKu': '失效VAT禁售數量',
  'aaTDNr': '不可用庫存數量',
  'cyH+CL': '不可用庫存類型',
  'WFc0E0': '<red>請提供完整的操作視頻，最多上傳1個視頻，限制為50M以內的avi，dat，mpg，wmv，asf，rm，rmvb，mov，flv，mp4格式</red>',
  'Da2ffQ': '本功能用於臨時鎖定銷售庫存，防止被其他訂單佔用。 鎖定後，系統將凍結對應數量的庫存； 釋放後，庫存將恢復為可用狀態。 請務必在釋放後及時創建出庫單，以避免該部分庫存被其他訂單分配。{break}請注意：此操作僅凍結庫存數量，不會指定或鎖定倉庫中的具體實物及庫比特。',
  '0GMK7Y': '鎖定/釋放銷售庫存',
  '+swO4L': '註意:修改偏好,將不會影響歷史引用偏好的商品數據。{break}如若需要修改商品服務數據,請在[平臺同步-eBay Fulfillment商品管理|菜單中重新設置EF服務',
  '3YAh2J': '導出當前商品匹配數據',
  '6cvqQC': '使用偏好將會全量更新服務設置中的所有內容{break}是否要使用偏好?',
  'BPAh3l': '請選擇你需要導出的列表信息',
  'GU8kAT': '已加入EF的商品若修改需要維護信息，則需等維護通過後才會更新EF信息',
  'KzSXfU': '根據當前列表信息導出',
  'MyYCNq': '可以提前設置EF服務信息,幫助您快速加入eBayFulfillment服務。',
  'NJ3JfH': '確定刪除當前商品嗎？',
  'OwvQbz': 'eBa Fulfillment服務偏好',
  'YIvnlG': '請設置一個ef服務',
  'YNHo/g': '導出信息同eF導入模板，支持修改後直接通過excel導入。暫僅支持導出非組合商品的已匹配數據以及不帶規格的商品。',
  'c5rvdd': 'eBay Fulfillment偏好',
  'qXGWFz': '按導入eBay eF添加商品模板所需信息導出',
  'y3FPak': '<a1>管理我的eF偏好</a1>',
  'IBAsbe': '待分批处理容器',
  'qs/sEC': '请选择打托策略',
  '0Qjh2e': '請選擇條件',
  '1le4VE': '商品類名稱',
  '2k/NaR': '支援批次查詢，最多支援 500 個',
  '3kiSJD': '編輯類',
  '62KzCa': '指定 SKU',
  '7gWnrn': '確定生效嗎？',
  'C0a1YB': '客戶自訂分組－類資訊',
  'J7BQCH': '設定商品',
  'LUruKv': '新增類',
  'P2ZRxg': '支援 64 位字元，中文、英文以及數字',
  'Tp4hPZ': '組名稱',
  'VYPW7Q': '請選擇類',
  'aYnWaR': '新增組',
  'leNznf': '初始未分類',
  'ltjhyJ': '類',
  'mR+91E': '確定失效嗎？',
  'pfb8mk': '編輯組',
  'rEIk6P': '組',
  's5s2ZC': '類名稱',
  'IRsr6r': '查看類{className}內商品明細',
  'aD9f+6': '組內的分類規則',
  'dI3AcE': '已關聯的業務策略',
  'fXe0i9': '配置類{className}內商品明細',
  'yGtqiA': '添加類{className}內商品',
  '+eg7JV': '請先選擇索賠單',
  '0mnS/Y': '成功數量:{successNum}, 失敗數量:{failNum}, 失敗數據文件:{a1}',
  '1CaoGO': '請點擊下載<a1>導入模板</a1>',
  '1qBbCX': '下載待上傳附件索賠單',
  '8o9WZa': '批量提交草稿單',
  '9HoB8V': '待補充附件',
  '9wtfmH': '批量補充索賠附件導入結果，成功{successCount}單/失敗{failedCount}單',
  'A3wZYS': '批量上傳索賠附件',
  'BoHeLy': '是否有待補充附件',
  'DWtPOJ': '附件格式:支持格式{attachmentFileFormat},每個附件不超過{attachmentSizeMax}M。',
  'Ho12yP': '說明: {break}批量創建後索賠單為草稿狀態，需要批量補充索賠附件信息後才能完成索賠單提交。',
  'SfkC0A': '批量新增代客索賠單',
  'UQHOCp': '批量將草稿單變更為已提交狀態',
  'UWPWwZ': '暫無上傳附件配置',
  'XPpHtm': '上傳文件成功：{successUploadNum} 個',
  'Y2g3bc': '文件格式：{allowExtensions}',
  'pVw6Hz': '批量新增索賠草稿文件',
  'u9ZvIB': '批量申請代客索賠',
  'x18yAp': '點擊 <a1>下載失敗原因</a1>',
  'x6oA5O': '批量補充索賠附件',
  'pTe5/s': '說明: {break} 1、批量補充附件功能僅針對當前選擇的草稿狀態索賠單，單個附件類型最多上傳{attachmentNumMax}個附件，支持只上傳部分勾選的索賠單附件，支持只上傳部分附件類型的附件。{break} 2、請按「快遞單號或出庫單號」對附件進行命名，同一單同一附件類型有多個加序號（示例：9200190389086505358894_01、WO10129482224、claim_WO10129182224），否則系統無法識別。{break} 3、同一類型附件索賠單己存在附件文件名相同會覆蓋，文件名不同會新增附件。',
  'jTcDk6': '批量補充索賠附件導入結果，成功{successCount}個附件/失敗{failedCount}個附件',
  '4q8NAE': '確認批量提交草稿單？',
  'XlpMPJ': '是否需要補充附件',
  '+rqZZp': '取消組',
  '3Pel4Z': '業務對象屬性',
  'HT2Yg+': '請設置條件',
  'IffoXK': '且',
  'P9Bukq': '操作符',
  'S5F4CX': '訂單作廢及費用說明',
  'ZY7dz0': '添加組',
  'c1hrRi': '添加條件',
  'kbdFu6': '條件設置',
  'lH+4LY': '組合現有條件並添加',
  'lNBWTt': '當前訂單若作廢成功,預計將產生以下費用{break}請註意:訂單作廢後無法撤銷,請您確認是否作廢該訂單?',
  'p4KceZ': '請註意:訂單作廢後無法撤銷,請您確認是否作廢該訂單?',
  'zcHSrz': '添加動作',
  'svVpbB': '請在<a>【偏好設置 > 下單設置 > 出庫 > 出庫裝箱打托規則】</a>中，先自定義 「SKU 單獨裝箱」 的具體條件，設置完成後，裝箱時選擇該規則，訂單內滿足條件的 SKU 會自動單獨裝箱，不滿足條件的 SKU 則可混合裝箱。',
  '303VyS': '箱內單品條碼',
  '9lv9YM': '暫存信息',
  'IOixLx': '拆包暫存',
  'JW+UnW': '確認，已知悉此處理方式',
  'L0npSX': '全部標準出庫',
  'TK6NXC': '商品編碼-規格',
  'VZOsju': '確認執行此操作?',
  'ZyPM4b': '整托暫存',
  'qfDt0+': '處理模式',
  'rjXuaJ': '預付費用合計 {amount}',
  'utLXuQ': '退貨暫存繼續上架操作系統將自動為您創建無箱單海外驗入庫單上架，後續處理費用按入庫處理費收取。',
  'vVCO9b': '全部自提出庫',
  'yuTIzT': '全部繼續上架',
  'CUWc65': '重新上架',
  'IWzg8c': '再次派送',
  'UhU6pD': '請註意：系統將自動為您創建【無箱單預報】入庫單，並收取相應的入庫處理費及其他相費用',
  'hnI3J7': '確認重新上架',
  'oOO3DI': '請註意：【標準出庫單 - 托盤服務】派送失敗退回到倉後，WINIT將進行整托暫存，等待您選擇後續的處理方式：再次派送、自提出庫、全部銷毀或重新上架。',
  '+E8UXl': '使用WINIT出库單號提貨',
  '3HcSs9': '新單號',
  '5QSXrD': '不可預約',
  '5rjTA7': '總打托數量',
  '9hrTna': '可用不足',
  'FFHf9t': '產能配額預約',
  'FayNbO': '基於倉庫實时產能動態分配的可預約時段，客戶需在系統提供的可選時間段內選擇提貨時間，且單時段預約資源設有上限，超出後需選擇其他時段。 該模式保障資源公平分配與工作效率。',
  'HNAOck': '1、您已提交{bookingPermissionTypeName}，請按提貨預約時間安排到倉提貨，提貨地址資訊請在訂單詳情頁面或<a>自提暫存訂單處理詳情</a>查看；{break}2、請確保增值已完成提交，增值如需變更需取消預約後重新操作；{break}3、為確保您的貨物能够準確交付，請及時將提貨碼告知您的供應商，並要求其在提貨時出示提貨碼。 若供應商在提貨時無法提供有效的提貨碼資訊，倉庫將無法完成交貨。 提貨碼資訊如下：',
  'MGtIz4': '下载打托明细',
  'MyvkIy': '第三方提货码',
  'RTQq0d': '装箱信息',
  'SdcdsR': '增值預約說明{break}1、提交增值預約後需待審批通過才能安排送倉，審批結果將在1個工作日內通過郵件推送。{break}2、審批通過前取消預約不收取增值預約費用。{break}3、稽核通過，如需變更送倉日期，請聯系客服！',
  'IbDLTM': '1、您已提交{bookingPermissionTypeName}，請按提貨預約時間安排到倉提貨，提貨地址資訊請在訂單詳情頁面或<a>自提暫存訂單處理詳情</a>查看；{break}2. 請確保增值已完成提交，增值如需變更需取消預約後重新操作；{break}3、為確保您的貨物能够準確交付，請及時將提貨碼告知您的供應商，並要求其在提貨時出示提貨碼。 若供應商在提貨時無法提供有效的提貨碼資訊，倉庫將無法完成交貨。 提貨碼資訊請在審批通過後在暫存訂單處理詳情查看。',
  'Syl9aV': '提貨碼是供應商上門提貨的重要憑證。 您可以選擇填寫與供應商約定的協力廠商提貨碼； 如果未填寫，系統將自動生成一個WINIT提貨碼。 為確保您的貨物能够準確交付，請及時將此WINIT提貨碼告知您的供應商，並要求其在提貨時出示提貨碼。 若供應商在提貨時無法提供有效的提貨碼資訊，倉庫將無法完成交貨。',
  'U7u9KN': '預約許可權類型',
  'ZBkx19': '託盤資訊',
  'brwHC8': '預約',
  'cD6kKC': '專屬預約單',
  'cpnZ0r': '自提預約協定',
  'dpCjW4': '提貨資訊',
  'k9/jgR': '預約單說明',
  'nGupIx': '注：僅限倉庫工作時間週一至週五10.00-18.00提貨',
  'pECeHH': '提貨供應商',
  'qG/vmE': '下載提貨碼',
  'srGye/': '面向專屬客戶開放的靈活預約通道，不限制時間段與資源配額，支持客戶自定義提貨時間。 該類型突破常規產能限制，通過後臺許可權配寘實現“隨需預約”，滿足緊急訂單、大額批量需求等特殊場景。',
  'tH/9GD': '已選',
  'umqj6F': '可預約',
  'xGjK9D': '訂單收貨人類型為FBA轉倉-VC訂單或FBA轉倉-非VC訂單時，為確保您的貨物能够準確交付，請在預約時填寫ARN資訊，並要求供應商在提貨時出示ARN。 若供應商在提貨時無法提供有效的提貨碼資訊，倉庫將無法完成交貨。',
  'yK8AbT': '預約提貨注意事項：{break}{break}1. 不使用WINIT尾程提貨資源交貨的自提單必須在系統預約提貨時間，並按照預約時間自提，若後續提貨時間有變更，需在系統取消原預約並安排重新預約；{break}{break}2. 自提訂單發生以下异常，系統將會自動收取違規費用（費用標準詳見萬邑通异常與增值價卡說明）：{break}{break}1)預約未提貨：自提單預約後未在預約時間提貨；{break}{break}①需在系統取消原預約並安排重新預約；{break}{break}②訂單會繼續收取暫存倉儲費及在預約提貨日期1天后收取滯倉費{break}{break}2)自提單違規取消預約：自提訂單已預約，若提貨時間有變更，賣家需要在預約時間前2個工作日取消預約則不收費。 （預約時間為工作日，按海外倉當地時間計算）。 超出此要求時間則收取違規費用。{break}{break}舉例：如賣家預約提貨時間是2022-6-17，賣家在2022-6-15當天以及之前取消預約不收費。{break}{break}3. 若未按預約時間提貨或未預約上門提貨，WINIT無法保證提貨時效甚至無法提貨，客戶囙此產生的額外費用WINIT不承擔。',
  'zzKha6': '您可以選擇配寘通過WINIT出庫單號進行提貨。 當您勾選此項時，即表示您已確認並授權供應商使用WINIT出庫單號進行提貨，並自行承擔由此產生的相關風險。 請務必確保您對WINIT出庫單號進行妥善管理。',
  '0JI7MG': '預估價格(原幣)',
  '4VYo04': '上傳超重標簽',
  'Ahc+oL': '註意：根據美國地區服務商提貨相關要求，供應商提貨時需倉庫提供對應BOL信息。請勾選「交接BOL/CMR」增值服務並上傳BOL，否則將無法提貨。',
  'E86vxA': '倉庫操作完本次提交的增值服務後，是否直接出庫？',
  'Kh7nco': '您確定不需要增值服務，立即預約提貨嗎？',
  'TKS7HV': '暫不出庫，後續還需補充增值',
  'VWvqOM': '您選擇的增值服務[{vasNames}]未提交，點擊返回【返回增值服務清單】後，系統可能清除未填寫完整的增值服務要求及增值文件，請確認是否繼續返回嗎？',
  'VlcX6Y': '您確定不需要增值服務？',
  'dPuT2A': '當前取消預約將產生違規取消費，詳情請看價卡，取消後需重新預約',
  'eUGVb6': '新增增值服務',
  'jjl3V4': '增值預約未審批通過，當前取消不收費，取消後需重新預約',
  'l7hkkh': '預估價格',
  'lw7+aQ': '檢測到您已選擇「{vasType}」的增值服務，需按順序取消對應服務後再操作：{break} {voidSort}。{break} 請先完成取消，感謝配合！',
  'mDNuvx': '無需增值服務，立即預約提貨',
  'ncUfOl': '當前取消訂單不產生違規費用，取消後需重新預約',
  'oNqy62': '提交成功，您的增值服務已更新至"待處理"頁簽中，請註意查看~',
  'uFBjIr': '無需增值',
  'vHs/yd': '無需增值立即預約提貨',
  'vZhRbW': '返回增值服務列表',
  'f4F33r': '接受',
  '3FSqhT': 'SKU種數',
  '5Cpfb/': '托盤狀態',
  '61+I8P': '總庫存單元數',
  'UXjvqZ': '總托盤數',
  'UyFfj7': '總單品數',
  '6cGDgA': '提貨碼資訊請在核准通過後在暫存訂單處理詳情查看。 ',
  'DQY6It': '更換新自提單',
  'DVN3mT': '全部返架',
  'EN3RCP': '預約單已提交成功～',
  'JYe/i7': '拆單處理',
  'P/iVK7': '偵測到您已選擇「{vasType}」的加值服務，需先取消該服務後再操作。 {break}請先完成取消，感謝配合！ ',
  'YsZxSd': '容器最新狀態',
  'djaofb': '清空時間',
  'hA0cYL': '請您依照預約時間安排到倉提貨，取貨地址資訊可在<a>自提暫存訂單處理詳情</a>中查看',
  'iF/OW3': '取貨碼資訊如下：<downloadCode>點選此處下載提貨碼</downloadCode>',
  'rWrGpm': '更換新出庫單',
  'sFKm46': '您確認不需要加值服務？點選 「是」 後，倉庫將會立即安排出庫～',
  'wJRzN6': '1、請確保加值服務已提交完成。如需變更，請先取消目前預約後重新操作；{break}2、為確保您的貨物能夠準確交付，請及時將提貨碼告知您的服務商，並要求其在提貨時出示提貨碼；{break}3、若服務商在提貨時無法提供有效的提貨碼信息，倉庫將無法完成交貨。 ',
  'DEesVZ': '生成文件方式',
  '+/R6RX': '任務狀態',
  '4wdEel': '超出了 <remaining></remaining> 個單號',
  '9jqt68': '批量創建任務',
  'AXARO9': '操作環節',
  'E1T1CC': '下載視頻',
  'JTjHlt': '附件格式/數量:支持格式{attachmentFileFormat},每個附件不超過{attachmentSizeMax}M。',
  'O1Fcla': '視頻處理完成時間',
  'O6+tgT': '處理成功',
  'RONThN': '子單號',
  'WB2Dlp': '最大支持輸入{maxBueinessNo}個訂單,多個訂單用分號隔開或者換行輸入',
  'XCWQC8': '處理詳情',
  'bmxEvb': '查看截圖',
  'elh3I5': '視頻保存時限（天）',
  'jrz36o': '請選擇要導出的記錄',
  'lJykMl': '處理失敗',
  'nU5XCN': '還有可以輸入 <remaining></remaining> 個單號',
  'oYCouL': '查看視頻',
  'whFLBl': '創建任務',
  'BZtqw8': '請選擇要下載的記錄',
  'DsN6/g': '<strong>說明：</strong>{break}1、當前視頻功能暫僅支持查詢「出庫打包」環節。{break}2、若系統未能成功查詢到視頻，請您直接聯系客服/客戶經理，我們將為您及時處理。',
  'G2+WDL': '獲取視頻雲鏈失敗',
  'PaaQBb': '創建失敗',
  'k/ZYCd': '無視頻文件',
  'xkHjBa': '批量下載結果',
  '/vrVEz': '<strong>尊敬的客戶您好：</strong>{break}{break} 使用視頻查詢功能前，您需簽署《{agreementName}》，請認真閱讀並接受協議。{break}謝謝您的理解與配合，順祝商祺～',
  'Jast2K': '我已閱讀並接受',
  'UzxG4z': '協議簽署成功',
  'orZ3MI': '協議簽署通知',
  '2LSGCJ': '根據訂單當前狀態及軌跡，作廢訂單的費用處理規則如下：',
  'J7LVnb': '請註意：訂單作廢後無法撤銷，請您確認是否作廢該訂單？',
  'JuDvIb': '<font>以下場景下，訂單作廢成功不收取費用：</font>{break} 1.出庫單狀態為「出庫確認中」；{break} 2.出庫單狀態為「出庫確認」，且訂單軌跡中未出現【揀選中】狀態（可在子訂單詳情頁查看訂單軌跡）。{break}',
  'tOYzEt': '本次共選擇訂單：{orderList}單',
  'PcipCg': '<font>以下場景下，訂單作廢成功將產生訂單攔截費：</font>{break} 1.出庫單狀態為「出庫確認」，且訂單軌跡中已顯示【揀選中】。{break} 2.出庫單狀態為「揀選完成」或「暫存完成」；{break}',
  'DgiUWw': '您尚未開通此報告權限，如有需要請聯繫商務開通',
  '0pBOr8': '本功能使用組-類兩層結構，建議組用於區分使用場景，類用於區分此場景下關聯不同的策略。{break}每個組的數據都是所有已發佈的SKU，每個組均是基於所有SKU進行分類，一個SKU在同一個組下只允許存在一個類內。',
  '6ZFs0i': '{skuType}[{skuCodes}]的出庫數量為 1 {unit}，請確認是否僅{type} 1 {unit}？',
  'Xagh1G': '下架',
  'bEBWR+': '您選擇的商品中：',
  '+ey7Yq': 'itemId',
  'PUjSsA': '目前僅支持 eBay、eBay eF、Temu、AliExpress、Shopify、Shein、Amazon(MSF)平臺配置規則。其余平臺將陸續開放，敬請期待!',
  'PoV573': '是否為EF服務',
  'S/dUu1': 'ef SKUID',
  'lLS+rK': '僅同步已完成註冊的平臺商品',
  '/TI8v+': '按平臺要求，eF平臺不允許與其他平臺共用一個組織內的庫存！',
  'AizcnV': '勾選入庫標簽特征=未貼包裹碼，僅貼商品碼後，將清空現有的箱單信息，您需要重新導入箱單，請確認是否勾選？',
  'MSpE0K': '提櫃申請已提交，屆時萬邑通將按照您的提櫃申請前往目的港進行提櫃，針對該訂單您無需進行預約，萬邑通提櫃送倉完成將郵件通知您，如有任何疑問您可咨詢客服，謝謝！',
  'gXvdYK': '該入庫標簽特征僅支持滿足以下條件的SKU進行下單：{break}1、SKU的商品包裹類型=A+包裹；{break}2、SKU出庫是否采集包裹碼=否；{break}3、SKU批次管理類型≠保質期管理/生產批次管理；',
  'qvErRI': '請註意：在【海運整櫃100%A+包裹】場景下，每個整櫃只能對應一個入庫單。請勿創建多個入庫單或將一個入庫單的貨物分散放置在多個櫃子中。',
  '05eCAs': '系統升級通知',
  'DkFwmu': '系統公告',
  'L24ioQ': '標題',
  'MtNsT8': '猜你想選擇：',
  '/F5ua7': '角色管理',
  '/kcDRM': '權限分配',
  '0fPGWA': '轉入方',
  '39n5YN': '發票生成成功',
  '50JdGS': '新增角色',
  '7WRAqc': '確認接收成功',
  'CwD34X': '轉出方',
  'EWyvCn': '貨權轉移單{orderNo}，狀態非“已上架”，不允許生成發票',
  'Eco+Vy': '*許可權修改後，相關子帳號重新登入後生效',
  'F7+3p7': '發票號',
  'IPlwHh': '轉出PVA庫存',
  'JiNi3f': '生成發票',
  'T7TK6n': '授權下單',
  'TMLZfW': '確認中',
  'TOmMNL': '角色名稱',
  'UlzvsW': '系統生成',
  '4Rjjko': '貨權轉移單{orderNo}，狀態非“確認中"',
  'f/1WBy': '確認接收',
  'j/5P4C': '您確定要删除此角色嗎？',
  'k+zCG7': '角色描述',
  'mFr2rC': '拒絕接收成功',
  'mGo/vP': '拒絕接收',
  'v0zMRx': '訂單作廢後不可恢復，確認作廢嗎？',
  'vTqH3H': '<font>請註意：為確保【100%A+包裹入庫】服務的順利執行，請按以下規則創建入庫單：</font>{break} <font>整櫃/整車入庫</font>：一個整櫃或整車<red>有且僅能對應一個入庫單</red>。請勿為一個櫃/車創建多個入庫單，也請勿將一個入庫單的貨物分裝至多個櫃/車。{break} <font>散貨入庫</font>：同一預約單內，<red>單個SKU有且僅能對應一個入庫單</red>。請勿為同一預約單下的同一SKU創建多個入庫單，也請勿將一個SKU的入庫單拆分至多個預約單。',
  'tXn/GP': '提櫃申請已提交，屆時萬邑通將按照您的提櫃申請前往目的港進行提櫃，針對該訂單您無需進行預約，{break}萬邑通提櫃送倉完成將郵件通知您，如有任何疑問您可咨詢客服，謝謝！',
  '4wYj0s': '按單號精確查詢',
  'AnBOmT': '本報表僅統計近12個月標準出庫訂單的數據。',
  'DQVpB8': '海外倉卸貨時間',
  'DcJ5SS': '月份',
  'dm5kaR': '模糊查詢僅支持一條記錄，至少輸入6位',
  'nJMBKl': '延遲',
  'vB+VpF': '{countryCode} 啟用國際服務,至少要配一個區域的運費和續件費',
  'wXBORv': '如批量查詢，每行輸入一條記錄，至多不超過{num}行',
  'y7RIrZ': '按單號模糊查詢',
  '10cSqN': '入庫包材類型',
  'Dyhkec': '關聯業務單據號',
  'Ek/myJ': '自定義分組',
  'iicPwU': '請選擇組',
  'x4UkYl': '說明：單次最多支持導入10000行數據； 導入的單品條碼會自動忽酪大小寫（例：A001=a001）',
  '4+JGPX': '點擊跳轉查看',
  'XfMvRR': '商品編碼已存在，請勿重複注册',
  'tgl+wy': '電池重量不能大於商品注册重量',
  '6F/qMC': '不能包含中文字元且前後不允許有空格',
  'VzWDBN': '貨權轉移單號',
  '849JPP': '否：',
  'HWGh4O': '當前數據獲取時間{time} 數據僅供預覽，僅展示已完成註冊的平臺商品及加入服務支持的倉庫',
  'SMfcim': '{msg}',
  '+74dRQ': '確認作廢',
  '8XdH/H': '請註意，當前訂單倉庫已<font>打包完成</font>。',
  'EJ0ilf': '請註意，當前訂單已進入<font>揀選環節</font>（您可在子單詳情查看軌跡）。',
  'GElz75': '請註意，當前訂單倉庫已<font>揀選完成</font>。',
  'K0VbUB': '建議您核實具體情況，並最終確認是否繼續。',
  'QUABn3': '當前訂單正處於{status}，作廢後將無法恢復。{break} 經系統預估，<font>本次作廢訂單不會產生費用。 </font>請您確認是否繼續',
  'Snx1CT': '此時作廢訂單，<font>將產生額外操作費用</font>，具體如下：',
  'VbK2G8': '嘗試攔截作廢',
  'W/umjf': '訂單狀態發生變化',
  'a/7jJk': '訂單狀態和預估的作廢費用已經發生變化，點擊確定查看最新預估費用。',
  'pISR6a': '我們將嘗試攔截，<font>若攔截成功，將產生以下費用</font>。若攔截失敗，訂單將正常發出。',
  'snmY5L': '作廢訂單再次確認',
  'v1TKFQ': '仍要作廢',
  '8xggaR': '<bold>溫馨提示</bold>：再次下單時，原訂單的增值服務不會自動延續。如您需要，請在新訂單中重新勾選。{break} <bold>重要提醒</bold>：為避免產生重復訂單，在進行「作廢」操作後，請確認系統狀態是否成功更新。',
  '+51v3G': '入庫下單錯誤',
  '+T7oUP': '匯出成功',
  '/Ygt9N': '記錄為空，請更新查詢條件',
  '0K+2Nl': '庫存查詢',
  '1oRL0R': '至',
  '3Dke5v': '庫存分析',
  '4TE3dA': '匯出入庫單資訊',
  '4ZwaVH': '儲存本地',
  '4jd2fs': '超時上架',
  '57EBJb': '進行中準時',
  '5e7tR0': '參數錯誤，請聯繫客服',
  '5ryQLW': '海外倉庫存',
  '8Ly5mZ': '入庫即時率',
  'J1Xz01': 'LMA全部訂單匯出',
  'MA9H0D': '商品關聯WEEE註冊號',
  'NDyvdD': '通知單',
  'NSlIU8': '海外倉出庫單',
  'OL8i5W': 'eBay認證倉商品',
  'QTxuNZ': '投保商品管理',
  'QX1e50': '匯出中',
  'QxJYio': '進行中超時',
  'SE4xTN': '平台同步匯出訂單',
  'SwgIXx': 'PVA押金凍結管理',
  'UYfJ4Z': '資料中心',
  'VD3UIl': '押金凍結管理',
  'VVOxxi': '匯出內容',
  'ZtIH+x': '倉儲收費單明細',
  'hvP05y': '週期',
  'kDoBV6': 'FBA未識別包裹資訊',
  'l2fKmn': '準時上架',
  'mygmne': '庫齡分析明細',
  'o9bMHL': '大小',
  'oi6ik1': '出庫商品組配置',
  'p2ed1q': '增值單列表匯出',
  'pkjKfJ': '進行',
  'qSxVi0': '遲到',
  'sCJx+e': '全球送訂單',
  'sJqXBl': '匯出失敗',
  'sWrLcU': '重新匯出',
  'slfC8D': '系統異常',
  'tQbfBF': '重試成功',
  'wYl6K+': 'PVA入庫明細追蹤',
  'wqlbYC': '費用項明細',
  'PKTV4F': '匯出中心資料僅保留7天',
  'e2OLRg': '子包裹資訊',
  'p7oVuI': 'LMA訂單',
  'uUtMYK': '分類庫存',
  '90dgBB': '下單時間 月',
  'jnsal6': '報表說明：',
  'KvFZEa': '1、僅統計近12個月入庫訂單的數據；',
  'fmCKMv': '2、不包含草稿、作廢、中止等狀態的訂單；',
  'o4T3N2': '3、不包含存在客戶異常且沒有物流單的訂單。',
  'w8TzTf': '排隊中...',
  '0I4Mwl': '訂單中的賣家訂單號，無映射則按winit規則自動生成',
  '3+2bo1': 'eBay帳號縮寫+Order No.',
  'BVLsdQ': '截取分割符號前',
  'Bdu5n5': '=CustomLabel',
  'DGYr7K': '填入需要截取的customlabel',
  'ER9apN': '=CustomLabel中指定分隔符號截取',
  'FNOn2N': '無映射',
  'MKTUwk': '賣家訂單號映射規則',
  'MT58zS': 'Order No.',
  'PCGKLz': '截取分割符號後',
  'PIWfVv': '從第一位向後截取',
  'Q8W43H': '可填入需要截取customlabel後測試結果：',
  'Se5OgA': 'Item ID + Transaction ID',
  'T0Qed1': 'Sales Record Number',
  'TgBR1/': '字段長度',
  'WzyWXL': '從最後一位向前截取',
  'XSETFO': '填寫字段長度',
  'Z9n0H8': '填寫後，系統將按固定長度的前面/後面部分截取',
  'anv9VE': '如：CustomLabel = ABC001，SKU No. = ABC001。',
  'cmEcYe': '商品編碼+規格',
  'cvIhux': '截取',
  'dG9rFr': '分割符號',
  'dLDvO0': '如：CustomLabel=ABC_001，SKU No.=ABC。',
  'dgBUXs': '=CustomLabel中指定字段截取',
  'en9HKt': 'eBay帳號縮寫 + Order Number',
  'gjwW8D': '多屬性商品暫不支援，請使用“同步配置-商品匹配”功能',
  'hlzsNt': '測試截取匹配結果',
  'kPrPHg': '填寫後，系統將截取此分隔符的前面/後面部分，多個分隔符號以第一個為準',
  'mAn1wq': '如：CustomLabel=ABC001002，SKU No.是CustomLabel前6位字符，即ABC001。',
  'qJQ6c5': '截取結果：',
  'sOdSKZ': '填寫分割符號',
  'tUa1Vm': '商品編碼映射規則',
  'tbyR9N': '規則',
  'znPwsY': '系統根據映射規則截取customlabel字段，與winit系統中註冊的商品編碼或商品編碼+規格進行匹配',
  '+Wl5kQ': '退貨完成',
  'G4onth': '僅支持查詢一年以內的的卸貨軌跡，如無法查詢到請核實退貨單的退貨時間。',
  'IGSkxG': '長度限制1-20個字符',
  'ITF7LG': '已銷毀出庫',
  'K0wFa7': '對不起，未查詢到該退貨運單號信息',
  'MMs0dW': '若您的包裹包含可識別退貨信息（退貨ID/RMA#/已註冊的商品條碼），海外倉在卸貨後5個工作日內會按退貨策略完成處理。',
  'RVmnGY': '請輸入退貨單號',
  'RzvkXS': '註：eBay賬號縮寫可進入<a target="_blank" href="%s">eBay帳戶管理</a>中設置。',
  'm5jINs': '无主货销毁',
  'uhTa0i': '預覽',
  '+S9nDE': '您已到達最高返利優惠！',
  '37ySYt': '當前消費{currentValue}{currency},距離更高返利還差{remaining}{currency}',
  '6X3LzI': '當期尾程消費完成情況',
  '6ux/gW': '抱歉，該國家暫無業務激勵方案',
  '85SrKm': '友情提示：本方案中的內容未經我司允許，不得以任何形式向第三方洩露，因洩露方案中的內容給我司造成損失的，萬邑通將根據您與我司簽訂的《供應鏈服務管理協議》中保密條款的相關內容依法追究責任；',
  'C1sxZK': '達標消費額',
  'DZknnb': '上月已享受折扣',
  'Frd9m1': '當前貨量',
  'K87Idn': '尾程派送激勵方案',
  'K9N76+': '已完成此階段',
  'LlkHzw': '激勵介紹',
  'Qgwwca': '您當前享受折扣',
  'RjguGP': '頭程運輸激勵方案',
  'TFywKD': '當期頭程貨量完成情況',
  'WWGa6X': '暫無上月折扣數據',
  'WhiSjD': '達標貨量',
  'YFWuRp': '已享受優惠查詢',
  'bioFIA': '全重量段',
  'cJOO41': '尾程運輸上月折扣',
  'eCCg6m': '頭程運輸上月返利',
  'fk7rme': '當期消費完成情況',
  'hi+lji': '消費總額',
  'kEOHIU': '本版海外倉標準方案生效日期：{releaseDate}（期間若有新版本發布，本版自動失效，已簽客戶遵照合同約定）',
  'o7lceA': '返利率',
  'u2vr71': '抱歉，您當前暫時未享受到任何折扣！',
  'umu2mn': '海外倉業務激勵方案',
  'vOBw66': '重量範圍',
  'xEhqVL': '激勵標準',
  'm45gH/': '尾程運輸本月折扣',
  'AHk13m': '享受更高折扣',
  'eWjKON': '預計下月可享受折扣',
  'j+0loD': '尾程派送方式',
  'N4RO+G': '標籤屬性',
  'mIetiv': '標籤序號',
  'ulOkM+': '標籤描述',
  'vVQCFA': '子包裹標籤列表',
  'O1Owap': '未分類',
  '+VopDc': '檢查結果為不良品{break}處理方式',
  '+mYfas': '檢查項目配置',
  '/n+tKs': 'WINIT計劃於2026年1月1日起，正式關閉「退貨策略維護1.0」的配置入口。',
  '0cMr0D': '點擊前往補充',
  '1IIbDN': '其他配置',
  '2BxBTv': '策略待補充信息',
  '2KONJS': '退貨策略維護2.0',
  '4HISCS': '歷史版本記錄',
  '4dEEgP': '下單時質檢方案',
  '5tkC4Q': '編輯退貨策略',
  '61cDzQ': '確定失效【{name}】嗎？',
  '6ytQ75': '商品組類',
  '73eXMD': '需要，按WINIT標準拍攝',
  '7vX7Un': '僅最終處理意見為',
  '9Hn46w': '創建新方案 | 查看所有方案',
  '9YUNcP': '說明: 因下單環節無法獲取實際質檢結果以及最終處理方式和需加工增值；以上預估費用不含存在質檢服務的商品倉庫處理費,',
  '9yRzlq': '檢查結果判斷標準',
  'AI6DDX': '最後一個檢查項不允許選擇【繼續檢查】',
  'AtdvGF': '整體照片:',
  'AzJgkv': '2. 策略優先級：',
  'B40RlV': '<bold>最終處理意見如何判定？</bold>{break} 步驟一：倉庫按序檢查，若觸發「處理並結束檢查」的結果，則質檢流程終止，並采用該結果作為最終意見；{break} 步驟二：若全程無中斷，則系統會收集所有檢查結果，並按照 銷毀 > 拍照暫存 > 不良品上架 > 良品上架 的優先級，確定最終處理意見。',
  'CDdDy+': '需要拍攝整體照片',
  'D23Qrv': '此商品的RMA質檢方案中，存在檢查項目信息缺失，請<a>前往</a>補充！',
  'DY6+vH': '質檢類型-質檢項',
  'EECzKR': '執行的加工修復增值',
  'GS1Lum': '執行',
  'GZsvFK': '適用範圍',
  'GluGBZ': '退貨策略維護1.0',
  'HfSjD4': '1.0版本的歷史配置在功能下線後將繼續生效。為確保策略統一，請盡快在2.0版本中完成配置，原有策略將在被2.0新策略覆蓋後失效。',
  'ISikVi': '質檢服務待補充信息',
  'Irs1wT': '質檢服務指定質檢方案',
  'JEav9w': '是否需要定製打包復原',
  'JK2HF/': '創建商品分類 | 查看所有商品分類',
  'JoXUXa': '示意圖',
  'KbwupO': '未執行',
  'LAH16f': '退貨策略維護版本升級',
  'MFIIR2': '請先選擇品類！',
  'MLSFI9': '適用商品組類',
  'MpyhY0': '1. 功能下線：',
  'ODFB43': '質檢方案',
  'OjHnTC': '查看質檢結果',
  'Q2tIhz': '上架處理方式',
  'RF4cO0': '發布人',
  'RjQfND': '是否完成檢查',
  'TT18ya': '適用SKU級',
  'U5LjS2': 'WINIT收貨環節會基於統一標準對商品進行初步判斷是否正常以及對應異常！',
  'VWqu6P': '選擇品類[<span>{categoryName}</span>]檢查項目',
  'WSbvVj': '檢查結果-處理方式',
  'X5lvqc': '請輸入正整數，數字越小優先級越高',
  'Xqvhg+': '需拍照',
  'YBE8cL': '質檢結果',
  'YS1hEm': '需提供信息',
  'Yygon3': '檢查結果-處理意見',
  'ZNKoOi': '質檢品類',
  'ZSIyhH': '確定生效【{name}】嗎？',
  'aMWIVz': '方案版本',
  'bU9iQR': '「退貨策略維護2.0」中配置的策略，其優先級高於1.0版本。',
  'bwYTdQ': '新增質檢方案',
  'c1d3HN': '此策略存在質檢服務待補充信息，為避免影響質檢服務正常使用，請及時完成補充。',
  'cGhj/6': '此商品的退貨策略中，尚未配置RMA質檢服務及質檢方案。請<a>前往</a>配置！',
  'dr80Nj': '質檢方案維護',
  'dtzzvy': '新增退貨策略',
  'fgmSvQ': '質檢方案名稱',
  'fi0x6R': '需要特殊打包復原',
  'fxqKz3': '發布時間',
  'g/7FFs': '請根據您的需求選擇檢查項目。WINIT標準檢查項已為您自動勾選並鎖定，以滿足基礎質檢要求，因此無法取消。{break} 請註意，增選拓展檢查項，該部分服務將依據質檢等級按項計費。',
  'gFmt0w': '執行加工增值',
  'gskk4+': '查看照片',
  'hBFKEL': '是否執行特殊打包還原:',
  'hDlNTS': '查看質檢方案版本<span>[{version}]</span>',
  'hME8oO': '質檢方案類型',
  'hTCHMm': '可選加工增值',
  'iwyzfn': '編輯質檢方案版本<span>[{version}]</span>',
  'j5Iaok': '適用組-類',
  'jZgtLX': '無需，正常折疊即可',
  'k869y5': '最少支持上傳1張，最多支持上傳5張模板圖片！',
  'kbEx/Z': '檢查順序',
  'l/g30I': '所選收貨倉無質檢服務權限！',
  'lT4lHY': '3. 過渡期安排：',
  'leNLKM': '策略編碼',
  'mXVcp/': '繼續檢查',
  'mt22Qq': '請選擇檢查項目',
  'n3ssO6': '無需',
  'nZHz3j': '檢查結果為良品{break}處理方式',
  'oMwON9': '質檢類型',
  'ozSlY1': '信息類型',
  'p9IpMU': '任一加工無法完成時{break}的處理方式',
  'qFVFrW': '需要，根據SOP進行操作',
  'qKuhZr': '重要提醒：',
  'qZChGk': '檢查項目',
  'qaw9Fz': '最大圖像大小 10M',
  'qfjmAq': '選擇檢查項目',
  'quY7u+': '方案類型',
  'sAcyRI': '商品組-類',
  'tYfrZI': '策略優先級',
  'u5ohvf': '最終處理方式:',
  'wDr1QD': '質檢項目',
  'wIzG3R': '檢查分組',
  'wTnJse': '觸發後按此意見處理並結束檢查',
  'xDRO8r': '適用商品組-類',
  'zMhU9B': '是否需要全局拍照',
  '5Dydff': '需要拍攝全局照片',
  'D2YSB/': '質檢類型-檢查分組',
  '0Ajg2F': '期望發貨時間',
  'QeOd3T': 'deliveryDateTime',
  'uOBD7S': '新增國家',
  'BTdEai': 'eBay Fulfillment 操作手冊',
  '/Q8O28': '設置質檢商品組',
  '/btlgL': '補充更詳細的質檢方案信息：如質檢結果示例圖、質檢結果處理方案、復原標準',
  '7Rp7oM': '吊牌商品編碼',
  '8/gXkq': '操作示意圖',
  '883yLc': '觸發後終止後續檢查',
  'AHfgiT': '選擇便捷的<{winit}推薦質檢方案>',
  'B6p1SV': '最少支持上傳1張，最多支持上傳3張模板圖片！',
  'D4fIn6': '實際吊牌商品編碼*數量',
  'DmZnYv': '說明：因下單時無法預知質檢結果與處理方式，故預估費用不含質檢相關處理費，該部分費用將根據實際情況另行結算，感謝理解。',
  'FpYvaM': '方案選用情況',
  'IUybYJ': '將需要質檢的商品進行分組歸類，建立清晰的<商品分組>',
  'QUKcOA': '補充質檢方案細節',
  'Zxk1bV': '爲商品選用方案',
  'dbocUy': '下單吊牌商品編碼*數量',
  'kJYqHD': '爲不同場景下的各個商品組，配置相應的<退貨策略>並關聯您在第一步設置好的<質檢方案>',
  'nA3Afb': '<bold>最終處理意見如何判定？</bold>{break} <bold>步驟一：</bold>倉庫按序檢查。若過程中出現觸發“終止後續檢查”的結果，則提前結束檢查；若全程未發生中斷，系統將彙總所有檢查結果。{break} <bold>步驟二：</bold>根據步驟一結束時所收集到的各項檢查結果，系統將按照以下優先級順序確定最終處理意見：<bold>銷燬>拍照暫存>不良品上架>良品上架</bold>',
  'rzkSaC': '創建專屬的<自定義質檢方案>',
  'xzmXSZ': '維護質檢方案',
  'I9UyiL': '請選擇吊牌商品編碼',
  'sX1llE': '請上傳操作示意圖',
  '573nH1': '第四步',
  'BmAtwJ': '系統配置異常，請聯繫在線客服 或 客戶經理反饋。',
  'hSm/op': '第三步',
  '79nva+': '近{recentRepaidBillDay}天{count}個賬單待還，請在最後還款日前及時還款，若未及時還款，按逾期日利率{rate}收取逾期費用。',
  '+mpYXC': '屬於',
  '/KCuQq': '不匹配結尾字符',
  '0wttn2': '出庫缺量規則',
  '2lZKYS': '不屬於任意一個',
  '2z97tj': '不加包裝（使用纏繞膜）',
  '4A/BqL': '優先原箱出庫，無原箱則WINIT標準紙箱打包',
  '4qooC7': '確認禁用嗎？',
  '5b6SVH': '不匹配開頭字符',
  '9D/n/z': '請輸入大於等於20%小於等於100%',
  'A2itln': '大於',
  'BQN5Hx': '滿足以上加包裝條件，則會按照以下優先級嘗試加包材；如果無法找到合適的包材，將導致下單失敗。',
  'D7AwWR': '匹配結尾字符',
  'EyhCf2': '常規打包',
  'HrwGnE': '匹配開頭字符',
  'IUOVvQ': '確認是否刪除【{name}】？',
  'KhzCZr': '不爲空',
  'L/Uqej': '僅在滿足此特定條件（{conditions}）時可支持纏繞膜打包出庫，若不符合此條件且訂單未選用快遞袋、氣泡袋或紙箱等包材將導致下單失敗。',
  'LGG3nQ': '已選擇條件',
  'N38CBT': '大於等於',
  'NOZnfu': '優先基於訂單上和SKU上指定的規則加包裝，如果訂單上且SKU上未指定加包裝，則按照下表的單一訂單/複合訂單配置的規則加包裝',
  'P0fYLA': '標準出庫/自提出庫',
  'QE3tCM': '常規打包-複合訂單',
  'Qk2Fwa': '匹配任意正則',
  'SgUr0U': '訂單類型爲',
  'T7RALq': '常規打包-單一訂單',
  'TQEgjF': '{specification}-內徑{inner}cm，外徑{diameter}cm;重量{innerWeight}kg;承重{bearingWeight}kg',
  'ThN9T7': '自提出庫默認使用WINIT出庫單號提貨',
  'UDzRdE': '紙箱最低裝載率',
  'VvAOXx': '一單多面單',
  'XJuKZH': '標準出庫/三方面單服務',
  'XrMPG5': '同時滿足以下條件時執行規則，無條件則代表所有訂單執行該規則',
  'Y+pkUW': '小於',
  'YKYgRu': '增值服務默認值設置',
  'ZV8mXo': '發貨國家爲',
  'b1hQA+': '驗貨',
  'bvyU1O': '爲空',
  'chN6Xr': '全部包含',
  'czF4u1': '屬於任意一個',
  'f0Gcik': '{specification}-長{inner}cm，寬{diameter}cm;重量{innerWeight}kg;承重{bearingWeight}kg',
  'fiZT2Z': '托盤打包',
  'gixfQz': '任意不屬於區間',
  'hdX8Pq': '纏繞膜',
  'iGsJxa': '發貨人類型',
  'ix+KJM': '不等於',
  'jVIEZ3': '禁用包材規則',
  'kTpKDZ': '查看出庫加包裝規則設置說明',
  'mpw9oD': '小於等於',
  'oQuDLX': '加包裝條件',
  'p4WOam': '同一包裹內商品',
  'p5oi8m': '預設',
  'qiep+I': '全部不包含',
  'r8CWAF': '查看增值服務默認值設置說明',
  'rnpwS0': '所有正則不匹配',
  's5/hma': '複製規則',
  'tzxes+': '設置默認規則',
  'yxG6B5': '收貨人類型爲',
  'Oo2pw2': '若對費用有異議，WINIT可代爲向供應商申訴，具體申訴結果以供應商回覆爲準。',
  'S6WSou': '爲確保下單順利，請保持此規則爲開啓狀態。',
  'U4i64H': '支持大於等於20小於等於100，支持兩位小數',
  'eaSAy1': '費用須知',
  'hOPK15': '開啓即代表您知悉：加包裝可能產生如人力分揀費、異形包裹附加費等尾程費用，WINIT有權事後補收。',
  'ig4HD7': '若出庫訂單及SKU層面均未指定包裝方式，則以您在此處維護的包裝偏好爲準。',
  '0PBdTA': '支持大於等於0小於等於100，支持兩位小數',
  '2Za3dq': '提示：系統將按優先級順序匹配規則。',
  '92hxXQ': '紙箱須滿足的最低裝載率',
  'M2x5Om': '優先使用原箱發貨；如無原箱，則使用WINIT標準紙箱進行包裝。',
  'SZ9xgJ': '僅當商品總體積達到紙箱容量的 [輸入框] % 以上時，纔會啓用加紙箱。',
  'W8+D0b': '當',
  'bwmdNs': '包材選擇方',
  'eqh60T': '禁用包材',
  'jOdBrw': '優先遵循訂單或SKU上指定的包裝方式。當這兩級均未指定時，則以您在下表設置的加包裝規則執行。',
  'jprqwi': '請注意：一旦匹配到某條規則，但其中設置的包材無法滿足當前訂單需求，將導致訂單無法成功提交。請確保您的規則中包材配置充足、合理。',
  'ju6uc8': 'Winit主動加包裝',
  'l+6ZhQ': '{specification}-長{inner}cm，寬{diameter}cm；重量{innerWeight}kg；承重{bearingWeight}kg',
  'ruLMCq': '{specification}-內徑{inner}cm，外徑{diameter}cm；重量{innerWeight}kg；承重{bearingWeight}kg',
  't4Tfd5': '客戶加包裝',
  'DQmnDh': '客戶自選',
  'o7FEk2': 'Winit分配',
  'sbYSy6': '僅在滿足此特定條件（訂單中僅包含大件商品，{conditions}）時可支持纏繞膜打包出庫，若不符合此條件且訂單未選用快遞袋、氣泡袋或紙箱等包材將導致下單失敗。',
  'B0hVHU': '班車',
  'IPZmD/': '查看預約包裹',
  '5ug8SP': '系統優先匹配編號大的同步規則。',
  '9YYRcf': '當訂單locationID為選中的一個或多個ID則匹配成功；若訂單存在其他ID則匹配失敗。',
  'MTp0sd': '設置訂單同步規則',
  'Tp3jPk': '平臺locationID',
  'UojdSt': '請先選擇店鋪',
  'WzLMak': '目前僅支持Shopify平臺配置自動同步規則。',
  'YsrOWu': '編輯locationID',
  'aP/oFv': '同步訂單&商品條件',
  'g8mKIE': '您已預約成功，請先取消預約後再操作添加增值',
  'gk6SAm': 'Shopify',
  'hhWF5b': '自動同步規則配置',
  'yuv9uR': '僅同步平臺訂單中商品locationID為配置的訂單和商品信息。不在配置中的商品和訂單將不會同步保存。',
  'zkSTJD': 'locationID',
  '42b83H': '若單一訂單無適配包材，則不加包裝直接出庫。',
  '//H9da': '遇到問題不用等！點擊右上角【AI客服】，快速獲取精準答案，高效解決您的疑問～',
  '2/xUY2': '軌跡描述',
  'D+aQT8': '軌跡地點',
  'O9Dydo': '軌跡類型',
  'VOmITT': '異常生成時間',
  'W2/H8Q': '在線咨詢',
  'lb7M58': '立即體驗',
  'm7Fe9Q': '稍後提醒',
  'vCVG+U': '建議處理方案',
  'zyNzwM': '軌跡時間',
  '1DGt6b': '標準箱長*寬*高{unit}',
  '1UPiOF': '標準箱長{unit}',
  'J6QDbf': '確認長*寬*高{unit}',
  'Q6n4fg': '電池重量{unit}',
  'Q7nIpV': '確認重量{unit}',
  'W+Bzyl': '標準箱寬{unit}',
  'rF5c2o': '標準箱重量{unit}',
  'yXUP/+': '標準箱高{unit}',
  '/+ndT1': '訂單是否含子包裹',
  '1jPngw': '箱材規格/箱材編碼',
  'CdxiZ3': '修改裝箱限製',
  'Itr6lw': '跳過提醒',
  'b7VRoN': '實際',
  'd/ONmD': '批量指定包材',
  'nvXY53': '若您選擇 「API 推單」 方式，推單時系統將默認按當前配置的裝箱策略及規則自動完成裝箱；若采用 「萬邑聯 - 單步下單」，系統會直接按您預設的偏好展示裝箱策略及規則，無需手動選擇，讓下單操作更高效便捷～',
  'rFHv5s': '裝箱策略及規則',

  '4xOx+o': '線上充值單',
  '6UsC+5': '入庫單交易明細',
  '9DCtKT': '賬戶交易明細',
  'Am2G5d': '線下充值單',
  'Ban2xz': '周帳單',
  'Blh176': '庫間調撥單交易明細',
  'BwuVZ7': 'ISP信用交易明細',
  'D2cPwp': 'OWHS信用交易明細',
  'DJDZm5': '手續費明細',
  'FKiuoZ': 'UPS原始賬單文件類型',
  'P99UIJ': '支付調用交易',
  'Qn4ZJ7': '出庫單交易明細',
  'R+16Rx': '新報表管理',
  'UUtqvk': '未處理',
  'UowarN': 'ISP信用賬單',
  'Vt6fEY': '信用賬單',
  'WSy4T+': '導出時間區間',
  'WWNyCw': '待入賬充值單',
  'Y5g8Te': '現金交易明細',
  'a+Meoo': '海外倉信用賬單',
  'ajO1Yd': '額度信息',
  'c1Ov+v': '所有報表內容僅保留1周，一周後自動清除',
  'c1yyOH': '付款人審核導出',
  'dpdA01': '倉儲收費交易明細',
  'e/Kla9': 'ISP交易明細',
  'iVjOaJ': '已導出',
  'n+a2gw': '正在處理',
  'oFuiXN': '收入結算單明細',
  'oiAyXn': '收入對賬結果',
  'qhdw65': '月帳單',
  'r0N3YU': '現金凍結交易明細',
  'rp4YdL': '導出異常',
  't/lC2V': '信用凍結交易明細',
  'uncTHU': '庫間調撥單',
  'xjS3qP': 'ISP對賬導出excel文件類型',
  'b7f9/d': '標籤/截止所選日期, 計算該SKU過去30天出庫量，高溫≥600, 600>中溫≥100, 100>低溫≥3, 超低溫<3',
  '/W2550': '複測尺寸',
  '1shlp5': '申訴中',
  '3rVAtp': '申訴失敗',
  '4hHXvr': '收入',
  'C0aYMc': '測算成功-不可申訴',
  'C6V18R': '原費用',
  'Mp1p5g': '差異費用',
  'N/NSFM': '費用項重算狀態',
  'NpOV17': '應收',
  'OpFlc4': '申訴成功',
  'RP3KQM': '重算執行日期',
  'Rlyigi': '尺重變更日期',
  'TPYRkz': '申訴原因',
  'UOD37Y': '新費用',
  'Uqv0qr': '複測圖片',
  'XZPExn': '重算單據號',
  'bAgRYE': '申訴截止日期',
  'ciSKVC': '查看申訴',
  'hbBX4R': '費用項類型',
  'ibGw3L': '單據日期',
  'jh3sUQ': '複測尺重圖片',
  'kREBCU': '扣費成功',
  'kSfHBY': '收費日期',
  'nloyV1': '重算截止日期',
  'p/PaxD': '差異總金額',
  'qlqr7V': '重算失敗',
  'slPSb/': '測算成功-可申訴',
  'u1D872': '申訴',
  'v8+0OK': '複測重量',
  'vkjFzi': '重算開始日期',
  'wlAKI+': '重算任務ID',
  'yaqV36': '重算成功',
  'p2StB1': '匯出資料僅支援一個月，請將查詢時間段調整在一個月內！',
  'pCAB8K': '日期範圍不能超過355天',
  'nmEIaT': '遇到問題不用等！點擊右上角{aiBtn}，快速獲取精準答案，高效解決您的疑問～',
  'C5uoG9': '是否出庫{break}凍結VAT',
  'Cfi1QF': '是否要求英{break}國本地VAT',
  'ayVWWJ': '是否填寫Eaby{break}SellerID',
  'k5V2i1': '是否簽署PVA{break}進口承諾函',
  'opq3xJ': '是否簽署{break}PVA申請函',
  '+3BCby': '{region}倉庫入庫管理質量數據',
  '/BLtk+': '指標數值',
  '2nQM1/': '{region}倉庫出庫派送質量數據',
  '4BanNe': '{type}率',
  '4JQSJ4': '{region}倉庫退貨處理質量數據',
  '4c7clp': '<=1天妥投率',
  '4ogMrT': 'D1 06:00Ascan比例',
  '5GwH/k': '達標',
  '5bO/vj': '退貨卸貨及時率',
  '6+cS9s': 'D0 24:00Ascan比例',
  '8g1o3T': '表示未達成目標',
  '8sxPPw': '<=5天妥投率',
  'CC4qyE': '未達標',
  'Cjvc04': '無RMA退貨',
  'Dlbh6k': '尾程派送質量',
  'DtQflA': '{type}時效目標',
  'E8nUQr': '<=14天妥投率',
  'G4Cg+g': '<=4天妥投率',
  'GM78L2': '綠色背景',
  'GkZeI+': '出庫派送質量',
  'Kez/zi': '<=7天妥投率',
  'L5GYuC': 'D3 24:00Ascan比例',
  'LRdkg3': '{region}倉庫尾程物流時效數據',
  'LeT+rO': '庫存健康度',
  'Mm4f9o': 'D2 12:00Ascan比例',
  'MniuVV': '<=6天妥投率',
  'NCjXYb': '{type}平均耗時（小時）',
  'NN9mm/': '退貨處理質量',
  'Ncm89Z': 'D1 12:00Ascan比例',
  'NlcrDa': 'D1 18:00Ascan比例',
  'OxzUDc': '<=3天妥投率',
  'QFFPhw': '{region}-{name}業務環節',
  'RET0ZI': '表示超額完成目標',
  'S3ijv4': 'D2 06:00Ascan比例',
  'SBgk1D': 'Ascan平均耗時(小時)',
  'Sr9DZQ': '澳洲市場',
  'TBXETG': 'TOB（企業客戶）',
  'YRVQwi': '有RMA退貨（Return label）',
  'ZaJqci': 'D1 24:00Ascan比例',
  'ZcUqFC': 'D3 12:00Ascan比例',
  'aUFcH3': '紅色背景',
  'amFFbq': '<=13天妥投率',
  'arsh33': '妥投率',
  'b32F5l': '入庫管理質量',
  'bwu9tI': '歐洲市場',
  'dYo8lQ': '標籤/指標定義{break} SKU溫度:標籤/截止所選日期, 計算該SKU過去30天出庫量，高溫≥600, 600>中溫≥100, 100>低溫≥3, 超低溫<3{break} DOI:截止所選日期, 計算該SKU近30天日均庫存數/近30天日均銷售數量{break} 日均庫存:截止所選日期, 該類SKU過去30天日均庫存數據{break}',
  'dxM+62': '<=2天妥投率',
  'eWHkTw': '<=8天妥投率',
  'ehRq3Q': 'TOC（個人客戶）',
  'fBZUil': 'D2 24:00Ascan比例',
  'gU2RPE': '目標值',
  'hEZmKt': 'Dscan時效明細',
  'hmxEAM': '北美市場',
  'iAc1uK': '履約質量報告',
  'iU9ECC': '<=9天妥投率',
  'jCvvE9': 'WINIT履約報告-{title}',
  'jiggJ0': '出庫派送質量(TOC)',
  'n1xD0M': 'D2 18:00Ascan比例',
  'nHjvuO': '<=11天妥投率',
  'nZ2ohi': '<=10天妥投率',
  'ntVbOw': '尾程物流質量',
  'qY9pNj': 'D3 18:00Ascan比例',
  'qdwlqH': '有RMA退貨（非Return label）',
  'r9nrCn': 'Dscan平均耗時(日)',
  'tWxzCK': '>15天妥投率',
  'uih03I': '出庫派送質量(TOB)',
  'v3QnyV': 'D3 06:00Ascan比例',
  'vmNCLW': '卸貨及時率',
  'wV4K52': 'Ascan時效明細',
  'ypRgWq': '<=15天妥投率',
  'ytPRt8': 'WINIT實際達成',
  'zi01v/': '<=12天妥投率',
  '1yVezl': '{region}倉庫退貨質量數據',
  '2EQl5D': 'Ascan及時率/目標及時率',
  '2UCAT/': '包裹數量(件)/總數量佔比',
  '3HPRdL': '點擊查看上月履約質量報告',
  'Cf4Dxe': '{region}倉庫入庫質量數據',
  'DxD84c': '退貨質量',
  'KCPw20': '出庫質量',
  'KETrVd': '數據更新:{updateDate}',
  'bP+DXy': 'Dscan及時率/目標及時率',
  'ebeXB4': '有RMA退貨（非Return Label）',
  'i7/n4q': '自營網站',
  'kPgNRf': '{type}時效明細',
  'n8wokX': '庫存健康度-溫度DOI矩陣',
  'r9hPjy': '有RMA退貨（Return Label）',
  's7xX25': '出庫運單',
  'wa+GQk': '入庫質量',
  'yoE23F': '實際出庫包裹數',
  '/VLPAR': '應Ascan包裹數(件)/總數量佔比',
  '9qSePb': '{type}平均耗時（日）',
  'HzZNGd': '應Dscan包裹數(件)/總數量佔比',
  '0ADeXp': '當前目標值爲WINIT標準，各平臺維度標準將在下期上線',
  'ArtXNn': 'A/Dscan時效表格',
  'BGefxq': '*下方時效數據中的Day均按工作日',
  'S2N7yW': 'Dscan時效表格',
  'UpARF1': '<=N天妥投率',
  'bs+f21': '統計維度',
  'g+DdcS': '應出庫包裹數(件)/總數量佔比',
  'smMCna': 'Ascan時效表格',
  'HOx5Gm': 'SKU存在審核不通過退回資訊，請',
  'K2Knso': '庫存來源',
  'VLkMXm': '自有進口商新遞延清關',
  'YPMVhh': '前往配置',
  'kFpo0l': '暫存倉儲單明細',
  'nFd8Op': '使用客戶自有進口商新遞延清關做進口申報，繳納關稅，進口暫不繳納VAT增值稅。',
  'S1UW0D': '前往更新',
  'kbXdMn': '卸車完成',
  '2RcAEK': '卸車實際開始時間(當地)',
  'Z3oDda': '卸車實際完成時間(當地)',
  'i24dmn': '目标卸车完成时间(當地)(客戶)',
  '+zITmD': '確認取消',
  '/9nx66': '待受理',
  '2RSxtZ': 'LMA出庫',
  '3Xtdou': '取件人時間',
  '4dXcaE': '查件單號',
  '4db2vs': '註：預計在10個工作日內收到反饋',
  '5COJCU': '查詢方式',
  '5n+nEm': '請填寫!',
  '6gddnv': '支持最多輸入300個子訂單號批量申請，用英文格式逗號隔開。例如：輸入W0111111111A,W0111111111B,W02222222222C或 直接復製表格數據添加。',
  '8K3n/q': '已提交供應商查件',
  '8bfXLo': '查件類型',
  '9BjcPI': '收貨人城市',
  'AXYXL1': '失敗訂單數：{sumErr}',
  'BwttVT': '收貨人電話',
  'GRcYPa': '（預計會在10個工作日內收到反饋）',
  'HbuMn5': '收貨人街道2',
  'J22fiQ': '申請尾程查件',
  'LSu7mi': '請輸入正確的郵箱地址',
  'PNaem7': '此操作將作廢原申請單：{serialNumber}，生成新申請單。是否確定提交？',
  'Rmy+/j': '支持最多輸入300個快遞單號批量申請，用英文格式逗號隔開。例如：輸入111111111,22222222或 直接復製表格數據添加。',
  'UGJiTJ': '支持最多輸入300個出庫單或包裹號批量申請，用英文格式逗號隔開。例如：輸入LMA010000000200CN,LMA010000000200CN,LMA010000000200CN或 直接復製表格數據添加。',
  'UQtFd4': '超過 <remaining></remaining> 個',
  'UhOXYz': '收貨人email',
  'WNS2rG': '前往查看成功申請單',
  'XMWZ7W': '反饋時間',
  'YnkdZ4': '成功提交查件訂單數：{sumSuc}',
  'Zk/ICr': '還能輸入 <remaining></remaining> 個',
  'bRnJvw': '收貨人姓名',
  'fCZa1O': '申請簽收證明（POD）',
  'fobnc0': '退回選項',
  'h9ocDd': '商品英文品名',
  'kES5v8': '請填寫查件原因等備註信息',
  'nxOK10': '支持最多輸入300個出庫單或包裹號批量申請，用英文格式逗號隔開。例如：輸入W0111111111,W022222222,W0333333333或 直接復製表格數據添加。',
  'pFDH8b': '超時未妥投',
  'q07jrc': '說明: {break}1、以下訂單存在拆單情況，請選擇需要查件的子訂單號或快遞單號 {break}2、點擊確定後,將為您合並數據,並切換至按子訂單號查詢方式查詢',
  'qsIJNh': '收貨人州',
  'rC41Ru': '附件格式/數量:支持格式{attachmentFileFormat},最多上傳{attachmentNumMax}個附件,每個附件不超過{attachmentSizeMax}M',
  'rW9+Sw': '部分妥投',
  'sXA8Hu': '以下為失敗訂單:',
  'siLxjW': '支持最多輸入300個包裹號批量申請，用英文格式逗號隔開。例如：輸入LMA010000000200CNA,LMA010000000200CNB,LMA010000000200CNC或 直接復製表格數據添加。',
  'vO6qbO': '查件結果',
  'w0OdQ5': '收貨人國家',
  'wJ6xYQ': '確定要取消這條尾程追蹤記錄嗎？',
  'xQ11Dd': '妥投未收到',
  'yOT8p7': '收貨人街道1',
  'yVvdHC': '查退回原因',
  'zYluLh': '海外倉出庫',
  'zuhcw0': '收貨郵編',
  '1JeJN7': '實際上架時間(當地)',
  'o+ag/q': '預計上架時間(當地)',
  '8uMLuW': '異常發生時間',
  '2m0yvL': '加Winit包裝：指客戶選擇加Winit標準包材，不關聯判斷SKU設置的包裝方式{break} 不加Winit包裝：指客戶選擇不加包裝，不關聯判斷SKU設置的包裝方式{break} 包材類型：部分包材類型Winit可能未準備，結果如為無合適包材可選擇其他包材測算{break} 計算復合打包限製：選擇Y時，按照70*60*60 加PSC尺寸限製打包，選項為人工選擇，系統不自動判斷實際是否會觸發限製。{break} 打包結果取值原則：在符合限製的多種打包結果中取周長（長+2*寬+2*高）最小的值。',
  '7sNu+S': '測算',
  'CWPyfS': '包裹長',
  'MA/Mn5': '計算復合打包限製',
  'UNr9ES': '輸入的值必須是大於0的整數,且最多4位',
  'WWFTye': '是否加Winit包裝',
  'XikQEu': '若SKU類型為單一產品，請填寫出庫單商品個數；若SKU類型為套裝產品，請填寫出庫的套數',
  'dFl4jM': '測算結果',
  'gIOerf': '包裹寬',
  'n5n1OS': '包裹高',
  '+iNy1w': '作業啟動模式',
  '/1QYno': '等報價，運費確認後再開始作業',
  'BNCADB': '無需暫存，打包後直接出庫',
  'KkzMm4': '倉庫立即作業，若後續運費不合適可轉為自提',
  'LFKMDI': '當前訂單的作業啟動模式為【倉庫立即作業，若後續運費不合適可轉為自提】{break} 在確認報價前，倉庫已經開始作業，請確認打包後是否還需要暫存？',
  'Z3Riil': '請先選擇發貨倉',
  'o03lm4': '需暫存，還需要補其他增值',
  'rqJgva': '當前訂單的作業啟動模式為【倉庫立即作業，若後續運費不合適可轉為自提】{break} 在確認報價前，倉庫已經打包完成，請確認需要補其他增值？',
  '9GFPa8': '需補增值，前往訂單處理頁',
  'Wiixeg': '無需補增值，直接出庫',
  '9OiRk/': '平臺退貨履約ID',
  'BL3caE': '退貨履約單狀態',
  'RT4t52': '退貨訂單名稱',
  'SITYoM': '平臺{platform}和eBay/TikTok/shopify不能同時選擇',
  'SYgdsw': 'eBay Fulfillment服務偏好',
  '3TBBLJ': '如需重新選擇處理方式，系統將自動作廢{storageBusinessNo}【{storageOutboundStatusName}】【{storageBusinessSceneName}】，請確認',
  'vhSqCh': '重新選擇處理方式',
  'w11zgT': '{returnGoodsOrderNo}重新選擇處理方式，系統作廢原處理方式創建單據',
  '1yn9kZ': '庫存轉移數量',
  '4yMMq7': '銷售退貨',
  '76+Fks': '取消銷售',
  '9jgpXZ': '貨權轉移日期',
  'EznFZ5': '凍結數量',
  'JPZ+FG': '經營單位',
  'N0gitK': '子賬戶名稱',
  'T2OhL9': '待上傳資料',
  'VP1jIv': 'M碼',
  'Z63W6m': '銷售出庫',
  'Z85O4V': '貨權轉移時間',
  'ZRD6CI': '轉移數量',
  'bA403s': '關聯單據號',
  'clh844': '關聯銷售單號',
  'dMeRwF': '轉入庫存總數',
  'iFuCVP': '退貨單作廢',
  'keBtGB': '轉出庫存總數',
  'mJ6Rya': '是否PVA',
  'uol1F5': '貨權轉移類型',
  'vb+EJD': '轉移原因',
  'AYhu7z': '直接輸入單個商品的裝箱信息。適合一次添加少量商品時使用，最多支持添加10種商品，且不超過5個箱子（非原箱/箱產品）',
  'FXbf/N': '整箱出庫，不可額外加包裝',
  'J3ny5z': '當箱子裏面的數量為1時，才支持選擇包材為「不加包裝」',
  'WqgvIj': '最多支持添加{x}箱（非原箱/箱產品），如需添加更多箱，請選擇「批量上傳」指定裝箱。',
  'a+FHIT': '不額外加包裝（原包裝）',
  'qCrGhM': '包材規格/包材編碼',
  'NAML+W': '若您通過API下單，系統將自動應用當前設定的裝箱策略。{break}若您在萬邑聯進行下單，訂單頁面將默認選用此偏好設置，您也可根據實際需要在下單時隨時調整。',
  'PKAG7q': '裝箱規則-條件設置',
  'iGal4w': '請輸入包材編碼；若未輸入，系統將自動推薦有庫存的適配規格。',
  'kS+WhZ': '倉庫自主加包裝',
  '8HakYW': '下單偏好：裝箱策略及規則',
  'KAFHjX': '裝箱規則偏好',
  'SiGjJP': '裝箱策略偏好',
  'i7hr5i': '確認要撤回改訂單嗎?撤回後請在未發貨頁簽中手動編輯發貨,不及時發貨會影響平臺時效考核。',
  'yyoFou': '忽略已綁定數據',
  '7ndvwC': '投保有效期',
  'A0f0/k': '投保保額',
  'JCLJ1E': '保費幣種',
  'NFlgV7': '投保箱數/套數',
  'Q2RQiv': '關聯訂單號類型',
  'cmGX6v': '投保日期',
  'dJDoS9': '保費金額',
  'ecwmuS': '投保單號',
  'pl49Yd': '投保單品總數',
  'wpcxNG': '投保單品數量',
  '/1DQhx': '按批次查詢時，僅可查詢批次商品，僅支持查詢在庫、已下單未入庫、已預約未上架3類庫存屬性',
  '1ndhGR': '是否有剩余可用額度',
  '2gQoSe': '限製項目',
  '5K9Hwk': '在庫+已下單未入庫',
  '5tSmdq': '商品限製屬性',
  'ETuiyY': '限製值',
  'Ih1vCg': '商品是否高貨值',
  'JDsBXq': '客戶限製條件',
  'NsjPkd': '請選擇批次屬性',
  'PCnNO2': '剩余額度',
  'V6APKW': '預約限製',
  'XetU9f': '查詢維度',
  'Xp5lvu': '在庫可用值',
  'Y10AHt': '在庫',
  'Zzw4rv': '在庫+已預約未上架',
  'axS6oX': '指Winit對客戶入庫限製庫存推薦的查詢條件組，選擇後即不能選擇商品帶電池、商品電池功率、商品是否高貨值、包裝方式、其他屬性篩選項',
  'e9zkGw': '其他屬性',
  'eq0G/k': '方案名稱',
  'gsiAen': '預警值',
  'hiBbus': '庫存限製',
  'iVJdmg': '現有值',
  'kZZRbD': '商品帶電池',
  'l8LunG': '限製規則',
  'lO7FcR': 'SKU數量：{skuQty}，SKU體積：{inTransitVolume}CBM，SI數量：{itemQty}（備註:根據當前所選擇的查詢條件匯總）',
  'mZbqYV': '已預約未上架',
  'n83qoO': '數據刷新時間：{time}',
  'pFHvk7': '入庫庫容資源額度',
  'qZgAkG': '商品電池功率（WH）',
  'qc2vsi': '已下單未入庫',
  'ray6Xr': '在途值(已下單未入庫)',
  'sofh2q': '庫存屬性',
  'u+2dkd': '方案說明',
  'S1jwaU': '種類',
  'r6qzDG': '包裝',
  'D1YrAF': '大包標籤',
  'TxJxc3': '海外倉出庫日期',
  'VqfoRn': '大包狀態',
  'emU+Eq': '已到海外倉',
  'm1liyd': '大包號',
  'oHApkd': '大包條碼',
  'ooeZJH': '到達海外倉日期',
  'QuQimk': '說明：單次最多支持導入20000行數據； 導入的單品條碼會自動忽酪大小寫（例：A001=a001）',
  '4g/YNM': '低級別服務運費不能大於等於高級別',
  "/l2Id0": "目前選取的訂單編號[{orderNos}]不是待預約狀態，請修改後重新選擇【批量預約提貨】。",
  "6LvyX5": "您選擇的訂單包含托盤自提（{palletNos}）與包裹自提（{packageNos}）兩種類型。因貨物形態不同，暫不支援一起預約，請您分開選擇同類型訂單後重新操作。",
  "AEVtQQ": "修改第三方提貨碼",
  "IY3FXR": "您目前選擇的訂單中存在不同的提貨碼，請確認是否修改成同一個提貨碼？",
  "JAHjpN": "批量預約",
  "Jtowgc": "批量預約提貨",
  "McPFaa": "新第三方提貨碼",
  "f4NmJd": "您選擇的訂單[{orderNos}]分屬不同的發貨倉。暫不支援一起預約，請您分開選擇同發貨倉訂單後重新操作。",
  "iIGDFN": "目前選取的訂單編號[{orderNos}]不是預約成功狀態，不支援修改預約資訊，請修改後重新選擇【批量修改預約資訊】。",
  "jHGQ5p": "請輸入新提貨碼",
  "lVnIuK": "原第三方提貨碼",
  "oyfZ7G": "批量修改預約資訊",
  '/dZoKR': '對比結果',
  '203KK1': '幅度: {resultRatio}',
  '51Xeya': '多個單號用逗號或者空格隔開，最多支持 {n} 個單號',
  '6UtugB': '（電商清關）',
  '9CfUdP': '支持上傳 pdf/bmp/jpg/png 格式的文件',
  'BWxabz': '標籤來源',
  'DTE63f': '採集部分商品',
  'E+V4qJ': '凍結單號',
  'E94VE7': '（運費+DUTY+進口VAT）',
  'EVdExE': '（傳統清關）',
  'Eh8ecU': '不允許清除的標籤',
  'Ezd3IN': '被標記為「禁止覆蓋」的標籤',
  'GGVXel': '已解凍金額',
  'Hih1cN': '採集範圍',
  'ITEyhW': '一次導入不能超過100條數據，請刪除部分數據後再導入。',
  'JuzkYv': '剩餘凍結金額最大值',
  'KJ8w2z': '上傳需要採集的商品資訊',
  'MIfGVs': '上傳示意圖',
  'NZ5BVa': '金額: {comparedResult}',
  'O2HC+u': '申報價格總額或',
  'Pt4b9+': '關稅稅率',
  'QTZ0Y9': '對比結果(USD)',
  'SasUDH': '選擇此項後，WINIT將優先採集外箱標籤上的SN碼。{break} 請注意：{break} ① 請您確保外箱所貼的SN碼與箱內單品實際SN碼一致。若兩者不符，由此引發的異常及相關責任將由您自行承擔。{break} ② 若外箱未貼完整的箱內單品SN碼，為保障操作準確性，倉庫將自動轉為開箱採集。',
  'T/xzrY': '選中的訂單不產生違規費用，取消後需重新預約。',
  'TTEs1k': '貨權轉移',
  'TdfPoy': '剩餘數量',
  'V74Nnm': '電商清關',
  'VMdkVZ': '手動輸入',
  'XMmUru': '請注意：選擇此項即表示您同意：倉庫將開箱採集箱內單品SN碼。此操作將拆開原箱包裝（膠帶），請確認操作。',
  'XdgqX6': '剩餘凍結金額',
  'ZMLOdj': 'VAT No.',
  'aP7Y4s': '源單類型',
  'bHoKa/': '傳統清關',
  'blqDHs': '綜合成本',
  'ckW6cz': '條件查詢',
  'dDGFPE': '剩餘凍結金額最小值',
  'dT/4mA': '批量取消預約',
  'f065td': '請先選擇文件',
  'fZSqu5': '押金凍結金額',
  'fph6KW': '搬倉',
  'gzdH4A': '單品應繳增值稅(USD)',
  'htJN69': '出庫單要求增值補貼的標籤',
  'iWRgTe': '凍結日期',
  'ia3MaQ': '已出數量',
  'ivyd8M': '僅支持針對商品化管理的SKU採集；單品化管理的SKU，系統會自動追蹤並反饋出庫單品碼，無需額外提交SN碼採集增值服務。',
  'j4FqiC': 'DGb標籤',
  'jt8XHR': '採集外箱上的SN碼',
  'k6nibR': '指定標籤{index}',
  'mLD2Rk': '計算結果明細對比',
  'meL30M': '（共 {total} 條記錄）',
  'mmiuH1': '僅保留<tooltip>不允許清除的標籤</tooltip>，其餘全部清除',
  'nFZLVS': '計算結果',
  'oz+tJE': '指定標籤',
  'pAsUMd': '尾程出庫',
  'pGxqSP': '開箱採集SN碼',
  'pdT4l0': '清關模式',
  'q9mfG6': '對比比例(%)',
  'qwBnz+': '數據來源',
  'r79YLd': '單品申報價值(USD)',
  'rjl+EA': '海關建議申報價格總額',
  'sW4ZUc': '批量查詢',
  'thhsjq': '選中的訂單[{orderNos}]將產生違規取消費，詳情請看價卡，取消後需重新預約。',
  'yKSKEE': '最多支持輸入{n}個單號',
  'yaM9oN': '標籤示例',
  '/BHFm2': '入駐進度查詢',
  '/GaNdh': '上傳指定標籤',
  '/TzrDD': '請務必上傳指定標籤～',
  '0SYcTZ': '僅採集導入的商品',
  '6+8CRa': '請選擇國家',
  '6EyN8h': 'Winit初篩通過',
  '9c1hzl': '入駐申請狀態',
  'rJGLim': '（已發送綠色通道郵件）',
  'EuHa/E': '訂單中存在單品化管理的SKU[{skuCode}]，系統會默認追蹤並反饋出庫單品碼，無需您再額外提交採集SN碼的增值服務，此增值僅採集商品化管理的SKU',
  'FXfS9v': '郵編查詢工具',
  'G+eQ6Y': '電商清關計算器',
  'GBRNdf': '申請編號',
  'JBvtCq': '箱產品/原箱 採集位置',
  'KYK6eH': '入駐平台',
  'Kqtpf2': '已提交平台',
  'N6ajdw': '平台審核失敗',
  'SMmJ95': '平台審核通過',
  'NEpuF0': '城市、州、郵編需至少填寫一項',
  'YulXiJ': '訂單內所有商品都需要採集',
  'cBcQ2x': '當前選中的訂單號[{orderNos}]不是預約成功狀態，不支持取消預約信息，請修改後重新選擇【批量取消預約】。',
  'fEklXb': '查詢結果',
  'k8fjyM': '選擇【僅保留不允許清除的標籤,其餘全部清除】時，將自動去除其他選項，是否確定選擇？',
  'lp414l': '僅保留不允許清除的標籤，其餘全部清除',
  'r3cJxf': '國家/城市/州/郵編查詢',
  'yGydU8': '最多支持上傳{maxCount}個文件',
  'yRcdbz': '申請狀態',
  'M/dbSE': 'Winit初篩不通過',
  'qpJ1Q8': '入駐進度信息',
  'sd8yW7': 'Winit初篩通過',
  '3x03jC': '定製標簽',
  '411c5X': '上傳SN碼位置示意圖',
  'hbqoJB': '部分商品采集',
  'k48Ow1': '支持上傳bmp/jpg/jpeg/png格式的文件，且每張圖片最大1M',
  's68RTA': '文件大小超過1M',
  '+5l5RU': '提單',
  '+YZ9D0': '萬邑通進口商',
  '+fWkMw': '自有出口商',
  '+sTzV8': '每個記錄至多上傳20個附件！',
  '/ne/E8': '訂單列表',
  '/x7nZy': '添加訂單',
  '/xZBur': '1.快遞--請上傳快遞公司原始發票和報關單；{break} 2.空運/海運（整櫃或散貨）---請上傳英國進口報關文件C88和E2或者CDS entry文件{break} 3.轉倉--請上傳貨物合法進口清關資料{break}',
  '04hsSz': '無需上傳',
  '0Aqamd': '進口報關方式',
  '29WiJt': '請選擇項目!',
  '3MVwP5': '下載資料',
  '3dIgTz': '自有進口商',
  '3mYFsT': '萬邑通將應英國海關稅務總局總署（HMRC）要求提供相應的信息和文件',
  '5f/tmO': '關聯訂單',
  '5ha5za': '所選訂單存在不同的進口商',
  '7hCnwL': '文件資料',
  '92mnHT': '進口文件下載',
  'A0dboq': '無進口商',
  'DNhsJs': '添加成功!',
  'ETsbI4': '進口申報資料',
  'ElSBFf': '提單收貨人',
  'EswQfb': '品名描述',
  'HHvf84': '生成日期',
  'HYBpDp': '出口報關單',
  'Hy9KWe': '說明，每個品名單獨一行輸入',
  'ILoiBi': '資料詳情',
  'IuHG6+': '無文件',
  'KYBCb+': '訂單查詢',
  'KyeBiS': '金融出口商',
  'QaWo2G': '提單發貨人',
  'R4dmjn': '等待上傳',
  'RA4e41': '自報關',
  'Rz9imW': '已開票',
  'ThBqN+': '批量下載',
  'Ty8kO6': '第三方出口商',
  'U1mKIE': '到倉時間',
  'WoxXMD': '所選訂單存在不同的訂單進口商，是否繼續提交？',
  'WwhSzz': '管理進口商',
  'Xah/LD': '提交提單資料',
  'YL79u+': '待上傳直發英國文件',
  'a1FoJJ': '上傳文件說明',
  'b3QMvT': '運輸資料管理',
  'dApyqa': '運輸資料下載',
  'djX2Ag': '新增提單信息',
  'f0ik7b': '發票下載',
  'fIjF3a': '可按CTRL批量選擇文件上傳{break} 支持jpg，gif，png，jpeg，pdf，doc，docx，xls，csv，xlsx，每個附件不超過5M,每條記錄至多上傳20個附件！',
  'fh7G1f': '訂單進口商',
  'hfAmiH': 'ENTRY NO（MRN NO）',
  'jl5HLa': '萬邑通出口商',
  'jo21HT': '所選進口商與文件不一致原因',
  'kM0bHJ': '直發英國文件上傳',
  'myXsKd': '已申請',
  'nLN0mF': '出口報關方式',
  'nt+PjS': '進口報關資料',
  'pxHrbj': '進口稅單',
  'pzpMYc': '選中的訂單中有未完成驗貨的，提單不生成默認信息',
  'q8devg': '第三方進口商',
  'smovHs': '請填寫大於0的數，最多保留{number}位小數',
  'xptZYF': '出口報關資料',
  'ypVf0h': '提單信息',
  '+wet4N': '驗證碼錯誤',
  '4TJ3fw': '按住滑塊，拖曳驗證',
  '5LHKKt': '6-32位，且包含字母、數字、特殊字元中至少兩種',
  '6AJEH3': '新密碼',
  '9ljNkr': '重新發送',
  'CALdTq': '用微信找回密碼',
  'NvFWAN': '最多200字元',
  'NzYMJp': '請使用已綁定{a}帳號的微信掃碼確認',
  'PzWEi/': '用郵箱找回密碼',
  'QNdRrx': '兩次輸入的密碼不一致',
  'RMNNp4': '請確認密碼',
  'SkmWND': '用手機號碼找回密碼',
  'TZjLzQ': '新密碼設定成功，請前往登入~',
  'VVnTpe': '該微信帳號未綁定當前郵箱，請使用綁定郵箱的微信掃碼驗證',
  'W7shU1': '提供帳號資訊',
  'Y8fUsW': '請選擇方式',
  'Z5Nevj': '修改密碼',
  'ejs0A3': '請輸入手機號碼',
  'iTrKWD': '記得密碼？返回{a}',
  'pTv/F0': '點擊下方{a1}按鈕，我們將向您{a2}發送郵件以驗證您的帳戶',
  't0nA+i': '安全驗證',
  'tqxH2C': '請輸入有效的郵箱',
  'uGp2R1': '確認發送',
  'w2+gpZ': '我們已向您發送電子郵件以驗證您的帳戶，請檢查您的{a2}收件箱並完成驗證，若您未收到郵件，請點擊這裡以{a1}',
  '1NA8y/': '重設密碼失敗',
  'YAH/13': '質檢服務僅支持基於具體商品組-類配置，不允許選擇適用所有商品',
  'e2ng4d': '多個商品條碼需換行或用英文逗號隔開，最多支持{num}個，雙擊切換到單個查詢',
  '81cy/S': '支持上傳bmp/jpg/png/jepg/gif格式的文件',
  '02WhE8': '反饋內容',
  '4R5GEq': '首頁',
  '9mMWiw': '創建問題工單',
  'L/NHRt': '變更狀態',
  'Lb+A3a': '答復',
  'LqIgJ0': '問題/建議分類',
  'Mx2ytz': '錄屏',
  'OjLqmy': '未知',
  'UJM0aP': '截圖',
  'W1XmWz': '第',
  'XPFi6q': '條',
  'bRWVNo': '模塊_功能頁面',
  'e4xBZM': '條，共',
  'gGSndD': '我',
  'jlVsSp': '反饋記錄',
  'oeAKKH': '功能建議詳情',
  'pqjc9a': '功能建議',
  '1t+SIt': '待分批處理包裹/托盤',
  'UhLIyC': 'OTTO平臺創建退貨單，請選擇return label退貨服務。否則下退貨單失敗，會導致平臺訂單標發失敗。',
  'B5WNzT': '<font>以下場景下，訂單作廢成功將產生訂單攔截費：</font>{break} 1.出庫單狀態為「出庫確認」，且訂單軌跡中已顯示【揀選中】；{break} 2.出庫單狀態為「出庫確認」，且從供應商獲取到尾程面單（僅部分供應商，詳見價卡）；{break} 3.出庫單狀態為「揀選完成」「打包完成」或「暫存完成」。',
  'F88GCy': '貨權轉移明細列表',
  'Ggi6gC': '<font>以下場景下，訂單作廢成功不收取費用：</font>{break} 1.出庫單狀態為「出庫確認中」；{break} 2.出庫單狀態為「出庫確認」，且訂單軌跡中未出現【揀選中】狀態（可在子訂單詳情頁查看訂單軌跡）。{break} 3.出庫單狀態為「出庫確認」，且未從供應商獲取到尾程面單。',
  'h0xL1u': '此時作廢訂單，<font>將產生面單取消費用</font>，具體如下：',
  'hEd0nU': '貨權轉移列表',
  'pTH9Tb': '請註意，當前訂單倉庫已<font>出庫確認</font>，並且從供應商獲取到尾程面單。',
  'Us7j0k': '本次共選擇訂單：{orderList}單。{break}若作廢成功，預計將產生作廢費用：<span>{money}<a>下載費用明細</a></span>',
  '1LwUBD': '關鍵字',
  '7wLx36': '勾选后取消不可恢复上次选择，请确认！',
  '9UefLp': '標籤',
  '9cCkiO': 'Webhook地址',
  'E/+KA9': '訂閱對象',
  'FBDWRn': '請輸入消息標題',
  'FuniBX': '變更主連絡人',
  'H4wovK': '請輸入Webhook地址',
  'JAIyUz': '通知消息',
  'JqgJGX': '訂閱人/郵箱/手機號碼',
  'NvLtl+': '一般',
  'OS0LiT': '新增訂閱',
  'PPbRVY': '請先驗證webhook地址',
  'SaWUeK': '消息一級分類',
  'Se+Fml': '訂閱類型',
  'TB0+MB': '訂閱對象名稱',
  'VCA4P7': '是否訂閱',
  'W5ZChw': '訂閱語言',
  'WG5j22': '訂閱角色',
  'YQjCEJ': '消息二級分類',
  'Yb84w9': '重要程度',
  'anJ1Qt': '請選擇標記數據',
  'f+39S3': '請選擇訂閱內容',
  'geJ09d': '添加時間',
  'gh/3UH': '推送時間',
  'hj+c+u': '去設定訂閱角色',
  'jhsT9N': '職務/備註',
  'kdTh+7': '標記已讀',
  'ktaxSw': '未讀',
  'luc2Nr': '同步訂閱短信',
  'nDCjZ5': '確認全部標記已讀？ ',
  'nVQlZW': '全部訂閱',
  'pTYW3/': '已驗證',
  'qK1KCj': '全部標記已讀',
  'rHCuQ1': '重要',
  'sKrE9C': '驗證',
  'sjRsMZ': '訂閱所有“重要”通知',
  'uENXqC': '請在個人中心-我的資料-連絡人資訊變更主連絡人',
  'xq3BbG': '該主題為主連絡人強制訂閱，不可取消勾選。 ',
  'z/zD9X': '機器人名稱',
  'zkfr4X': '選擇角色,則默認訂閱該角色對應訂閱內容',
  'zmDYiF': '訂閱許可權',
  'E4mrQc': 'Webhook地址：參考 <a>取得機器人Webhook</a>',
  '/rSdLg': '31-60天',
  '0IOfTn': '91-120天',
  '1Fjaq+': '貨值',
  '7PBmg9': '151-180天',
  '7bxNmH': '181-365天',
  'B5zlty': '未出庫天數段',
  'C0WfWt': '61-90天',
  'CeraFI': '在庫體積',
  'E8+w5M': '截止日期',
  'EHUOf7': '近30天平均銷量最大值',
  'KtoCy3': '超180天未出庫',
  'OLULP8': '查詢日期',
  'Q9GryY': '121-150天',
  'QMF2SE': '近30天平均銷量',
  'SutcRd': '未出庫區間段',
  'X8reig': '超60天未出庫',
  'hkJnTx': '365天以上',
  'iQLiiJ': '近30天平均銷量最小值',
  'k6/mVV': '超90天未出庫',
  'kZ0gWm': '超150天未出庫',
  'krNXZs': '倉群DOI',
  'md/ktr': '超365天未出庫',
  'nEOgoo': '在庫數量',
  'tMo2Zv': '未出庫天數',
  'vGXXMs': '超120天未出庫',
  'vHrtsr': '溫馨提示：庫齡分析明細數據中在庫數量已排除待銷毀庫存，商品未出庫天數不會統計銷毀出庫記錄！目前只支援查詢60天內的數據。',
  'y0pCCP': '超30天未出庫',
  'yE2ftt': '30天內有出庫',
  'zSTmkX': '30天以內',
  '1Z0q20': '禮品卡幣種',
  '5CxfGD': '導出使用記錄',
  '95Hp/S': '查看使用記錄',
  '9Usr+K': '禮品卡管理',
  '9WR7+x': '申領禮品卡',
  'ASFlCO': '使用記錄',
  'KlWMzW': '已激活',
  'NCSj7q': '費用原幣幣種',
  'NvMM+d': '批量激活',
  'RWLYAl': '禮品卡生效日期',
  'UQs3Nl': '面值',
  'ZCDASn': '活動名稱',
  'aN+DgN': '激活時間',
  'b/np9H': '過期時間',
  'dsUPu7': '卡號',
  'g7PNrP': '禮品卡使用金額',
  'hV++l4': '訂單履約場景',
  'kXhKwt': '已用完',
  'nHyNVr': '禮品卡餘額',
  'sCayEg': '費用原幣抵扣金額',
  'xISm1t': '激活',
  'xRUwu0': '餘額',
  'yIVw3+': '使用限制說明',
  '/CSTCd': '*特別說明：',
  'FgKwXB': '1.禮品卡使用不支援訂單補收、退費。',
  'rL3SDa': '2.同一訂單的同費用下只允許抵扣一張滿足條件禮品卡，有多張優先抵扣先過期的，過期時間相同則使用抵扣金額大的禮品卡。',
  'Ro2qcz': '是否不良品混合儲存',
  '8qXhbV': '異常單[{eventNo}]已經提交過標準增值單[<a>{orderNo}</a>]，請從原來增值訂單-暫存待處理繼續創建增值',
  'WvkP+p': 'API下單忽略非批次商品的批次入參資訊',
  '/gzqUq': '异常單[{eventNo}]已經提交過標準增值單[<a>{orderNo}</a>]，不允許批量創建增值，請從原來增值訂單-暫存待處理繼續創建增值！',
  'wLp4S1': '備註：若您開啟了此偏好，針對非批次商品或者是入庫批次的商品，若您API下單傳參了保質批次管理或者生產批次管理的批次資訊，系統將自動忽略該資訊進行下單。',
  'MfyMkP': '請先選擇「發貨國家」',
  '/VTvju': '收費幣種',
  '1PGUKz': '不收費',
  '2qIWkk': '調整前SKU類型',
  '3uLrd9': '收費金額',
  '441EO8': '調整前信息',
  '5PA3dx': '該訂單選擇了箱產品破損後按單一產品上架的增值服務，此單一產品來源於對應的箱產品。',
  '5c2lA7': '已收費',
  '8CXErc': '實際調整信息',
  '9pf+1/': '單品明細',
  'AkqrWy': '庫存類型調整單',
  'BpshEj': '收費狀態',
  'FgGPtz': '系統生成的單為下述3類：{break}出庫單分配共享庫存時，自動觸發的整箱/套拆零服務；{break}在創建入庫單時選擇了單品轉整箱的增值服務，且轉箱成功而自動生成的調整單據；{break}在創建入庫單時選擇了箱產品破損後按單一產品上架增值服務，且轉單一產品成功而自動生成的調整單據；',
  'Fwsf/M': '櫃號',
  'HPY1mp': '系統生成的單為：在創建入庫單時選擇了單品轉整箱的增值服務，且轉箱成功而自動生成的調整單據',
  'KznAti': '子包裹數量',
  'LsLx7J': '調整後庫存單元數量(個/套/箱)',
  'MIqUrD': '庫存類型調整單號',
  'MKUN8s': '下單信息',
  'NOYwTf': '收費明細',
  'TA/dF+': '不良品數量',
  'Thb3IK': '調整前庫存單元數量(個/套/箱)',
  'UQJOTC': 'Winit作廢',
  'bM/rWy': '該訂單選擇了箱產品破損後按單一產品上架的增值服務，部分單一產品來源於對應的箱產品。',
  'bS1ela': '關聯SG',
  'cPOcLF': '當天',
  'crf+ux': '作廢中',
  'dYxO8a': '調整的庫存組織',
  'eOSHuj': '調整後SKU類型',
  'eqSzQH': '應完成時間(當地)',
  'gZTbq+': '調整來源',
  'ghuJzS': '是否需要收費',
  'iTkG5n': '良品數量',
  'ih/an8': '作廢時間',
  'itKAwe': '異常反饋',
  'm2weIk': '客戶作廢',
  'mLZov4': '異常流程',
  'mcwf7W': '分類庫存調整單',
  'mvFsMl': '是否拆箱逐件清點',
  'oCtS+Y': '調整後信息',
  'rfLmih': '未收費',
  'rvag4g': '作廢失敗原因',
  'uLI4ok': '子包裹明細',
  'uQwOYT': '收費時間',
  'vfZB01': '觸發環節',
  'w6ZZc4': '預計/實際影響SLA',
  'wG10je': '調整中',
  'FAvugZ': '異常定義',
  'O2MhLZ': '郵件發送配置',
  'Vi8Lwt': '請選擇配置',
  '0axu1J': '包裹類別數',
  'DJAqHM': '托盤尺寸限製',
  'Pq4RvP': '包裹類別編號/包裹號',
  'RmJtzp': '實收總金額（幣種）',
  'bDWm20': '每箱件數',
  'dwmkO8': '<a>標準說明文案</a>',
  'fRe2FR': '預估總金額（幣種）',
  'EA+JnO': '驗證成功',
  '7Y8msb': '導出/導入狀態',
  'DvfSVz': '前往設定',
  'QpRtOT': '執行中',
  'XWtLrG': '數據已為您導入，是否已成功請在列表中查看，如數據量較大，可能需要稍等一會兒',
  'mD6tbQ': '導出/導入內容',
  'nap+VW': '數據已為您導出，請在列表中下載，如數據量較大，可能需要稍等一會兒',
  'z3f/YA': '尺重來源',
  'I60VBo': '<strong>德國倉初始化說明：</strong>{break}德國庫存初始化選擇的VAT號請確保已維護德國包裝法號（LUCID號），{break}並請確保在途訂單也維護好有LUCID號的進口商，{break}否則初始化將在7月1日後失效，需重新初始化。',
  'pWnuuW': '<strong>操作說明：</strong>{break}請先導出各倉還在庫的SKU清單，輸入對應SKU輸入有效的VAT號後導入。{break}一次只能導出或導入一個倉庫的數據，不允許單倉多次導入，且導入後不可再修改。{break}導入時SKU必須齊全，如存在部分SKU未導入將不成功（請注意導出與導入間隔期的新入庫SKU）。',
  'PfM5xX': '電池重量應小於商品註冊重量',
  '64x/DJ': '<strong>溫馨提示：</strong>此商品為裸貨，因未設置出庫包裝方式，存在出庫下單失敗的風險。為避免影響出庫，建議您：{break}<strong>1. 快速啟用：</strong>直接啟用出庫加包裝-系統預設規則 【裸貨加快遞袋】（若已啟用，請忽略）。{break}<strong>2. 自定義配置：</strong>為裸貨或其所在商品分組創建專屬的包裝規則，{a}。',
  'LWZ8r8': '(查看包裝分類說明)',
  '38BVhg': '暫停出庫，還需提交其他增值',
  'Efi7Rw': '暫停出庫',
  'SZNjiF': '無需增值直接預約提貨',
  'So7SRd': '倉庫會攔截出庫，等待新的增值單',
  'm325Qd': '倉庫不會等待新增值，直接出庫',
  'pZTxK9': '暫停出庫訂單',
  '3K1yMY': '庫內監控材料',
  'KqTHNC': '庫內截圖',
  '1Xj+fp': '<strong>說明：</strong>{break}1、當前視頻功能暫僅支持查詢"出庫打包"環節。{break}2、截至目前支持查詢的國家和倉庫有:美國、英國、DEBR2倉。不支持查詢的國家和倉庫有:澳大利亞、加拿大、DEBR倉。{break}3、若系統未能成功查詢到視頻,請您直接聯系客服/客戶經理,我們將為您及時處理。',
  '9WJ3hf': '您目前存在未提交的增值服務[{serviceName}]，請點擊「確認提交」後再提交預約信息。',
  'lV87ri': '功能描述：用戶能夠依據訂單轉電商平臺倉或者第三方倉入庫時的收件規則，在這裏製定對應的裝箱規則。比如，按照訂單類型、訂單履約場景、發貨國家等業務特性，對即將出庫的貨物進行分箱和裝箱操作。同時，還可以對裝箱後的尺寸與重量加以限製。系統會依據用戶所設定的規則，自動完成訂單的分箱和裝箱工作，從而滿足電商平臺倉或第三方倉的收件要求，有效提升貨物在平臺倉入庫的合規程度。 {break}註：系統按照訂單類型、訂單履約場景、發貨國家等業務特性未命中您配置的裝箱規則時，倉庫打包時默認按WINIT的裝箱規則來校驗是否符合發貨標準',
  'oQEw+5': '智能推薦下單是指系統根據客戶下單時買家地址、派送方式、海外倉庫存等信息,基於配置的發貨策略計算出最優發貨方案(發貨倉庫和派送方式的組合)後,自動按照最優方案發貨{break} 註： {break} - 如果訂單為組套訂單，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單來源為「平臺同步」並且電商平臺為「速賣通」或「TIkTok」，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果客戶下單時指定了批次商品，不支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單的訂單履約場景為「FBA轉倉-VC訂單」或「FBA轉倉-非VC訂單」，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 如果訂單包含不允許拆單的增值服務，支持推薦發貨倉庫和派送方式，不支持拆到多個倉庫發貨{break} - 預售訂單無在庫庫存不支持推薦倉庫和產品發貨{break} - 當您在【倉組配置】裏面選擇了【校驗地址】，在推薦的過程中會校驗地址並且預估地址相關的附加費用；如果您未選擇【校驗地址】，推薦的過程中將不會校驗地址，也不會預估地址相關的附加費用，推薦結果的準確性可能存在偏差。',
  'veHerq': '一、若貨物不屬於轉倉場景請選擇訂單履約場景為「買家訂單」；{break} 二、轉倉貨物若屬於以下場景請選擇對應訂單履約場景：{break} 場景1、Amazon Seller Central賬號補貨至亞馬遜倉庫，請選擇「FBA轉倉-非VC訂單」{break} 場景2、Amazon Vendor Central賬號補貨至亞馬遜倉庫，請選擇」FBA轉倉-VC訂單「{break} 場景3、不需要更換商品標簽且收貨人非Amazon倉庫，請選擇「轉第三方倉」。{break}',
  'FEfuAq': '默認產品',
  'H8hS8Q': '請配置具體的發貨國家後再選擇指定產品。',
  'MVIVPx': '頁面下單默認產品',
  'PzFoST': '出庫下單步驟"<span>3</span>產品信息"默認產品配置',
  'Q+xlLd': '指定產品',
  'U0xV2c': '訂單履約場景即將更新，需要將您的增值服務文件全部清空。',
  'Vavxm/': '7.如果您需要上傳多種訂單履約場景的訂單時，請先拆分訂單後再上傳。',
  'bCNs4z': '默認產品分類',
  'fbz9dH': '默認產品分組',
  'STmIBX': '是否妥投',
  'nxPf1g': '訂單履約場景為FBA轉倉-VC訂單或FBA轉倉-非VC訂單時，為確保您的貨物能夠準確交付，請在預約時填寫ARN信息，並要求供應商在提貨時出示ARN。若供應商在提貨時無法提供有效的提貨碼信息，倉庫將無法完成交貨。',
  'fczSMH': '近30天倉儲費',
  'A3v8+M': '部分國家適用',
  'HYjlvY': '組套關係適用範圍',
  'yn0Z1T': '全部國家適用',
  '+UQ2eB': '超出視頻保存期限後無法在線下載視頻，您若是需要長期保存視頻需要下載到本地電腦端。',
  '2j7A41': '庫內視頻查詢任務通知',
  'CkgJHS': '還剩 {seconds}秒',
  'LCaGPE': '無效時間',
  'PAXSjK': '視頻保存時限(天)',
  'ewjsQ3': '還剩 {minutes}分 {seconds}秒',
  'nFv12a': '還剩 {hours}小時 {minutes}分 {seconds}秒',
  'nbY55F': '還剩 {days}天 {hours}小時 {minutes}分 {seconds}秒',
  'rLegUs': '還剩',
  'umzznh': '是否已完成視頻查看/下載',
  'IoKeBc': '未完成視頻查看/下載',
  'ZWDLuK': '客戶在線查看/下載視頻狀態',
  'eyh8B0': '已完成視頻查看/下載',
  'g0zndJ': '未完成',
  'mdXvfZ': '視頻文件僅在有效保存期內開放下載，逾期將關閉下載權限。如需長期保存請在有效期內完成本地備份。',
  'uEOZtc': '本功能用於臨時鎖定銷售庫存，防止被其他訂單占用。{break}鎖定後，系統將凍結對應數量的庫存；釋放後，庫存將恢復為可用狀態。{break}請務必在釋放後及時創建出庫單，以避免該部分庫存被其他訂單分配。{break}<red>請注意：此操作僅凍結庫存數量，不會指定或鎖定倉庫中的具體實物及庫位。</red>',
  'DM3pHW': '視頻處理SLA',
  'UM4UnF': '多個關鍵詞需換行或用英文逗號隔開,最多支持{num}個,雙擊切換到單個查詢',
  'j8igBS': '超出了 <remaining></remaining> 個商品條碼',
  'lcAMwu': '還有可以輸入 <remaining></remaining> 個商品條碼',
  'ovsuH1': '最大支持輸入{maxSku}個訂單,多個訂單用分號隔開或者換行輸入',
  't2OPU9': '質檢編碼',
  '45lH3G': '最大支持輸入{maxSku}個商品,多個商品用分號隔開或者換行輸入',
  'pNyaJv': '視頻處理目標完成時間',
  'Fxyurl': '如RT單號內有超過5個商品，建議填寫商品條碼,否則視頻時間太長，導致拉流失敗；最大支持輸入{maxSku}個商品，多個商品用分號隔開或者換行輸入。',
  '89V9jv': '<strong>說明：</strong>{break}1、當前視頻功能暫僅支持查詢*出庫打包、退貨質檢"環節。{break}2、出庫打包環節：截至目前支持查詢的國家和倉庫有:美國、英國、DEBR2倉。不支特查詢的國家和倉庫有:澳大利亞、加拿大、DEBR倉。{break}3、退貨質檢環節：截至目前支持查詢的倉庫有：USKY3倉、USKY5倉, {break}4、若系統未能成功查詢到視頻,請您直接聯系客服/客戶經理,我們將為您及時處理',
  '+jm37H': '請輸入Rithum賬號',
  '1rwX6s': 'Rithum賬號',
  'ASwJRg': 'Client Secret',
  'FfoP3r': '請輸入Client ID',
  'LZtUTs': '請輸入Client Secret',
  'U5+MBC': 'Client ID',
  'Z6U+rH': '請輸入備註信息',
  'pSlZth': 'Token有效期',
  'vDYlCJ': 'eBay訂單號ID',
  'z5aOWE': 'Rithum商品ID',
  'L/pf+d': '拆單後系統無法上傳跟蹤號，需要手工上傳跟蹤號',
  'Bo7i+/': '創建視頻下載任務',
  'CJkoZ/': '質檢視頻',
  'PVQZGn': '最終處理方式',
  'akHEml': '是否執行特殊打包還原',
  'apn9Xp': '整體照片',
  'OWchTO': '店鋪年營業額',
  'S1M0+D': '德國（Germany）（EUR）',
  'lx500t': '國內（China）（RMB）',
  'TP2mcZ': '全球（Global）（USD）',
  '3/Oz1Q': '訂單：【{orderIds}】為平臺面單發貨，不允許合單',
  '4HJ+hu': '不同步庫存',
  '6M9rWS': '查看未發貨訂單',
  'Boxv3o': '平臺倉庫id',
  'Bpo42k': '萬邑通倉庫',
  'Cp9jJx': '請輸入1~100的正整數',
  'D+aqEf': '請輸入0~1000000的正整數',
  'Fx2qpm': 'Tiktok平臺數據授權與免責協議',
  'Hd8vWP': '倉庫庫存數量 X',
  'JXyArZ': '倉庫匹配',
  'PAK8Nq': '閱讀並同意',
  'PaIEXA': '同步倉庫實際庫存',
  'RI3DFS': '確認簽署',
  'SQfl8g': '《TikTok平臺面單免責協議》',
  'V7Hm5N': '安全庫存設置',
  'VKrL6o': '物流成本最優',
  'ZFAL2b': 'Tiktok平臺面單出庫的訂單，不使用選擇的發貨方式，以平臺提供的發貨方式為準。',
  'bGcjx4': '庫存同步數量',
  'cZA4KD': '同步固定值',
  'gBPBiQ': '目前僅支持 eBay、eBay eF、Temu、AliExpress、Shopify、Shein、Amazon(MSF)、Tiktok平臺配置規則。其余平臺將陸續開放，敬請期待!',
  'ie/swL': '確定重試嗎？',
  'kMFVJj': '物流時效最優',
  'pR5Kts': '重試',
  'qUjxg7': '平臺面單物流服務',
  'qvnXLa': '平臺面單類型訂單和普通訂單不允許批量發貨',
  'rbvotq': '當庫存推送數小於等於',
  'sZjg8x': '訂單產品不一致，不允許批量操作',
  'uLJq8F': '臨界庫存同步',
  '+P419K': '倉庫編碼資訊',
  '+xf5LH': '1. WINIT 版本：WINIT 收集的倉庫地址庫。{break}2. 客戶自訂版本：若發現 WINIT 地址庫不足或不正確，客戶可新增或修改為自訂版本，經 WINIT 核實後可變更為 WINIT 版本',
  '/VFVLw': '保險',
  '0xNKc0': '預約通知',
  '12KbCB': '倉庫類型',
  '1RHbXm': '請填寫正確的電話號碼',
  '1n00Pf': '妥投前補充',
  '2wyrYZ': '全部停用',
  '2xmNc6': '全部啟用',
  '3/G8js': '提交方式',
  '5HuwKj': '查看倉庫地址',
  '5WPh1K': '收貨詳細資訊',
  '6DlX5w': '滿足以下條件時，將依下列預設的預設值選取加值服務，並預選服務要求{break}包裹類加值：包裹內任一商品符合條件，下單時依預設設定預選加值服務。{break}棧板類加值：棧板內任一商品符合條件，下單時依預設設定預選加值服務。{break}訂單類加值：訂單內任一商品符合條件，下單時依預設設定預選加值服務',
  '6V8ZWK': '加值處理對象',
  '6fmxsV': '請務必於妥投前至【海外倉 > 出庫 > 訂單處理】頁面補充文件，否則可能導致妥投失敗',
  '8NfVgn': '尾程派送必備資料',
  'FMruey': '修改為 WINIT 收集的地址',
  'FUE1Xh': '切換至 WINIT 版本',
  'FVnYDW': 'WINIT 收集的倉庫編碼庫',
  'HCqQh3': '簽收',
  'IfNpby': '倉庫地址維護操作指引',
  'JNA7rx': '是否確定關閉加值服務啟用設定？關閉後預設所有加值服務皆可使用。',
  'JpUbUj': '加值服務啟用設定',
  'OTr06+': '前往第一步修改',
  'Pnu7pK': '倉庫聯絡人資訊',
  'QEvtRI': '客戶自訂',
  'QVos5P': '請選擇加值服務',
  'RK6igF': '第 {number} 份',
  'T4UDYW': '僅支援 PDF 格式',
  'UAGX0o': '請填寫小於 11 位的數字',
  'UCi1ha': '加值預設值',
  'V9pblS': '僅支援字母（大小寫）、數字、連字號 (-)、底線 (_)',
  'VEeyMn': '新增倉庫地址',
  'XwddT+': '倉庫資訊',
  'ZqGdmU': '請填寫文件中條碼對應的包裹標籤號。',
  'ahJ0bo': '目前為 WINIT 收集的倉庫地址資訊，修改後將儲存為客戶自訂版本。後續將使用自訂版本，WINIT 將核實您修改的內容，若核實無誤，將納入 WINIT 地址庫。',
  'btwTap': '資料名稱',
  'cGw/dK': '是否確定開啟加值服務啟用設定？開啟後可針對不同加值服務設定是否啟用。',
  'eW0mE7': '物流單據號',
  'fFdCB/': '保留自訂版本',
  'hOuetV': '補資料狀態',
  'k52nEU': '平台倉地址管理',
  'l+s9v9': '規則條件',
  'lAXhml': '直接提交必須上傳文件',
  'lZc15H': '重要須知：平台倉庫地址資訊由 WINIT 收集提供，僅供參考。請務必於下單前登入平台賣家後台核對官方地址，如有不符，請新增自訂地址。',
  'oQcYUf': '清關',
  'p1foSY': '請選擇提交方式',
  'pSzJbd': '同一加值服務符合多條規則時，下單將依優先順序最高的設定預選加值服務',
  'q+bzsZ': '請輸入倉庫編碼',
  'qEa+3w': '適用訂單履約場景',
  'qd0uEq': '選擇',
  'qfegYk': '加值服務的預設設定',
  'qnV5+U': '查看操作指引',
  'qyWbSL': '填寫公司名稱後，【尾程派送必備資料】可能會發生變化，請確認後再提交訂單。',
  'vRzyZ4': 'WINIT 預設',
  'vpLMUD': '平台類型',
  'wU0X4a': '清空公司名稱後，【尾程派送必備資料】可能會發生變化，請確認後再提交訂單。',
  'x3DxSw': '要求',
  'xbgk/K': '倉庫所在國家',
  'xvTd17': '無需修改，繼續提交',
  'yEdgdM': '提交方式：',
  'zHkAhj': '請務必於出庫前至【海外倉 > 出庫 > 訂單處理】頁面補充文件，否則倉庫將不會執行出庫',
  'xYVdAi': '當同一增值服務同時命中多條規則時，下單時將按優先級最高的規則配置進行預選。',
  'KeVFuf': '我們為您提供了自訂偏好的增值服務設定功能，您可以根據自己的需求選擇不同的增值服務內容進行設定。',
  '/zb/9N': '自定義增值啟用設置',
  'gt+BYr': '自定義增值默認設置',
  'Iblz/N': '同時滿足以下條件時執行規則',
  '/6D15a': '<strong>第一步 檔案命名＆打包</strong>{break}<s>將您需上傳的檔案命名後，壓縮打包上傳；也可直接選擇檔案上傳。</s>{break}<a>注意：檔案名稱不可重複。</a>',
  '1e+lfh': '單個檔案上傳',
  '2VaUeR': '共上傳失敗{count}個檔案。請修改後重新上傳～',
  '2sc1lw': '<strong>第二步 選擇檔案類型</strong>{break}<s>整理相同類型的檔案進行一鍵上傳。（如：FCC 證書、FDA 證書、MSDS）</s>',
  'CMk7q2': '請輸入檔案類型',
  'DVfUAF': '<strong>第三步 上傳壓縮檔／檔案</strong>{break}<s>點擊上傳檔案／壓縮檔，並點擊解析檔案。（或框選多個檔案）</s>{break}<a>注意：僅支援上傳一個壓縮檔或多個檔案，不可混合上傳。</a>',
  'DatzNt': '壓縮檔僅支援上傳一個',
  'G+kKIz': '檔案大小請勿超過 100MB',
  'GJD8OT': '僅支援上傳一個壓縮檔或多個檔案，不可混合上傳',
  'KKrGjP': '批量檔案上傳',
  'Oww89Y': '上傳中',
  'R8Yt/D': '上傳失敗',
  'a8yr7M': '解析檔案',
  'b5UHNR': '點擊上傳檔案／壓縮檔',
  'ffS1Wg': '檔案名稱不可重複',
  'j20JY3': '多個檔案上傳，最多支援 100 個',
  'jESzgk': '共上傳 {total} 個檔案，其中成功 {success} 個，失敗 {fail} 個。請修改後重新上傳～',
  'jWpBuZ': '共成功上傳 {count} 個檔案。',
  'vH0KYs': '正在解析檔案，請稍候～～',
  'hYiq/5': '已上傳其他檔案，不可再上傳壓縮檔',
  'uHyP+I': '已上傳壓縮檔，不可再上傳其他檔案',
  'Powhxj': '支援 jpg、jpeg、png、pdf 格式檔案；如選擇多個檔案上傳，最多支援 100 個{break}壓縮檔最大 100MB，支援 .zip 格式',
  'MLfjNu': '確認刪除所選的檔案嗎？',
  'rsjPmA': '請選擇要刪除的檔案',
  '/8l7B/': '申訴費用項',
  '0+AICR': '審核結果',
  '06gaSA': '發起訂單費用申訴',
  '1ccOSo': '承運人',
  '4PD/Ca': '確認復測數據',
  '52epuj': '點擊查看《2026萬邑通標準海外倉入庫禁限運清單》',
  '5uo0iz': '請上傳尺重圖片',
  '7eFbwy': '請先選擇申訴單',
  '8k2AYo': '尺寸（長*寬*高（cm））',
  'AgNSLU': '處理資訊',
  'AiPEqG': '目標更新時間',
  'B5G8Q/': '費用項幣種',
  'BkrrAn': '申訴結果',
  'DqjMgY': '商品-寬',
  'L2f/fL': '<strong>說明：圖片格式支援png、jpg、jpeg每個類型最多支援上傳一張圖片</strong>',
  'NgvUpD': '請輸入大於0且最多2位小數的數字',
  'OvzMGf': '出口申報價值：指向出口國海關申報的貨物交易價格。{break}該價格通常是貨物在出口國出口時的實際銷售價格。{break}舉例：中國工廠出口一個商品，成本￥80，境內運費￥5，利潤￥15，則該商品的出口申報價值=80+5+15=￥100',
  'PVQpzu': '批量提交草稿',
  'RzFgS0': '批量建立草稿',
  'UItCWS': '請確認或重新發起商品複測',
  'YVowea': '已提交供應商',
  'Zv76CL': '禁止入庫商品',
  'avSJC2': '僅草稿狀態操作',
  'dPvdln': '商品-重量',
  'eODzg7': '進口申報價值：指向進口國海關申報的貨物完稅價格。{break}該價格以貨物的成交價格為基礎，並應當包括貨物運抵進口國起卸前的運輸及相關費用、保險費。{break}舉例：一個商品從中國運至美國，貨物成交價：12.8USD，國際運費：1.5USD，保險費：0.2USD，則該商品的進口申報價值=12.8+1.5+0.2=14.5USD',
  'fgri9f': '申訴單號',
  'fr3ntC': '<strong>申述說明：</strong>{break} 1、當前訂單費用申訴僅支持尾程附加費。；{break} 2、尺寸類附加費申訴-系統自動查詢最近3個月內最新的商品複測信息,勾選確認是否使用該複測信息进行申訴(如不認可複測數據,請重新發起商品複測)<a1>發起商品複測</a1>；{break} 3、尺寸類附加費申訴-無可用庫存商品進行複測情況下，需手動填商品真實尺重和上傳對應圖片，需手動填寫時商品的尺寸+重量信息和尺重圖片都必填；{break} 4、包裝類附件費-需手動填商品真實尺重和上傳對應圖片，需手動填寫時商品的尺寸+重量信息和尺重圖片都必填；{break}',
  'hvBg88': '複測重量（kg）',
  'iBcg3T': '說明: {break}1.批量一次最多建立200單草稿單。{break}2.建立後請先在草稿頁確認當前所選的商品複測資訊是否認可，不认可請重新複測商品後，再重新申訴。{break}3.系統自動查詢最近3個月內的最近的商品複測資訊，如不认可當前複測資訊請重新複測商品後再重新提交申訴。{break}4.無庫存商品進行複測情況下，需手動填商品真實尺重和上傳對應圖片，無法批量建立草稿。{break}',
  'iLafuf': '申請單號',
  'ip5cx2': '您好，當前帳號未簽署《銷售包裝商品海外倉免責協議》，不允許銷售包裝直接出庫，若需請前往<a>[個人中心-服務與合同]</a>中簽署此協議。',
  'kOn88E': '商品-高',
  'mMV/jz': '複測重量（cm）',
  'mSN2yH': '沒有查到訂單號，請重新輸入跟蹤號！',
  'pnBgir': '尺重圖片',
  'tx48V6': '商品-長',
  'u80eLf': '複測尺寸（長*寬*高（cm））',
  'weyGoU': '費用項金額',
  'wgyfWx': '流轉記錄',
  'xf0qAj': '批量提交草稿尺重類費用類型的申訴單將默認使用當前系統獲取的複測數據，請確認當前的複測數據是否與您需要提交申訴的商品長寬高重一致',
  'zfds0r': '批量建立草稿檔案',
  'zw7iku': '訂單補收時間',
  'DEQRoM': '僅看',
  'yfYA0b': '不看',
  '7/ENeL': '庫齡段內最大庫齡',
  'BHZZaE': '數據分析模式為T+1,不支持查詢當天數據',
  'Uh/9e9': '導出SKU每個倉庫的庫齡分析明細',
  'g+nQhV': '導出SKU國家級匯總的庫齡分析明細',
  'l8Ee+W': '統計分析日期',
  '5/sVZa': '註意：打托及裝箱結果為算法測算值，倉庫實際打包情況可能存在差異，最終以實際打包結果為準。',
  '7IJ5BW': '展開全部',
  'MmLF/d': '當前配置的打托限製，支持下單時選擇打托尺寸限製',
  'Pvsnbq': '收起全部',
  'f4xheU': '面單校驗失敗，訂單已作廢',
  'kJQBzE': '註：若所選 SKU 為 「箱產品」，禁止在表格中填寫裝箱信息，系統將依據該箱產品對應庫存單元的標準箱件數進行出庫',
  'lu8rjz': '裝箱作業遵循<span>」箱產品/原箱「優先出庫</span>原則。即貨物入庫時的原箱將作為出庫時的首選方式；若無原箱，則按散件重新裝箱出庫。',
  'pTNeVB': '{break}請註意：允許多SKU混裝，將按照裝載率最優原則裝箱。因此，每個箱子都可能裝有多個SKU。',
  'xS397O': '限製類型',
  'EuX4xu': '通過以下裝箱策略生成裝箱方案後，包裹數量可能發生變化，系統已清除批量導入時上傳的補貼包裹條碼增值服務，請在確定裝箱方案後重新選擇補貼包裹條碼增值服務並上傳文件。',
  'GgxSpv': '下單偏好：打托策略及規則',
  'hetIOa': '系統已清除批量導入時選擇的加包裝方式，請在以下裝箱策略中重新選擇包裝方式。',
  '+y6h2D': '密碼必須為6-32位，且包含字母、數字或特殊字符中的至少兩種',
  '5mxOVM': '<strong>溫馨提示：</strong>修改密碼不影響已經授權的第三方應用使用，為了您的資金和信息安全，如您已授權其他應用，成功變更密碼後，請前往-個人中心-<a1>獲取Token</a1>，進行Token更新。',
  'OKlhp/': '原密碼',
  'TAdFnk': '確認新密碼',
  'YcmSjW': '請輸入新密碼',
  'cBEBNV': '密碼修改成功，請重新登錄',
  'siMfC6': '請輸入原密碼',
  'H1lPwr': '密碼格式錯誤',
  '0vQ+P7': '衡量貨物到倉後（訂單有到倉記錄）在目標卸貨日期內完成卸貨掃描的比例',
  'DKVSAG': '衡量貨物到倉後（訂單有到倉記錄）在目標上架日期內完成上架的比例',
  'MtH1Jn': '衡量貨物卸貨後（包裹有掃描記錄）在目標上架日期內完成上架的比例',
  'Sasajn': '衡量貨物卸貨後（包裹有掃描記錄）在目標時間內完成退貨處理的比例',
  'mq0IED': '衡量在實際出庫日期範圍內，錯發漏發訂單占實際出庫訂單的比例',
  'nVDQvd': '衡量貨物下單後（訂單狀態為：出庫確認）在目標出庫日期內完成出庫的比例',
  'r1W38P': '衡量貨物下單後（訂單狀態為：出庫確認）在應完成暫存時間內完成暫存的比例',
  's4iMkY': '衡量貨物下單後（訂單狀態為：出庫確認）在目標出庫時間內完成出庫的比例',

  'w+Hm5T': '异常單[{eventNo}]已經提交過標準增值單[<a>{orderNo}</a>]且為草稿狀態，請從草稿增值訂單繼續創建增值！',
  'WAZY5Z': '根據中國相關法律法規及監管要求，通過富友支付渠道進行的交易數據，可能會被同步至中國稅務機關和中國外匯管理部門。請您理解並配合相關稅務及外匯合規要求。',
  '9ybqTC': '主賬戶賬單欠款100USD,子賬戶無欠款且有餘額，在賬單還款節點，會自動從子賬戶轉入100USD到主賬戶用於賬單還款。',
  'BfY6zk': '我已知悉並確認',
  'b6Ftgn': '若您的欠款賬戶主體無法充值，系統會在賬單還款節點自動進行平賬還款處理，若您不想平賬還款，請在賬單自動還款前使用欠款賬戶主體進行充值還款。',
  'c+6Mcc': '平賬還款後，主賬戶賬單欠款還清',
  's66VWi': '案例',
  'hEw5Zd': '賬單欠款',
  'iJEe/7': '平賬還款通知',
  'pHsWN7': '自動購匯優先級',
  'rJHovg': '進行還款操作，處理完畢後，賬單預估待還金額將自動更新。不同賬戶之間會進行跨賬戶還款。',
  'olAL8z': '上傳格式僅限於jpg, gif, png, jpeg, pdf, doc, xls, csv, docx, xlsx',
  'Jb9xrm': '若您不希望觸發跨賬戶平賬還款，請在賬單自動還款前，使用對應欠款賬戶的主體完成充值並還款。',
  'P7F6p5': '即日起取消“擔保還款”，啓用“跨賬戶平賬還款”，對同時存在餘額與欠款的賬戶：會先進行內部購匯實還；實還後仍有餘額，會自動用於歸還其他欠款賬戶。',
  'mtnGvg': '跨賬戶平賬還款通知',
  '8QYba6': '商品編碼，按兩下切換到批量査詢',
  'CTSFb2': 'LPN碼退倉默認增值',
  'EmoOE5': '無增值服務～',
  'yvrcJY': '掃描LPN碼',
  '3hr4e+': '亞馬遜移除單LPN碼退倉處理偏好',
  'kgwERZ': '<title>當您啟用【亞馬遜移除單LPN碼退倉處理偏好】，WINIT將根據您維護的偏好規則自動下發增值服務，規則的優先順序為：商品級偏好>客戶級偏好</title>{break}<title>請注意：</title>{break}<span>只有實物上貼有LPN碼的貨物，WINIT才會執行增值處理並收取相應費用</span>{break}<span>實物上沒有粘貼LPN碼的貨物將正常上架，不受影響</span>{break}<title>若您未啟用該偏好設定，則所有貨物將默認直接上架，不進行任何LPN碼相關的增值處理。</title>',
  'kEZSHt': '請輸入2~9999的正整數',
  'K/rVnU': '庫存調整單拆箱商品逐件清點',
  '2PjyVY': '測量後重量(kg)',
  '3PU34C': '測量前長*寬*高(cm)',
  'DM58vT': '測量後長*寬*高(cm)',
  'LFF3YN': '商品尺重来源',
  'nOswfr': '測量前重量(kg)',
  'JIjYxo': '點擊設定',
  'f+w9o7': '平臺指定發貨倉庫',
  '9i33Yv': '抽验后商品尺重信息',
  'ANUUVO': '该入库标签特征仅支持满足以下条件的SKU进行下单：{break}1、SKU的商品包裹类型=A+包裹/A包裹；{break}2、SKU出库是否采集包裹码=否；{break}3、SKU批次管理类型≠保质期管理/生产批次管理；',
  'c9QG6o': '抽驗前商品尺重資訊',
  'kaQdAy': '批量下載圖片',
  'OCL2Hd': '抽验服务单',
  'rF6BoJ': '登記時間',
  'rWkOBK': '服務單狀態',
  'x5w3KZ': '下載圖片',
  'xgsqna': 'SKU尺重是否超過誤差範圍',
  'K/8VsZ': '無圖片',
  '1v4cYx': '建立庫存組織',
  'Xkr/pI': '<font>【100% A+/A包 無包裹條碼入庫】規則聲明</font>{break} 為確保服務高效執行，請在建立入庫單時嚴格遵守以下「一對一」規則：{break} <font>一、預約要求：</font>同一預約單內，單個SKU僅限對應一個入庫單。請勿將單一SKU拆分至多個入庫單 或 預約單；{break} <font>二、快遞要求：</font>同一快遞單號僅限對應一個入庫單，入庫單必須維護快遞單號，否則到倉將無法識別。{break} <font>三、箱規要求：</font>同一預約單/入庫單內，單個SKU僅限一種箱規。{break}{break} <font>👉 核心原則： 一SKU一單 / 一SKU一箱規 / 一快遞單號一入庫單號</font>',
  'W2Q4xC': '請先選擇操作環節',
  'YetEPs': '是否提交索賠',
  'c3ZveH': '調查目的',
  'UWnDgh': '選擇"是否提交索賠"時，需選擇創建時間範圍，且日期範圍不能超過[31]天',

  '9Zelye': '請輸入0~1區間的數字，最多保留兩位小數',
  'MrxaHb': '固定值',
  'QKkbFX': '請輸入誤差範圍',
  'QPW4nT': '誤差範圍',
  'UiYhnn': '誤差範圍類型',
  'WNgP0R': '倉庫稱重重量(kg)',
  'fLVutH': '入庫包裹稱重誤差範圍偏好',
  'qqtFhJ': '請輸入0~10區間的數字，最多保留兩位小數',
  'saDtih': '百分比',
  '5eqsQ4': '開啟該偏好設定後，您可自定義入庫包裹的稱重誤差範圍。貨物到倉後，系統將自動比對倉庫實稱重量與包裹驗貨重量；若差值超出您設定的誤差範圍，系統將自動登記該包裹為稱重異常，您可提交增值服務申請處理該異常。',
  'VGwJX0': '備註：目前萬邑通並非所有倉庫均支持包裹流水線稱重服務，具體支持該服務的倉庫清單，您可聯繫客服諮詢獲取。',
  'TbsaPf': '批次庫存重要提示：',
  'U7FwM7': '當前系統僅記錄<strong>訂單級的批次資訊</strong>，未記錄包裹與批次的對應關係。{break}若您執行拆單，原訂單的批次資訊將分攤至新訂單中，<strong>因此新訂單中記錄的批次資訊可能與實物批次不一致。</strong>{break}<strong>請注意：</strong>發生退貨時，系統將按出庫記錄的批次回庫，進而影響後續的庫存批次準確性及效期管理。{break}<strong>請您確認：</strong>{break}<checkbox>我已充分知悉上述情況，並自行承擔由此帶來的庫存管理風險。</checkbox>',
  '+h2y9F': '所選子訂單[{shippingNos}]的容器類型包含托盤、包裹等多種類型,無法合並處理,請調整後重新提交',
  'ifPB9z': '按單號合並處理',
  '/fR/9R': '尺重類',
  '0w8AQY': '包裹尺寸（長*寬*高（cm））',
  'Az+wsj': '申訴費用類型',
  'IvBH95': '確定刪除當前申訴單嗎？',
  'ZXxh9p': '確定批量刪除選中的申訴單嗎？',
  'k/Fdcc': '包裝類',
  'u7l5xi': '批量刪除草稿',
  'wrq36m': '當前申訴單申訴要求已發生變化,將為你刷新申訴數據,請按最新申訴要求提交申訴。',
  'za91kF': '請選擇要刪除的申訴單',
  'h/44mD': '<strong>申述說明：</strong>{break} 1、當前訂單費用申訴僅支持尾程附加費；{break} 2、尺重類附加費申訴，系統自動查詢最近12個月內最新的商品復測信息，勾選確認是否使用該復測信息進行申訴(如不認可復測數據，請重新發起商品復測)<a1>發起商品復測</a1>；{break} 3、尺重類附加費申訴，當無可用庫存商品進行復測或一個包裹包含多個商品的情況下，系統將自動查詢出庫時包裹的尺重信息進行申訴。{break}',

  '7jPRVd': '根據比例計算推送數為小數時將向下取整。請註意臨界值的庫存同步數量。',
  'Bg7ijV': 'FBM退貨單報告每天更新{pullCount}次，僅更新{pullFrequency}天內報告。最新更新時間{pullDate}',
  'FHACGw': '{platform}平臺每30分鐘同步一次',
  'HdmoCU': '解決方案',
  'cDiSfJ': '平臺退貨單請求時間',
  's+52Wu': '當前數據獲取時間{time}數據僅供預覽，僅展示已完成匹配的萬邑聯商品和相應的平臺商品',
  'sgfWtm': '目前僅支持 eBay、eBay eF、Temu、AliExpress、Shopify、Shein、Amazon(MSF)、Tiktok、Amazon平臺配置規則。其余平臺將陸續開放，敬請期待!',
  'xJyOfr': '平臺{platform}和eBay/TikTok/shopify/Amazon不能同時選擇',
  '2C1sgV': '原商品條碼',
  '2ksSH+': '包裝材料',
  '3m+rLI': '備註不能超過1000個字符',
  '46Zfck': '下載模板',
  '56Mr7j': '請輸入關鍵字',
  '7ZJI4v': '模板更新日期：{date}',
  '92t0OL': '增值分類',
  'D/L2ET': '國內倉增值服務(DWVS)',
  'D24vq6': '確定要取消這條增值服務申請嗎？',
  'DjbRc6': '支持格式：{formats}，單個文件不超過{size}M',
  'FaA57c': 'W補單',
  'Hkp4HH': '線下配送供應商',
  'Jy1MK4': '誠信機製',
  'KWyyzx': '服務報價',
  'L+pJgC': '第三方編碼(拍照)',
  'MTXmQC': '服務定義',
  'Mx0ZLV': '附件格式支持：jpg,jpeg,pdf,xlsx,xls,doc,docx,rar,zip',
  'NCJ4K3': '原M碼',
  'NEW+As': 'WB包裹號',
  'OQxzDl': '補貼商品條碼*補貼商品數量',
  'PaiOKY': '請上傳增值服務附件',
  'Qlp7Vi': '實際完成日期',
  'Rkav/l': '線下配送單號',
  'SLfQbs': '服務類別',
  'TV87OQ': '文件格式限製為jpg,jpeg,pdf,doc,docx,xls,xlsx,zip,rar',
  'TvheV6': '文件格式限製為.xls,.xlsx',
  'VtfDWk': '修改預計完成時間從',
  'WyaP/1': '原M碼-包裝材料',
  'XwamxK': '原商品條碼*原商品數量',
  'Zo/F1x': '增值服務附件',
  'ZujT6m': '您好，您海外倉賬戶可下單余額不足，請先充值再下單。',
  'biNaN+': '實際完成時間',
  'c88ldb': '文件大小請勿超過20M，請壓縮後上傳',
  'd2OCAd': '增值單',
  'd4gxj9': '原入庫單號',
  'ezVhiW': '貨幣',
  'faVuvQ': '預計完成時間',
  'g2suWA': '實際托盤數量',
  'gEdTsX': '附件和備註至少填寫一項',
  'hVrEDt': '倉庫已處理',
  'hg+ipZ': 'FNSKU/第三方編碼',
  'hroK4P': '受理狀態',
  'ja6+IG': '壓縮包不可超過20M',
  'kRVlNZ': '出庫單-SKU-M碼',
  'o4dmMm': 'M碼數量',
  'oIfPYs': '下載增值服務模板',
  'pFR/sR': '<strong>申請範圍（僅針對國內倉增值服務）：</strong>{break} 1. 攬收增值：指您的貨物在WINIT提貨環節需要WINIT安排人員搬運，針對此部分貨物您需要增值操作；{break} 2. 收貨增值：指您的貨物自發物流到WINIT國內倉庫時，需要在倉庫的收貨時間提供的超時收貨增值服務操作；{break} 3. 退貨增值：指您的貨物已經到達WINIT國內倉庫後您需要將貨物退回，針對此部分貨物您需要增值服務操作；{break} 4. 庫內增值：指您的貨物需要國內倉庫提供標簽更換（或清除），重量尺寸復核、商品拍照、銷毀等增值服務操作；{break} <strong>溫馨提醒：</strong>有最低收費的增值服務項，若"單價*計量總數"低於基礎收費的，按基礎收費收取。{break} 具體可受理的增值服務選項及更多的內容，您可以點擊下載：<guideLink>國內倉增值服務說明</guideLink>查閱。{break} 若您需選擇的增值服務項未在此範圍內，請您及時聯系在線客服確認。',
  'pf5GO+': '服務異常單號',
  'pzCFfS': '文件大小請勿超過{size}M，請壓縮後上傳',
  'rkRZDZ': '原包裹條碼',
  'sJAZkX': '服務SLA',
  'vOShGA': '入庫單-集裝箱',
  'vRKqEJ': '服務單詳情',
  'vlAfAg': '補貼包裹條碼',
  'w39+Yw': 'M碼-SKU-數量',
  'xAJEgV': '如有多個文件，請用壓縮的形式上傳，壓縮包不可超過20M',
  'xw+LAO': 'M碼-SKU',
  'Rt7R5q': '非標包材',
  '13hSB5': '登錄子賬戶簽署',
  'qNjqDv': '該帳號暫無權限，請在主帳號【個人中心-角色管理】中開通權限',

  '/Kjec2': '收件人州/省',
  '/gjvWG': '解綁成功',
  '/hIsI9': '計費Winit產品',
  '/swipJ': '發件人VAT',
  '07/CHe': '主聯繫人郵箱',
  '0LH9gq': '導入成功，預計{time}分鐘後完成處理',
  '0yGDMb': '確認發貨時間',
  '1nQ6Q0': '在途中',
  '4ez7K0': '訂單信息不存在',
  '5cSTPo': '已簽收',
  '5gwWsl': '請輸入取消原因',
  '7PWaoz': '系統檢查到已導入過該EXCEL文件，是否強制重複導入？',
  '7pSDDW': '原快遞單號',
  '8hjdXb': '刷新token將會導致原有的token失效，請及時前往ERP、萬邑鏈分銷平台等第三方平台更新授權，否則影響正常的ERP下單等功能。',
  'BPpVvR': '下載失敗數據',
  'C4NBzM': '導出任務已創建',
  'Ce7vZx': '導入失敗數量',
  'Dmtj/G': '請選擇可取消的訂單',
  'Iq4nof': '獲取中',
  'JNnt7j': '包裹條碼地址',
  'KGUCkP': '導入記錄',
  'KdAzze': '下單Winit產品',
  'LT+72I': '感謝使用萬邑通開發者，為了給賣家提供更好得OpenAPI服務，萬邑通已經在2019年3月升級了V2.0的授權模式，修復了V1.0授權模式的漏洞，數據安全性更高，V1.0的版本即將下線，請及時升級為V2.0',
  'Oi8z2o': '確認並刷新',
  'OqW32/': '退貨包裹信息',
  'PSAuem': '最後一次請求時間 (created)',
  'PZl5gn': '修改人',
  'SFuc4p': '是否ReturnLabel',
  'SG9nY5': '註冊手機號',
  'SMp/wI': '收件人地址2',
  'SqYZf7': '收件人地址1',
  'TI/7v4': 'Token刷新成功',
  'Ti/ykE': '下載DG文件',
  'Tq9B8M': '確認出庫',
  'U/PBbo': '應用 (Platform)',
  'U12LPk': '供應商快遞',
  'WArcN1': '<fw600>注意</fw600>: {break}1.如同一訂單有多個包裹，則相同sellerOrderNo的多行包裹信息將被合併到一個訂單中。{break}2.如同一包裹有多個商品，則相同parcelNo的多行商品信息將被合併到一個包裹中。{break}3.請上傳已填寫商品信息的XLS、XLSX格式模板。{break}4.文件大小上限10M，單次最大導入5萬行數據，如文件過大，請拆分成多個文件上傳，謝謝配合。{break}',
  'XgAe2+': '批量導出面單',
  'ZQQMPa': '投遞失敗',
  'aBZwNm': '共{total}個，成功{success}個，失敗{failed}個，獲取中{obtaining}個',
  'ab/bzw': '請選擇已下單狀態的訂單',
  'b9hLXj': '當前Token',
  'bLeaYX': '點擊下載《導入模板》',
  'blFOFv': '批量導出訂單',
  'eiF6p5': '文件大小不能超過10M',
  'fWgRNR': '發件人EORI',
  'fha7dM': '請求賬號 (app_key)',
  'hY87MC': '返回主訂單信息',
  'jgn9zI': '取消信息',
  'kLKiKo': '手機號驗證',
  'mnKvul': '失敗列表',
  'pgJo0v': '最後一次調用時間',
  'q2ri9c': '單次最大導入5萬行數據。{a}',
  'qnt35F': '取消結果',
  'r+H/+u': '申報英文名稱',
  'sT8cX0': '導入成功數量',
  'se42so': '請先上傳文件',
  'tYYS5g': '軌跡地址信息',
  'uH+8Ls': '驗證碼已發送',
  'uLKavV': '刷新Token',
  'xF3rQS': '修改內容',
  'xHrvKs': '批量確認出庫',
  'yzVagq': '文件大小上限10M，單次最大導入5萬行數據',
  'zG0cS1': '打印結果',
  'zcrIG3': '郵箱驗證',
  '/bblSw': '*請填寫針對該異常所提交的增值服務單流水號，如您還未提交增值服務請{break}<a>點擊此處</a>跳轉至增值服務頁面提交增值服務後填寫增值服務單號。',
  '/dO0Zh': '發票號，雙擊切換到批量查詢',
  '6qp+Kh': '發票還在生成中，請稍後再下載',
  'Z6i0fj': '共{total}條記錄',
  'eIUAml': '轉入方VAT',
  'f5YTQ8': '發票{invoiceNo}還在生成中，請稍後再下載',
  't//uHV': '轉出方VAT',
  'tWahWO': '請選擇需要下載的發票',
  'v20n+9': '最多支持{num}個查詢，當前{curlength}個查詢',

  '7iY70N': '存在格式不正確的郵箱：{emails}',
  'WiV6jm': '請輸入郵箱地址',
  'd9Uwtz': '最多支持輸入10個郵箱',
  'daJRgP': '當申訴單狀態發生變更時，將向以下郵箱發送通知：',
  'um8Poz': '郵箱設置',
  'x9rnrD': '請輸入郵箱，支持輸入多個郵箱，多個使用英文逗號分隔',
  '8KzClh': '<bold>溫馨提示：</bold>{break}僅支持查看近一個月的日誌記錄',
  'T9ePA4': '下單失敗原因',
  'sDKJow': '下單結果',
  '6HyNip': '分攤後單個商品體積CBM',
  '8Bk/YO': '貨物物理形態',
  '91i84+': '單件嵌套增量尺寸{unit}',
  'AES1eq': '單件嵌套增量尺寸',
  'AN/RCB': '自定義庫存屬性',
  'BN5b0w': '下單時指定分配',
  'KHtG0z': '文件不足需補充？<a>去上傳></a>',
  'KynRtO': 'WINIT批次',
  'L4saUx': '庫位體積',
  'Tc8oZC': '支持jpg, jpeg, png格式文件；如選擇多個文件上傳，最多支持100個{break}壓縮包最大 100MB，壓縮包支持.zip文件',
  'USpNz6': '嵌套示意圖',
  'g5/oeV': '文件格式限制為jpg,jpeg,png,zip',
  'gqm/zX': '是否支持嵌套',
  'hWycP/': '嵌套方向',
  'r9C7Fo': '庫位數量',
  'wkw7IC': '示意圖類型:',
  'xFDeT3': '#吊牌商品',
  '6joCxB': '汽摩配商品',
  'GBjJpf': '輪胎',
  'enruIK': '一級特殊品類',
  'v3Rbes': '二級特殊品類',
  'CIpP+n': '單件佔用體積 × 商品件數',
  'EFcehB': '單件商品的實際尺寸體積(長×寬×高)',
  'FVlbv8': '文件最多選擇{maxCount}個',
  'L4WfIN': '單件佔用體積',
  'RbUaBU': '單件商品體積 × 商品件數',
  'ZpfNBt': '計費總體積(CBM)',
  'ahWSuC': '單件商品體積',
  'fKRO0W': '若未達到最小計費體積，僅在最高庫齡段按[SKU最小計費體積]，其他庫齡段為0；{break}若達到最小計費體積，則等於佔用總體積。',
  'hLf5JI': '商品總體積',
  'iVsoMZ': '1.普通存儲：單件商品體積；{break}2.嵌套存儲：該SKU同屬性/批次的所有庫存佔用的庫位體積/商品件數',
  'puDJsX': '佔用總體積(CBM)',
  'wRZzeg': '嵌套商品單個商品體積分攤明細',
  '+zFuPB': '最多只能新增10條數據',
  '31gOZg': '確定生效?',
  '3aUs7u': '出庫數量大於組織庫存可用數量',
  '7LDk4s': '支持最多創建10個自定義庫存屬性',
  '8ShkGV': '是否啟用自定義庫存屬性？',
  '8YT1ZR': '檔案名稱（含後綴）過長，最大長度為128個字元',
  'GYK7aF': '自定義庫存屬性名稱',
  'H7i3dw': '字元長度不超過20位',
  'NRcfui': '合計出庫數量',
  'QC5nqj': '請輸入批次號',
  'RKMg83': '批量修改自定義分類庫存屬性',
  'TpQ4Z2': '自定義分類庫存屬性',
  'Y0FWdh': '已上傳{count}/{total}個檔案',
  'YJckwc': '開關用於控制是否啟用自定義庫存分類功能，開啟後可為商品設置不同屬性值進行精細化庫存管理。',
  'YQYqch': '沒有模板檔案',
  'knmGbF': '支持修改自定義分類庫存屬性的訂單列表',
  'ksIiO+': '系統為每個自定義庫存屬性自動生成的唯一標識，格式為CIA+兩位數字（如CIA01），用於區分不同屬性值。',
  'rY/OTa': '自定義庫存屬性CODE',
  '8f3Q/+': '轉出方和轉入方不能相同',
  'JpSsbk': '請先上傳商品資訊',
  'K4c0o9': '請選擇轉入方',
  'h/Hllz': '請選擇轉出方',
  'zJnAnC': '檔案中未解析到有效商品資料',
  'C0R9tL': '請<a>點擊此處</a>下載箱單資訊模板。',
  '3GPqgs': '結算帳戶ID',
  '3ddBdi': '渠道商主帳戶',
  '5uMoeS': '結算帳戶名稱',
  '9tuJMY': '渠道商子帳戶',
  'Mb7YiT': '處理日誌',
  '63a55U': '經營類型',
  'ICk0T+': '下載提貨憑證',
  'ZUlm9o': '注意：為確保您的貨物能夠準確交付，請及時將提貨碼告知您的服務商，並要求其在提貨時出示提貨碼。若服務商在提貨時無法提供有效的提貨碼資訊，倉庫將無法完成交貨。',
  'xzJES5': '審批通過',
  'Ln4xjm': '審批不通過',
  'Ud1aVE': '待交貨',
  'sYItjX': '已提貨',
  'RcmOHt': '提交補增值',
  'lgIr5X': '不加包裝（原包裝出庫）',
  'yBUeMr': '訂單發貨憑證',
  '+6Oqq8': '多倉整櫃調撥',
  '/1UKIF': '尾程總運費',
  '/8GfsH': '四',
  '/9tj9L': '匯入檔案名稱',
  '0M0TxV': '3)直發訂單預約未到倉：直發訂單預約後未按時到倉，即超出預約送倉日期當天',
  '0uRy1k': '一',
  '0uUXzW': '2.卸貨完成後可提空櫃，實際卸貨時間請在列表中查看；',
  '1ACUbT': '①倉庫有權拒收(特別為整櫃貨物)；',
  '1Azre4': '調撥',
  '1hHAA2': '預約協議',
  '1yOoPu': '預約單集裝箱號修改為【{containerNo}】，將同步更新入庫單的集裝箱號，請確認是否修改？',
  '2658Fp': '最優倉配送單位成本',
  '2F+lpC': '最低保留數量-USWC Group',
  '2mkpp2': '4）直發訂單取消預約違規：',
  '2yeWUE': '6、以上說明及定義若有變動，需以最新版價卡為準；',
  '3OEi4n': '{num}、AU倉庫需Drop整櫃到WINIT海外倉，賣家可在Drop2個工作日後提空櫃!',
  '3Oulgi': '確認更新預約單？',
  '3ePWxW': '尾程總費用',
  '4NqD9g': '已成功',
  '4eiz1r': '當前訂單數量',
  '5Jt3jD': '箱單匯入',
  '5PPi66': '當前預約為增值預約，若已收取增值預約費用，<red>取消後將不會退還</red>，確認取消？',
  '7Byi8m': '預約體積',
  '7ONEE4': '請先選擇櫃型和卸貨方式',
  '7byHbN': '不能超過100個字元',
  '7wqm1H': '灰色表示預約單超出可預約量，請選擇其他時段，如無其他時段或所有時段均為灰色，請選擇其他日期或者提交增值預約',
  '7zmjeC': '最晚調撥日期',
  '88ZQzP': '已為您生成草稿單，因庫存資料在即時變化，請仔細檢查後再提交',
  '8bSe2D': '單倉不調撥',
  '8bV7Eg': '如選擇BC類包裹目的倉群，BC類包裹總重量總體積不能為0；如無BC類包裹，請勿選目的倉群',
  '8ygnMt': '計費重',
  '98snx+': '溫馨提醒：若直發訂單未在預約當天到倉，系統會自動取消預約，後續送倉需要重新預約，否則訂單到倉後將按未預約送倉收取違規費用。若賣家需要送倉，但系統未觸發自動取消預約，賣家可自行取消預約後重新預約。',
  '9R3rKz': '一鍵下單',
  'ATArx7': '所選訂單的目的倉與當前訂單列表的目的倉不一致，請重新選擇',
  'Bbb+xm': '暫無檔案可下載',
  'COPDHA': '集裝箱號應為四位大寫字母+7位數字，請檢查後提交',
  'Cbiwqw': '單倉目的倉',
  'Cu164M': '提前DROP到倉時間指將櫃子DROP到倉庫的時間，不等於預約卸貨時間。',
  'D+06qU': '海運整櫃',
  'DC6Ho0': '2、如是整櫃DROP卸貨，請準確填寫聯繫人、聯繫電話、郵箱等資訊，倉庫將按照聯繫人資訊通知提回空櫃。',
  'DNvJVy': '頭程明細',
  'DOJH5Q': '始發地',
  'DUh2HX': '歷史日均銷量',
  'DYyX3T': '請輸入托盤數量',
  'DrawKq': '2)直發訂單提前送倉：直發訂單已預約，但提前安排送倉（非預約送倉當天），即：送倉日期<預約日期',
  'DybI9o': '最晚下單日期',
  'E4piJY': '箱單匯入成功',
  'EmwQQW': '預約說明：',
  'F28y5s': '確定取消該預約單嗎？',
  'FkqZd5': '請根據實際情況填寫關聯單號(快遞單號、提單號或其它能夠識別訂單的唯一單號)，如包裹條碼無法識別時，可作為識別訂單依據。如一旦無法識別訂單，以異常包裹進行處理，將會影響上架時效!',
  'FtgJ3c': '收貨時間',
  'GUQlNv': '3、若賣家預約時選擇的實際送倉方式與事實不符，視為未預約送倉；',
  'Go3Yk0': '總SKU數',
  'HTWUVn': '賣家預約後若預計無法按時送倉，在一定時間範圍內取消可免費取消；超出免費取消時間範圍將會收取取消預約違規費，具體免費取消時間範圍及收費標準請查看最新版《萬邑通異常與增值價卡說明》；',
  'HTa4JK': '目的地',
  'Ht7i9O': '頭程單位成本',
  'IVF1Ki': '倉組',
  'IeNIkX': '僅支援xls/xlsx格式檔案',
  'JH+HU8': '推薦發貨方式',
  'Jg2/qY': '建議補貨量',
  'KyfE2Y': '指定倉組',
  'M404r0': '二',
  'NU27nj': '調撥在途(KYN|TX)',
  'NuSd3i': '調撥在途',
  'OVc0wE': '沒有資料',
  'Op4tNz': '箱單檔案匯入',
  'P+Va8u': '選擇日期',
  'PoT6AG': '非最優倉發貨SI數量',
  'PpB0X4': '總運費',
  'QvUtKi': '調撥總運費',
  'RL8oaG': '預約單建立成功',
  'RLjQNE': '預約重量',
  'S/Qx5D': '檔案內容為空',
  'S7QkvX': '3.如預約送倉時間都為灰色不可選，請選擇其他日期',
  'SWZEJI': '分倉比例',
  'T0HUpc': '當前預約單已過允許取消時間（當地時間預約送倉日期前 {advanceDateQty} 個工作日中午12點），如確認取消將收違規取消預約費用（{currency}）：{amount}，確認取消預約？',
  'T7LV0R': '方案匯總(USD)',
  'TJCrq3': '可用庫存(WC|KYN|TX)',
  'TuXHDV': '②若倉庫安排收貨，無法保證卸貨時效，並將收取違規費用',
  'TybHeW': '提前DROP到倉時間',
  'U/IJT+': '請選擇送倉時間',
  'UDZql1': '備貨天數',
  'UZylhz': '審批備註',
  'Uf04rk': '2、直發訂單發生以下異常，系統將會自動收取違規費用（費用標準詳見萬邑通異常與增值價卡說明）：',
  'VCv9iq': '多倉直發',
  'WYHxWn': '三',
  'XdU5ui': '可售天數',
  'XmyT7Q': '價差：不調撥預計尾程成本-調撥後預計尾程成本-調撥成本{break}{break}建議調撥數量：基於三倉歷史30天日均銷量和在庫庫存計算的理論調撥數量{break}{break}一鍵下單：系統自動篩選價差大於0的SKU數量生成草稿單{break}{break}匯出：如調撥推薦需調整SKU數量較多，可匯出檔案，進行處理後在調撥單中匯入下單',
  'Y3AngN': '審批結果',
  'YFPd5r': '訂單總數量不能超過100',
  'Yz/BQg': '可預約(CBM)',
  'Z9ZnUG': '價差-USTX Group',
  'Za03Z3': '1.預計卸貨時間請以預約後預約單管理列表中時間為準；',
  'aA+aj6': '預約時間',
  'bFBjSK': '五',
  'c/IOKb': 'SKU明細',
  'cg+X+P': '預約編碼',
  'ckVhDS': '預約單修改失敗，請重試',
  'dwuQx4': '預約送倉注意事項：',
  'e/+InV': '價差-USKYN Group',
  'eISfUy': '5、對於預約卸貨方式為DROP的預約單，若未在預約送倉時間當天送倉，WINIT無法保證卸貨時效，若貨代產生壓櫃費/滯箱費等異常費用需賣家自行承擔；若因賣家問題導致WINIT卸貨產生額外費用，將有權向賣家補收。',
  'eLwCE1': '預計銷量增幅',
  'eaPY96': '仍未到倉',
  'fEnr2e': '建議調撥數量-USTX Group',
  'g/+igE': '1、直發散貨及直發整櫃類訂單必須在系統預約送倉，並按照預約時間將貨物送達。',
  'g0mKuT': 'A/A+類包裹資訊',
  'g2ziRJ': '非最優倉配送單位成本',
  'gyr3Is': '預約成功後，請下載列印POD並在送倉時使用此POD簽收交接，否則倉庫有權拒收貨物。',
  'h++FGi': '申請期間',
  'h/vUnD': '請選擇日期和送倉時間段',
  'hnqFVO': '物流供應商',
  'iR0js9': '預約包裹數',
  'j9Auje': '匯出錯誤檔案',
  'kWNgsD': 'VIP預約',
  'kgzI/H': '建議調撥數量-USKYN Group',
  'l1JdsU': '請輸入正確的郵箱格式，多個郵箱用英文逗號隔開',
  'l2uDIN': 'BC類包裹資訊',
  'lNPW6X': '1、請根據實際情況填寫資訊，如填寫資訊不符，倉庫有權拒收!',
  'lcMHHh': '4、對於預約卸貨方式為LIVE的預約單，若未在預約送倉時間前後2個小時內送達，WINIT無法保證卸貨時效，若貨代產生超時等待費等異常費用需賣家自行承擔；若因賣家問題導致WINIT卸貨產生額外費用，將有權向賣家補收。',
  'lrZQOk': '預約單修改成功',
  'mYTAaf': '確定取消該預約單審批嗎？',
  'n1JFjW': '限制數量',
  'oSDHEp': '多個郵箱用英文逗號隔開',
  'oiMin5': '最優倉發貨SI數量',
  'pqiPMV': '增值預約說明：',
  'quHuln': '說明：',
  'rCAxM4': '送倉時間',
  'rRDd1R': '單SI總成本',
  'sIeNFX': '需在系統取消原預約並安排重新預約；',
  'sOqgP2': '已失敗',
  't2ENq8': '預計上架日期',
  't68ZGk': '適用國家/地區：US{break}{break}適用客戶：頭程發單獨整櫃，散貨，空運，目標在多倉配置庫存{break}{break}包裹類型限制：A或A+類包裹，BC只有一個預設倉庫，不參與尾程計算{break}{break}尾程測算：只測算A與A+類包裹內SKU，只測算小於200lbs商品{break}{break}箱單總體積：小於75CBM{break}{break}SKU：需為已註冊商品，SKU數量建議勿超過200，超過可能因為網路等原因導致測算失敗{break}{break}分倉比例：匯入箱單中可定義各SKU分倉比例，未指定的預設用主介面的分倉比例需為已註冊商品{break}{break}發單倉不調撥：BC類包裹有輸入資訊時，只輸出此目的倉群一個方案',
  'tT3dfa': '卸貨方式為DROP時，WINIT將在卸貨完成後發送資訊給此郵箱，請填寫準確。如有多個郵箱，請以英文逗號隔開，否則將接收不到郵件。',
  'tt6STd': '新增失敗',
  'u4MnQs': '2、審批通過前取消預約不收取增值預約費用。',
  'uGhPgf': '請輸入供應商名稱',
  'uhVC9h': '所有內容僅保留30天，30天後自動清除',
  'urHj4j': '1、直發散貨及直發整櫃類訂單必須在系統預約送倉，並按照預約時間將貨物送達。若後續送倉時間有變更，需在系統取消原預約並安排重新預約；',
  'vdmRcs': '海運散貨',
  'vx1jHW': '集裝箱留夜',
  'w3HHEl': '預計斷貨日期',
  'wQ6Hav': '日均銷量*30(WC|KYN|TX)',
  'wbWE3u': '計算',
  'xFqUvC': '確認建立預約單？',
  'yeCGlM': '六',
  'z+4Ml7': '頭程總運費',
  'z/pOEL': '預約單建立失敗，請重試',
  'zU0td4': '預計卸貨日期：',
  'zaFQyH': '1、提交增值預約後需待審批通過才能安排送倉，審批結果將在1個工作日內透過郵件推送。',
  'zjDJEU': '單位成本',
  'zkbzRU': '1)直發訂單未預約送倉：直發訂單到倉後發現未預約（包含預約單到倉後發現有部分訂單未預約）；',
  'zqtkWa': '匯出SKU明細',
  '4VZtf3': '該訂單對應SKU在倉庫存在部分單品丟失，目前可出庫商品已完成打包，{bold}。',
  '4WkUeY': 'step1 點擊下方按鈕，跳轉至【創建增值單】頁面；',
  '5SfEB4': '訂單裝箱策略為「智能推薦裝箱」或「客戶指定裝箱」時選「是」，其餘選「否」。',
  '98W2f1': '該訂單的增值服務已完成操作。',
  '9E4t9T': '下單是否已上傳包裹/托盤/訂單增值文件',
  'A1iv06': '重新補貼增值文件',
  'C6dwoc': '同意缺量出庫後，Winit將安排訂單正常交貨；{break}若為自提單，請儘快預約提貨。',
  'D8RIAD': '以下增值服務倉庫已經操作完成，如需{bold}，請在【全部訂單】介面基於此訂單，點擊【創建增值單】提交補貼要求（增值服務：出庫非標增值(特批)-出庫其他服務需求）。',
  'Eg/Q5a': 'step2 在頁面中選擇增值服務：「出庫非標增值（特批）-出庫其他服務需求」',
  'KFLFxe': '是否指定裝箱',
  'MSt+a0': '以下增值服務倉庫還未操作，請您確認以下增值服務是否需要{bold}：',
  'Md16EN': '裝箱尺寸、重量及件數已發生變更',
  'OsPvEX': '暫存並更換增值文件後出庫',
  'PdsWYk': '如需更換增值文件：',
  'YgIHDj': '無需更換，直接缺量出庫',
  'ZqmL/w': '取消出庫',
  'bQShmQ': '下單是否已上傳增值文件',
  'buMQVc': '下單時已上傳包裹、托盤、訂單增值文件中任意一種則選「是」，均未上傳選「否」。缺貨場景下，已上傳文件的訂單可能需要替換文件後再出庫。',
  'mX6eqN': '您輸入的{name}[{value}]非正整數，最小限制1，請修改',
  'oHD0Wg': '重新上傳增值文件',
  'rjHMrk': '獲取增值服務列表失敗，請關閉後重試',
  'wKCm42': '請注意：每個訂單僅限重提1次增值申請，請務必確認所有需求填寫完整。',
  'yh4SUs': '更換文件出庫',
  'yvtLPB': '確認無需更換增值文件，直接缺量出庫？{break}同意缺量出庫後，Winit將安排訂單正常交貨給供應商;如果為自提單，請儘快安排供應商提貨。',
  'zbRNyc': '確認後，系統將取消您勾選的增值服務並自動跳轉到【訂單處理】介面，您可重新提交增值文件。',
  '+pUZ2c': '組合操作工時/h',
  '/Curu/': '下單的批次日期',
  '1mkIyt': '實際使用的包材規格',
  '47WapO': '拆分組號',
  '4QJCil': '組合前商品編碼',
  '4uIuDS': '下單第三方單品碼',
  '7ETl22': '拆分前商品規格',
  'A7tbkQ': '組合組號',
  'AetEIm': '單品貼標明細',
  'HHo9uh': '是否貼標',
  'IHXnmK': '組合後商品實物貼標條碼',
  'JHSxnG': '實際使用的包材類型',
  'Jmx7kq': '下單的包裝方式',
  'JzQZko': '下單的商品等級',
  'LYq20E': '下單的包材類型',
  'Oxy6mI': '拆分後商品實物貼標條碼',
  'TGq3dm': '拆分操作工時/h',
  'U9So1E': '組合前庫存單元標準件數',
  'VvO7WL': '下單的包材規格',
  'Vz/H86': '組合前商品規格',
  'WwOxr3': '組合後SKU類型',
  'aKVgRI': '拆分前SKU類型',
  'aZocHe': '拆分前庫存單元標準件數',
  'c99Spy': '拆分後商品規格',
  'clwzFz': '組合前SKU類型',
  'fpeqzZ': '組合後庫存單元標準件數',
  'h//zxe': '下單的批次號',
  'irKGZX': '拆分後庫存單元標準件數',
  'kN9oyw': '檢查不通過原因',
  'lIKAwH': '組合後商品編碼',
  'o5X07X': '拆分後SKU類型',
  'r3mB6U': '組合後商品規格',
  't78c/q': '組合數量',
  'tLfxSA': '拆分前商品編碼',
  'txTZkG': '原包破損銷毀單品數',
  'wH3X/0': '拆分後商品編碼',
  'x1v1yl': '增值完成數量',
  'w6c28E': '實際調整數量',
  'CeNCTb': '退貨增值服務',
  'Mig4cI': '請輸入增值服務名稱',
  'eCNlUz': '請輸入{minValue}-{maxValue}的整數',
  '+KlP6R': '<strong>第三步 上传压缩包/图片</strong>{break}<s>上传图片/压缩包上传</s>{break}<s>(可框选上传多张图片)</s>',
  '0z1mV/': '实际上架商品策略',
  'A36OtU': '【SKU】格式:',
  'B6a4K7': '上传成功，共上传{count}张图片。',
  'Btwv+5': '组-类名称,检查项目,检查结果判断标准,图片序号1-5',
  'Cv6Pdx': '多个文件上传，最多支持{maxLength}个',
  'Dvqe17': '文件大小請勿超過{maxSize}MB',
  'F6s36W': '部分上傳失敗，共上傳{total}張圖片，其中{fail}個上傳失敗。請重新上傳~',
  'HPQemJ': '點擊上傳圖片/壓縮包',
  'OgEnZT': '【組-類】格式:',
  'Q7U7AT': '<strong>第二步 壓縮文件</strong>{break}<s>(此步非必需)</s>{break}<s>上傳圖片過多，可先壓縮打包</s>',
  'YHV5T1': '圖裝品類-針織衫,銷售{break}包裝是否缺失破損髒污,{break}合格,1',
  'aSkMEx': '商品編碼,檢查項目,檢查結果判斷標準,圖片序號1-5',
  'gofBHI': '重命名規則:',
  'hmpnRF': '上傳失敗，共上傳失敗{count}張圖片',
  'par2Tu': '舉例:"服裝品類-針織衫,銷售包裝是否缺失破損髒污,合格,1"',
  'rn2+vO': '文件格式限制爲{fileType}',
  'sbQMLh': '<strong>第一步 重新命名</strong>{break}<s>將您的圖片重新命名</s>{break}<s>(命名規則查看下方)</s>',
  'xtFAYC': '舉例:"SKU001,銷售包裝是否缺失破損髒污,不合格,1"',
  'PA/154': '批量上傳圖片',
  'P6fguC': '圖片名稱',
  'moeTsb': '壓縮包最大 {length}MB{break}每個【組-類】【SKU】最少上傳1張，最多支持上傳{singleMaxLength}張圖片{break}若超過5張，系統會自動覆蓋原數據。{break}壓縮包支持{archiveExtensions}文件{break}圖片格式支持{imageExtensions}',
  '+/C3V3': '僅允許英文、數字、字符，最大支持120個字符',
  '+OaqN3': '最少支持上傳1張，最多支持上傳{maxCount}張模板圖片！',
  '2xxt0V': '【SKU】格式:商品編碼,圖片序號 註：如有規格,在商品編碼後使用英文逗號,隔開',
  '7ZIju2': '每個商品均有其固定的尺碼。請在 <適用SKU級> 界面中，以文本形式為每個商品填寫對應的尺碼。僅支持英文字母與數字（例如：S、M、L、XL、36、38、40）',
  'IgfTgz': '實際檔貼商品編碼*數量',
  'QLPDSp': `僅英文字母（a-z, A-Z）、數字（0-9）、常用英文標點（,.;:!?-/()'"）、空格、換行`,
  'U66mh1': '已補充信息',
  'VaMwVh': 'SKU0012,1.png',
  'YFQOtu': '舉例:"SKU0012,1.png、SKU0012,2.png、SKU0015,黑色,1.png"',
  'de6utO': '請輸入內容',
  'mXgCKO': '批量上傳文本',
  'tBHcCS': '請選擇商品編碼',
  'tkQZxH': '下單檔貼商品編碼*數量',
  'zLJ4n4': '最大支持120個字符',
  '0XIMDJ': '前往已創建草稿',
  'Ah/Oag': '下載失敗文件',
  'oBtpWm': '待確認查件',
  'JqcS0L': '銷毀處理',
  'YG6DZz': '確認後，所選訂單將全部執行{bold}，貨物將不再保留。請確認是否繼續？',
  '6xeDr7': '組內沒有未讀消息',
  'E0bHrY': '加載更多',
  'VHkWk8': '沒有更多數據',
  'b/4MR8': '消息狀態',
  'g8yytK': '已讀',
  'jG/Vu6': '點擊收起',
  'jWoM3f': '請選擇一條消息查看詳情',
  'mao1Hs': '點擊展開',
  'xM8iPW': '點擊將組內所有消息標記為已讀',
  'gyBhng': '不支持選擇線上渠道。此處默認的付款渠道僅供參考，實際付款時可選用系統上的任一渠道',
  'jyt5cs': '以下第三方包裹條碼在系統中已存在，是否確認重複入庫？',
  'H+XwXJ': '請輸入數字、字母、減號、下劃線或空格，並且長度不少於5且不超過128個字元',
  'tQOkKV': '請輸入第三方包裹條碼',
  'FIIG+B': '未查到包材商品，請確認是否已維護包材資訊',
  '2dN1oP': '6位數字驗證碼',
  '4poD2P': '上次登錄成功時間',
  '64rf6L': '為您的賬號提供額外的安全保護。開啟後，使用郵箱+密碼登錄時，除密碼之外還需要輸入手機短信驗證碼才能完成登錄，有效防止密碼泄露導致的賬號被盜風險。',
  '9vgnTW': '第二步 綁定新手機號',
  'A9J8qN': '第一步 驗證當前手機號',
  'BAaueF': '確認接收驗證碼手機號',
  'Bo4W0X': '發送失敗',
  'FVhoeo': '手機短信驗證（短信驗證碼將發送至您的手機）',
  'GSz70z': '繼續登錄',
  'GbVzjW': '開啟雙因子認證需要綁定手機號，用於接收登錄驗證碼。',
  'HIxnWR': '新手機號：',
  'Kq3A21': '手機號：',
  'OF47vj': '請輸入新手機號',
  'QlcAF5': '更換成功',
  'Slgi07': '登錄是否開啟雙因子認證',
  'Tmwttq': '驗證碼錯誤或已過期',
  'V5+7Vd': '開啟雙因子認證',
  'a4eQd6': '驗證手機號',
  'es2f2w': '驗證碼：',
  'fvqSaK': '當前手機號:',
  'gr6+Ku': '為確認您的身份，我們將在登錄時向該手機號發送驗證碼，請確保該手機號能接收到驗證碼。',
  'ilbOZH': '驗證碼格式不正確',
  'pg2Zrh': '手機號格式不正確',
  'v58se4': '驗證方式',
  'wsIzRQ': '登錄驗證',
  'y2hVhr': '請輸入6位驗證碼',
  'uP7/F/': '新手機號不能與當前手機號相同',
  '5t3OvC': 'WINIT出庫Return Label服務專用模版',
  'KP0qqu': 'WINIT出庫非Return Label服務專用模版',
  'SUYlwz': '如果是WINIT出庫退貨',
  'Theats': '<a>點擊此處下載《WINIT出庫非Return Label服務專用模版》</a>',
  'Vy1821': '<a>點擊此處下載《非WINIT出庫Return Label服務專用模板》</a>',
  'lQbHaU': '<a>點擊此處下載《非WINIT出庫非Return Label服務專用模版》</a>',
  'ol18mf': '是否整包銷毀',
  'rGuBTT': '<a>點擊此處下載《WINIT出庫Return Label服務專用模版》</a>',
  'xzJJFB': '如果是非WINIT出庫退貨',
  'SZZFJv': '請選擇商品 {sku} 的自定義分類庫存屬性',
  'pvfzZN': '撤回失敗',
  'zcFTzN': '是否確認撤回該 SKU 的註冊申請？撤回後將退回並終止審核流程，需重新提交註冊。',
  '+kNGFj': '新增產品小組時，自動賦予小組優先級（按創建順序遞增：1, 2, 3...）',
  '1yvLHE': '自動優先級規則',
  '6BKlvh': '{names}已經重復，請修改後再確認',
  '9ETVMH': '+ 新增產品小組',
  '9uzVsM': '刪除後優先級自動重新編號',
  'Fxj6Zh': '新增產品小組',
  'HsTxdY': '在小組內新增產品時，自動賦予產品優先級（按添加順序遞增：1, 2, 3...）',
  'J74Zh0': '產品小組名稱不能重復',
  'NLXhrj': '產品{productName}在產品組{groupName}中已存在',
  'Ptuq5B': '產品小組下需要存在產品',
  'SywXus': '產品組[{productGroupName}]下[{subGroupName}]產品[{productNames}]',
  'bBSqB/': '小組優先級',
  'hm6rEG': '刪除小組',
  'nOONQR': '產品小組數量已達上限（最多{count}個）',
  'rbekyj': '請添加產品小組',
  'uywlC0': '產品小組中PSC不能重復',
  'wMLc2I': '拖拽產品小組前方的 ≡ 圖標可調整小組優先級順序，拖拽產品行的 ≡ 圖標可調整產品優先級順序',
  'wf3UDG': '請輸入小組名稱',
  '+FtfyI': '由客戶註冊的評估維度計算',
  '+P5szr': '長(CM)',
  '1avWrI': '折疊難度等級',
  '58J0vS': '評估維度對比',
  '8jnsLg': '折疊視頻',
  'AP8nQh': '倉庫評定值',
  'AqLCD4': '倉庫判定客戶折疊方案無法執行或不合理',
  'HJhYOM': '倉庫評定等級：',
  'HaA4wY': '沿用客戶值',
  'JjujPU': '客戶註冊等級：',
  'LKH8GC': '倉庫實測值',
  'LWVCnq': '折疊後重量：',
  'Lf3sAC': '折疊後寬：',
  'MaY1Uy': '客戶註冊值',
  'Mmgunh': '查看視頻鏈接',
  'NBlfTe': '增值服務尚未完成，倉庫暫未提交複核結果',
  'Oxv4Sq': '增值明細 - 測量商品折疊尺重',
  'PcZu3h': '倉庫複核結果',
  'RKqZlb': '折疊後長：',
  'SJWwn3': '客戶折疊視頻',
  'UgdEZ1': '倉庫尚未提交複核結果',
  'XOQHXR': '由倉庫評定的評估維度計算',
  'Xa8cFE': '待倉庫複核',
  'b8Ge4E': '倉庫尚未上傳',
  'd+Hky2': '寬(CM)',
  'dQ3Yo3': '折疊後高：',
  'eoI1f5': '增值服務完成後，倉庫將在此處回傳實測尺寸重量、評估維度評分及折疊視頻',
  'fH56ZI': '倉庫折疊視頻',
  'fabLLN': '折疊尺寸重量對比',
  'jwtadX': '評估維度',
  'k+30OI': '高(CM)',
  'kBhsM3': '倉庫確認客戶折疊方案可執行，實測數據已回傳',
  'mvIkQl': '複核通過',
  'qVDx5J': '查看複核結果',
  'qvU5DC': '複核不通過',
  'wenYEM': '客戶註冊折疊信息',
  'e6oBFj': '{codeName} ({score}分)',
  'yV8cJU': '暫無圖片內容',
  'fLvjrT': '最多展示5張圖片，點擊可放大查看',
  'ZL8ECg': '暫無視頻內容',
  '+IywH2': '折疊方案名稱',
  '+iKIxg': '請選擇折疊方案',
  '/wxs/V': '開啟本功能，即視為您已充分知悉、理解並自願接受上述風險。',
  '0CytZx': '商品中文名',
  '22uhgj': '折疊方案信息',
  '26iWHp': '啟用「折疊尺寸」功能後，您可在系統中維護商品的折疊尺寸及方案。倉庫作業人員將依據您填報的方案，對商品進行折疊並打包發貨。',
  '3G/Y6u': '折疊分數(提交值/倉庫核實)',
  '3OnTSz': '倉庫復核值',
  '3SDs3M': '暫時放棄折疊方案',
  '3ejdft': '新增折疊方案',
  '4ONBYD': '新增折疊商品',
  '6xYThs': '實測計費與補收風險：',
  '7ElLD6': '難度等級',
  '7NhkOW': '請上傳折疊示意圖',
  '7Ryszk': '小批量測試：',
  '820Rmu': '啟用後，支持對商品配置折疊方案並按折疊尺寸出庫',
  '8NtNJD': '不規則折疊（無固定步驟）',
  '8QU2kq': '高敏商品慎用：',
  '8dIERc': '方案信息加載中，請稍後',
  '9d5w4X': '原始尺寸(長/寬/高 CM)',
  '9iksrZ': '折疊後尺寸(長/寬/高 CM)',
  '9mx6Dl': '以下為系統根據商品自動判定項',
  'AUtGtv': '折疊動作',
  'AZTDDu': '分',
  'Afjr+M': '當前評分合計：',
  'AgoDYU': '為幫助您優化商品包裝、合理降低物流成本，萬邑通系統已上線「折疊尺寸」維護功能。為確保倉配履約順暢，避免售後爭議，請在啟用該功能前，仔細閱讀並充分理解以下內容：',
  'B6JAav': '定期核對"預報"與"實測"尺寸的差異，及時調整系統內的商品基礎信息，以免因頻繁的"費用補收"影響您的店鋪利潤核算。',
  'CSJ4/m': '加工前件型',
  'D+EPnl': '規則折疊',
  'D8z0sL': '確保指引清晰：',
  'DOC2nO': '我已知曉並同意',
  'DmSDbT': '四、使用建議',
  'DpZzWb': '折疊評分維度（參考）',
  'DyKYSz': '操作示意',
  'EPC9wx': '折疊方案配置',
  'Er4hMs': '填報錯誤與異常風險：',
  'FOyYsM': '折疊操作視頻',
  'FQQECq': '必填',
  'GTvlQu': '難度等級規則',
  'GgrAXu': '根據上述評分規則計算折疊總分後，將按照下述規則匹配難度等級，出庫時將按難度等級收取折疊費用：',
  'HYu/QZ': '折疊總分',
  'Hn8jHg': '評分規則',
  'INyG/e': '(點擊查看評分維度詳情)',
  'Id5C6a': '三、免責聲明',
  'IdCX/r': '折疊分數',
  'JLXsRX': '請選擇折疊動作',
  'JzEEKa': '折疊商品',
  'KP+O+b': '復核狀態',
  'KdctYQ': '請務必上傳清晰、無歧義的折疊圖示和視頻，並確保尺寸數據真實準確，避免因信息偏差造成額外的倉庫處理費或運費差異。',
  'Kwl+8x': '不通過原因：',
  'L/r4E4': '商品英文名',
  'L/tGo1': '方案名稱/編碼',
  'L29CXA': '請選擇折疊方式',
  'M70WBZ': '已添加',
  'MKrIC1': '復核失敗',
  'Mhah4V': '不規則折疊',
  'NBni3Y': '確認刪除該折疊方案？',
  'NcPOg3': '▶ 折疊評分維度',
  'Nj3dpI': '無關聯',
  'Nucwe1': '復核失敗時，商品已禁止出庫，重新關聯折疊方案審核通過後商品將自動解除禁售並按新的折疊方案出庫',
  'NvkaqN': '復核狀態：',
  'Ou64NO': '方案復核與阻斷風險：',
  'Q2kiiZ': '添加步驟',
  'QHoyk4': '倉庫嚴格按系統方案執行。因折疊方案設置錯誤、信息不全、配圖/視頻指引有歧義導致的打包異常或損失，由賣家自行承擔。',
  'QQh0pA': '關聯商品數',
  'QTyqRQ': '第{num}步',
  'ScDs/p': '一、功能說明',
  'T7btJ9': '折疊前尺寸',
  'ThdQMz': '折疊後尺寸(提交值/倉庫核實)',
  'ThoN94': '請輸入方案名稱',
  'TmWFp3': '折疊方案',
  'UKBPDX': '重新關聯折疊方案',
  'V8aw7Z': '倉庫復核反饋',
  'WTxcRs': '條碼',
  'WVOOTv': '多人協同性',
  'Wg/mIe': '請選擇處理方式：',
  'XkkLpf': '客戶提交值',
  'Xv84Oh': '該商品已添加',
  'XzYyze': '確認成功',
  'YaADOB': '復核失敗後，商品將禁止出庫，需要客戶處理。',
  'YbNnek': '復核失敗時，商品已禁止出庫，重新關聯折疊方案審核通過後商品將自動解除禁售並按新的折疊方案出庫。',
  'YxeAt2': '打分規則與具體釋義',
  'ZMUCpZ': '折疊評分維度',
  'ZRGMvK': '支持批量查詢，多個用逗號或換行分隔，最多支持500個',
  'b0hYiw': '商品外觀與售後風險：',
  'bZuFX3': '倉庫會對方案進行人工復核。若復核不通過（如方案無法實現、難度過高），商品將無法正常出庫。賣家需及時取消折疊或更新方案，因停滯導致的發貨延誤由賣家自行承擔。',
  'fO7Wn9': '折疊商品信息',
  'fxWATB': '第{num}步：{action}',
  'h1MojX': '建議首次使用時，先選取少量商品進行打樣測試，確認實際折疊效果及包裹尺寸符合預期後，再批量復製推廣。',
  'h5uE2n': '折疊可能導致商品產生折痕、褶皺，影響展陳效果或買家開箱體驗。由此引發的客戶投訴、退換貨及售後爭議，由賣家自行承擔。',
  'hI0fuz': '倉庫操作視頻',
  'k4qjyi': '方案編碼',
  'kSqUPs': '復核失敗確認狀態',
  'kfqn3k': '是否有關聯商品',
  'lw/rgu': '折疊方式',
  'mbqow5': '對比項',
  'miLi7a': '最多256個字符',
  'n9qGGl': '去確認',
  'nec8ps': '關註賬單波動：',
  'oZ5jEg': '折疊難度',
  'p2Ual4': '復核失敗時，商品已禁止出庫，暫時放棄折疊方案後商品自動解除禁售，可按未折疊出庫',
  'pFnTni': '尺寸(長×寬×高)',
  'pN5HUe': '已關聯方案',
  'q086bg': '去確認 >',
  'qj1Wl+': '請上傳折疊操作視頻',
  'qlGCOp': '折疊步驟',
  'qrzyEa': '折疊示意圖',
  'qtod5Z': '商品編碼/條碼',
  'rBP3eh': '二、風險提示',
  'rNAPzj': '折疊後尺寸(CM)',
  's+52fT': '評估要素',
  'sbQ3JR': '對於高價值、易損、易皺或對展陳外觀有嚴格要求的商品，請務必謹慎評估是否使用該功能。',
  'srAxbu': '復核失敗確認',
  'tY2lx1': '啟用出庫折疊',
  'tYbn5d': '難度等級(提交值/倉庫核實)',
  'tbLVjd': '賣家預報的折疊尺寸僅供參考。商品實際打包時的庫內操作、尾程運費及渠道匹配，均以倉庫最終實測數據為準。若預報與實測不符，萬邑通將依據實測數據自動補收差額費用（追溯計費），並可能引發渠道匹配受阻或時效延誤。',
  'uItXZV': '確認關閉啟用折疊尺寸嗎？',
  'uyRBQ9': '請選擇處理方式',
  'vNTqpX': '圖片預覽',
  'wMGqy7': '請先選擇折疊方案',
  'xQ0lpl': '復核失敗時，商品已禁止出庫，暫時放棄折疊方案後商品自動解除禁售，可按未折疊出庫。',
  'xYnPVU': '確認刪除該折疊商品？',
  'xdZhq5': '折疊評分對比（提交值 vs 倉庫復核值）',
  'xj42AN': '風險告知書',
  'xonsuo': '衡量內容（判定標準）',
  'yIlbSY': '有關聯',
  'ypUR3X': '折疊尺寸功能風險告知書',
  'yylzFW': '因使用「折疊尺寸」功能而產生的商品形變、消費者投訴、退款退貨、費用補收、出庫攔截等各類售後與經濟爭議，萬邑通均不承擔相關賠償或法律責任。',
  'zlj40+': '不規則折疊無固定的折疊步驟，請在折疊示意視頻中做清晰示範。',
  '8kMV7u': '<red>請上傳折疊示意圖，需包含：初始平鋪狀態、折疊中間狀態、折疊完成狀態；如有特殊處理步驟（如翻轉、固定等）請標識並做說明。最多上傳5張圖片，限製為5M以內的jpg、gif、bmp、png格式。</red>',
  'OnzNXC': '折疊示意圖示例',
  '4yZdWb': '極低風險',
  '6OVHj9': '常規操作',
  '7DSPGR': '1個動作',
  '8Bdau9': '高度依賴',
  '8YgDYw': '必須使用耗材',
  'Anmv5v': 'T3（中等加工）',
  'AwQkTs': '高阻力',
  'DyKz+/': '複核中',
  'FWYyCD': '3個動作',
  'HX9vPx': '長邊3折',
  'IsB4B1': 'T1（簡單）',
  'K6aW2A': '已複核',
  'PKTs4u': '需精確對齊或角度控制',
  'QbZDtu': '低阻力',
  'R2lFCJ': '無需額外加固',
  'SUrk8j': '待校驗',
  'SpyA8i': '已確認',
  'eLh34B': '複雜判斷',
  'fi3/Ij': '4個動作及以上',
  'ia6jWE': 'T2（輕加工）',
  'qNMv8B': '中阻力',
  'r8CLmb': '短邊對折',
  'rbO1Zc': '較高風險',
  'vD5jGb': 'T4（複雜加工）',
  'vyHj86': '長邊對折',
  'w6/mi5': 'T5（定制加工）',
  'xV9GAM': '待複核',
  'y5TSsz': '2個動作',
  'zZ7K/0': '無要求',

  '+ckE5q': '自定義規則 - 點擊跳轉編輯頁',
  '+he445': '限制高',
  '/BT6LH': '每個國家設置一條默認托盤，當您下單時（API下單/萬邑聯下單）系統將按【訂單履約場景】+【發貨國家】+【訂單類型】自動選中您預設的默認托盤，無需重複手動選擇，讓下單更高效便捷~',
  '/QiwF7': '開啟後可自定義各包裹類型的尺寸和重量限制，關閉則使用WINIT預設標準值',
  '0/05jB': '超托最大長*寬(cm)',
  '18txdT': '自定義的裝箱規則僅允許A+包裹，倉庫只會打包成A+包裹，如果需要調整，請前往<a>偏好設置 > 出庫裝箱打托規則 > 修改裝箱規則</a>',
  '1XIOoQ': '自定義打托尺寸限制',
  '2ki+EH': '偏好設置>出庫裝箱打托規則>修改裝箱規則',
  '2onNlK': '允許超托時，超托限長和超托限寬不能同時為空',
  '3LoS6X': '您在裝箱限制中【允許出庫的包裹類型】只選擇了A+包，後續下單會按照您維護的偏好單箱單件出庫，請再次確認是否不允許出庫其餘包裹類型',
  '57A25u': '請先選擇一個標準等級後，再點擊查看說明。',
  '6BP2WV': '您選擇的發貨國家【{names}】未配置默認的托盤限制，請配置後再提交。',
  '6MCtrP': '最大限長*寬*高(cm)',
  '6QlKYT': '在此配置的打托規格，可供您在下單環節自主勾選；若未勾選，系統將自動應用下方設置的默認托盤。{break}<b>⚠️請注意：托盤限高與限重均包含托盤自身高度與重量。</b>',
  '6RxoC7': '若您選擇了指定的WINIT包材規格，倉庫將依照您指定的包材進行裝箱打包。僅在尾箱商品數量不足，無法充分利用包材空間時，為提升裝載率，倉庫將更換尺寸更加匹配的包材完成裝箱。',
  '6rfgyr': '添加自定義托盤規格',
  '7E9ZuP': '為了提供更流暢的操作體驗，當前頁面於2026年5月23日進行更新。將原有的包裹規則和托盤規則合併管理，並優化了操作流程。',
  '8qklB4': '是否允許大件超托',
  '8rBHI7': '基於當前訂單的訂單履約場景，僅允許A+包裹，倉庫只會打包成A+包裹，如果需要調整，請前往<a>偏好設置 > 出庫裝箱打托規則 > 新增自定義裝箱規則</a>',
  '94r+du': '歷史版本 {versionNo}',
  'ABy1Q9': '自定義裝箱限制',
  'C90sDl': '僅本單使用',
  'Co5I9q': '托盤最大限寬超出最大限制{maxNum}，請修改。',
  'FFF/0W': '當以托盤形態出庫時，應用以下限制',
  'G2DazA': '請選擇托盤規格',
  'G7aUQb': '直接輸入單個商品的裝箱資訊。適合一次添加少量商品時使用，最多支持添加10種商品，如果超過5個箱子（非原箱/箱產品），請點右側按模板進行上傳。',
  'GPpRyd': '<a>查看標準說明</a>',
  'GrtwPH': '歷史版本',
  'I0AabQ': '需自定義打托尺寸限制？',
  'IDZF+u': '沿用「包裹形態出庫」時的限制',
  'InsjbD': '<b>裝箱打托規則：</b>{break}WINIT已預設默認裝箱打托規則，如未滿足您的需求，您可自定義規則。需注意：相同【訂單履約場景】+【發貨國家】+【訂單類型】僅支持維護一條自定義規則。{break}<b>規則優先級說明：</b>{break}1.自定義規則 > WINIT預設規則{break}2.訂單履約場景層級越小，優先級越高{break}例如：訂單履約場景：平台倉 → FBA → VC，則規則優先級為：VC > FBA > 平台倉',
  'Kd6DFN': '允許',
  'Mo8VZW': '包裹類型說明：{break}A+包：每箱一種SKU且一件單品{break}A包：每箱一種SKU且多件單品{break}B/C包：每箱多種SKU且多件單品',
  'NrsSFS': '選擇B/C包時會自動勾選A+包和A包；選擇A包時會自動勾選A+包',
  'O/6b4k': '偏好設置 > 出庫裝箱打托規則 > 新增自定義裝箱規則',
  'OpRKUu': '托盤最大限高超出最大限制{x}，請修改。',
  'PIpde6': '當以包裹形態出庫時，應用以下限制',
  'PYNsHB': '托盤最大限長超出最大限制{maxNum}，請修改。',
  'PgWP74': '偏好設置 > 出庫裝箱打托規則 > 修改裝箱規則',
  'Pt6pX8': '下單偏好',
  'Qaco0J': '不指定則由倉庫按需加包裝',
  'R+YG8D': '最大值{max}',
  'R0uumR': '確認提交',
  'Rxpxbs': '請填寫0~9999.999999之間的數',
  'SyZfMJ': '不啟用',
  'T2mjhs': '托盤規格',
  'Tz1rLW': '未填寫',
  'UAXlTL': '指定WINIT包材規格',
  'VDPfzE': '當前顯示為WINIT預設限制值，若不符合您的業務需求，您可自定義修改。若未修改，則系統將默認以原規則執行。如果WINIT預設發生變化，則會自動應用最新的WINIT預設規則。',
  'XSG5MB': '<b>一、通過萬邑聯下單：</b>{break}當裝箱/打托策略配置為「智能推薦裝箱/打托」或「倉庫自主裝箱/打托」時，訂單頁面將默認按照該偏好對應的策略與規則執行裝箱、打托操作。{break}當裝箱/打托策略配置為「客戶指定裝箱/打托」時，訂單頁面將默認採用該裝箱策略，您可上傳指定的裝箱/打托清單，完成自定義裝箱、打托。{break}您也可在下單時，根據實際業務需求隨時調整上述設置。{break}<b>二、通過 API 下單：</b>{break}當裝箱/打托策略配置為「智能推薦裝箱/打托」或「倉庫自主裝箱/打托」時，系統將按照預設置的策略與規則完成裝箱、打托。{break}當裝箱/打托策略配置為「客戶指定裝箱/打托」時，因當前暫不支持上傳指定裝箱/打托清單，即便勾選該選項，系統仍將按「倉庫自主裝箱/打托」策略執行。',
  'XbMhDq': '允許出庫的包裹類型',
  'Y4+DI1': '如您選擇允許超托，當單件貨物的長寬尺寸已超出標準托盤規格時，將按照超托限長、超托限寬來進行打托作業。{break}<b>注：高度和重量限制默認與前面不超托的配置一致。</b>',
  'ZxcjWC': '大件超托的最大限長*寬',
  'c7Gr0e': '托盤最大限高超出最大限制{maxNum}，請修改。',
  'dJ6P4F': '請填寫數字且不超過9999.999999',
  'e0f36U': '範圍0~9999.99',
  'eE00S5': '裝箱規則名稱：',
  'f1Ytxn': '您在托盤限制中【允許出庫的包裹類型】只選擇了A+包，後續下單會按照您維護的偏好單箱單件出庫，請再次確認是否不允許出庫其餘包裹類型',
  'f8UFNh': '<font>包裹類型說明：</font> <span>A+包：每箱一種SKU且一件單品</span> <span>A包：每箱一種SKU且多件單品</span> <span>B/C包：每箱多種SKU且多件單品</span> {break} <font>尺寸輸入規則：</font>長=最長邊, 寬=次長邊, 高=最短邊',
  'fJrZna': '查看出庫裝箱/打托規則',
  'fN+ZcF': '裝箱/打托策略及規則',
  'gouM9H': '編輯出庫裝箱/打托規則',
  'hISg6v': '是否要將本次自定義的打托尺寸限制保存為偏好？',
  'hrWiy/': '個人中心-服務設置-偏好設置-出庫-出庫裝箱打托規則',
  'ihxtB1': '您當前未配置自定義裝箱打托規則。如需將本次設置的打托尺寸限制保存為偏好，可前往【{link}】進行添加。',
  'ip8dK4': '裝箱限制：',
  'jeA4XC': '最大限重(kg)',
  'lCZcaY': '該【訂單履約場景】+【發貨國家】+【訂單類型】存在托盤出庫的場景，需要維護打托偏好及限制規則',
  'lR42Sf': '加入偏好，下次自動應用',
  'leTgXY': '偏好設置>出庫裝箱打托規則>新增自定義裝箱規則',
  'pBIVP3': '裝箱限制將重置為WINIT預設限制值，是否確定不再使用自定義裝箱限制？',
  'poOH7Q': '新增出庫裝箱/打托規則',
  'qFuqIi': '未完成自定義設置',
  'r2IQV+': '已完成自定義設置',
  's/HYTy': '基於當前選擇的訂單履約場景、發貨國家、訂單類型無法查詢到WINIT預設的限制規則，請選擇自定義裝箱限制。',
  'srr4QC': '確認刪除該規則？',
  'tJodAf': '請先選擇「發貨國家」',
  'terT9Z': '限寬',
  'uD2fw9': '規則來源',
  'uOHtrA': '是否存在托盤出庫',
  'uvDeZu': '裝箱規則允許的包裹類型：',
  'vk9qd9': '知道了，僅本單使用',
  'wqv8fJ': '請填寫大於0的數',
  'x0loNq': '最大限制體積(m³)',
  'xiXj0t': '限長',
  'y/d6hW': '打托規格配置',
  'y9MLne': '已填寫',
  'y9e5pn': '當前平台收貨倉默認的限制高度',
  'yWAEoF': '當前自定義規則超出WINIT預設標準，是否確認保存？',
  'z59dN9': '為避免異常情況，每種包裹類型都需要提前設置尺重限制。',
  'vS3JrY': '適用發貨國家/是否下單默認規格',
  '0UEzyc': '請按順序完成上方學習以解鎖',
  '3mtqbh': '當前學習進度',
  '4YmEll': '繼續上次學習，',
  '7yA19M': '跳過後該模組學習進度將標記為100%，所有步驟自動解鎖。',
  '8D5vlV': '⚠️風險提示',
  'I+852a': '連結已複製',
  'LeROQa': '全部跳過，我已知悉',
  'Ow/wZi': '服務未開通',
  'PnBZCt': '新手指南',
  'U2JLej': '確認跳過',
  'YDxecj': '未開始',
  'ZDsp2U': '請先完成「賣家入駐和系統配置」中的資料提交和服務開通，才能使用該功能。',
  'aIrpM5': '已複製',
  'gsHKqP': '確定，繼續跳過',
  'ji6SmL': '繼續學習',
  'rLcwmd': '整體學習進度',
  'sRgYwK': '跳過學習後，您將無法獲得系統操作指引，可能影響後續業務操作。確認跳過嗎？',
  'hzXNb6': '抱歉～暫無該頁面操作權限',
  'sg0SbV': '請先在 個人中心-資料管理 頁面提交資料開通服務，等待人工審核通過後即可開通操作權限哦～',
  'zg8dMt': '去提交資料',
  '+Y+qJW': '文檔（幫助文檔）',
  't8lGeH': '去操作（跳轉頁面）',
  'vFgsNr': '視頻（教程視頻）',
  'JmcooD': '如果ERP推單並且需要同步Tracking NO，則需要在「平臺同步 > 商品匹配 > Shopify」中維護商品匹配關系。如果不維護，針對一個訂單多個跟蹤號，系統則只能上傳一個跟蹤號到Shopify平臺。',
  'SuJ6Y+': '系統將根據商品尺寸，從您在庫的該類型客製包材中自動匹配最合適的包材。若無法匹配，將按您選擇的方式處理。',
  // 入庫覆蓋標籤偏好設置
  '0HOUTr': '調整優先級',
  '0m+JH1': '標籤覆蓋組合',
  '1gYyVg': '請選擇清除標籤類型',
  '55ug9C': '調整後，該規則的匹配優先級將降低。',
  '9f5hRc': '客戶自提供覆蓋標籤',
  'BQcLxf': '下移',
  'F6idOC': '自定義標籤需要上傳清除標籤示例圖',
  'FppcdS': '選中「自定義標籤」後需上傳示例圖，供倉庫操作人員識別並清除對應標籤',
  'G67RcH': '覆蓋的標籤類型',
  'HDuLWx': 'WINIT標籤-白標',
  'HV9qgw': '請選擇覆蓋標籤尺寸規格',
  'IE37Ac': '（優先級最高）',
  'IJwvjn': '開啟後，入庫下單時系統將根據下方規則自動下發覆蓋標籤增值服務',
  'JhV03g': 'WINIT標籤-帶圖文',
  'Kx4mtI': '一、匹配條件（滿足條件時自動下發）',
  'Ljnhpd': '客戶自提供覆蓋標籤需要上傳覆蓋標籤圖片',
  'Pv4ATk': '選中「客戶自提供覆蓋標籤」後需上傳客戶提供的標籤圖片',
  'QJ59zq': '規則按優先級從高到低匹配，命中第一條規則後停止匹配，不再繼續往下。可通過上下箭頭調整規則優先級。',
  'RV2TpZ': '入庫覆蓋標籤偏好設置',
  'SRXhGA': '偏好規則列表',
  'STYRVg': '（優先級最低）',
  'TEs+AV': '覆蓋',
  'UMXIBV': '上傳覆蓋標籤',
  'UR1C+p': '暫無規則，請點擊上方按鈕新增',
  'W/U9cW': '編輯偏好規則',
  'W3RezG': '自定義標籤',
  'WWNMkw': '調整成功',
  'X84aIR': '請選擇覆蓋標籤類型',
  'ZGXiJi': '尺寸規格：',
  'b7Hn2j': '覆蓋標籤圖片：',
  'c6qxc5': '上傳示例圖（支持多份）',
  'cOY61P': '清除',
  'eNSBG6': '查看覆蓋標籤示例圖',
  'eTJFGJ': '二、標籤覆蓋組合（自動下發的增值內容）',
  'hXMo+d': '匹配條件',
  'izhn6M': '清除標籤示例圖：',
  'kybTOB': '覆蓋標籤示例圖',
  'lucwJt': '查看清除標籤示例圖',
  'oiPE7z': '新增偏好規則',
  'rHpLZ7': '調整後，該規則將優先於其他規則被匹配。',
  't/oV+c': '清除標籤示例圖',
  'w40Ttp': '清除的標籤類型',
  'wCBYZz': '啟用覆蓋標籤偏好',
  'wOHHSJ': '上移',
  'z8wlxI': '確認將 規則 {priority} {direction}至 優先級 {target}？',
  'Y7aSxo': '僅支持 jpg、png、pdf 格式文件',
  'HNW17u': '存在上傳失敗的文件，請刪除後重新上傳',
  'LSLKRz': '文件正在上傳中，請稍後再試',
  'ZnXkoX': '請配置至少一條匹配條件',
  'ftLnx1': '清除標籤',
  'jiKPgo': '覆蓋標籤',
  'fKvnkn': '暫無示例圖',
  '+FDO1E': '進駐聯絡人郵箱',
  '/XxWUC': '自有海外倉直接填寫自有海外倉，如沒有，填寫「無」',
  '/q5fD8': '是否在英國/東南亞本地有海外倉',
  '01n1lw': '該品牌是否已在德國當地擁有R標',
  '0sn8j/': '請填寫姓名',
  '1wOLiI': '做獨立站意向',
  '2cyTCk': '已提交(需等待 {day1} 個工作日) ——> 初篩通過已同步提交給平台(需等待 {day2} 個工作日) ——> 平台通過',
  '2towDA': '美國站近一年銷售額(USD)',
  '387HdI': '是否有自建海外倉或第三方海外倉',
  '49iOzF': '企業/品牌類型',
  '4L3xFT': '公司規模（員工數量）',
  '5grmob': '請填寫郵箱',
  '5rJPKe': '希望開通ManoMano的國家站點',
  '6C4ze5': '主要產品類目',
  '6jglbI': '品牌商標註冊地',
  '6nYN2s': '請選擇是否有自建海外倉或第三方海外倉',
  '6udigR': '公司性質',
  '7V8auA': '單品牌全渠道近一年的銷售額(USD)',
  '7gK7Rj': '在經營中的店鋪最近一季平均月銷售額(USD)',
  '7wp+GP': '其他電商平台單站點單帳號近一年的銷售額(USD)',
  '85GJe2': '帳號負責人電話',
  '8xAjhV': '賣家聯絡人信息',
  '9aEF/T': '店鋪貨源',
  '9bKiBE': '請務必確保郵箱可以接收郵件，發放註冊連結',
  'A3JVko': '營業執照公司名稱',
  'AyGOuG': '亞馬遜德國、eBay德國、Kaufland 或其他平台店鋪/獨立站後台截圖',
  'B4jhFM': '帳號註冊用郵箱',
  'BZ219V': '請填寫中文名稱',
  'BgUDFC': '進駐狀態',
  'D6nMUK': '主營類目',
  'DU8pzO': '請填寫公司法定名稱',
  'DcPRut': '請填寫您常用的QQ號',
  'DhEqZS': '您的微信號',
  'E92Gy6': '新增連結',
  'EL4b8j': '請填寫其他北美電商平台的「店鋪」連結',
  'EPp062': '德國公司名',
  'Ems0C9': '如有，請填寫海外倉服務商名',
  'EoXCE9': '業務模式',
  'F+ij7Y': '是否已辦理該德國公司的VAT',
  'FPYNcH': '請填寫1到11位數字',
  'GzrOsm': '申請的二級類目',
  'H26cpN': '20字以上，150字以內',
  'Hh+8lr': '填寫您目前主營產品類目',
  'IcnW+V': '其他北美電商平台的「店鋪」連結',
  'InYzo7': '您計劃是做英國市場還是東南亞市場',
  'Iv0cZc': '法人國籍',
  'JonMgV': 'SKU數量',
  'JzufF9': '您常用的QQ號',
  'KIfH+Q': '請填寫20到150位任意字符',
  'KQOzSw': '電子郵箱',
  'L4jOeD': '填寫主營的具體二級類目',
  'LxjC12': 'QQ號',
  'MdKKAC': '其他電商平台的店鋪連結',
  'NG02nv': '公司所在區域',
  'NuSU2V': '中文填寫',
  'Nwgq9f': '是否擁有德國當地海外倉',
  'OOfHj5': '法人姓名',
  'Ot/X5z': '進駐聯絡人信息',
  'P6ktCt': '填寫中文名',
  'P8S+b1': '是否有德語客服人員',
  'R4mfIu': '例如，亞馬遜店鋪/速賣通店鋪/天貓/京東/獨立站優先，或其他',
  'SNeIpX': '亞馬遜歐洲站, Allegro, Fnac/darty 等等',
  'U3/OiC': '其他歐洲電商平台店鋪連結',
  'Uo35I9': '點擊影片連結打開影片（只有已申請查詢並獲取影片的單據有庫內影片資訊，超期檔案無法打開）',
  'VFVI+w': '填寫具體金額',
  'VwT6Ym': '請填寫金額',
  'WIRiiO': '主營產品（具體二級類目）',
  'WXHb1+': '請務必保持電話暢通，將作為後續主要聯絡方式',
  'X+Zymb': '公司簡介或者羅列出公司的優勢',
  'XEsuFF': '請填寫主營產品',
  'XXh7Kw': '營業執照中文名稱',
  'XwN70f': '請填寫亞馬遜德國, eBay德國, Kaufland,或者其他平台店鋪/獨立站連結',
  'Y0L01Z': '正在營運的歐美跨境電商平台連結',
  'YI7fqG': '第三方平台連結',
  'Z1d1dA': '進駐品牌名',
  'ZcMSoa': '請填寫營業執照公司名稱',
  'aIq9ik': '其他（eBay、Amazon）北美電商平台單站點單帳號近一年的銷售額(USD)',
  'aidSjp': '點擊截圖連結下載檔案（只有已申請查詢並獲取影片的單據有庫內截圖資訊，超期檔案無法打開）',
  'bN8SdN': '企業/品牌簡介',
  'bNQ47y': '重新編輯',
  'bilPnX': '公司主營產品',
  'c9DIEs': '填寫英文或漢語拼音 例：中- Zhang San or 英- Rachel Green',
  'crZAUj': '申請人QQ號',
  'csAYl3': '電子產品類目必須填寫是否有Weee',
  'd+drZB': '如果有 請填寫 將有機會對接引流項目',
  'fqBdzm': '公司法定名稱',
  'gGYhmd': '帳號負責人姓名',
  'gKaGa2': '填寫美國站銷售平台（是否有亞馬遜/沃爾瑪/獨立站）',
  'gP+ldf': '進駐聯絡人姓名',
  'gVUjRH': '請務必確保電話暢通',
  'gqZa18': '中國公司辦地址',
  'hC7WeL': '企業/品牌官網',
  'i2HQKK': '進駐聯絡人電話',
  'i8orsr': '銷售額',
  'iTutLd': '您擁有的品牌名稱',
  'jJeioA': '法人',
  'k0TWda': '正在使用的獨立站平台',
  'kUTW+Q': '申請人電話',
  'l+0j0U': '以上電商平台過去30天銷售額',
  'lC0TIO': '請填寫具體金額',
  'lCo8xA': '請填寫1到20位數字',
  'm8yqtX': '請填寫微信號',
  'mkiqo/': '中國公司名',
  'nVPQ6u': 'Shopify獨立站網址',
  'nbGLjI': '庫內影片',
  'oFGnIc': '中國公司的營業執照{break}德國公司的營業執照{break}法人手持護照和身份證的拍照件{break}德國當地海外倉的發貨證明{break}德語客服人員的德語證書',
  'pKBw1k': '{platform} 進駐申請',
  'pb7ufS': '帳號負責人郵箱',
  'pe5tUK': '美國站銷售平台',
  'pnPqSu': '公司全名',
  'q9+Dhh': '請填寫註冊郵箱',
  'qDJlru': '客單價 (USD)',
  'qDga7W': '您距離進駐成功需要等多久：',
  'qjVIUB': '海外倉服務商名稱',
  's7Ufrr': '是否有直播/短影片運營經驗',
  'u1sMF4': '請提供證件並打包發送',
  'udZJ3q': '只填數字，不需要貨幣符號',
  'uqYkNh': '如沒有操作過其他平台 填「否」，如有請填寫具體金額',
  'v725h2': '請填寫電話',
  'v8b14F': '請填寫聯絡人姓名',
  'vc/KMI': '立即進駐',
  'w+7yLR': '跨境電商近一年銷售額(USD)',
  'w6hWi5': '帳號負責人微信',
  'x6NFpn': '客戶單價 (USD)',
  'xToKvz': 'TikTok帳號名稱（沒有請填無）',
  'yMUv2D': '請填寫1到60位任意字符',
  'q1fRx5': '亞馬遜德國，eBay德國，Kaufland等店鋪的後台銷售截圖',
  '+7V2pl': '共',
  '/1JAw2': '英文品名',
  '8970ZG': 'Winit計費產品',
  '9SA/lA': '出庫資訊',
  'GZcPC1': '返回主訂單資訊',
  'QkwbXX': '(*以下時間取操作地點當地時區)',
  'fD8+70': '條記錄',
  'fGrEYv': '收件人Email',
  'yF/N68': '驗證碼校驗失敗',
  '9xi3Ju': '使用',
  'EtZQBV': '規則按優先級從高到低匹配，命中第一條規則後停止匹配，不再繼續往下。可通過拖拽調整規則優先級。',
  'bNYcA1': '不包含',
  '+9DG38': '合同變更聯繫人',
  '+CApE9': '30萬人民幣/每月~100萬人民幣/每月',
  '+Hoc+l': '商業登記證示例',
  '+cIuZr': '聯繫傳真',
  '+yzo5G': '合同及協議編碼',
  '/29Euc': '3月',
  '/7kcrm': '身份證號碼格式不正確（15-18位字母數字）',
  '/BNN7i': '服務及合同',
  '/CE92s': '帳戶資訊(帳號已開通，可正常使用)',
  '/StN3o': '請輸入營業執照號',
  '/cT1pT': '香港身份證號碼',
  '/v6znS': '街道/鎮',
  '0/NBwM': '您的變更資料已提交，{countdown} 秒後自動跳轉...',
  '00Dl+I': '請選擇客戶類型',
  '0XhRJ5': '501-1000人',
  '0hlEvZ': '付款人中文名',
  '0o9tL0': '10月',
  '0v065z': '海外客戶',
  '0vqd6C': '付款人類型',
  '13TWwp': '開通中',
  '1ku3tW': '法人代表',
  '1ucY54': '驗證帳戶使用者身份證掃描件',
  '1vy0rP': '子帳戶註冊',
  '24fCGT': '待再次審核',
  '2IUda7': '電商屬性',
  '2RFenw': '營業執照掃描件',
  '2TsfbW': '邀請子帳戶',
  '2klgKR': '個人',
  '2qGweW': '澳門身份證號碼',
  '32l3EA': '被邀請資訊',
  '36Utyl': '區號',
  '3Mzomi': '支持 jpg, png, jpeg, pdf，大小小於5M',
  '3Qa+El': '查看樣例',
  '3Uobx0': '申請人護照號',
  '3XFSkD': '確認拒絕邀請？',
  '3rV78M': '檔案上傳支持格式 jpg, png, gif, jpeg, bmp, 檔案大小小於5M。證件照片需清晰、完整、無反光。',
  '3vyvYW': '身份證號碼',
  '472GLl': '法人身份證號碼',
  '4dF7v6': '快速添加子帳戶',
  '4femBB': '關係證明檔案',
  '5ZMEGU': '已通過',
  '5d/2Vz': '倉庫所在地',
  '5teFfD': '邀請方公司名稱',
  '658jXb': '價卡群體',
  '69FfwB': '（下列主體將是你使用萬邑聯平台各項服務與功能的唯一法律主體與締約主體）',
  '6CESlO': '請選擇證件類型',
  '6HPRD5': '《協議簽署確認函》',
  '6YaQo+': '證件號碼已存在',
  '6bNLQY': '清關代理協議',
  '6byXVU': '商業登記證號',
  '6cqEcl': '個人地址',
  '6fZv9O': '700萬人民幣/每月~3000萬人民幣/每月',
  '7AMsUx': '檔案上傳支持格式jpg，jpeg，png，pdf，檔案大小小於5M。',
  '7ThyFd': '香港身份證掃描件',
  '7XpSSu': '駕駛證/其他證件號碼',
  '7fcykz': '地址證明檔案',
  '7s6ur5': 'OCR識別失敗，請手動輸入',
  '7spWbI': '中國香港/台灣/澳門客戶',
  '8H2OHK': '中國香港客戶',
  '8IjGQX': '樣本',
  '8P/G1N': '護照/當地身份證',
  '8bJTvq': '確認撤回邀請？',
  '8l5TcI': '澳門身份證',
  '8ugzNj': '檔案上傳支持格式 jpg, png, gif, jpeg, bmp，檔案大小小於5M',
  '9A3C2h': '子帳戶與主帳戶的關係',
  '9FtIgY': '駕駛證或其他證件號碼',
  '9HIsg3': '公司註冊證書',
  '9cdIhE': '1月',
  '9h+nqk': '11-50人',
  '9p3Tkx': '最多60個字符',
  '9wzk8E': '起始日期',
  'A2THfo': '認證材料已提交，審核通過後將自動開通額度服務。',
  'ADhUgT': '客戶基本資訊',
  'AH8FM1': '客戶名稱已存在',
  'APEnMa': '電商平台月均總營業額（萬元人民幣）',
  'AQe5/5': '公司名稱需與充值主體名稱一致',
  'AhUzIA': '請輸入護照號碼',
  'B3w1/1': '重新簽署',
  'BMABZJ': '法人身份證/護照、營業執照',
  'BOfsuX': '子帳戶資訊',
  'BOox40': '子帳戶ID',
  'BZAJ5w': '法人身份證有效期',
  'BfMW6T': '請輸入申請人姓名',
  'BjsAw0': '上傳（最多{max}張）',
  'BuE30c': '區縣',
  'BxgAk/': '不允許變更客戶名稱',
  'C94f9k': '經營品類',
  'CMtdKT': '2. 認證資訊',
  'Cc5pXc': '新主體的清關代理協議',
  'CeSENy': '是否與帳戶主體一致',
  'D3sd4t': '變更資料',
  'D9AaM/': '其他資訊',
  'DB77Ln': '請閱讀並確認',
  'DKkkv9': '香港身份證',
  'DOP2hn': '長期',
  'DXcpHk': '無效的變更類型參數',
  'DYXVSj': '海外倉國家',
  'EoVLzL': '示例(HK)',
  'EpFNtd': '成交第一要因',
  'EpVYM2': '海外倉《供應鏈管理協議》和《海外倉商業性條款補充協議》',
  'EwUCWH': '不允許的檔案格式，支持 jpg, jpeg, png, pdf',
  'F3QGoQ': '簽約時間',
  'FOGW3w': '是否使用除eBay外的電商平台',
  'FeWWMh': '駕駛證掃描件',
  'FfuHbC': '公司註冊證書示例',
  'FnimtQ': '協議名稱',
  'FoE46O': '主子帳戶關係',
  'G1RZwj': '為順利提交資料，請根據您的客戶類型和開戶類型提前準備對應的材料',
  'GXi4YZ': '已提供',
  'GhUVYq': '協議簽署確認函',
  'Gk7LWL': '1-10人',
  'GqjTbU': '登錄帳號',
  'GvnX5P': '已生效',
  'H3ZtQe': '簽署',
  'HUgN5U': '認證材料提交成功',
  'IC1h4R': '證件類型',
  'IN3tvo': '護照示例',
  'IOMpyN': '駕駛證號碼',
  'ISdltD': '帳戶組列表',
  'IvAEHK': '申請人姓名',
  'Izxr3P': '如您收到邀請，請確認邀請方資訊後選擇接受或拒絕。',
  'J0euZj': '請輸入護照號',
  'J5KYh7': '公司註冊證書掃描件',
  'J8aQci': '100萬人民幣/每月~300萬人民幣/每月',
  'JM0Z8+': '小於30萬人民幣/每月',
  'JW4xKl': '駕駛證或其他證件掃描件',
  'JgARuC': '接受邀請',
  'Jnvy7T': '壞賬客戶不允許添加子帳戶',
  'JwpS8H': '12月',
  'JygcLG': '澳大利亞客戶',
  'KBEkaQ': '公司規模',
  'KEPXlg': '是否有VAT稅號',
  'KY9Lch': '該子帳戶刪除後，將不再存在於當前帳戶組中，您確認刪除嗎？',
  'KlDbAb': '代運營',
  'L1PAth': '企業',
  'LBAV1N': '以個人為單位與萬邑通建立合作關係的客戶',
  'LOIsbN': '付款主體帳戶管理',
  'LPi8CO': '法人代表姓名',
  'LQAdg1': '請填寫公司名稱',
  'LU2K5S': '2月',
  'LWEs1S': '子帳戶與主帳號的關係',
  'LeUTRH': '變更中詳情資訊',
  'LzpMjm': '工廠所在地',
  'M5YDuP': '溫馨提示：帳戶列表中管理的是帳戶組所有帳戶，如果您需要使用其他主體來付款，您可以將付款主體添加為您的子帳戶。如您的主帳戶主體無法付款，請直接變更主帳戶主體，無需註冊子帳戶。',
  'MEEiLH': '請輸入詳細地址',
  'MFXP7H': '所屬主帳戶',
  'MMCAZ8': '請輸入商業登記號碼',
  'Mjfa6o': '11月',
  'N4QdRi': '檔案大小不能超過5MB',
  'N52KMq': '詳細地址',
  'N8hPDs': '護照號碼',
  'NOW26J': '請輸入統一社會信用代碼',
  'NVG0yN': '客戶註冊地址的證明檔案',
  'O19lil': '請確認您提交的個人資料真實有效，如有虛假資訊將承擔相應法律責任。',
  'OcjtgQ': '我已閱讀並確認以上關係證明內容',
  'Oj4FyF': '變更中詳情',
  'Oq50W9': '證件號碼',
  'PCFi32': '大於等於3000萬人民幣/每月',
  'PTl9Bi': '300萬人民幣/每月~700萬人民幣/每月',
  'PdlThh': '請輸入客戶名稱',
  'QK7qOF': '驗證帳戶使用者身份證姓名',
  'QS6VWp': '5月',
  'Qxp8mo': '已邀請資訊',
  'R/iqJm': '驗證資訊人姓名',
  'ROXEVo': '身份證號碼格式不正確',
  'RtJnaj': '請輸入姓名',
  'SE63qT': '組織機構代碼證',
  'SG7SHS': '是否使用第三方ERP系統',
  'SKyitS': '請輸入法人身份證號碼',
  'SfysDv': '註冊地為中國大陸地區的企業客戶或使用大陸身份證註冊的個人客戶',
  'SiO92D': '我已閱讀並確認《關係證明-朋友及非直系親屬》',
  'T3xGmR': '主/子帳戶',
  'TBiYNm': '法人代表身份證掃描件',
  'TCvPX4': '邀請狀態',
  'TX+ka3': '已拒絕',
  'Tdq1Gf': '身份證掃描件',
  'TkMY1P': '材料上傳',
  'UB7ax/': '新主體的主子關係證明',
  'UDEIri': '澳門身份證掃描件',
  'UEiMSy': '身份驗證',

  'UrM0bR': '認證資訊',
  'UtCIn0': '8月',
  'V7gB+B': '請輸入法人代表姓名',
  'VOBapr': '註冊地為澳大利亞以外的其他國家的企業客戶或國籍為澳大利亞以外的海外個人客戶',
  'VPQA6P': '快速添加子帳戶，預設會將付款人資訊載入到子帳戶添加頁面，您也可在頁面編輯修改。',
  'WPDMcF': '營業執照號',
  'WaLVm1': '清關代理協議和授權委託書',
  'Wg4cCI': '請輸入身份證號碼',
  'WocH+A': '7月',
  'X8fPpI': '已歸檔',
  'XI+CCX': '我已閱讀並確認通過',
  'XaOtBT': '香港永久性居民身份證、香港居民身份證均可',
  'XbArtN': '法人身份證與姓名不匹配',
  'XubzYT': '客戶名稱需與充值主體名稱一致',
  'Xvdst0': '商業登記號碼',
  'YAQ7rx': '對接平台資訊',
  'YIAhsY': '系統',
  'YLFpFt': '推薦客戶',
  'YSy2/s': '1. 帳戶資訊(帳號已開通，可正常使用)',
  'YZSsDz': '註冊地為澳大利亞的企業客戶或國籍為澳大利亞的個人客戶',
  'YjJIvk': '若您未提供，將無法新增Winit承運服務的訂單。',
  'Yk4XHE': '經營資訊',
  'ZI8d7M': '商業登記證號碼',
  'ZYI5Al': '邀請發送成功',
  'Zmfa+l': '省份',
  'aArN9y': '接受成功',
  'aWgexz': '補充資料提交',
  'aXAhIL': '請填寫與身份證一致的姓名',
  'arv4g+': '請選擇城市',
  'b4+bD9': '澳洲',
  'bFDGAE': '最多50個字符，不允許中文',
  'bQM+7I': '認證材料已提交，請等待審核。',
  'bXRVNi': '客戶名稱(姓名)',
  'bXi2Wm': '護照號',
  'bjU+OH': '由於',
  'blw6Vt': '簽署時間',
  'bwPC7o': '認證材料上傳',
  'bzXZCY': '申請人證件類型',
  'c9ATtu': '提交資料需要準備的材料',
  'cZdEMH': '主子關係證明',
  'cjWs0X': '請先開通海外倉服務後再簽署清關協議。',
  'cxptRD': '為保證{subName}功能的正常使用，{subName}預設簽署{mainName}已簽署的以下協議，以及{mainName}後續簽署和更新的協議，{subName}預設同步簽署。',
  'd+bdlp': '1、請上傳6個月以內的帶有地址資訊的水電煤費用帳單、固話繳費帳單、物業費用繳費帳單、信用卡帳單等任一能夠證明地址正確性的圖片，並確保圖片中的用戶名和地址資訊與註冊時您填寫的客戶名稱和聯繫地址的一致性；',
  'd6hPUr': '請輸入駕駛證/其他證件號碼',
  'd9ivKd': '填寫客戶資訊',
  'dLQBLA': '分機號',
  'dTFZrp': '若此協議內容與您的線下簽署的協議有差異，以線下協議為準。',
  'dbqd/9': '（合同期限：{startDate} - {endDate}）的所有內容',
  'dmZTUz': '是否自建工廠',
  'dozWHK': '檔案照片需清晰、完整、無反光。',
  'dtUNQA': '請輸入法人代表身份證號',
  'e9YEZh': '請上傳帳戶關係證明檔案',
  'eILZXl': '法人代表身份證有效期',
  'echU02': '材料類型',
  'eckayc': '支持 jpg, png, jpeg, pdf 格式，檔案大小不超過5M',
  'ew9IbS': '帳號異常，請聯繫您的銷售代表',
  'ewqgLV': '已撤回',
  'f3175/': '申請開通海外倉時，需此項材料已經提供並審核通過。',
  'fKQkIL': '3、檔案上傳支持格式 jpg, png, gif, jpeg, bmp，單個檔案小於5M。',
  'fQx7n8': '法人代表護照號',
  'fQyKmo': '服務類型',
  'fXseSl': '公司固定電話',
  'fhnTp9': '合同編號',
  'fjdGBq': '已接受',
  'g8CVty': '身份證',
  'gNViUK': '請輸入駕駛證號碼',
  'gcxyYc': '稅務登記證',
  'gxsu0P': '的內容具有相互關聯性，兩份協議需要同時簽署，您可以點擊協議名稱查看具體內容。',
  'h18w+Q': '待維護帳戶（原付款人資訊）',
  'hRTXpg': '變更客戶名稱後，信用額度將暫停使用，請確認是否已申請新協議？',
  'hanZNQ': '載入失敗',
  'hswXDb': '法人代表身份證號',
  'i660Gu': '法人代表證件類型',
  'iFu/jb': '101-500人',
  'iMrHyx': '主帳戶ID',
  'jIYWiV': '帳戶資訊',
  'jWrnD6': '主帳戶名稱',
  'jbO5eW': '額度協議',
  'jwGGQC': '溫馨提示：如您的主帳戶主體無法付款，請直接變更主帳戶主體，無需註冊子帳戶，以免造成主帳戶無法還清欠款。',
  'k3ggh8': '請選擇開戶類型',
  'k9Z1aG': '時效的穩定性',
  'kD/WOs': '註冊地為中國香港/澳門/台灣的企業客戶或使用中國香港/澳門/台灣身份證註冊的個人客戶',
  'kUfI5j': '檔案不存在，正在重新生成，請稍後再試',
  'kll/tx': '以企業或組織為單位與萬邑通建立合作關係的客戶',
  'koPxOB': '子帳戶註冊成功',
  'kokU70': '請上傳必填材料：{labels}',
  'kpIbQC': '上傳（最多3張）',
  'kpoJ9o': '合同期限',
  'kyvQ8G': '當前狀態不允許操作',
  'lRRe8a': '查看示例',
  'liumu4': '帳戶名',
  'mAWXCU': '2、營業執照作為地址證明的，如為影印件，需影印後加蓋公章；如為掃描件，需加蓋電子公章；',
  'mMZYKe': '簽署失敗',
  'mQsRy2': '資料管理',
  'mRq6Fw': '請輸入個人地址',
  'mv7klT': '未同意',
  'nBK3U2': '如何提供?',
  'nKEZEf': '已更新',
  'nTGLyC': '推薦您來註冊的銷售代表的聯繫郵箱',
  'nhhUEK': '護照掃描件',
  'noKt4Z': '護照/駕駛證/其他證件，商業登記證',
  'nwyXo8': '個人照片',
  'ny0ynj': '身份證有效期',
  'nykDD6': '關聯證明檔案',
  'oIaB29': '請正確填寫，一旦提交不可自行修改',
  'ocW47+': '已同意',
  'ov2Tnz': '錢包可消費的國家',
  'pEclQv': '特定服務',
  'pGg2Jq': '4月',
  'pTMsfn': '9月',
  'pvwIWk': '付款人英文名',
  'q0msCl': '是否自有IOR',
  'qJ7ha/': '護照姓名',
  'qkZeU+': '個體客戶',
  'qrkKt7': '請輸入商業登記證號',
  'r/tdDN': '護照/駕駛證/其他證件',
  'r1bZJl': '重新提交關係證明',
  'rB0rpK': '撤回邀請',
  'rBYkkv': '銷售淡季',
  'rZK6Nv': '合同號',
  'rtsk2b': '拒絕',
  'rvmG34': '的內容具有相互關聯性，三份協議需要同時簽署，您可以點擊協議名稱查看具體內容。',
  'rwwA42': '合同及協議',
  's4UXY6': '商業登記證掃描件',
  's9xFxt': '和',
  'sa0zjq': '若您變更客戶名稱（萬邑聯平台各項服務的法律主體），原主體締結的合同協議需要重新簽署，請同意以下協議，其他協議如有需要請至個人中心-服務與合同簽署。',
  'sizSxZ': '駕駛證/其他證件',
  'slLSac': '海外倉《新供應鏈管理協議》和《新海外倉商業性條款補充協議》和《三方轉讓協議》',
  'sotoMX': '子帳戶認證狀態',
  'swVIZ8': '是否有開發團隊',
  'tHCcFc': '子帳戶註冊成功，充值後帳戶可正常使用。您可以即刻補充認證資料，也可以在7天內補充認證資料。',
  'tHhycC': '帳戶關係證明檔案',
  'tK+g+d': '不允許的檔案格式，支持 jpg, png, gif, jpeg, bmp',
  'tgev/Q': '如頭程運輸方式想使用winit承運，請您先提供您簽署完成的清關代理協議和授權委託書。',
  'u1fYB+': '確認儲存其他資訊的修改嗎？',
  'uJtC0k': '護照',
  'v4Nkiu': '公司註冊證書編號',
  'v5e10Y': '法人護照、商業登記證',
  'vRhbL7': '6月',
  'vfyv2v': '請輸入公司註冊證書編號',
  'vlq+5R': '請選擇省份',
  'vpFnVy': '企業資訊',
  'vxhTE0': '壞賬客戶不允許操作',
  'w5rc6W': '供應鏈資訊',
  'wO5MxF': '請選擇關係類型',
  'wmZ7YZ': '正面示例',
  'wmwYjQ': '合同主體變更三方協議',
  'wu5dwO': '銷售旺季',
  'x+okXO': '請確認您的身份資訊是否正確？',
  'xGq1Su': '1000人以上',
  'xXMsQn': '重新提交認證',
  'xsN0zZ': '公司註冊證書示例：',
  'xxkXLy': '51-100人',
  'yAibl7': '是否自有品牌',
  'yD1dFr': '反面示例',
  'yXEBUd': '駕駛證/其他證件掃描件',
  'ygr6yk': '自運營',
  'ygyLem': '是否自建倉',
  'zrPHhb': '添加子帳戶',
  '5WtksW': '檔案解析失敗，請檢查檔案格式',
  'Jv29lf': '發送頻率',
  'OgmspG': '收件信箱',
  'gdqRti': '提交成功，開啟批次任務中心查看結果',
  'itqntG': '信箱格式不正確：{emails}',
  'sae4DD': '批次任務中心',
  'x8Anbh': '多個信箱請用英文逗號間隔',
  '95EEUk': '訂單產品出現多個產品組處理方式',
  'BFquwc': '請務必在出庫前在[海外倉 > 出庫 > 訂單處理]頁面補充資料內容，否則倉庫不會操作出庫',
  'CbTnzf': '下單報錯',
  'D57dEh': '預約窗口',
  'GUC5Ld': '請務必在妥投前在[海外倉 > 出庫 > 訂單處理]頁面補充資料內容，否則可能會妥投失敗',
  'GXkv7X': '實際用量',
  'HU/sk6': '請輸入ASN',
  'IIPVBV': '（2）如果下單時指定產品信息，則會遇到訂單產品出現多個產品組情況，處理方式選擇下單報錯則遇到這種情況直接下單失敗，處理方式選擇直接使用下單產品不使用智能推薦，下單不會失敗，訂單直接使用指定的產品出庫，不會使用智能推薦功能去選擇最優的產品出庫',
  'RPDXWq': '直接使用下單產品不使用智能推薦',
  'YgJy9e': '當前存在跨組重復的產品配置，切換為標準類別後將清除重復配置，是否繼續？',
  'ZOK20H': '實際裝箱結果',
  'ZT6Wlf': '出庫處理費-標準包裝打包費/出庫處理費-復合打包附加費 按實際裝箱結果為準',
  'ZzfHpZ': '包材費用將根據打包完成後的{b1}進行結算，最終費用以倉庫{b2}為準。',
  'cRQFUR': 'PSC：{names}同時出現在多個產品組中，已按「訂單產品出現多個產品組處理方式」配置處理沖突。',
  'fWHxHn': '請選擇預約窗口',
  'ilS24x': '資料內容',
  'qao8cv': '（1）如果下單時選擇產品組，則不會出現訂單產品出現多個產品組情況',
  'r9Pakk': 'ASN',
  // '2nPj6J': '<bold>標籤/指標定義：</bold>{break}SKU溫度:截至所選日期,計算該SKU過去30天出庫量:高溫>=600,600>中溫>=100,100>低溫>=3,滯銷<3;{break}DOI:截至所選日期,計算該SKU近30天日均庫存數/近30天日均銷售數量;{break}日均庫存:截至所選日期,該類SKU過去30天日均庫存數據;{break}剔除新品庫存：SKU最早上架時間距今<60天',
  '5L5HWp': '剔除新品庫存',
  'GIpWfV': 'SKU最早上架時間距今<60天',
  'QuupS2': '（2）汽配類，高溫>=30，30>中溫>=10，10>低溫>=3，超低溫<3； （系統默認通用標準，主營汽配可聯繫您的銷售變更類目配置。）',
  'SIqgtx': '<bold>標籤/指標定義：</bold>{break}SKU溫度:截至所選日期,計算該SKU過去30天出庫量:高溫>=600,600>中溫>=100,100>低溫>=3,滯銷<3;{break}（1）非汽配類劃分：高溫>=600，600>中溫>=100，100>低溫>=3，超低溫<3；{break}（2）汽配類，高溫>=30，30>中溫>=10，10>低溫>=3，超低溫<3； （系統默認通用標準，主營汽配可聯繫您的銷售變更類目配置。）{break}DOI:截至所選日期,計算該SKU近30天日均庫存數/近30天日均銷售數量;{break}日均庫存:截至所選日期,該類SKU過去30天日均庫存數據;{break}剔除新品庫存：SKU最早上架時間距今<60天',
  'nUaOH0': '（1）非汽配類劃分：高溫>=600，600>中溫>=100，100>低溫>=3，超低溫<3；',
  '6aITvx': '<bold>標籤/指標定義：</bold>{break} {symbol}SKU溫度:截至所選日期,計算該SKU過去30天出庫量:高溫>=600,600>中溫>=100,100>低溫>=3,滯銷<3;{break} （1）非汽配類劃分：高溫>=600，600>中溫>=100，100>低溫>=3，超低溫<3；{break} （2）汽配類，高溫>=30，30>中溫>=10，10>低溫>=3，超低溫<3； （系統默認通用標準，主營汽配可聯繫您的銷售變更類目配置。）{break} {symbol}DOI:截至所選日期,計算該SKU近30天日均庫存數/近30天日均銷售數量;{break} {symbol}日均庫存:截至所選日期,該類SKU過去30天日均庫存數據;{break} {symbol}剔除新品庫存：SKU最早上架時間距今<60天',
  '+OQSHt': '適用客戶',
  '6SaKc3': '操作影片',
  'RKDS0B': '打託等級名稱',
  'clwNaF': '點看具體說明',
  'jOosuV': '<a>點選查看具體說明</a>',
  'QN7qT1': '已認證或（已開通服務）的賬戶且主子關係證明審覈通過，纔可以作爲付款發起賬戶。',
  'Bklei+': '系統計算折疊分數與難度等級，若系統審核不通過，可在對應方案內失效此商品後關聯其他方案。',
  'CuAg0e': '首次出庫前由倉庫進行複核，若符合失敗可放棄折疊出庫或重選方案。',
  'GPqzPr': '維護折疊方案',
  'SoPWko': '新增方案，填寫折疊方案、步驟、折疊示意圖、折疊視頻。',
  'XZ25+X': '提交系統審核',
  'gTOf0A': '倉庫複核',
  'it9ahA': '關聯折疊商品',
  't5QRAS': '近半年',
  't6fdxD': '選擇方案，添加商品，確認折疊後尺寸信息。',
  'iy9fgm': '說明: {break}1.批量一次最多創建{maxDraftNum}單草稿單。{break}2.創建後請先在草稿頁確認當前所選的商品複測信息是否認可,不認可請重新複測商品後,再重新申訴。{break}3.申請尺重類費用系統自動查詢最近12個月內最新的商品複測信息,提交草稿後,即代表同意使用萬邑通複測結果進行申訴;當無可用庫存商品進行複測時,系統自動查詢出庫時包裹的尺重信息進行提交。{break}',
  'ANUBEZ': '自主裝箱/打托 由倉庫根據實際裝載情況判斷是否混裝，混裝時機和方式不做承諾。',
  'BBAB0l': '優先單SKU裝箱（按裝載需要混箱）',
  'BwLBVN': '批量下載（{count}）',
  'G5kS8+': '優先同類包裹打托（按裝載需要混托）',
  'Lguoj3': '未找到POD檔案（{count}個單號）',
  'LhUQLV': '風險提示：',
  'UKe03t': 'POD 檔案查詢結果',
  'famGVR': '系統已查詢到以下快遞單號的POD檔案，您可以直接下載。',
  'fbFvrI': '系統已查詢到以下快遞單號的POD檔案，您可以直接下載。對於未找到POD的單號，可選擇繼續提交查件申請。',
  'kTlf72': '為未找到的單號提交查件',
  'kzQni7': '提交失敗（{count}個單號）',
  'qSLsI7': '已找到POD檔案（{count}個單號）',
  'zGe/VP': '下載POD',
  'G+vm8C': '僅當裝箱策略選擇智能推薦裝箱或客戶指定裝箱時，支持選擇優先同類包裹打托。',
  'CYcS4F': '倉庫人員根據商品特性與運輸要求，靈活進行打托，具體打托結果後續可查看子訂單詳情~ {break}<span>重要提示：如您選擇此策略，則視為您授權並同意以倉庫最終的實際打托結果為準。倉庫將依實際裝載情況判斷是否混裝，混裝時機及方式不作承諾。</span>',
  'IKLLzL': '倉庫人員將根據商品特性和運輸要求，靈活選擇包材與裝箱方式，具體裝箱結果後續可查看子訂單詳情~ {break}<span>重要提示：如您選擇此策略，則視為您授權並同意以倉庫最終的實際裝箱結果為準。倉庫將依實際裝載情況判斷是否混裝，混裝時機及方式不作承諾。</span>',
  '+LqiLB': '拆單成功',
  '0An1WL': '新入庫單將自動繼承原單信息',
  '14C8J/': '中轉倉',
  '2qsyUR': '確認後，已選的 {count} 個包裹將從 {from} 中轉至 {to} 完成入庫。中轉費用按合同約定計費。',
  '34Nm6H': '確認中轉',
  '4Q4ztC': '查看訂單詳情',
  '5imQHj': '請勾選需要拆出的包裹',
  '7EfxeQ': '個（全部）',
  '7zajKA': '選擇包裹',
  'AeBvmu': '拆出包裹數',
  'AwPWk2': '選擇中轉類型',
  'AwzhnY': '入庫單內所有包裹統一中轉至新目的倉',
  'Bd3f88': '入庫單拆單',
  'Cvrnz2': '請選擇中轉類型',
  'Dcy1/5': '查看新入庫單',
  'FdU90R': '選擇目的倉',
  'FmmsT+': '請勾選需要中轉的包裹',
  'FpjLEL': '中轉倉（原目的倉）',
  'HpFbBI': '確定要作廢該中轉單嗎？',
  'IgzD9u': '新入庫單已自動發起海外中轉，無需額外操作。',
  'JWJ+/S': '入庫單 {orderNo} 的中轉已成功發起。',
  'JWrk7G': '個包裹拆出',
  'Jk3X8R': '海外中轉',
  'L4D0ff': '僅顯示已配置的中轉倉庫（基於Winit產品+目的倉配置）',
  'LeVkNq': '包含包裹數',
  'LelI4l': '整單中轉：所有',
  'M7LM+x': '選擇新目的倉',
  'MuCcVn': '請選擇新的目的倉',
  'NfBRBZ': '整單中轉',
  'PjSYqs': '新Winit產品',
  'Q9iQHY': '多個用換行或逗號隔開',
  'QUbxVa': '入庫單信息',
  'RVNwaA': '中轉發起成功',
  'SmkREh': '原目的倉（中轉倉）',
  'TfptPu': '原單剩餘包裹',
  'TpX3uS': '是否海外中轉',
  'ULVDFv': '新入庫單已生成，自動繼承原單的Winit產品、發貨計劃等信息。您可以在入庫全部訂單中查看並對其進行後續操作。',
  'WgLwa5': '請至少選擇一個包裹',
  'Y77Gxw': '已選擇',
  'aJkyQ0': '中轉類型',
  'bBUl8w': '中轉包裹數',
  'bM4NKj': '目的倉和中轉倉不能是同一個倉庫！',
  'dQ9VyS': '包裹單號',
  'gjgB7K': '部分中轉：請在下一步選擇需要中轉的包裹',
  'iIH0vE': '新目的倉',
  'j6EyHL': '個包裹中轉',
  'jfJdT8': '已將選中的 {count} 個包裹從原入庫單 {orderNo} 拆出，生成新入庫單：',
  'juLnBd': '作廢成功',
  'ktQROn': '中轉已發起，所有包裹將從原目的倉中轉至新目的倉完成入庫。可在訂單詳情中查看中轉進度。',
  'l3cE5+': '已選的 {count} 個包裹',
  'laEPdF': '中轉狀態',
  'lmbxWv': '拆出的包裹將生成新的入庫單，自動繼承原單的Winit產品、目的倉、驗貨信息等，無需重新填寫。',
  'mBz8fo': '選擇部分包裹中轉至新目的倉，其餘包裹留在原單',
  'mZ/ix2': '當前目的倉',
  'mj7TCE': '已將選中包裹拆為新入庫單並自動發起中轉，原入庫單剩餘包裹不受影響。可在入庫全部訂單中查看兩個單據。',
  'qA8a8u': '個包裹將中轉',
  'rZEho1': '您即將對入庫單 {orderNo} 執行拆單操作：',
  's99Nb4': '拆單信息',
  'sLD7EO': '包裹總數',
  'szz1uP': '暫無軌跡信息',
  'tOJdpO': '中轉信息確認',
  'tUAYlD': '已從入庫單 {orderNo} 成功拆出包裹，生成新入庫單。',
  'warsjn': '部分包裹中轉',
  'xJXdl5': '中轉軌跡',
  'yqgS2d': '拆單後將生成新的入庫單，此操作不可撤銷，請確認無誤後提交。',
  'zd/qTo': '中轉入庫單號：',
  'QT4kgx': '請選擇預約倉庫相同的訂單創建預約單，已發起中轉的入庫單的預約倉庫是中轉倉，未發起中轉的入庫單的預約倉庫是目的倉！',
  '1R2faN': '新的Winit產品',
  'mKTpg9': '系統根據配置自動匹配Winit產品，不可手動修改，中轉包裹將使用該Winit產品完成中轉入庫。',
  '+c+COK': '海外倉入庫完成',
  '+loinA': '揀選異常',
  '/1L/Ya': '計費重({unit})',
  '5vjKo1': '請選擇文件',
  '9nYt4g': '批量導入將清空原輸入/導入SKU數據',
  'AbnhUS': '預計凍結金額',
  'EJ3SFH': '揀選完成',
  'Em6cvX': '總重量(kg)',
  'GxOf0U': '請先添加商品信息',
  'HK4jwl': '不能大於可用庫存',
  'HgKGiV': '打包完成',
  'Io/uF/': '長({unit})',
  'J1yTE1': '請先選擇商品',
  'LAYnKu': '長*寬*高({unit})',
  'LTIAEF': '打包異常',
  'Mw6BFk': '體積({unit})',
  'SA7tfX': '您確定作廢選中的出庫單？',
  'Wb/RGJ': '重量({unit})',
  'Y9zNap': '進倉完成',
  'Zew02R': '您的賬戶余額低於預計凍結金額，將無法提交提貨單，請及時',
  'at3b+O': '進行批次管理的商品【{codes}】暫不支持進行庫間調撥，請修改商品信息。',
  'eO/IUc': '您的賬戶余額',
  'f4sjzU': '寬({unit})',
  'h3KPr3': '海外倉上架完成',
  'i10W+Z': '繼續提交',
  'lrcTTN': '下單導入模板',
  'm8+2gt': '進行多SKU類型管理的商品【{codes}】暫不支持進行庫間調撥，請修改商品信息。',
  'n0frm/': '運送供應商',
  'n6s9y/': '不支持退貨商品',
  'oymnKM': '下調撥單',
  'qYU7sG': '高({unit})',
  'ud12Je': 'Winit跟蹤號',
  'vbbD6x': '調撥產品',
  'w5Q/br': '調撥商品',
  'xi7zM4': '庫間調撥',
  '9i32k6': '預估費用查詢失敗',
  'LLMOrF': '調整前庫存單元數',
  'SUoa+u': '預估金額',
  'ZL+MoW': '切換{field}的同時會將已添加的商品刪除，請確認是否切換{field}',
  'cn9+pn': '可調整庫存單元數(箱/套)',
  'eHEMay': '不能大於可調整庫存單元數(箱/套)',
  'ePmeDm': '拆箱商品逐件清點偏好設置',
  'zv8drN': '當前預約為增值預約，若已收取增值預約費用，取消後將不會退還，確認取消？',
  '88qyGm': '取消預約後如送倉需重新預約，確認取消預約？',
  'DkkSLz': '請閱讀並勾選協議',
  'Ps22Sc': '預計卸貨日期',
  'dIXyA7': '審批說明',
  's6flrP': '此預計卸貨日期為預估時間，需以審批通過時預計卸貨日期為準',
  '+KGCki': '請輸入法人代表護照號',
  '0J80uO': '驗證賬戶使用者身份證號碼',
  '0fSxpD': '歡迎使用萬邑通',
  '0ijY0r': '3. 開通並使用',
  '1Lc3fb': '3. 港澳個人/企業，需要護照/身份證',
  '1Xpl5b': '周一~周六 09:30-18:30',
  '1weoYE': '寄件人手機',
  '21YVhF': '提供清關代理協議和授權委託書',
  '2rhiSN': '恭喜您！已成功提供清關代理協議和授權委託書。',
  '2xgBZt': '銀行預留手機號',
  '4RhMJm': '請選擇營業額',
  '4gzwfO': '省/州',
  '5Br/27': '2. 大陸企業用戶，需要企業法人身份證/護照、營業執照、地址證明',
  '5dIO1y': '《線上小包+服務協議》',
  '6EZQnj': '鑒於萬邑通為貴方提供物流管理服務，就貴方主賬戶（以下簡稱"主賬戶"）和貴方新增子賬戶（以下簡稱"子賬戶"）的關係，貴方聲明並確認如下： 1. 貴方確認主賬戶與子賬戶為同一實際控制人控制或者具有關聯關係。 2. 貴方確認主賬戶對子賬戶因使用萬邑通各項服務而產生的債務承擔連帶保證責任。 3. 主子賬戶在使用萬邑通各項服務的過程中，如出現違規行為（包括但不限於運輸違禁品、侵犯他人知識產權等），萬邑通有權對主子賬戶採取相同的處理措施。',
  '6RGTQg': '如有疑問請聯繫客服',
  '7oM8cP': '是否擁有IT系統開發團隊',
  '7yTSYL': '國際達倉(FBA)服務',
  '8Mpenh': '如開通物權保管單的服務，請點擊右上角【在線諮詢】諮詢',
  '8Pf78d': '1. 選擇服務',
  '90DlR1': '聲明書',
  '9YD9zW': '您也可以：',
  'AT8jzy': '海外倉服務',
  'BFtNdx': '代理協議頁2',
  'BGUkPS': '開通服務諮詢',
  'CzizdQ': '去認證',
  'DJyE9w': '請輸入登錄賬號',
  'DeW7me': '溫馨提示：{break}如果您意向變更關鍵信息（客戶名稱、證件號碼和開戶類型），需要上傳{link}，您可以提前準備此合同簽署後的掃描件。{break}客戶名稱變更審核通過後，原主體的{agency}將失效、相關的{relation}將變為審核不通過，請您及時提供{newAgency}、{newRelation}；{warn}{break}如有疑問請聯繫對應的銷售或客服諮詢。',
  'FHar07': '很抱歉，您的資料審核不通過，請根據以下不通過原因修改後重新提交',
  'FO8HwP': '2. 填寫信息',
  'HdY1ln': '您想使用哪些產品？',
  'HkqhLb': '示例(DE)',
  'IXaNMx': '請填寫完整驗證信息',
  'J5gibL': '您可隨時登錄查看審核進度',
  'KAd/I+': '第1頁示例',
  'KDEGxk': '請提交收件郵件地址',
  'LcjamZ': '企業客戶：請填寫營業執照上完整的公司名稱',
  'M2zKeY': '請填寫銀行卡號',
  'MSqVZ1': '3. 主聯繫人',
  'MYcqLd': '提供',
  'NvdTs3': '進入萬邑通',
  'O9n3RX': '發送驗證碼',
  'OQBTGI': '如果後收到材料，點擊下方【上傳資料】上傳',
  'OdIKCB': '幫助賣家將大宗商品批量運送到國際各品牌跨境電商平臺倉庫配送全球的物流末端服務',
  'Of6YPc': '寄件地址',
  'OkZkZj': '已線下提供，無需郵寄',
  'P/vC/z': '專為輕準電商提供經濟快遞服務國際各品牌跨境電商及買家的最優經濟路線',
  'P37sWB': '1. 提交資料所需要準備的材料',
  'PRzU2R': '已開通服務',
  'PbHiU1': '您的賬戶存在欠費，暫時無法開通新服務，請先完成費用結清。',
  'PnBZCt': '新手指南',
  'QH+N9+': '請上傳所有協議圖片',
  'QUei3X': '請輸入銀行預留手機號',
  'QtI7kN': '文件上傳支持格式：jpg,png,gif,jpeg,bmp，文件大小小於5M',
  'Qtfwk/': '當前資料',
  'R+dDnK': '4. 海外個人用戶，需要護照',
  'SU+VLr': '點擊進入',
  'SUR3uB': '您的主體信息正在變更中，請等待完成後再開通服務',
  'TAeOSl': '代理協議頁3',
  'TOKgDI': '主聯繫人是您在萬邑通的主要聯繫人，系統會將重要通知發送到主聯繫人的郵箱和手機',
  'V8oU7w': '示例(UK)',
  'VGgJF7': '配力購拓展供體運營及鋪配置市場，增長對外貿易服務',
  'WQ6eD4': '法人代表護照掃描件',
  'WgINdV': '查看樣本',
  'XNooSI': '示例(AU)',
  'XjPqWa': '個體客戶所需資料',
  'YXQOSI': '前往變更主體',
  'YaRSs3': '格式不正確',
  'Z0sJ3u': '手機號碼必須為數字',
  'ZtiXo0': '請輸入公司名稱',
  'a3p4+m': '企業客戶所需資料',
  'alScLc': '產品介紹',
  'bXmxV6': '溫馨提示：{break}如果您意向變更關鍵信息（客戶名稱、證件號碼和開戶類型），您需要上傳{link}，需要重新簽署{credit}和{agency}，您的新主體需要提前簽署上述合同並準備掃描件。{break}客戶名稱變更生效後，原主體的清關代理協議將失效，額度協議將失效，相關的主子關係證明將變為審核不通過，請您及時提供新主體的清關代理協議、新主體的額度協議以及新主體的主子關係證明；{warn}{break}如有疑問請聯繫對應的銷售或客服諮詢。',
  'bcO3DM': '代理協議頁1',
  'bhdAVg': '第2頁示例',
  'cS3uAM': '個人客戶：請填寫身份證上的姓名',
  'cT+TM6': '操作失敗！請等待資料審核通過後再簽署清關協議。',
  'cdEZcI': '2. 填寫申請資料',
  'cjVt7P': '壞賬客戶不可用',
  'cr3PBp': '請輸入聯繫人',
  'd0PEzZ': '確定要取消授權嗎？',
  'd5fyCd': '電話客服',
  'dAmvz8': '公司名稱/客戶名稱已存在',
  'dEBQta': '分銷服務',
  'dSKZh7': 'ISP服務',
  'e+pjZj': '請耐心等待...協議約在一個工作日寄到您的郵箱',
  'eFvFoh': '立即開通',
  'etMKVx': '返回重新提交主體資料',
  'frzcHZ': '電商平臺月均營業額',
  'fy+hiL': '1. 大陸個人用戶，需要身份證、地址證明',
  'gAlCCc': '請選擇您所需要的產品服務',
  'jC5PcU': '開通服務所需資料',
  'jfGyLt': '授權委託書頁2',
  'komV6f': '合同及協議編號',
  'l9PDt/': '上傳資料',
  'lKLi66': '操作失敗！請先點擊右上角登錄帳號二級菜單【開通服務指引】開通海外倉服務，再進行此操作。',
  'mcoHvq': '主體資料審核已通過',
  'mh/8yw': '請選擇錢包可消費的國家',
  'mw/y6w': '定義合作有效期的地址',
  'njMKo0': '港澳客戶請按證件上顯示的姓名填寫',
  'nogv8V': '寄件人',
  'nr7bST': '變更了關鍵信息（客戶名稱、證件號碼、開戶類型等）時，請下載"<a>合同主體變更三方協議</a>"簽署並上傳；',
  'ogAJPw': '萬邑通為您提供一站式跨境物流解決方案，包括海外倉儲、國際達倉、ISP小包及分銷等全方位服務。',
  'p8QAaO': '請勾選服務協議',
  'pUZ4q7': '授權委託書頁1',
  'paDSa5': '主聯繫人變更後，系統默認的郵件和短信訂閱以及找回密碼功能將發送到新的聯繫人郵箱和手機號碼，請確認填寫。',
  'pdwVpx': '驗證賬戶使用者身份證有效期',
  'peVto9': '在線解答您的諮詢、辦理、受理',
  'pmOHMy': '我已閱讀並同意{link1}及{link2}',
  'qE1Dl+': '配力購拓展供體運營及鋪配置市場，匹配海外市場分布通渠率，增長對外貿易服務。',
  'r/TTkp': '提供須知',
  'riCoWg': '5. 海外企業用戶，需要企業法人護照、商業登記證',
  'rmsXMq': '查看資料詳情',
  's5woUU': '上傳已簽署的協議回傳件',
  's7aJO6': '銀行卡號',
  'tZBs5t': '開始',
  'tgl43v': '資料已提交成功，我們將在1-2個工作日內完成審核',
  'tjiU4g': '分機',
  'tmuXtr': '專為大賣家提供商品批量運送至海外倉存儲、交易成交後配送至買家及退貨等增值服務',
  'u5ZBsZ': '寄件人郵箱',
  'w52iDk': '合同期限：{startDate} - {endDate}',
  'wJR7KF': '正面示例(頭像面)',
  'x+hx89': '郵寄方式',
  'x2XJq3': '立即諮詢',
  'x88sZJ': '認證',
  'xJoLq6': '反面示例(國徽面)',
  'zMrCID': '新建郵箱地址',
  'ziT67U': '立即授權',
  '0AYQ4O': '新增子帳戶',
  '2UZfqj': '請填寫身份證有效期',
  '2xSZ3s': '如您無需使用富友充值，可忽略此提示。',
  '3Qj8Ey': '檔案上傳支援格式jpg，jpeg，png，pdf，檔案大小小於5M。檔案照片需清晰、完整、無反光。',
  '3YUWW0': '關係證明 (掃描件/影印件/照片均可)',
  '3q8UGf': '請閱讀並勾選確認',
  '4hV2p6': '請輸入緊急聯絡人電話',
  '4ytGna': '請填寫客戶名稱',
  '5xLi4r': '請選擇電商平台月均總營業額',
  '6x+VFm': '本公司/本人亦同意，本帳號的額度可分享至本帳戶組內任一帳號，同時，如帳戶組內任一帳號觸發《擔保協議》的擔保責任，貴司亦有權停止向本帳號的提供服務。',
  '7ayFnj': '請正確填寫客戶名稱，與合約簽約名稱一致，一旦提交將無法修改',
  '8fBHBI': '本公司/本人承諾，該聲明真實有效，如有違背，本公司/本人承擔全部賠償責任。',
  'DTIhVg': '支援 jpg, png, jpeg, pdf 格式，檔案大小不超過5M。檔案照片需清晰、完整、無反光。',
  'EuZwE2': '您大約需要等待1個工作日即可審核完畢，待審核通過後需要完成相關協議簽署，請耐心等待資料審核。',
  'G5rRTS': '身份驗證失敗',
  'HoKcxU': '請輸入收件人Email',
  'I3hgJA': '本公司/本人同意，本帳戶組內任一帳戶可銷售本帳戶庫存，同時，如帳戶組內任一帳號項下的錢包餘額與庫存因故被凍結，貴司均亦有權凍結本司/本人帳號項下的錢包餘額和庫存。',
  'J9BBV7': '如果你已經和編輯協商並簽署了「清關代理協議和授權委託書」，不需要我們線上給你寄送這委託書，請勾選此項。',
  'MFmMMP': '本人/本公司確認，以上資訊真實有效。如有違背，本人/本公司承擔全部賠償責任。',
  'NRyVCE': '子帳戶當前僅支援出庫和退貨業務，選擇國家，表示子帳戶僅支援所選國家倉庫的出庫單。比如：選擇US，所有US倉的出庫單均可以歸屬到當前子帳戶',
  'QSApnT': '壞帳客戶不允許新增子帳戶',
  'RPyXoX': '該名稱已存在，請確認',
  'Rv++fr': '已邀請',
  'T2cK0M': '合約有效期',
  'Vw5IgN': '收件聯絡人姓名',
  'XBLRbl': '請輸入收件聯絡人姓名',
  'Y/0iZJ': '詳情請見萬邑聯公告：',
  'YAlOmH': '身份證號',
  'YDux6E': '帳號名稱',
  'ZQYAGh': '線下已提供',
  'ZurE3P': '資料提交成功！',
  'eGO5h/': '該名稱已被使用',
  'erj1yA': '該手機號已被註冊',
  'lzseXh': '該證件號碼已存在，請確認',
  'nOKRRS': '如開通過程有任何疑問，請點擊右上角【線上諮詢(AI)】諮詢。',
  'o3inPO': '請正確填寫公司名稱，與合約簽約名稱一致，一旦提交將無法修改',
  'pwiaf4': '注意：接受邀請並驗證通過，則此帳戶作為該帳戶的子帳戶，無法再接受其他邀請。',
  'q7wQgd': '{countdown} 秒後自動跳轉，立即跳轉',
  'qBz+pd': '身份證與姓名不匹配',
  'rT+IsV': '請輸入緊急聯絡人',
  'sVbO2z': '提交身份驗證',
  'seQfmX': '提交關聯證明',
  'sneOFd': '聲明函',
  'vKNDOz': '開通時間',
  'xxmXbQ': '請上傳關係證明檔案',
  'z259bI': '邀請失敗',
  'zALLNK': '因富友支付渠道人民幣出境的政策要求，需要對大陸-企業客戶和大陸-個人客戶的相關資料項做有效性、完整性校驗。提交資料時請您提前確認資料的有效性，建議提供最新的資料檔案，否則將無法使用富友充值，甚至面臨充值失敗退回的風險。',
  'zUaBWY': '邀請',
  'RMSKAT': '每個客戶僅能申請一次變更名稱或類型，您已變更過一次，不支持再次變更，如有疑問請諮詢客服。',
  '7MLoBp': '訂單【{orderNo}】不滿足預約條件或不存在，請檢查',
  'LJBSgJ': '共 {total} 條',
  'QBGTlS': '訂單號不能為空',
  'UzRdmP': '{num}、如是整櫃DROP卸貨，請準確填寫聯繫人、聯繫電話、郵箱等信息，倉庫將按照聯繫人信息通知提回空櫃。',
  'apXnDe': '訂單號不能超過100個',
  'jqi6+v': '所選訂單的目的倉不一致，無法創建預約單',
  '1c6LDN': '客製包材編碼',
  '2gEo49': '訂單明確指定場景',
  '35dnG8': '作廢訂單：',
  '3Q3MF1': '更換WINIT包材：',
  '53MVz2': '保存配置',
  '6x0xR6': '規則說明：',
  '7mBmA2': '報錯提示',
  '7zxWzW': '包材排除配置',
  '9/2b1I': '衝突處理方式',
  'A9n84m': '說明：出客製包材庫存不足時，系統將按以下配置處理訂單，未配置則默認「作廢訂單」。',
  'DBDOxo': '客製包材',
  'EDhiUB': '配置保存後將自動推送雲倉系統。',
  'FJzTjL': '請選擇打包方式',
  'G7MDWq': '編輯排除規則',
  'HT7nGY': '直接下單',
  'I3vZ/T': '請選擇客製包材編碼',
  'IFB2eq': '新增排除規則',
  'L3SPWo': '當訂單/SKU指定包材與排除規則衝突時，按規則中配置的「衝突處理方式」執行。',
  'LrThAO': '命中排除規則的包材不參與智能推薦和下單選擇。',
  'N98qnm': '請輸入規則名稱，不可重複',
  'OKWdoC': '選擇需要排除的包材規格',
  'PCZwld': '客製包材缺量處理方式',
  'SoPUpI': '出庫加包裝配置',
  'TSXSjM': 'WINIT包材規格',
  'UrE8yI': '訂單下單時報錯攔截，提示用戶「指定包材與排除規則衝突，請更換包材」。適用於需要用戶確認的場景',
  'UxZZYu': 'WINIT包材規格 和 客製包材編碼 為選填項，但必須填寫其中一項',
  'VVu71G': '更換WINIT包材',
  'YCbLtb': '客製包材缺量時直接作廢訂單，雲倉不發貨',
  'YVtXEN': '一單多包裹打包客製包材缺量時默認更換WINIT包材之庫，不支持設置操作訂單',
  'bWd3aD': '排除包材',
  'cmaIxX': 'WINIT包材規格 和 客製包材編碼 必須填寫其中一項',
  'fqrDS1': '下發提示：',
  'k7epGn': '配置保存後將自動推送雲倉系統',
  'khGlAG': '客製包材缺量時倉庫自行換成合適的WINIT標準包材繼續出庫',
  'mTsgKL': '配置包材排除規則和客製包材缺量處理方案',
  'u6CUJT': '衝突處理',
  'v+NFbW': '排除規則',
  'xeTVHA': '排除條件',
  'yoWkrt': '訂單/SKU指定的包材符合包材排除規則時，以訂單/SKU指定的包材下單',
  'z58bKI': '衝突處理：',
  'w6lsmO': '1. 請務必填寫客戶訂單號，這是必填項。{break} 2. 所有上傳的訂單必須選擇相同的倉庫，如果訂單涉及不同出庫倉庫，請分開提交。{break} 3. 每次最多可導入200個訂單，文件大小限制為5M。如果文件過大，請分割成多個文件逐批上傳。{break} 4. 操作步驟：先上傳批量模板文件，然後提交增值服務，最後點擊確認。{break}',
  '7H1d1S': '異常類型 TOP 5',
  'I5RfGb': '確定處理嗎？',
  'PAWk7K': '本日新增',
  't/TC7E': '操作狀態',
  '1tzsQb': '港澳臺身份證明',
  'HA7GIy': '其他證件',
  'KTfVtd': '社保證明/勞動合同',
  'ewq7ga': '戶口本',
  'hlPhA8': '請填寫訂單包裝對應的包材類型',
  's5WurW': '結婚證',
  '/7etjS': '選中棄置',
  '3zg9jr': '棄置完成',
  '7oFoNK': '第二步:創建非標增值單',
  '8vOmaS': '全部棄置',
  'L1RpeK': '棄置',
  'RlJdy9': '請創建非標增值單，若未正常創建，後續訂單無法正常進行',
  'WmoT2W': '下載銷毀憑證',
  'XztFHH': '出庫單操作指引',
  'Z/oOll': '基於出庫單資訊, 創建非標增值單。',
  'jqT0Ti': '填寫收貨地址和出庫SKU資訊, 選擇產品【出標/增值】, 提交出庫單。',
  'neKvVH': '處置出庫',
  'oEK6zS': '在Winit海外倉當中的滯銷品進行銷毀或棄置處理,從而減少賣家庫存及倉儲費',
  'ozcVKW': '已完成第一步, 請繼續創建非標增值單',
  'qEMCPi': '創建非標增值單',
  '1PSjMh': '注意：未創建非標增值單，訂單將無法繼續安排處理。',
  'Ck4MBK': '出庫單已成功提交（當前狀態：出庫確認中）！',
  'M+ttFe': '將在庫滯銷或不良庫存進行棄置或銷毀處理，幫助賣家快速釋放庫存並減少倉儲費。',
  'rQpp0X': '專業銷毀操作指引',
  'wQcQi0': '客戶放棄指定庫存貨物的所有權及後續處置權，由 WINIT 對貨物進行自主處置。處置方式可能包括合規轉售、資源回收利用或環保處理。',
  'yBmy5W': '對庫存貨物進行物理破壞或交由專業機構無害化處置，確保徹底無法二次銷售，處理完成後將出具相應的銷毀證明。',
  'yg+Zko': '由於專業銷毀屬於線下定製化服務，需委託第三方資質機構處理，且不同品類（如普貨/危廢/TS合規）的處理標準與費用存在差異，請繼續創建非標增值單以確認銷毀方案與服務報價。',
  'HlmrMx': '聯行號',
  'S+8BUO': '請填寫訂單包裝對應的包材類型',
  'uq5Uzv': '銀行代碼',
  'y/6o2M': '開戶名',
  '3/P5TI': '待寄件',
  'jD1Oyu': '已寄件',
  'nTvggn': '待查件',
  'r1mcOg': '待收件',
  '8WhlVp': '1、請上傳最新版營業執照。（避免後續無法使用富友充值，或富友充值無法到賬被退回）',
  'in6pv9': '2、文件上傳支持格式 jpg, png, gif, jpeg, bmp，單個文件小於5M',
  '+u4OEX': '增值附件',
  '/+KIkw': '請輸入電話',
  '2LR7Bk': '切換盤點方式將清空商品明細，確認切換?',
  '6sLMW0': '盤點結果明細',
  '78f9nf': '預估盤點的理論工時時長：',
  '7U4OZ3': '盤點類型',
  '83xMhL': '是否全部庫存盤點',
  'ALCnoI': '到倉人員',
  'AZW0JL': '外箱條碼',
  'ChOVyr': '盤點方式',
  'EtaVvI': '箱內商品盤點結果',
  'GJCFCQ': '請選擇關聯賬號',
  'GKsEYw': '動態盤點：客戶無需停止推單；靜態盤點：盤點期間出庫確認環節將被攔截',
  'GMtO6C': '盤點SI總數（下單|實際）',
  'H3sCL2': '少貨',
  'HoKTsV': '查看增值結果',
  'IRWpZq': '刪除盤點客戶將清空商品，確認刪除盤點客戶？',
  'KGFzKs': '箱內商品庫存差異件數',
  'Ka/Io8': '盤點正本快遞資訊',
  'M6PlA2': '切換快捷下單方式將清空商品明細，確認切換？',
  'Me/sPx': '箱產品逐件清點明細',
  'MtOFjZ': '箱內商品庫存在庫數量',
  'N+bIJl': '盤點準確率（SKU數）',
  'NPXmOW': '新增人員',
  'OuafM9': '請至少添加一位到倉人員',
  'QBn98f': '快遞費',
  'Tbnf1W': '所選時間不在該倉庫可用盤點時間內，提交後將觸發審批流程，由運營人員在後台審批通過後才能下發增值單；該倉庫正常上班時間為：{workTime}',
  'UwfpmS': '自定義屬性',
  'WEo103': '更換倉庫將清空商品明細，確認更換倉庫？',
  'Z/iCTZ': '期望結束時間必須大於期望開始時間',
  'cjiBb5': '盤點客戶賬號',
  'dwlSYa': '差異件數',
  'eXAo9i': '箱內商品實際盤點數量',
  'evYjxL': '準確',
  'f5aifa': '張',
  'iSWFr7': '盤點單品明細',
  'lAeyEd': '商品編碼[{merchandiseCode}]規格[{specification}]在庫庫存不足，請您修改後再下單',
  'lBNsWH': '盤點單號',
  'mVdFCk': '預估盤點的理論工時時長',
  'nskr0G': '盤點方式在第一步選擇，如需修改請返回上一步',
  'p5sT8O': '盤點結果',
  'pUWFPW': '盤點SKU數',
  'qfntuf': '費用=盤點總工時×增值工時費',
  'r0hf7Y': '年/月/日',
  'rGqmhK': '庫位',
  'rj0CJB': '請選擇拜訪日期',
  'rx76l3': '期望開始時間必須小於期望結束時間',
  't0C80u': '盤點準確率（SI數）',
  'vW8q5o': '拜訪日期',
  'w9FoQd': '多貨',
  'wErrs4': '該功能未開放，敬請期待',
  'wzHNwV': '快遞面單圖片',
  'xK/w2b': '在庫庫存不足，請您修改後再下單。',
  'xS0ers': '盤點SI總數(下單|實際)',
  'yiElpc': '客戶指定分組數不能超過到倉人數({count})',
  'zsVDet': '實際盤點數量',
  '2umuoE': '提前提供抽盤比例，以便倉庫預估人力安排。',
  '98/n0f': '提示：因抽盤貨物需盤點當日現場指定，當前無法預先估算費用，最終收費以當天實際盤點數量為準。',
  'bqP00r': '審計人員如到現場，請告知需要幾組盤點人員，倉庫將提前按組配備盤點人員。',
  'hcxV9X': '可多選當前客戶的關聯帳號進行盤點',
  'qzsQNP': '盤點期間拍攝的所有照片僅供本次盤點記錄與核對使用，請勿對外發佈或用於其他用途。如因對外洩露引發任何糾紛或損失，萬邑通有權追究相應責任。',
  'sO8GLG': '如您需要將盤點簽字正本郵寄至指定地址，將涉及以下收費：·WINIT承運：由萬邑通安排郵寄，相關快遞費用將向您收取。·WINIT無法承運：客戶需自行提供發運面單並預約供應商上門提貨，萬邑通將收取協助交運的附加服務費。',
  'tZJUhF': '說明：將同一SKU在不同庫位的盤點數據匯總合併，便於從商品維度查看整體盤點結果。',
  'wC9qVV': '盤點結果明細（按SKU匯總）',
  'g9nrIG': '盤點SI總數（在庫|實際）',
  'Xr3iLB': '指定UN編碼',
  'jVeNe7': '商品資訊維護的UN編碼',
  '5Y0NX/': '帶電附屬資訊',
  'diePMJ': '請輸入大於等於1的整數',
  '0Bl1I/': '未申請，取消變更',
  '1+EFeX': '變更客戶名稱後，信用額度將暫停使用。如需繼續使用額度服務，請在變更前申請新協議。',
  '2VuMXA': '同一集團/同一控股人關係需提交兩份材料，缺一不可：① 萬邑通模板聲明文件（需雙方蓋章）② 第三方關係證明材料（如企查查截圖）',
  '2rtqtD': '提貨車型',
  '3XqWd1': '請上傳萬邑通模板聲明文件',
  '4AqZuL': '申請代客索賠（需您到代客索賠管理人工創建代客索賠申請單）',
  '50FxDt': '頭程詢價報價 <span>(實際打托數量會影響最終頭程費用，請確認報價的單價，以實際扣費金額為準)</span>',
  '5QgGeE': '目標到倉時間',
  '6ngvxG': '本地攬收地址',
  '7CgrYB': '帳號異常，請聯繫您的銷售代表{salerInfo}',
  'ATqkIU': '確認處理方式',
  'CgGs+i': '提貨地址類型',
  'DhscDp': '申請代客索賠-自動生成索賠申請草稿單（注意：此方式仍需要您到代客索賠管理補充索賠信息及資料後確認提交。）',
  'EX9Om/': '倉庫收貨地址',
  'F0XcGu': '導出全部失敗記錄',
  'FhwORH': '預估頭程費用',
  'KlYmmc': '重新提交證明',
  'M5I+Tc': '快捷操作',
  'NJ/NF/': '檢測到以下運單已超時，支持索賠',
  'NeFbk5': '已申請新協議',
  'NmMPWV': '預計攬收時間（本地時間）',
  'OVRt0j': '收貨倉庫',
  'R68w20': '前往代客索賠',
  'Ryn9QL': '請提供甲乙公司實為同一集團/同一法人/同一股東/同一控股人的證明材料；如：企查查內公司法人/股東截圖。支持格式jpg，jpeg，png，pdf，文件大小小於5M。',
  'S68Ovq': '取消變更',
  'STkN9e': '運單數量',
  'TB1zPI': '檢測結果',
  'U9tgAX': '【材料一】WINIT模版證明文件',
  'UTbJVx': '是否存在DG商品',
  'Udgm+Y': '時間與備註',
  'XCM+/O': '確認進行客戶名稱變更？變更後信用額度將暫停使用，直至新協議生效。',
  'Xq6UP0': '請為所有行選擇處理方式',
  'Z+7bu2': '預計攬收時間',
  'cjZZ0V': '頭程詢價報價',
  'd+4/21': '是否需要尾板',
  'fIt5Xg': '請下載附件模板，填寫完整並加蓋雙方公章後上傳。支持格式jpg，jpeg，png，pdf，文件大小小於5M。',
  'hV2Ott': '實際頭程費用',
  'hVF3KL': '支持 jpg, png, jpeg, pdf 格式',
  'haFwvF': '請選擇您的處理方式',
  'iyFbgI': '【材料二】證明文件截圖',
  'kt3jz+': '繼續提交查件申請',
  'm37N51': '目標到倉時間（本地時間）',
  'm3931M': '前往標準索賠',
  'nHw56+': '街道',
  'owsVek': '建議處理方式',
  'qQ3ujN': '請上傳關係證明材料',
  'rKSG5U': '攬收貨物信息',
  'uIzYCq': '確認變更',
  'vJupx8': '驗證信息人身份證有效期',
  'wL2135': '無需處理',
  '/On9qX': '預約模式',
  'v+v1Hz': '越庫/合流預約',
  '4PTy7k': '普通入庫預約',
  'xYiYWb': '預約總件數',
  'X4Y2RY': '出庫件數',
  'WV+ROF': '當前預約單已過允許取消時間（當地時間預約送倉日期前 {advanceDateQty} 個工作日{cancelTime}點），如確認取消將收違規則取消預約費用（{currency}）：{amount}，確認取消預約？',
  '09d8/y': '請選擇時段',
  '2kn2QD': '出庫單類型',
  '9SQhL0': '客戶波次號',
  'Fl0md0': '越庫包裹來源',
  'I32zDQ': '是否越庫訂單',
  'MQRJm/': 'Winit波次號',
  'VsvL0B': '預約件數',
  'ZRZ2D4': '出庫單件數',
  'c/r3gS': '包裹履約方式',
  'jWGCbt': '純越庫訂單',
  'kFKQU4': '越庫在庫混合訂單',
  'm1EQXR': '越庫入庫單【{crossOrders}】和普通入庫單【{normalOrders}】不能混合預約',
  'nraiDe': '可預約(件)',
  'oLh6eL': '越庫類型',
  'rcGMvc': '波次信息',
  'x6qgBE': '包裹卸貨時間',
  'z5BWKU': 'Winit波次到倉時間',
  '/F5P6C': '可選條碼位置',
  '/RSLq0': '文件上傳支持格式 jpg, png, gif, jpeg, bmp, 文件大小小於5M。',
  '3FqV77': '完整條碼（掃描原始值）',
  '7ZFWJJ': '請從左側選擇條碼位置',
  '7fuevf': '您可以通過拖拽調整質檢類型、檢查分組和檢查項目的排序',
  '8OBdgQ': '退貨序列號',
  'AmumwD': '表達式',
  'C/PA/R': '重置為默認順序',
  'EnXlhr': '存儲字段',
  'FeGA3a': '同步範圍',
  'FqK9c4': '確認並保存',
  'IQ0HLa': '添加樣本',
  'J8oiXY': '附加增值服務',
  'LUSqnQ': '請先生成有效規則',
  'LuPAIp': '採集說明',
  'OdhwLg': '生成規則',
  'TPATep': '當前已保存規則',
  'Tf+EeR': '識別條碼位置',
  'V91z5g': '僅在退貨處理作業環節生效。啟用後可指定條碼所在位置及掃描優先級，引導倉庫準確找到條碼。',
  'V98Jt3': '更換包裝',
  'Vesyaw': '至少需要3組樣本',
  'VyjPWN': '全部展開',
  'WLT41E': '僅在退貨處理作業環節生效。啟用後可設定截取邏輯，從掃描原始值中提取出商品條碼用於匹配。',
  'WxVFaa': '請輸入多組樣本：左列填掃描到的完整條碼，右列填期望提取出的商品條碼。系統自動推導截取規則，輸入越多越準確（建議至少3組）。',
  'YPWr5t': '當前方案未選擇「包裝檢查」分組，請配置包裝處理方式',
  'byRQrX': '保留原包裝可能存在破損/污損風險，可能影響二次銷售',
  'epxUn5': '每個已選位置都必須上傳圖片',
  'fFfZBY': '推導成功',
  'gJDiKh': '包裝處理方式',
  'is41YI': '配置變更實時同步至海外倉（CWM）',
  'j7wLuz': '全部收起',
  'kC/jbD': '條碼截取規則',
  'kqoce7': '商品條碼（期望截取結果）',
  'oHyBI0': '查詢支持',
  'oO+ieb': '包裝處理配置',
  'odD6mi': '請至少輸入3組有效樣本',
  'py/we0': '存在未填寫完整的樣本行，請填寫完整或刪除多餘行',
  'qJmtAN': '啟用時必須配置至少一個條碼位置',
  'qa14Fy': '替換圖片',
  'qxbg6U': '已選位置（拖拽排序，序號=優先級）',
  'raE12f': '圖片大小不能超過5M',
  'tuGlzF': '{projectCount}個分組，{itemCount}個檢查項目',
  'u7LJPC': '補貼商品條碼',
  'vab3GQ': '上傳圖片',
  'vbQVrq': '條碼採集',
  'yIRROV': '檢查分組下的必檢項目，不支持刪除！',
  'zmdHfX': '{count}個檢查項目',
  'zvxx4M': '如需修改，請重新輸入樣本並生成規則',
  'ETrVHz': '此配置僅在退貨處理環節生效。請選擇商品條碼所處的實際位置，並設定掃描的優先順序，以便操作員快速、準確地找到條碼。WINIT 將盡量按此配置執行作業。本配置為操作指引，最終處理結果以現場實際操作為準。',
  'pf1Kiz': '此配置僅在退貨處理環節生效。啟用後，WINIT 將自動記錄完整的原始掃描碼，作為退貨序列號記錄。',
  'xYS0LQ': '此配置僅在退貨處理環節生效。請輸入您截取前的號碼以及截取後的號碼案例，WINIT就根據您提供的案例自動推導出截取規則，規則生效後，現場將按照截取後的條碼進行作業操作。',
  'KJAQ59': '條碼採集（退貨序列號記錄）',
  'imC1Uc': '退貨訂單列表可按退貨序列號精準查詢',
  'kTIdLR': '僅在退貨處理作業環節生效。啟用後倉庫掃描的原始碼將作為退貨序列號回傳並綁定到對應庫存。',
  'vHRJyo': '啟用後，倉庫在退貨收貨環節掃描到的完整原始條碼將被記錄為該商品的退貨序列號（唯一碼），並通過系統回傳綁定到對應庫存記錄。',
  'gRDR6v': '退貨序列號（collectGoodsBarcode）',
  '/Bv6+f': '主體變更審核通過後，當前賬戶被分配的這部分額度將被立即暫停，在主子關係審核通過後，被暫停的額度才會恢復！',
  '44PnfQ': '未申請',
  'GZX8nB': '導入組合商品',
  'Np2ifd': '退費金額',
  'O47wOv': '額度提示',
  'POitLI': '首次申訴信息：',
  'Z555H+': '主體變更審核通過後，額度將於審核通過當天的23:59:59失效！您是否已申請新主體的額度？',
  'g/G0D9': '申訴類型',
  'jwRl9i': '結果時間',
  'oZm0IU': '下載組合商品導入模板',
  'sbnNMK': '上次申訴信息：',
  'wBalnh': '新主體變更生效後，新額度協議審核配置約需3個工作日，額度在審核及配置期間將暫停。若無異議，請繼續操作。',
  'x/bJdB': '使用範圍：當一個平台商品對應多個萬邑通商品。',
  '/Axoyw': '發起成功',
  'F3k4N8': '發起庫內複覈',
  'RPlhiI': '佔用庫位數量',
  'cs8RMy': '請輸入商品條碼',
  'eT8fYP': '請選擇複覈倉庫',
  'i35X4Z': 'winit批次號',
  'qmps2V': '庫位計費明細',
  '5exYYY': '產品批號',
  'SST615': '單件商品體積(CBM)',
  '1OnAvh': '滿足此單需最低配置額度至:',
  'A5U/MC': '額度缺口:',
  'TcelN2': '當前訂單佔用:',
  'WjVYaQ': '當前已使用（不含此單）:',
  '0f2PTD': '該費用僅為預估費用，若您未預約送倉將按照未預約收費',
  'FiMb3G': '需折疊商品列表（共{count}個）',
  'mLL5e4': '需折疊商品：',
  '/WTGil': '尊敬的客戶，您好！我們已提取到您提交異常的訂單（單號：{orderNo}）的打包發貨視頻，經分析：',
  '/cG8F3': 'Winit海外倉原因導致發漏貨物。產生串貨的情況，或者發漏給買家的情況。',
  '18FqUS': '注：只允許派送中、派送成功、派送失敗的包裹申請{type}貨物',
  '1sSVAc': '錯發',
  '6QWeU+': '如果您對分析結果有異議，仍可繼續提交索賠申請，請上傳相關證明附件。',
  '75l/Ac': '視頻獲取後將自動進行分析，屆時請關注狀態變更通知。',
  '9JN3xh': '請先查看或下載出庫視頻後，再提交索賠申請',
  'Fstkz3': '待確認視頻調查結果',
  'HZEoZT': '出庫視頻調查中',
  'HkZoUO': '在線查看',
  'IHNzKZ': '經以上視頻分析，初步判斷未出現您提到的商品錯發/漏發',
  'IlwOEh': '出庫視頻分析結果',
  'KXSeuQ': '此附件指，買家投訴{type}貨的郵件（能清晰識別到快遞單號/ winit訂單號 / 賣家訂單號 / 電商平台交易單號比如ebay TransactionID, ItemID)',
  'OVIKXM': '獲取視頻下載鏈接失敗',
  'S+R2AK': '索賠單號：{serial_number}',
  'UMyC/x': '經以上視頻分析，初步判斷出現了您提到的商品錯發/漏發',
  'VOpmmN': '查看索賠列表',
  'VlsVYE': '提交成功，我公司需要進一步對是否錯發/漏發做人工分析，請您耐心等待，我們會盡快反饋。',
  'WJz4ka': '該訂單暫無出庫視頻，系統已自動創建視頻查詢任務。',
  'fYJd5n': '1. 面單照片（可見Winit出庫單號或快遞單號）{break}2. 收到所有單品的清晰M碼或S碼照片{break}3. 包裹及實物照片。{break}注：如買家/賣家無法提供面單照片和收到貨物的清晰M碼或S碼照片：請聯繫Winit客服調查，如Winit客服確認倉庫漏發，將主動發起賠付，並且於確認後的五個工作日內賠償到賬。{break} 1）原出庫單號；{break} 2）收到貨物的包裹及實物照片； {break}3）買家向賣家投訴收到漏貨的溝通截圖。',
  'gfwt4b': '我已知曉，取消索賠',
  'hUNff2': '視頻分析時間線（倉庫當地時間）：',
  'lps+xX': '仍要提交索賠',
  'pLFSsa': '1、客戶不能提供Wint所要求的證明文件或者索賠申請文件；{break}2、超索賠受理時效，不予賠付。具體索賠受理時效請以Winit最新公布價卡為準。',
  's3T3pR': '索賠單將進入質控審核環節，質控人員將調取視頻進行人工複核。',
  'sPHPen': '出庫視頻:',
  'vP8rqE': '漏發',
  'vhT71n': '請先點擊右上角登入帳號二級選單【開通服務指引】開通海外倉服務，再進行此操作。',
  'Zq+Se6': '在 {scanTime}，員工對商品 {merchandiseSerno}（{merchandiseName}）進行掃描複核（第{sequence}件）',
  '+VCZz4': '修改後的Winit產品',
  '1Ao7np': '單次最多200單，所有字段均為必填。',
  '1d6EK6': '第{num}行目的港「{port}」不在可選範圍內，請從下拉選項中選擇',
  '2gBezr': '第{num}行預計到港時間格式不正確，請使用 YYYY-MM-DD HH:mm 格式',
  '7J1W1n': '根據入庫單的驗貨類型選擇對應產品，同一批次僅支持相同頭程類型的入庫單',
  '8MEOQq': '預計到港時間(北京時間)',
  '8nD5JW': '從Excel複製後點擊第一個單元格，按Ctrl+V貼上即可自動填入多行多列',
  '9AGywt': '請選擇修改後的Winit產品',
  'Kf4Oor': '請填寫入庫單信息',
  'PMapov': '單次最多200單，支持換行、逗號、空格分隔',
  'PqD7nU': '請輸入入庫單號',
  'R3d2Zf': '修改Winit整柜港提派',
  'XBtag+': '修改類型後將清空已填寫內容，請確認？',
  'Zdsm2X': '修改Winit產品後將清空已填寫內容，請確認？',
  'e/EtSz': '第{num}行存在未填寫的必填字段',
  'iTLwLH': '提交修改',
  'rUzgju': '批量修改訂單',
  'xWNt8l': '修改100%A+/A包裹（無包裹條碼）',
  'zqILSF': '單次最多200單',
  'g/Za+0': '支持從Excel直接複製貼上，按Tab分列、換行分行自動填入。',
  '0NaB0z': '請輸入Winit入庫單號，單次最多200單，支持換行、逗號、空格分隔',
  'bYsu3+': 'API无箱单下单自动拆分识别码',
  'ydktLD': '分隔符',
  'korflh': '<title>备注：</title>{break}<span>您开启此偏好后，请维护对应的拆分分隔符号，系统将根据您维护的分隔符号进行拆分。{break}分隔符格式：支持最大长度10字符，不允许包含字母，数字。{break}如维护英文逗号“,”，针对无箱单预报单，若您API下单传参了多个识别码，系统将自动按照英文逗号拆分进行下单。{break}举例：若识别码传参为【00340312892440215576,00340312892440215601】，系统将自动拆分成【00340312892440215576】和【00340312892440215601】两个识别码进行下单。</span>',
  'bbQdax': '入庫單號重複：{nos}，請檢查後重新提交',
  '/HL9iL': '<title>備註：</title>{break}<span>您開啟此偏好後，請維護對應的拆分分隔符號，系統將根據您維護的分隔符號進行拆分。{break}分隔符格式：支援最大長度10字元，不允許包含字母、數字。{break}如維護英文逗號","，針對無箱單預報單，若您API下單傳參了多個識別碼，系統將自動按照英文逗號拆分進行下單。{break}舉例：若識別碼傳參為【00340312892440215576,00340312892440215601】，系統將自動拆分成【00340312892440215576】和【00340312892440215601】兩個識別碼進行下單。</span>',
  '2nM0La': '請輸入分隔符',
  'K2BzuE': '入庫單號重複：{nos}，請檢查後重新提交',
  'ae3z74': '分隔符最大支援10字元',
  'dWBLP6': '主子關係證明未審覈通過，請重新提交主子關係證明並等審覈通過再操作',
  '1hZYqM': '主子關係證明審覈不通過不允許提交，請提交主子關係證明並等審覈通過再操作',
  'FhyCgU': '您的報價已確認；{break}WINIT倉庫將聯繫您填寫的提貨聯繫人，確認最終攬收時間及預計到倉時間。請您創建預約單並按照預計到倉時間進行預約；請下載附件BOL作為提貨交接憑證。提貨當天，WINIT將使用BOL紙質單據進行現場交接和簽收確認。',
  'PwoQ9d': '下載BOL提貨憑證',
  'PYH+gX': '不推薦產品（使用訂單產品）只推薦倉庫',
  'Q0smbN': '（2）如果下單時指定產品資訊，則會遇到訂單產品出現多個產品組情況，處理方式選擇下單報錯則遇到這種情況直接下單失敗，處理方式選擇不推薦產品（使用訂單產品）只推薦倉庫，下單不會失敗，訂單直接使用指定的產品出庫，不會使用智能推薦功能去選擇最優的產品出庫',
  '4QtXfF': '客戶放棄指定庫存貨物的所有權及後續處置權，由 WINIT 對貨物進行自主處置。處置方式可能包括資源回收或環保處理。 ',
  '+NIPLv': '報關補充信息',
  '+yabwR': '關聯入庫單：',
  '/nQkzo': '駁回',
  '1XOnrV': '上傳報關資料',
  '1Xk/0Q': '該報關資料同時關聯了 {count} 個入庫單：{orders}',
  '36iBqe': '支持 xlsx / xls 格式',
  '3KtggC': '審核人：',
  '3YYYgM': '駁回後，系統將自動發送駁回通知郵件至報關行（包含駁回原因），並抄送客戶。報關行修正後將重新出具預錄單。',
  '3nxaFG': '備注不能超過2000字符',
  '64CZXO': '修正後重新上傳將同步更新所有關聯訂單。',
  '6aRJjQ': '點擊或拖拽文件上傳附件',
  '6gZ3dk': '商品{no}：{name}',
  '6y2aQX': '9810/9710關聯單號',
  '8WMnSl': '未填寫，',
  '9Obhoh': '請輸入駁回原因',
  '9TAz6Y': '導入提示',
  '9opxaf': '共校驗 {total} 項，通過 {pass} 項，不通過 {fail} 項',
  'AQ9twL': '暫無審核記錄',
  'BbyQrr': '第三步：上傳報關資料（',
  'BjcN87': 'AI審核不通過',
  'DJq/pp': '駁回原因',
  'EHEJCe': '駁回原因不能超過500字符',
  'Ei7lyw': '下載報關信息模板',
  'G4a26M': '填寫"{value}"，',
  'HwOzec': '報關資料信息',
  'ICeSwc': '請輸入正確的郵箱格式',
  'J0ZKwN': '多個郵箱用逗號分隔',
  'JMshma': '確認駁回',
  'JOqHcX': '人工審核不通過',
  'JSzuMh': '表頭',
  'JTfWyA': '請上傳Excel文件',
  'KbVEHM': '報關資料表頭信息校驗（{count}項）',
  'Kj9Usf': '當前版本',
  'LPOKOG': '報關資料已通過AI審核，已自動進入待發送隊列。系統將在配載完成後自動發送至報關行。',
  'MFgDzg': '搜索或輸入入庫單號',
  'NMLDeP': '上傳附件：',
  'O2I3YI': '請輸入聯系郵箱',
  'Ou2Wt3': '審核類型：',
  'PRRcLo': 'AI審核通過',
  'Pzur0w': '支持 jpg/gif/png/jpeg/pdf/doc/docx/xls/csv/xlsx 格式，可多文件上傳',
  'RaguVe': '點擊此區域上傳',
  'T4fH20': '上傳報關資料附件',
  'UVi3d0': '審核時間：',
  'Ub9kru': '不支持該文件格式，請上傳jpg/gif/png/jpeg/pdf/doc/docx/xls/csv/xlsx格式的文件。',
  'UcM4B/': '暫無報關資料',
  'UzmisV': '預錄單附件',
  'VGoWnS': '人工審核結果',
  'VK50At': '報關資料',
  'VX2B6y': '9810/9710 訂單編號（非必填）',
  'VnKOxH': '第壹步：下載導入模板',
  'WTLdPG': 'AI審核',
  'WW7GfS': '報關資料審核通過',
  'WfS4rv': '操作人：',
  'WyB8ig': '報關資料表體信息校驗（{fieldCount}項 × {itemCount}條商品）',
  'Xgj8wy': '駁回預錄單',
  'Y5h3t2': '確認預錄單',
  'YVdj/s': '確認導入',
  'YcKsDx': '9810/9710訂單編號',
  'cf+Gh6': '當前版本附件',
  'dKY1TQ': '請上傳報關資料附件',
  'dc4Xir': '關聯入庫單',
  'de8EBC': '客戶訂單號：',
  'fBdsjg': '單壹窗口E編碼',
  'foYkxO': '請輸入備注信息（選填）',
  'g1cKwj': '暫無版本記錄',
  'h8e2WN': '附件數量已達上限（10個），請刪除後重新上傳',
  'ib4rj9': '判定依據',
  'jIpNnE': '必填）',
  'jO9shU': '（根據入庫單號自動帶出）',
  'jjo9Gz': 'AI審核結果',
  'kle3CD': '人工審核',
  'lZFv6p': '上傳資料時自動帶入，不可編輯，自動更新',
  'lipHr3': '請上傳報關資料',
  'nEvz7V': '駁回原因：',
  'oBTdvg': '請填寫駁回預錄單的原因，報關行將收到此內容...',
  'ogt+tK': '確認上傳',
  'pFP+/B': '單壹窗口E編碼（非必填）',
  'pxnIia': '報關資料狀態',
  'qODon7': 'AI審核不通過，需修正後重新上傳',
  's5+02b': '人工審核通過',
  'sy7m/m': '支持jpg/png/jpeg/pdf/doc/docx/xls/csv/xlsx格式文件，可多文件同時上傳',
  'u12O09': '校驗項',
  'uRhhXO': '曆史報關資料',
  'vgp2rG': '批量上傳報關資料',
  'wWOv+i': '請修正以上問題後，點擊「重新上傳資料」提交新版本',
  'xRxIHw': '下載報關資料模板',
  'yd14jk': '導入成功，共上傳 {count} 條記錄',
  'ypUU3i': '文件大小超過10MB，請壓縮後重新上傳',
  'zof5x4': '第二步：上傳填寫好的Excel文件（',
  'zuc4Gg': '支持上傳報關資料的訂單列表',
  '25BYK8': '軌跡變更日誌',
  '8Q4uC2': '客戶放棄指定庫存貨物的所有權及後續處置權，由 WINIT 對貨物進行自主處置。處置方式包括資源回收利用或環保處理等。',
  'GZLZSR': '修改次序',
  'RuItAS': '修改前時間',
  'dHOT0C': '修改原因',
  'uh9L8a': '修改後時間',
  '5tnI7K': '您好，申請尾程代客索賠-妥投未收到需要保證索賠資料的真實合法，請您先簽署承諾書。',
  'AthyIZ': '填寫發貨資訊',
  'JKZJgL': '承諾書簽署',
  'Mxplhy': '批量已讀',
  'PoyMGI': '尾程派送異常功能說明',
  'RFu03m': '修改PSC',
  'RdLh4C': '修改後的Winit產品(PSC)',
  'UXLhwo': '未妥投',
  'VHHcWu': '請填寫發貨資訊',
  'c5LwpD': '同一批入庫單將統一修改為此PSC',
  'cXHXi2': '商品標籤資訊',
  'dEMknn': '入庫單號列不可編輯（來自第一步），其他列支援Excel貼上',
  'hwW/0c': '請補充每個入庫單的貨櫃號、提單號、目的港、預計到港時間。支援Excel貼上。',
  'l6I9d3': '承諾書內容',
  'ljL3gz': '第一步（修改Winit產品）已完成並鎖定，入庫單的Winit產品已修改成功。請繼續填寫發貨資訊。',
  'mxHH+s': '預計到港時間(北京)',
  'rcOn5i': '標籤條碼',
  'uOmHPQ': '同意並簽署',
  'ux5ZBe': '請確認',
  'vfyAfP': '請選擇修改後的Winit產品(PSC)',
  'yx7oLR': '查看商品標籤資訊',
  'Gqafh0': '實際卸車完成時間',
  'IuLtpQ': '現場作業照片',
  'JmzURT': '實際櫃型',
  'Kdy15G': '（本地時間）',
  'dpyNCw': '實際集裝箱號',
  'fTpv4q': '實際卸貨方式',
  'laeHnj': '實際裝貨方式',
  'zPXseg': '關聯的客戶預約單號',
  '/mLHLD': '列印時間',
  '24Thgy': '商品【{sku}】請選擇 {count} 個要刪除的包裹',
  '8Twc0c': '複用上一次列印條碼 + 自動新增',
  '9ZPZgL': '確認選擇',
  'Bnkh4w': '複用上一次列印條碼',
  'CGQ3Xl': '複用上一次列印條碼 + 手工刪除多餘條碼',
  'I5FiGK': '確認處理',
  'KI/GdI': '📦 條碼變更處理',
  'LLJsOt': '貼上多個包裹序號或包裹條碼，每行一個或用逗號/空格分隔',
  'LzT6io': '全部刪除',
  'NNq6ji': '已選 {selected}/{need}',
  'NYKIRS': '複用 {reuse} 個原條碼，自動新增 +{add} 個',
  'Nipe8P': '需手工選擇 {count} 個多餘條碼刪除',
  'O7pZSc': '商品【{sku}】請選擇 {count} 個歷史條碼',
  'UcWFNn': '確認全部刪除？',
  'Ur/Bod': '當前數量',
  'Xcvnrr': '確認處理後，系統將列印全部包裹條碼（包含複用的原條碼和新生成的條碼），請注意核對。',
  'Xm1i12': '全部重新生成',
  'YSJbfi': '列印說明',
  'bdu6F4': '選擇歷史條碼',
  'bueIW/': '批量查詢（貼上包裹序號/包裹條碼）：',
  'cAcaUk': '支援換行、逗號、空格分隔',
  'evOQEG': '系統自動生成 {count} 個新條碼',
  'f8t63R': '原列印條碼數',
  'jOnpg1': '需從歷史列印記錄中選擇 {count} 個條碼複用',
  'k/OmWi': '選擇歷史列印過的條碼',
  'kN/irF': '系統按包裹序號自動刪除最後 {count} 個',
  'kZTCdQ': '處理方式規則：系統根據「原列印條碼數」與「當前數量」的差異，自動匹配變更類型與可選處理方式。',
  'kx92Hl': '個，需要選擇',
  'vSs2OO': '變更類型/判斷條件',
  'vUQyA/': '複用上一次列印條碼 + 系統按包裹序號自動刪除最後 {count} 個',
  'yIKZNo': '已選擇的歷史記錄',
  'ztV27A': '選擇要刪除的包裹',
  'zxz7sF': '💡系統已載入該 SKU 的歷史列印條碼記錄，請勾選需要複用的條碼。',
  '20mYrK': '生效時機',
  '7CoGIn': '第三方面單服務補貼 UN 標籤',
  '7cJiqy': '我已閱讀並同意上述條款',
  '9JcidQ': '增值服務規則',
  'AxBfyF': '訂單類型：自提出庫-第三方面單服務常規打包產品',
  'COdnuj': 'OSF8V1743 補貼鋰電池運輸標籤',
  'H1otQv': '請選擇{field}的屬性',
  'HONX1w': '確認關閉自動補貼？',
  'KaKkWJ': '確認關閉',
  'LevjV3': '規則類型：',
  'NVof2I': '未開啟：系統不再為您的自提-第三方面單服務的訂單自動構建補貼鋰電池 UN 運輸標籤增值，存在 USPS 罰款風險',
  'P3poe9': '修改包裝資訊會導致個性化打包增值清空，請確認是否修改包裝資訊',
  'PN0uPP': '增值服務規則為系統規則，滿足條件時自動觸發對應增值服務。系統規則不可編輯、不可刪除。',
  'RsPUtK': '開啟前請閱讀以下事項',
  'aVmQ6K': '請確認您已了解以下風險與責任：',
  'b5OmiM': '鋰電池商品未維護 UN 編碼時下單會被阻斷',
  'bSLvFe': '開啟「第三方面單服務補貼 UN 標籤設置」後，系統將對您的第三方面單服務常規打包訂單執行以下動作：',
  'cBrdf6': '提示：如果有多個包裹，所有包裹都會執行勾選的服務',
  'h3nC41': '生效範圍',
  'iLAIH1': '因商品資訊不準確導致的 USPS 罰款、錯貼、漏貼由',
  'jdelkV': '結合商品 UN 編碼自動選擇對應的 UN 標籤類型',
  'juz0lL': '同意並開啟',
  'o+e1vO': '前置校驗',
  'qW2sWh': '關閉後，系統不再為您的自提-第三方面單服務的訂單自動構建補貼鋰電池 UN 運輸標籤增值。',
  'sxiXs2': '增值編碼',
  't8LW1B': '規則名稱：',
  'uKG0B0': '第三方面單服務補貼 UN 標籤設置',
  'ucT0L6': '關閉本功能後，系統不再自動補貼，倉庫線下識別可能存在遺漏',
  'upQelj': '自動識別商品符合 USPS Hazmat 合規要求並構建',
  'vAuKNM': '您承擔',
  'vO3xCd': '開啟後：商品符合 USPS Hazmat 合規要求自動構建補貼鋰電池 UN 運輸標籤增值，規避 USPS 罰款風險',
  'ws0XMU': '開啟後立即對新下單生效，歷史訂單不追溯',
  'zTkyPu': '請確保您在 MMS 維護的商品電池資訊、UN 編碼、USPS Hazmat 合規字段準確無誤',
  'Q3OEyt': '自提出庫模板',
  '7ZdcxH': '費用總計',
  '9GajoZ': '回退草稿',
  '9Z+Yzp': '是否缺量',
  'COTXe/': '批量導入將清空原輸入/導入SKU數據；僅支持 XLS/XLSX 格式，文件大小限制 5M',
  'GgMgwh': '請選擇批次日期',
  'LZDlcg': '已入庫',
  'Py3OyW': '下載導入模板（含SKU類型/批次/等級/自定義屬性等11列）',
  'RJj9NN': '超過可用庫存',
  'TZcm4S': '下單數量|發貨倉揀選數量|目的倉商品預分揀數量|目的倉上架數量',
  'Wsui9Z': '回退中',
  'dDmQcT': '請確認是否回退草稿？',
  'hUREVs': '是否全部庫存調撥',
  'leJYmZ': '實際扣費金額與預估金額可能不一致，以實際扣費金額為準',
  'oHlEPm': '不允許的文件格式，請上傳 XLS/XLSX',
  'qOPvJP': '請輸入產品批次號',
  'vRL430': '文件上傳失敗，請重試',
  'S5Stcp': '打包數量|目的倉商品預分揀數量|目的倉上架數量',
  'YzhdUJ': '上架完成',
  '+UErHL': '請先選擇增值服務！',
  '2XormZ': '選擇增值服務',
  '6asrX+': '選項加載失敗，',
  'EFyLnr': '選擇處理方式',
  'FKfuYc': '切換處理方式將清空已填寫內容，請確認是否切換？',
  'GvqKSj': '從下方組合中選擇一個（單選）',
  'JI+iiO': '輸入入庫單號',
  'JKx8s3': '加載失敗，',
  'JdHJMh': '入庫單號校驗失敗',
  'KdSCWh': '支持批量粘貼，每行一個或用逗號/空格分隔',
  'RFYLDS': 'WINIT創建新入庫單上架',
  'RR36mz': '客戶創建新單上架',
  'WqCD+7': '將清空已填寫內容，請確認是否切換？',
  'X+OwBR': '該異常不支持選擇!',
  'YMPCBA': '當前異常場景無可用處理方式，請聯繫客服。',
  'dAO3T4': '暫存',
  'dtlrnv': '價格(USD)',
  'eMI1Th': '已達最大500個入庫單號，超出部分已忽略',
  'fUVx+F': '自提',
  'fdnK/M': '離開將丟失當前填寫內容，是否確認？',
  'kJtA/G': '請先選擇處理方式！',
  'qsj7Cv': '根據您輸入的入庫單號未匹配到處理方式為【客戶創建新單上架】的增值服務！請刷新後重試',
  'rT1Nil': '填寫服務要求',
  'rmOWn8': '請粘貼或輸入客戶新單的入庫單號（例：WI50000001）',
  'w1h6bJ': '粘貼內容過大，請分批粘貼',
  'ygqWgW': '原單上架',
  'zvHAkW': '當前處理方式暫無可用增值服務，請聯繫客服申請特批。',
  '1hqMwB': '格式疑似不正確',
  'TzWVXx': '上次提交',
  'YiYwCO': '填寫進度',
  'YjdPjx': '填寫要求',
  'b5kCtF': '待選擇',
  'jw8OnZ': '填寫中',
  'mdMlwG': '已填寫完成',
  'n6HlL+': '或使用逗號/空格分隔',
  '64/HXZ': '關閉本功能後，系統不再自動補貼',
  'QYN6KE': '請確保您在 商品管理 維護的商品電池資訊、UN 編碼、USPS Hazmat 合規欄位準確無誤',
  '1S13GM': '未開啟：無論是否符合 USPS Hazmat 合規要求，Winit 都不會自動下發補貼鋰電池 UN 標籤增值服務。如客戶需補貼鋰電池 UN 標籤，則應自行下發相應增值。',
  '3I/koe': '自提出庫-第三方面單服務-美國倉庫',
  '5d3yZi': '生效時間',
  'DkZgMf': '若鋰電池商品未維護 UN 編碼，則無法下發OSF8V1743增值且下單失敗',
  'JVIiNL': '關閉後,系統不再為您的自提-第三方面單服務的訂單自動下發補貼鋰電池UN運輸標籤增值。',
  'b1RX5n': '使用範圍',
  'hx8gUx': '開啟即生效',
  'y2h80L': '開啟後：訂單內任意商品含鋰電池，且不符合 USPS Hazmat 合規要求時，Winit 將自動下發補貼鋰電池 UN 標籤增值服務，降低 USPS 罰款風險。',
  'za/zJ1': 'OSF8V1743補貼鋰電池運輸標籤',
  'FfFaqm': '關聯跟蹤號',
  '/+VB3y': '標籤條碼格式與 EAN不匹配，需為 12 位純數字',
  '/aKsXS': '批量上傳成功',
  '1rB/Z5': '標籤內容',
  '50W5Rn': '標籤格式=EAN，標籤條碼為12位純數字',
  '9D1q0F': '是否列印商品編碼',
  'Gdsg//': '填寫標籤內容',
  'I3Cawd': '商品標籤資訊不能為空',
  'K1QScR': '標籤條碼:',
  'MdzU66': '說明：標籤尺寸100x60mm, 主條碼位於標籤中部,「商品編碼」位於標籤右下角（當「是否列印商品編碼」= 是 時顯示）。 平台商品名稱、商品狀態、原產地按順序展示；主條碼類型由「列印格式」決定（EAN / UPC / CODE 128）。',
  'U7YTet': '標籤條碼格式與 CODE128 不匹配，最多20個字符，只能輸入數字和字母',
  'W6B/ZV': '若訂單履約場景為"轉第三方倉/買家訂單"，請填寫',
  'WVEsfT': '列印格式',
  'XqtpZ3': '標籤格式=CODE 128，標籤條碼限制20個字符，僅允許輸入數字+字母',
  'dYIiDZ': '請填寫標籤內容',
  'guajX8': '標籤條碼格式與 UPC不匹配，需為 11 位純數字',
  'ih2fEa': '請填寫標籤條碼',
  'jilYXi': '標籤格式=UPC，標籤條碼為11位純數字',
  'lYSvAE': '根據您選擇的收貨人類型，請填寫對應編碼資訊:',
  'mNTg67': '若訂單履約場景為"平台倉-Walmart"，請填寫',
  'o6LxpZ': '若訂單履約場景為"平台倉-FBA(VC)/FBA(SC)"，請填寫',
  'pXMwr5': '填寫完成後，系統將基於您提供的編碼自動生成條形碼資訊。為確保條形碼準確有效，請務必核對並填寫正確的編碼內容。',
  'qL9rhl': '編碼，12位的純數字編碼',
  'hF5h/M': '標籤格式=CODE 128，標籤條碼不能超過20個字（允許少於20個字），僅允許輸入數字+字母',
  'D7qtVC': 'EAN-13：國際通用商品條碼，固定 13 位純數字，用於國內超市、零售商品外包裝，掃碼收銀必需。',
  'hnHHof': 'UPC-A：北美商品條碼，固定 12 位純數字，用於銷往美國、加拿大的零售商品。',
  'iTw7tD': 'CODE 128：最常用的通用條碼，可含數字 + 字母 ，長度≤20個字，適合倉儲、物流、內部單號、箱標等場景。',
  'moupQK': '列印標籤條碼的格式，如無特殊要求，則選擇系統預設的<b>CODE 128</b>格式即可，各格式場景如下：',
  '+u5rcb': '已預約SLOT（CBM）',
  '/QFie7': '分配和預約明細',
  '03oH+l': '請先查詢出有效的預約單2',
  '34aN7u': '請先查詢出有效的預約單1',
  '4un7lV': '已預約 SLOT',
  '56e0bu': '預約單號2',
  '6ndV9k': '儲存修改',
  'A5tL4O': '編輯天SLOT',
  'Ag1TbG': '預約卸貨時間',
  'FEQqGe': '本週',
  'FEe9ks': '以下日期的天SLOT不能低於已預約SLOT：{days}',
  'N7bcSG': '當天剩餘可佔用SLOT（CBM）',
  'PvY4GQ': '請輸入預約單號',
  'Zfx7GJ': '天SLOT總和（{total} CBM）不能超過週SLOT（{weekly} CBM）',
  'axsjIx': '單',
  'cpOa69': '預約單2',
  'gRT7HC': '週SLOT',
  'gyOgWt': '天SLOT（CBM）',
  'jjy0PS': '預約單1',
  'oRLj7v': '儲存分配',
  'ox0R2v': '終止類型',
  'pr55PD': '分配天SLOT',
  'ttucU+': '關聯預約單',
  'xPf0w5': '已分配天SLOT',
  'y+nJm9': '倉庫休息',
  'z2xGPm': '預約送倉時間',
  'OGlQt5': '日期【{date}】已分配天SLOT需要≥已預約SLOT【{booked}】',
  '+2wUa+': 'Winit商品狀態',
  '+vFteY': '請輸入TT入庫單號，如CUST-20260420-001',
  '/MLSJ+': '透過 Excel 匯入未註冊商品清單，系統按行註冊商品、提交發布審核並自動建聯；其他所需註冊資訊將直接從 TiktokFBT 商品資料自動匯入。若商品已註冊但需新增進口國的關聯，也需透過此方式匯入註冊該進口國。若 TiktokFBT 商品資訊缺失，則自動儲存為草稿，需手動補齊資訊後提交發布審核。單次 ≤ 500 條。',
  '/PdBsH': '匯入的商品ID/Barcode',
  '/qd06T': '校驗憑證',
  '/ys4jP': '貨主 ID',
  '0+Dqij': '刪除後訂單將永久移除，不可恢復。',
  '1U7QvB': '失敗：{count}',
  '1jNGJ9': '請檢查商品 ID / Barcode 是否屬於該 TiktokFBT 貨主 ID，確認後重新提交。',
  '2Y4K/H': '註：以下費用為預估費用，帳戶可用餘額小於系統預估費用則無法提交訂單，煩請在下單前確保帳戶可用餘額充足。',
  '2qTuwe': '請輸入 TiktokFBT 貨主 ID',
  '2xmYN3': '提交成功，已生成頭程運輸單',
  '3DX5OB': '請輸入貨主簡稱',
  '3SL4WI': '貨主 ID：',
  '3UR/Cs': '·共 {total} 條',
  '4CagJY': '失敗明細',
  '4JFxZB': '建立頭程運輸單',
  '4ShKdS': '收貨尺寸',
  '4UPNap': '首次建立頭程運輸單？請按以下 3 步完成前期配置',
  '4lBG/a': '校驗憑證至少 2 個',
  '4uT0Nv': '全部命中，可提交綁定',
  '5Q1wC+': '綁定新 TiktokFBT 貨主 - 校驗失敗',
  '5em3kd': '下單箱數',
  '6FDAdc': '關聯的TT商品條碼',
  '7+qmpn': '卸貨重量',
  '8EQrqZ': '綁定新貨主',
  '8FEREW': '驗貨件數',
  '9v/D4V': '已綁定客戶 ID：',
  'A9BUVZ': '批量快速註冊',
  'AQtV7m': '下單件數',
  'Ac+XIc': '，萬邑聯帳號：',
  'AmgwF0': '綁定 TiktokFBT 貨主',
  'B/ipI7': '運輸軌跡',
  'D0R7zD': '重新建聯',
  'E94zBi': '點擊或拖拽上傳 Excel（.xlsx / .xls，單次 ≤ 500 條）',
  'Fh7YPD': '萬邑通已和 TiktokFBT 深入合作，支持客戶直接快速建立頭程運輸單，直接發貨至 TiktokFBT 倉。',
  'Fx/yiw': '補充資訊',
  'H/DRyY': '卸貨體積(CBM)',
  'Hrb1O1': '校驗',
  'HxBS4j': '批量關聯',
  'IVmm5R': '請選擇貨主',
  'J//5tH': '驗貨重量',
  'JUyiEx': 'TiktokFBT 商品 ID',
  'JqMC+q': '解綁貨主',
  'L6M3HO': '卸貨箱數',
  'O2/AyA': '頭程運輸單號：',
  'OMr4eM': 'TT入庫單號',
  'OQrhwl': '綁定時間：',
  'OkXJwu': '重新校驗',
  'P+tJNO': '確認解綁{count}個商品嗎？',
  'PF3ERh': '下單|收貨|驗貨|卸貨',
  'PON3xy': '確認解綁該 TiktokFBT 貨主嗎？',
  'PYVuTl': '請先選擇提貨地址！',
  'PdaTsL': 'Step 3 · 完成以上步驟即可在【入庫 - 頭程運輸單】中建立訂單',
  'Pgy5nC': '收貨箱數',
  'QgltAQ': '成功：{count}',
  'QxIgO8': '命中·萬邑通帳號',
  'RSr4CH': '下單尺寸',
  'TFPba5': '貨主簡稱：',
  'Tksazo': '該 TiktokFBT 貨主 ID 已被其他萬邑聯客戶綁定',
  'ToroOE': '貨主簡稱',
  'ULyz5A': '該貨主下 {count} 條已關聯商品全部同步置為「已解綁」',
  'URyjAi': '第 {row} 行',
  'Vkac+c': '已解綁',
  'WnwfhL': '確認解綁',
  'XXMltT': '部分商品在該貨主下未查到歸屬，請核對後重新提交',
  'XjkJXt': '提交頭程運輸單',
  'YcGgvm': '解綁後：',
  'ZYV6bl': '每行 1 個，支持 TiktokFBT 商品 ID 或 Barcode',
  'Zqsx9N': '開啟 TiktokFBT 頭程運輸',
  'aEWVKN': '驗貨箱數',
  'bVwEuw': '綁定失敗',
  'bc+mEK': '註冊重量',
  'ceOmHh': '收貨體積(CBM)',
  'cgikOb': '請選擇物流計劃',
  'dmGeZC': '批量解綁',
  'eWdu63': '註冊|核實',
  'esQHyz': 'Step 2 · 完成 TiktokFBT 商品和萬邑通商品建聯',
  'fYxisF': '貨主 ID {ownerId} 下無此商品 ID',
  'gHhyK6': '支持批量貼上，多個用逗號或換行分隔',
  'ggCQtQ': '收貨重量',
  'h79tjH': '下單|收貨',
  'hjT3DZ': '批量關聯（已註冊商品）',
  'hz0Wmf': '註冊尺寸',
  'iNwVgn': '確認解綁該商品嗎？',
  'iPONvw': '具體操作如下：',
  'ixAXfT': '適用場景：客戶在萬邑通已註冊商品，與 TiktokFBT 商品做關聯。系統按「國家 + 第三方商品條碼 → TiktokFBT 商品 ID」查詢，命中多個 TiktokFBT 編碼則報錯。單次 ≤ 300 條。',
  'jPwEDg': '運輸單號',
  'jhilUP': '選擇貨主',
  'kHvnhz': '確認重新建聯該商品嗎？',
  'lkqKU+': '重新建聯成功',
  'muygN6': '查詢和校驗',
  'mxJ2RN': '一個 TiktokFBT 貨主 ID 全局僅允許綁定一個萬邑聯帳號。如需綁定到當前帳號，請先聯繫原客戶解綁，或聯繫萬邑通運營協助處理。',
  'nDAVFw': '卸貨件數',
  'pOzKhw': '收貨件數',
  'rxpvne': 'TiktokFBT 貨主 ID',
  'sJa05X': '回退後訂單將變為草稿狀態，可重新繼續下單再次提交。',
  'svu+m3': '支持透過 FBT 商品快速註冊萬邑通商品',
  't5oTEY': '輸入TT入庫單號，系統將自動查詢對應的入庫單，並校驗入庫單下所有商品是否已完成關聯。校驗通過後進入建立嚮導。',
  'tGJZ+G': '綁定新 TiktokFBT 貨主',
  'tXJ03I': '解綁結果',
  'urlMn/': '支持後續重新綁定，歷史關聯可透過「重新建聯」快速恢復',
  'wSdWu+': '終止後訂單將不可恢復，請確認是否終止？',
  'x+xja9': '每行 1 個，支持 TiktokFBT 商品 ID 或 Barcode，至少 2 個',
  'xjWHGB': '請選擇提貨類型',
  'yEXHj/': '已綁定 TiktokFBT 貨主（{count}）',
  'ya32Dh': '匯入完成',
  'yj3b8Q': '批量快速註冊（未註冊商品）',
  'zjun/X': 'Step 1 · 綁定 TiktokFBT 貨主',
  'A7PkTj': '命中TiktokFBT批次管理商品，已為您自動開啟批次管理權限。同時商品已默認使用TiktokFBT商品的批次管理信息。',
  'EyDu5z': '綁定貨主ID',
  'Ru9X3s': '批量導入 賣家SKU 商品，建立 客戶商品 ↔ TT 商品 關聯',
  'a27VWc': '提供貨主ID + 至少 2 個校驗商品ID，MIMS 校驗通過後建立綁定',
  'eKqSaD': '當前',
  'ggF6+v': '點擊或拖拽上傳 Excel（.xlsx / .xls，單次 ≤ 300 條）',
  'h/0cCn': '輸入 TT 入庫單號 → 校驗通過 → 填寫運輸單',
  'vONXo4': '三方條碼',
  'zJ8Ntt': '商品同步並關聯',
  'WYeRKr': '通過 Excel 導入未註冊商品清單，系統按行註冊商品、提交發布審核並自動建聯；其他所需註冊信息將直接從 TiktokFBT 商品數據自動導入。若商品已註冊但需新增進口國的關聯，也需通過此方式導入註冊該進口國。若 TiktokFBT 商品信息缺失，則自動保存為草稿，需手動補齊信息後提交發布審核。單次 ≤ 300 條。',
  '2TipcB': '未註冊萬邑通商品，請使用[批量快速註冊]，將直接用平臺商品信息註冊並關聯。 已註冊萬邑通商品，請使用[批量關聯]，將批量關聯平臺商品。',
  'EX1Jzw': '適用場景：客戶在萬邑通已註冊商品，與 TiktokFBT 商品做關聯。系統按「國家 + 第三方商品條碼 → TiktokFBT 商品 ID」查詢，命中多個 TiktokFBT 編碼則報錯。單次 ≤ 300 條。',
  'hyXT/t': '提供貨主ID+至少2個Tiktok商品ID，校驗通過後建立綁定',
  '/YUuzV': '作廢要求已經通知倉庫，待倉庫確認是否成功作廢',
  '0Q0/dW': '確認並關閉簽署',
  'BKtWp2': '訂單將無法提交，需更換指定包材後重新下單',
  'UGkT0P': '攔截下單',
  'X7nCJV': '我已閱讀並同意以上協議',
  'eDNxm3': '忽略對應的排除規則，訂單可正常提交',
  'sZy6WK': '請同意以上協議',
  'sjBT8L': '檢視排除規則',
  'x5h+4q': '中國大陸地址選擇區域後，郵編將自動填寫',
  'Lkn1XH': '增值自動觸發規則',
  'S2Y15B': '出庫加包裝相關配置',
  'Z/0cr1': '關閉規則請知悉以下協議內容',
  'cMwFvA': '已知悉',
  'cPu3iv': '關聯商品條碼',
  '+0oPPG': '<bold>最終處理意見如何判定？</bold>{break} <bold>步驟一：</bold>倉庫按序檢查。若過程中出現觸發「終止後續檢查」的結果，則提前結束檢查；若全程未發生中斷，系統將彙總所有檢查結果。{break} <bold>步驟二：</bold>根據步驟一結束時所收集到的各項檢查結果，系統將按照以下優先級順序確定最終處理意見：<bold>銷毀>拍照暫存>不良品上架>良品上架</bold>',
  '/1QQlL': '總件數=每箱件數*箱數',
  '/D5MgW': '商品資訊不能為空！',
  '9vqlvE': '請輸入大於0的數字，最多兩位小數',
  'AS5sYN': '確定要批量刪除選中的商品嗎？',
  'EGrucD': '退貨質檢',
  'G22Twb': '【{info}】未維護商品包裹類型A+/A，請維護後再進行下單！',
  'MqloPV': '同一個商品不能新增多筆！',
  'U9SWt3': '是否完成質檢',
  'V3UDXJ': '包裹長寬高(cm)',
  'd+Twhp': '刪除商品會同時刪除其關聯的包裹資料，確定刪除？',
  'jElDms': '大於0，最多兩位小數',
  'vV8RQq': '總件數',
  'E/4rGQ': '填寫收貨地址和出庫SKU資訊, 選擇需要【非標增值】,提交出庫單。',
  'U/8V+P': '處置',
  'Y90SUR': '您未選擇增值或您選擇的增值無需暫存後補充資料，訂單將不會進入暫存流程',
  'eLoNJr': '自提訂單需暫存，請在訂單更新暫存後補充增值資料',
  'gw/emU': '您選擇了增值且需要暫存後補充資料，訂單需暫存，請在訂單更新暫存後補充增值資料',
  'hIhiH9': '勾選此選項後，出庫單將保持為"出庫確認中"狀態，等待客戶提交額外的非標增值訂單才會將任務下發給倉庫進行揀選操作',
  'qREhKj': '選中處置出庫',
  'EH3soQ': '2. 如客戶配置了拍照暫存定製模板，將優先使用定製模板；未配置定製模板，則預設採用萬邑通質檢全局拍照模板。',
  'EaLlzm': '溫馨提示：當客戶選擇質檢後的處理方式為拍照暫存時，此字段的處理策略將更新為拍照暫存',
  'bUHpnt': '1. 因拍照暫存服務自帶照片，選用該處理方式時，客戶無需額外勾選全局拍照服務。',
  '51giX6': '（數據截至 {date}）',
  'AuZRr4': '已扣費欠款(USD)',
  'MC/rfG': '立即還款',
  'Pbubl4': '賬戶存在逾期欠款，已被列爲壞賬客戶。清償全部欠款後方可恢復下單與發貨權限。',
  'in6jZn': '（已凍結）',
  'v+ZDR0': '資金信息',
  'wUWLaA': '當前總欠款(USD)',
  'xUDpHO': '當前爲壞賬客戶，如需取消壞賬標記，請還清總欠款 {amount} USD',
  '936OGI': '批量下載電子收據',
  'ubXjRA': '壞賬期間未扣倉租費（USD）',
  'eNv+ZF': '包裝及損壞類型的破損細節選擇「其他」時，索賠備註需要填寫破損細節',
  '+/wf+u': '單個商品體積（{volume} CBM）',
  '8HFbFG': 'V = {v}（CBM）',
  'Fz1L32': '無法識別嵌套方向，請重新選擇',
  'Fz2EAa': '沿最短邊嵌套',
  'Nh6Ixk': '沿次長邊嵌套',
  'Rf24jR': 'Y={a}（向上取整）',
  'XnhwRe': '單個庫位體積（{volume} CBM）',
  'ZQyYos': '單件佔用體積 V（CBM）隨預期庫存數量 Y 變化曲線',
  'b0chiT': '件數為 {counts} 時嵌套商品單件體積最小',
  'g4dEnk': '嵌套商品單件體積曲線',
  'gZ+ZoG': '嵌套庫位匹配模擬計算',
  'l27O3i': '沿最長邊嵌套',
  'pMqwj0': 'Y = {y}（件）',
  'zZgnnM': '嵌套商品單件體積與單個商品體積交點，Y={a}（向上取整）',
  'PGscWZ': '請先完善以下必填信息：{fields}',
  '5d9IGP': '嵌套方向是指商品在庫內進行嵌套存儲時，可以堆疊嵌套新增的方向（點擊圖片查看大圖）',
  'PAlllX': '模擬在庫庫存件數',
  'ZrZB8l': '單件嵌套體積',
  'J4Q2/A': '正在計算是否需要嵌套…',
  '4QnKNq': '最優庫位',
  '7sdlr4': '{name}（{length} × {width} × {height} cm，{volume} CBM）',
  'AgHbP5': '不滿一個庫位仍按一個庫位計費，建議增加備貨量，提高庫位利用率。',
  'Di6ekN': '圖例解讀：',
  'FJxziP': '在庫件數超過 {a} 件時，單件平均佔用體積為 {aVolume} CBM，小於商品體積 {itemVolume} CBM，使用嵌套計費理論上可節省倉租。',
  'Yt3SAv': '單件最小平均佔用體積：{xCbm} CBM',
  'fqoFr6': '嵌套計費測算結果',
  'nzDFlX': '單庫位最多存放：{bestCount} 件',
  'pPm4PB': '單庫位存滿 {b} 件時，單件平均佔用體積最低，為 {x} CBM，倉租節省最多。',
  'JrVsmG': '嵌套庫位都無法裝下，請勿使用嵌套商品。',
  'ZWHEC0': '查看測算明細',
  'h6F76V': '在庫件數＞{a}件時，推薦嵌套計費：嵌套後單件平均佔用體積更小；≤{a}件時不推薦。',
  'kH3pAE': '不推薦嵌套計費：嵌套後單件平均佔用體積更大。',
  '33XNhl': '經測算，在 {length} × {width} × {height} cm 的庫位中最多可存放 {bestCount} 件。嵌套後的單件最小平均佔用體積為 {x} CBM，大於商品體積 {itemVolume} CBM，因此不推薦使用嵌套計費。',
  'FJdrbY': '經測算，在 {length} × {width} × {height} cm 的庫位中最多可存放 {bestCount} 件。嵌套後的單件最小平均佔用體積為 {x} CBM，等於商品體積 {itemVolume} CBM，因此不推薦使用嵌套計費。',
  '4CVs8w': '不推薦嵌套計費',
  'ZZStup': '不推薦嵌套計費：嵌套後單件平均佔用體積與商品體積相同。',
  'BCSAaC': '商品主圖',
  'PjJ8Hm': '商品主體正面圖，以商品主體為核心，清晰展示商品外觀形態及品牌、型號、規格等關鍵信息的圖片。',
  'rvBYko': '圖片大小限制10M以內',
  't/jdWn': '是否RFID標籤',
  'xBK+Po': '圖片格式限制為{formats}',
  '+bZkH5': '入庫限制額度預警通知配置',
  '+ual19': '當您生效了該偏好且維護了具體的比例值，當您的庫容限制額度使用率達到您的比例值時，系統將通過郵件通知您，請注意查收！',
  'Nu4Dmo': '%，系統將郵件通知您，請注意查收！',
  'VsyDN2': '限制下單',
  'VtIlog': '限制預約',
  'Z4eFFb': '只能輸入1~100以內的正整數！',
  'evKwR6': '已消耗',
  'ygL0Ou': '當您的限制額度使用率達到',
  'rvBPE9': '關聯的TT商品編碼',
  'lnIXeF': '預約單狀態',
  'qoyajK': '提示失敗信息',
  'uFMzYD': '送倉單號',
  '6OLyVt': '請填寫所有面單文件的第一頁跟踪號',
  '7rz7kX': '支持多個 PDF 文件；每個文件上傳後需填寫該文件第一頁跟踪號，系統據此識別跟踪號位置。',
  'AShfCC': ' 說明：上傳每個面單 PDF 後需人工填寫該文件第一頁跟踪號（用於系統 OCR 定位跟踪號所在位置），再上傳關係表指定每個包裹（BOX 號）對應哪個 PDF 的哪一頁，系統據此識別其它頁跟踪號並與關係表比對，不一致則報錯。',
  'OMm85S': '只支持上傳 XLSX 格式的文件',
  'W42Ljf': '請輸入該文件第一頁跟踪號',
  'b0oR2h': '使用一單多面單渠道，請點擊"下一步"確定裝箱方案後再基於裝箱結果上傳面單文件。',
  'omnQsM': '上傳中...',
  'rE9cml': '當前選擇"常規打包"：下一步顯示跟踪號+第三方面單上傳，產品服務僅顯示常規打包 PSC。',
  'sgVKxe': '第一頁跟踪號',
  'wPcSJS': '上傳包裹與面單的關係',
  'zGCJkF': '下載包裹與面單關係模板',
  '9jkNMN': '請輸入客製包材編碼',
  'NoCyvl': '是否購買Amazon Buy Shipping',
  'RZfR1q': '當前費用僅供參考，部分費用項暫無法確定，最終以實際收費為準。',
  '4AdVUI': '聯絡電話不能超過20個字元',
  '9s/SpT': '不支援該檔案格式，請上傳jpg/gif/png/jpeg/pdf/doc/docx/xls/csv/xlsx/zip/rar/7z格式的檔案。',
  'CcgLlj': '支援 jpg/gif/png/jpeg/pdf/doc/docx/xls/csv/xlsx/zip/rar/7z 格式，可多檔案上傳',
  'HiaUtp': '該費用按實際包裹計收，暫無預估',
  'lMmy7Y': '客戶聯絡備用手機號、座機（選填）',
  'p+bCwQ': '支援jpg/png/jpeg/pdf/doc/docx/xls/csv/xlsx/zip/rar/7z格式檔案，可多檔案同時上傳',
};
